
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4jplB", function(module, exports) {
/**
 * @generated SignedSource<<c0556b57221609bd9cab7615e29b73cc>>
 * @relayHash 0e5febadf148cca119a3a0d78cb36fef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 81fd6afd89e473aab00d07efa1a7ca5e6dc192c9fac1e00f986fb5eef38e2d47
const $6a4b6bfe2e3e4030$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resultCount"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "timestamp"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "query",
                            "variableName": "query"
                        },
                        {
                            "kind": "Variable",
                            "name": "resultCount",
                            "variableName": "resultCount"
                        },
                        {
                            "kind": "Variable",
                            "name": "timestamp",
                            "variableName": "timestamp"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ConfluenceGenerateSearchPerformedEventPayload",
            "kind": "LinkedField",
            "name": "confluence_generateSearchPerformedEvent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "QuickFindSearchPerformedEventMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "QuickFindSearchPerformedEventMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "0e5febadf148cca119a3a0d78cb36fef",
            "id": "81fd6afd89e473aab00d07efa1a7ca5e6dc192c9fac1e00f986fb5eef38e2d47",
            "metadata": {},
            "name": "QuickFindSearchPerformedEventMutation",
            "operationKind": "mutation",
            "text": "mutation QuickFindSearchPerformedEventMutation($cloudId:ID!,$resultCount:Int!,$query:String!,$timestamp:String!){confluence_generateSearchPerformedEvent(cloudId:$cloudId,input:{resultCount:$resultCount,query:$query,timestamp:$timestamp}){success}}"
        }
    };
}();
$6a4b6bfe2e3e4030$var$node.hash = "3d3d464aa097e75cea744ba09799dccd";
var $6a4b6bfe2e3e4030$export$2e2bcd8739ae039 = $6a4b6bfe2e3e4030$var$node;



var $cozmU = parcelRequire("cozmU");


var $jb2gB = parcelRequire("jb2gB");





var $kSwu1 = parcelRequire("kSwu1");


var $7akNQ = parcelRequire("7akNQ");


var $5Tdig = parcelRequire("5Tdig");


var $1fHIr = parcelRequire("1fHIr");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");

var $gnKXs = parcelRequire("gnKXs");

var $buxP3 = parcelRequire("buxP3");


var $65DSU = parcelRequire("65DSU");


var $d5gEx = parcelRequire("d5gEx");


var $iKybC = parcelRequire("iKybC");


var $89906 = parcelRequire("89906");


var $3XLuW = parcelRequire("3XLuW");


var $ja2HH = parcelRequire("ja2HH");


var $2O9Q9 = parcelRequire("2O9Q9");


var $3Ydx7 = parcelRequire("3Ydx7");


var $dvVWp = parcelRequire("dvVWp");

// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $bc7ff59073912303$export$7640e1e223f51f1a = 'referrer';



var $9pcjO = parcelRequire("9pcjO");


var $c11PZ = parcelRequire("c11PZ");


var $hdMUr = parcelRequire("hdMUr");


var $8BkJa = parcelRequire("8BkJa");


var $emZZY = parcelRequire("emZZY");


var $cJff5 = parcelRequire("cJff5");


var $535ZC = parcelRequire("535ZC");


var $iHg8v = parcelRequire("iHg8v");


var $6yu7A = parcelRequire("6yu7A");

const $7471834b36d88f18$export$94e76cb7fb4eb6e7 = ({ attributes: attributes, isExpanded: isExpanded, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yu7A.ACTION_SUBJECT_PREFIX}QuickFindFiltersToggleButton`,
        attributes: {
            ...attributes,
            isExpanded: isExpanded
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });



var $hnDqW = parcelRequire("hnDqW");


var $gQNge = parcelRequire("gQNge");





function $6d0b2e4ae28c8d0a$export$2811a6cefe42670b(generateSearchUrl = (0, $gQNge.defaultGenerateSearchUrl)) {
    try {
        const searchPath = new URL(generateSearchUrl({})).pathname;
        const currentPath = new URL(window.location.href).pathname;
        return searchPath === currentPath;
    } catch  {
        return undefined;
    }
}
function $6d0b2e4ae28c8d0a$export$98262e13018313b(destinationUrl, generateSearchUrl = (0, $gQNge.defaultGenerateSearchUrl)) {
    try {
        const searchPath = new URL(generateSearchUrl({})).pathname;
        const destinationPath = new URL(destinationUrl, window.location.href).pathname;
        return searchPath === destinationPath;
    } catch  {
        return undefined;
    }
}



var $68JhS = parcelRequire("68JhS");




const $fe7f36bf6e32c349$export$da42c48b16873c83 = 'search-page-results-quick-find';



var $4aAXq = parcelRequire("4aAXq");


var $9PGk3 = parcelRequire("9PGk3");





var $eUI6V = parcelRequire("eUI6V");


var $fq2CX = parcelRequire("fq2CX");


var $32Eau = parcelRequire("32Eau");

const $4cf422296f563edd$export$88d19ca4a35e5eb5 = (isInteracted)=>{
    const [thirdPartyConfigs] = (0, $32Eau.useThirdPartyConfigs)();
    const availableProducts = (0, $32Eau.useAvailableProducts)();
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    // In Jira, the quick find component is already rendered on hover, so isInteracted is not needed.
    const isJira = primaryProduct === (0, $dvVWp.ProductKeys).Jira;
    const bannerEligibleProductsOrder = (0, $fq2CX.useBannerEligibleProductsOrder)({
        isOnSearchDialog: true,
        thirdPartyConfigs: thirdPartyConfigs,
        availableProducts: availableProducts
    });
    const suppressBanner = (0, $eUI6V.useShouldSuppressBannerForAnimation)();
    const hasBannerEligibleProducts = bannerEligibleProductsOrder.length > 0;
    const shouldMountPlacement = hasBannerEligibleProducts && (isInteracted || isJira) && !suppressBanner;
    return {
        thirdPartyConfigs: thirdPartyConfigs,
        bannerEligibleProductsOrder: bannerEligibleProductsOrder,
        shouldMountPlacement: shouldMountPlacement
    };
};


const $9ce89b0c45ce9e88$export$6f38235f6fa1e5b1 = ({ children: children, isInteracted: isInteracted })=>{
    const { thirdPartyConfigs: thirdPartyConfigs, bannerEligibleProductsOrder: bannerEligibleProductsOrder, shouldMountPlacement: shouldMountPlacement } = (0, $4cf422296f563edd$export$88d19ca4a35e5eb5)(isInteracted);
    if (!shouldMountPlacement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aAXq.QuickFindHeadlessPlacementDataProvider), {
        placementId: (0, $fe7f36bf6e32c349$export$da42c48b16873c83),
        thirdPartyConfigs: thirdPartyConfigs,
        availableProductsOrder: bannerEligibleProductsOrder,
        useOAuthHandlers: (0, $9PGk3.useOAuthHandlers)
    }, children);
};






var $iKWdo = parcelRequire("iKWdo");








var $7DMz5 = parcelRequire("7DMz5");


var $AgYeH = parcelRequire("AgYeH");


var $1sz28 = parcelRequire("1sz28");





var $7zn5c = parcelRequire("7zn5c");


var $9peWR = parcelRequire("9peWR");


var $5RzlA = parcelRequire("5RzlA");











var $bQ6i3 = parcelRequire("bQ6i3");


var $4jbt4 = parcelRequire("4jbt4");


var $jTbFT = parcelRequire("jTbFT");


var $hnyex = parcelRequire("hnyex");











var $kPgkn = parcelRequire("kPgkn");


var $krr0S = parcelRequire("krr0S");

// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");

async function $e7e2968db5ab6556$export$45bde04e7d1842b0(asyncFunction) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const markName = (0, $03RpJ.default)();
    performance.mark(`${markName}-start`);
    const result = await asyncFunction();
    performance.mark(`${markName}-end`);
    performance.measure(markName, `${markName}-start`, `${markName}-end`);
    const measure = performance.getEntriesByName(markName)[0];
    const duration = measure.duration;
    // Clear the marks and measure to avoid memory leaks
    performance.clearMarks(`${markName}-start`);
    performance.clearMarks(`${markName}-end`);
    performance.clearMeasures(markName);
    return {
        result: result,
        duration: duration
    };
}



var $9gI1G = parcelRequire("9gI1G");

const $939b646033906433$export$932440ee05101c0d = ({ success: success, attributes: attributes, resultsType: resultsType })=>({
        eventType: 'operational',
        action: success ? 'taskSuccess' : 'taskFail',
        actionSubject: 'ui',
        attributes: {
            ...attributes,
            // This edition is not exact matching the need for the AutoHots
            // A follow up is to find the current primary product edition and log that.
            // Currently we only have confluence edition in the productEdition object, so logging the entire object for now.
            edition: attributes.productEdition,
            task: 'unifiedSearch',
            capability: `quickFind_${resultsType}`,
            // Confirmed with AutoHots team this is mandatory
            // and base on "Can I log this" doc, we can log this.
            // https://hello.atlassian.net/wiki/spaces/Monitoring/pages/5816497997/Vitalstats+Onboarding+contract?focusedCommentId=5864073069
            // https://hello.atlassian.net/wiki/spaces/SECURITY/pages/236070634/Can+I+Log+This
            hostname: window.location.hostname
        }
    });


const $37c63952ee27f671$export$2d1da932f40a427e = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, resultsType: resultsType })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: 'searchResults',
        actionSubjectId: resultsType,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $2d57856ab6367a0e$export$9698f7c8e7c9a2f7 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'shown',
        actionSubject: 'suggestedQueries',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });



var $cI6da = parcelRequire("cI6da");


var $c9Gfx = parcelRequire("c9Gfx");


var $1mE5s = parcelRequire("1mE5s");


var $cRSxF = parcelRequire("cRSxF");


var $6ZL8f = parcelRequire("6ZL8f");


var $2csHQ = parcelRequire("2csHQ");


var $hMXVq = parcelRequire("hMXVq");





var $5lH3O = parcelRequire("5lH3O");


var $1i979 = parcelRequire("1i979");


var $3t6NJ = parcelRequire("3t6NJ");





var $2PBjm = parcelRequire("2PBjm");


var $1KAXF = parcelRequire("1KAXF");





var $8D0XM = parcelRequire("8D0XM");


var $dsOco = parcelRequire("dsOco");




const $e316eec52d5f461a$export$c24470e080406156 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dsOco.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $68JhS.useQuickFindAttributes)();
    const createNetworkCallbacks = (0, $cozmU.useCallback)((options)=>{
        const taskId = crypto.randomUUID();
        const searchSessionId = commonAttributes.searchSessionId || '';
        const taskStartAt = performance.now();
        return (0, $8D0XM.createVitalStatsNetworkCallbacks)(taskId, options.taskName, searchSessionId, fireAnalyticsEvent, taskStartAt, {
            uxTaskId: options.uxTaskId,
            isPreQuery: options.isPreQuery
        });
    }, [
        commonAttributes.searchSessionId,
        fireAnalyticsEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            createNetworkCallbacks: createNetworkCallbacks
        }), [
        createNetworkCallbacks
    ]);
};






var $fbOob = parcelRequire("fbOob");


var $fR63l = parcelRequire("fR63l");


var $emjGn = parcelRequire("emjGn");


var $79sCv = parcelRequire("79sCv");








var $9AIBu = parcelRequire("9AIBu");

/**
 * Returns whether Loom recents should be included.
 *
 * Loom-hosted Quick Find remains controlled by its own rollout gate. Other hosts include Loom
 * recents only for the products that received the shipped cohort and for users with Loom access.
 */ const $67534d8052f31965$var$shouldIncludeLoomRecents = (availableProducts, primaryProduct)=>{
    if (primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Loom) return (0, $iDrrr.fg)('loom-rovo-search');
    if (primaryProduct !== (0, $3Ydx7.PrimaryProductKeys).Confluence && primaryProduct !== (0, $3Ydx7.PrimaryProductKeys).Atlas && primaryProduct !== (0, $3Ydx7.PrimaryProductKeys).RovoExtension) return false;
    return availableProducts?.includes((0, $dvVWp.ProductKeys).Loom) ?? false;
};
const $67534d8052f31965$var$hasGithubConnectorAccess = (thirdPartyConfigs)=>{
    const githubConfig = thirdPartyConfigs?.[(0, $fR63l.ProductKeys3P).Github];
    return !!(githubConfig && !githubConfig.userNeedsOAuth);
};
/**
 * GitHub work-item recents are isolated behind a separate gate so the work-item entity type can be
 * rolled out independently from the rest of the GitHub weak-link impersonation feature.
 */ const $67534d8052f31965$var$hasGithubWorkItemImpersonationAccess = (thirdPartyConfigs)=>{
    const githubConfig = thirdPartyConfigs?.[(0, $fR63l.ProductKeys3P).Github];
    return !!(githubConfig?.userNeedsOAuth && githubConfig.impersonationEnabled && (0, $iDrrr.fg)('weaklink-github-work-item-fg'));
};
const $67534d8052f31965$export$48de245659972a87 = [
    'confluence',
    'jira',
    'townsquare',
    'graph'
];
const $67534d8052f31965$export$742b5ce6018da1f4 = [
    'page',
    'blogpost',
    'whiteboard',
    'issue',
    'project',
    'goal',
    'content',
    'document',
    'remote-link',
    'pull-request'
];
/**
 * Event types to be included in the recent activities query.
 * Based upon the AVI actions for each product: https://bitbucket.org/atlassian/flight-deck/src/7bab054550927c3c023f2eb783ce9d2ca6279bfc/packages/integrations/worklens/contrib/
 */ const $67534d8052f31965$var$INCLUDED_EVENT_TYPES = [
    'assigned',
    'unassigned',
    'viewed',
    'updated',
    'created',
    'liked',
    'transitioned',
    'published',
    'edited',
    'commented',
    'sl-viewed',
    'sl-clicked',
    'shared',
    'exported',
    'deleted',
    'started',
    'snapshotted',
    'trashed',
    'reaction'
];
/**
 * Returns the list of products to be included in the recent activities query.
 */ const $67534d8052f31965$var$getIncludedProducts = (availableProducts, primaryProduct)=>{
    return [
        ...$67534d8052f31965$export$48de245659972a87,
        ...(0, $iDrrr.fg)('assets_rovo_search_all') ? [
            'assets'
        ] : [],
        ...$67534d8052f31965$var$shouldIncludeLoomRecents(availableProducts, primaryProduct) ? [
            (0, $dvVWp.ProductKeys).Loom
        ] : []
    ];
};
const $67534d8052f31965$var$getIncludedProductsBasedOnProduct = (includedProducts, product)=>{
    /**
   * Decision on Experiment (https://hello.atlassian.net/wiki/spaces/CentAI/pages/5652280226)
   * Remove Jira from QF Recents to have better relevance and CTR.
   */ if (product === (0, $3Ydx7.PrimaryProductKeys).Confluence) return includedProducts.filter((product)=>product !== (0, $3Ydx7.PrimaryProductKeys).Jira);
    if (product === (0, $3Ydx7.PrimaryProductKeys).Jira) return includedProducts.filter((p)=>p !== (0, $3Ydx7.PrimaryProductKeys).Confluence);
    if (product === (0, $3Ydx7.PrimaryProductKeys).Loom && (0, $iDrrr.fg)('loom-rovo-search')) return includedProducts.filter((p)=>p === (0, $dvVWp.ProductKeys).Loom || p === 'graph');
    return includedProducts;
};
const $67534d8052f31965$var$getFilteredEventTypes = (thirdPartyConfigs)=>{
    if (thirdPartyConfigs && (0, $9AIBu.isEligibleFor3PClickIngestion)(thirdPartyConfigs)) return [
        ...$67534d8052f31965$var$INCLUDED_EVENT_TYPES,
        'clicked'
    ];
    return $67534d8052f31965$var$INCLUDED_EVENT_TYPES;
};
const $67534d8052f31965$var$getFilteredProducts = (primaryProduct, availableProducts)=>{
    // Get products that are available to this Quick Find host.
    const includedProducts = $67534d8052f31965$var$getIncludedProducts(availableProducts, primaryProduct);
    // Further filter products based on primary product
    const filteredProductsBasedOnProduct = $67534d8052f31965$var$getIncludedProductsBasedOnProduct(includedProducts, primaryProduct);
    return filteredProductsBasedOnProduct;
};
const $67534d8052f31965$export$ae65634d024c5427 = async (cloudId, aggAbsoluteUrl, after = '', thirdPartyConfigs, headers, primaryProduct, networkCallbacks, availableProducts, options)=>{
    const filteredProducts = $67534d8052f31965$var$getFilteredProducts(primaryProduct, availableProducts);
    const variables = {
        filteredProducts: Array.from(new Set(filteredProducts)),
        filteredObjectTypes: Array.from(new Set([
            ...$67534d8052f31965$export$742b5ce6018da1f4,
            // Confluence Slides in Recents are gated behind the environment content-type rollout.
            ...(0, $fbOob.isContentTypeEnabledInCurrentEnv)('slide') ? [
                'slide'
            ] : [],
            ...(0, $iDrrr.fg)('assets_rovo_search_all') ? [
                'object',
                'object_type',
                'schema'
            ] : [],
            ...$67534d8052f31965$var$shouldIncludeLoomRecents(availableProducts, primaryProduct) ? [
                'video'
            ] : [],
            ...$67534d8052f31965$var$hasGithubWorkItemImpersonationAccess(thirdPartyConfigs) || $67534d8052f31965$var$hasGithubConnectorAccess(thirdPartyConfigs) || !$67534d8052f31965$var$hasGithubConnectorAccess(thirdPartyConfigs) && (0, $iDrrr.fg)('rovo-search-fetch-work-items-for-all') ? [
                'work-item'
            ] : []
        ])),
        filteredRootContainerIds: [
            `ari:cloud:platform::site/${cloudId}`,
            `ari:cloud:townsquare::site/${cloudId}`,
            ...$67534d8052f31965$var$shouldIncludeLoomRecents(availableProducts, primaryProduct) ? [
                `ari:cloud:loom::site/${cloudId}`
            ] : []
        ],
        itemsLimit: 200,
        after: after,
        includeJiraIssueMetadata: true,
        ...options?.includeSearchAppMetadata && (0, $iDrrr.fg)('rovo-search-team-eu-26-search-app') ? {
            includeSearchAppMetadata: true
        } : {},
        includeLoomVideoMetadata: (0, $iDrrr.fg)('loom-rovo-search'),
        filteredEventTypes: $67534d8052f31965$var$getFilteredEventTypes(thirdPartyConfigs)
    };
    const response = await (0, $emjGn.cachedRecentActivitiesQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        headers: headers,
        onlyRefreshIfExpired: true,
        returnExpired: false,
        networkCallbacks: networkCallbacks
    });
    const edges = response.data?.activity?.myActivity?.all?.edges || [];
    return edges.map($67534d8052f31965$export$cf1f13813d90479a);
};
const $67534d8052f31965$export$cf1f13813d90479a = (result)=>{
    const product = result.node.object.product;
    let title = '';
    const timestamp = result.node?.event?.timestamp;
    if ((0, $79sCv.is1PActivity)(result.node.object)) {
        if (product === 'confluence') title = result.node.object.data?.title || '';
        else if (product === 'jira') {
            const key = result.node.object.data?.key;
            const summary = result.node.object.data?.fieldsById?.edges?.[0]?.node?.text;
            title = key && summary ? `${key}: ${summary}` : '';
        } else if (product === 'townsquare') title = result.node.object.data?.name || '';
    } else if ((0, $79sCv.isGraphActivity)(result.node.object) && ((0, $79sCv.isDocumentActivity)(result.node.object) || (0, $79sCv.isRemoteLinkActivity)(result.node.object) || (0, $79sCv.isGraphPullRequestActivity)(result.node.object) || (0, $79sCv.isGraphWorkItemActivity)(result.node.object))) title = result.node.object.data?.displayName || '';
    else if ((0, $79sCv.isLoomActivity)(result.node.object)) title = result.node.object.data?.name || '';
    else if ((0, $79sCv.isAssetsActivity)(result.node.object)) title = (0, $iDrrr.fg)('cdm_ga') ? result.node.object.data?.assetsDisplayName || '' : result.node.object.data?.assetsLabel || '';
    else title = '';
    return {
        id: result.node.object.id,
        title: title,
        data: result,
        type: 'recent-activity',
        activityTimestamp: timestamp
    };
};





const $163a324f5597962c$export$f7b7f83c551ecf0b = (existingItems, newItems)=>{
    const deduplicatedResults = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))([
        ...existingItems,
        ...newItems
    ], (item)=>item.id);
    // We sort to show the most recent autorefreshed results in pre-query state.
    try {
        deduplicatedResults.sort((a, b)=>new Date(b.data.node.event.timestamp).getTime() - new Date(a.data.node.event.timestamp).getTime());
    } catch  {
    // If we have an error, the results simply won't be sorted.
    }
    return deduplicatedResults;
};






var $aj2pm = parcelRequire("aj2pm");


var $eYg5X = parcelRequire("eYg5X");


var $6h661 = parcelRequire("6h661");


var $1qIUZ = parcelRequire("1qIUZ");










const $6838a8bbe742cb30$export$caa45abe6a87e5b5 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'completed',
        actionSubject: 'searchRequest',
        actionSubjectId: 'postQuerySearchResults',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


















var $1OGSC = parcelRequire("1OGSC");

const $09173d8eb8b93ff5$export$3b18f7e3dc975b4 = 250;
const $09173d8eb8b93ff5$export$7ebf6620acc135ab = $09173d8eb8b93ff5$export$3b18f7e3dc975b4;
const $09173d8eb8b93ff5$export$9e8b58cc1c8bacd2 = ()=>$09173d8eb8b93ff5$export$3b18f7e3dc975b4;
const $09173d8eb8b93ff5$export$483ef80309da5ade = ()=>{
    const { incrementQueryVersion: incrementQueryVersion } = (0, $1i979.useSearchActions)();
    const onSearchCompleted = (0, $32Eau.useOnSearchCompleted)();
    const { fireAnalyticsEvent: fireQuickFindAnalyticsEvent } = (0, $68JhS.useQuickFindAnalytics)();
    const { fireAnalyticsEvent: fireVitalStatsEvent } = (0, $dsOco.useAnalytics)();
    const [searchSessionId] = (0, $32Eau.useSearchSessionId)();
    const userId = (0, $32Eau.useCurrentUserId)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $68JhS.useQuickFindAttributes)();
    const quickFindOpen = (0, $5lH3O.useQuickFindOpen)();
    const quickFindQuery = (0, $5lH3O.useQuickFindQuery)();
    const content = (0, $5lH3O.useContent)();
    const debounceTimeout = $09173d8eb8b93ff5$export$9e8b58cc1c8bacd2();
    // Store stable references for functions/values used in useEffect and useCallback
    // This avoids effects/callbacks re-running when analytics callbacks change,
    // while ensuring we always call the latest version via .current
    const fireVitalStatsEventRef = (0, $cozmU.useRef)(fireVitalStatsEvent);
    const searchSessionIdRef = (0, $cozmU.useRef)(searchSessionId);
    const userIdRef = (0, $cozmU.useRef)(userId);
    // State tracking for pre-query VitalStats events
    const preQueryTaskIdRef = (0, $cozmU.useRef)(null);
    const preQueryTaskStartedRef = (0, $cozmU.useRef)(false);
    const preQueryTaskCompletedRef = (0, $cozmU.useRef)(false);
    const preQueryErrorRef = (0, $cozmU.useRef)(null);
    // State tracking for post-query VitalStats events using shared context
    const postQueryTaskState = (0, $1OGSC.useVitalStatsTaskState)();
    // Store stable reference to postQueryTaskState to avoid adding it to dependency arrays
    const postQueryTaskStateRef = (0, $cozmU.useRef)(postQueryTaskState);
    // Track if we've handled cached state for this dialog session (postquery only)
    const handledCachedPostQueryStateRef = (0, $cozmU.useRef)(false);
    // Track if we've handled cached state for prequery (when transitioning back from postquery)
    const handledCachedPreQueryStateRef = (0, $cozmU.useRef)(false);
    // Track if we've handled initial dialog open with cached preQuery
    const handledInitialCachedPreQueryRef = (0, $cozmU.useRef)(false);
    // Keep refs updated with latest values
    (0, $cozmU.useEffect)(()=>{
        fireVitalStatsEventRef.current = fireVitalStatsEvent;
        searchSessionIdRef.current = searchSessionId;
        userIdRef.current = userId;
        postQueryTaskStateRef.current = postQueryTaskState;
    }, [
        fireVitalStatsEvent,
        searchSessionId,
        userId,
        postQueryTaskState
    ]);
    // Handle initial dialog open with cached preQuery results
    // This fires VitalStats events when dialog opens with existing preQuery data
    (0, $cozmU.useEffect)(()=>{
        // Reset flag when dialog closes
        if (!quickFindOpen) {
            handledInitialCachedPreQueryRef.current = false;
            return;
        }
        // Only fire once per dialog open session
        if (handledInitialCachedPreQueryRef.current) return;
        const state = content?.state;
        // Only fire if we have preQuery results showing but no task has started yet
        // This handles the case where dialog opens with cached preQuery results
        // Skip if we came from postQuery (that case is handled by the transition-back useEffect)
        if (state === 'PREQUERY_RESULTS' && !preQueryTaskStartedRef.current && !postQueryTaskStateRef.current.current.started) {
            handledInitialCachedPreQueryRef.current = true;
            // Use the existing taskId if already set; otherwise generate a new one
            if (!preQueryTaskIdRef.current) preQueryTaskIdRef.current = crypto.randomUUID();
            const taskId = preQueryTaskIdRef.current;
            preQueryTaskStartedRef.current = true;
            // Fire both taskStart and taskSuccess immediately (results are cached)
            (0, $cozmU.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $hnyex.onTaskStart)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
                fireVitalStatsEventRef.current((0, $hnyex.onTaskSuccess)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
            });
            preQueryTaskCompletedRef.current = true;
        }
    }, [
        quickFindOpen,
        content?.state
    ]);
    // Reset VitalStats state when dialog closes
    (0, $cozmU.useEffect)(()=>{
        if (!quickFindOpen) {
            // Fire taskAbort if postQuery task is in progress
            if (postQueryTaskState.current.started && !postQueryTaskState.current.completed) (0, $cozmU.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $hnyex.onTaskAbort)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: postQueryTaskState.current.id,
                    task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                    moreContext: {
                        abortReason: 'dialog_closed_during_network'
                    }
                }));
            });
            preQueryTaskStartedRef.current = false;
            preQueryTaskIdRef.current = null;
            preQueryTaskCompletedRef.current = false;
            preQueryErrorRef.current = null;
            postQueryTaskState.current.started = false;
            postQueryTaskState.current.id = null;
            postQueryTaskState.current.completed = false;
            // NOTE: We intentionally DO NOT clear postQueryTaskState.current.error here
            // so that when the dialog reopens with cached POSTQUERY_ERROR state,
            // we can still include error details in the taskFail event
            handledCachedPostQueryStateRef.current = false; // Reset for next open
            handledCachedPreQueryStateRef.current = false; // Reset for next open
            handledInitialCachedPreQueryRef.current = false; // Reset for next open
        }
    }, [
        quickFindOpen,
        postQueryTaskState
    ]);
    // Fire taskSuccess/taskFail when content state changes
    (0, $cozmU.useEffect)(()=>{
        if (!preQueryTaskStartedRef.current || preQueryTaskCompletedRef.current) // Don't fire if task hasn't started or already completed
        return;
        if (content?.state === 'PREQUERY_RESULTS') {
            // Task succeeds when PRE_QUERY results are shown
            (0, $cozmU.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $hnyex.onTaskSuccess)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: preQueryTaskIdRef.current,
                    task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
            });
            preQueryTaskCompletedRef.current = true;
        } else if (content?.state === 'PREQUERY_ERROR') {
            // Include error information if available (errorName and errorMessage for debugging)
            const moreContext = preQueryErrorRef.current ? {
                errorName: preQueryErrorRef.current.name,
                errorMessage: preQueryErrorRef.current.message
            } : undefined;
            (0, $cozmU.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $hnyex.onTaskFail)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: preQueryTaskIdRef.current,
                    task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS,
                    moreContext: moreContext
                }));
            });
            preQueryTaskCompletedRef.current = true;
        }
    }, [
        content?.state
    ]);
    // Reset preQuery tracking when transitioning back from POSTQUERY to PREQUERY
    (0, $cozmU.useEffect)(()=>{
        const state = content?.state;
        // If we're back in PREQUERY state after being in POSTQUERY, reset preQuery tracking
        // so that new preQuery VitalStats events can fire
        if (state === 'PREQUERY_RESULTS' || state === 'PREQUERY_ERROR' || state === 'PREQUERY_LOADING') // Check if we previously had a postQuery task (indicates we're transitioning back)
        {
            if (postQueryTaskStateRef.current.current.started) {
                // Abort the postQuery task if it's still active (not completed)
                // This handles the case where user backspaces/clears text before postQuery results arrive
                if (!postQueryTaskStateRef.current.current.completed) {
                    (0, $cozmU.startTransition)(()=>{
                        fireVitalStatsEventRef.current((0, $hnyex.onTaskAbort)({
                            searchSessionId: searchSessionIdRef.current,
                            taskId: postQueryTaskStateRef.current.current.id,
                            task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                            moreContext: {
                                abortReason: 'text_cleared'
                            }
                        }));
                    });
                    postQueryTaskStateRef.current.current.completed = true;
                }
                // Reset preQuery tracking flags to allow new preQuery task to start
                preQueryTaskStartedRef.current = false;
                preQueryTaskCompletedRef.current = false;
                preQueryTaskIdRef.current = null;
            }
        }
    }, [
        content?.state
    ]);
    // Fire taskSuccess/taskFail for post-query when content state changes
    (0, $cozmU.useEffect)(()=>{
        if (!postQueryTaskState.current.started || postQueryTaskState.current.completed) // Don't fire if task hasn't started or already completed
        return;
        const state = content?.state;
        if (state === 'POSTQUERY_RESULTS' || state === 'POSTQUERY_NO_RESULTS') {
            // Snapshot per-product counts before `startTransition` defers the fire;
            // reads the DOM at the moment we commit the success transition.
            // The builder returns `null` when there is no `userId`, so the tag is
            // omitted entirely in that case.
            const mlLensEnvelope = (0, $1qIUZ.buildPostQueryMlLensEnvelope)((0, $9gI1G.getProductResultCounts)(), userIdRef.current);
            const mlLensMoreContext = mlLensEnvelope ? {
                ml_lens: mlLensEnvelope
            } : undefined;
            (0, $cozmU.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $hnyex.onTaskSuccess)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: postQueryTaskState.current.id,
                    task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                    moreContext: mlLensMoreContext
                }));
            });
            postQueryTaskState.current.completed = true;
        } else if (state === 'POSTQUERY_ERROR') {
            // Include error information if available (errorName and errorMessage for debugging)
            const moreContext = postQueryTaskState.current.error ? {
                errorName: postQueryTaskState.current.error.name,
                errorMessage: postQueryTaskState.current.error.message
            } : undefined;
            (0, $cozmU.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $hnyex.onTaskFail)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: postQueryTaskState.current.id,
                    task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                    moreContext: moreContext
                }));
            });
            postQueryTaskState.current.completed = true;
        }
    }, [
        content?.state,
        postQueryTaskState
    ]);
    // Handle cached terminal states when dialog reopens
    // This fires VitalStats events for cached POSTQUERY_RESULTS/NO_RESULTS/ERROR states
    // when the dialog opens but no new fetch happens (e.g., same query as before)
    (0, $cozmU.useEffect)(()=>{
        if (!quickFindOpen) return;
        // Only fire if task hasn't been started yet (dialog just opened)
        if (postQueryTaskState.current.started) return;
        // Only fire once per dialog open session
        if (handledCachedPostQueryStateRef.current) return;
        const state = content?.state;
        // Check if we have cached terminal postquery states
        if (state === 'POSTQUERY_RESULTS' || state === 'POSTQUERY_NO_RESULTS' || state === 'POSTQUERY_ERROR') {
            // Mark as handled to prevent duplicate events
            handledCachedPostQueryStateRef.current = true;
            // Start and immediately complete the task for the cached state
            const taskId = crypto.randomUUID();
            postQueryTaskState.current.id = taskId;
            postQueryTaskState.current.started = true;
            postQueryTaskState.current.completed = true;
            // Fire taskStart and completion events (defer to not block rendering)
            (0, $cozmU.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $hnyex.onTaskStart)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_POST_QUERY_UX
                }));
                // Immediately fire completion event based on cached state
                if (state === 'POSTQUERY_RESULTS' || state === 'POSTQUERY_NO_RESULTS') {
                    // The builder returns `null` when there is no `userId`, so the tag
                    // is omitted entirely in that case.
                    const mlLensEnvelope = (0, $1qIUZ.buildPostQueryMlLensEnvelope)((0, $9gI1G.getProductResultCounts)(), userIdRef.current);
                    const mlLensMoreContext = mlLensEnvelope ? {
                        ml_lens: mlLensEnvelope
                    } : undefined;
                    fireVitalStatsEventRef.current((0, $hnyex.onTaskSuccess)({
                        searchSessionId: searchSessionIdRef.current,
                        taskId: taskId,
                        task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                        moreContext: mlLensMoreContext
                    }));
                } else if (state === 'POSTQUERY_ERROR') {
                    // Note: error might be null since it was cleared on dialog close
                    const moreContext = postQueryTaskState.current.error ? {
                        errorName: postQueryTaskState.current.error.name,
                        errorMessage: postQueryTaskState.current.error.message
                    } : undefined;
                    fireVitalStatsEventRef.current((0, $hnyex.onTaskFail)({
                        searchSessionId: searchSessionIdRef.current,
                        taskId: taskId,
                        task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                        moreContext: moreContext
                    }));
                }
            });
            // Clear error after it's been used to prevent memory accumulation
            if (state === 'POSTQUERY_ERROR') postQueryTaskState.current.error = null;
        }
    }, [
        quickFindOpen,
        content?.state,
        postQueryTaskState
    ]);
    // Handle transition back to PREQUERY_RESULTS from postquery states
    // This fires VitalStats events when user clears the search text and returns to prequery
    (0, $cozmU.useEffect)(()=>{
        const state = content?.state;
        // Reset the flag when entering postquery states so we can track the next transition back
        if (state === 'POSTQUERY_LOADING' || state === 'POSTQUERY_RESULTS' || state === 'POSTQUERY_NO_RESULTS' || state === 'POSTQUERY_ERROR') {
            handledCachedPreQueryStateRef.current = false;
            return;
        }
        // Only handle PREQUERY_RESULTS state
        if (state !== 'PREQUERY_RESULTS') return;
        // Don't fire if we've already handled this transition
        if (handledCachedPreQueryStateRef.current) return;
        // Only fire if we previously had a postquery task (meaning we're transitioning back from postquery)
        // We fire events even if preQueryCompleted is false because the results might be cached
        // (i.e., dialog opened with existing cached results, so onPreQueryStart was never called)
        if (postQueryTaskStateRef.current.current.started) {
            // Mark as handled to prevent duplicate events
            handledCachedPreQueryStateRef.current = true;
            // Reset prequery flags and start a new prequery task for the cached results
            // Use the existing taskId if already set; otherwise generate a new one
            if (!preQueryTaskIdRef.current) preQueryTaskIdRef.current = crypto.randomUUID();
            const taskId = preQueryTaskIdRef.current;
            preQueryTaskStartedRef.current = true;
            preQueryTaskCompletedRef.current = false; // Set to false first so the state-watching useEffect doesn't interfere
            // Fire taskStart and taskSuccess (defer to not block rendering)
            (0, $cozmU.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $hnyex.onTaskStart)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
                // Immediately fire taskSuccess for cached prequery results
                fireVitalStatsEventRef.current((0, $hnyex.onTaskSuccess)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
            });
            // Now mark as completed
            preQueryTaskCompletedRef.current = true;
        }
    }, [
        content?.state
    ]);
    /**
   * Called when pre-query search starts.
   * Fires VitalStats taskStart event to track the beginning of the pre-query operation.
   * Only fires when Quick Find is actually open (not during background preloading).
   * Ensures taskStart is only fired once per session.
   */ const onPreQueryStart = (0, $cozmU.useCallback)(()=>{
        // Fire VitalStats taskStart event only if Quick Find is open and not already started
        // Skip if cached POSTQUERY results are showing (postQuery events will handle that case)
        if (quickFindOpen && !preQueryTaskStartedRef.current) {
            // Check if we have cached postQuery results - if so, don't fire preQuery events
            const state = content?.state;
            if (state === 'POSTQUERY_RESULTS' || state === 'POSTQUERY_NO_RESULTS' || state === 'POSTQUERY_ERROR') // Cached postQuery state detected - skip preQuery tracking
            // The cached postQuery useEffect will handle firing postQuery events
            return;
            // Generate a consistent taskId for this pre-query task
            if (!preQueryTaskIdRef.current) preQueryTaskIdRef.current = crypto.randomUUID();
            (0, $cozmU.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $hnyex.onTaskStart)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: preQueryTaskIdRef.current,
                    task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
            });
            preQueryTaskStartedRef.current = true;
            // If cached preQuery data is already showing,
            // immediately fire taskSuccess since the useEffect won't trigger (no state change)
            if (content?.state === 'PREQUERY_RESULTS') {
                (0, $cozmU.startTransition)(()=>{
                    fireVitalStatsEventRef.current((0, $hnyex.onTaskSuccess)({
                        searchSessionId: searchSessionIdRef.current,
                        taskId: preQueryTaskIdRef.current,
                        task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                    }));
                });
                preQueryTaskCompletedRef.current = true;
            }
        }
    }, [
        quickFindOpen,
        content?.state
    ]);
    /**
   * Called when pre-query search completes successfully.
   * VitalStats taskSuccess event is automatically fired by useEffect when content.state changes to PREQUERY_RESULTS.
   */ const onPreQuerySuccess = (0, $cozmU.useCallback)(()=>{
    // VitalStats success event is handled by useEffect watching content.state
    }, []);
    /**
   * Called when pre-query search fails with an error.
   * Stores error details (name, message) which will be included in the VitalStats taskFail event.
   * VitalStats taskFail event is automatically fired by useEffect when content.state changes to PREQUERY_ERROR.
   *
   * @param error - Optional Error object containing failure details. Error messages should not contain PII.
   */ const onPreQueryFailure = (0, $cozmU.useCallback)((error)=>{
        // Store error for useEffect to access
        if (error) preQueryErrorRef.current = error;
    // VitalStats fail event is handled by useEffect watching content.state
    }, []);
    const onPostQueryStart = (0, $cozmU.useCallback)(()=>{
        // If dialog is closed, fire taskStart + immediate taskAbort to track background cache request
        // Network request still fires for caching, but user isn't waiting for it
        if (!quickFindOpen) {
            // Generate taskId for the background cache request
            const taskId = crypto.randomUUID();
            postQueryTaskState.current.id = taskId;
            postQueryTaskState.current.started = true;
            postQueryTaskState.current.completed = true; // Mark as completed immediately
            (0, $cozmU.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $hnyex.onTaskStart)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_POST_QUERY_UX
                }));
                fireVitalStatsEventRef.current((0, $hnyex.onTaskAbort)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                    moreContext: {
                        abortReason: 'dialog_closed_before_debounce_fired'
                    }
                }));
            });
            return;
        }
        // Abort previous task if still active
        if (postQueryTaskState.current.started && !postQueryTaskState.current.completed) (0, $cozmU.startTransition)(()=>{
            fireVitalStatsEventRef.current((0, $hnyex.onTaskAbort)({
                searchSessionId: searchSessionIdRef.current,
                taskId: postQueryTaskState.current.id,
                task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                moreContext: {
                    abortReason: 'superseded_by_new_query'
                }
            }));
        });
        // Start new task - use existing taskId if already set (e.g., by fetchQuickFindPostQuery)
        // Only generate a new one if not already set or if we just aborted a previous task
        if (!postQueryTaskState.current.id || postQueryTaskState.current.started) postQueryTaskState.current.id = crypto.randomUUID();
        const taskId = postQueryTaskState.current.id;
        postQueryTaskState.current.started = true;
        postQueryTaskState.current.completed = false;
        (0, $cozmU.startTransition)(()=>{
            fireVitalStatsEventRef.current((0, $hnyex.onTaskStart)({
                searchSessionId: searchSessionIdRef.current,
                taskId: taskId,
                task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_POST_QUERY_UX
            }));
        });
        /**
     * QS-7380 (LDR: https://hello.atlassian.net/wiki/x/QVo8QwE)
     * Aborting on keypress fires a lot of dirty data volume to ufo. Instead we only instrument on query (inside the debounce), offsetting the start time by the debounce window because the keypress that trigger the debounce is the start of the interaction.
     */ const startTimestamp = performance.now() - debounceTimeout;
        // Only begin the interaction if QF is still open
        // If QF is closed, we still make the network request, so the next open of the same text is instant
        // However, we must not start the interaction, as if QF is closed during the debounce window, this interaction can abort other intreractions, like FPS search results shown!
        if (quickFindOpen) (0, $eYg5X.default)((0, $6h661.QUICK_FIND_POST_QUERY_INTERACTION), startTimestamp);
    }, [
        quickFindOpen,
        debounceTimeout,
        postQueryTaskState
    ]);
    const onPostQuerySuccess = (0, $cozmU.useCallback)((duration, hasThirdPartyResults, resultCount)=>{
        incrementQueryVersion();
        onSearchCompleted?.(resultCount, quickFindQuery);
        fireQuickFindAnalyticsEvent((0, $6838a8bbe742cb30$export$caa45abe6a87e5b5)({
            attributes: {
                ...commonAttributes,
                postQueryRequestDurationMs: duration,
                hasThirdPartyResults: hasThirdPartyResults
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireQuickFindAnalyticsEvent,
        incrementQueryVersion,
        nonPrivacySafeAttributes,
        onSearchCompleted,
        quickFindQuery
    ]);
    const onPostQueryFailure = (0, $cozmU.useCallback)((error)=>{
        (0, $aj2pm.setInteractionError)((0, $6h661.QUICK_FIND_POST_QUERY_INTERACTION), {
            errorMessage: error?.message || 'request failed',
            name: error?.name || 'request failed'
        });
        // Store error for useEffect to access when state changes to POSTQUERY_ERROR
        if (error) postQueryTaskState.current.error = error;
    }, [
        postQueryTaskState
    ]);
    const onPostQueryCancel = (0, $cozmU.useCallback)(()=>{}, []);
    return (0, $cozmU.useMemo)(()=>({
            onPreQueryStart: onPreQueryStart,
            onPreQuerySuccess: onPreQuerySuccess,
            onPreQueryFailure: onPreQueryFailure,
            onPostQueryStart: onPostQueryStart,
            onPostQuerySuccess: onPostQuerySuccess,
            onPostQueryFailure: onPostQueryFailure,
            onPostQueryCancel: onPostQueryCancel,
            postQueryTaskState: postQueryTaskState,
            preQueryTaskIdRef: preQueryTaskIdRef
        }), [
        onPostQueryCancel,
        onPostQueryFailure,
        onPostQueryStart,
        onPostQuerySuccess,
        onPreQueryFailure,
        onPreQueryStart,
        onPreQuerySuccess,
        postQueryTaskState
    ]);
};



var $7AGG2 = parcelRequire("7AGG2");




const $c278ce1ceab1ece2$export$290039782fc4e47 = async (query, organizationId, primaryProduct, principalId, siteId)=>{
    // Override townsquare with watermelon as URS does not support townsquare as a primary product
    const productKey = primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Atlas ? 'watermelon' : primaryProduct;
    const response = await (0, $7AGG2.default)({
        query: query,
        context: {
            contextType: 'quick_find',
            siteId: siteId,
            productKey: productKey,
            principalId: principalId,
            organizationId: organizationId
        },
        includeUsers: true,
        includeTeams: true,
        includeGroups: false,
        maxNumberOfResults: 2,
        performSearchQueryOnly: false,
        searchQuery: {
            filter: 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)'
        }
    });
    return response.map($c278ce1ceab1ece2$export$cf1f13813d90479a);
};
const $c278ce1ceab1ece2$export$cf1f13813d90479a = (result)=>({
        id: result.id,
        title: result.name || result.displayName || '',
        data: result,
        type: 'people-and-teams'
    });



var $cXtTj = parcelRequire("cXtTj");














var $8N8EQ = parcelRequire("8N8EQ");


var $dv1ov = parcelRequire("dv1ov");


var $coUcA = parcelRequire("coUcA");


var $fnx12 = parcelRequire("fnx12");


var $5msm2 = parcelRequire("5msm2");


var $7OWRz = parcelRequire("7OWRz");


var $7ohhA = parcelRequire("7ohhA");


var $2ePuQ = parcelRequire("2ePuQ");





var $hea5O = parcelRequire("hea5O");


var $03qcI = parcelRequire("03qcI");

const $a0bf6222642757c3$var$createValidationError = (message)=>{
    return {
        success: false,
        error: {
            name: 'ValidationError',
            message: message
        }
    };
};
const $a0bf6222642757c3$var$validateBaseSearchResultsResponse = (response)=>{
    if (!response) return $a0bf6222642757c3$var$createValidationError('Response is null or undefined');
    // GraphQL response should always include a `data` key (it can be null)
    if (!('data' in response)) return $a0bf6222642757c3$var$createValidationError('Response missing "data" field');
    if (!response.data) return {
        success: true
    };
    const data = response.data;
    if (!data.search) return $a0bf6222642757c3$var$createValidationError('Response missing "data.search" field');
    if (!data.search.results) return $a0bf6222642757c3$var$createValidationError('Response missing "data.search.results" field');
    if (!('edges' in data.search.results)) return $a0bf6222642757c3$var$createValidationError('Response missing "data.search.results.edges" field');
    if (!Array.isArray(data.search.results.edges)) return $a0bf6222642757c3$var$createValidationError('Expected "data.search.results.edges" to be an array');
    if (response.extensions !== undefined && response.extensions !== null) {
        if (typeof response.extensions !== 'object') return $a0bf6222642757c3$var$createValidationError('Expected "extensions" to be an object');
    }
    if (response.errors !== undefined && response.errors !== null) {
        if (!Array.isArray(response.errors)) return $a0bf6222642757c3$var$createValidationError('Expected "errors" to be an array');
    }
    return {
        success: true
    };
};
const $a0bf6222642757c3$var$validateEdgesHaveRenderableNodes = (response, productName)=>{
    const baseResult = $a0bf6222642757c3$var$validateBaseSearchResultsResponse(response);
    if (!baseResult.success) return baseResult;
    if (!response.data) return {
        success: true
    };
    const edges = response.data.search?.results?.edges;
    if (!edges || edges.length === 0) return {
        success: true
    };
    for(let i = 0; i < edges.length; i++){
        const node = edges[i]?.node;
        if (!node) return $a0bf6222642757c3$var$createValidationError(`${productName} response has null/undefined node at index ${i}`);
        if (!node.id || typeof node.id !== 'string' || node.id.length === 0) return $a0bf6222642757c3$var$createValidationError(`${productName} response node at index ${i} missing valid 'id'`);
        // title can be empty string but not null/undefined
        if (node.title === null || node.title === undefined) return $a0bf6222642757c3$var$createValidationError(`${productName} response node at index ${i} missing 'title'`);
    }
    return {
        success: true
    };
};
const $a0bf6222642757c3$export$20b56250dbe571a6 = (response)=>{
    return $a0bf6222642757c3$var$validateEdgesHaveRenderableNodes(response, 'Confluence entities');
};
const $a0bf6222642757c3$export$2d15de88a41d9abf = (response)=>{
    return $a0bf6222642757c3$var$validateEdgesHaveRenderableNodes(response, 'Loom entities');
};
const $a0bf6222642757c3$export$8a51174b28efed00 = (response)=>{
    return $a0bf6222642757c3$var$validateEdgesHaveRenderableNodes(response, 'Confluence spaces');
};
const $a0bf6222642757c3$export$bced2ae2552eb202 = (response)=>{
    return $a0bf6222642757c3$var$validateEdgesHaveRenderableNodes(response, 'Jira issues');
};
const $a0bf6222642757c3$export$543d873e6345fc5d = (response)=>{
    return $a0bf6222642757c3$var$validateEdgesHaveRenderableNodes(response, 'Jira entities');
};
const $a0bf6222642757c3$export$e4f72abe33981720 = (response)=>{
    return $a0bf6222642757c3$var$validateEdgesHaveRenderableNodes(response, 'Atlas');
};
const $a0bf6222642757c3$export$871e055bca75b7a7 = (response)=>{
    return $a0bf6222642757c3$var$validateEdgesHaveRenderableNodes(response, 'Mercury');
};
const $a0bf6222642757c3$export$ed329220155db920 = (response)=>{
    return $a0bf6222642757c3$var$validateEdgesHaveRenderableNodes(response, 'Talent');
};
const $a0bf6222642757c3$export$e72eeeb1dc40af20 = (response)=>{
    return $a0bf6222642757c3$var$validateEdgesHaveRenderableNodes(response, 'Assets');
};


const $8991f7e4656f199d$var$experience = 'quick-find';
const $8991f7e4656f199d$var$LEGACY_LOOM_VIDEO_ENTITY = 'ati:cloud:graph:video';
const $8991f7e4656f199d$var$LOOM_PLAYLIST_ENTITY = 'ati:cloud:loom:playlist';
const $8991f7e4656f199d$var$LOOM_VIDEO_ENTITY = 'ati:cloud:loom:video';
const $8991f7e4656f199d$var$hasSelectedLoomVideoFilters = (loomFilters)=>[
        loomFilters?.spaceIds,
        loomFilters?.folderIds,
        loomFilters?.tagNames,
        loomFilters?.videoTypes
    ].some((filterValues)=>Boolean(filterValues?.length));
const $8991f7e4656f199d$var$getLoomEntities = (isLoomRovoSearchEnabled, selectedTypeEntities, loomFilters)=>{
    if (!isLoomRovoSearchEnabled) return [
        $8991f7e4656f199d$var$LEGACY_LOOM_VIDEO_ENTITY
    ];
    const nativeTypeEntities = selectedTypeEntities.filter((entity)=>entity.startsWith('ati:cloud:loom:'));
    if (nativeTypeEntities.length > 0) return nativeTypeEntities;
    const valueFilterEntities = [];
    if ($8991f7e4656f199d$var$hasSelectedLoomVideoFilters(loomFilters)) valueFilterEntities.push($8991f7e4656f199d$var$LOOM_VIDEO_ENTITY);
    if (loomFilters?.playlistIds?.length) valueFilterEntities.push($8991f7e4656f199d$var$LOOM_PLAYLIST_ENTITY);
    return valueFilterEntities.length > 0 ? valueFilterEntities : [
        $8991f7e4656f199d$var$LEGACY_LOOM_VIDEO_ENTITY
    ];
};
/**
 * Builds merged headers combining atl-attribution and region steering headers.
 * Feature flag check for atl-attribution is handled internally by buildAtlAttributionHeaders.
 */ const $8991f7e4656f199d$var$buildMergedHeaders = (cloudId, activationId, sourceProduct, productDataRegions)=>{
    // Feature flag check is handled internally by buildAtlAttributionHeaders
    const atlAttributionHeaders = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: activationId,
        product: sourceProduct
    });
    const regionSteeringHeaders = sourceProduct && productDataRegions ? {
        'atl-edge-region-hint': (0, $fnx12.getEdgeRegionHint)(sourceProduct, productDataRegions)
    } : undefined;
    if (!atlAttributionHeaders && !regionSteeringHeaders) return undefined;
    return {
        ...regionSteeringHeaders,
        ...atlAttributionHeaders
    };
};
const $8991f7e4656f199d$export$263a3384b7ce18b1 = (thirdPartyConfigs)=>{
    const excluded3PProducts = [
        (0, $fR63l.ProductKeys3P).Slack,
        (0, $fR63l.ProductKeys3P).Teams,
        (0, $fR63l.ProductKeys3P).Gmail,
        (0, $fR63l.ProductKeys3P).OutlookMail
    ];
    // Adding additional 3P products not included in thirdPartyConfigs
    const additional3PProducts = [
        (0, $fR63l.ProductKeys3P).Loom // Loom is 1P product but treated as 3P in API filters
    ];
    const thirdPartyKeys = Object.keys(thirdPartyConfigs);
    const quickFind3PProducts = additional3PProducts.concat(thirdPartyKeys).filter((productKey)=>!excluded3PProducts.includes(productKey));
    return (0, $hea5O.getThirdPartyFilters)(quickFind3PProducts, false, // titleMatchOnly value
    [], // it will search all subtypes if no entities are provided
    thirdPartyConfigs);
};
const $8991f7e4656f199d$export$3c29f91d40cd1d3f = (thirdPartyConfigs)=>{
    // Prerequisite: We should not request 3P in Quick Find if the user does not have any 3P authenticated
    const isEligible3PUser = Object.keys(thirdPartyConfigs).some((productKey)=>thirdPartyConfigs[productKey]?.userNeedsOAuth === false);
    return isEligible3PUser;
};
/**
 * Returns a copy of `filters` with `entity` added to the GitHub `thirdPartyProducts` entry's
 * `entities` array. Scopes the requested entity to GitHub only (vs the top-level `entities`
 * field which fans the request out to every connected 3P provider). No-op if no GitHub entry
 * exists.
 */ const $8991f7e4656f199d$var$addEntityToGitHubProduct = (filters, entity)=>({
        ...filters,
        thirdPartyProducts: filters?.thirdPartyProducts?.map((product)=>{
            if (product.product !== 'github') return product;
            const entities = new Set([
                ...product.entities ?? [],
                entity
            ]);
            return {
                ...product,
                entities: [
                    ...entities
                ]
            };
        })
    });
const $8991f7e4656f199d$var$GITHUB_PRODUCT_KEYS = [
    (0, $fR63l.ProductKeys3P).Github,
    (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
    (0, $fR63l.ProductKeys3P).ForgePioGithubProd
];
const $8991f7e4656f199d$var$hasGitHubConnected = (thirdPartyConfigs)=>$8991f7e4656f199d$var$GITHUB_PRODUCT_KEYS.some((key)=>thirdPartyConfigs[key]?.userNeedsOAuth === false);
const $8991f7e4656f199d$var$hasGitHubImpersonationEnabled = (thirdPartyConfigs)=>!!(thirdPartyConfigs[(0, $fR63l.ProductKeys3P).Github]?.userNeedsOAuth && thirdPartyConfigs[(0, $fR63l.ProductKeys3P).Github]?.impersonationEnabled);
const $8991f7e4656f199d$export$f1b35c234241f2ba = (thirdPartyConfigs)=>{
    return {
        serveGitHub3P: $8991f7e4656f199d$var$hasGitHubConnected(thirdPartyConfigs) || $8991f7e4656f199d$var$hasGitHubImpersonationEnabled(thirdPartyConfigs)
    };
};
const $8991f7e4656f199d$export$a850af7b2e4494bd = (thirdPartyConfigs)=>{
    const gitHubThirdPartyConfigs = {};
    for (const key of $8991f7e4656f199d$var$GITHUB_PRODUCT_KEYS)if (thirdPartyConfigs[key]) gitHubThirdPartyConfigs[key] = thirdPartyConfigs[key];
    return (0, $hea5O.getThirdPartyFilters)($8991f7e4656f199d$var$GITHUB_PRODUCT_KEYS, false, // titleMatchOnly value
    [], // search all subtypes
    gitHubThirdPartyConfigs);
};
const $8991f7e4656f199d$export$9605a5c4a68b2654 = async (aggAbsoluteUrl, useCaseId, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, filteredEntities, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters } = selectedFilters || (0, $hea5O.getEmptySelectedFilters)();
    const serve3P = $8991f7e4656f199d$export$3c29f91d40cd1d3f(thirdPartyConfigs);
    let thirdPartyFilters = serve3P ? $8991f7e4656f199d$export$263a3384b7ce18b1(thirdPartyConfigs) : {
        titleMatchOnly: true,
        subtypes: []
    };
    const supportedEntities = [
        'ati:cloud:confluence:page',
        'ati:cloud:confluence:blogpost',
        'ati:cloud:confluence:attachment',
        'ati:cloud:confluence:whiteboard',
        ...(0, $fbOob.isContentTypeEnabledInCurrentEnv)('slide') && !(0, $iDrrr.fg)('cc-mui-slides-opted-out') && (0, $cXtTj.default).getExperimentValue('cc-mui-slides-experiment', 'isEnabled', false, {
            fireExperimentExposure: true
        }) === true ? [
            'ati:cloud:confluence:slide'
        ] : [],
        'ati:cloud:confluence:database',
        'ati:cloud:confluence:embed',
        'ati:cloud:confluence:folder',
        ...serve3P ? [
            'ati:cloud:graph:document'
        ] : [],
        ...(0, $iDrrr.fg)('quickfind-smartlinks') || serve3P ? [
            'ati:cloud:graph:remote-link'
        ] : []
    ];
    const entities = supportedEntities.filter((supportedEntity)=>filteredEntities.includes(supportedEntity));
    // GitHub code search is independently gated: any user with GitHub connected and the gate
    // on gets code results, regardless of which other 3P experiment cohort they're in.
    // Scope the document entity to the GitHub thirdPartyProducts entry (not the top-level
    // entities array) so we don't fan the request out to every other 3P provider.
    // Quick Find code search is legacy-only: in code search M1 mode only Full Page Search
    // serves code, so this path stays off.
    const isGitHubConnectedForConfluence = $8991f7e4656f199d$var$GITHUB_PRODUCT_KEYS.some((key)=>thirdPartyConfigs[key]?.userNeedsOAuth === false);
    if (isGitHubConnectedForConfluence && (0, $coUcA.isLegacyCodeSearchEnabled)()) thirdPartyFilters = $8991f7e4656f199d$var$addEntityToGitHubProduct(thirdPartyFilters, 'ati:cloud:graph:document');
    const backendExperiment = (0, $5msm2.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $03qcI.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $8991f7e4656f199d$var$experience,
        tenantId: cloudId,
        thirdPartyFilters: thirdPartyFilters
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $8991f7e4656f199d$var$experience,
        useCaseId: useCaseId,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 7,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        assetsFilters: assetsFilters,
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: [],
                reporterARIs: [],
                commenterARIs: [],
                issueTypeIDs: [],
                issueLabels: [],
                issueTypes: [],
                statusCategories: [],
                watcherARIs: []
            }
        },
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId ?? undefined,
        shadowExperimentId: shadowExperimentId ?? undefined,
        experimentLayers: $8991f7e4656f199d$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeUserSignals: false,
        includeSpaceSubtype: false,
        includeConfluenceEntity: false,
        skipFieldsFor3pInQuickFind: serve3P,
        includeGithubEntityHydration: false,
        includeAutocompleteSuggestions: (0, $iDrrr.fg)('fe_quickfind_autocomplete_suggestions')
    };
    const headers = $8991f7e4656f199d$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $dv1ov.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $8N8EQ.extractTraceInfoFromResponse)(response);
        if (networkCallbacks) {
            const validationResult = (0, $a0bf6222642757c3$export$20b56250dbe571a6)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        const autocompleteSuggestions = response.data?.search?.results.autocompleteSuggestions;
        return {
            fetchResults: $8991f7e4656f199d$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || [],
            autocompleteSuggestions: autocompleteSuggestions
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined,
            autocompleteSuggestions: undefined
        };
    }
};
const $8991f7e4656f199d$export$732c2c351dac9fec = async (aggAbsoluteUrl, useCaseId, query, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, thirdPartyConfigs, sessionId, networkCallbacks, activationId, selectedTypeEntities = [])=>{
    const sourceProduct = (0, $fR63l.ProductKeys3P).Loom;
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters } = (0, $hea5O.getEmptySelectedFilters)();
    const isLoomRovoSearchEnabled = (0, $iDrrr.fg)('loom-rovo-search');
    const loomFilters = selectedFilters?.loomFilters;
    const entities = $8991f7e4656f199d$var$getLoomEntities(isLoomRovoSearchEnabled, selectedTypeEntities, loomFilters);
    const usesNativeLoomEntities = entities.some((entity)=>entity.startsWith('ati:cloud:loom:'));
    const thirdPartyFilters = usesNativeLoomEntities ? undefined : (0, $hea5O.getThirdPartyFilters)([
        (0, $fR63l.ProductKeys3P).Loom
    ], false, [], thirdPartyConfigs, false);
    const backendExperiment = (0, $5msm2.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $03qcI.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $8991f7e4656f199d$var$experience,
        tenantId: cloudId,
        ...thirdPartyFilters ? {
            thirdPartyFilters: thirdPartyFilters
        } : {}
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $8991f7e4656f199d$var$experience,
        useCaseId: useCaseId,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:loom::site/${cloudId}`,
        tenantId: cloudId,
        limit: 7,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        assetsFilters: assetsFilters,
        ...isLoomRovoSearchEnabled ? {
            loomFilters: loomFilters
        } : {},
        ...thirdPartyFilters ? {
            thirdPartyFilters: thirdPartyFilters
        } : {},
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId ?? undefined,
        shadowExperimentId: shadowExperimentId ?? undefined,
        experimentLayers: $8991f7e4656f199d$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeUserSignals: false,
        includeSpaceSubtype: false,
        includeConfluenceEntity: false,
        skipFieldsFor3pInQuickFind: true,
        includeGithubEntityHydration: false,
        includeLoomVideoMetadata: isLoomRovoSearchEnabled,
        // TODO: Enable Loom autocomplete after its suggestions are forwarded through Quick Find.
        includeAutocompleteSuggestions: false
    };
    const headers = $8991f7e4656f199d$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $dv1ov.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $8N8EQ.extractTraceInfoFromResponse)(response);
        if (networkCallbacks) {
            const validationResult = (0, $a0bf6222642757c3$export$2d15de88a41d9abf)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        return {
            fetchResults: $8991f7e4656f199d$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || []
        };
    } catch (error) {
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined
        };
    }
};
const $8991f7e4656f199d$export$919c2c6ec09a9e2 = async (aggAbsoluteUrl, useCaseId, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters } = selectedFilters || (0, $hea5O.getEmptySelectedFilters)();
    const entities = [
        'ati:cloud:confluence:space'
    ];
    const backendExperiment = (0, $5msm2.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $03qcI.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $8991f7e4656f199d$var$experience,
        tenantId: cloudId
    });
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $8991f7e4656f199d$var$experience,
        useCaseId: useCaseId,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 1,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        assetsFilters: assetsFilters,
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: [],
                reporterARIs: [],
                commenterARIs: [],
                issueTypeIDs: [],
                issueLabels: [],
                issueTypes: [],
                statusCategories: [],
                watcherARIs: []
            }
        },
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: []
        },
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId ?? undefined,
        shadowExperimentId: shadowExperimentId ?? undefined,
        experimentLayers: $8991f7e4656f199d$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeSpaceSubtype: false
    };
    const headers = $8991f7e4656f199d$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $dv1ov.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $8N8EQ.extractTraceInfoFromResponse)(response);
        if (networkCallbacks) {
            const validationResult = (0, $a0bf6222642757c3$export$8a51174b28efed00)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        return {
            fetchResults: $8991f7e4656f199d$var$processAndValidateNodes(nodes),
            fetchSpacesRequestId: response.extensions?.gateway?.request_id,
            errors: response.errors || []
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchSpacesRequestId: undefined
        };
    }
};
const $8991f7e4656f199d$export$65df7212bf163b08 = async (aggAbsoluteUrl, useCaseId, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    const { commonFilters: commonFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters } = selectedFilters || (0, $hea5O.getEmptySelectedFilters)();
    const serve3P = $8991f7e4656f199d$export$3c29f91d40cd1d3f(thirdPartyConfigs);
    const thirdPartyFilters = serve3P ? $8991f7e4656f199d$export$263a3384b7ce18b1(thirdPartyConfigs) : {
        titleMatchOnly: false,
        subtypes: []
    };
    const entities = [
        'ati:cloud:townsquare:project',
        'ati:cloud:townsquare:goal',
        'ati:cloud:townsquare:tag',
        'ati:cloud:confluence:page',
        'ati:cloud:confluence:blogpost',
        (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI),
        ...serve3P ? [
            'ati:cloud:graph:document'
        ] : [],
        ...serve3P ? [
            'ati:cloud:graph:remote-link'
        ] : []
    ];
    const backendExperiment = (0, $5msm2.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $03qcI.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $8991f7e4656f199d$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $8991f7e4656f199d$var$experience,
        useCaseId: useCaseId,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 6,
        commonFilters: commonFilters,
        assetsFilters: assetsFilters,
        confluenceFilters: {
            spacesFilter: [],
            contributorsFilter: [],
            ancestorIdsFilter: [],
            range: [],
            owners: [],
            labelsFilter: [],
            titleMatchOnly: true,
            contentStatuses: [],
            containerStatus: []
        },
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: [],
                reporterARIs: [],
                commenterARIs: [],
                issueTypeIDs: [],
                issueLabels: [],
                issueTypes: [],
                statusCategories: [],
                watcherARIs: []
            }
        },
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $8991f7e4656f199d$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeSpaceSubtype: false,
        skipFieldsFor3pInQuickFind: serve3P,
        includeGithubEntityHydration: false
    };
    const headers = $8991f7e4656f199d$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $dv1ov.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $8N8EQ.extractTraceInfoFromResponse)(response);
        if (networkCallbacks) {
            const validationResult = (0, $a0bf6222642757c3$export$e4f72abe33981720)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        return {
            fetchResults: $8991f7e4656f199d$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || []
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined
        };
    }
};
const $8991f7e4656f199d$export$60162ce0dfbba9f8 = async (aggAbsoluteUrl, useCaseId, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters, thirdPartyFilters: selectedThirdPartyFilters } = selectedFilters || (0, $hea5O.getEmptySelectedFilters)();
    // Respect explicit user-selected 3P filters if provided; otherwise fall back to the empty default.
    const thirdPartyFilters = selectedFilters?.thirdPartyFilters ?? selectedThirdPartyFilters;
    const passionfruitAskEntity = 'ati:cloud:passionfruit:ask';
    const mercuryAskEntity = 'ati:cloud:mercury:ask';
    const mercuryRiskEntity = 'ati:cloud:mercury:risk';
    const organizationEntity = 'ati:cloud:mercury:organization';
    const organizationStatusUpdateEntity = 'ati:cloud:mercury:organization-status-update';
    const entities = [
        'ati:cloud:mercury:focus-area',
        'ati:cloud:mercury:focus-area-status-update',
        // Ask UI migration flag takes precedence over the legacy Passionfruit flag so only one
        // Ask entity (Mercury or Passionfruit) is ever requested from the backend.
        ...(0, $iDrrr.fg)('platform_mercury_ask_search_ui_enabled') ? [
            mercuryAskEntity
        ] : (0, $iDrrr.fg)('platform_passionfruit_search_onboarding_enabled') ? [
            passionfruitAskEntity
        ] : [],
        ...(0, $iDrrr.fg)('platform_mercury_risk_search_ui_enabled') ? [
            mercuryRiskEntity
        ] : [],
        ...(0, $iDrrr.fg)('platform_organization_search_onboarding_enabled') ? [
            organizationEntity,
            organizationStatusUpdateEntity
        ] : []
    ];
    const backendExperiment = (0, $5msm2.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $03qcI.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $8991f7e4656f199d$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $8991f7e4656f199d$var$experience,
        useCaseId: useCaseId,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 6,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        assetsFilters: assetsFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $8991f7e4656f199d$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeSpaceSubtype: false,
        includeGithubEntityHydration: false
    };
    const headers = $8991f7e4656f199d$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $dv1ov.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $8N8EQ.extractTraceInfoFromResponse)(response);
        if (networkCallbacks) {
            const validationResult = (0, $a0bf6222642757c3$export$871e055bca75b7a7)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        return {
            fetchResults: $8991f7e4656f199d$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || []
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined
        };
    }
};
const $8991f7e4656f199d$export$39ffd40a0e828404 = async (aggAbsoluteUrl, useCaseId, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters, talentFilters: talentFilters, thirdPartyFilters: selectedThirdPartyFilters } = selectedFilters || (0, $hea5O.getEmptySelectedFilters)();
    // Respect explicit user-selected 3P filters if provided; otherwise fall back to the empty default.
    const thirdPartyFilters = selectedFilters?.thirdPartyFilters ?? selectedThirdPartyFilters;
    const entities = [
        'ati:cloud:radar:position'
    ];
    const backendExperiment = (0, $5msm2.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $03qcI.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $8991f7e4656f199d$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $8991f7e4656f199d$var$experience,
        useCaseId: useCaseId,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 6,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        assetsFilters: assetsFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        talentFilters: talentFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $8991f7e4656f199d$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeSpaceSubtype: false,
        includeGithubEntityHydration: false
    };
    const headers = $8991f7e4656f199d$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $dv1ov.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $8N8EQ.extractTraceInfoFromResponse)(response);
        if (networkCallbacks) {
            const validationResult = (0, $a0bf6222642757c3$export$ed329220155db920)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        return {
            fetchResults: $8991f7e4656f199d$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || []
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined
        };
    }
};
const $8991f7e4656f199d$export$7e4a42258e6edc26 = async (aggAbsoluteUrl, useCaseId, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters, thirdPartyFilters: selectedThirdPartyFilters } = selectedFilters || (0, $hea5O.getEmptySelectedFilters)();
    // Respect explicit user-selected 3P filters if provided; otherwise fall back to the empty default.
    const thirdPartyFilters = selectedFilters?.thirdPartyFilters ?? selectedThirdPartyFilters;
    const entities = [
        'ati:cloud:cmdb:object',
        'ati:cloud:cmdb:schema',
        'ati:cloud:cmdb:type'
    ];
    const backendExperiment = (0, $5msm2.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $03qcI.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $8991f7e4656f199d$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $8991f7e4656f199d$var$experience,
        useCaseId: useCaseId,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 6,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        assetsFilters: assetsFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $8991f7e4656f199d$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeSpaceSubtype: false,
        includeGithubEntityHydration: false
    };
    const headers = $8991f7e4656f199d$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $dv1ov.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $8N8EQ.extractTraceInfoFromResponse)(response);
        if (networkCallbacks) {
            const validationResult = (0, $a0bf6222642757c3$export$e72eeeb1dc40af20)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        return {
            fetchResults: $8991f7e4656f199d$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || []
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined
        };
    }
};
/**
 * The experiment layers are mapped to ensure permitted attributes are sent into search requests.
 */ const $8991f7e4656f199d$var$mapExperimentLayers = (experimentLayers)=>experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
            name: name,
            layerId: layerId,
            shadowId: shadowId,
            definitions: definitions
        }));
const $8991f7e4656f199d$export$eaafe46561fa4ee5 = async (aggAbsoluteUrl, useCaseId, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, isJiraIssueIndexed, thirdPartyConfigs, typeFilterEntities, sessionId, hasEditOrViewPlanPermission, networkCallbacks, activationId)=>{
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, thirdPartyFilters: thirdPartyFilters, jiraFilters: jiraFilters, assetsFilters: assetsFilters } = selectedFilters || (0, $hea5O.getEmptySelectedFilters)();
    const { selectedEntities: selectedEntities, entitiesForQuery: entitiesForQuery } = typeFilterEntities;
    const gitHub3PExperiment = $8991f7e4656f199d$export$f1b35c234241f2ba(thirdPartyConfigs);
    // This fetcher always searches Jira issues, so evaluating the experiment here only fires
    // exposure for Jira-relevant Quick Find searches. When enabled, the SearchDialogQuery emits the
    // lighter value-field Jira issue hydration (see serveQfFastJiraHydrationExperiment).
    const fastJiraHydration = (0, $cJff5.serveQfFastJiraHydrationExperiment)();
    const supportedEntities = [
        (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI),
        (0, $2ePuQ.JIRA_PROJECT_ENTITY_ATI),
        (0, $2ePuQ.JIRA_BOARD_ENTITY_ATI),
        (0, $2ePuQ.JIRA_FILTER_ENTITY_ATI),
        (0, $2ePuQ.JIRA_DASHBOARD_ENTITY_ATI)
    ];
    if (hasEditOrViewPlanPermission) supportedEntities.push((0, $2ePuQ.JIRA_PLAN_ENTITY_ATI));
    const entities = selectedEntities.length ? supportedEntities.filter((supportedEntity)=>entitiesForQuery.includes(supportedEntity)) : [
        (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
    ];
    // GitHub entities are appended directly to the final entities array because they are
    // not part of Jira's type mapping in useTypeEntities, so they would be lost if included
    // in supportedEntities (filtered out on the type-filter path, absent on the default path).
    if (gitHub3PExperiment.serveGitHub3P) entities.push(...(0, $7ohhA.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI), ...(0, $7OWRz.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI));
    let gitHubThirdPartyFilters = gitHub3PExperiment.serveGitHub3P ? $8991f7e4656f199d$export$a850af7b2e4494bd(thirdPartyConfigs) : thirdPartyFilters;
    // Scope the document entity to GitHub only via thirdPartyProducts[github].entities.
    // Quick Find code search is legacy-only: in code search M1 mode only Full Page Search
    // serves code, so this path stays off.
    if (gitHub3PExperiment.serveGitHub3P && (0, $coUcA.isLegacyCodeSearchEnabled)()) gitHubThirdPartyFilters = $8991f7e4656f199d$var$addEntityToGitHubProduct(gitHubThirdPartyFilters, 'ati:cloud:graph:document');
    const backendExperiment = (0, $5msm2.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $03qcI.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $8991f7e4656f199d$var$experience,
        tenantId: cloudId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        thirdPartyFilters: gitHubThirdPartyFilters
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers } = backendExperiment || {};
    const variables = {
        experience: $8991f7e4656f199d$var$experience,
        useCaseId: useCaseId,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:jira::site/${cloudId}`,
        tenantId: cloudId,
        limit: 12,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: gitHubThirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentLayers: $8991f7e4656f199d$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeJiraIssueType: true,
        // rovo_qf_jira_fast_hydration: emit the lighter value-field Jira issue hydration via
        // @include/@skip in the query (mirrors includeSocialSignals). Evaluated here because this
        // fetcher always searches Jira issues, so exposure only fires for Jira-relevant searches.
        includeFastJiraHydration: fastJiraHydration,
        includeSpaceSubtype: false,
        assetsFilters: assetsFilters,
        skipFieldsFor3pInQuickFind: false
    };
    const headers = $8991f7e4656f199d$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $dv1ov.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $8N8EQ.extractTraceInfoFromResponse)(response);
        if (networkCallbacks) {
            const validationResult = (0, $a0bf6222642757c3$export$bced2ae2552eb202)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        const autocompleteSuggestions = response.data?.search?.results.autocompleteSuggestions;
        return {
            fetchResults: $8991f7e4656f199d$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || [],
            autocompleteSuggestions: autocompleteSuggestions
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined,
            autocompleteSuggestions: undefined
        };
    }
};
const $8991f7e4656f199d$export$cfa5e5437133749b = async (aggAbsoluteUrl, useCaseId, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, isJiraIssueIndexed, thirdPartyConfigs, sessionId, hasEditOrViewPlanPermission, networkCallbacks, activationId)=>{
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, thirdPartyFilters: thirdPartyFilters, jiraFilters: jiraFilters, assetsFilters: assetsFilters } = selectedFilters || (0, $hea5O.getEmptySelectedFilters)();
    const entities = [
        (0, $2ePuQ.JIRA_BOARD_ENTITY_ATI),
        (0, $2ePuQ.JIRA_FILTER_ENTITY_ATI),
        (0, $2ePuQ.JIRA_PROJECT_ENTITY_ATI),
        (0, $2ePuQ.JIRA_DASHBOARD_ENTITY_ATI)
    ];
    if (hasEditOrViewPlanPermission) entities.push((0, $2ePuQ.JIRA_PLAN_ENTITY_ATI));
    const backendExperiment = (0, $5msm2.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $03qcI.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $8991f7e4656f199d$var$experience,
        tenantId: cloudId,
        isJiraIssueIndexed: isJiraIssueIndexed
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers } = backendExperiment || {};
    const variables = {
        experience: $8991f7e4656f199d$var$experience,
        useCaseId: useCaseId,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:jira::site/${cloudId}`,
        tenantId: cloudId,
        limit: 5,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        assetsFilters: assetsFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentLayers: $8991f7e4656f199d$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeJiraBoardContainer: true,
        includeSpaceSubtype: false
    };
    const headers = $8991f7e4656f199d$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $dv1ov.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $8N8EQ.extractTraceInfoFromResponse)(response);
        if (networkCallbacks) {
            const validationResult = (0, $a0bf6222642757c3$export$543d873e6345fc5d)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        const autocompleteSuggestions = response.data?.search?.results.autocompleteSuggestions;
        return {
            fetchResults: $8991f7e4656f199d$var$processAndValidateNodes(nodes),
            errors: response.errors || [],
            autocompleteSuggestions: autocompleteSuggestions
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            autocompleteSuggestions: undefined
        };
    }
};
const $8991f7e4656f199d$export$cf1f13813d90479a = (result)=>{
    // Detect and filter out invalid/empty nodes from API
    // Allow empty strings but not null/undefined
    if (!result || !result.id || result.title == null) return null;
    return {
        id: result.id,
        title: result.title,
        data: result,
        type: 'search-result'
    };
};
/**
 * Processes nodes and filters out invalid ones.
 */ const $8991f7e4656f199d$var$processAndValidateNodes = (nodes)=>{
    const mappedNodes = nodes.map($8991f7e4656f199d$export$cf1f13813d90479a);
    const validNodes = mappedNodes.filter((node)=>node !== null);
    return validNodes;
};



var $fM05T = parcelRequire("fM05T");

const $e196a48462814c1f$export$d6415f081f333b17 = (primaryProduct, userId)=>{
    const recentSearches = (0, $fM05T.getRecentSearches)({
        userId: userId,
        productId: primaryProduct,
        key: (0, $fM05T.RECENT_SEARCH_KEY)
    });
    return recentSearches.map($e196a48462814c1f$export$cf1f13813d90479a);
};
const $e196a48462814c1f$export$cf1f13813d90479a = (value)=>{
    const data = (0, $fM05T.getRecentQueryObject)(value);
    return {
        id: data.query,
        title: data.query,
        data: data,
        type: 'recent-query'
    };
};






var $dLc3D = parcelRequire("dLc3D");

const $20df5d9011d84a8b$export$5e799f849d8e922b = 20;
/** Entity types the query only asks for when `quick_find_recommendations_for_issue_pr` is on. */ const $20df5d9011d84a8b$var$JIRA_RECOMMENDATION_TYPENAMES = [
    'JiraIssue',
    'ExternalPullRequest'
];
/**
 * Drops Jira work item and pull request recommendations while the gate is off.
 *
 * The query already omits their fragments, so this normally filters nothing. It
 * matters when one arrives anyway — most plausibly from a response cached before
 * the gate was turned off, since the response cache keys on the query variables and
 * not on the composed document. Without this, such a recommendation would occupy one
 * of the three pre-query slots and then render nothing, leaving a short section.
 */ const $20df5d9011d84a8b$var$isSupportedRecommendation = (result)=>{
    const typename = result.object?.__typename;
    if (typename && $20df5d9011d84a8b$var$JIRA_RECOMMENDATION_TYPENAMES.includes(typename)) return (0, $iDrrr.fg)('quick_find_recommendations_for_issue_pr');
    return true;
};
const $20df5d9011d84a8b$export$4858b654778bd2b4 = async (cloudId, userId, aggAbsoluteUrl, headers, featureServiceModel)=>{
    const response = await (0, $dLc3D.cachedRecommendedDocumentsQuery)({
        variables: {
            userId: userId,
            tenantId: cloudId,
            caller: 'quick-find',
            maxNumberOfResults: $20df5d9011d84a8b$export$5e799f849d8e922b,
            // Sent for eligible users in the Quick Find 3P recommendation-model
            // experiment. When omitted, AGG falls back to its default model.
            ...featureServiceModel ? {
                featureServiceModel: featureServiceModel
            } : {}
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        onlyRefreshIfExpired: true,
        returnExpired: false,
        headers: headers
    });
    const recommendations = response.data?.contextService?.quickfindUserRecommendations || [];
    return recommendations.filter((r)=>Boolean(r.object)).filter($20df5d9011d84a8b$var$isSupportedRecommendation).map($20df5d9011d84a8b$export$cf1f13813d90479a);
};
/**
 * The title is what pre-query client-side filtering (`filterSearchResults`)
 * matches the typed query against, so it must mirror what the row renders:
 * Jira issues render as `KEY: summary`.
 */ const $20df5d9011d84a8b$var$getRecommendationTitle = (object)=>{
    switch(object?.__typename){
        case 'ConfluencePage':
            return object.title || '';
        case 'ExternalDocument':
        case 'ExternalPullRequest':
            return object.displayName || '';
        case 'JiraIssue':
            return object.key && object.summary ? `${object.key}: ${object.summary}` : '';
        default:
            return '';
    }
};
const $20df5d9011d84a8b$export$cf1f13813d90479a = (result)=>{
    const object = result.object;
    const title = $20df5d9011d84a8b$var$getRecommendationTitle(object);
    return {
        id: result.id,
        title: title,
        data: result,
        type: 'recommended-document'
    };
};





const $74219d4176b56099$var$getResultSources = (content)=>({
        state: content?.state,
        searchResults: content?.state === (0, $cI6da.State).POSTQUERY_RESULTS ? content.searchResults : content?.state === (0, $cI6da.State).POSTQUERY_LOADING ? content.staleSearchResults : undefined,
        peopleAndTeams: content?.state === (0, $cI6da.State).POSTQUERY_RESULTS ? content.peopleAndTeams : content?.state === (0, $cI6da.State).POSTQUERY_LOADING ? content.stalePeopleAndTeams : undefined,
        recentActivities: content && 'recentActivities' in content ? content.recentActivities : undefined,
        recommendedDocuments: content && 'recommendedDocuments' in content ? content.recommendedDocuments : undefined
    });
const $74219d4176b56099$export$fb053fb6bdc90071 = (content, previousContent, readResultTypeCounts)=>{
    if (!content) return undefined;
    if (content.state === (0, $cI6da.State).POSTQUERY_NO_RESULTS) return content.state !== previousContent?.state ? 'empty' : undefined;
    if (content.state === (0, $cI6da.State).POSTQUERY_ERROR) return content.state !== previousContent?.state ? 'error' : undefined;
    if (content.state !== (0, $cI6da.State).POSTQUERY_RESULTS && content.state !== (0, $cI6da.State).POSTQUERY_LOADING) return undefined;
    const sources = $74219d4176b56099$var$getResultSources(content);
    const previous = $74219d4176b56099$var$getResultSources(previousContent);
    const searchResultsChanged = Boolean(sources.searchResults?.length) && sources.searchResults !== previous.searchResults || Boolean(sources.peopleAndTeams?.length) && sources.peopleAndTeams !== previous.peopleAndTeams;
    if (searchResultsChanged) {
        const counts = readResultTypeCounts();
        if (counts.searchResults > 0 || counts.peopleAndTeams > 0) return 'search';
    }
    const recentResultsChanged = Boolean(sources.recentActivities?.length) && sources.recentActivities !== previous.recentActivities || Boolean(sources.recommendedDocuments?.length) && sources.recommendedDocuments !== previous.recommendedDocuments;
    if (content.state === (0, $cI6da.State).POSTQUERY_LOADING && recentResultsChanged) {
        const counts = readResultTypeCounts();
        if (counts.recentActivities > 0 || counts.recommendations > 0) return 'recent';
    }
    return undefined;
};





const $e42e7db018c399bf$export$6e4070116bdfa183 = ({ query: query, hasFiltersSelected: hasFiltersSelected })=>{
    return Boolean(query || hasFiltersSelected);
};
const $e42e7db018c399bf$var$preQueryErrorHandler = ({ hasQueryOrFilters: hasQueryOrFilters, preQueryError: preQueryError, postQueryDisabled: postQueryDisabled })=>{
    if ((!hasQueryOrFilters || postQueryDisabled) && preQueryError) return {
        state: 'PREQUERY_ERROR',
        query: ''
    };
};
const $e42e7db018c399bf$var$preQueryLoadingHandler = ({ hasQueryOrFilters: hasQueryOrFilters, preQueryLoading: preQueryLoading, filteredRecentQueries: filteredRecentQueries, postQueryDisabled: postQueryDisabled })=>{
    if ((!hasQueryOrFilters || postQueryDisabled) && preQueryLoading) return {
        state: 'PREQUERY_LOADING',
        query: '',
        recentQueries: filteredRecentQueries
    };
};
const $e42e7db018c399bf$var$preQueryNoResultsHandler = ({ hasQueryOrFilters: hasQueryOrFilters, filteredRecentActivities: filteredRecentActivities, filteredRecommendedDocuments: filteredRecommendedDocuments, filteredZeroQueries: filteredZeroQueries, postQueryDisabled: postQueryDisabled })=>{
    const totalResults = filteredRecentActivities.result.length + filteredRecommendedDocuments.result.length + filteredZeroQueries.length;
    if ((!hasQueryOrFilters || postQueryDisabled) && totalResults === 0) return {
        state: 'PREQUERY_NO_RESULTS',
        query: ''
    };
};
const $e42e7db018c399bf$var$preQueryResultsHandler = ({ hasQueryOrFilters: hasQueryOrFilters, filteredRecentQueries: filteredRecentQueries, filteredRecentActivities: filteredRecentActivities, filteredRecommendedDocuments: filteredRecommendedDocuments, filteredZeroQueries: filteredZeroQueries, postQueryDisabled: postQueryDisabled })=>{
    const totalResults = filteredRecentActivities.result.length + filteredRecommendedDocuments.result.length + filteredZeroQueries.length;
    if ((!hasQueryOrFilters || postQueryDisabled) && totalResults > 0) return {
        state: 'PREQUERY_RESULTS',
        query: '',
        recentQueries: filteredRecentQueries,
        recentActivities: filteredRecentActivities.result,
        recommendedDocuments: filteredRecommendedDocuments.result,
        zeroQueries: filteredZeroQueries
    };
};
const $e42e7db018c399bf$var$postQueryErrorHandler = ({ query: query, hasQueryOrFilters: hasQueryOrFilters, postQueryError: postQueryError, postQueryDisabled: postQueryDisabled })=>{
    if (hasQueryOrFilters && !postQueryDisabled && postQueryError) return {
        state: 'POSTQUERY_ERROR',
        query: query || ''
    };
};
const $e42e7db018c399bf$var$postQueryLoadingHandler = ({ query: query, hasQueryOrFilters: hasQueryOrFilters, postQueryLoading: postQueryLoading, filteredRecentActivities: filteredRecentActivities, filteredRecommendedDocuments: filteredRecommendedDocuments, filteredRecentQueries: filteredRecentQueries, filteredZeroQueries: filteredZeroQueries, searchResults: searchResults, peopleAndTeams: peopleAndTeams, postQueryDisabled: postQueryDisabled, primaryProduct: primaryProduct, autocompleteSuggestions: autocompleteSuggestions, instantSearch: instantSearch })=>{
    if (hasQueryOrFilters && !postQueryDisabled && postQueryLoading) {
        // zero queries are only relevant for Jira in post query loading state
        const zeroQueries = primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira ? filteredZeroQueries : [];
        return {
            state: 'POSTQUERY_LOADING',
            query: query || '',
            recentActivities: filteredRecentActivities.result,
            recommendedDocuments: filteredRecommendedDocuments.result,
            recentQueries: filteredRecentQueries,
            zeroQueries: zeroQueries,
            autocompleteSuggestions: autocompleteSuggestions?.map((suggestion, index)=>({
                    id: `autocomplete-suggestion-${index}`,
                    title: suggestion,
                    data: suggestion,
                    type: 'autocomplete-suggestion'
                })),
            // Treatment only: carry previous results for stale-while-revalidate.
            ...instantSearch && {
                staleSearchResults: searchResults.result,
                stalePeopleAndTeams: peopleAndTeams.result
            }
        };
    }
};
const $e42e7db018c399bf$var$postQueryNoResultsHandler = ({ query: query, hasQueryOrFilters: hasQueryOrFilters, filteredRecentActivities: filteredRecentActivities, filteredRecommendedDocuments: filteredRecommendedDocuments, searchResults: searchResults, peopleAndTeams: peopleAndTeams, postQueryDisabled: postQueryDisabled })=>{
    const totalResults = filteredRecentActivities.result.length + filteredRecommendedDocuments.result.length + searchResults.result.length + peopleAndTeams.result.length;
    if (hasQueryOrFilters && !postQueryDisabled && totalResults === 0) return {
        state: 'POSTQUERY_NO_RESULTS',
        query: query || ''
    };
};
const $e42e7db018c399bf$var$postQueryResultsHandler = ({ query: query, hasQueryOrFilters: hasQueryOrFilters, filteredRecentQueries: filteredRecentQueries, filteredRecentActivities: filteredRecentActivities, filteredRecommendedDocuments: filteredRecommendedDocuments, searchResults: searchResults, peopleAndTeams: peopleAndTeams, postQueryDisabled: postQueryDisabled, filteredZeroQueries: filteredZeroQueries, primaryProduct: primaryProduct, autocompleteSuggestions: autocompleteSuggestions })=>{
    // zero queries are only relevant for Jira in post query results state
    const zeroQueries = primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira ? filteredZeroQueries : [];
    const totalResults = filteredRecentActivities.result.length + filteredRecommendedDocuments.result.length + searchResults.result.length + peopleAndTeams.result.length + zeroQueries.length;
    if (hasQueryOrFilters && !postQueryDisabled && totalResults > 0) return {
        state: 'POSTQUERY_RESULTS',
        query: query || '',
        recentQueries: filteredRecentQueries,
        recentActivities: filteredRecentActivities.result,
        recommendedDocuments: filteredRecommendedDocuments.result,
        searchResults: searchResults.result,
        peopleAndTeams: peopleAndTeams.result,
        zeroQueries: zeroQueries,
        autocompleteSuggestions: autocompleteSuggestions?.map((suggestion, index)=>({
                id: `autocomplete-suggestion-${index}`,
                title: suggestion,
                data: suggestion,
                type: 'autocomplete-suggestion'
            }))
    };
};
const $e42e7db018c399bf$export$553e14dec2459e25 = (requestGeneration, latestAppliedGeneration)=>requestGeneration === undefined || requestGeneration >= latestAppliedGeneration;
const $e42e7db018c399bf$export$1b92b497b817b358 = (requestGeneration, latestIssuedGeneration)=>requestGeneration === undefined || requestGeneration === latestIssuedGeneration;
const $e42e7db018c399bf$export$35ead133d529e85e = (args)=>{
    if (!args.quickFindOpen) return;
    const hasProductSelected = args.hasProductSelected ?? false;
    const hasQueryOrFilters = $e42e7db018c399bf$export$6e4070116bdfa183({
        query: args.query,
        hasFiltersSelected: args.hasFiltersSelected || hasProductSelected
    });
    const handlers = [
        $e42e7db018c399bf$var$preQueryErrorHandler,
        $e42e7db018c399bf$var$preQueryLoadingHandler,
        $e42e7db018c399bf$var$preQueryNoResultsHandler,
        $e42e7db018c399bf$var$preQueryResultsHandler,
        $e42e7db018c399bf$var$postQueryErrorHandler,
        $e42e7db018c399bf$var$postQueryLoadingHandler,
        $e42e7db018c399bf$var$postQueryNoResultsHandler,
        $e42e7db018c399bf$var$postQueryResultsHandler
    ];
    for (const handler of handlers){
        const result = handler({
            ...args,
            hasQueryOrFilters: hasQueryOrFilters
        });
        if (result) return result;
    }
    // This should never happen, but default to error state
    if (!args.query) return {
        state: 'PREQUERY_ERROR',
        query: ''
    };
    else return {
        state: 'POSTQUERY_ERROR',
        query: args.query
    };
};



var $CLiaR = parcelRequire("CLiaR");

const $4796b598495fba64$var$EMPTY_RESULTS = {
    result: [],
    duration: 0
};
const $4796b598495fba64$export$6312fbfa29be092d = ()=>{
    let counters = {
        searchResultsRequestCount: 0,
        searchResultsRepaintCount: 0
    };
    return {
        incrementSearchResultsRequest: ()=>{
            counters.searchResultsRequestCount += 1;
        },
        incrementSearchResultsRepaint: ()=>{
            counters.searchResultsRepaintCount += 1;
        },
        snapshotAndReset: ()=>{
            const snapshot = {
                ...counters
            };
            counters = {
                searchResultsRequestCount: 0,
                searchResultsRepaintCount: 0
            };
            return snapshot;
        }
    };
};
const $4796b598495fba64$export$ab15aae48c593ecc = ({ postQueryDisabled: postQueryDisabled, onPreQueryStart: onPreQueryStart, onPreQuerySuccess: onPreQuerySuccess, onPreQueryFailure: onPreQueryFailure, onPostQueryStart: onPostQueryStart, onPostQuerySuccess: onPostQuerySuccess, onPostQueryFailure: onPostQueryFailure, onPostQueryCancel: onPostQueryCancel, postQueryTaskState: postQueryTaskState, preQueryTaskIdRef: preQueryTaskIdRef, analyticsCounterAccumulator: analyticsCounterAccumulator })=>{
    const [bootstrap] = (0, $32Eau.useBootstrap)();
    const useCaseId = (0, $3t6NJ.useSearchUseCaseId)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const isSearchReady = (0, $1i979.useIsSearchReady)();
    const [searchSessionId] = (0, $32Eau.useSearchSessionId)();
    const [selectedProduct] = (0, $1i979.useSelectedProduct)();
    const sessionId = (0, $bQ6i3.getSessionIdFromLocalStorage)();
    const logException = (0, $2csHQ.useLogException)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [retryCount] = (0, $1i979.useRetryCount)();
    const quickFindOpen = (0, $5lH3O.useQuickFindOpen)();
    const quickFindQuery = (0, $5lH3O.useQuickFindQuery)();
    const currentQueryFilter = (0, $5lH3O.useCurrentQueryFilter)();
    const selectedQueryFilters = (0, $5lH3O.useSelectedQueryFilters)();
    const { setRequestedBackendExperiments: setRequestedBackendExperiments } = (0, $1i979.useSearchActions)();
    const { selectedFilters: selectedFilters, entities: entities, hasFiltersSelected: hasFiltersSelected } = (0, $hMXVq.useSelectedFilters)({
        experience: (0, $9pcjO.SearchExperience).QUICK_FIND
    });
    const useTypeEntitiesArgs = (0, $cozmU.useMemo)(()=>({
            thirdPartyConfigs: bootstrap.thirdPartyConfigs
        }), [
        bootstrap.thirdPartyConfigs
    ]);
    const typeFilterEntities = (0, $1i979.useTypeEntities)(useTypeEntitiesArgs);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $68JhS.useQuickFindAnalytics)();
    const debounceTimeout = (0, $09173d8eb8b93ff5$export$9e8b58cc1c8bacd2)();
    const { createNetworkCallbacks: createNetworkCallbacks } = (0, $e316eec52d5f461a$export$c24470e080406156)();
    /**
   * Unfortunately, we need to reintroduce this to avoid unnecessarily
   * fetching results for the same query and filters.
   *
   * In order to understand why this is needed, we must first understand that
   * the filters object is one gigantic object - whenver any kind of updates
   * happens to the filters, the object reference changes, as it should. This
   * includes when the loaded options in the filters change, e.g. when opening
   * the space filter or typing into the lookup query for the filter. These
   * user interactions cause the filters object to change, which in turn causes
   * the references of selectedFilters and entities to change, regardless of
   * whether or not search parameters (query, filters and entities) have changed.
   *
   * In the past, we were able to get away wih reacting on references changes
   * of selectedFilters and entities as it was impossible for filters to change
   * in Quick Find without actually changing the search parameters. Now that
   * there are UI elements in Quick Find (e.g. space filter), this is no longer
   * true.
   *
   * This is temporary until we move to search requests being triggered on user
   * interactions, rather than state updates, which will happen as part of Relay
   * migration.
   */ const selectedFiltersEquality = JSON.stringify(selectedFilters);
    const entitiesEquality = JSON.stringify(entities);
    const prevQueryRef = (0, $cozmU.useRef)();
    const prevQuickFindOpenRef = (0, $cozmU.useRef)(quickFindOpen);
    const onPreQuerySuccessWasFired = (0, $cozmU.useRef)(false);
    const prevSelectedFiltersEquality = (0, $cozmU.useRef)();
    const prevEntitiesEquality = (0, $cozmU.useRef)();
    const prevHasFiltersSelected = (0, $cozmU.useRef)(hasFiltersSelected);
    const fetchRecentActivitiesPromiseRef = (0, $cozmU.useRef)();
    const fetchRecommendedDocumentsPromiseRef = (0, $cozmU.useRef)();
    const preQueryPromiseRef = (0, $cozmU.useRef)();
    const postQueryPromiseRef = (0, $cozmU.useRef)();
    // rovo_qf_instant_search (quick_find_layer). No-exposure read (safe on every render);
    // the layer exposure is fired separately, once, on the Quick Find open transition below.
    // Confluence-only: serveQuickFindInstantSearch returns false for every non-Confluence
    // product, so the instant-search fetch behaviour never activates outside Confluence.
    const instantSearch = (0, $cJff5.serveQuickFindInstantSearch)(bootstrap.primaryProduct);
    // Monotonic guard: a response is applied only if its generation is >= the latest
    // applied, so out-of-order (older) responses are dropped. Inert under control
    // (generations never advance).
    const postQueryGenerationRef = (0, $cozmU.useRef)(0);
    const latestAppliedPostQueryGenerationRef = (0, $cozmU.useRef)(0);
    const prevSelectedProduct = (0, $cozmU.useRef)(selectedProduct);
    // Fire the instant-search layer exposure once, when Quick Find is opened — not on
    // every render that reads the (no-exposure) flag. Statsig dedupes per allocation, so
    // this counts a user as exposed at the moment they enter the QF experience.
    const hasFiredInstantSearchExposureRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (quickFindOpen && !hasFiredInstantSearchExposureRef.current) {
            hasFiredInstantSearchExposureRef.current = true;
            // Confluence-only: the exposure fn is a no-op for non-Confluence products, matching
            // serveQuickFindInstantSearch, so we never over-expose users who cannot see the UI.
            (0, $cJff5.triggerExposureForQuickFindInstantSearch)(bootstrap.primaryProduct);
        }
    }, [
        quickFindOpen,
        bootstrap.primaryProduct
    ]);
    const { setUpdateRecentQueries: setUpdateRecentQueries, setFetchEntitiesRequestId: setFetchEntitiesRequestId, setFetchEntitiesTraceId: setFetchEntitiesTraceId, setUpdateZeroQueries: setUpdateZeroQueries, setFetchSpacesRequestId: setFetchSpacesRequestId, setSearchErrors: setSearchErrors } = (0, $5lH3O.useQuickFindActions)();
    const [preQueryLoading, setPreQueryLoading] = (0, $cozmU.useState)(true);
    const [preQueryError, setPreQueryError] = (0, $cozmU.useState)();
    const [postQueryLoading, setPostQueryLoading] = (0, $cozmU.useState)(false);
    const [postQueryError, setPostQueryError] = (0, $cozmU.useState)();
    const [recentQueries, setRecentQueries] = (0, $cozmU.useState)([]);
    const [filteredRecentQueries, setFilteredRecentQueries] = (0, $cozmU.useState)([]);
    const [filteredRecentActivities, setFilteredRecentActivities] = (0, $cozmU.useState)($4796b598495fba64$var$EMPTY_RESULTS);
    const [filteredRecommendedDocuments, setFilteredRecommendedDocuments] = (0, $cozmU.useState)($4796b598495fba64$var$EMPTY_RESULTS);
    const [filteredZeroQueries, setFilteredZeroQueries] = (0, $cozmU.useState)([]);
    const [zeroQueries, setZeroQueries] = (0, $cozmU.useState)($4796b598495fba64$var$EMPTY_RESULTS);
    const [searchResults, setSearchResults] = (0, $cozmU.useState)($4796b598495fba64$var$EMPTY_RESULTS);
    const [peopleAndTeams, setPeopleAndTeams] = (0, $cozmU.useState)($4796b598495fba64$var$EMPTY_RESULTS);
    const [autocompleteSuggestions, setAutocompleteSuggestions] = (0, $cozmU.useState)(undefined);
    const isConfluence = bootstrap.primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Confluence;
    const isJira = bootstrap.primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira;
    const isJiraRecommendationsEligible = isJira && (0, $cJff5.isEligibleForQuickFindJiraRecommendationsExperiment)(bootstrap.productEdition);
    /**
   * Cohort read for `quick_find_jira_recommendations` WITHOUT exposure — it
   * only decides which slices of pre-query state are kept in sync. Exposure is
   * fired from `fetchRecommendedDocumentsCallback`, which runs for both
   * cohorts.
   */ const serveJiraRecommendations = isJiraRecommendationsEligible && (0, $cJff5.serveQuickFindJiraRecommendationsExperiment)();
    const serveZeroQuery = (bootstrap.primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Confluence || bootstrap.primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Atlas || bootstrap.primaryProduct === (0, $3Ydx7.PrimaryProductKeys).RovoExtension && (0, $iDrrr.fg)('quickfind-rovo-extension')) && (0, $iDrrr.fg)('kd_zero_query_in_qf_fg') || bootstrap.primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira;
    const workspaceId = bootstrap.primaryProduct && bootstrap.cloudId && bootstrap.analyticsAttributes?.activationId ? `ari:cloud:${bootstrap.primaryProduct}:${bootstrap.cloudId}:workspace/${bootstrap.analyticsAttributes.activationId}` : '';
    const useKdZeroQueryAtlHeader = (0, $iDrrr.fg)('kd_zero_query_agg_atl_attribution_header');
    const atlAttributionHeaderValue = (0, $cozmU.useMemo)(()=>(0, $AgYeH.createAtlAttributionHeaderValue)({
            atlWorkspaceId: workspaceId,
            tenantId: bootstrap.cloudId || '',
            product: bootstrap.primaryProduct || ''
        }), [
        bootstrap.cloudId,
        bootstrap.primaryProduct,
        workspaceId
    ]);
    /**
   * Callback to update recent queries for the current product and user
   */ const fetchRecentQueries = (0, $cozmU.useCallback)(()=>{
        if (!bootstrap.primaryProduct || !bootstrap.user?.id) return;
        const recentQueries = (0, $e196a48462814c1f$export$d6415f081f333b17)(bootstrap.primaryProduct, bootstrap.user.id);
        setRecentQueries(recentQueries);
    }, [
        bootstrap.primaryProduct,
        bootstrap.user?.id,
        setRecentQueries
    ]);
    /**
   * Store the callback to update recent queries in the store. This is used to refresh recent queries
   * when they are updated, e.g. when a search request is made or when a recent query is removed.
   */ (0, $cozmU.useEffect)(()=>{
        fetchRecentQueries();
        setUpdateRecentQueries(fetchRecentQueries);
    }, [
        fetchRecentQueries,
        setUpdateRecentQueries
    ]);
    /**
   * Callback to fetch recent activities
   */ const fetchRecentActivitiesCallback = (0, $cozmU.useCallback)(async (cursor)=>{
        if (!bootstrap.cloudId) return [];
        const headers = {
            'atl-attribution': atlAttributionHeaderValue
        };
        const taskId = crypto.randomUUID();
        const taskStartAt = performance.now();
        const baseVitalStatsParams = {
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_RECENT_ACTIVITIES_UX
        };
        fireAnalyticsEvent((0, $4jbt4.remapVitalStatsEventForQuickFind)((0, $hnyex.onTaskStart)(baseVitalStatsParams)));
        const networkCallbacks = createNetworkCallbacks({
            taskName: (0, $jTbFT.TASK_NAMES).QUICK_FIND_RECENT_ACTIVITIES_NETWORK,
            uxTaskId: taskId,
            isPreQuery: true
        });
        try {
            const recentActivities = await (0, $67534d8052f31965$export$ae65634d024c5427)(bootstrap.cloudId, bootstrap.aggAbsoluteUrl, cursor, bootstrap.thirdPartyConfigs, headers, bootstrap.primaryProduct, networkCallbacks, bootstrap.products);
            const resultsWithFailedHydration = recentActivities.filter((activity)=>activity.data?.node?.object?.data === null).map((activity)=>activity.id);
            // It doesn't distinguish between a network call and fetching from cache.
            // We can consolidate that once quick_find_autorefresh_experiment_v3 is shipped.
            fireAnalyticsEvent((0, $4jbt4.remapVitalStatsEventForQuickFind)((0, $hnyex.onTaskSuccess)({
                ...baseVitalStatsParams,
                moreContext: {
                    timeTaken: performance.now() - taskStartAt,
                    resultsLoaded: recentActivities.length,
                    resultsWithFailedHydration: resultsWithFailedHydration,
                    failedHydrationResultCount: resultsWithFailedHydration.length
                }
            })));
            return recentActivities;
        } catch (error) {
            fireAnalyticsEvent((0, $4jbt4.remapVitalStatsEventForQuickFind)((0, $hnyex.onTaskFail)({
                ...baseVitalStatsParams,
                moreContext: {
                    error: error instanceof Error ? error.message : String(error),
                    timeTaken: performance.now() - taskStartAt
                }
            })));
            throw error;
        }
    }, [
        bootstrap.cloudId,
        bootstrap.aggAbsoluteUrl,
        bootstrap.thirdPartyConfigs,
        bootstrap.products,
        searchSessionId,
        fireAnalyticsEvent,
        atlAttributionHeaderValue,
        bootstrap.primaryProduct,
        createNetworkCallbacks
    ]);
    const fetchRecommendedDocumentsCallback = (0, $cozmU.useCallback)(async ()=>{
        if (isJira) {
            if (!bootstrap.cloudId || !bootstrap.user?.id) return [];
            if (!isJiraRecommendationsEligible) return [];
            // Fire `quick_find_jira_recommendations` exposure here — the point at
            // which the Recommended section would be served to a Jira user who has
            // everything else in place. It has to happen before the cohort check so
            // the control cohort, which fetches nothing, is still exposed.
            if (!(0, $cJff5.serveQuickFindJiraRecommendationsExperiment)({
                fireExperimentExposure: true
            })) return [];
            return (0, $20df5d9011d84a8b$export$4858b654778bd2b4)(bootstrap.cloudId, bootstrap.user.id, bootstrap.aggAbsoluteUrl, {
                'atl-attribution': atlAttributionHeaderValue
            }, (0, $cJff5.QUICK_FIND_JIRA_RECS_FEATURE_SERVICE_MODEL));
        }
        if (bootstrap.cloudId && bootstrap.user?.id && isConfluence) {
            const headers = {
                'atl-attribution': atlAttributionHeaderValue
            };
            // Fire `quick_find_recs_1p_3p_sequence_model_exp_p2` exposure at the
            // exact point we're about to fetch recommended documents — i.e. for
            // users who would actually receive the treatment (or control). This
            // keeps the exposure population aligned with where the model is
            // delivered (Confluence primary product, authenticated user, with at
            // least one Google Drive or SharePoint connector).
            // `FeatureGates.getExperimentValue` dedupes repeated exposures for
            // the same user/experiment, so calling this on every fetch is safe.
            //
            // The default model is the control, preserving the shipped 3P
            // sequence model. The experiment test cohort routes eligible users to
            // the challenger 1P + 3P sequence model.
            const featureServiceModel = (0, $cJff5.getQuickFindRecs1P3PSequenceModelP2)(bootstrap.thirdPartyConfigs, {
                fireExperimentExposure: true
            });
            if (featureServiceModel) return (0, $20df5d9011d84a8b$export$4858b654778bd2b4)(bootstrap.cloudId, bootstrap.user.id, bootstrap.aggAbsoluteUrl, headers, featureServiceModel);
            return (0, $20df5d9011d84a8b$export$4858b654778bd2b4)(bootstrap.cloudId, bootstrap.user.id, bootstrap.aggAbsoluteUrl, headers);
        }
        return [];
    }, [
        bootstrap.cloudId,
        bootstrap.user?.id,
        bootstrap.aggAbsoluteUrl,
        bootstrap.thirdPartyConfigs,
        atlAttributionHeaderValue,
        isConfluence,
        isJira,
        isJiraRecommendationsEligible
    ]);
    /**
   * Callback to fetch zero queries
   */ const fetchZeroQueriesCallback = (0, $cozmU.useCallback)(()=>{
        if (!bootstrap.cloudId) return;
        const fetchFn = (0, $7DMz5.SAINFeatureControl).isZeroQuerySuggestionsV1Enabled(bootstrap.primaryProduct) ? (0, $CLiaR.fetchZeroQueriesV1) : (0, $CLiaR.fetchZeroQueries);
        (0, $e7e2968db5ab6556$export$45bde04e7d1842b0)(()=>fetchFn({
                cloudId: bootstrap.cloudId,
                product: (0, $9peWR.getUppercasePrimaryProductKey)(bootstrap.primaryProduct)
            }, useKdZeroQueryAtlHeader && atlAttributionHeaderValue ? {
                'atl-attribution': atlAttributionHeaderValue
            } : {})).then((result)=>{
            setZeroQueries(result ?? $4796b598495fba64$var$EMPTY_RESULTS);
        }).catch((error)=>{
            logException(error);
            setZeroQueries($4796b598495fba64$var$EMPTY_RESULTS);
        });
    }, [
        bootstrap.cloudId,
        logException,
        bootstrap.primaryProduct,
        atlAttributionHeaderValue,
        useKdZeroQueryAtlHeader
    ]);
    /**
   * Store the callback to update zero queries in the store. This is used to refresh zero queries
   * when they are updated, e.g. when a zero query is clicked.
   */ (0, $cozmU.useEffect)(()=>{
        if (serveZeroQuery) fetchZeroQueriesCallback();
        setUpdateZeroQueries(fetchZeroQueriesCallback);
    }, [
        fetchZeroQueriesCallback,
        setUpdateZeroQueries,
        serveZeroQuery
    ]);
    // Clears the highlighted pre-query collections (recent queries/activities/zero-queries/
    // recommendations) so a previous query's highlightedTitle markup does not linger on the
    // landing view. Shared by the filter-hide path and the instant-search full-clear path.
    const clearFilteredPreQueryResults = (0, $cozmU.useCallback)(()=>{
        setFilteredRecentQueries([]);
        setFilteredRecentActivities($4796b598495fba64$var$EMPTY_RESULTS);
        setFilteredZeroQueries([]);
        (isConfluence || serveJiraRecommendations) && setFilteredRecommendedDocuments($4796b598495fba64$var$EMPTY_RESULTS);
    }, [
        isConfluence,
        serveJiraRecommendations
    ]);
    /**
   * Callback to fetch pre-query results and updates the store with the results
   */ const fetchQuickFindPreQuery = (0, $cozmU.useCallback)((query, hideFilteredPreQueryResults, shouldRefetchPreQueryResults)=>{
        if (hideFilteredPreQueryResults) clearFilteredPreQueryResults();
        if (!fetchRecentActivitiesPromiseRef.current || !fetchRecommendedDocumentsPromiseRef.current) {
            setPreQueryError(undefined);
            setPreQueryLoading(true);
            onPreQueryStart?.();
        }
        if (!fetchRecentActivitiesPromiseRef.current) {
            const fetchRecentActivitiesPromise = (0, $e7e2968db5ab6556$export$45bde04e7d1842b0)(fetchRecentActivitiesCallback).catch((error)=>{
                logException(error);
                setPreQueryError(error);
                onPreQueryFailure?.(error);
                fetchRecentActivitiesPromiseRef.current = undefined;
                return $4796b598495fba64$var$EMPTY_RESULTS;
            });
            fetchRecentActivitiesPromiseRef.current = fetchRecentActivitiesPromise;
        }
        if (!fetchRecommendedDocumentsPromiseRef.current) {
            // Jira runs the callback for both cohorts so the control cohort is
            // exposed too; the callback itself returns no results for control.
            if (isConfluence || isJira) {
                const fetchRecommendedDocumentsPromise = (0, $e7e2968db5ab6556$export$45bde04e7d1842b0)(fetchRecommendedDocumentsCallback).catch((error)=>{
                    logException(error);
                    onPreQueryFailure?.(error);
                    fetchRecommendedDocumentsPromiseRef.current = undefined;
                    return $4796b598495fba64$var$EMPTY_RESULTS;
                });
                fetchRecommendedDocumentsPromiseRef.current = fetchRecommendedDocumentsPromise;
            } else fetchRecommendedDocumentsPromiseRef.current = Promise.resolve($4796b598495fba64$var$EMPTY_RESULTS);
        }
        if (shouldRefetchPreQueryResults) {
            // mutual exclusivity with postQuery tasks
            (0, $e7e2968db5ab6556$export$45bde04e7d1842b0)(()=>fetchRecentActivitiesCallback()).then((results)=>{
                setPreQueryError(undefined);
                fetchRecentActivitiesPromiseRef.current = Promise.all([
                    fetchRecentActivitiesPromiseRef.current,
                    Promise.resolve(results)
                ]).then(([existingResults, newResults])=>{
                    const deduplicatedResults = (0, $163a324f5597962c$export$f7b7f83c551ecf0b)(existingResults?.result ?? [], newResults?.result ?? []);
                    return {
                        result: deduplicatedResults,
                        duration: newResults.duration
                    };
                });
            }).catch((error)=>{
                logException(error);
                onPreQueryFailure?.(error);
            });
            if (isConfluence || serveJiraRecommendations) (0, $e7e2968db5ab6556$export$45bde04e7d1842b0)(()=>fetchRecommendedDocumentsCallback()).then((results)=>{
                fetchRecommendedDocumentsPromiseRef.current = Promise.all([
                    fetchRecommendedDocumentsPromiseRef.current,
                    Promise.resolve(results)
                ]).then(([existingResults, newResults])=>{
                    const result = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))([
                        ...newResults?.result ?? [],
                        ...existingResults?.result ?? []
                    ], (item)=>item.id);
                    return {
                        result: result,
                        duration: newResults.duration
                    };
                });
            }).catch((error)=>{
                logException(error);
                onPreQueryFailure?.(error);
            });
        }
        const preQueryPromise = new (0, $1sz28.CancellablePromise)(Promise.all([
            fetchRecentActivitiesPromiseRef.current,
            fetchRecommendedDocumentsPromiseRef.current
        ]));
        preQueryPromiseRef.current = preQueryPromise;
        preQueryPromise.promise().then(([recentActivities, recommendedDocuments])=>{
            if (!onPreQuerySuccessWasFired.current) {
                onPreQuerySuccess?.();
                onPreQuerySuccessWasFired.current = true;
            }
            setPreQueryLoading(false);
            if (hideFilteredPreQueryResults) return;
            const filteredRecentQueries = (0, $kPgkn.filterSearchResults)(recentQueries, query);
            setFilteredRecentQueries(filteredRecentQueries);
            if (bootstrap.primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira) {
                // We only filter zero queries for Jira as it's needed in post-query state
                const filteredZeroQueries = (0, $kPgkn.filterSearchResults)(zeroQueries.result, query);
                setFilteredZeroQueries(filteredZeroQueries);
            } else setFilteredZeroQueries(zeroQueries.result);
            const filteredRecentActivityResults = (0, $kPgkn.filterRecentActivities)(recentActivities.result, query);
            setFilteredRecentActivities({
                result: filteredRecentActivityResults,
                duration: recentActivities.duration
            });
            if (isConfluence || serveJiraRecommendations) {
                const filteredRecommendedDocuments = (0, $kPgkn.filterSearchResults)(recommendedDocuments.result, query);
                setFilteredRecommendedDocuments({
                    result: filteredRecommendedDocuments,
                    duration: recommendedDocuments.duration
                });
            }
        }).catch(()=>{
        // no-op on cancel
        }).finally(()=>{
            preQueryPromiseRef.current = undefined;
        });
    }, [
        clearFilteredPreQueryResults,
        fetchRecentActivitiesCallback,
        fetchRecommendedDocumentsCallback,
        logException,
        onPreQueryFailure,
        onPreQueryStart,
        onPreQuerySuccess,
        recentQueries,
        zeroQueries,
        isConfluence,
        isJira,
        serveJiraRecommendations,
        bootstrap.primaryProduct
    ]);
    /**
   * Callback to fetch confluence entities
   * @param uxTaskId - The UX task ID to associate with the network requests
   * @param isPreQuery - Whether this is a pre-query (warmup) request. Defaults to false.
   */ const fetchConfluenceEntitiesCallback = (0, $cozmU.useCallback)(async (uxTaskId, isPreQuery = false)=>{
        return Promise.all([
            (0, $8991f7e4656f199d$export$9605a5c4a68b2654)(bootstrap.aggAbsoluteUrl, useCaseId, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, entities, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
                taskName: (0, $jTbFT.TASK_NAMES).QUICK_FIND_CONFLUENCE_ENTITIES_NETWORK,
                uxTaskId: uxTaskId,
                isPreQuery: isPreQuery
            }), bootstrap.analyticsAttributes?.activationId),
            (0, $8991f7e4656f199d$export$919c2c6ec09a9e2)(bootstrap.aggAbsoluteUrl, useCaseId, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
                taskName: (0, $jTbFT.TASK_NAMES).QUICK_FIND_CONFLUENCE_SPACES_NETWORK,
                uxTaskId: uxTaskId,
                isPreQuery: isPreQuery
            }), bootstrap.analyticsAttributes?.activationId)
        ]).then((results)=>{
            const [entities, spaces] = results;
            return {
                results: [
                    ...entities.fetchResults,
                    ...spaces.fetchResults
                ],
                fetchEntitiesRequestId: entities.fetchEntitiesRequestId ?? undefined,
                fetchEntitiesTraceId: entities.fetchEntitiesTraceId ?? undefined,
                fetchSpacesRequestId: spaces.fetchSpacesRequestId ?? undefined,
                errors: [
                    ...entities.errors || [],
                    ...spaces.errors || []
                ],
                autocompleteSuggestions: entities.autocompleteSuggestions
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        useCaseId,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        entities,
        sessionId,
        createNetworkCallbacks
    ]);
    const fetchLoomEntitiesCallback = (0, $cozmU.useCallback)(async (uxTaskId, isPreQuery = false)=>{
        return (0, $8991f7e4656f199d$export$732c2c351dac9fec)(bootstrap.aggAbsoluteUrl, useCaseId, quickFindQuery, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
            taskName: (0, $jTbFT.TASK_NAMES).QUICK_FIND_LOOM_ENTITIES_NETWORK,
            uxTaskId: uxTaskId,
            isPreQuery: isPreQuery
        }), bootstrap.analyticsAttributes?.activationId, entities).then((results)=>{
            const { fetchResults: fetchResults, fetchEntitiesRequestId: fetchEntitiesRequestId, fetchEntitiesTraceId: fetchEntitiesTraceId, errors: errors } = results;
            return {
                results: fetchResults,
                fetchEntitiesRequestId: fetchEntitiesRequestId ?? undefined,
                fetchEntitiesTraceId: fetchEntitiesTraceId ?? undefined,
                fetchSpacesRequestId: undefined,
                errors: errors,
                autocompleteSuggestions: undefined
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        useCaseId,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        entities,
        setRequestedBackendExperiments,
        sessionId,
        createNetworkCallbacks
    ]);
    /**
   * Callback to fetch atlas entities
   */ const fetchAtlasEntitiesCallback = (0, $cozmU.useCallback)(async (uxTaskId, isPreQuery = false)=>{
        return (0, $8991f7e4656f199d$export$65df7212bf163b08)(bootstrap.aggAbsoluteUrl, useCaseId, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
            taskName: (0, $jTbFT.TASK_NAMES).QUICK_FIND_ATLAS_ENTITIES_NETWORK,
            uxTaskId: uxTaskId,
            isPreQuery: isPreQuery
        }), bootstrap.analyticsAttributes?.activationId).then((results)=>{
            const { fetchResults: fetchResults, fetchEntitiesRequestId: fetchEntitiesRequestId, fetchEntitiesTraceId: fetchEntitiesTraceId, errors: errors } = results;
            return {
                results: fetchResults,
                fetchEntitiesRequestId: fetchEntitiesRequestId ?? undefined,
                fetchEntitiesTraceId: fetchEntitiesTraceId ?? undefined,
                fetchSpacesRequestId: undefined,
                errors: errors,
                autocompleteSuggestions: undefined
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        useCaseId,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        sessionId,
        createNetworkCallbacks
    ]);
    const fetchAssetsEntitiesCallback = (0, $cozmU.useCallback)(async (uxTaskId, isPreQuery = false)=>{
        return (0, $8991f7e4656f199d$export$7e4a42258e6edc26)(bootstrap.aggAbsoluteUrl, useCaseId, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
            taskName: (0, $jTbFT.TASK_NAMES).QUICK_FIND_ASSETS_ENTITIES_NETWORK,
            uxTaskId: uxTaskId,
            isPreQuery: isPreQuery
        }), bootstrap.analyticsAttributes?.activationId).then((results)=>{
            const { fetchResults: fetchResults, fetchEntitiesRequestId: fetchEntitiesRequestId, fetchEntitiesTraceId: fetchEntitiesTraceId, errors: errors } = results;
            return {
                results: fetchResults,
                fetchEntitiesRequestId: fetchEntitiesRequestId ?? undefined,
                fetchEntitiesTraceId: fetchEntitiesTraceId ?? undefined,
                fetchSpacesRequestId: undefined,
                errors: errors,
                autocompleteSuggestions: undefined
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        useCaseId,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        sessionId,
        createNetworkCallbacks
    ]);
    const fetchMercuryEntitiesCallback = (0, $cozmU.useCallback)(async (uxTaskId, isPreQuery = false)=>{
        return (0, $8991f7e4656f199d$export$60162ce0dfbba9f8)(bootstrap.aggAbsoluteUrl, useCaseId, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
            taskName: (0, $jTbFT.TASK_NAMES).QUICK_FIND_MERCURY_ENTITIES_NETWORK,
            uxTaskId: uxTaskId,
            isPreQuery: isPreQuery
        }), bootstrap.analyticsAttributes?.activationId).then((results)=>{
            const { fetchResults: fetchResults, fetchEntitiesRequestId: fetchEntitiesRequestId, fetchEntitiesTraceId: fetchEntitiesTraceId, errors: errors } = results;
            return {
                results: [
                    ...fetchResults
                ],
                fetchEntitiesRequestId: fetchEntitiesRequestId ?? undefined,
                fetchEntitiesTraceId: fetchEntitiesTraceId ?? undefined,
                fetchSpacesRequestId: undefined,
                errors: errors,
                autocompleteSuggestions: undefined
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        useCaseId,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        sessionId,
        createNetworkCallbacks
    ]);
    const fetchTalentEntitiesCallback = (0, $cozmU.useCallback)(async (uxTaskId, isPreQuery = false)=>{
        return (0, $8991f7e4656f199d$export$39ffd40a0e828404)(bootstrap.aggAbsoluteUrl, useCaseId, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
            taskName: (0, $jTbFT.TASK_NAMES).QUICK_FIND_TALENT_ENTITIES_NETWORK,
            uxTaskId: uxTaskId,
            isPreQuery: isPreQuery
        }), bootstrap.analyticsAttributes?.activationId).then((results)=>{
            const { fetchResults: fetchResults, fetchEntitiesRequestId: fetchEntitiesRequestId, fetchEntitiesTraceId: fetchEntitiesTraceId, errors: errors } = results;
            return {
                results: [
                    ...fetchResults
                ],
                fetchEntitiesRequestId: fetchEntitiesRequestId ?? undefined,
                fetchEntitiesTraceId: fetchEntitiesTraceId ?? undefined,
                fetchSpacesRequestId: undefined,
                errors: errors,
                autocompleteSuggestions: undefined
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        useCaseId,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        sessionId,
        createNetworkCallbacks
    ]);
    const fetchJiraIssuesCallback = (0, $cozmU.useCallback)(async (uxTaskId, isPreQuery = false)=>{
        const issuesAndTypesCallbacks = createNetworkCallbacks({
            taskName: (0, $jTbFT.TASK_NAMES).QUICK_FIND_JIRA_ISSUES_AND_TYPES_NETWORK,
            uxTaskId: uxTaskId,
            isPreQuery: isPreQuery
        });
        const entitiesCallbacks = !hasFiltersSelected ? createNetworkCallbacks({
            taskName: (0, $jTbFT.TASK_NAMES).QUICK_FIND_JIRA_ENTITIES_NETWORK,
            uxTaskId: uxTaskId,
            isPreQuery: isPreQuery
        }) : undefined;
        return Promise.all([
            (0, $8991f7e4656f199d$export$eaafe46561fa4ee5)(bootstrap.aggAbsoluteUrl, useCaseId, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.isJiraIssueIndexed, bootstrap.thirdPartyConfigs, typeFilterEntities, sessionId, bootstrap.hasEditOrViewPlanPermission, issuesAndTypesCallbacks, bootstrap.analyticsAttributes?.activationId),
            !hasFiltersSelected ? (0, $8991f7e4656f199d$export$cfa5e5437133749b)(bootstrap.aggAbsoluteUrl, useCaseId, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.isJiraIssueIndexed, bootstrap.thirdPartyConfigs, sessionId, bootstrap.hasEditOrViewPlanPermission, entitiesCallbacks, bootstrap.analyticsAttributes?.activationId) : Promise.resolve({
                fetchResults: [],
                errors: [],
                autocompleteSuggestions: undefined
            })
        ]).then((results)=>{
            const [issuesResult, entitiesResult] = results;
            return {
                results: [
                    ...issuesResult.fetchResults,
                    ...entitiesResult.fetchResults
                ],
                fetchEntitiesRequestId: issuesResult.fetchEntitiesRequestId ?? undefined,
                fetchEntitiesTraceId: issuesResult.fetchEntitiesTraceId ?? undefined,
                fetchSpacesRequestId: undefined,
                errors: [
                    ...issuesResult.errors || [],
                    ...entitiesResult.errors || []
                ],
                autocompleteSuggestions: issuesResult.autocompleteSuggestions
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        useCaseId,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.isJiraIssueIndexed,
        bootstrap.thirdPartyConfigs,
        bootstrap.hasEditOrViewPlanPermission,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        typeFilterEntities,
        hasFiltersSelected,
        sessionId,
        createNetworkCallbacks
    ]);
    /**
   * Callback to fetch people and teams results
   */ const fetchPeopleAndTeamsCallback = (0, $cozmU.useCallback)(async ()=>{
        const { orgId: orgId, primaryProduct: primaryProduct, user: user, cloudId: cloudId } = bootstrap;
        if (orgId && primaryProduct && user?.id && cloudId) {
            // When a single query filter is selected and it is a contributor filter,
            // get people and teams results using the contributor name
            if (selectedQueryFilters.length === 1 && selectedQueryFilters[0].filterId === 'contributor') return (0, $c278ce1ceab1ece2$export$290039782fc4e47)(selectedQueryFilters[0].displayText, orgId, primaryProduct, user.id, cloudId);
            // Only fetch people and teams results if there are no filters selected
            if (!hasFiltersSelected) return (0, $c278ce1ceab1ece2$export$290039782fc4e47)(quickFindQuery, orgId, primaryProduct, user.id, cloudId);
        }
        return [];
    }, [
        bootstrap,
        quickFindQuery,
        selectedQueryFilters,
        hasFiltersSelected
    ]);
    /**
   * Function which fetches search results. This consists of a call to get
   * product search results and a call to get people and teams. Given that Promise.allSettled
   * is used, the slowest request will determine the time it takes to resolve.
   */ const fetchQuickFindPostQuery = (0, $cozmU.useCallback)(()=>{
        analyticsCounterAccumulator.incrementSearchResultsRequest();
        // Determine if this is a pre-query state based on whether there's actual text in the query
        // isPreQuery = true when there's no text query (even if filters are selected)
        // isPreQuery = false when there's actual text in the query
        const isPreQuery = !quickFindQuery || quickFindQuery.length === 0;
        // Generate and store uxTaskId so network events use the same taskId as UX events.
        // For pre-query: use preQueryTaskIdRef, for post-query: use postQueryTaskState.
        let uxTaskId;
        if (isPreQuery) {
            if (preQueryTaskIdRef && !preQueryTaskIdRef.current) preQueryTaskIdRef.current = crypto.randomUUID();
            uxTaskId = preQueryTaskIdRef?.current || crypto.randomUUID();
        } else {
            // Reset state if previous query completed
            if (postQueryTaskState?.current?.completed) postQueryTaskState.current = {
                id: null,
                started: false,
                completed: false,
                error: null
            };
            if (postQueryTaskState && !postQueryTaskState.current.id) postQueryTaskState.current.id = crypto.randomUUID();
            uxTaskId = postQueryTaskState?.current?.id || crypto.randomUUID();
        }
        let fetchProductEntities;
        if (bootstrap.primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Confluence || bootstrap.primaryProduct === (0, $3Ydx7.PrimaryProductKeys).RovoExtension && (0, $iDrrr.fg)('quickfind-rovo-extension')) fetchProductEntities = ()=>fetchConfluenceEntitiesCallback(uxTaskId, isPreQuery);
        else if (bootstrap.primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Atlas) fetchProductEntities = ()=>fetchAtlasEntitiesCallback(uxTaskId, isPreQuery);
        else if (bootstrap.primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Focus) fetchProductEntities = ()=>fetchMercuryEntitiesCallback(uxTaskId, isPreQuery);
        else if (bootstrap.primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Talent && (0, $iDrrr.fg)('talent_global_search')) fetchProductEntities = ()=>fetchTalentEntitiesCallback(uxTaskId, isPreQuery);
        else if (bootstrap.primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira) fetchProductEntities = ()=>fetchJiraIssuesCallback(uxTaskId, isPreQuery);
        else if (bootstrap.primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Assets && (0, $iDrrr.fg)('assets_rovo_search_all')) fetchProductEntities = ()=>fetchAssetsEntitiesCallback(uxTaskId, isPreQuery);
        else if (bootstrap.primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Loom && (0, $iDrrr.fg)('loom-rovo-search')) fetchProductEntities = ()=>fetchLoomEntitiesCallback(uxTaskId, isPreQuery);
        else fetchProductEntities = ()=>Promise.resolve({
                results: [],
                fetchEntitiesRequestId: undefined,
                fetchEntitiesTraceId: undefined,
                fetchSpacesRequestId: undefined,
                errors: [],
                autocompleteSuggestions: undefined
            });
        const fetchPeopleAndTeams = bootstrap.primaryProduct !== (0, $3Ydx7.PrimaryProductKeys).Jira && bootstrap.primaryProduct !== (0, $3Ydx7.PrimaryProductKeys).Focus && !(bootstrap.primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Loom && (0, $iDrrr.fg)('loom-rovo-search')) && !selectedProduct ? fetchPeopleAndTeamsCallback : ()=>Promise.resolve([]);
        const postQueryPromise = new (0, $1sz28.CancellablePromise)(Promise.allSettled([
            (0, $e7e2968db5ab6556$export$45bde04e7d1842b0)(fetchProductEntities),
            (0, $e7e2968db5ab6556$export$45bde04e7d1842b0)(fetchPeopleAndTeams)
        ]));
        postQueryPromiseRef.current = postQueryPromise;
        // Snapshot the generation at issue time so the resolver can drop stragglers.
        const requestGeneration = instantSearch ? postQueryGenerationRef.current : undefined;
        onPostQueryStart?.();
        postQueryPromise.promise().then((results)=>{
            // Drop this response if a newer request has already applied its results.
            if (!(0, $e42e7db018c399bf$export$553e14dec2459e25)(requestGeneration, latestAppliedPostQueryGenerationRef.current)) return results;
            if (requestGeneration !== undefined) latestAppliedPostQueryGenerationRef.current = requestGeneration;
            const productEntitiesStatus = results[0].status;
            const peopleAndTeamsStatus = results[1].status;
            // Post-query success is determined by product entities request, errors
            // from people and teams are ignored
            if (productEntitiesStatus === 'fulfilled') {
                const fetchedResults = results[0].value.result.results;
                analyticsCounterAccumulator.incrementSearchResultsRepaint();
                setSearchResults({
                    result: fetchedResults,
                    duration: results[0].value.duration
                });
                const errors = results[0].value.result.errors || [];
                setSearchErrors(errors);
                const hasThirdPartyResults = fetchedResults.some((result)=>result.id.startsWith('ari:cloud:graph::document') || result.id.startsWith('ari:cloud:graph::remote-link'));
                setFetchEntitiesRequestId(results[0].value.result.fetchEntitiesRequestId);
                setFetchEntitiesTraceId(results[0].value.result.fetchEntitiesTraceId);
                setFetchSpacesRequestId(results[0].value.result.fetchSpacesRequestId);
                setAutocompleteSuggestions(results[0].value.result.autocompleteSuggestions);
                const peopleAndTeams = peopleAndTeamsStatus === 'fulfilled' ? {
                    result: results[1].value.result,
                    duration: results[1].value.duration
                } : $4796b598495fba64$var$EMPTY_RESULTS;
                setPeopleAndTeams(peopleAndTeams);
                const allDurations = results.map((result)=>result.status === 'fulfilled' ? result.value.duration : 0);
                const maxDuration = Math.max(...allDurations);
                const resultCount = fetchedResults.length;
                onPostQuerySuccess?.(maxDuration, hasThirdPartyResults, resultCount);
            } else {
                const error = new Error('Failed to fetch post query results');
                setPostQueryError(error);
                onPostQueryFailure?.(error);
            }
            // Only clear loading when this is the latest issued request, so an older
            // completion can't hide the progress bar while a newer one is in flight.
            if ((0, $e42e7db018c399bf$export$1b92b497b817b358)(requestGeneration, postQueryGenerationRef.current)) setPostQueryLoading(false);
            return results;
        }).catch((error)=>{
            if (!(error instanceof (0, $1sz28.CancelError))) logException(error);
        });
    }, [
        bootstrap,
        fetchAssetsEntitiesCallback,
        fetchAtlasEntitiesCallback,
        fetchConfluenceEntitiesCallback,
        fetchJiraIssuesCallback,
        fetchLoomEntitiesCallback,
        fetchMercuryEntitiesCallback,
        fetchTalentEntitiesCallback,
        fetchPeopleAndTeamsCallback,
        onPostQueryFailure,
        onPostQueryStart,
        onPostQuerySuccess,
        selectedProduct,
        setFetchEntitiesRequestId,
        setFetchEntitiesTraceId,
        setFetchSpacesRequestId,
        setSearchErrors,
        logException,
        preQueryTaskIdRef,
        postQueryTaskState,
        quickFindQuery,
        instantSearch,
        analyticsCounterAccumulator
    ]);
    /**
   * Debounced fetch function for quick find results. This callback should never mutate
   * as the only dependency is the timeout value, hence it can be safely used in dependency array.
   */ const debouncedFetchQuickFindPostQuery = (0, $cRSxF.useDebouncedCallback)(fetchQuickFindPostQuery, debounceTimeout);
    (0, $cozmU.useEffect)(()=>{
        if (quickFindOpen) // If the user is allocated to this mutually exclusive experiment,
        // We fire an exposure by accessing a parameter within the layer.
        (0, $7zn5c.getMutuallyExclusiveUIExperiment)('quick_find_user_relevant_documents_experiment', (0, $3XLuW.STATSIG_QUICK_FIND_LAYER))?.get('cohort', undefined);
    }, [
        quickFindOpen
    ]);
    /**
   * Updates results when various Quick Find states change, this includes:
   * - when search is ready
   * - when the dialog opens
   * - when the query changes
   * - when recent queries or activities change
   * - when selected entities or filters change
   */ (0, $cozmU.useEffect)(()=>{
        if (!isSearchReady) return;
        if (preQueryPromiseRef.current) preQueryPromiseRef.current.cancel();
        const hideFilteredPreQueryResults = !!(hasFiltersSelected || selectedProduct);
        const shouldRefetchPreQueryResults = prevQuickFindOpenRef.current === false && quickFindOpen === true;
        fetchQuickFindPreQuery(quickFindQuery, hideFilteredPreQueryResults, shouldRefetchPreQueryResults);
        prevQuickFindOpenRef.current = quickFindOpen;
        /**
     * Skip fetching post-query results if:
     * - Quick Find is closed
     * - Post-query is disabled
     * - There is a current query filter selected
     */ if (!quickFindOpen || postQueryDisabled || currentQueryFilter) return;
        // Check if search parameters have changed, if not, skip fetching post-query results
        if (quickFindQuery === prevQueryRef.current && selectedFiltersEquality === prevSelectedFiltersEquality.current && entitiesEquality === prevEntitiesEquality.current && prevHasFiltersSelected.current === hasFiltersSelected && selectedProduct === prevSelectedProduct.current) return;
        prevQueryRef.current = quickFindQuery;
        prevSelectedFiltersEquality.current = selectedFiltersEquality;
        prevEntitiesEquality.current = entitiesEquality;
        prevHasFiltersSelected.current = hasFiltersSelected;
        prevSelectedProduct.current = selectedProduct;
        if (!instantSearch) {
            // Control: reset results (blank to skeletons) on query change.
            setSearchResults($4796b598495fba64$var$EMPTY_RESULTS);
            setPeopleAndTeams($4796b598495fba64$var$EMPTY_RESULTS);
        }
        // Treatment keeps the previous results in state for stale-while-revalidate.
        setPostQueryLoading(true);
        setPostQueryError(undefined);
        if (!instantSearch && postQueryPromiseRef.current) {
            // Control cancels in-flight on query change; treatment lets it resolve and
            // relies on the generation guard to decide which response paints.
            postQueryPromiseRef.current.cancel();
            onPostQueryCancel?.();
            postQueryPromiseRef.current = undefined;
        }
        const hasProductSelected = Boolean(selectedProduct) ?? false;
        const hasQuery = (0, $e42e7db018c399bf$export$6e4070116bdfa183)({
            query: quickFindQuery,
            hasFiltersSelected: hasFiltersSelected || hasProductSelected
        });
        if (hasQuery) {
            // Bump the generation on the keystroke (before the debounce) so a straggler
            // resolving during the debounce window is treated as stale.
            if (instantSearch) ++postQueryGenerationRef.current;
            setPostQueryLoading(true);
            debouncedFetchQuickFindPostQuery();
        } else if (instantSearch) {
            // Full clear: return to recents, so drop the kept results. Raising the applied
            // watermark to this new generation makes the guard reject any in-flight
            // straggler that would otherwise repaint stale results over the cleared state.
            ++postQueryGenerationRef.current;
            latestAppliedPostQueryGenerationRef.current = postQueryGenerationRef.current;
            setPostQueryLoading(false);
            setSearchResults($4796b598495fba64$var$EMPTY_RESULTS);
            setPeopleAndTeams($4796b598495fba64$var$EMPTY_RESULTS);
            // Also drop the previous query's highlighted pre-query collections. Unlike the
            // control path they are not refetched-and-replaced synchronously on clear, so
            // without this a highlighted recent/recommended row lingers on the landing view.
            // The subsequent pre-query fetch repopulates them unhighlighted.
            clearFilteredPreQueryResults();
        }
    }, [
        fetchQuickFindPreQuery,
        debouncedFetchQuickFindPostQuery,
        quickFindQuery,
        retryCount,
        isSearchReady,
        quickFindOpen,
        selectedFilters,
        entities,
        onPostQueryCancel,
        postQueryDisabled,
        currentQueryFilter,
        selectedProduct,
        hasFiltersSelected,
        selectedFiltersEquality,
        entitiesEquality,
        clearFilteredPreQueryResults,
        instantSearch,
        analyticsCounterAccumulator
    ]);
    return (0, $cozmU.useMemo)(()=>(0, $e42e7db018c399bf$export$35ead133d529e85e)({
            // Using refs here to ensure new results state is returned only
            // when the various result variables in the dependency array change
            query: prevQueryRef.current,
            hasFiltersSelected: prevHasFiltersSelected.current,
            quickFindOpen: prevQuickFindOpenRef.current,
            preQueryError: preQueryError,
            preQueryLoading: preQueryLoading,
            postQueryError: postQueryError,
            postQueryLoading: postQueryLoading,
            filteredRecentQueries: filteredRecentQueries,
            filteredRecentActivities: filteredRecentActivities,
            filteredRecommendedDocuments: filteredRecommendedDocuments,
            filteredZeroQueries: filteredZeroQueries,
            searchResults: searchResults,
            peopleAndTeams: peopleAndTeams,
            postQueryDisabled: postQueryDisabled,
            primaryProduct: bootstrap.primaryProduct,
            hasProductSelected: !!prevSelectedProduct.current,
            autocompleteSuggestions: autocompleteSuggestions,
            instantSearch: instantSearch
        }), [
        filteredRecentActivities,
        filteredRecommendedDocuments,
        filteredRecentQueries,
        filteredZeroQueries,
        peopleAndTeams,
        postQueryDisabled,
        postQueryError,
        postQueryLoading,
        preQueryError,
        preQueryLoading,
        searchResults,
        bootstrap.primaryProduct,
        autocompleteSuggestions,
        instantSearch
    ]);
};
const $4796b598495fba64$export$4f32340729fb620b = (analyticsCounterAccumulator)=>{
    const previousStateRef = (0, $cozmU.useRef)();
    const previousContentRef = (0, $cozmU.useRef)(undefined);
    const content = (0, $5lH3O.useContent)();
    const quickFindOpen = (0, $5lH3O.useQuickFindOpen)();
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $32Eau.useBootstrap)();
    const searchErrors = (0, $5lH3O.useSearchErrors)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $68JhS.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $68JhS.useQuickFindAttributes)();
    const { enablePerceivedLatencyTracking: enablePerceivedLatencyTracking, observeResults: observeResults, takeResultsAttributes: takeResultsAttributes, resetResultsMeasurement: resetResultsMeasurement } = (0, $1KAXF.useQuickFindPerceivedLatency)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [requestedBackendExperiments] = (0, $1i979.useRequestedBackendExperiments)();
    const intl = (0, $kSwu1.useIntl)();
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const { chatIntentDetectionEnabled: chatIntentDetectionEnabled } = (0, $iHg8v.serveChatConvergenceExperiment)(primaryProduct);
    const intentDetectionExperiment = (0, $535ZC.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        // Exposure is fired when a user calls the intent detection API
        locale: intl.locale
    });
    const intentRouterEnabled = intentDetectionExperiment?.cohort === 'test';
    const intentDetectionCohort = intentDetectionExperiment?.cohort;
    const productsWithTimeoutsFromErrors = (0, $cozmU.useMemo)(()=>{
        const errors = searchErrors || [];
        return errors.filter((error)=>error.extensions?.statusCode === 408).map((error)=>error.extensions?.integration ?? error.extensions?.product).flatMap((s)=>s && (0, $dvVWp.isProductKey)(s) ? [
                s
            ] : []);
    }, [
        searchErrors
    ]);
    const are3PSmartLinksInResults = (0, $cozmU.useMemo)(()=>{
        if (!content) return false;
        const checkIsSmartLink = (result)=>{
            if (!result.data?.node?.object?.id || !result.data?.node?.event?.eventType) return false;
            const mappedResult = (0, $6ZL8f.mapActivityToSearchResult)(result.data, '', // query not needed to obtain the `product` value
            '', // searchSessionId not needed to obtain the `product` value
            thirdPartyConfigs);
            return (0, $1mE5s.isResultSmartLink)({
                resultAri: result.data.node.object.id,
                thirdPartyConfigs: thirdPartyConfigs,
                productKey: mappedResult?.analyticsMetadata.product,
                eventType: result.data.node.event.eventType,
                connectorType: result.data.connectorType
            });
        };
        return ('recentActivities' in content ? content.recentActivities : []).some(checkIsSmartLink) || ('searchResults' in content ? content.searchResults : []).some(checkIsSmartLink);
    }, [
        content,
        thirdPartyConfigs
    ]);
    (0, $cozmU.useEffect)(()=>{
        const previousState = previousStateRef.current;
        previousStateRef.current = content?.state;
        const previousContent = enablePerceivedLatencyTracking ? previousContentRef.current : undefined;
        if (enablePerceivedLatencyTracking) previousContentRef.current = content;
        // Don't fire analytics event if the dialog is closed
        if (!quickFindOpen || !content) return;
        // Instant results and recents can update while the state remains loading.
        // Observe them before the event's state-change guard, without emitting another event.
        let resultTypeCounts;
        const readResultTypeCounts = ()=>{
            if (resultTypeCounts === undefined) resultTypeCounts = (0, $9gI1G.getResultTypeCounts)();
            return resultTypeCounts;
        };
        if (enablePerceivedLatencyTracking) {
            const kind = (0, $74219d4176b56099$export$fb053fb6bdc90071)(content, previousContent, readResultTypeCounts);
            if (kind) observeResults(kind);
        }
        // Don't fire analytics event if the state hasn't changed
        if (content.state === previousState) return;
        // Ignore states that do not have search results
        if (content.state === (0, $cI6da.State).PREQUERY_LOADING || content.state === (0, $cI6da.State).PREQUERY_ERROR || content.state === (0, $cI6da.State).POSTQUERY_ERROR) {
            if (content.state === (0, $cI6da.State).PREQUERY_ERROR) fireAnalyticsEvent((0, $939b646033906433$export$932440ee05101c0d)({
                success: false,
                attributes: commonAttributes,
                resultsType: 'preQuerySearchResults'
            }));
            if (content.state === (0, $cI6da.State).POSTQUERY_ERROR) {
                fireAnalyticsEvent((0, $939b646033906433$export$932440ee05101c0d)({
                    success: false,
                    attributes: commonAttributes,
                    resultsType: 'postQuerySearchResults'
                }));
                if (enablePerceivedLatencyTracking) resetResultsMeasurement();
            }
            return;
        }
        /**
     * Do not fire analytics event when the dialog is opened and post-query
     * results are already returned. This is to have parity with the old
     * quick find component.
     *
     * Whilst this may not be correct, this is here to ensure changes in metrics
     * such as QSR and CTR are intentional.
     *
     * TODO: Discuss with DS/DE if this correct behaviour
     */ if (content.state === (0, $cI6da.State).POSTQUERY_RESULTS && previousState === undefined) return;
        const resultsTypeMap = {
            PREQUERY_RESULTS: 'preQuerySearchResults',
            PREQUERY_NO_RESULTS: 'preQuerySearchResults',
            POSTQUERY_LOADING: 'cachedResults',
            POSTQUERY_RESULTS: 'postQuerySearchResults',
            POSTQUERY_NO_RESULTS: 'postQuerySearchResults'
        };
        const resultsType = resultsTypeMap[content.state];
        const { sectionCount: sectionCount, resultCount: resultCount } = (0, $9gI1G.getSectionsAndResultsCount)({
            includeHeadinglessResults: chatIntentDetectionEnabled
        });
        const shownResultTypeCounts = enablePerceivedLatencyTracking ? readResultTypeCounts() : (0, $9gI1G.getResultTypeCounts)();
        const productsInResults = (0, $9gI1G.getProductsInResults)();
        const isBulkConnectBannerShown = (0, $9gI1G.getIsBulkConnectBannerShown)();
        const resultsShown = (0, $9gI1G.getResultsShown)();
        const noResultsFetched = content.state === (0, $cI6da.State).PREQUERY_NO_RESULTS || content.state === (0, $cI6da.State).POSTQUERY_NO_RESULTS || resultCount === 0;
        // Don't fire cachedResults event if there are no results
        if (noResultsFetched && resultsType === 'cachedResults') return;
        const are3pResultsShown = productsInResults.some((0, $5RzlA.is3pProductKeyForAnalytics));
        const are3PInRecommendations = (0, $9gI1G.getProductsInRecommendations)().some((0, $5RzlA.is3pProductKeyForAnalytics));
        const authorized3PProducts = Object.keys(thirdPartyConfigs || {}).filter((product)=>!thirdPartyConfigs?.[product]?.userNeedsOAuth);
        // Each searchResultsShown event closes one measurement window. Full backspace
        // therefore snapshots and clears the previous query counter window.
        const analyticsCounters = analyticsCounterAccumulator.snapshotAndReset();
        fireAnalyticsEvent((0, $37c63952ee27f671$export$2d1da932f40a427e)({
            attributes: {
                ...commonAttributes,
                ...enablePerceivedLatencyTracking && resultsType === 'postQuerySearchResults' ? takeResultsAttributes() : {},
                sectionCount: sectionCount,
                resultCount: resultCount,
                resultTypeCounts: shownResultTypeCounts,
                productsInResults: productsInResults,
                are3pResultsShown: are3pResultsShown,
                // Use `searchAndResult` to keep the schema consistent with FPS, but we don't need other attributes yet.
                searchAndResult: {
                    authorized3PProducts: authorized3PProducts
                },
                resultsShown: resultsShown,
                ...resultsType === 'postQuerySearchResults' ? analyticsCounters : {},
                isBulkConnectBannerShown: isBulkConnectBannerShown,
                are3PSmartLinksInResults: are3PSmartLinksInResults,
                noResultsFetched: noResultsFetched,
                ...(0, $68JhS.getCommonQueryAttributes)(content.query),
                ...requestedBackendExperiments,
                ...resultsType === 'postQuerySearchResults' ? {
                    productsWithTimeout: productsWithTimeoutsFromErrors || []
                } : {},
                are3PInRecommendations: are3PInRecommendations,
                intentDetectionTriggered: (0, $535ZC.isIntentDetectionTriggeredForExperiment)(primaryProduct, intl.locale),
                queryClassification: (0, $krr0S.INTENT_DETECTION).value()?.mode,
                modelId: (0, $krr0S.INTENT_DETECTION).value()?.modelId,
                cohort: intentDetectionCohort,
                patternType: (0, $krr0S.INTENT_DETECTION).value()?.patternType
            },
            nonPrivacySafeAttributes: {
                query: content.query
            },
            resultsType: resultsType
        }));
        fireAnalyticsEvent((0, $939b646033906433$export$932440ee05101c0d)({
            success: true,
            attributes: commonAttributes,
            resultsType: resultsType
        }));
    }, [
        chatIntentDetectionEnabled,
        commonAttributes,
        content,
        resetResultsMeasurement,
        fireAnalyticsEvent,
        quickFindOpen,
        takeResultsAttributes,
        observeResults,
        enablePerceivedLatencyTracking,
        requestedBackendExperiments,
        are3PSmartLinksInResults,
        thirdPartyConfigs,
        productsWithTimeoutsFromErrors,
        intentRouterEnabled,
        primaryProduct,
        intl.locale,
        intentDetectionCohort,
        analyticsCounterAccumulator
    ]);
};
const $4796b598495fba64$export$6a204b1a019f0cc8 = ()=>{
    const previousStateRef = (0, $cozmU.useRef)();
    const content = (0, $5lH3O.useContent)();
    const quickFindOpen = (0, $5lH3O.useQuickFindOpen)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $68JhS.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $68JhS.useQuickFindAttributes)();
    const intl = (0, $kSwu1.useIntl)();
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const intentRouterEnabled = (0, $535ZC.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        // Exposure is fired when a user calls the intent detection API
        locale: intl.locale
    })?.cohort === 'test';
    (0, $cozmU.useEffect)(()=>{
        // Store a copy of previous state before updating the ref
        const previousState = previousStateRef.current;
        previousStateRef.current = content ? content.state : undefined;
        // Don't fire analytics event if the dialog is closed
        if (!quickFindOpen || !content) return;
        // Don't fire analytics event if the state hasn't changed
        if (content.state === previousState) return;
        // Fire a single consolidated event with all suggested queries when Quick Find opens.
        // This complements (but does not replace) the existing per-item suggestedQuery shown events.
        // Read actually-rendered zero query nodes from the DOM (mirrors getResultsShown approach),
        // so the event only reflects what was visible to the user.
        const shownZeroQueries = (0, $9gI1G.getShownZeroQueries)();
        if (shownZeroQueries.length > 0) fireAnalyticsEvent((0, $2d57856ab6367a0e$export$9698f7c8e7c9a2f7)({
            actionSubjectId: (0, $2PBjm.getActionSubjectId)(content.state),
            attributes: {
                // All existing commonAttributes — same as what each per-item suggestedQuery shown event sends
                ...commonAttributes,
                // Intent router attributes (same gate as existing per-item event)
                ...intentRouterEnabled ? {
                    queryClassification: (0, $krr0S.INTENT_DETECTION).value()?.mode,
                    modelId: (0, $krr0S.INTENT_DETECTION).value()?.modelId,
                    patternType: (0, $krr0S.INTENT_DETECTION).value()?.patternType
                } : {},
                // Per-item fields consolidated into one array, derived from DOM
                suggestedQueriesShown: shownZeroQueries.map(({ zeroQueryType: zeroQueryType, zeroQueryPosition: zeroQueryPosition })=>({
                        zeroQueryType: zeroQueryType,
                        zeroQueryPosition: zeroQueryPosition,
                        zeroQueryVersion: (0, $c9Gfx.getZeroQueryVersion)(zeroQueryType),
                        is3PZeroQuery: (0, $c9Gfx.is3PZeroQuery)(zeroQueryType)
                    }))
            },
            nonPrivacySafeAttributes: // Same nonPrivacySafeAttributes as the existing per-item event
            nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        nonPrivacySafeAttributes,
        content,
        fireAnalyticsEvent,
        quickFindOpen,
        intentRouterEnabled
    ]);
};
const $4796b598495fba64$export$da9d0159e5272189 = /*#__PURE__*/ (0, $cozmU.memo)((options)=>{
    const callbacks = (0, $09173d8eb8b93ff5$export$483ef80309da5ade)();
    const analyticsCounterAccumulator = (0, $cozmU.useMemo)($4796b598495fba64$export$6312fbfa29be092d, []);
    const useQuickFindResultsArgs = (0, $cozmU.useMemo)(()=>({
            ...options,
            ...callbacks,
            analyticsCounterAccumulator: analyticsCounterAccumulator
        }), [
        options,
        callbacks,
        analyticsCounterAccumulator
    ]);
    const content = $4796b598495fba64$export$ab15aae48c593ecc(useQuickFindResultsArgs);
    const { setContent: setContent } = (0, $5lH3O.useQuickFindActions)();
    (0, $cozmU.useEffect)(()=>{
        setContent(content);
    }, [
        content,
        setContent
    ]);
    $4796b598495fba64$export$4f32340729fb620b(analyticsCounterAccumulator);
    $4796b598495fba64$export$6a204b1a019f0cc8();
    return null;
});



var $gj3Ne = parcelRequire("gj3Ne");











var $50CxG = parcelRequire("50CxG");










const $ac6e3cb70b2fb8b6$var$RovoJourneyIdUrlSync = ({ incomingRovoJourneyId: incomingRovoJourneyId })=>{
    const { setRovoJourneyId: setRovoJourneyId } = (0, $5lH3O.useQuickFindActions)();
    const previousIncomingRovoJourneyId = (0, $cozmU.useRef)(incomingRovoJourneyId);
    (0, $cozmU.useEffect)(()=>{
        if (incomingRovoJourneyId && incomingRovoJourneyId !== previousIncomingRovoJourneyId.current) setRovoJourneyId(incomingRovoJourneyId);
        previousIncomingRovoJourneyId.current = incomingRovoJourneyId;
    }, [
        incomingRovoJourneyId,
        setRovoJourneyId
    ]);
    return null;
};
const $ac6e3cb70b2fb8b6$export$5f60ff1bbe7f1a37 = ({ children: children, initialRovoJourneyId: initialRovoJourneyId, shouldInitializeRovoJourneyId: shouldInitializeRovoJourneyId = false })=>{
    const scopedInitialRovoJourneyId = shouldInitializeRovoJourneyId ? initialRovoJourneyId : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5lH3O.QuickFindStoreContainer), {
        initialRovoJourneyId: scopedInitialRovoJourneyId,
        shouldInitializeRovoJourneyId: shouldInitializeRovoJourneyId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ac6e3cb70b2fb8b6$var$RovoJourneyIdUrlSync, {
        incomingRovoJourneyId: scopedInitialRovoJourneyId
    }), children);
};



var $c7Prm = parcelRequire("c7Prm");





var $ir4XI = parcelRequire("ir4XI");










var $iUHik = parcelRequire("iUHik");

// Mirrors `searchDialogStyles` in `./index` by hand. Importing it would pull the whole dialog back
// into the eager chunk, and the dialog is what failed to load here in the first place.
const $a24c8fcf96ead36a$var$unavailableStyles = (0, $buxP3.xcss)({
    display: 'flex',
    position: 'absolute',
    flexDirection: 'column',
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    width: '100%',
    borderRadius: "var(--ds-radius-small, 4px)",
    marginTop: 'space.100'
});
const $a24c8fcf96ead36a$export$374f053b11c7271d = ()=>{
    const onRetry = (0, $cozmU.useCallback)(()=>{
        window.location.reload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $a24c8fcf96ead36a$var$unavailableStyles,
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iUHik.ErrorScreen), {
        onRetry: onRetry
    }));
};



const $4f63a9f3639108f7$var$loadSearchDialog = ()=>(parcelRequire("d5sGV"));
const $4f63a9f3639108f7$export$6152aa411dc131d1 = ()=>{
    // Swallowed: nothing is rendered yet, so there is nothing to degrade. A failure the user can
    // notice is surfaced by the error boundary when the dialog is opened.
    $4f63a9f3639108f7$var$loadSearchDialog().catch(()=>{});
};
// `Object.assign` because `LazyExoticComponent` does not declare `displayName`, so assigning it
// directly does not typecheck. Keeps the component stack readable in the logged exception.
const $4f63a9f3639108f7$var$SearchDialogLazy = Object.assign(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>$4f63a9f3639108f7$var$loadSearchDialog().then(({ SearchDialog: SearchDialog })=>({
            default: SearchDialog
        }))), {
    displayName: 'lazy(SearchDialog)'
});
const $4f63a9f3639108f7$export$8fecb6bd50f97bd1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ir4XI.ErrorBoundary), {
        section: "QuickFindSearchDialogAsync",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a24c8fcf96ead36a$export$374f053b11c7271d), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4f63a9f3639108f7$var$SearchDialogLazy, props)));








const $476cb45229544790$export$9310e79b116dbbca = ()=>{
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            (0, $krr0S.INTENT_DETECTION).dispose();
        };
    }, []);
};












function $3e179a8629268861$export$8454b21541ff9c9b(isInteracted) {
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    // Latched on the first render where the product is known, and nothing preloads before then.
    // `primaryProduct` starts undefined, so reading it eagerly would latch "not Confluence" and
    // preload on mount for Confluence too, defeating the deferral.
    const shouldDeferRef = (0, $cozmU.useRef)(undefined);
    if (shouldDeferRef.current === undefined && primaryProduct !== undefined) shouldDeferRef.current = primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Confluence;
    const shouldDefer = shouldDeferRef.current;
    (0, $cozmU.useEffect)(()=>{
        if (shouldDefer === undefined) return;
        if (!shouldDefer || isInteracted) (0, $4f63a9f3639108f7$export$6152aa411dc131d1)();
    }, [
        shouldDefer,
        isInteracted
    ]);
}
























var $fcz8B = parcelRequire("fcz8B");




const $164161c0c1096563$export$494a88615cfa0dd3 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yu7A.ACTION_SUBJECT_PREFIX}QuickFindClearButton`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });





const $4ea6677991c56e26$export$d56b70a75f0c16 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yu7A.ACTION_SUBJECT_PREFIX}QuickFindConnectAppsPill`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $d8e5e54882b7e9d4$export$f86bcd23f07f7d76 = ({ attributes: attributes })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: `ghostText`,
        actionSubjectId: 'customGhostText',
        attributes: attributes
    });


const $9620bf983ba41b7c$export$5633d029795394f8 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'searchDialogInput',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $eb3513c810be3873$export$db28d8e16fb16e80 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'entered',
        actionSubject: 'text',
        actionSubjectId: 'searchDialogTextField',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

















const $789ad13e648baaf8$var$ON_TEXT_ENTERED_ANALYTICS_DEBOUNCE_TIME = 300;
const $789ad13e648baaf8$export$fe11394d33dcb3dd = ()=>{
    const quickFindOpen = (0, $5lH3O.useQuickFindOpen)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $68JhS.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $68JhS.useQuickFindAttributes)();
    const fireOnTextEnteredAnalyticsCallback = (0, $cozmU.useCallback)(()=>{
        if (!quickFindOpen) return;
        fireAnalyticsEvent((0, $eb3513c810be3873$export$db28d8e16fb16e80)({
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        quickFindOpen
    ]);
    const debouncedOnTextEnteredAnalyticsCallback = (0, $cRSxF.useDebouncedCallback)(fireOnTextEnteredAnalyticsCallback, $789ad13e648baaf8$var$ON_TEXT_ENTERED_ANALYTICS_DEBOUNCE_TIME);
    (0, $cozmU.useEffect)(()=>()=>debouncedOnTextEnteredAnalyticsCallback.cancel(), [
        debouncedOnTextEnteredAnalyticsCallback
    ]);
    return debouncedOnTextEnteredAnalyticsCallback;
};
const $789ad13e648baaf8$export$39ddbf45077610d4 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $68JhS.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $68JhS.useQuickFindAttributes)();
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const content = (0, $5lH3O.useContent)();
    const quickFindOpen = (0, $5lH3O.useQuickFindOpen)();
    const openBeforePointerDown = (0, $cozmU.useRef)(undefined);
    // Capture before focus can open a host-owned dropdown.
    const onPointerDown = (0, $cozmU.useCallback)(()=>{
        openBeforePointerDown.current = quickFindOpen;
    }, [
        quickFindOpen
    ]);
    const fireOnSearchDialogInputClicked = (0, $cozmU.useCallback)(()=>{
        const wasOpen = openBeforePointerDown.current ?? quickFindOpen;
        openBeforePointerDown.current = undefined;
        if (!wasOpen) fireAnalyticsEvent((0, $9620bf983ba41b7c$export$5633d029795394f8)({
            attributes: {
                ...commonAttributes,
                productKey: primaryProduct
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        quickFindOpen,
        fireAnalyticsEvent,
        commonAttributes,
        primaryProduct,
        nonPrivacySafeAttributes
    ]);
    const debouncedOnTextEnteredAnalyticsCallback = $789ad13e648baaf8$export$fe11394d33dcb3dd();
    const fireOnQuickFindClearButtonClicked = (0, $cozmU.useCallback)(()=>{
        debouncedOnTextEnteredAnalyticsCallback.cancel();
        fireAnalyticsEvent((0, $164161c0c1096563$export$494a88615cfa0dd3)({
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        debouncedOnTextEnteredAnalyticsCallback,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes
    ]);
    const fireOnQuickFindConnectAppsPillClicked = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $4ea6677991c56e26$export$d56b70a75f0c16)({
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes
    ]);
    const fireOnGhostTextShownEvent = (0, $cozmU.useCallback)((attributes)=>{
        fireAnalyticsEvent((0, $d8e5e54882b7e9d4$export$f86bcd23f07f7d76)({
            attributes: attributes
        }));
    }, [
        fireAnalyticsEvent
    ]);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const intentDetectionExperiment = (0, $535ZC.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        locale: locale,
        fireLayerExposure: false
    });
    const intentDetectionCohort = intentDetectionExperiment?.cohort;
    const trackSearchSubmit = (0, $cozmU.useCallback)(({ query: query, trigger: trigger, returnModified: returnModified })=>{
        if (!primaryProduct) return;
        fireAnalyticsEvent((0, $fcz8B.onAdvancedSearchLinkSelected)({
            actionSubjectId: (0, $fcz8B.getAdvancedSearchActionSubjectId)(primaryProduct),
            query: query,
            intent: (0, $krr0S.INTENT_DETECTION).value(),
            isLoading: content?.state === (0, $cI6da.State).PREQUERY_LOADING || content?.state === (0, $cI6da.State).POSTQUERY_LOADING,
            cohort: intentDetectionCohort,
            attributes: {
                ...commonAttributes,
                trigger: trigger,
                returnModified: returnModified,
                newTab: false
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        nonPrivacySafeAttributes,
        intentDetectionCohort,
        commonAttributes,
        content?.state,
        fireAnalyticsEvent,
        primaryProduct
    ]);
    return (0, $cozmU.useMemo)(()=>({
            onPointerDown: onPointerDown,
            fireOnSearchDialogInputClicked: fireOnSearchDialogInputClicked,
            debouncedOnTextEnteredAnalyticsCallback: debouncedOnTextEnteredAnalyticsCallback,
            trackSearchSubmit: trackSearchSubmit,
            fireOnQuickFindClearButtonClicked: fireOnQuickFindClearButtonClicked,
            fireOnQuickFindConnectAppsPillClicked: fireOnQuickFindConnectAppsPillClicked,
            fireOnGhostTextShownEvent: fireOnGhostTextShownEvent
        }), [
        onPointerDown,
        fireOnSearchDialogInputClicked,
        debouncedOnTextEnteredAnalyticsCallback,
        trackSearchSubmit,
        fireOnQuickFindClearButtonClicked,
        fireOnQuickFindConnectAppsPillClicked,
        fireOnGhostTextShownEvent
    ]);
};


const $2978b921841aca22$export$92f7713045c6fd6a = (ref)=>{
    const analytics = (0, $789ad13e648baaf8$export$39ddbf45077610d4)();
    (0, $cozmU.useImperativeHandle)(ref, ()=>analytics, [
        analytics
    ]);
};






var $5Sv3D = parcelRequire("5Sv3D");




/**
 * Given a query and a list of filter keywords, determine if the user is using
 * a query filter. If so, return the filter keyword they are using.
 * @param query
 * @param filterKeywords
 * @returns
 */ const $1094801a8b9aa725$export$a47046b35fa42e2d = (query, filterKeywords)=>{
    for (const keyword of filterKeywords){
        if (query.includes(keyword)) return keyword;
    }
};


/**
 * Given a query and a filter keyword, return the query text after the filter keyword.
 * @param query
 * @param inQueryFiltersKey
 * @returns
 */ const $83f81d68cd229264$export$3141a593bcb9212f = (query, filterKeyword)=>{
    if (!query.includes(filterKeyword)) return;
    const lookupQueryIndexStart = query.lastIndexOf(filterKeyword) + filterKeyword.length;
    const lookupQuery = query.substring(lookupQueryIndexStart);
    return lookupQuery;
};


const $8c5a95c7ecfc19a6$export$f0a1ecf34ab38b2d = (inputQuery, selectedQueryFilters)=>{
    let filteredQuery = inputQuery;
    for (const selectedQueryFilter of selectedQueryFilters)filteredQuery = filteredQuery.replace(selectedQueryFilter.displayText, '');
    return filteredQuery;
};





const $4b2c46b0e1c9fde6$export$170a7ded78a9d477 = ()=>{
    return (0, $cozmU.useMemo)(()=>{
        return {};
    }, []);
};





const $c37a2d511bedb9d4$export$c37f199dbeef0d2c = ()=>{
    return (0, $cozmU.useMemo)(()=>{
        return {};
    }, []);
};





const $b27d5aab424bac8b$export$d3538183feb90c1a = (localQuery, postQueryDisabled)=>{
    const filterKeywordToFilterId = (0, $c37a2d511bedb9d4$export$c37f199dbeef0d2c)();
    const filterKeywordToFilterActions = (0, $4b2c46b0e1c9fde6$export$170a7ded78a9d477)();
    const selectedQueryFilters = (0, $5lH3O.useSelectedQueryFilters)();
    const { setQuickFindQuery: setQuickFindQuery, deleteSelectedQueryFilter: deleteSelectedQueryFilter, setCurrentQueryFilter: setCurrentQueryFilter } = (0, $5lH3O.useQuickFindActions)();
    const [debouncedSetLookupInput, cancelDebouncedSetLookupInput] = (0, $5Sv3D.default)((lookupInput, setLookupInput)=>{
        setLookupInput(lookupInput);
    }, 300);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('keep_filter_values_in_quick_find_input')) {
            const trimmedQuery = localQuery.trim();
            setQuickFindQuery(trimmedQuery);
        }
    }, [
        localQuery,
        setQuickFindQuery
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('keep_filter_values_in_quick_find_input')) return;
        const queryWithoutSelectedQueryFilters = (0, $8c5a95c7ecfc19a6$export$f0a1ecf34ab38b2d)(localQuery, selectedQueryFilters);
        const trimmedQuery = queryWithoutSelectedQueryFilters.trim();
        setQuickFindQuery(trimmedQuery);
    }, [
        localQuery,
        selectedQueryFilters,
        setQuickFindQuery
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (postQueryDisabled) return;
        // Deselect select query filters if their display text is no longer in the query
        for (const selectedQueryFilter of selectedQueryFilters)if (!localQuery.includes(selectedQueryFilter.displayText)) {
            const filterActions = filterKeywordToFilterActions[selectedQueryFilter.keyword];
            if (filterActions && selectedQueryFilter.option) {
                filterActions.setOption({
                    ...selectedQueryFilter.option,
                    isSelected: true
                });
                deleteSelectedQueryFilter(selectedQueryFilter);
            }
        }
        // To determine if a user is accessing a query filter, we use the query without
        // selected query filters to allow for multiple query filters to be used at once
        const queryWithoutSelectedQueryFilters = (0, $8c5a95c7ecfc19a6$export$f0a1ecf34ab38b2d)(localQuery, selectedQueryFilters);
        // Determine if the user is using a query filter
        const filterKeywords = Object.keys(filterKeywordToFilterId);
        const keyword = (0, $1094801a8b9aa725$export$a47046b35fa42e2d)(queryWithoutSelectedQueryFilters, filterKeywords);
        // Reset current query filter if keyword is not found
        if (!keyword) {
            cancelDebouncedSetLookupInput();
            setCurrentQueryFilter(undefined);
            return;
        }
        // Get the filter id and actioins for the filter corresponding to the keyword
        const filterId = filterKeywordToFilterId[keyword];
        const filterActions = filterKeywordToFilterActions[keyword];
        const filterLookupQuery = (0, $83f81d68cd229264$export$3141a593bcb9212f)(queryWithoutSelectedQueryFilters, keyword);
        // Load the options for the filter
        if (filterId && filterActions && filterLookupQuery !== undefined) {
            setCurrentQueryFilter({
                filterId: filterId,
                keyword: keyword
            });
            cancelDebouncedSetLookupInput();
            if (filterLookupQuery === '') {
                filterActions.loadInitialOptions();
                filterActions.setLookupInput('');
            } else debouncedSetLookupInput(filterLookupQuery, filterActions.setLookupInput);
        }
    }, [
        selectedQueryFilters,
        filterKeywordToFilterId,
        filterKeywordToFilterActions,
        deleteSelectedQueryFilter,
        setCurrentQueryFilter,
        localQuery,
        cancelDebouncedSetLookupInput,
        debouncedSetLookupInput,
        postQueryDisabled
    ]);
};


const $11aef5215e825422$export$a6dc0a1a1a8532e = ({ localQuery: localQuery, postQueryDisabled: postQueryDisabled, analyticsRef: analyticsRef })=>{
    const { setQueryUpdatedTime: setQueryUpdatedTime } = (0, $1i979.useSearchActions)();
    (0, $b27d5aab424bac8b$export$d3538183feb90c1a)(localQuery, postQueryDisabled);
    (0, $2978b921841aca22$export$92f7713045c6fd6a)(analyticsRef);
    (0, $cozmU.useEffect)(()=>{
        setQueryUpdatedTime();
    }, [
        setQueryUpdatedTime,
        localQuery
    ]);
    return null;
};


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $7sJoX = parcelRequire("7sJoX");


var $kkFbH = parcelRequire("kkFbH");


var $1LOGx = parcelRequire("1LOGx");


var $g9ioO = parcelRequire("g9ioO");





var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $fd0l2 = parcelRequire("fd0l2");


var $73Hia = parcelRequire("73Hia");





var $k7Gcl = parcelRequire("k7Gcl");


var $2MNU9 = parcelRequire("2MNU9");


var $5sEiG = parcelRequire("5sEiG");

















var $jLnA6 = parcelRequire("jLnA6");














var $dr3fs = parcelRequire("dr3fs");





var $1F9mF = parcelRequire("1F9mF");


var $44yDZ = parcelRequire("44yDZ");


var $4PFuU = parcelRequire("4PFuU");


var $a4K4k = parcelRequire("a4K4k");




const $2d35387ef9041c09$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    contributor: {
        id: "quick-find.filters.names.contributor",
        defaultMessage: "Contributor"
    },
    confluenceFilterContributorPlaceholder: {
        id: "quick-find.confluence.filter.contributor.placeholder",
        defaultMessage: "Find people"
    },
    confluenceFilterLabelSelected: {
        id: "quick-find.confluence.filter.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelUnselected: {
        id: "quick-find.confluence.filter.label.unselected",
        defaultMessage: "Suggested"
    }
});


const $e7f3ac019ce91218$export$fcbf8a9904746204 = ({ iconBefore: iconBefore, iconAfter: iconAfter, onFilterClose: onFilterClose })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOptionForContributorFilter, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $4PFuU.useSelectFilter)({
        filterId: (0, $a4K4k.filter).id
    });
    const confluenceProductConfig = (0, $73Hia.useProductConfig)((0, $dvVWp.ProductKeys).Confluence);
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, badgeLabel: badgeLabel, firstSelectedOptionLabel: firstSelectedOptionLabel } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $2d35387ef9041c09$export$a7357cdd1f0b0168).confluenceFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $2d35387ef9041c09$export$a7357cdd1f0b0168).confluenceFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    const ConfluenceIcon = confluenceProductConfig.Icon;
    const getIconBefore = ()=>{
        if (iconBefore) return iconBefore;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1F9mF.FilterButtonIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ConfluenceIcon, {
            size: "xxsmall"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g9ioO))), {
            label: formatMessage((0, $2d35387ef9041c09$export$a7357cdd1f0b0168).contributor)
        }));
    };
    const getIconAfter = ()=>{
        return selectedOptions.length === 0 ? iconAfter ? iconAfter : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            size: "small"
        }) : badgeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLnA6.default), {
            appearance: "information"
        }, badgeLabel);
    };
    const setOption = (option)=>{
        setOptionForContributorFilter(option, undefined, (0, $dvVWp.ProductKeys).Confluence);
    };
    const onDropdownClose = ()=>{
        clearLookupInput();
        if (onFilterClose) onFilterClose(options, selectedOptions);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $44yDZ.FilterPopupSelect), {
        filterId: (0, $a4K4k.filter).id,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: onDropdownClose,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $2d35387ef9041c09$export$a7357cdd1f0b0168).contributor),
        placeholder: formatMessage((0, $2d35387ef9041c09$export$a7357cdd1f0b0168).confluenceFilterContributorPlaceholder),
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $dr3fs.formatAvatarOptionLabel),
        onClearOptions: clearOptions,
        target: ({ isOpen: isOpen, ...targetProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k7Gcl.FilterButton), {
                testId: "search-dialog-contributor-filter-button",
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter(),
                minWidthZero: true
            }, firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $2d35387ef9041c09$export$a7357cdd1f0b0168).contributor))
    });
};



var $dolMg = parcelRequire("dolMg");







const $b8738a83cd93875b$export$767d38fff643cac6 = ({ productConfig: productConfig, onAppFilterSelected: onAppFilterSelected, productKey: productKey })=>{
    const Icon = productConfig.IconBorderless ?? productConfig.Icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k7Gcl.FilterButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            size: 'xsmall'
        }),
        contentFit: 'default',
        isSelected: false,
        spacing: 'default',
        onClick: (event)=>{
            onAppFilterSelected(productKey, {
                redirectToFPS: true,
                isPostAuthAction: false
            }, event);
        }
    }, productConfig.displayName);
};











const $7f5300e868f893fe$export$42a563ec5acc14f9 = ({ productConfig: productConfig, userNeedsAuth: userNeedsAuth, triggerProps: triggerProps, onAppFilterSelected: onAppFilterSelected, productKey: productKey })=>{
    const Icon = productConfig.IconBorderless ?? productConfig.Icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k7Gcl.FilterButton), {
        ...triggerProps,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            size: 'xsmall'
        }),
        contentFit: 'default',
        isSelected: false,
        spacing: 'default',
        gap: (0, $iDrrr.fg)('rovo-search-team-eu-26-search-app') ? 'default' : 'comfortable',
        onClick: (event)=>{
            if (!userNeedsAuth) onAppFilterSelected(productKey, {
                redirectToFPS: true,
                isPostAuthAction: false
            }, event);
        }
    }, productConfig.displayName);
};






var $18jLb = parcelRequire("18jLb");


var $gPOtu = parcelRequire("gPOtu");


var $5pcom = parcelRequire("5pcom");













const $4fd31762c594b703$export$cca86f2b29004207 = ({ productKey: productKey, redirectToFPSWithProductSelected: redirectToFPSWithProductSelected, trigger: trigger })=>{
    const [thirdPartyConfigs] = (0, $32Eau.useThirdPartyConfigs)();
    const isSmartlink = (0, $gPOtu.isProductSmartlink)({
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const { userNeedsOAuth: userNeedsOAuth } = (0, $9PGk3.useIsUserOAuthed)(productKey);
    const quickFindQuery = (0, $5lH3O.useQuickFindQuery)();
    const isAdminImported = (0, $gPOtu.hasAdminImportedUserLink)(productKey, thirdPartyConfigs);
    if (userNeedsOAuth && !isAdminImported) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ir4XI.ErrorBoundary), {
        section: "FiltersRowAppButtonFor3PAppsOAuthWrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18jLb.OAuthWarningWrapper), {
        key: productKey,
        product: productKey,
        postAuthAction: ()=>{
            redirectToFPSWithProductSelected();
        },
        trigger: (triggerProps)=>trigger({
                ...triggerProps,
                userNeedsAuth: true
            }),
        isOnSearchDialog: false,
        isInline: true,
        useOAuthHandlers: (0, $9PGk3.useOAuthHandlers),
        useIsUserOAuthed: (0, $9PGk3.useIsUserOAuthed),
        isSmartlink: isSmartlink,
        searchQuery: quickFindQuery,
        oAuthSource: (0, $5pcom.OAuthSource).quickFindFilter,
        thirdPartyConfigs: thirdPartyConfigs
    }));
    return trigger({
        userNeedsAuth: false
    });
};





const $cacf92e2ad493f9b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    filterByIcon: {
        id: "search-filters.filter-by-icon",
        defaultMessage: "Filter by icon"
    },
    more: {
        id: "search_filters.more",
        defaultMessage: "more"
    },
    moreAppsSearchTooltip: {
        id: "search_filters.more-apps-search",
        defaultMessage: "Open full page search for this term searching all apps"
    },
    contributor: {
        id: "search-filters.names.contributor",
        defaultMessage: "Contributor"
    },
    type: {
        id: "search-filters.names.type",
        defaultMessage: "Type"
    }
});

















// TODO: Render dynamic 1P products, hardcoded for now for Team 25
// This should be synced with the FilterRowLoading component that hard codes filter buttons
const $f7a2720cd257000c$var$supported1PApps = (primaryProduct)=>{
    if (!primaryProduct) return [];
    return [
        {
            productKey: (0, $dvVWp.ProductKeys).Confluence,
            redirectToFPS: false
        }
    ];
};
// TODO: Render dynamic 3P products, hardcoded for now for Team 25
// This should be synced with the FilterRowLoading component that hard codes filter buttons
const $f7a2720cd257000c$var$supported3PApps = [
    (0, $dvVWp.ProductKeys).GoogleDrive,
    (0, $dvVWp.ProductKeys).Teams
];
const $f7a2720cd257000c$export$6889317edccadd84 = ()=>{
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const availableProducts = (0, $32Eau.useAvailableProducts)();
    const [selectedProduct] = (0, $1i979.useSelectedProduct)();
    const productConfigs = (0, $73Hia.useProductConfigs)();
    const apps3PToDisplay = (0, $cozmU.useMemo)(()=>$f7a2720cd257000c$var$supported3PApps.filter((supported3PApp)=>availableProducts.includes(supported3PApp)).filter((_)=>!selectedProduct).map((productKey)=>({
                productKey: productKey,
                productConfig: productConfigs[productKey]
            })), [
        availableProducts,
        productConfigs,
        selectedProduct
    ]);
    const apps1PToDisplay = (0, $cozmU.useMemo)(()=>$f7a2720cd257000c$var$supported1PApps(primaryProduct).filter((supported1PApp)=>availableProducts.includes(supported1PApp.productKey)).filter((supported1PApp)=>!selectedProduct || supported1PApp.productKey === selectedProduct).map((supportedApp)=>({
                ...supportedApp,
                productConfig: productConfigs[supportedApp.productKey]
            })), [
        availableProducts,
        primaryProduct,
        productConfigs,
        selectedProduct
    ]);
    return {
        apps1PToDisplay: apps1PToDisplay,
        apps3PToDisplay: apps3PToDisplay,
        primaryProduct: primaryProduct,
        selectedProduct: selectedProduct
    };
};


const $b6874b45aa369dfc$var$styles = {
    container: "_3SamIHNHnM _2YLqiKIZbP _2Y7lL4NHnM _39xV02N91d _1EqgXlbQX2 _3TGfC9HnLE _2lyjcILRg7",
    icon: "_1UtDYzKGUX _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    defaultFilterButton: "_2mHwu8gVvo _0bjKvDKxmn _30huDKOeNX _2sNsIgmnOE _2Y7lL48HPE _4c065U1Y8M _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYzZpcK _39xV02W9qI _4kiQYAUofl _1EqgXllwhp _0KLXru66of _1ANEUSLRg7 _1kk5Tkf7mX",
    filterButtonContent: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7"
};
const $b6874b45aa369dfc$export$876f25caa2b82f74 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { onNavigate: onNavigate, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $c11PZ.useAppContext)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $5lH3O.useQuickFindActions)();
    const quickFindQuery = (0, $5lH3O.useQuickFindQuery)();
    const { selectProductFilter: selectProductFilter, clearAllFilters: clearAllFilters } = (0, $1i979.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $68JhS.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $68JhS.useQuickFindAttributes)();
    const { selectedProduct: selectedProduct } = (0, $f7a2720cd257000c$export$6889317edccadd84)();
    const onAppFilterSelected = (productKey, options, event)=>{
        const newSelectedProduct = selectedProduct === productKey ? undefined : productKey;
        fireAnalyticsEvent((0, $2MNU9.onAppFilterSelect)({
            actionSubjectId: productKey,
            action: newSelectedProduct === undefined ? 'unselected' : 'selected',
            attributes: {
                ...commonAttributes,
                isPostAuthAction: options.isPostAuthAction,
                isRedirectedToFPS: options.redirectToFPS,
                source: 'inline'
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        if (!options.redirectToFPS) {
            selectProductFilter(newSelectedProduct);
            return;
        }
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...queryParams,
            product: productKey,
            text: quickFindQuery
        }), 'push', event);
        clearAllFilters();
        setQuickFindOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignBlock: "center",
        alignInline: "center",
        xcss: $b6874b45aa369dfc$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b6874b45aa369dfc$var$styles.icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1LOGx))), {
        label: formatMessage((0, $cacf92e2ad493f9b$export$defe85febe8b728c).filterByIcon)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b6874b45aa369dfc$var$FilterSelects, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b6874b45aa369dfc$var$FilterApps, {
        onAppFilterSelected: onAppFilterSelected
    }));
};
const $b6874b45aa369dfc$var$FilterSelects = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { unselectProductFilter: unselectProductFilter } = (0, $1i979.useSearchActions)(); // Deselect 'Confluence' when closing the contributor filter with no options selected
    // This should restore any 3P filters that were hidden while this filter was active
    const onFilterClose = (options, selectedOptions)=>{
        if (selectedOptions.length === 0) unselectProductFilter();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e7f3ac019ce91218$export$fcbf8a9904746204), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g9ioO))), {
            label: formatMessage((0, $cacf92e2ad493f9b$export$defe85febe8b728c).contributor)
        }),
        iconAfter: (0, $iDrrr.fg)('rovo-search-team-eu-26-search-app') ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        onFilterClose: onFilterClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dolMg.UniversalTypeFilter), {
        filterOptionsByPrimaryProduct: !(0, $iDrrr.fg)('rovo-search-team-eu-26-search-app'),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
            label: formatMessage((0, $cacf92e2ad493f9b$export$defe85febe8b728c).type)
        }),
        iconAfter: (0, $iDrrr.fg)('rovo-search-team-eu-26-search-app') ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        selectPrimaryProductOnChange: !(0, $iDrrr.fg)('rovo-search-team-eu-26-search-app')
    }));
};
const $b6874b45aa369dfc$var$FilterApps = ({ onAppFilterSelected: onAppFilterSelected })=>{
    const { apps3PToDisplay: apps3PToDisplay, apps1PToDisplay: apps1PToDisplay } = (0, $f7a2720cd257000c$export$6889317edccadd84)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, apps1PToDisplay.map((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: app.productKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8738a83cd93875b$export$767d38fff643cac6), {
            productConfig: app.productConfig,
            onAppFilterSelected: onAppFilterSelected,
            productKey: app.productKey
        }))), apps3PToDisplay.map((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: app.productKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fd31762c594b703$export$cca86f2b29004207), {
            productKey: app.productKey,
            redirectToFPSWithProductSelected: ()=>onAppFilterSelected(app.productKey, {
                    redirectToFPS: true,
                    isPostAuthAction: true
                }),
            trigger: ({ triggerProps: triggerProps, userNeedsAuth: userNeedsAuth })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7f5300e868f893fe$export$42a563ec5acc14f9), {
                    productConfig: app.productConfig,
                    userNeedsAuth: userNeedsAuth,
                    triggerProps: triggerProps,
                    onAppFilterSelected: onAppFilterSelected,
                    productKey: app.productKey
                })
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b6874b45aa369dfc$var$AdditionalAppsButton, null));
};
const $b6874b45aa369dfc$var$AdditionalAppsButton = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $68JhS.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $68JhS.useQuickFindAttributes)();
    const { onNavigate: onNavigate, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $c11PZ.useAppContext)();
    const quickFindQuery = (0, $5lH3O.useQuickFindQuery)();
    const { clearAllFilters: clearAllFilters } = (0, $1i979.useSearchActions)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $5lH3O.useQuickFindActions)();
    const onClick = (event)=>{
        fireAnalyticsEvent((0, $2MNU9.onAppFilterSelect)({
            actionSubjectId: 'more-apps-search',
            action: 'selected',
            attributes: {
                ...commonAttributes,
                isPostAuthAction: false,
                isRedirectedToFPS: true,
                source: 'inline'
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...queryParams,
            text: quickFindQuery
        }), 'push', event);
        clearAllFilters();
        setQuickFindOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k7Gcl.FilterButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5sEiG.AllAppsIcon), null),
        contentFit: 'default',
        isSelected: false,
        spacing: 'default',
        tooltip: formatMessage((0, $cacf92e2ad493f9b$export$defe85febe8b728c).moreAppsSearchTooltip),
        onClick: onClick
    }, `+${formatMessage((0, $cacf92e2ad493f9b$export$defe85febe8b728c).more)}`);
};
const $b6874b45aa369dfc$export$28e86b995fe6c793 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignBlock: "center",
        alignInline: "center",
        xcss: $b6874b45aa369dfc$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b6874b45aa369dfc$var$styles.icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1LOGx))), {
        label: formatMessage((0, $cacf92e2ad493f9b$export$defe85febe8b728c).filterByIcon)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b6874b45aa369dfc$var$ContributorFilterLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b6874b45aa369dfc$var$UniversalTypeFilterLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b6874b45aa369dfc$var$ProductFilterLoading, {
        productKey: "confluence"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b6874b45aa369dfc$var$ProductFilterLoading, {
        productKey: "drive"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b6874b45aa369dfc$var$ProductFilterLoading, {
        productKey: "teams"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b6874b45aa369dfc$var$ProductMoreAppsButtonLoading, null));
};
const $b6874b45aa369dfc$var$ContributorFilterLoading = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b6874b45aa369dfc$var$styles.defaultFilterButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g9ioO))), {
        label: formatMessage((0, $cacf92e2ad493f9b$export$defe85febe8b728c).contributor)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b6874b45aa369dfc$var$styles.filterButtonContent
    }, formatMessage((0, $cacf92e2ad493f9b$export$defe85febe8b728c).contributor)), (0, $iDrrr.fg)('rovo-search-team-eu-26-search-app') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        size: "small"
    }));
};
const $b6874b45aa369dfc$var$UniversalTypeFilterLoading = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b6874b45aa369dfc$var$styles.defaultFilterButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
        label: formatMessage((0, $cacf92e2ad493f9b$export$defe85febe8b728c).type)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b6874b45aa369dfc$var$styles.filterButtonContent
    }, formatMessage((0, $cacf92e2ad493f9b$export$defe85febe8b728c).type)), (0, $iDrrr.fg)('rovo-search-team-eu-26-search-app') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        size: "small"
    }));
};
const $b6874b45aa369dfc$var$ProductFilterLoading = ({ productKey: productKey })=>{
    const config1P = (0, $73Hia.products1P)[productKey];
    const config3P = (0, $fd0l2.ThirdPartyConfigsSync).get(productKey);
    let displayName = '';
    let displayNameString = ''; // 1P configs use config.Icon/IconBorderless, 3P configs use config.icon/iconBorderless
    let IconComponent;
    if (config1P) {
        // ProductConfig from products1P
        IconComponent = config1P.IconBorderless ?? config1P.Icon;
        displayName = config1P.displayName;
        displayNameString = String(displayName);
    } else if (config3P) {
        // ThirdPartyConfig from ThirdPartyConfigs
        IconComponent = config3P.iconBorderless ?? config3P.icon;
        displayName = config3P.displayName;
        displayNameString = String(displayName);
    } else return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b6874b45aa369dfc$var$styles.defaultFilterButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
        size: "xsmall",
        label: displayNameString
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b6874b45aa369dfc$var$styles.filterButtonContent
    }, displayName));
};
const $b6874b45aa369dfc$var$ProductMoreAppsButtonLoading = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b6874b45aa369dfc$var$styles.defaultFilterButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5sEiG.AllAppsIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b6874b45aa369dfc$var$styles.filterButtonContent
    }, `+${formatMessage((0, $cacf92e2ad493f9b$export$defe85febe8b728c).more)}`));
};









var $1hQ0e = parcelRequire("1hQ0e");


var $gXfti = parcelRequire("gXfti");























var $54yUd = parcelRequire("54yUd");














var $6s3PG = parcelRequire("6s3PG");

const $0226f3b1aac05b3d$export$d41d96cbdaac172b = ({ thirdPartyConfigs: thirdPartyConfigs })=>{
    const isEligible3PUser = Object.keys(thirdPartyConfigs).some((productKey)=>thirdPartyConfigs[productKey]?.userNeedsOAuth === false);
    if (!isEligible3PUser) return false;
    return (0, $cXtTj.default).getExperimentValue('confluence_quick_find_ghost_text_3p_experiment', 'cohort', (0, $6s3PG.GhostTextExperimentCohort).CONTROL) === (0, $6s3PG.GhostTextExperimentCohort).THREE_P;
};






var $eCHsK = parcelRequire("eCHsK");





var $5cu3N = parcelRequire("5cu3N");












var $2Icgs = parcelRequire("2Icgs");


var $l35DG = parcelRequire("l35DG");


var $7dKcF = parcelRequire("7dKcF");























const $4e7e4895dca28633$export$766d74f7dcab3339 = (0, $kSwu1.defineMessages)({
    controlPlaceholder: {
        id: "quick-find.ghost-text.control",
        defaultMessage: "Search"
    },
    default3PPlaceholder: {
        id: "quick-find.ghost-text.default-3p",
        defaultMessage: "Search across all your apps"
    },
    sainPlaceholder: {
        id: "quick-find.ghost-text.sain",
        defaultMessage: "Ask me anything or search..."
    },
    multipleThirdPartyPlaceholder: {
        id: "quick-find.ghost-text.3p-multiple",
        defaultMessage: "Search {firstPartyApp}, {thirdPartyApp1}, {thirdPartyApp2} and other apps"
    },
    twoAppPlaceholder: {
        id: "quick-find.ghost-text.two-apps",
        defaultMessage: "Search {firstPartyApp}, {thirdPartyApp1} and other apps"
    },
    mixedAppsPlaceholder: {
        id: "quick-find.ghost-text.mixed-apps",
        defaultMessage: "Search {currentApp}, {otherFirstPartyApp}, {thirdPartyApp} and other apps"
    },
    // Third-party product specific messages
    googleDrivePlaceholder: {
        id: "quick-find.ghost-text.3p.google-drive",
        defaultMessage: "Search your Google Drive Docs, Sheets and Slides"
    },
    sharepointPlaceholder: {
        id: "quick-find.ghost-text.3p.sharepoint",
        defaultMessage: "Search your SharePoint documents and files"
    },
    onedrivePlaceholder: {
        id: "quick-find.ghost-text.3p.onedrive",
        defaultMessage: "Search your OneDrive documents and files"
    },
    teamsPlaceholder: {
        id: "quick-find.ghost-text.3p.teams",
        defaultMessage: "Search your Microsoft Teams chats and messages"
    },
    slackPlaceholder: {
        id: "quick-find.ghost-text.3p.slack",
        defaultMessage: "Search your Slack DMs and messages"
    },
    githubPlaceholder: {
        id: "quick-find.ghost-text.3p.github",
        defaultMessage: "Search your GitHub repos, commits and PRs"
    },
    // SAIN cohort question suggestions
    sainQuestionTimeOff: {
        id: "quick-find.ghost-text.sain.time-off",
        defaultMessage: "Try any question, like \"How do I request time off?\""
    },
    sainQuestionResetPassword: {
        id: "quick-find.ghost-text.sain.reset-password",
        defaultMessage: "Try any question, like \"How do I reset my password?\""
    },
    sainQuestionNotifications: {
        id: "quick-find.ghost-text.sain.notifications",
        defaultMessage: "Try any question, like \"How do I change my notification settings?\""
    },
    sainQuestionITSupport: {
        id: "quick-find.ghost-text.sain.it-support",
        defaultMessage: "Try any question, like \"How do I contact IT support?\""
    },
    sainQuestionMeetingRoom: {
        id: "quick-find.ghost-text.sain.meeting-room",
        defaultMessage: "Try any question, like \"How do I book a meeting room?\""
    },
    sainQuestionBenefits: {
        id: "quick-find.ghost-text.sain.benefits",
        defaultMessage: "Try any question, like \"Where can I see my benefits?\""
    }
});



var $6IUkh = parcelRequire("6IUkh");

// TODO: to be used in second experiment https://hello.atlassian.net/wiki/pages/resumedraft.action?draftId=6192988799
/**
 * Generate ghost text rotations for SAIN cohort (AI-powered question suggestions)
 */ // const calculateSainGhostTextRotations = (
// 	formatMessage: (message: any, values?: any) => string,
// ): string[] => {
// 	return [
// 		formatMessage(ghostTextMessages.sainQuestionTimeOff),
// 		formatMessage(ghostTextMessages.sainQuestionResetPassword),
// 		formatMessage(ghostTextMessages.sainQuestionNotifications),
// 		formatMessage(ghostTextMessages.sainQuestionITSupport),
// 		formatMessage(ghostTextMessages.sainQuestionMeetingRoom),
// 		formatMessage(ghostTextMessages.sainQuestionBenefits),
// 	];
// };
/**
 * Generate ghost text rotations for 3P cohort (based on available products)
 * Returns ordered list: combined texts -> 3P specific texts (sorted by hash)
 */ const $f69947e5b9109bd0$var$calculate3PGhostTextRotations = ({ products: products, thirdPartyConfigs: thirdPartyConfigs, primaryProduct: primaryProduct, formatMessage: formatMessage })=>{
    const SUPPORTED_3P_MESSAGES = new Map([
        [
            (0, $fR63l.ProductKeys3P).GoogleDrive,
            (0, $4e7e4895dca28633$export$766d74f7dcab3339).googleDrivePlaceholder
        ],
        [
            (0, $fR63l.ProductKeys3P).Sharepoint,
            (0, $4e7e4895dca28633$export$766d74f7dcab3339).sharepointPlaceholder
        ],
        [
            (0, $fR63l.ProductKeys3P).OneDrive,
            (0, $4e7e4895dca28633$export$766d74f7dcab3339).onedrivePlaceholder
        ],
        [
            (0, $fR63l.ProductKeys3P).Teams,
            (0, $4e7e4895dca28633$export$766d74f7dcab3339).teamsPlaceholder
        ],
        [
            (0, $fR63l.ProductKeys3P).Slack,
            (0, $4e7e4895dca28633$export$766d74f7dcab3339).slackPlaceholder
        ],
        [
            (0, $fR63l.ProductKeys3P).Github,
            (0, $4e7e4895dca28633$export$766d74f7dcab3339).githubPlaceholder
        ]
    ]);
    const currentAppName = primaryProduct && (0, $dvVWp.is1pProductKey)(primaryProduct) ? (0, $73Hia.products1P)[primaryProduct]?.displayName : undefined;
    const available1PExcludePrimary = Array.from(new Set(products.filter((0, $dvVWp.is1pProductKey)).map((productKey)=>{
        // Consolidate Jira variants to base Jira for ghost text
        if (productKey === (0, $dvVWp.ProductKeys).JiraProductDiscovery || productKey === (0, $dvVWp.ProductKeys).JiraServiceManagement) return (0, $dvVWp.ProductKeys).Jira;
        return productKey;
    }))).filter((productKey)=>productKey !== primaryProduct);
    const available3PProducts = Object.keys(thirdPartyConfigs || {}).filter((key)=>thirdPartyConfigs?.[key] !== undefined && !thirdPartyConfigs?.[key]?.userNeedsOAuth && !key.toLowerCase().startsWith('forge-connector-') && !key.toLowerCase().includes((0, $fR63l.ProductKeys3P).AtlassianWebCrawler) && !key.toLowerCase().endsWith('-dc'));
    const textRotations = [];
    if (currentAppName) {
        if (available3PProducts.length >= 1 && available1PExcludePrimary.length >= 1) {
            const top1P = (0, $73Hia.products1P)[available1PExcludePrimary[0]].displayName;
            const top3P = thirdPartyConfigs?.[available3PProducts[0]]?.displayName;
            textRotations.push({
                id: (0, $4e7e4895dca28633$export$766d74f7dcab3339).mixedAppsPlaceholder.id,
                text: formatMessage((0, $4e7e4895dca28633$export$766d74f7dcab3339).mixedAppsPlaceholder, {
                    currentApp: currentAppName,
                    otherFirstPartyApp: top1P,
                    thirdPartyApp: top3P
                })
            });
        }
        if (available3PProducts.length >= 2) {
            const top3P1 = thirdPartyConfigs?.[available3PProducts[0]]?.displayName;
            const top3P2 = thirdPartyConfigs?.[available3PProducts[1]]?.displayName;
            textRotations.push({
                id: (0, $4e7e4895dca28633$export$766d74f7dcab3339).multipleThirdPartyPlaceholder.id,
                text: formatMessage((0, $4e7e4895dca28633$export$766d74f7dcab3339).multipleThirdPartyPlaceholder, {
                    firstPartyApp: currentAppName,
                    thirdPartyApp1: top3P1,
                    thirdPartyApp2: top3P2
                })
            });
        }
        if (available3PProducts.length === 1 && available1PExcludePrimary.length === 0) {
            const top3P = thirdPartyConfigs?.[available3PProducts[0]]?.displayName;
            textRotations.push({
                id: (0, $4e7e4895dca28633$export$766d74f7dcab3339).twoAppPlaceholder.id,
                text: formatMessage((0, $4e7e4895dca28633$export$766d74f7dcab3339).twoAppPlaceholder, {
                    firstPartyApp: currentAppName,
                    thirdPartyApp1: top3P
                })
            });
        }
    }
    for (const productKey of available3PProducts){
        const message = SUPPORTED_3P_MESSAGES.get(productKey);
        if (message) textRotations.push({
            id: message.id,
            text: formatMessage(message)
        });
    }
    return textRotations;
};
const $f69947e5b9109bd0$export$1933af4a353afb6d = ({ products: products, thirdPartyConfigs: thirdPartyConfigs, primaryProduct: primaryProduct, formatMessage: formatMessage })=>{
    const rotations = $f69947e5b9109bd0$var$calculate3PGhostTextRotations({
        products: products,
        thirdPartyConfigs: thirdPartyConfigs,
        primaryProduct: primaryProduct,
        formatMessage: formatMessage
    }).filter((r)=>r.text.length <= 85);
    rotations.push({
        id: (0, $4e7e4895dca28633$export$766d74f7dcab3339).default3PPlaceholder.id,
        text: formatMessage((0, $4e7e4895dca28633$export$766d74f7dcab3339).default3PPlaceholder)
    });
    return rotations;
};
const $f69947e5b9109bd0$export$6d85a15223337a49 = ({ products: products, thirdPartyConfigs: thirdPartyConfigs, locale: locale, primaryProduct: primaryProduct, formatMessage: formatMessage, existingGhostTextData: existingGhostTextData })=>{
    // Get all text rotations
    const rotations = $f69947e5b9109bd0$export$1933af4a353afb6d({
        products: products,
        thirdPartyConfigs: thirdPartyConfigs,
        primaryProduct: primaryProduct,
        formatMessage: formatMessage
    });
    // Select appropriate text based on current state
    const { id: id, text: text, occurrence: occurrence } = (0, $6IUkh.selectGhostText)(rotations, locale, existingGhostTextData);
    return {
        id: id,
        locale: locale,
        text: text,
        occurrence: occurrence
    };
};
const $f69947e5b9109bd0$export$b18766b017ecaef9 = (value)=>{
    return value === '{}' || value === '' || value === null || value === undefined;
};
const $f69947e5b9109bd0$export$e1cd992f057eb389 = ({ serve3PGhostText: serve3PGhostText, lastPersisted: lastPersisted, products: products, thirdPartyConfigs: thirdPartyConfigs, locale: locale, primaryProduct: primaryProduct, formatMessage: formatMessage, existingGhostTextData: existingGhostTextData })=>{
    const newGhostTextData = serve3PGhostText ? $f69947e5b9109bd0$export$6d85a15223337a49({
        products: products,
        thirdPartyConfigs: thirdPartyConfigs,
        locale: locale,
        primaryProduct: primaryProduct,
        formatMessage: formatMessage,
        existingGhostTextData: existingGhostTextData
    }) : {};
    const serialized = JSON.stringify(newGhostTextData);
    // Reject transition from non-empty to empty (don't overwrite valid data)
    // Accept transition from empty to non-empty (allow valid data to be set)
    const isNewEmpty = $f69947e5b9109bd0$export$b18766b017ecaef9(serialized);
    const wasLastEmpty = $f69947e5b9109bd0$export$b18766b017ecaef9(lastPersisted);
    if (!wasLastEmpty && isNewEmpty) // Don't overwrite valid ghost text with empty
    return null;
    return serialized;
};












// Matches `<Link prefetch="hover">` PREFETCH_DELAY in react-resource-router.
const $08aec3c81efaefb3$var$PREFETCH_DEBOUNCE_TIME = 225;
const $08aec3c81efaefb3$var$PREFETCH_MIN_QUERY_LENGTH = 2;
const $08aec3c81efaefb3$export$79486f10508cab81 = ({ onPrefetch: onPrefetch, getQuery: getQuery, getUrls: getUrls })=>{
    const fire = (0, $cozmU.useCallback)(()=>{
        if (!onPrefetch || !(0, $iDrrr.fg)('quick_find_typing_debounce_prefetch')) return;
        const trimmed = getQuery().trim();
        if (trimmed.length < $08aec3c81efaefb3$var$PREFETCH_MIN_QUERY_LENGTH) return;
        for (const url of getUrls(trimmed))if (url) onPrefetch(url);
    }, [
        onPrefetch,
        getQuery,
        getUrls
    ]);
    // Uses `use-debounce` rather than the package's lodash `useDebouncedCallback`
    // because it auto-cancels on unmount and is
    // controllable by jest fake timers; we expose its callback + cancel.
    const [debouncedPrefetch, cancelDebouncedPrefetch] = (0, $5Sv3D.default)(fire, $08aec3c81efaefb3$var$PREFETCH_DEBOUNCE_TIME);
    return [
        debouncedPrefetch,
        cancelDebouncedPrefetch
    ];
};


const $a4d54046c757631f$export$fb8d8fbc0c4c1705 = ({ dialogId: dialogId, inputRef: inputRef, localQuery: localQuery, setLocalQuery: setLocalQuery, textfieldComponent: textfieldComponent, postQueryDisabled: postQueryDisabled, customPlaceholder: customPlaceholder, onGhostTextGenerated: onGhostTextGenerated, intentRouterEnabled: intentRouterEnabled, filterPresentation: filterPresentation, onPrefetch: onPrefetch, counterfactualIntentDetection: counterfactualIntentDetection, autoFocusInput: autoFocusInput = false })=>{
    const previousTextQueryParam = (0, $cozmU.useRef)();
    const hasAppliedAutoFocus = (0, $cozmU.useRef)(false);
    const wasQuickFindOpen = (0, $cozmU.useRef)(false);
    const { generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, queryParams: queryParams, isNav4Enabled: isNav4Enabled, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $c11PZ.useAppContext)();
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const applicationMode = (0, $32Eau.useApplicationMode)();
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const [user] = (0, $32Eau.useUser)();
    const [thirdPartyConfigs] = (0, $32Eau.useThirdPartyConfigs)();
    const products = (0, $32Eau.useAvailableProducts)();
    const quickFindOpen = (0, $5lH3O.useQuickFindOpen)();
    const quickFindQuery = (0, $5lH3O.useQuickFindQuery)();
    // Do not deconstruct useKeyboardHighlightProvider as it causes the SSR to fail
    const keyboardHighlight = (0, $89906.useKeyboardHighlightProvider)();
    const getSelectedIndex = keyboardHighlight?.getSelectedIndex;
    const keyboardNavComponents = keyboardHighlight?.keyboardNavComponents;
    const updateRecentQueries = (0, $5lH3O.useUpdateRecentQueries)();
    const [selectedIndex, setSelectedIndex] = (0, $cozmU.useState)(getSelectedIndex?.());
    // Compute the activeDescendantId for aria-activedescendant
    const activeDescendantId = (0, $cozmU.useMemo)(()=>{
        if (selectedIndex === undefined || !keyboardNavComponents) return undefined;
        const selectedComponent = keyboardNavComponents[selectedIndex];
        return selectedComponent?.navigationTrackingId || undefined;
    }, [
        selectedIndex,
        keyboardNavComponents
    ]);
    const selectedQueryFilters = (0, $5lH3O.useSelectedQueryFilters)();
    const [selectedProduct] = (0, $1i979.useSelectedProduct)();
    const { selectedFilters: { jiraFilters: jiraFilters } } = (0, $hMXVq.useSelectedFilters)({});
    const { setQuickFindOpen: setQuickFindOpen, resetSelectedQueryFilters: resetSelectedQueryFilters } = (0, $5lH3O.useQuickFindActions)();
    const { setQueryUpdatedTime: setQueryUpdatedTime, clearAllFilters: clearAllFilters, setInputQuery: setInputQuery } = (0, $1i979.useSearchActions)();
    const { fireOnSearchDialogInputClicked: fireOnSearchDialogInputClicked, debouncedOnTextEnteredAnalyticsCallback: debouncedOnTextEnteredAnalyticsCallback, trackSearchSubmit: trackSearchSubmit, fireOnQuickFindClearButtonClicked: fireOnQuickFindClearButtonClicked, fireOnQuickFindConnectAppsPillClicked: fireOnQuickFindConnectAppsPillClicked, fireOnGhostTextShownEvent: fireOnGhostTextShownEvent } = (0, $789ad13e648baaf8$export$39ddbf45077610d4)();
    const { recordQueryChange: recordQueryChange, resetOnClear: resetOnClear, resetOnSubmit: resetOnSubmit } = (0, $1KAXF.useQuickFindPerceivedLatency)();
    const fireCounterfactualIntentDecision = (0, $2Icgs.useCounterfactualIntentDecision)(counterfactualIntentDetection);
    const [debouncedPrefetchCallback, cancelDebouncedPrefetchCallback] = (0, $08aec3c81efaefb3$export$79486f10508cab81)({
        onPrefetch: onPrefetch,
        getQuery: (0, $cozmU.useCallback)(()=>inputRef?.current?.value ?? '', [
            inputRef
        ]),
        getUrls: (0, $cozmU.useCallback)((query)=>{
            try {
                return (0, $5cu3N.getWorkItemPrefetchUrls)({
                    query: query,
                    jiraFilters: jiraFilters,
                    generateSearchUrl: generateSearchUrl,
                    queryParams: queryParams,
                    isQueryJql: (0, $krr0S.isJqlQueryDetected)(query)
                });
            } catch  {
                return [];
            }
        }, [
            jiraFilters,
            generateSearchUrl,
            queryParams
        ])
    });
    const logException = (0, $2csHQ.useLogException)();
    const { abortTask: abortTask, isTaskActive: isTaskActive } = (0, $7dKcF.useQuickFindPostQueryVitalStats)();
    const { abortTask: abortIntentDetectionTask, isTaskActive: isIntentDetectionTaskActive } = (0, $l35DG.useIntentDetectionVitalStats)();
    const isConfigLoaded = (0, $32Eau.useIsConfigLoaded)();
    (0, $8BkJa.useInputSkeleton)({
        localQuery: localQuery,
        inputRef: inputRef
    });
    // Ghost text is scoped to Confluence only. This replaces the `quickfind-ghosttext` feature gate,
    // which was only ever enabled for Confluence.
    const isConfluence = primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Confluence;
    const serve3PGhostText = (0, $cozmU.useMemo)(()=>isConfluence && (0, $0226f3b1aac05b3d$export$d41d96cbdaac172b)({
            thirdPartyConfigs: thirdPartyConfigs
        }), [
        isConfluence,
        thirdPartyConfigs
    ]);
    const existingGhostTextData = (0, $cozmU.useMemo)(()=>isConfluence ? (0, $6s3PG.parseGhostTextData)(customPlaceholder) : undefined, [
        isConfluence,
        customPlaceholder
    ]);
    // Track last persisted ghost text to prevent overwriting valid data with empty
    const lastPersistedGhostTextRef = (0, $cozmU.useRef)('{}');
    (0, $cozmU.useEffect)(()=>{
        if (!onGhostTextGenerated || !isConfigLoaded) return;
        const serialized = (0, $f69947e5b9109bd0$export$e1cd992f057eb389)({
            serve3PGhostText: serve3PGhostText,
            lastPersisted: lastPersistedGhostTextRef.current,
            products: products,
            thirdPartyConfigs: thirdPartyConfigs,
            locale: locale,
            primaryProduct: primaryProduct,
            formatMessage: formatMessage,
            existingGhostTextData: existingGhostTextData
        });
        if (serialized === null || isConfluence && (0, $f69947e5b9109bd0$export$b18766b017ecaef9)(serialized)) return;
        lastPersistedGhostTextRef.current = serialized;
        onGhostTextGenerated(serialized);
    }, [
        serve3PGhostText,
        products,
        thirdPartyConfigs,
        primaryProduct,
        formatMessage,
        existingGhostTextData,
        onGhostTextGenerated,
        isConfigLoaded,
        isConfluence,
        locale
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (serve3PGhostText && existingGhostTextData) fireOnGhostTextShownEvent({
            id: existingGhostTextData.id,
            locale: existingGhostTextData.locale,
            customGhostText: existingGhostTextData.text
        });
    }, [
        serve3PGhostText,
        existingGhostTextData,
        fireOnGhostTextShownEvent
    ]);
    /**
   * When Quick Find is SSR'd, users may type into the input before the
   * React component is mounted. Given that useLayoutEffect is called before
   * the first browser paint but after the input ref is set, this essentially
   * initialises the React component with the input's state prior to hydration.
   * - Input in the DOM element is reflected in localQuery
   * - Focus state is preserved as hydration causes the input to lose focus
   *
   * It should be noted that re-renders caused state by updates in useLayoutEffect
   * are synchronous, i.e. occurs before the paint, hence this is TTVC friendly.
   *
   * When this component is not SSR'd, this effectively does nothing.
   */ (0, $cozmU.useLayoutEffect)(()=>{
        if (inputRef?.current) {
            setLocalQuery(inputRef.current.value);
            const document = (0, $1hQ0e.getDocument)();
            const isFocused = document && document.activeElement === inputRef.current;
            const selectionStart = isFocused ? inputRef.current.selectionStart : null;
            const selectionEnd = isFocused ? inputRef.current.selectionEnd : null;
            if (isFocused) requestAnimationFrame(()=>{
                inputRef?.current?.focus();
                if (selectionStart !== null && selectionEnd !== null) inputRef?.current?.setSelectionRange(selectionStart, selectionEnd);
            });
        }
    }, [
        inputRef,
        setLocalQuery
    ]);
    (0, $b27d5aab424bac8b$export$d3538183feb90c1a)(localQuery, postQueryDisabled);
    // Only when the text query param changes, update the local query. If the
    // local query without selected query filters is the same as text query param,
    // do nothing.
    (0, $cozmU.useEffect)(()=>{
        const textParam = typeof queryParams.text === 'string' ? queryParams.text : undefined;
        if (textParam === previousTextQueryParam.current) return;
        previousTextQueryParam.current = textParam;
        const localQueryWithoutSelectedQueryFilters = (0, $8c5a95c7ecfc19a6$export$f0a1ecf34ab38b2d)(localQuery, selectedQueryFilters);
        const newLocalQuery = typeof queryParams.text === 'string' ? queryParams.text : '';
        if (localQueryWithoutSelectedQueryFilters !== newLocalQuery) {
            setInputQuery(newLocalQuery);
            setLocalQuery(newLocalQuery);
            clearAllFilters();
            resetSelectedQueryFilters();
        }
    }, [
        clearAllFilters,
        queryParams.text,
        resetSelectedQueryFilters,
        selectedQueryFilters,
        setLocalQuery,
        localQuery,
        setInputQuery
    ]);
    // Update query time when query changes
    (0, $cozmU.useEffect)(()=>{
        setQueryUpdatedTime();
    }, [
        setQueryUpdatedTime,
        localQuery
    ]);
    (0, $cozmU.useEffect)(()=>{
        const input = inputRef?.current;
        // Preserve the original Quick Find focus behavior unless a host opts into autofocus.
        if (!autoFocusInput) {
            hasAppliedAutoFocus.current = false;
            wasQuickFindOpen.current = false;
            if (quickFindOpen) input?.focus();
            else input?.blur();
            return;
        }
        if (quickFindOpen) {
            wasQuickFindOpen.current = true;
            input?.focus();
            return;
        }
        if (wasQuickFindOpen.current) {
            wasQuickFindOpen.current = false;
            input?.blur();
            return;
        }
        if (!hasAppliedAutoFocus.current && input) {
            hasAppliedAutoFocus.current = true;
            const { activeElement: activeElement } = input.ownerDocument;
            const modalWithFocus = activeElement?.closest('[role="dialog"], [aria-modal="true"]');
            if (!modalWithFocus || activeElement === input) input.focus({
                preventScroll: true
            });
        }
    // Keep the asserted signal from undoing focus during Strict Mode's effect replay.
    }, [
        autoFocusInput,
        inputRef,
        quickFindOpen
    ]);
    const openQuickFind = (0, $cozmU.useCallback)((event)=>{
        if (!quickFindOpen) {
            setQuickFindOpen(true);
            (0, $eYg5X.default)((0, $6h661.QUICK_FIND_OPEN_INTERACTION), event.timeStamp);
            (0, $gXfti.addUFOCustomData)({
                queryLength: localQuery.length
            });
            if (event.type === 'click') fireOnSearchDialogInputClicked();
        }
    }, [
        fireOnSearchDialogInputClicked,
        localQuery.length,
        setQuickFindOpen,
        quickFindOpen
    ]);
    const onKeyDown = (0, $cozmU.useCallback)(async (event)=>{
        // ArrowDown, Enter and Space keys on input should open the dialog so keyboard users can access results.
        if ((event.key === 'ArrowDown' || event.key === 'Enter') && !quickFindOpen) {
            openQuickFind(event);
            return;
        }
        /**
     * Ignore enter key press if a search result is highlighted as we let
     * the keyboard highlight provider handle the event in this case.
     */ const resultHighlighted = getSelectedIndex && getSelectedIndex() !== undefined;
        if (event.key === 'Enter' && !resultHighlighted) {
            /**
       * Prevent IME composition from submitting the search
       */ if (event.nativeEvent.isComposing) {
                event.preventDefault();
                return;
            }
            if (!primaryProduct) return;
            /**
       * Use localQuery instead of quickFind query for keydown events
       * to prevent desync between what's shown in the input and what's
       * actually used in the callback here.
       */ const submitQuery = localQuery;
            /**
       * Stop the event from propagating to prevent UFO
       * VC90 metric from being cancelled on route change.
       */ event.stopPropagation();
            // Store search in recent searches
            if (submitQuery.trim() !== '' && user && user.id && primaryProduct) {
                (0, $fM05T.addRecentSearch)({
                    value: quickFindQuery.trim(),
                    userId: user.id,
                    productId: primaryProduct,
                    key: (0, $fM05T.RECENT_SEARCH_KEY)
                });
                updateRecentQueries?.();
            }
            resetOnSubmit();
            event.currentTarget.blur();
            setQuickFindOpen(false);
            fireCounterfactualIntentDecision({
                query: submitQuery
            });
            trackSearchSubmit({
                query: submitQuery,
                trigger: 'return',
                returnModified: event.metaKey || event.ctrlKey
            });
            // Executing a search query on FPS search will always clear the filters in QF as FPS filters
            // is the source of truth for filter state.
            clearAllFilters();
            (0, $eYg5X.default)((0, $6h661.QUICK_FIND_CLOSE_INTERACTION), event.timeStamp);
            const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
            if (primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira) {
                const ctrlKey = event.metaKey || event.ctrlKey;
                // Intent detection is ongitly enabled if the experiment is enabled
                if (intentRouterEnabled) {
                    // VitalStats: Abort intent detection UX task if user submits search
                    if (isIntentDetectionTaskActive()) abortIntentDetectionTask('search_submitted');
                    const intentDetection = (0, $krr0S.INTENT_DETECTION).value();
                    const url = intentDetection?.route || (0, $5cu3N.getWorkItemPageUrl)({
                        query: submitQuery,
                        jiraFilters: jiraFilters,
                        generateSearchUrl: generateSearchUrl,
                        queryParams: queryParams,
                        isQueryJql: (0, $krr0S.isJqlQueryDetected)(submitQuery)
                    });
                    onNavigateCallback(url, 'push', event);
                    return;
                }
                // Ctrl + Enter
                // On Jira Full Page Search, Ctrl + Enter = Go to NIN
                // On other products, Ctrl + Enter = Go to FPS
                const swapQuickFindCTAs = (0, $eCHsK.isOnJiraFullPageSearch)() && primaryProduct && primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira;
                if (ctrlKey && !swapQuickFindCTAs || !ctrlKey && swapQuickFindCTAs) {
                    onNavigateCallback(generateSearchUrl({
                        ...queryParams,
                        text: submitQuery
                    }, false // This is still Confluence, so won't be a secondary link
                    ), 'push', event);
                    return;
                }
                try {
                    const url = (0, $5cu3N.getWorkItemPageUrl)({
                        query: submitQuery,
                        jiraFilters: jiraFilters,
                        generateSearchUrl: generateSearchUrl,
                        queryParams: queryParams,
                        isQueryJql: (0, $krr0S.isJqlQueryDetected)(submitQuery)
                    });
                    onNavigateCallback(url, 'push', event);
                    return;
                } catch (error) {
                    // If network or runtime errors occcur, follow the default redirection behaviour.
                    logException(error);
                }
            }
            const searchForPrimaryProduct = !selectedProduct && (applicationMode === (0, $2O9Q9.ApplicationModes).Rovo && (event.metaKey || event.ctrlKey) || applicationMode !== (0, $2O9Q9.ApplicationModes).Rovo && !(event.metaKey || event.ctrlKey));
            onNavigateCallback(generateSearchUrl({
                ...queryParams,
                ...searchForPrimaryProduct ? {
                    product: primaryProduct
                } : {},
                text: submitQuery,
                cql: undefined // Clear CQL parameter when performing a regular search
            }, false), 'push', event);
        }
        if (event.key === 'Escape') {
            /**
       * Prevent IME composition from closing the quick find
       */ if (event.nativeEvent.isComposing) {
                event.preventDefault();
                return;
            }
            event.currentTarget.blur();
            setQuickFindOpen(false);
            (0, $eYg5X.default)((0, $6h661.QUICK_FIND_CLOSE_INTERACTION), event.timeStamp);
        }
        // if arrow keys, then update the selected index
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') setSelectedIndex(getSelectedIndex?.());
    }, [
        trackSearchSubmit,
        resetOnSubmit,
        fireCounterfactualIntentDecision,
        getSelectedIndex,
        primaryProduct,
        quickFindQuery,
        localQuery,
        user,
        setQuickFindOpen,
        selectedProduct,
        applicationMode,
        clearAllFilters,
        onNavigate,
        generateSearchUrl,
        queryParams,
        updateRecentQueries,
        jiraFilters,
        logException,
        intentRouterEnabled,
        isIntentDetectionTaskActive,
        abortIntentDetectionTask,
        quickFindOpen,
        openQuickFind
    ]);
    const onChange = (0, $cozmU.useCallback)((event)=>{
        const newQuery = event.currentTarget.value;
        recordQueryChange(event.timeStamp, newQuery.length === 0);
        setLocalQuery(newQuery);
        debouncedOnTextEnteredAnalyticsCallback();
        debouncedPrefetchCallback();
        if (!quickFindOpen) // open quick find when input is focused by quick find is not opened
        openQuickFind(event);
    }, [
        debouncedOnTextEnteredAnalyticsCallback,
        debouncedPrefetchCallback,
        setLocalQuery,
        quickFindOpen,
        openQuickFind,
        recordQueryChange
    ]);
    const onFocus = (0, $cozmU.useCallback)((_event)=>{
    // Don't do anything on focus
    }, []);
    const Textfield = textfieldComponent || (0, $54yUd.Textfield);
    const [cloudId] = (0, $32Eau.useCloudId)();
    const [orgId] = (0, $32Eau.useOrgId)();
    const { chatIntentDetectionEnabled: chatIntentDetectionEnabled } = (0, $iHg8v.serveChatConvergenceExperiment)(primaryProduct);
    const smartLinkUsage = (0, $32Eau.useSmartLinkUsage)();
    const defaultTextfieldProps = textfieldComponent ? {} : {
        filterPresentation: filterPresentation
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Textfield, {
        value: localQuery,
        dialogId: dialogId,
        inputRef: inputRef,
        quickFindOpen: quickFindOpen,
        isNav4Enabled: isNav4Enabled,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        intentRouterEnabled: intentRouterEnabled,
        chatIntentDetectionEnabled: chatIntentDetectionEnabled,
        unifiedSurface: (0, $cJff5.serveQuickFindInstantSearch)(primaryProduct),
        activeDescendantId: activeDescendantId,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onChange: onChange,
        onClick: openQuickFind,
        onClear: ()=>{
            resetOnClear();
            fireOnQuickFindClearButtonClicked();
            cancelDebouncedPrefetchCallback();
            // Abort task if active when user clicks clear button
            // Note: We don't wrap in startTransition here because abortTask needs to
            // update state synchronously to prevent race conditions with new queries
            if (isTaskActive()) abortTask('text_cleared');
            // VitalStats: Abort intent detection UX task if user clears text
            if (isIntentDetectionTaskActive()) abortIntentDetectionTask('text_cleared');
            setLocalQuery('');
            inputRef?.current?.focus();
        },
        onAppsClick: fireOnQuickFindConnectAppsPillClicked,
        placeholder: existingGhostTextData?.text,
        cloudId: cloudId,
        accountId: user.id ?? undefined,
        orgId: orgId,
        primaryProduct: primaryProduct,
        smartLinkUsage: smartLinkUsage,
        thirdPartyConfigs: thirdPartyConfigs,
        ...defaultTextfieldProps
    });
};

















const $e1110ebedadd6968$export$de1e7dc8982a7dbb = (generateSearchUrl)=>{
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const rovoJourneyId = (0, $5lH3O.useRovoJourneyId)();
    const shouldIncludeRovoJourneyId = (0, $hnDqW.isRovoJourneyIdEnabled)(primaryProduct);
    return (0, $cozmU.useMemo)(()=>{
        if (!shouldIncludeRovoJourneyId) return generateSearchUrl;
        return (urlQueryParams, ...rest)=>(generateSearchUrl ?? (0, $gQNge.defaultGenerateSearchUrl))({
                ...urlQueryParams,
                rovoJourneyId: rovoJourneyId
            }, ...rest);
    }, [
        generateSearchUrl,
        rovoJourneyId,
        shouldIncludeRovoJourneyId
    ]);
};














const $b0d288d9334249b5$export$57669d07df76513 = (initialQuery)=>{
    const [localQuery, setLocalQueryState] = (0, $cozmU.useState)(initialQuery);
    const localQueryRef = (0, $cozmU.useRef)(localQuery);
    localQueryRef.current = localQuery;
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const { refreshRovoJourneyId: refreshRovoJourneyId } = (0, $5lH3O.useQuickFindActions)();
    const journeyContextRef = (0, $cozmU.useRef)({
        primaryProduct: primaryProduct,
        refreshRovoJourneyId: refreshRovoJourneyId
    });
    journeyContextRef.current = {
        primaryProduct: primaryProduct,
        refreshRovoJourneyId: refreshRovoJourneyId
    };
    const setLocalQuery = (0, $cozmU.useCallback)((value)=>{
        if (!(0, $hnDqW.isRovoJourneyIdEnabled)(journeyContextRef.current.primaryProduct)) {
            setLocalQueryState(value);
            return;
        }
        const previousQuery = localQueryRef.current;
        const nextQuery = typeof value === 'function' ? value(previousQuery) : value;
        localQueryRef.current = nextQuery;
        if (previousQuery.trim().length > 0 && nextQuery.trim().length === 0) journeyContextRef.current.refreshRovoJourneyId();
        setLocalQueryState(nextQuery);
    }, []);
    return [
        localQuery,
        setLocalQuery
    ];
};






















var $imdMF = parcelRequire("imdMF");





var $8nTVT = parcelRequire("8nTVT");

/**
 * @generated
 * This file is generated by scripts/generate-async-query-metadata.js.
 * Do not edit manually.
 * Source: src/ui/search-page-relay/right-panel/__generated__/rightPanelAsyncQuery.graphql.ts
 */ const $0521ca45b351232d$export$b93f8325f362c8e2 = '1b285bd9c0f69f12205ff3d82a67734a98f412f776d2ff17f7329d17ee089ec0';
const $0521ca45b351232d$export$d879c693c9d5dd1d = 'rightPanelAsyncQuery';


/**
 * @generated
 * This file is generated by scripts/generate-async-query-metadata.js.
 * Do not edit manually.
 * Source: src/ui/search-page-relay/search-results/__generated__/searchResultsAsyncQuery.graphql.ts
 */ const $2445f62ca69a36bb$export$d2f5eaa391338206 = 'a93928dc028dbabb04e6259f617882b26db0c5bd15b6fc871455052cfb22e4ec';
const $2445f62ca69a36bb$export$ba2c557d27f18b1d = 'searchResultsAsyncQuery';



var $9oZuK = parcelRequire("9oZuK");





var $23j2F = parcelRequire("23j2F");





var $7KnRQ = parcelRequire("7KnRQ");

/*
 * Not required: all callbacks happen after the fetch.
 */ const $72e197b4b897baec$var$noopCallbacks = {
    setIntentData: ()=>{},
    setQueryIntent: ()=>{},
    setTransformedQuery: ()=>{},
    setRequestId: ()=>{},
    setTraceId: ()=>{}
};
const $72e197b4b897baec$export$840abf07587d206 = (args)=>{
    (0, $7KnRQ.getQueryIntent)({
        ...args,
        ...$72e197b4b897baec$var$noopCallbacks
    });
};





const $b297ad4f219f6f1f$export$d1be7f2304606f8e = ({ persistedId: persistedId, operationName: operationName, queryVariables: queryVariables, edgeRegionHint: edgeRegionHint, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    return fetch(`${aggAbsoluteUrl}/pq/${persistedId}?operation=${operationName}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...edgeRegionHint ? {
                [(0, $fnx12.EDGE_REGION_HINT_HEADER)]: edgeRegionHint
            } : {}
        },
        body: JSON.stringify({
            operationName: operationName,
            variables: queryVariables
        })
    }).then(()=>undefined).catch(()=>{
    // Swallow — warm-up is best-effort.
    });
};


const $0b3cea8008424799$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
/**
 * A small fraction of WebKit-based browsers (desktop Safari, iOS Safari/Chrome/Edge)
 * report `Event.timeStamp` as wall-clock epoch time rather than a
 * `performance.now()`-relative `DOMHighResTimeStamp`, in violation of the spec —
 * confirmed in production by `preloadNavigateAt` values landing near `Date.now()`
 * (~10^12) instead of a small offset. A genuine timestamp for an event that
 * already fired can never be later than `performance.now()` right now, so
 * anything past that bound is discarded here rather than reported as a
 * corrupted UFO mark downstream.
 */ function $0b3cea8008424799$var$isPlausiblePerformanceTimestamp(value) {
    return typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= performance.now();
}
const $0b3cea8008424799$export$fde16a5fe64932bd = ()=>{
    const [user] = (0, $32Eau.useUser)();
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const [cloudId] = (0, $32Eau.useCloudId)();
    const [aggAbsoluteUrl] = (0, $32Eau.useAggAbsoluteUrl)();
    const [thirdPartyConfigs] = (0, $32Eau.useThirdPartyConfigs)();
    const unitMetadata = (0, $32Eau.useUnitMetadata)();
    const [productDataRegions] = (0, $32Eau.useProductDataRegions)();
    const [isJiraIssueIndexed] = (0, $32Eau.useIsJiraIssueIndexed)();
    const [experimentLayers] = (0, $32Eau.useExperimentLayers)();
    const [features] = (0, $32Eau.useFeatures)();
    const products = (0, $32Eau.useAvailableProducts)();
    const [productEdition] = (0, $32Eau.useProductEdition)();
    const logError = (0, $2csHQ.useLogException)();
    // SAIN intent-detection preload deps (only consumed when the FG is on at
    // invocation time).
    const [{ analyticsAttributes: analyticsAttributes, orgId: orgId }] = (0, $32Eau.useBootstrap)();
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const depsRef = (0, $cozmU.useRef)({
        aggAbsoluteUrl: aggAbsoluteUrl,
        cloudId: cloudId,
        experimentLayers: experimentLayers,
        isLiteMode: features?.lite?.enabled ?? false,
        isJiraIssueIndexed: isJiraIssueIndexed,
        logError: logError,
        primaryProduct: primaryProduct,
        productDataRegions: productDataRegions,
        productEdition: productEdition,
        products: products,
        thirdPartyConfigs: thirdPartyConfigs,
        unitMetadata: unitMetadata,
        user: user,
        activationId: analyticsAttributes?.activationId,
        orgId: orgId,
        locale: locale
    });
    (0, $cozmU.useEffect)(()=>{
        depsRef.current = {
            aggAbsoluteUrl: aggAbsoluteUrl,
            cloudId: cloudId,
            experimentLayers: experimentLayers,
            isLiteMode: features?.lite?.enabled ?? false,
            isJiraIssueIndexed: isJiraIssueIndexed,
            logError: logError,
            primaryProduct: primaryProduct,
            productDataRegions: productDataRegions,
            productEdition: productEdition,
            products: products,
            thirdPartyConfigs: thirdPartyConfigs,
            unitMetadata: unitMetadata,
            user: user,
            activationId: analyticsAttributes?.activationId,
            orgId: orgId,
            locale: locale
        };
    });
    return (0, $cozmU.useCallback)((url, navigateAt)=>{
        const deps = depsRef.current;
        const identity = (0, $9oZuK.createQueryBootstrapSnapshotIdentity)({
            cloudId: deps.cloudId
        });
        if (identity) (0, $9oZuK.prepareQueryBootstrapSnapshotForTransition)(identity);
        // Required pieces — bail out silently if bootstrap hasn't populated them yet.
        if (!deps.primaryProduct || !deps.cloudId) return;
        const searchSessionId = crypto.randomUUID();
        const sessionId = (0, $bQ6i3.getSessionIdFromLocalStorage)();
        // Parse query params from the destination URL — the URL is the source
        // of truth for what the search page will render.
        let queryParams = {};
        try {
            const parsed = new URL(url, window.location.origin);
            queryParams = Object.fromEntries(parsed.searchParams);
        } catch  {
            // Malformed URL — abort warm-up.
            return;
        }
        let searchInputs;
        try {
            searchInputs = (0, $8nTVT.generateSearchInputs)({
                backendExperimentOverrides: [],
                cloudId: deps.cloudId,
                experimentLayers: deps.experimentLayers,
                experience: (0, $imdMF.SEARCH_PAGE),
                useCaseId: (0, $iKybC.SEARCH_USE_CASE_IDS).SEARCH_PAGE,
                isJiraIssueIndexed: deps.isJiraIssueIndexed,
                jsmIncidentFilterIds: [],
                primaryProduct: deps.primaryProduct,
                productDataRegions: deps.productDataRegions || {},
                productEdition: deps.productEdition || {},
                products: deps.products,
                queryParams: queryParams,
                searchSessionId: searchSessionId,
                sessionId: sessionId,
                thirdPartyConfigs: deps.thirdPartyConfigs,
                unitMetadata: deps.unitMetadata,
                user: deps.user,
                expectResult: false,
                onError: deps.logError,
                // Forward lite mode so the prewarmed searchResults query matches the
                // variant the search page fires on mount. Omitting it defaults to
                // `false`, which drifts `includeJiraLiteModeFields` from the SPA's
                // `true` and silently misses the persisted-query cache on the lite
                // (test) cohort — inflating the searchResultsAsyncQuery network fetch.
                isLiteMode: deps.isLiteMode
            });
        } catch  {
            // generateSearchInputs threw — abort warm-up silently.
            return;
        }
        const edgeRegionHint = deps.primaryProduct && deps.productDataRegions ? (0, $fnx12.getEdgeRegionHint)(deps.primaryProduct, deps.productDataRegions) : undefined;
        const searchResultsQueryVariables = {
            ...searchInputs.searchResultsQueryVariables,
            ...searchInputs.searchResultsQueryRelayProvidedVariables
        };
        // Stamped immediately before the fetch is issued, so the search page can
        // measure how long the user waited before the warm-up left the browser.
        const timings = {
            navigateAt: $0b3cea8008424799$var$isPlausiblePerformanceTimestamp(navigateAt) ? navigateAt : undefined,
            preloadStartAt: performance.now()
        };
        // Fire-and-forget — both fetches.
        (0, $b297ad4f219f6f1f$export$d1be7f2304606f8e)({
            persistedId: (0, $2445f62ca69a36bb$export$d2f5eaa391338206),
            operationName: (0, $2445f62ca69a36bb$export$ba2c557d27f18b1d),
            queryVariables: searchResultsQueryVariables,
            edgeRegionHint: edgeRegionHint,
            aggAbsoluteUrl: deps.aggAbsoluteUrl || $0b3cea8008424799$var$DEFAULT_GRAPHQL_ENDPOINT
        });
        // Multi-site counts are unavailable, and lite mode does not render the right panel.
        const skipMultiSiteCounts = searchInputs.rightPanelQueryVariables.cloudIdARIs.length > 1;
        if (!deps.isLiteMode && !skipMultiSiteCounts) (0, $b297ad4f219f6f1f$export$d1be7f2304606f8e)({
            persistedId: (0, $0521ca45b351232d$export$b93f8325f362c8e2),
            operationName: (0, $0521ca45b351232d$export$d879c693c9d5dd1d),
            queryVariables: searchInputs.rightPanelQueryVariables,
            edgeRegionHint: edgeRegionHint,
            aggAbsoluteUrl: deps.aggAbsoluteUrl || $0b3cea8008424799$var$DEFAULT_GRAPHQL_ENDPOINT
        });
        // SAIN intent-detection preload
        // Fires `getQueryIntent` early from the warm-up, supported by the request cache inside search-ai
        const rawSearchText = queryParams.text;
        const searchTextFromUrl = typeof rawSearchText === 'string' ? rawSearchText : '';
        if (searchTextFromUrl && // Skip preload when `kd_recent_activity_intent` is on. The FG is being unlaunched (false path kept).
        !(0, $iDrrr.fg)('kd_recent_activity_intent') && (0, $iDrrr.fg)('rovo_fps_preload_sain_intent_from_quick_find')) (0, $72e197b4b897baec$export$840abf07587d206)({
            ...(0, $23j2F.buildIntentDetectionVariables)({
                cloudId: deps.cloudId,
                primaryProduct: deps.primaryProduct,
                activationId: deps.activationId,
                locale: deps.locale,
                orgId: deps.orgId,
                query: searchTextFromUrl
            }),
            onError: deps.logError
        });
        const preloadData = {
            cloudId: deps.cloudId,
            config: null,
            isConfigFromCache: undefined,
            configFailReason: undefined,
            cacheFailReason: undefined,
            search: {
                queryVariables: searchResultsQueryVariables,
                generated: {
                    sessionId: sessionId,
                    searchSessionId: searchSessionId
                },
                steeringHeader: edgeRegionHint ? `${0, $fnx12.EDGE_REGION_HINT_HEADER}: ${edgeRegionHint}` : undefined,
                timings: timings
            },
            rightPanel: {
                queryVariables: searchInputs.rightPanelQueryVariables,
                generated: {
                    sessionId: sessionId,
                    searchSessionId: searchSessionId
                },
                steeringHeader: edgeRegionHint ? `${0, $fnx12.EDGE_REGION_HINT_HEADER}: ${edgeRegionHint}` : undefined
            },
            source: 'quick-find'
        };
        try {
            window.__PRELOADED_SEARCH__ = preloadData;
        } catch  {
        // window may be unavailable in unusual environments.
        }
    }, []);
};


const $e582a4f413c76123$export$86c95f2dee1a5a72 = (originalOnNavigate, generateSearchUrl)=>{
    const warmUp = (0, $0b3cea8008424799$export$fde16a5fe64932bd)();
    return (0, $cozmU.useMemo)(()=>{
        // Return original by identity when there is no navigation handler to wrap.
        if (!originalOnNavigate) return originalOnNavigate;
        const original = originalOnNavigate;
        const wrappedCallback = (url, action, event)=>{
            // Only warm up when we definitively know we're NOT already on the
            // search page AND the destination is the search page itself. For
            // `isOnSearchRoute`, both `true` (already there) and `undefined`
            // (couldn't tell) skip warm-up.
            if (generateSearchUrl && (0, $6d0b2e4ae28c8d0a$export$2811a6cefe42670b)(generateSearchUrl) === false && (0, $6d0b2e4ae28c8d0a$export$98262e13018313b)(url, generateSearchUrl) === true) // `event.timeStamp` anchors preload timings to the originating user
            // action (e.g. the Enter keypress) rather than to this callback, so
            // the measurement includes the work the key handler does before
            // navigating. It shares `performance.now()`'s time origin.
            warmUp(url, event?.timeStamp);
            return typeof original === 'function' ? original(url, action, event) : original.callback(url, action, event);
        };
        return typeof original === 'function' ? wrappedCallback : {
            callback: wrappedCallback,
            options: original.options
        };
    }, [
        originalOnNavigate,
        generateSearchUrl,
        warmUp
    ]);
};






var $cbY7C = parcelRequire("cbY7C");

function $55b5cb22ee758be3$var$mapToInteractionType(eventType) {
    if (eventType === 'click' || eventType === 'dblclick' || eventType === 'mousedown') return 'press';
    if (eventType === 'mouseenter' || eventType === 'mouseover') return 'hover';
    return undefined;
}
var $55b5cb22ee758be3$export$2e2bcd8739ae039 = $55b5cb22ee758be3$var$mapToInteractionType;



var $2j5oi = parcelRequire("2j5oi");

/**
 * *Warning* Currently this only supports the events with the following types
 * ```ts
 * 'click' | 'dblclick' | 'mousedown' | 'mouseenter' | 'mouseover'
 * ```
 */ function $1f40035b0c546597$var$traceUFOInteraction(name, event) {
    if (!event || !event.isTrusted) return;
    const interactionType = (0, $55b5cb22ee758be3$export$2e2bcd8739ae039)(event.type);
    if (!interactionType) // when interactionType is falsy we do not yet support this type of event. should we blow up with throwing error instead?
    return;
    return (0, $2j5oi.default)(name, interactionType, event.timeStamp);
}
var $1f40035b0c546597$export$2e2bcd8739ae039 = $1f40035b0c546597$var$traceUFOInteraction;











const $c1998e35278f3774$var$isClickInRelatedLinkModalBlanket = (targetNode)=>{
    if (!targetNode) return false;
    const relatedLinksModal = document.querySelector('[data-testid="related-links-modal"]');
    const relatedLinkModalBlanket = document.querySelector('[data-testid="related-links-modal--blanket"]');
    const isInRelatedLinksModal = relatedLinksModal ? relatedLinksModal.contains(targetNode) : false;
    const isInRelatedLinkModalBlanket = relatedLinkModalBlanket ? relatedLinkModalBlanket.contains(targetNode) : false;
    return isInRelatedLinksModal || isInRelatedLinkModalBlanket;
};
const $c1998e35278f3774$export$92dae2778ae88f9d = ({ dialogRef: dialogRef, inputBoxRef: inputBoxRef })=>{
    const mouseDownInside = (0, $cozmU.useRef)(false);
    const quickFindOpen = (0, $5lH3O.useQuickFindOpen)();
    const [isFeedbackModalOpen] = (0, $5lH3O.useIsFeedbackModalOpen)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $5lH3O.useQuickFindActions)();
    (0, $cozmU.useEffect)(()=>{
        const onMouseDown = (event)=>{
            mouseDownInside.current = false;
            const { target: target } = event;
            const targetNode = target;
            const isClickOnPopup = dialogRef.current && dialogRef.current.contains(targetNode);
            const isClickOnTrigger = inputBoxRef.current && inputBoxRef.current.contains(targetNode);
            if (isClickOnPopup || isClickOnTrigger) mouseDownInside.current = true;
        };
        const onClick = (event)=>{
            const { target: target } = event;
            const targetNode = target;
            if (isFeedbackModalOpen) return;
            if ($c1998e35278f3774$var$isClickInRelatedLinkModalBlanket(targetNode)) return;
            // Prevent QuickFind from closing when clicking inside the Rovo settings
            // modal or its blanket overlay.
            if (targetNode instanceof Element && (targetNode.closest('[data-testid="rovo-settings-modal"]') || targetNode.closest('[data-testid="rovo-settings-modal--blanket"]'))) return;
            const isClickOnPopup = dialogRef.current && dialogRef.current.contains(targetNode);
            const isClickOnTrigger = inputBoxRef.current && inputBoxRef.current.contains(targetNode);
            if (!isClickOnPopup && !isClickOnTrigger && !mouseDownInside.current) {
                setQuickFindOpen(false);
                if (quickFindOpen) (0, $1f40035b0c546597$export$2e2bcd8739ae039)((0, $6h661.QUICK_FIND_CLOSE_INTERACTION), event);
            }
        };
        const onKeyDown = (event)=>{
            const { key: key } = event;
            if (key === 'Escape' || key === 'Esc') {
                setQuickFindOpen(false);
                if (quickFindOpen) (0, $1f40035b0c546597$export$2e2bcd8739ae039)((0, $6h661.QUICK_FIND_CLOSE_INTERACTION), event);
            }
        };
        const onBlur = ()=>{
            const activeElement = document.activeElement;
            const activeElementIsIFrame = activeElement instanceof HTMLIFrameElement;
            // Close Quick Find if the new active element is an iframe, we need
            // to do this check since click events are not fired on iframes
            if (activeElementIsIFrame) {
                setQuickFindOpen(false);
                if (quickFindOpen) (0, $eYg5X.default)((0, $6h661.QUICK_FIND_CLOSE_INTERACTION), performance.now());
            }
        };
        const unbind = (0, $cbY7C.bindAll)(window, [
            {
                type: 'mousedown',
                listener: onMouseDown,
                options: {
                    capture: false
                }
            },
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: true // Closes the dialog before SPA transitions
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'blur',
                listener: onBlur
            }
        ]);
        return ()=>{
            unbind();
        };
    }, [
        setQuickFindOpen,
        isFeedbackModalOpen,
        quickFindOpen,
        dialogRef,
        inputBoxRef
    ]);
};











const $4fce6431adc4175e$export$24139682747f5c4 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'dwelled',
        actionSubject: 'searchResults',
        actionSubjectId: 'preQuerySearchResults',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });





function $fb5c91811c0afed8$export$632123ff591ac565({ onTimerEnd: onTimerEnd }) {
    const [timer, setTimer] = (0, $cozmU.useState)({
        status: 'idle'
    });
    const start = (0, $cozmU.useCallback)(()=>{
        setTimer((state)=>{
            if (state.status !== 'idle') return state;
            return {
                ...state,
                startTime: new Date(),
                status: 'running'
            };
        });
    }, []);
    const stop = (0, $cozmU.useCallback)(()=>{
        setTimer((state)=>{
            if (state.status !== 'running') return state;
            const end = new Date().getTime() - (timer.startTime?.getTime() ?? 0);
            onTimerEnd?.(end);
            return {
                ...state,
                endTime: new Date(),
                milliseconds: end,
                status: 'finished'
            };
        });
    }, [
        onTimerEnd,
        timer.startTime
    ]);
    const cancel = (0, $cozmU.useCallback)(()=>{
        setTimer((state)=>{
            if (state.status !== 'running') return state;
            return {
                ...state,
                status: 'cancelled'
            };
        });
    }, []);
    return {
        start: start,
        stop: stop,
        cancel: cancel,
        status: timer.status,
        milliseconds: timer.milliseconds
    };
}








const $4a391a476a4a6642$export$20260e4d2b6c9d50 = ()=>{
    const { queryParams: queryParams } = (0, $c11PZ.useAppContext)();
    const quickFindOpen = (0, $5lH3O.useQuickFindOpen)();
    const quickFindQuery = (0, $5lH3O.useQuickFindQuery)();
    const hadInitialQuery = (0, $cozmU.useRef)(Boolean((0, $8BkJa.getInitialQuery)() || queryParams.text));
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $68JhS.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $68JhS.useQuickFindAttributes)();
    const { start: startTimer, stop: stopTimer, cancel: cancelTimer } = (0, $fb5c91811c0afed8$export$632123ff591ac565)({
        onTimerEnd: (ms)=>fireAnalyticsEvent((0, $4fce6431adc4175e$export$24139682747f5c4)({
                attributes: {
                    ...commonAttributes,
                    duration: ms
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }))
    });
    // Analytics to track the first transition from pre-query to post-query
    (0, $cozmU.useEffect)(()=>{
        // Do nothing if the page loaded with a query
        if (hadInitialQuery.current) return;
        // Start the timer when the dialog is opened
        if (quickFindOpen) startTimer();
        // Cancel the timer when the dialog is closed
        if (!quickFindOpen) cancelTimer(); // no-ops if the timer hasn't started or has already finished
        // Stop the timer when the user starts typing
        if (quickFindQuery) stopTimer();
    }, [
        cancelTimer,
        quickFindOpen,
        quickFindQuery,
        startTimer,
        stopTimer
    ]);
};





function $f78c8c4511fd49ed$export$29d6913fc893cfe8(stateA, setStateA, stateB, setStateB) {
    const prevA = (0, $cozmU.useRef)();
    const prevB = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        // Do nothing if any of the arguments are undefined
        if (stateA === undefined || setStateA === undefined || stateB === undefined || setStateB === undefined) return;
        // On mount, use stateA as the source of truth
        if (prevA.current === undefined && prevB.current === undefined) {
            prevA.current = stateA;
            prevB.current = stateA;
            setStateB(stateA);
            return;
        }
        // If updates to both states are updated to the same value in the
        // same render cycle, ensure previous values are updated
        if (stateA === stateB) {
            prevA.current = stateA;
            prevB.current = stateB;
            return;
        }
        // If stateA has changed, update stateB to match
        if (prevA.current !== stateA) {
            prevA.current = stateA;
            prevB.current = stateA;
            setStateB(stateA);
            // Exit here as only one state should be updated, otherwise an infinite
            // loop will occur. This means that stateA takes precedence if both
            // states are changed in the same render cycle.
            return;
        }
        // If stateB has changed, update stateA to match
        if (prevB.current !== stateB) {
            prevA.current = stateB;
            prevB.current = stateB;
            setStateA(stateB);
        }
    }, [
        setStateA,
        setStateB,
        stateA,
        stateB
    ]);
}


const $8ecc21febbc529aa$var$textFieldBoxStyles = (0, $buxP3.xcss)({
    width: '100%',
    position: 'relative'
});
const $8ecc21febbc529aa$var$minWidthStyles = (0, $buxP3.xcss)({
    left: '50%',
    transform: 'translate(-50%, 0)',
    // Anchor Quick Find input and dialog to the center of the viewport
    position: 'fixed',
    maxWidth: '780px',
    // To retain the same width as Quick Search
    zIndex: 'navigation',
    [(0, $gnKXs.media).above.lg]: {
        maxWidth: 'unset',
        position: 'relative'
    }
});
const $8ecc21febbc529aa$var$QuickFindComponent = ({ open: open, setOpen: setOpen, postQueryDisabled: postQueryDisabled, textfieldComponent: textfieldComponent, isSSR: isSSR, PlacementPO: PlacementPO, showFilters: showFilters = true, showFiltersRow: showFiltersRow = false, searchRefreshStyling: searchRefreshStyling = false, customPlaceholder: customPlaceholder, onGhostTextGenerated: onGhostTextGenerated, inputRef: inputRef, autoFocusInput: autoFocusInput = false, preQueryContent: preQueryContent, onPrefetch: onPrefetch, externalInput: externalInput, hideBanners: hideBanners })=>{
    const inputBoxRef = (0, $cozmU.useRef)(null);
    const dialogRef = (0, $cozmU.useRef)(null);
    const { isNav4Enabled: isNav4Enabled, queryParams: queryParams } = (0, $c11PZ.useAppContext)();
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const [cloudId] = (0, $32Eau.useCloudId)();
    const applicationMode = (0, $32Eau.useApplicationMode)();
    const internalInputRef = (0, $cozmU.useRef)(null);
    const effectiveInputRef = inputRef || internalInputRef;
    const intl = (0, $kSwu1.useIntl)();
    const intentRouterEnabled = (0, $cozmU.useMemo)(()=>(0, $535ZC.serveJiraNINFpsNLQNavigation)({
            primaryProduct: primaryProduct,
            fireLayerExposure: false,
            // Exposure is fired when a user calls the intent detection API
            locale: intl.locale
        })?.cohort === 'test', [
        primaryProduct,
        intl.locale
    ]);
    const isExternalInput = !!externalInput && (0, $iDrrr.fg)('rovo_fps_quick_find_external_input');
    const externalContainerRef = isExternalInput ? externalInput?.containerRef : undefined;
    const externalQuery = isExternalInput ? externalInput?.query : undefined;
    const onExternalQueryChange = isExternalInput ? externalInput?.onQueryChange : undefined;
    // Hosts can supply external-input props before the runtime gate enables that mode.
    // Preserve the existing dialog styling until the external-input path is active.
    const effectiveSearchRefreshStyling = externalInput && !(0, $iDrrr.fg)('rovo_fps_quick_find_external_input') ? false : searchRefreshStyling;
    const [localQuery, setLocalQueryState] = (0, $b0d288d9334249b5$export$57669d07df76513)(()=>externalQuery !== undefined ? externalQuery : (0, $8BkJa.getInitialQuery)(typeof queryParams.text === 'string' && queryParams.text || ''));
    const counterfactualIntentDetectionEnabled = primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Confluence && (0, $hnDqW.isRovoJourneyIdEnabled)(primaryProduct) && !(0, $iHg8v.serveChatConvergenceExperiment)(primaryProduct).chatIntentDetectionEnabled;
    const counterfactualIntentResult = (0, $ja2HH.useInputIntent)({
        input: counterfactualIntentDetectionEnabled ? localQuery : '',
        context: {
            cloudId: cloudId,
            locale: intl.locale,
            primaryProduct: counterfactualIntentDetectionEnabled ? (0, $3Ydx7.PrimaryProductKeys).Confluence : undefined
        }
    });
    const counterfactualIntentDetection = counterfactualIntentDetectionEnabled ? counterfactualIntentResult : undefined;
    // The host owns the input in external-input mode, so mirror its query into local state.
    (0, $cozmU.useEffect)(()=>{
        if (externalQuery !== undefined) setLocalQueryState(externalQuery);
    }, [
        externalQuery,
        setLocalQueryState
    ]);
    const localQueryRef = (0, $cozmU.useRef)(localQuery);
    localQueryRef.current = localQuery;
    const setLocalQuery = (0, $cozmU.useCallback)((value)=>{
        setLocalQueryState(value);
        onExternalQueryChange?.(typeof value === 'function' ? value(localQueryRef.current) : value);
    }, [
        setLocalQueryState,
        onExternalQueryChange
    ]);
    const { setQuickFindOpen: setQuickFindOpen } = (0, $5lH3O.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $68JhS.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $68JhS.useQuickFindAttributes)();
    const quickFindOpen = (0, $5lH3O.useQuickFindOpen)();
    const generatedDialogId = (0, $cozmU.useId)();
    const dialogId = isExternalInput ? externalInput.dialogId ?? generatedDialogId : generatedDialogId;
    const [filtersExpanded, setFiltersExpanded] = (0, $cozmU.useState)(false);
    const expandableFiltersEnabled = (0, $cozmU.useMemo)(()=>showFilters && applicationMode === (0, $2O9Q9.ApplicationModes).Rovo && !textfieldComponent && !isExternalInput && (0, $iHg8v.serveChatConvergenceExperiment)(primaryProduct).chatIntentDetectionEnabled, [
        applicationMode,
        isExternalInput,
        primaryProduct,
        showFilters,
        textfieldComponent
    ]);
    const filterPresentation = (0, $cozmU.useMemo)(()=>expandableFiltersEnabled ? {
            regionId: `${dialogId}-filters`,
            isExpanded: filtersExpanded,
            onToggle: ()=>{
                const isExpanded = !filtersExpanded;
                fireAnalyticsEvent((0, $7471834b36d88f18$export$94e76cb7fb4eb6e7)({
                    attributes: commonAttributes,
                    isExpanded: isExpanded,
                    nonPrivacySafeAttributes: nonPrivacySafeAttributes
                }));
                setFiltersExpanded(isExpanded);
            }
        } : undefined, [
        commonAttributes,
        dialogId,
        expandableFiltersEnabled,
        filtersExpanded,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes
    ]);
    const setMinWidthStyles = isNav4Enabled && !textfieldComponent && // min-width styles is only supported with the default text field
    !externalContainerRef && quickFindOpen;
    // The first state pair is the source of truth on mount. The host owns the open state in
    // external-input mode, so let it seed the store; otherwise the store seeds the host as before.
    const [syncSourceOpen, setSyncSourceOpen, syncTargetOpen, setSyncTargetOpen] = isExternalInput ? [
        open,
        setOpen,
        quickFindOpen,
        setQuickFindOpen
    ] : [
        quickFindOpen,
        setQuickFindOpen,
        open,
        setOpen
    ];
    (0, $f78c8c4511fd49ed$export$29d6913fc893cfe8)(syncSourceOpen, setSyncSourceOpen, syncTargetOpen, setSyncTargetOpen);
    (0, $c1998e35278f3774$export$92dae2778ae88f9d)({
        dialogRef: dialogRef,
        inputBoxRef: externalContainerRef ?? inputBoxRef
    });
    (0, $4a391a476a4a6642$export$20260e4d2b6c9d50)();
    // Dispose intent detection state when QuickFind unmounts.
    (0, $476cb45229544790$export$9310e79b116dbbca)();
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const handleOpenLayerObserverCloseSignal = (0, $cozmU.useCallback)(()=>{
        if (!isFhsEnabled) return;
        setQuickFindOpen(false);
    }, [
        isFhsEnabled,
        setQuickFindOpen
    ]);
    /**
   * We need to notify the open layer observer when the quick find dialog is open.
   * This is required for several navigation-system features to work correctly, such as:
   * - Closing layers when the user resizes a layout slot (e.g. SideNav, Panel)
   * - Ensuring correct layer stacking order when a popup is open within the TopNav or SideNav
   *
   * Ideally, the dialog would be using the ADS Popup component instead, which handles this internally
   * among other benefits.
   */ (0, $5Tdig.useNotifyOpenLayerObserver)({
        isOpen: isFhsEnabled && quickFindOpen,
        type: 'popup',
        onClose: handleOpenLayerObserverCloseSignal
    });
    const isPOBannerPlacementforQFEnabled = !hideBanners && (0, $cJff5.serveQF3PBannerExperimentWithoutExposure)();
    const [isInteracted, setIsInteracted] = (0, $cozmU.useState)(false);
    const isBannerPlacementReady = isInteracted || !!externalContainerRef && quickFindOpen;
    const onMouseEnter = (0, $cozmU.useCallback)(()=>setIsInteracted(true), []);
    const onFocus = (0, $cozmU.useCallback)(()=>setIsInteracted(true), []);
    (0, $3e179a8629268861$export$8454b21541ff9c9b)(isInteracted || !!externalContainerRef);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4796b598495fba64$export$da9d0159e5272189), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $8ecc21febbc529aa$var$textFieldBoxStyles,
            setMinWidthStyles && $8ecc21febbc529aa$var$minWidthStyles
        ],
        ref: inputBoxRef,
        onMouseEnter: onMouseEnter,
        onFocus: onFocus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $89906.KeyboardHighlightProvider), {
        ref: isExternalInput ? externalInput?.keyboardHighlightRef : undefined,
        onSelectedElementChange: isExternalInput ? externalInput?.onActiveDescendantChange : undefined,
        listenerNode: externalContainerRef ? externalContainerRef.current : effectiveInputRef?.current
    }, externalContainerRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $11aef5215e825422$export$a6dc0a1a1a8532e), {
        localQuery: localQuery,
        postQueryDisabled: postQueryDisabled,
        analyticsRef: externalInput?.analyticsRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a4d54046c757631f$export$fb8d8fbc0c4c1705), {
        dialogId: dialogId,
        inputRef: effectiveInputRef,
        localQuery: localQuery,
        setLocalQuery: setLocalQuery,
        textfieldComponent: textfieldComponent,
        postQueryDisabled: postQueryDisabled,
        customPlaceholder: customPlaceholder,
        onGhostTextGenerated: onGhostTextGenerated,
        intentRouterEnabled: intentRouterEnabled,
        filterPresentation: filterPresentation,
        onPrefetch: onPrefetch,
        counterfactualIntentDetection: counterfactualIntentDetection,
        autoFocusInput: autoFocusInput
    }), !isSSR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, quickFindOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $emZZY.WidthObserverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4f63a9f3639108f7$export$8fecb6bd50f97bd1), {
        dialogId: dialogId,
        dialogRef: dialogRef,
        inputRef: externalContainerRef ? undefined : effectiveInputRef,
        localQuery: localQuery,
        setLocalQuery: setLocalQuery,
        PlacementPO: PlacementPO,
        showFilters: showFilters,
        filterPresentation: filterPresentation,
        searchRefreshStyling: effectiveSearchRefreshStyling,
        preQueryContent: preQueryContent,
        isExternalInput: isExternalInput,
        externalInputTopOffset: isExternalInput ? externalInput?.topOffset : undefined,
        hideBanners: hideBanners,
        counterfactualIntentDetection: counterfactualIntentDetection
    }))), showFiltersRow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6874b45aa369dfc$export$876f25caa2b82f74), null))));
    if (isPOBannerPlacementforQFEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ce89b0c45ce9e88$export$6f38235f6fa1e5b1), {
        isInteracted: isBannerPlacementReady
    }, content);
    return content;
};
const $8ecc21febbc529aa$export$68bbc91d7879f9e4 = ({ children: children, queryParams: actualQueryParams, callbacks: callbacks, ...props })=>{
    const { onSearchCompleted: onSearchCompleted } = callbacks ?? {};
    const customParams = props.primaryProduct?.includes((0, $dvVWp.ProductKeys).Jira) ? {
        [(0, $bc7ff59073912303$export$7640e1e223f51f1a)]: (0, $9pcjO.SearchExperience).QUICK_FIND
    } : {};
    /**
   * Quick Find does not need to set queryParams, hence using an object
   * in a state variable as the queryParams object. Any interactions with
   * the url should be done through onNavigate in the AppContext.
   */ const [queryParams, setQueryParams] = (0, $cozmU.useState)({
        text: actualQueryParams?.text,
        ...customParams
    });
    /**
   * Quick Find only reacts to changes in the text query parameter when the
   * user is on the search page.
   */ const previousTextQueryParam = (0, $cozmU.useRef)(actualQueryParams?.text);
    const initialRovoJourneyId = (0, $hnDqW.normalizeRovoJourneyId)(actualQueryParams?.rovoJourneyId);
    (0, $cozmU.useEffect)(()=>{
        if (actualQueryParams?.text === previousTextQueryParam.current) return;
        // If isOnSearchRoute fails and returns undefined, we default to true
        const onSearchRoute = (0, $6d0b2e4ae28c8d0a$export$2811a6cefe42670b)(props.generateSearchUrl) ?? true;
        if (onSearchRoute) setQueryParams((previousQueryParams)=>({
                ...previousQueryParams,
                text: actualQueryParams?.text
            }));
        previousTextQueryParam.current = actualQueryParams?.text;
    }, [
        actualQueryParams?.text,
        props.generateSearchUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $50CxG.BootstrapStoreProvider), {
        ...props,
        queryParams: queryParams,
        callbacks: {
            onSearchCompleted: onSearchCompleted,
            updateQueryParameters: setQueryParams
        },
        statsigLayer: (0, $3XLuW.STATSIG_QUICK_FIND_LAYER),
        experience: (0, $9pcjO.SearchExperience).QUICK_FIND
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c7Prm.SearchStoreProvider), {
        experience: (0, $9pcjO.SearchExperience).QUICK_FIND,
        useCaseId: (0, $iKybC.SEARCH_USE_CASE_IDS).QUICK_FIND
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ac6e3cb70b2fb8b6$export$5f60ff1bbe7f1a37), {
        initialRovoJourneyId: initialRovoJourneyId,
        shouldInitializeRovoJourneyId: (0, $hnDqW.isRovoJourneyIdEnabled)(props.primaryProduct)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1KAXF.QuickFindPerceivedLatencyProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1OGSC.QuickFindPostQueryVitalStatsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj3Ne.IntentDetectionVitalStatsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8ecc21febbc529aa$var$QuickFindAppContextProvider, {
        ...props,
        queryParams: queryParams
    }, children)))))));
};
/**
 * Quick-Find–scoped `AppContextProvider`. Wraps the host-provided `onNavigate`
 * with a warm-up that primes the search-page query cache in the backend when the
 * user navigates to the search page from Quick Find.
 */ const $8ecc21febbc529aa$var$QuickFindAppContextProvider = ({ children: children, ...props })=>{
    const generateSearchUrl = (0, $e1110ebedadd6968$export$de1e7dc8982a7dbb)(props.generateSearchUrl);
    const wrappedOnNavigate = (0, $e582a4f413c76123$export$86c95f2dee1a5a72)(props.onNavigate, generateSearchUrl);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c11PZ.AppContextProvider), {
        ...props,
        ...generateSearchUrl && {
            generateSearchUrl: generateSearchUrl
        },
        onNavigate: wrappedOnNavigate
    }, children);
};
const $8ecc21febbc529aa$export$7d842d92e2721710 = ({ children: // eslint-disable-next-line no-unused-vars
children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
        name: "quick-find"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hdMUr.default), {
        experience: (0, $9pcjO.SearchExperience).QUICK_FIND
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.RelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8ecc21febbc529aa$export$68bbc91d7879f9e4, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8ecc21febbc529aa$var$QuickFindComponent, props)))));
};



var $308Wd = parcelRequire("308Wd");


var $56QzY = parcelRequire("56QzY");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");


var $9wGTI = parcelRequire("9wGTI");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $e4o8D = parcelRequire("e4o8D");


var $1xpoY = parcelRequire("1xpoY");

parcelRequire("6OL2O");
var $5t3NX = parcelRequire("5t3NX");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $3LDzU = parcelRequire("3LDzU");


var $kysoj = parcelRequire("kysoj");

const $5235a3f27f080bad$var$SEARCH_ROUTE_PRELOAD_DELAY = 500;
const $5235a3f27f080bad$var$LITE_MODE_FEATURES = {
    lite: {
        enabled: true
    }
};
const $5235a3f27f080bad$var$QUICK_FIND_SEARCH_PERFORMED_EVENT_MUTATION = (0, $6a4b6bfe2e3e4030$export$2e2bcd8739ae039);
const $5235a3f27f080bad$var$generateUserUrl = (userId, orgId)=>{
    return (0, $5t3NX.getNavigateToTeamsApp)(orgId, {
        type: 'USER',
        payload: {
            userId: userId
        }
    }).href;
};
const $5235a3f27f080bad$var$generateTeamUrl = (teamId, orgId)=>{
    return (0, $5t3NX.getNavigateToTeamsApp)(orgId, {
        type: 'TEAM',
        payload: {
            teamId: teamId
        }
    }).href;
};
const $5235a3f27f080bad$var$useTextParameter = (0, $dPJCf.createSingleQueryParamHook)('text');
const $5235a3f27f080bad$var$useRovoJourneyIdParameter = (0, $dPJCf.createSingleQueryParamHook)('rovoJourneyId');
/**
 * Component that handles the search performed event mutation.
 * Wrapped in UFOInteractionIgnore to prevent the mutation from creating UFO holds.
 */ const $5235a3f27f080bad$var$SearchPerformedEventEmitter = ({ cloudId: cloudId, setHandleSearchCompletedRef: setHandleSearchCompletedRef })=>{
    const [generateSearchPerformedEvent] = (0, $308Wd.useMutationInterop)($5235a3f27f080bad$var$QUICK_FIND_SEARCH_PERFORMED_EVENT_MUTATION, {
        __callerPackage__: "navigation-search-dialog"
    });
    const handleSearchCompleted = (0, $cozmU.useCallback)((resultCount, query)=>{
        if (!(0, $9wGTI.fg)('should_enable_confluence_search_performed_event')) return;
        generateSearchPerformedEvent({
            variables: {
                cloudId: cloudId,
                resultCount: resultCount || 0,
                query: query || '',
                timestamp: new Date().toISOString()
            }
        });
    }, [
        cloudId,
        generateSearchPerformedEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        setHandleSearchCompletedRef(handleSearchCompleted);
    }, [
        handleSearchCompleted,
        setHandleSearchCompletedRef
    ]);
    return null;
};
const $5235a3f27f080bad$export$8233bb098a93ad26 = (urlQueryParams)=>{
    const url = new URL('/wiki/search', window.location.origin);
    const searchParams = new URLSearchParams(window.location.search);
    Object.entries(urlQueryParams).forEach(([key, value])=>{
        if (value !== undefined && value !== null) searchParams.set(key, String(value));
        else searchParams.delete(key);
    });
    url.search = searchParams.toString();
    return url.href;
};
const $5235a3f27f080bad$export$7d842d92e2721710 = ()=>{
    const [open, setOpen] = (0, $cozmU.useState)(false);
    const { cloudId: cloudId, orgId: orgId, activationId: activationId, isAdminHubAIEnabled: isAdminHubAIEnabled, userId: userId, displayName: displayName, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { push: push, replace: replace, preloadRoute: preloadRoute } = (0, $dPJCf.useRouteActions)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const inputRef = (0, $cozmU.useRef)(null);
    const [persistedGhostText] = (0, $cozmU.useState)(()=>(0, $kysoj.getPersistedGhostText)(inputRef));
    const onPersistGhostText = (0, $cozmU.useCallback)((newGhostText)=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_PLATFORM_QUICKFIND_GHOSTTEXT, newGhostText);
    }, []);
    const textParameter = $5235a3f27f080bad$var$useTextParameter();
    const rovoJourneyIdParameter = $5235a3f27f080bad$var$useRovoJourneyIdParameter();
    const queryParams = (0, $cozmU.useMemo)(()=>({
            text: textParameter,
            rovoJourneyId: rovoJourneyIdParameter
        }), [
        rovoJourneyIdParameter,
        textParameter
    ]);
    const analyticsAttributes = (0, $cozmU.useMemo)(()=>({
            activationId: activationId,
            navdexPointType: (0, $56QzY.TOUCH)
        }), [
        activationId
    ]);
    const user = (0, $cozmU.useMemo)(()=>({
            id: userId,
            name: displayName
        }), [
        userId,
        displayName
    ]);
    const experimentLayers = (0, $1xpoY.default).getStringList('search_platform_layer_functions', []);
    const preloadDataProvider = (0, $3LDzU.usePreloadDataProvider)();
    const handleSearchCompletedRef = (0, $cozmU.useRef)(()=>{});
    const setHandleSearchCompletedRef = (0, $cozmU.useCallback)((callback)=>{
        handleSearchCompletedRef.current = callback;
    }, []);
    const onNavigate = (0, $cozmU.useCallback)((url, action)=>action === 'replace' ? replace(url) : push(url), [
        push,
        replace
    ]);
    const universalNavigationShortcut = (0, $4tOXV.isMac)() ? (0, $gnkil.UNIVERSAL_NAVIGATION_SHORTCUT_MAC) : (0, $gnkil.UNIVERSAL_NAVIGATION_SHORTCUT_WIN);
    const onGenerateUserUrl = (0, $cozmU.useCallback)((userIdParam)=>$5235a3f27f080bad$var$generateUserUrl(userIdParam, orgId ?? ''), [
        orgId
    ]);
    const onGenerateTeamUrl = (0, $cozmU.useCallback)((teamIdParam)=>$5235a3f27f080bad$var$generateTeamUrl(teamIdParam, orgId ?? ''), [
        orgId
    ]);
    const callbacks = (0, $cozmU.useMemo)(()=>({
            onSearchCompleted: (resultCount, query)=>handleSearchCompletedRef.current(resultCount, query)
        }), []);
    const onOpenQuickFind = (0, $cozmU.useCallback)(()=>setOpen(true), []);
    const preloadedRef = (0, $cozmU.useRef)(false);
    const onGenerateSearchUrlWithPreload = (0, $cozmU.useCallback)((urlQueryParams)=>{
        const url = $5235a3f27f080bad$export$8233bb098a93ad26(urlQueryParams);
        if (!preloadedRef.current) setTimeout(()=>{
            const onIdle = window.requestIdleCallback || window.requestAnimationFrame || ((cb)=>setTimeout(cb, 0));
            onIdle(()=>preloadRoute(url));
        }, $5235a3f27f080bad$var$SEARCH_ROUTE_PRELOAD_DELAY);
        preloadedRef.current = true;
        return url;
    }, [
        preloadRoute
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb2gB.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5235a3f27f080bad$var$SearchPerformedEventEmitter, {
        cloudId: cloudId,
        setHandleSearchCompletedRef: setHandleSearchCompletedRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8ecc21febbc529aa$export$7d842d92e2721710), {
        cloudId: cloudId,
        orgId: orgId,
        primaryProduct: "confluence",
        features: $5235a3f27f080bad$var$LITE_MODE_FEATURES,
        analyticsAttributes: analyticsAttributes,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        isNav4Enabled: true,
        onNavigate: onNavigate,
        queryParams: queryParams,
        open: open,
        setOpen: setOpen,
        user: user,
        generateSearchUrl: onGenerateSearchUrlWithPreload,
        generateUserUrl: onGenerateUserUrl,
        generateTeamUrl: onGenerateTeamUrl,
        experimentLayers: experimentLayers,
        preloadDataProvider: preloadDataProvider,
        isRovoLLMEnabled: isRovoLLMEnabled,
        isSSR: renderServerPlaceholder,
        customPlaceholder: persistedGhostText,
        onGhostTextGenerated: onPersistGhostText,
        inputRef: inputRef,
        callbacks: callbacks
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.NAVIGATION_SHORTCUT) : undefined,
        accelerator: isLiveEditMode || isOnEditRoute ? universalNavigationShortcut : [
            universalNavigationShortcut,
            (0, $gnkil.NAVIGATION_SLASH_SHORTCUT)
        ],
        listener: onOpenQuickFind,
        isAppNavigationShortcut: true
    }));
};
module.exports["generateSearchUrl"] = $5235a3f27f080bad$export$8233bb098a93ad26;
module.exports["QuickFind"] = $5235a3f27f080bad$export$7d842d92e2721710;

});

parcelRegister("gnKXs", function(module, exports) {
const $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
module.exports["media"] = $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f;

});

parcelRegister("iKybC", function(module, exports) {
/**
 * Stable, registered business identities for requests entering Search Platform from AFM.
 *
 * Naming convention: <domain>.<business-purpose>[.<sub-purpose>]
 *
 * Never add:
 * - per-user, session, request, or tenant values
 * - targeting or experiment values
 * - search behaviour or operation names
 *
 * Alexander owns the authoritative runtime registry. Keep this client catalog aligned through the
 * Search use-case registration runbook before rolling out a new value.
 */ const $70bf699b2ed3ce20$export$167a49e39c06691a = {
    /**
   * Registered migration bucket for AFM requests whose durable business owner cannot yet be
   * resolved. Use only at an explicit business boundary; never as a transport-layer default.
   */ AFM_UNATTRIBUTED: 'afm.unattributed',
    QUICK_FIND: 'search-interactive.quick-find',
    SEARCH_PAGE: 'search-interactive.search-page'
};
module.exports["SEARCH_USE_CASE_IDS"] = $70bf699b2ed3ce20$export$167a49e39c06691a;

});

parcelRegister("89906", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $0f466bf48220cda5$export$ef7af5d8bc5d5ac1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    registerKeyboardEnabled: undefined,
    unregisterKeyboardEnabled: undefined,
    getSelectedIndex: undefined,
    selectComponentByTrackingId: undefined,
    highlightComponentAt: undefined,
    unhighlightComponentAt: undefined,
    unhighlightAll: undefined,
    keyboardNavComponents: []
});
const $0f466bf48220cda5$export$4da28cf324280418 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (options)=>{
    const $ = (0, $bDgLe.c)(19);
    const [ref, setRef] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(null);
    const registrationId = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const navigationTrackingId = options?.navigationTrackingId ?? null;
    const { registerKeyboardEnabled: registerKeyboardEnabled, unregisterKeyboardEnabled: unregisterKeyboardEnabled } = (0, $cozmU.useContext)($0f466bf48220cda5$export$ef7af5d8bc5d5ac1) ?? {};
    const [isHighlighted, setIsHighlighted] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const onKeydownCallback = options?.onKeydownCallback;
    const onHighlightedCallback = options?.onHighlightedCallback;
    let t0;
    if ($[0] !== unregisterKeyboardEnabled) {
        t0 = ()=>{
            if (registrationId.current && unregisterKeyboardEnabled) unregisterKeyboardEnabled(registrationId.current);
        };
        $[0] = unregisterKeyboardEnabled;
        $[1] = t0;
    } else t0 = $[1];
    const unregister = t0;
    let t1;
    let t2;
    if ($[2] !== unregister) {
        t1 = ()=>()=>unregister();
        t2 = [
            unregister
        ];
        $[2] = unregister;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[5] !== ref || $[6] !== unregister) {
        t3 = ()=>{
            !ref && unregister();
        };
        t4 = [
            ref,
            unregister
        ];
        $[5] = ref;
        $[6] = unregister;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[9] !== navigationTrackingId || $[10] !== onHighlightedCallback || $[11] !== onKeydownCallback || $[12] !== ref || $[13] !== registerKeyboardEnabled || $[14] !== unregisterKeyboardEnabled) {
        t5 = ()=>{
            if (!registerKeyboardEnabled || !unregisterKeyboardEnabled) return;
            if (!ref) return;
            if (ref) {
                if (!ref.compareDocumentPosition || !ref.addEventListener || !ref.removeEventListener) {
                    console.error("It is expected that any keyboard highlighting enabled component also passes the ref all the way to the DOM node.", "It appears that the `ref` is not fowarded all the way to the DOM node, please use `React.forwardRef to ensure this is so`", "Falling back to using ReactDOM.findDOMNode, this is not recommended and this fallback may be removed in the future");
                    return;
                }
                registrationId.current = registerKeyboardEnabled(registrationId.current, ref, setIsHighlighted, onKeydownCallback, navigationTrackingId, onHighlightedCallback);
            }
        };
        t6 = [
            ref,
            setIsHighlighted,
            onKeydownCallback,
            registerKeyboardEnabled,
            unregisterKeyboardEnabled,
            navigationTrackingId,
            onHighlightedCallback
        ];
        $[9] = navigationTrackingId;
        $[10] = onHighlightedCallback;
        $[11] = onKeydownCallback;
        $[12] = ref;
        $[13] = registerKeyboardEnabled;
        $[14] = unregisterKeyboardEnabled;
        $[15] = t5;
        $[16] = t6;
    } else {
        t5 = $[15];
        t6 = $[16];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[17] !== isHighlighted) {
        t7 = [
            isHighlighted,
            setRef
        ];
        $[17] = isHighlighted;
        $[18] = t7;
    } else t7 = $[18];
    return t7;
} : (options)=>{
    const [ref, setRef] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(null);
    const registrationId = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const navigationTrackingId = options?.navigationTrackingId ?? null;
    const { registerKeyboardEnabled: registerKeyboardEnabled, unregisterKeyboardEnabled: unregisterKeyboardEnabled } = (0, $cozmU.useContext)($0f466bf48220cda5$export$ef7af5d8bc5d5ac1) ?? {};
    const [isHighlighted, setIsHighlighted] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const onKeydownCallback = options?.onKeydownCallback;
    const onHighlightedCallback = options?.onHighlightedCallback;
    const unregister = (0, $cozmU.useCallback)(()=>{
        if (registrationId.current && unregisterKeyboardEnabled) // If the ref got removed or changed we unregister the current ref
        unregisterKeyboardEnabled(registrationId.current);
    }, [
        unregisterKeyboardEnabled
    ]);
    // Will unmount effect
    (0, $cozmU.useEffect)(()=>()=>unregister(), [
        unregister
    ]);
    // Ref change to null
    (0, $cozmU.useEffect)(()=>{
        !ref && unregister();
    }, [
        ref,
        unregister
    ]);
    // Everything else
    (0, $cozmU.useEffect)(()=>{
        if (!registerKeyboardEnabled || !unregisterKeyboardEnabled) return;
        if (!ref) return;
        // Then we register the new ref
        if (ref) {
            // Another check here to ensure that the ref we get is actually a DOM node, there's probably better
            // ways to make this check but it doesn't matter too much.
            // If what we get is NOT a DOM node we will log a warning and default back to use React.findDOMNode
            if (!ref.compareDocumentPosition || !ref.addEventListener || !ref.removeEventListener) {
                // eslint-disable-next-line
                console.error('It is expected that any keyboard highlighting enabled component also passes the ref all the way to the DOM node.', 'It appears that the `ref` is not fowarded all the way to the DOM node, please use `React.forwardRef to ensure this is so`', 'Falling back to using ReactDOM.findDOMNode, this is not recommended and this fallback may be removed in the future');
                return;
            }
            registrationId.current = registerKeyboardEnabled(registrationId.current, ref, setIsHighlighted, onKeydownCallback, navigationTrackingId, onHighlightedCallback);
        }
    }, [
        ref,
        setIsHighlighted,
        onKeydownCallback,
        registerKeyboardEnabled,
        unregisterKeyboardEnabled,
        navigationTrackingId,
        onHighlightedCallback
    ]);
    return [
        isHighlighted,
        setRef
    ];
};
const $0f466bf48220cda5$export$c8551b32665b42b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ children: children, listenerNode: listenerNode, onSelectedElementChange: onSelectedElementChange }, ref)=>{
    const currentlySelectedRef = (0, $cozmU.useRef)(undefined);
    const currentSelectedTrackingIdRef = (0, $cozmU.useRef)(null);
    const keyboardNavComponentsRef = (0, $cozmU.useRef)([]);
    const getSelectedIndex = (0, $cozmU.useCallback)(()=>{
        const currentlySelected = currentlySelectedRef.current;
        if (!currentlySelected) return undefined;
        return keyboardNavComponentsRef.current.findIndex(({ id: id })=>id === currentlySelected);
    }, []);
    const getSearchIdIndex = (0, $cozmU.useCallback)((searchId)=>searchId === null ? undefined : keyboardNavComponentsRef.current.findIndex(({ navigationTrackingId: navigationTrackingId })=>navigationTrackingId === searchId), []);
    const unhighlightComponentAt = (0, $cozmU.useCallback)((index)=>{
        const components = keyboardNavComponentsRef.current;
        if (typeof index !== 'undefined' && index >= 0 && index < components.length) components[index].onHighlightChanged(false);
    }, []);
    const highlightComponentAt = (0, $cozmU.useCallback)((index_0)=>{
        const components_0 = keyboardNavComponentsRef.current;
        if (index_0 >= 0 && index_0 < components_0.length) {
            const { id: id_0, navigationTrackingId: navigationTrackingId_0 } = components_0[index_0];
            currentlySelectedRef.current = id_0;
            currentSelectedTrackingIdRef.current = navigationTrackingId_0;
            components_0[index_0].onHighlightChanged(true);
            onSelectedElementChange?.(navigationTrackingId_0 || undefined);
        }
    }, [
        onSelectedElementChange
    ]);
    const unhighlightAll = (0, $cozmU.useCallback)(()=>{
        currentSelectedTrackingIdRef.current = null;
        currentlySelectedRef.current = undefined;
        onSelectedElementChange?.(undefined);
        keyboardNavComponentsRef.current.forEach((component)=>component.onHighlightChanged(false));
    }, [
        onSelectedElementChange
    ]);
    const onHighlightedCallback = (0, $cozmU.useCallback)((index_1)=>{
        const components_1 = keyboardNavComponentsRef.current;
        if (typeof index_1 !== 'undefined' && index_1 >= 0 && index_1 < components_1.length) {
            const callback = components_1[index_1].onHighlightedCallback;
            callback && callback(index_1);
        }
    }, []);
    const selectComponentByTrackingId = (0, $cozmU.useCallback)((trackingId)=>{
        const index_2 = getSearchIdIndex(trackingId);
        if (index_2 === undefined || index_2 < 0) return undefined;
        unhighlightAll();
        highlightComponentAt(index_2);
        onHighlightedCallback(index_2);
        return index_2;
    }, [
        getSearchIdIndex,
        highlightComponentAt,
        onHighlightedCallback,
        unhighlightAll
    ]);
    const onKeyDownCallbackAt = (0, $cozmU.useCallback)((index_3, e)=>{
        const components_2 = keyboardNavComponentsRef.current;
        if (typeof index_3 !== 'undefined' && index_3 >= 0 && index_3 < components_2.length) {
            const onKeyDown = components_2[index_3].onKeyDownWhenHighlighted;
            onKeyDown && onKeyDown(e, components_2[index_3].domRef);
        }
    }, []);
    const registerKeyboardEnabled = (0, $cozmU.useCallback)((currentId, domRef, onHighlightChanged, onKeyDownWhenHighlighted, navigationTrackingId_1, onHighlightedCb)=>{
        const components_3 = keyboardNavComponentsRef.current;
        const indexAt = components_3.findIndex(({ id: id_1 })=>id_1 === currentId);
        // If the currentId is null or we can't find any records of the id we will create a new entry
        const isNew = currentId === null || currentId === undefined || indexAt === -1;
        const id_2 = isNew ? Math.max(...components_3.map((component_0)=>component_0.id), 0) + 1 : components_3[indexAt].id;
        if (isNew) components_3.push({
            id: id_2,
            domRef: domRef,
            onHighlightChanged: onHighlightChanged,
            onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
            navigationTrackingId: navigationTrackingId_1,
            onHighlightedCallback: onHighlightedCb
        });
        else // Otherwise we will update the current entry
        components_3[indexAt] = {
            id: id_2,
            domRef: domRef,
            onHighlightChanged: onHighlightChanged,
            onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
            navigationTrackingId: navigationTrackingId_1,
            onHighlightedCallback: onHighlightedCb
        };
        keyboardNavComponentsRef.current = components_3.sort((c1, c2)=>{
            const result = c1.domRef.compareDocumentPosition(c2.domRef);
            if (result & Node.DOCUMENT_POSITION_FOLLOWING || result & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
            else if (result & Node.DOCUMENT_POSITION_PRECEDING || result & Node.DOCUMENT_POSITION_CONTAINS) return 1;
            return 0;
        });
        const indexToHighlight = getSearchIdIndex(currentSelectedTrackingIdRef.current);
        if (indexToHighlight !== undefined && indexToHighlight >= 0) {
            unhighlightAll();
            highlightComponentAt(indexToHighlight);
        }
        return id_2;
    }, [
        getSearchIdIndex,
        highlightComponentAt,
        unhighlightAll
    ]);
    const unregisterKeyboardEnabled = (0, $cozmU.useCallback)((unregisterRef)=>{
        if (currentlySelectedRef.current === unregisterRef) {
            currentlySelectedRef.current = undefined;
            onSelectedElementChange?.(undefined);
        }
        keyboardNavComponentsRef.current = keyboardNavComponentsRef.current.filter(({ id: ref_0 })=>ref_0 !== unregisterRef);
        // Reset currentSelectedTrackingId when all components are unregistered
        if (keyboardNavComponentsRef.current.length === 0) currentSelectedTrackingIdRef.current = null;
    }, [
        onSelectedElementChange
    ]);
    const onKeyDown_0 = (0, $cozmU.useCallback)((e_0)=>{
        const components_4 = keyboardNavComponentsRef.current;
        if (components_4.length === 0) return;
        if (e_0.isComposing || e_0.keyCode === 229) return;
        let currentIndex = getSelectedIndex();
        const prevIndex = currentIndex;
        if (e_0.code === 'ArrowDown' || e_0.keyCode === 40) {
            if (!e_0.shiftKey) {
                if (typeof currentIndex === 'undefined') currentIndex = 0;
                else currentIndex = (currentIndex + 1) % components_4.length;
                e_0.preventDefault();
            }
        } else if (e_0.code === 'ArrowUp' || e_0.keyCode === 38) {
            if (!e_0.shiftKey) {
                if (typeof currentIndex === 'undefined') currentIndex = components_4.length - 1;
                else {
                    currentIndex -= 1;
                    if (currentIndex < 0) currentIndex = components_4.length - Math.abs(currentIndex);
                }
                e_0.preventDefault();
            }
        } else {
            if (typeof currentIndex !== 'undefined') onKeyDownCallbackAt(currentIndex, e_0);
            return;
        }
        if (prevIndex !== currentIndex && currentIndex !== undefined) {
            unhighlightComponentAt(prevIndex);
            highlightComponentAt(currentIndex);
            onHighlightedCallback(currentIndex);
        }
    }, [
        getSelectedIndex,
        onKeyDownCallbackAt,
        unhighlightComponentAt,
        highlightComponentAt,
        onHighlightedCallback
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!listenerNode) return;
        listenerNode.addEventListener('keydown', onKeyDown_0);
        return ()=>{
            listenerNode.removeEventListener('keydown', onKeyDown_0);
        };
    }, [
        listenerNode,
        onKeyDown_0
    ]);
    (0, $cozmU.useEffect)(()=>()=>onSelectedElementChange?.(undefined), [
        onSelectedElementChange
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            registerKeyboardEnabled: registerKeyboardEnabled,
            unregisterKeyboardEnabled: unregisterKeyboardEnabled,
            getSelectedIndex: getSelectedIndex,
            selectComponentByTrackingId: selectComponentByTrackingId,
            highlightComponentAt: highlightComponentAt,
            unhighlightComponentAt: unhighlightComponentAt,
            unhighlightAll: unhighlightAll,
            get keyboardNavComponents () {
                // Always read the latest registry from the ref so consumers that
                // destructure `keyboardNavComponents` from the context still see
                // up-to-date data without forcing a re-render of the provider.
                return keyboardNavComponentsRef.current;
            }
        }), [
        registerKeyboardEnabled,
        unregisterKeyboardEnabled,
        getSelectedIndex,
        selectComponentByTrackingId,
        highlightComponentAt,
        unhighlightComponentAt,
        unhighlightAll
    ]);
    (0, $cozmU.useImperativeHandle)(ref, ()=>({
            highlightComponentAt: highlightComponentAt,
            unhighlightComponentAt: unhighlightComponentAt,
            unhighlightAll: unhighlightAll,
            getSelectedIndex: getSelectedIndex
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0f466bf48220cda5$export$ef7af5d8bc5d5ac1.Provider, {
        value: contextValue
    }, children);
});
const $0f466bf48220cda5$export$cbeda0f7f7a8026c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($0f466bf48220cda5$export$ef7af5d8bc5d5ac1);
} : ()=>{
    return (0, $cozmU.useContext)($0f466bf48220cda5$export$ef7af5d8bc5d5ac1);
};
module.exports["useKeyboardNavigation"] = $0f466bf48220cda5$export$4da28cf324280418;
module.exports["KeyboardHighlightProvider"] = $0f466bf48220cda5$export$c8551b32665b42b;
module.exports["useKeyboardHighlightProvider"] = $0f466bf48220cda5$export$cbeda0f7f7a8026c;

});

parcelRegister("ja2HH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kmQhR = parcelRequire("kmQhR");


var $4TEhG = parcelRequire("4TEhG");

/**
 * The coarse routing decision produced by intent detection.
 *
 * PORTED FROM: `KnowledgeDiscoveryJiraSearchClassificationType`
 * https://bitbucket.org/atlassian/xp-knowledge-discovery/src/f02f6dd19b50e91f20c6ab94d493ce7764e76eb1/src/main/java/io/atlassian/micros/xpknowledgediscovery/dto/jiraintentdetection/KnowledgeDiscoveryJiraSearchClassificationType.java
 *
 * Values are spelled exactly as the backend enum so local and server-side
 * classifications are directly comparable in analytics.
 */ const $15144e47939e470d$export$a6c4835f6717e27f = {
    /** Send the input to full page search. */ FPS: 'FPS',
    /** Send the input to Jira's navigation destination. */ GNIN: 'GNIN',
    /** Send the input to full-page chat. */ CHAT: 'CHAT'
};
const $15144e47939e470d$export$8085bec54c027530 = {
    JIRA: 'jira',
    CONFLUENCE: 'confluence',
    HOME: 'townsquare'
};
const $15144e47939e470d$export$523ff7a47aadbc47 = [
    $15144e47939e470d$export$8085bec54c027530.CONFLUENCE,
    $15144e47939e470d$export$8085bec54c027530.HOME
];




/**
 * Lexicon data for the convergence rule pack.
 *
 * SOURCE: "Search x Chat Convergence - MVP Triggering Architecture", canonical
 * all-in-one rule catalog and `STOP_WORDS_V1`.
 * https://hello.atlassian.net/wiki/spaces/jirasearch/pages/7525895377
 *
 * Every list here is **exact-match pack data**, never a heuristic: a cue matches
 * only as a whole word or whole phrase at the position its rule specifies. Adding,
 * removing, or reordering a member requires a new pack version and regenerated
 * corpus evidence, which is why these arrays are frozen and typed `readonly`.
 *
 * Multi-word cues are listed longest-first within their family so a longest-match
 * strip cannot be pre-empted by a shorter sibling (`find me` before `find`,
 * `search for` before `search`).
 */ const $c56addc33acf11a0$var$freeze = (values)=>Object.freeze([
        ...values
    ]);
const $c56addc33acf11a0$export$78e30463ebf31a6c = $c56addc33acf11a0$var$freeze([
    'a',
    'an',
    'the',
    'this',
    'that',
    'these',
    'those',
    'i',
    'me',
    'my',
    'mine',
    'we',
    'us',
    'our',
    'ours',
    'you',
    'your',
    'yours',
    'it',
    'its',
    'they',
    'them',
    'their',
    'theirs',
    'something',
    'anything',
    'am',
    'is',
    'are',
    'was',
    'were',
    'be',
    'been',
    'being',
    'do',
    'does',
    'did',
    'can',
    'could',
    'may',
    'might',
    'must',
    'shall',
    'should',
    'will',
    'would',
    'and',
    'or',
    'but',
    'to',
    'for',
    'of',
    'in',
    'on',
    'at',
    'by',
    'from',
    'with',
    'as',
    'please',
    'kindly'
]);
const $c56addc33acf11a0$export$2fc57d44d74d659d = $c56addc33acf11a0$var$freeze([
    'vs',
    'versus'
]);
const $c56addc33acf11a0$export$bed0bcaf7f89f7a7 = $c56addc33acf11a0$var$freeze([
    'could you please',
    'would you please',
    'can you please',
    'will you please',
    'could you',
    'would you',
    'can you',
    'will you',
    'please',
    'kindly'
]);
const $c56addc33acf11a0$export$fabe3e6f39926741 = $c56addc33acf11a0$var$freeze([
    'please',
    'kindly'
]);
const $c56addc33acf11a0$export$de969193fc0be256 = $c56addc33acf11a0$var$freeze([
    'and',
    'or'
]);
const $c56addc33acf11a0$export$b3df2c211b86176 = $c56addc33acf11a0$var$freeze([
    'for ourselves',
    'for myself',
    'for me',
    'for us'
]);
const $c56addc33acf11a0$export$1255c0baaaa2b423 = $c56addc33acf11a0$var$freeze([
    'navigate to',
    'take me to',
    'go to',
    'visit'
]);
const $c56addc33acf11a0$export$dd4fae26e5900065 = 'open';
const $c56addc33acf11a0$export$8af24f041431d7f3 = $c56addc33acf11a0$var$freeze([
    'page',
    'document',
    'doc',
    'blog',
    'blogpost',
    'blog post',
    'space',
    'whiteboard',
    'database',
    'folder',
    'attachment',
    'comment',
    'template',
    'goal',
    'project',
    'board',
    'dashboard',
    'report'
]);
const $c56addc33acf11a0$export$ebb45db9043173ec = $c56addc33acf11a0$var$freeze([
    'comment on',
    'create',
    'publish',
    'edit',
    'update',
    'rename',
    'move',
    'copy',
    'archive',
    'delete',
    'restore',
    'share',
    'restrict'
]);
const $c56addc33acf11a0$export$96061f3f92adaeec = $c56addc33acf11a0$var$freeze([
    'help me understand',
    'walk me through',
    'elaborate on',
    'explain',
    'describe',
    'define'
]);
const $c56addc33acf11a0$export$7ee63605166d4aa3 = $c56addc33acf11a0$var$freeze([
    'search for',
    'look up',
    'find me',
    'show me',
    'tell me',
    'give me',
    'retrieve',
    'find',
    'show',
    'list'
]);
const $c56addc33acf11a0$export$e47a3ecb077c8e1c = $c56addc33acf11a0$var$freeze([
    'find out why',
    'find out what',
    'find out how'
]);
const $c56addc33acf11a0$export$18f3ddd305ccb6d1 = $c56addc33acf11a0$var$freeze([
    'summarize',
    'summarise',
    'rewrite',
    'extract',
    'draft',
    'translate'
]);
const $c56addc33acf11a0$export$d1c92911fa803027 = 'compare';
const $c56addc33acf11a0$export$4f39eb4cf287981e = $c56addc33acf11a0$var$freeze([
    'versus',
    'with',
    'and',
    'vs'
]);
const $c56addc33acf11a0$export$455555cb8284311b = $c56addc33acf11a0$var$freeze([
    'troubleshoot',
    'investigate',
    'recommend',
    'refactor',
    'optimise',
    'optimize',
    'generate',
    'evaluate',
    'validate',
    'diagnose',
    'organise',
    'organize',
    'prepare',
    'provide',
    'suggest',
    'analyse',
    'analyze',
    'improve',
    'verify',
    'assess',
    'review',
    'debug',
    'check',
    'build',
    'write',
    'make',
    'plan',
    'fix'
]);
const $c56addc33acf11a0$export$b038760db621922d = $c56addc33acf11a0$var$freeze([
    'where',
    'what',
    'how',
    'when',
    'who',
    'which',
    'why',
    'whose'
]);
const $c56addc33acf11a0$export$6ce55be9e64b410c = $c56addc33acf11a0$var$freeze([
    'what',
    'where',
    'who',
    'how',
    'when',
    'why'
]);
const $c56addc33acf11a0$export$258b045db4e92934 = $c56addc33acf11a0$var$freeze([
    'is',
    'are',
    'was',
    'were',
    'do',
    'does',
    'did',
    'can',
    'could',
    'should',
    'would',
    'will',
    'has',
    'have',
    'had'
]);


/**
 * Finds the protected atoms in `qMatch`.
 *
 * A protected atom is a span the engine must treat as one opaque operand: a balanced
 * quoted range, an approved whole URL, or a validated Atlassian identifier. Three rules
 * depend on getting this right:
 *
 * - `S-STRUCTURED` locks Search when the whole query is a single atom, and is the one
 *   place that validates a quoted range actually contains something.
 * - `navigationTarget` treats a non-empty atom after `open` as a navigation target.
 * - `compare` splits on a separator only outside every atom, so the `and` inside
 *   `"plan a and b"` is part of the operand.
 *
 * Quoted ranges are found first and every other pattern is matched only outside them, so
 * a URL inside a quoted title stays part of the title rather than becoming a second atom.
 */ /** Balanced double quotes: ASCII pairs and the curly pair. Single quotes are excluded because they are also apostrophes. */ const $15a748fe8f16730a$var$QUOTE_PAIRS = [
    [
        '"',
        '"'
    ],
    [
        "\u201C",
        "\u201D"
    ]
];
const $15a748fe8f16730a$var$ABSOLUTE_URL = /^https?:\/\/[^\s]+$/iu;
/**
 * A Confluence-relative content path.
 *
 * Anchored to the known `/wiki` prefix rather than any leading slash so an
 * ordinary query starting with `/` is not silently promoted to a Search lock.
 */ const $15a748fe8f16730a$var$WIKI_PATH = /^\/wiki\/[^\s]*$/u;
const $15a748fe8f16730a$var$ARI = /^ari:cloud:[a-z0-9-]+:[^\s:]*:[^\s]+$/iu;
/**
 * An explicitly labelled content identifier.
 *
 * A bare integer is deliberately **not** a validated content ID: nothing in the
 * browser can distinguish `12345` the page from `12345` the search term, and
 * treating it as structured input would lock Search on ordinary numeric queries.
 */ const $15a748fe8f16730a$var$CONTENT_ID = /^(?:contentId|pageId)=\d+$/iu;
const $15a748fe8f16730a$var$findQuotedAtoms = (qMatch)=>{
    const atoms = [];
    let index = 0;
    while(index < qMatch.length){
        const pair = $15a748fe8f16730a$var$QUOTE_PAIRS.find(([open])=>qMatch.startsWith(open, index));
        if (!pair) {
            index += 1;
            continue;
        }
        const [open, close] = pair;
        const closeIndex = qMatch.indexOf(close, index + open.length);
        // An unbalanced quote is not an atom. Mid-typing input regularly has one,
        // and promoting it would lock Search on every partially typed phrase.
        if (closeIndex === -1) {
            index += 1;
            continue;
        }
        const end = closeIndex + close.length;
        atoms.push({
            kind: 'QUOTED',
            start: index,
            end: end,
            text: qMatch.slice(index, end)
        });
        index = end;
    }
    return atoms;
};
const $15a748fe8f16730a$var$classifyToken = (token)=>{
    if ($15a748fe8f16730a$var$ABSOLUTE_URL.test(token)) return 'URL';
    if ($15a748fe8f16730a$var$WIKI_PATH.test(token)) return 'WIKI_PATH';
    if ($15a748fe8f16730a$var$ARI.test(token)) return 'ARI';
    if ($15a748fe8f16730a$var$CONTENT_ID.test(token)) return 'CONTENT_ID';
    return null;
};
const $15a748fe8f16730a$export$a6894629479d4cdc = (qMatch)=>{
    const quoted = $15a748fe8f16730a$var$findQuotedAtoms(qMatch);
    const isInsideQuoted = (start, end)=>quoted.some((atom)=>start < atom.end && end > atom.start);
    const identifiers = [];
    let offset = 0;
    for (const token of qMatch.split(' ')){
        const start = offset;
        const end = offset + token.length;
        offset = end + 1;
        if (token.length === 0 || isInsideQuoted(start, end)) continue;
        const kind = $15a748fe8f16730a$var$classifyToken(token);
        if (kind) identifiers.push({
            kind: kind,
            start: start,
            end: end,
            text: token
        });
    }
    return Object.freeze([
        ...quoted,
        ...identifiers
    ].sort((left, right)=>left.start - right.start));
};
const $15a748fe8f16730a$export$427521dd938a1d14 = (qMatch, atoms)=>atoms.length === 1 && atoms[0].start === 0 && atoms[0].end === qMatch.length ? atoms[0] : undefined;


const $b42fe61caa94402a$var$isBoundary = (character)=>character === undefined || character === ' ';
const $b42fe61caa94402a$export$cec6318cbd95e5ee = (input, phrases)=>{
    const folded = input.toLowerCase();
    const candidates = [
        ...phrases
    ].sort((left, right)=>right.length - left.length);
    for (const phrase of candidates){
        if (!folded.startsWith(phrase) || !$b42fe61caa94402a$var$isBoundary(input[phrase.length])) continue;
        const restOffset = phrase.length === input.length ? input.length : phrase.length + 1;
        return {
            phrase: phrase,
            rest: input.slice(restOffset)
        };
    }
    return null;
};
const $b42fe61caa94402a$export$9c28b4388f35e83e = (input, phrases)=>{
    const folded = input.toLowerCase();
    const candidates = [
        ...phrases
    ].sort((left, right)=>right.length - left.length);
    for (const phrase of candidates){
        if (!folded.endsWith(phrase)) continue;
        const start = input.length - phrase.length;
        if (!$b42fe61caa94402a$var$isBoundary(input[start - 1])) continue;
        return {
            phrase: phrase,
            rest: input.slice(0, Math.max(0, start - 1))
        };
    }
    return null;
};
const $b42fe61caa94402a$export$8fc7d7f700b600f9 = (span, separators)=>{
    const atoms = (0, $15a748fe8f16730a$export$a6894629479d4cdc)(span);
    const isProtected = (start, end)=>atoms.some((atom)=>start < atom.end && end > atom.start);
    const folded = span.toLowerCase();
    const candidates = [
        ...separators
    ].sort((left, right)=>right.length - left.length);
    for(let index = 0; index < span.length; index += 1){
        if (index !== 0 && span[index - 1] !== ' ') continue;
        const separator = candidates.find((candidate)=>folded.startsWith(candidate, index) && $b42fe61caa94402a$var$isBoundary(span[index + candidate.length]));
        if (!separator || isProtected(index, index + separator.length)) continue;
        return {
            left: span.slice(0, Math.max(0, index - 1)),
            right: span.slice(Math.min(span.length, index + separator.length + 1)),
            separator: separator
        };
    }
    return null;
};



/**
 * Bounded constants for the convergence rule pack.
 *
 * SOURCE: "Search x Chat Convergence - MVP Triggering Architecture", Appendix A
 * — Reference constants and representative cases.
 * https://hello.atlassian.net/wiki/spaces/jirasearch/pages/7525895377
 *
 * These are pack data, not harness behaviour: changing one requires a new pack
 * version and regenerated golden/corpus evidence. Values marked provisional in
 * the design are timing constants owned by the runtime layer and are therefore
 * absent here — this pack only classifies.
 */ /** Word-like tokens are counted up to this bound; observing token 513 commits Search. */ const $13d148987efba1d6$export$9d5b02018aadd3d2 = 512;
const $13d148987efba1d6$export$7e03fe4db7ce42a3 = 4096;
const $13d148987efba1d6$export$a077554631aef03 = 2;


/**
 * Fallback used only when `Intl.Segmenter` is missing.
 *
 * Deliberately conservative and Latin-shaped: it keeps intra-word apostrophes so
 * contracted forms stay single tokens, and it treats every other separator as a
 * boundary. A runtime without `Intl.Segmenter` is a degraded environment, not a
 * supported target, so this exists to keep classification running rather than to
 * reproduce UAX #29.
 */ const $5b2dcc709ee71f91$var$FALLBACK_WORD = RegExp("[\\p{L}\\p{N}]+(?:['\u2019][\\p{L}\\p{N}]+)*", "gu");
const $5b2dcc709ee71f91$var$segmentWithFallback = (qMatch)=>{
    const tokens = [];
    for (const match of qMatch.matchAll($5b2dcc709ee71f91$var$FALLBACK_WORD)){
        tokens.push(match[0]);
        if (tokens.length > (0, $13d148987efba1d6$export$9d5b02018aadd3d2)) return {
            tokens: tokens,
            exceededCap: true
        };
    }
    return {
        tokens: tokens,
        exceededCap: false
    };
};
/**
 * One segmenter for the module, built on first use.
 *
 * Constructing an `Intl.Segmenter` loads ICU break data, which is far more expensive than
 * running it. Classification happens on every input change with no debounce, so building
 * one per keystroke would dominate the input-handler budget. A segmenter carries no state
 * between `segment()` calls, so reuse is safe.
 */ let $5b2dcc709ee71f91$var$sharedSegmenter;
const $5b2dcc709ee71f91$var$getSegmenter = ()=>{
    if (!$5b2dcc709ee71f91$var$sharedSegmenter) $5b2dcc709ee71f91$var$sharedSegmenter = new Intl.Segmenter(undefined, {
        granularity: 'word'
    });
    return $5b2dcc709ee71f91$var$sharedSegmenter;
};
const $5b2dcc709ee71f91$export$f6c6dd1d752911b = (qMatch)=>{
    if (typeof Intl?.Segmenter !== 'function') return $5b2dcc709ee71f91$var$segmentWithFallback(qMatch);
    const segmenter = $5b2dcc709ee71f91$var$getSegmenter();
    const tokens = [];
    for (const segment of segmenter.segment(qMatch)){
        if (!segment.isWordLike) continue;
        tokens.push(segment.segment);
        // Observing the 513th token is enough to commit Search, so there is no
        // reason to keep segmenting a query that has already failed the bound.
        if (tokens.length > (0, $13d148987efba1d6$export$9d5b02018aadd3d2)) return {
            tokens: tokens,
            exceededCap: true
        };
    }
    return {
        tokens: tokens,
        exceededCap: false
    };
};
const $5b2dcc709ee71f91$var$LETTER = RegExp("\\p{L}", "u");
const $5b2dcc709ee71f91$export$5d8f8a240ab6d489 = (token, max = Number.MAX_SAFE_INTEGER)=>{
    let letters = 0;
    for (const codePoint of token)if ($5b2dcc709ee71f91$var$LETTER.test(codePoint)) {
        letters += 1;
        if (letters > max) return letters;
    }
    return letters;
};


/**
 * `operandEvidence(span)`: whether anything worth acting on remains in a span.
 *
 * A span has evidence when at least one content token survives removing connectors and
 * `STOP_WORDS_V1`. This single predicate is what separates a real Chat request from a
 * bare cue: `summarize the page` has evidence, `summarize this` does not.
 *
 * Filtering is case-folded and applies **only** to this derived span. `qMatch` and
 * `wordTokens` keep every stop word, so token counts and rule positions never move.
 *
 * The design's definition also counts "one complete protected atom" as evidence on its
 * own. That clause is deliberately **not** implemented: a protected atom can be empty
 * (`""`, `"   "`, `"???"`), so honouring it made `explain ""` and `open ""` look like
 * real requests. Counting the words *inside* a quoted range or URL instead is both
 * simpler and stricter — `explain "launch plan"` and `explain https://example.com/plan`
 * still have evidence, and an empty quote has none.
 */ const $d3d1e06ac0ff14e2$var$FILTERED_WORDS = new Set([
    ...(0, $c56addc33acf11a0$export$78e30463ebf31a6c),
    ...(0, $c56addc33acf11a0$export$2fc57d44d74d659d)
]);
const $d3d1e06ac0ff14e2$export$4c75db37d73617bc = (span)=>(0, $5b2dcc709ee71f91$export$f6c6dd1d752911b)(span).tokens.filter((token)=>!$d3d1e06ac0ff14e2$var$FILTERED_WORDS.has(token.toLowerCase()));
const $d3d1e06ac0ff14e2$export$2e37c471b771b5bd = (span)=>$d3d1e06ac0ff14e2$export$4c75db37d73617bc(span).length > 0;
const $d3d1e06ac0ff14e2$export$58b363b34f5a077 = (span)=>/\d/u.test(span) && !RegExp("\\p{L}", "u").test(span);



const $3a64d3a27a6b3e6b$export$9712699da2be3add = (qMatch)=>{
    const politeness = (0, $b42fe61caa94402a$export$cec6318cbd95e5ee)(qMatch, (0, $c56addc33acf11a0$export$fabe3e6f39926741));
    const withoutPoliteness = politeness ? politeness.rest : qMatch;
    const cue = (0, $b42fe61caa94402a$export$cec6318cbd95e5ee)(withoutPoliteness, [
        (0, $c56addc33acf11a0$export$dd4fae26e5900065)
    ]);
    return cue ? cue.rest : null;
};
/** Removes the first whole-word occurrence of an artefact noun, returning the remainder. */ const $3a64d3a27a6b3e6b$var$removeArtefactNoun = (span)=>{
    const folded = span.toLowerCase();
    for (const artefact of [
        ...(0, $c56addc33acf11a0$export$8af24f041431d7f3)
    ].sort((left, right)=>right.length - left.length)){
        const index = folded.indexOf(artefact);
        if (index === -1) continue;
        const before = span[index - 1];
        const after = span[index + artefact.length];
        const isWholeWord = (before === undefined || before === ' ') && (after === undefined || after === ' ');
        if (isWholeWord) return `${span.slice(0, index)} ${span.slice(index + artefact.length)}`;
    }
    return null;
};
const $3a64d3a27a6b3e6b$export$a47366ee6290ca = (qMatch)=>{
    const span = $3a64d3a27a6b3e6b$export$9712699da2be3add(qMatch);
    // Nothing worth navigating to, whatever shape it has. This is what stops an empty
    // quoted range — `open ""` — from counting as a complete protected atom.
    if (span === null || !(0, $d3d1e06ac0ff14e2$export$2e37c471b771b5bd)(span)) return false;
    if ((0, $15a748fe8f16730a$export$a6894629479d4cdc)(span).length > 0) return true;
    const withoutArtefact = $3a64d3a27a6b3e6b$var$removeArtefactNoun(span);
    return withoutArtefact !== null && (0, $d3d1e06ac0ff14e2$export$2e37c471b771b5bd)(withoutArtefact);
};



/**
 * Normalization, and the cheap bounds that keep it affordable.
 *
 * Classification runs synchronously on every input change with no debounce, so nothing
 * here may be proportional to what a user can paste. Two properties enforce that:
 *
 * - **Work is bounded before it starts.** `normalizeQuery` truncates to the widest input
 *   that could still be inside the code-point bound, so NFKC never runs over a megabyte
 *   of pasted text.
 * - **Nothing allocates per code point.** The bound check is a capped scan with an O(1)
 *   fast path, and the script and terminal-punctuation checks are single native passes.
 */ /**
 * The widest slice that can still hold a within-bound input.
 *
 * A code point is at most two UTF-16 code units, so any input of `MAX_CODE_POINTS` code
 * points fits in twice that many units. Anything longer is over the bound by definition,
 * and `S-INPUT-LIMIT` only needs to know *that* — so truncating here cannot change the
 * classification of any input the engine is willing to accept.
 */ const $49bd71f0e508fca4$var$MAX_CODE_UNITS = (0, $13d148987efba1d6$export$7e03fe4db7ce42a3) * 2 + 2;
const $49bd71f0e508fca4$export$d295fd374e4e3151 = (input)=>(input.length > $49bd71f0e508fca4$var$MAX_CODE_UNITS ? input.slice(0, $49bd71f0e508fca4$var$MAX_CODE_UNITS) : input).normalize('NFKC').replace(/\s+/gu, ' ').trim();
const $49bd71f0e508fca4$export$adc146166d45ecda = (qMatch, max = (0, $13d148987efba1d6$export$7e03fe4db7ce42a3))=>{
    if (qMatch.length <= max) return false;
    let count = 0;
    for (const _codePoint of qMatch){
        count += 1;
        if (count > max) return true;
    }
    return false;
};
/**
 * Letters outside the Latin script.
 *
 * The class negates the union of "non-letters" and "Latin", which leaves exactly the
 * letters that are not Latin — one native regex pass, rather than a per-code-point loop
 * that allocates a string for every character.
 */ const $49bd71f0e508fca4$var$NON_LATIN_LETTER = RegExp("[^\\P{L}\\p{Script=Latin}]", "u");
const $49bd71f0e508fca4$export$c208c604230c442d = (qMatch)=>$49bd71f0e508fca4$var$NON_LATIN_LETTER.test(qMatch);
const $49bd71f0e508fca4$var$TERMINAL_PUNCTUATION = RegExp("\\p{P}|\\p{S}", "u");
const $49bd71f0e508fca4$var$LOW_SURROGATE_START = 0xdc00;
const $49bd71f0e508fca4$var$LOW_SURROGATE_END = 0xdfff;
const $49bd71f0e508fca4$export$a216d4171371eb32 = (qMatch)=>{
    if (qMatch.length === 0) return '';
    const lastUnit = qMatch.charCodeAt(qMatch.length - 1);
    const isLowSurrogate = lastUnit >= $49bd71f0e508fca4$var$LOW_SURROGATE_START && lastUnit <= $49bd71f0e508fca4$var$LOW_SURROGATE_END;
    const last = qMatch.slice(isLowSurrogate && qMatch.length >= 2 ? -2 : -1);
    return $49bd71f0e508fca4$var$TERMINAL_PUNCTUATION.test(last) ? last : '';
};




const $3707a6d0464531d4$var$memo = ()=>({
        computed: false,
        value: undefined
    });
const $3707a6d0464531d4$var$read = (cache, compute)=>{
    if (!cache.computed) {
        cache.value = compute();
        cache.computed = true;
    }
    return cache.value;
};
const $3707a6d0464531d4$export$39cc066cc9a5aa04 = (input)=>{
    const qMatch = (0, $49bd71f0e508fca4$export$d295fd374e4e3151)(input);
    const exceedsCodePointLimit = $3707a6d0464531d4$var$memo();
    const wordTokens = $3707a6d0464531d4$var$memo();
    const protectedAtoms = $3707a6d0464531d4$var$memo();
    const nonLatin = $3707a6d0464531d4$var$memo();
    const terminalPunctuation = $3707a6d0464531d4$var$memo();
    const navigationTarget = $3707a6d0464531d4$var$memo();
    return {
        qMatch: qMatch,
        get exceedsCodePointLimit () {
            return $3707a6d0464531d4$var$read(exceedsCodePointLimit, ()=>(0, $49bd71f0e508fca4$export$adc146166d45ecda)(qMatch));
        },
        get wordTokens () {
            return $3707a6d0464531d4$var$read(wordTokens, ()=>(0, $5b2dcc709ee71f91$export$f6c6dd1d752911b)(qMatch)).tokens;
        },
        get exceededWordTokenCap () {
            return $3707a6d0464531d4$var$read(wordTokens, ()=>(0, $5b2dcc709ee71f91$export$f6c6dd1d752911b)(qMatch)).exceededCap;
        },
        get protectedAtoms () {
            return $3707a6d0464531d4$var$read(protectedAtoms, ()=>(0, $15a748fe8f16730a$export$a6894629479d4cdc)(qMatch));
        },
        get hasNonLatinLetter () {
            return $3707a6d0464531d4$var$read(nonLatin, ()=>(0, $49bd71f0e508fca4$export$c208c604230c442d)(qMatch));
        },
        get terminalPunctuation () {
            return $3707a6d0464531d4$var$read(terminalPunctuation, ()=>(0, $49bd71f0e508fca4$export$a216d4171371eb32)(qMatch));
        },
        get navigationTarget () {
            return $3707a6d0464531d4$var$read(navigationTarget, ()=>(0, $3a64d3a27a6b3e6b$export$a47366ee6290ca)(qMatch));
        }
    };
};






const $6b35f389f0fff91b$export$936699d77f5a15d1 = (features, { cues: cues, exclusions: exclusions = [], allowRequestPrefix: allowRequestPrefix = true })=>{
    const qMatch = features.qMatch;
    // Exclusions are checked against the whole query so an excluded span cannot be
    // smuggled in behind a request prefix.
    if (exclusions.some((exclusion)=>(0, $b42fe61caa94402a$export$cec6318cbd95e5ee)(qMatch, [
            exclusion
        ]) !== null)) return null;
    const prefix = allowRequestPrefix ? (0, $b42fe61caa94402a$export$cec6318cbd95e5ee)(qMatch, (0, $c56addc33acf11a0$export$bed0bcaf7f89f7a7)) : null;
    const cue = (0, $b42fe61caa94402a$export$cec6318cbd95e5ee)(prefix ? prefix.rest : qMatch, cues);
    if (!cue || !(0, $d3d1e06ac0ff14e2$export$2e37c471b771b5bd)(cue.rest)) return null;
    return {
        span: cue.rest,
        hasRequestPrefix: prefix !== null,
        cue: cue.phrase
    };
};



const $3a2eb807da90727b$export$6029cd0dc0ef5eac = (features)=>(0, $6b35f389f0fff91b$export$936699d77f5a15d1)(features, {
        cues: (0, $c56addc33acf11a0$export$ebb45db9043173ec)
    }) !== null;
const $3a2eb807da90727b$export$d2c605878905b0fe = {
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).CHAT,
    pattern: 'ACTION_REQUEST',
    matches: $3a2eb807da90727b$export$6029cd0dc0ef5eac
};




const $f04ce57a3445aa55$export$91bacd5ff334a98 = (features)=>(0, $3a64d3a27a6b3e6b$export$9712699da2be3add)(features.qMatch) !== null && !features.navigationTarget;
const $f04ce57a3445aa55$export$4ea14787e817e054 = {
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).FPS,
    pattern: 'AMBIGUOUS_OPEN',
    matches: $f04ce57a3445aa55$export$91bacd5ff334a98
};








/**
 * `C-WH-QUESTION` (priority 930) — a wh-word opens the query.
 *
 * The question grammars sit above `S-SHORT` deliberately. `what is SEO` is three
 * tokens and `what's SHA` is two, and under the earlier ordering the short fallback
 * claimed both — the single worst class of miss, because a question is the one thing
 * Search cannot answer.
 *
 * Four boundaries keep it precise:
 *
 * - **A question mark is optional here.** `where is the launch plan` is a question
 *   without one. A query that *has* one is claimed by `C-TERMINAL-QUESTION` below
 *   instead, so this grammar never has to reason about punctuation.
 * - **At least two word-like tokens**, so a lone `why` stays a search term.
 * - **Subject operand evidence**, so `what is it` has nothing to ask about.
 * - **Non-numeric remainder**, so `what 12 34` stays on Search.
 *
 * `hasNonLatinLetter=false` scopes it to the reviewed English shape. Non-English
 * phrasing is not unsupported — it is routed to the residual layer, where a launched
 * server-model language slice can judge it.
 *
 * Contracted forms accept the ASCII apostrophe, the curly apostrophe, and the
 * apostrophe-free spelling. `which` and `whose` have no contracted form.

 */ const $03cdf3fe3ead5011$var$CONTRACTION_SUFFIX = /^(.*?)(?:['’]s|s)$/u;
const $03cdf3fe3ead5011$export$343aaa477269e3e5 = (token)=>{
    const folded = token.toLowerCase();
    if ((0, $c56addc33acf11a0$export$b038760db621922d).includes(folded)) return true;
    const contraction = $03cdf3fe3ead5011$var$CONTRACTION_SUFFIX.exec(folded);
    return contraction !== null && (0, $c56addc33acf11a0$export$6ce55be9e64b410c).includes(contraction[1]);
};
const $03cdf3fe3ead5011$export$a5506fddaa360bf5 = (qMatch, firstToken)=>{
    const index = qMatch.toLowerCase().indexOf(firstToken.toLowerCase());
    return index === -1 ? '' : qMatch.slice(index + firstToken.length);
};
const $03cdf3fe3ead5011$export$9ebc800b751d27c = (features)=>{
    if (features.hasNonLatinLetter) return false;
    const tokens = features.wordTokens;
    if (tokens.length < 2 || !$03cdf3fe3ead5011$export$343aaa477269e3e5(tokens[0])) return false;
    const remainder = $03cdf3fe3ead5011$export$a5506fddaa360bf5(features.qMatch, tokens[0]);
    return !(0, $d3d1e06ac0ff14e2$export$58b363b34f5a077)(remainder) && (0, $d3d1e06ac0ff14e2$export$2e37c471b771b5bd)(remainder);
};
const $03cdf3fe3ead5011$export$4e06e6137b27213e = {
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).CHAT,
    pattern: 'WH_QUESTION',
    matches: $03cdf3fe3ead5011$export$9ebc800b751d27c
};


const $81040d7b65572f6b$export$d226b9ab633b051c = (features)=>{
    if (features.hasNonLatinLetter || features.terminalPunctuation !== '?') return false;
    const tokens = features.wordTokens;
    if (tokens.length < 2 || !(0, $c56addc33acf11a0$export$258b045db4e92934).includes(tokens[0].toLowerCase())) return false;
    return (0, $d3d1e06ac0ff14e2$export$2e37c471b771b5bd)((0, $03cdf3fe3ead5011$export$a5506fddaa360bf5)(features.qMatch, tokens[0]));
};
const $81040d7b65572f6b$export$58a6d89826b93309 = {
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).CHAT,
    pattern: 'AUX_QUESTION',
    matches: $81040d7b65572f6b$export$d226b9ab633b051c
};



const $088274c9e5acedee$export$20dc2cc9cbe0ae69 = {
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).FPS,
    // The design table spells this reason `NO_MATCH`. It means exactly what this
    // package's pre-existing `NO_PATTERN` already means, so there is one value
    // rather than two names for one condition.
    pattern: 'NO_PATTERN',
    matches: ()=>true
};




const $bb0678c0b287d616$export$5e495e75001b7984 = (features)=>{
    if (features.qMatch.length === 0) return true;
    // Oversized input is not trivial, it is oversized — and deciding otherwise would mean
    // segmenting a paste this engine has already decided not to classify.
    if (features.exceedsCodePointLimit) return false;
    const tokens = features.wordTokens;
    if (tokens.length === 0) return true;
    // One letter versus more than one is the whole question, so stop counting at two.
    return tokens.length === 1 && (0, $5b2dcc709ee71f91$export$5d8f8a240ab6d489)(tokens[0], 2) === 1;
};
const $bb0678c0b287d616$export$628793b2cca7d854 = {
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).FPS,
    pattern: 'EMPTY_OR_TRIVIAL',
    matches: $bb0678c0b287d616$export$5e495e75001b7984
};





const $ac94b44668ee51b0$export$8841b806afa7dc29 = (features)=>(0, $6b35f389f0fff91b$export$936699d77f5a15d1)(features, {
        cues: (0, $c56addc33acf11a0$export$96061f3f92adaeec)
    }) !== null;
const $ac94b44668ee51b0$export$4bf50b3245bca395 = {
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).CHAT,
    pattern: 'EXPLAIN_REQUEST',
    matches: $ac94b44668ee51b0$export$8841b806afa7dc29
};



const $841d2f253a0125c6$export$6ea845486e3f5160 = (features)=>features.exceedsCodePointLimit || features.exceededWordTokenCap;
const $841d2f253a0125c6$export$6dbaaf10cbc1d186 = {
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).FPS,
    pattern: 'INPUT_LIMIT',
    matches: $841d2f253a0125c6$export$6ea845486e3f5160
};






const $6bb3b93755f7d016$export$a487f710855499d4 = (features)=>{
    const qMatch = features.qMatch;
    const politeness = (0, $b42fe61caa94402a$export$cec6318cbd95e5ee)(qMatch, (0, $c56addc33acf11a0$export$fabe3e6f39926741));
    const cue = (0, $b42fe61caa94402a$export$cec6318cbd95e5ee)(politeness ? politeness.rest : qMatch, (0, $c56addc33acf11a0$export$1255c0baaaa2b423));
    if (cue) return (0, $d3d1e06ac0ff14e2$export$2e37c471b771b5bd)(cue.rest);
    // `open` is resolved through the shared navigation-target feature so this rule and
    // `S-AMBIGUOUS-OPEN` can never disagree about what counts as a target. The feature is
    // false unless an `open` cue leads the query, so no separate cue check is needed here.
    return features.navigationTarget;
};
const $6bb3b93755f7d016$export$e0b9ff90ed07df89 = {
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).FPS,
    pattern: 'NAVIGATE',
    matches: $6bb3b93755f7d016$export$a487f710855499d4
};






const $1d9348b10bc014c3$export$9d723fe297f819f8 = (features)=>{
    const qMatch = features.qMatch;
    const trailingFrame = (0, $b42fe61caa94402a$export$9c28b4388f35e83e)(qMatch, (0, $c56addc33acf11a0$export$b3df2c211b86176));
    const body = trailingFrame ? trailingFrame.rest : qMatch;
    const prefix = (0, $b42fe61caa94402a$export$cec6318cbd95e5ee)(body, (0, $c56addc33acf11a0$export$bed0bcaf7f89f7a7));
    const cue = (0, $b42fe61caa94402a$export$cec6318cbd95e5ee)(prefix ? prefix.rest : body, (0, $c56addc33acf11a0$export$455555cb8284311b));
    if (!cue || (0, $b42fe61caa94402a$export$cec6318cbd95e5ee)(cue.rest, (0, $c56addc33acf11a0$export$de969193fc0be256)) || !(0, $d3d1e06ac0ff14e2$export$2e37c471b771b5bd)(cue.rest)) return null;
    return {
        isFramed: prefix !== null || trailingFrame !== null
    };
};
const $1d9348b10bc014c3$export$f54325cc9f9d8092 = {
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).CHAT,
    pattern: 'REQUEST_FRAME',
    matches: (features)=>$1d9348b10bc014c3$export$9d723fe297f819f8(features)?.isFramed === true
};
const $1d9348b10bc014c3$export$954b9d4e7969748f = {
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).CHAT,
    pattern: 'REQUEST_BARE',
    matches: (features)=>$1d9348b10bc014c3$export$9d723fe297f819f8(features)?.isFramed === false
};





const $226ec7386306d810$export$6854cb6494f52e25 = (features)=>(0, $6b35f389f0fff91b$export$936699d77f5a15d1)(features, {
        cues: (0, $c56addc33acf11a0$export$7ee63605166d4aa3),
        exclusions: (0, $c56addc33acf11a0$export$e47a3ecb077c8e1c)
    }) !== null;
const $226ec7386306d810$export$5bb68268d6456c6b = {
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).CHAT,
    pattern: 'RETRIEVE_REQUEST',
    matches: $226ec7386306d810$export$6854cb6494f52e25
};




const $e91e4fbca2425ad1$export$7ce7ee9441e5a1a5 = (features)=>{
    const tokenCount = features.wordTokens.length;
    return tokenCount > 0 && tokenCount <= (0, $13d148987efba1d6$export$a077554631aef03);
};
const $e91e4fbca2425ad1$export$2fa74ec7867b4d92 = {
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).FPS,
    pattern: 'SHORT_QUERY',
    matches: $e91e4fbca2425ad1$export$7ce7ee9441e5a1a5
};





const $6693418a44f81dd9$export$77d4821c1d8dbde9 = (features)=>{
    const atom = (0, $15a748fe8f16730a$export$427521dd938a1d14)(features.qMatch, features.protectedAtoms);
    if (!atom) return false;
    if (atom.kind !== 'QUOTED') return true;
    // Strip the surrounding quote pair before asking whether a title is really there.
    const inner = atom.text.slice(1, -1);
    return (0, $5b2dcc709ee71f91$export$f6c6dd1d752911b)(inner).tokens.length > 0;
};
const $6693418a44f81dd9$export$abcd404ac229bced = {
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).FPS,
    pattern: 'STRUCTURED_INPUT',
    matches: $6693418a44f81dd9$export$77d4821c1d8dbde9
};



const $8e94ea769ff082d7$export$24dc7694781e04bc = (features)=>features.terminalPunctuation === '?';
const $8e94ea769ff082d7$export$22ba27fae4161c7d = {
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).CHAT,
    pattern: 'TERMINAL_QUESTION',
    matches: $8e94ea769ff082d7$export$24dc7694781e04bc
};







/**
 * `C-TRANSFORM` (priority 945) — do something to content the user names.
 *
 * Two arities, because they need different evidence:
 *
 * - `summarize`, `rewrite`, `extract`, `draft`, `translate` take one complete operand.
 * - `compare` takes two, separated by exactly `and`, `with`, `vs`, or `versus` **outside**
 *   protected ranges — so `compare "a and b" with c` splits on `with`, not on the `and`
 *   inside the quoted title.
 */ const $0f475c9145e69205$var$matchesCompare = (features)=>{
    const qMatch = features.qMatch;
    const prefix = (0, $b42fe61caa94402a$export$cec6318cbd95e5ee)(qMatch, (0, $c56addc33acf11a0$export$bed0bcaf7f89f7a7));
    const cue = (0, $b42fe61caa94402a$export$cec6318cbd95e5ee)(prefix ? prefix.rest : qMatch, [
        (0, $c56addc33acf11a0$export$d1c92911fa803027)
    ]);
    if (!cue) return false;
    const split = (0, $b42fe61caa94402a$export$8fc7d7f700b600f9)(cue.rest, (0, $c56addc33acf11a0$export$4f39eb4cf287981e));
    return split !== null && (0, $d3d1e06ac0ff14e2$export$2e37c471b771b5bd)(split.left) && (0, $d3d1e06ac0ff14e2$export$2e37c471b771b5bd)(split.right);
};
const $0f475c9145e69205$export$e90625bf14c3ec34 = (features)=>(0, $6b35f389f0fff91b$export$936699d77f5a15d1)(features, {
        cues: (0, $c56addc33acf11a0$export$18f3ddd305ccb6d1)
    }) !== null || $0f475c9145e69205$var$matchesCompare(features);
const $0f475c9145e69205$export$4f4728fb1ed123a6 = {
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).CHAT,
    pattern: 'TRANSFORM',
    matches: $0f475c9145e69205$export$e90625bf14c3ec34
};



/**
 * The convergence rules, in evaluation order.
 *
 * SOURCE: "Search x Chat Convergence - MVP Triggering Architecture", Canonical
 * all-in-one rule catalog.
 * https://hello.atlassian.net/wiki/spaces/jirasearch/pages/7525895377
 *
 * **Position is behaviour**: this array *is* the evaluation order, and moving a rule
 * changes classifications. `resolve-matchers.test.ts` asserts the exact order. The
 * design's priority numbers are recorded in each matcher's doc comment as provenance,
 * not repeated here as data — they had no runtime use.
 *
 * The Jira-only native-navigation band (`N-JQL`, `N-ISSUE-KEY`, `N-NUMERIC`,
 * `N-SINGLE-TOKEN`, priorities 1060–1090) is **absent by design**: Confluence and Rovo
 * Home have no native issue navigator to route to. No rule here emits `GNIN`, which the
 * test suite asserts. That band belongs to a future Jira pack.
 */ const $ec3d52536868bced$var$CONVERGENCE_RULES = Object.freeze([
    // Hard preflight — runs before every product rule.
    (0, $bb0678c0b287d616$export$628793b2cca7d854),
    (0, $841d2f253a0125c6$export$6dbaaf10cbc1d186),
    // Final Search protections — nothing below these can override them.
    (0, $6693418a44f81dd9$export$abcd404ac229bced),
    (0, $6bb3b93755f7d016$export$e0b9ff90ed07df89),
    // High-confidence Chat.
    (0, $3a2eb807da90727b$export$d2c605878905b0fe),
    (0, $ac94b44668ee51b0$export$4bf50b3245bca395),
    (0, $226ec7386306d810$export$5bb68268d6456c6b),
    (0, $0f475c9145e69205$export$4f4728fb1ed123a6),
    (0, $1d9348b10bc014c3$export$f54325cc9f9d8092),
    (0, $1d9348b10bc014c3$export$954b9d4e7969748f),
    // Bounded question grammars — above the length fallback, deliberately.
    (0, $03cdf3fe3ead5011$export$4e06e6137b27213e),
    (0, $81040d7b65572f6b$export$58a6d89826b93309),
    // Any remaining question-marked query, in any script. Below the grammars so the more
    // specific reason wins; above the short guards, which is what makes `why?` a question.
    (0, $8e94ea769ff082d7$export$22ba27fae4161c7d),
    // Short-input guards.
    (0, $e91e4fbca2425ad1$export$2fa74ec7867b4d92),
    (0, $f04ce57a3445aa55$export$4ea14787e817e054),
    // Terminal catch-all: anything left is residual.
    (0, $088274c9e5acedee$export$20dc2cc9cbe0ae69)
]);
const $ec3d52536868bced$export$b88fb1ba9c5fe58d = ()=>$ec3d52536868bced$var$CONVERGENCE_RULES;


const $f58c3f12730649be$export$9065ec9dbf9ce0c5 = (input)=>{
    const features = (0, $3707a6d0464531d4$export$39cc066cc9a5aa04)(input);
    const matched = (0, $ec3d52536868bced$export$b88fb1ba9c5fe58d)().find((rule)=>rule.matches(features));
    // The terminal rule matches everything, so `matched` is always set. The fallback keeps
    // that from being an assertion, and produces the same response the terminal rule would.
    const pattern = matched?.pattern ?? 'NO_PATTERN';
    return {
        didMatch: pattern !== 'NO_PATTERN',
        type: matched?.type ?? (0, $15144e47939e470d$export$a6c4835f6717e27f).FPS,
        pattern: pattern
    };
};





const $3d2dd5525c73d66f$export$6744d82fbacfe3c5 = {
    pattern: 'EMPTY',
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).GNIN,
    matches: (input)=>input.trim().length === 0
};



/**
 * PORTED FROM: `JqlUtils.isJql`
 * https://bitbucket.org/atlassian/xp-knowledge-discovery/src/f02f6dd19b50e91f20c6ab94d493ce7764e76eb1/src/main/java/io/atlassian/micros/xpknowledgediscovery/util/JqlUtils.java#lines-121
 *
 * A direct port of the backend's regex-based JQL detection. It is deliberately
 * **not** a real JQL parse: it recognises the *shape* of a query whose first
 * token is a known field followed by an operator, and nothing more.
 *
 * That distinction matters: `foo = bar` is syntactically valid JQL but is not
 * detected, because `foo` is not in the field allowlist. Parsing properly would
 * disagree with the backend on exactly those inputs.
 */ /**
 * PORTED FROM: `JqlUtils.JQL_FIELDS`
 * https://bitbucket.org/atlassian/xp-knowledge-discovery/src/f02f6dd19b50e91f20c6ab94d493ce7764e76eb1/src/main/java/io/atlassian/micros/xpknowledgediscovery/util/JqlUtils.java#lines-9
 *
 * Kept in the upstream order so the two lists can be diffed by eye.
 */ const $39367cac9767d990$var$JQL_FIELDS = [
    'affectedversion',
    'approvals',
    'assignee',
    'attachments',
    'category',
    'change-gating-type',
    'comment',
    'component',
    'created',
    'createddate',
    'creator',
    'description',
    'due',
    'duedate',
    'environment',
    'filter',
    'request',
    'savedfilter',
    'searchrequest',
    'fixversion',
    'hierarchylevel',
    'journeyid',
    'journeyparentoftypeid',
    'journeytypeid',
    'journeytypeversion',
    'journeyworkitemid',
    'labels',
    'lastviewed',
    'level',
    'organizations',
    'originalestimate',
    'timeoriginalestimate',
    'parent',
    'parentproject',
    'priority',
    'project',
    'projecttype',
    'remainingestimate',
    'timeestimate',
    'reporter',
    'request-channel-type',
    'request-last-activity-time',
    'resolution',
    'resolved',
    'resolutiondate',
    'sprint',
    'status',
    'summary',
    'text',
    'textfields',
    'timespent',
    'type',
    'worktype',
    'updated',
    'updateddate',
    'voter',
    'votes',
    'watcher',
    'watchers',
    'worklogcomment',
    'worklogdate',
    'workitemkey',
    'id',
    'workitem',
    'key',
    'workitemlink',
    'workitemlinktype',
    'workratio',
    'space'
];
/**
 * PORTED FROM: `JqlUtils.CHANGED_OPERATOR_FIELDS`
 * https://bitbucket.org/atlassian/xp-knowledge-discovery/src/f02f6dd19b50e91f20c6ab94d493ce7764e76eb1/src/main/java/io/atlassian/micros/xpknowledgediscovery/util/JqlUtils.java#lines-80
 */ const $39367cac9767d990$var$CHANGED_OPERATOR_FIELDS = [
    'assignee',
    'fixversion',
    'priority',
    'reporter',
    'resolution',
    'status'
];
/** Equivalent of Java's `Pattern.quote` for a single alternation branch. */ const $39367cac9767d990$var$escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
/**
 * Builds the field alternation.
 *
 * Sorted longest-first. Upstream this comes from a `Set.of(...)`, whose
 * iteration order is unspecified, and correctness there relies on regex
 * backtracking to eventually reach the longer alternative (so `createddate = x`
 * is not mis-read as the field `created`). Backtracking would get us the same
 * answer, but ordering explicitly makes the behaviour deterministic and
 * independent of how the list happens to be written.
 */ const $39367cac9767d990$var$toFieldsPattern = (fields)=>[
        ...fields
    ].sort((a, b)=>b.length - a.length).map($39367cac9767d990$var$escapeRegExp).join('|');
const $39367cac9767d990$var$FIELDS_PATTERN = $39367cac9767d990$var$toFieldsPattern($39367cac9767d990$var$JQL_FIELDS);
const $39367cac9767d990$var$CHANGED_FIELDS_PATTERN = $39367cac9767d990$var$toFieldsPattern($39367cac9767d990$var$CHANGED_OPERATOR_FIELDS);
/**
 * Emulates a Java atomic group `(?>...)`, which JavaScript has no syntax for.
 *
 * A lookahead captures the longest alternative that matches at this position,
 * and the backreference then consumes it — so the engine can never backtrack
 * into the group to try a shorter alternative.
 *
 * This is load-bearing, not pedantry. Upstream both operator groups are atomic.
 * Without it, `votes >=` would be treated as JQL: `>=` matches, the trailing
 * `.+` finds nothing left, and a non-atomic group would backtrack to `>` and
 * let `=` satisfy `.+`. Atomic matching refuses that, and so does the backend.
 *
 * The group is *named* rather than numbered so the backreference cannot be
 * knocked out of alignment by any other capture group in the pattern.
 */ const $39367cac9767d990$var$atomic = (alternation)=>`(?=(?<op>${alternation}))\\k<op>`;
const $39367cac9767d990$var$SYMBOL_OP_PATTERN = $39367cac9767d990$var$atomic('!=|>=|<=|!~|=|>|<|~');
const $39367cac9767d990$var$WORD_OP_PATTERN = $39367cac9767d990$var$atomic('was not in|not in|is not|was in|was not|in|not|is|was|changed');
/**
 * Java's `Matcher.matches()` requires the *entire* input to match, so every
 * pattern is anchored at both ends. `.` excludes newlines in both languages,
 * so no dot-all flag is used.
 */ const $39367cac9767d990$var$SYMBOL_JQL_PATTERN = new RegExp(`^(?:${$39367cac9767d990$var$FIELDS_PATTERN})\\s*${$39367cac9767d990$var$SYMBOL_OP_PATTERN}.+$`);
const $39367cac9767d990$var$WORD_JQL_PATTERN = new RegExp(`^(?:${$39367cac9767d990$var$FIELDS_PATTERN})\\s+${$39367cac9767d990$var$WORD_OP_PATTERN}\\b.+$`);
const $39367cac9767d990$var$ORDER_BY_PATTERN = new RegExp(`^order by\\s+(?:${$39367cac9767d990$var$FIELDS_PATTERN}).*$`);
const $39367cac9767d990$var$CHANGED_PATTERN = new RegExp(`^(?:${$39367cac9767d990$var$CHANGED_FIELDS_PATTERN})\\s+changed.*$`);
const $39367cac9767d990$export$7d94ced88cb7874b = (query)=>{
    if (query === null || query === undefined) return false;
    if (query.trim().length === 0) return true;
    const lower = query.toLowerCase().trim();
    return $39367cac9767d990$var$ORDER_BY_PATTERN.test(lower) || $39367cac9767d990$var$CHANGED_PATTERN.test(lower) || $39367cac9767d990$var$SYMBOL_JQL_PATTERN.test(lower) || $39367cac9767d990$var$WORD_JQL_PATTERN.test(lower);
};
const $39367cac9767d990$export$ed18d302d78c393f = {
    pattern: 'JQL',
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).GNIN,
    matches: $39367cac9767d990$export$7d94ced88cb7874b
};



/**
 * PORTED FROM: `HeuristicUtils.matchesNumericPattern` / `NUMERIC_PATTERN`
 * https://bitbucket.org/atlassian/xp-knowledge-discovery/src/f02f6dd19b50e91f20c6ab94d493ce7764e76eb1/src/main/java/io/atlassian/micros/xpknowledgediscovery/util/HeuristicUtils.java#lines-17
 *
 * Note this accepts *several* whitespace-separated numbers, not just one, and
 * allows a leading minus and a single decimal point on each.
 */ const $724b2171edb17d0a$var$NUMERIC_PATTERN = /^-?\d+(\.\d+)?(\s+-?\d+(\.\d+)?)*$/;
const $724b2171edb17d0a$export$ca940019d5e2dc61 = (query)=>$724b2171edb17d0a$var$NUMERIC_PATTERN.test(query.trim());
const $724b2171edb17d0a$export$6933cf3480864924 = {
    pattern: 'NUMERIC',
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).GNIN,
    matches: $724b2171edb17d0a$export$ca940019d5e2dc61
};



const $c510fe8c33e353ea$export$a4b16d5647ec0d0e = (query)=>!query.trim().includes(' ');
const $c510fe8c33e353ea$export$8d4205a11c65dee2 = {
    pattern: 'SINGLE_WORD',
    type: (0, $15144e47939e470d$export$a6c4835f6717e27f).GNIN,
    matches: $c510fe8c33e353ea$export$a4b16d5647ec0d0e
};


/**
 * Matchers that apply regardless of context.
 *
 * Intentionally empty. Everything ported so far is Jira intent detection, so
 * there is nothing yet that should run for every product.
 *
 * The slot is kept because cross-product matchers are expected later, and
 * because it documents that "universal" is a deliberate category rather than
 * somewhere matchers drift into by default. Adding one here switches it on for
 * every context at once, so it should be a considered decision.
 */ const $f99bd0f9bb3ee6ef$var$UNIVERSAL_MATCHERS = Object.freeze([]);
/**
 * Jira matchers, in the order upstream evaluates them.
 *
 * PORTED FROM: `GninHeuristicStrategy.classifyInternal`
 * https://bitbucket.org/atlassian/xp-knowledge-discovery/src/f02f6dd19b50e91f20c6ab94d493ce7764e76eb1/src/main/java/io/atlassian/micros/xpknowledgediscovery/services/strategy/GninHeuristicStrategy.java#lines-65
 *
 * This order is **not** a local preference — it is the upstream sequence of
 * `if` statements, and changing it changes classifications. In particular
 * `empty` must precede `jql`, because `isJql` reports blank input as JQL.
 *
 * Universal matchers are appended last, so a future cross-product matcher can
 * never pre-empt a confident Jira-specific one.
 */ const $f99bd0f9bb3ee6ef$var$JIRA_MATCHERS = Object.freeze([
    (0, $3d2dd5525c73d66f$export$6744d82fbacfe3c5),
    (0, $39367cac9767d990$export$ed18d302d78c393f),
    (0, $724b2171edb17d0a$export$6933cf3480864924),
    (0, $c510fe8c33e353ea$export$8d4205a11c65dee2),
    ...$f99bd0f9bb3ee6ef$var$UNIVERSAL_MATCHERS
]);
const $f99bd0f9bb3ee6ef$export$b88fb1ba9c5fe58d = (context = {})=>{
    if (context.primaryProduct === (0, $15144e47939e470d$export$8085bec54c027530).JIRA) return $f99bd0f9bb3ee6ef$var$JIRA_MATCHERS;
    return $f99bd0f9bb3ee6ef$var$UNIVERSAL_MATCHERS;
};


const $1a09ed94383663f4$export$9065ec9dbf9ce0c5 = (input, context = {})=>{
    const trimmed = input.trim();
    const matched = (0, $f99bd0f9bb3ee6ef$export$b88fb1ba9c5fe58d)(context).find((matcher)=>matcher.matches(trimmed));
    if (!matched) return {
        didMatch: false,
        type: (0, $15144e47939e470d$export$a6c4835f6717e27f).FPS,
        pattern: 'NO_PATTERN'
    };
    return {
        didMatch: true,
        type: matched.type,
        pattern: matched.pattern
    };
};


const $8adf45a1a49f5e12$export$9065ec9dbf9ce0c5 = (input, context = {})=>{
    const shouldUseConvergenceRules = context.primaryProduct === (0, $15144e47939e470d$export$8085bec54c027530).CONFLUENCE || context.primaryProduct === (0, $15144e47939e470d$export$8085bec54c027530).HOME;
    return shouldUseConvergenceRules ? (0, $f58c3f12730649be$export$9065ec9dbf9ce0c5)(input) : (0, $1a09ed94383663f4$export$9065ec9dbf9ce0c5)(input, context);
};



var $9C63M = parcelRequire("9C63M");
var $aHhuQ = parcelRequire("aHhuQ");



var $43H9l = parcelRequire("43H9l");


const $dee6eec1ba37ab36$export$af8bbbb5148dbc55 = async (input, options)=>{
    const response = await (0, $43H9l.searchChatIntentDetectionQuery)({
        // This endpoint uses the ARI owner to authorize the product. The multi-site search helper can
        // return a product-agnostic platform ARI, which the intent-detection backend rejects.
        siteId: `ari:cloud:${options.primaryProduct}::site/${options.cloudId}`,
        query: input,
        locale: options.locale,
        modelVersion: options.model
    });
    const result = response.data?.knowledgeDiscovery.searchChatIntentDetection;
    if (result?.__typename !== 'KnowledgeDiscoverySearchChatIntentDetectionSuccess') throw new Error('Search/Chat intent detection returned an unsuccessful response');
    // The backend returns no rule pattern. This adapter is only invoked for input left unresolved by
    // local rules, so the convergence design's `RESIDUAL` reason describes the route to this result.
    return {
        didMatch: true,
        type: result.decision === 'CHAT' ? (0, $15144e47939e470d$export$a6c4835f6717e27f).CHAT : (0, $15144e47939e470d$export$a6c4835f6717e27f).FPS,
        pattern: 'RESIDUAL',
        modelVersion: result.modelVersion
    };
};



var $a8RYh = parcelRequire("a8RYh");




var $b8bXF = parcelRequire("b8bXF");


const $fd41bf8770aca2f1$var$knownIntentPatterns = [
    'EMPTY',
    'JQL',
    'NUMERIC',
    'QUESTION',
    'SINGLE_WORD',
    'NO_PATTERN'
];
const $fd41bf8770aca2f1$var$toIntentPattern = (pattern)=>$fd41bf8770aca2f1$var$knownIntentPatterns.includes(pattern) ? pattern : 'NO_PATTERN';
const $fd41bf8770aca2f1$export$6ac4ae5c7caf2b79 = async (input, options)=>{
    const response = await (0, $43H9l.jiraIntentDetectionQuery)({
        query: input,
        siteId: options.siteId,
        orgId: options.orgId,
        sessionId: options.sessionId,
        experience: (0, $b8bXF.KnowledgeDiscoveryJiraSearchExperience).QUICK_FIND,
        model: options.model,
        includePatternType: true
    }, options.headers);
    const result = response.data?.knowledgeDiscovery.jiraIntentDetection;
    if (!(0, $a8RYh.isIntentDetectionSuccess)(result)) throw new Error('Jira intent detection returned an unsuccessful response');
    const classification = result.searchClassification;
    return {
        didMatch: classification.type !== null && classification.type !== undefined,
        type: classification.type ?? (0, $15144e47939e470d$export$a6c4835f6717e27f).FPS,
        pattern: $fd41bf8770aca2f1$var$toIntentPattern(classification.pattern)
    };
};


const $30c1ef01aa0626f0$export$9f84f96105e788c1 = 500;
class $30c1ef01aa0626f0$export$b0b08ad16c68d416 extends Error {
    constructor(timeoutMs){
        super(`Remote intent detection timed out after ${timeoutMs}ms`), this.timeoutMs = timeoutMs;
        this.name = 'IntentDetectionTimeoutError';
    }
}
const $30c1ef01aa0626f0$export$67a828e6f4a68bfc = async (promise, timeoutMs = $30c1ef01aa0626f0$export$9f84f96105e788c1)=>{
    try {
        return await (0, $9C63M.DegradablePromise).from(promise, ()=>{}, timeoutMs).promise();
    } catch (error) {
        if (error instanceof (0, $aHhuQ.DegradeError)) throw new $30c1ef01aa0626f0$export$b0b08ad16c68d416(timeoutMs);
        throw error;
    }
};
const $30c1ef01aa0626f0$export$7ddc00ad2e66f743 = (input, context, timeoutMs = $30c1ef01aa0626f0$export$9f84f96105e788c1)=>{
    const intentPromise = context.primaryProduct === (0, $15144e47939e470d$export$8085bec54c027530).JIRA ? (0, $fd41bf8770aca2f1$export$6ac4ae5c7caf2b79)(input, {
        siteId: context.siteId,
        orgId: context.orgId,
        sessionId: context.sessionId,
        model: context.model,
        headers: context.headers
    }) : (0, $dee6eec1ba37ab36$export$af8bbbb5148dbc55)(input, {
        primaryProduct: context.primaryProduct,
        cloudId: context.cloudId,
        locale: context.locale,
        model: context.model
    });
    return $30c1ef01aa0626f0$export$67a828e6f4a68bfc(intentPromise, timeoutMs);
};


/**
 * Safe default intent response when error handling is needed.
 *
 * Returns a no-match response (FPS routing) that is safe for callers to use.
 * This ensures that errors in local or remote classification do not break the
 * user experience — the input is simply passed to full-page search.
 */ const $3efb76e7662cf58b$var$createErrorFallbackIntent = ()=>({
        didMatch: false,
        type: 'FPS',
        pattern: 'NO_PATTERN'
    });
const $3efb76e7662cf58b$export$cb6d33e838d9fad = 250;
const $3efb76e7662cf58b$export$af41a2cc7e98a46b = ()=>{
    let pendingResolve;
    const resolvePending = (shouldExecute)=>{
        const resolve = pendingResolve;
        pendingResolve = undefined;
        resolve?.(shouldExecute);
    };
    const trigger = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(()=>resolvePending(true), $3efb76e7662cf58b$export$cb6d33e838d9fad, {
        leading: true,
        trailing: true
    });
    const schedule = ()=>{
        resolvePending(false);
        return new Promise((resolve)=>{
            pendingResolve = resolve;
            trigger();
        });
    };
    schedule.cancel = ()=>{
        trigger.cancel();
        resolvePending(false);
    };
    return schedule;
};
const $3efb76e7662cf58b$var$isConvergencePrimaryProduct = (primaryProduct)=>{
    const supportedProducts = (0, $15144e47939e470d$export$523ff7a47aadbc47);
    return primaryProduct !== undefined && supportedProducts.includes(primaryProduct);
};
const $3efb76e7662cf58b$var$isConvergenceIntentModel = (model)=>Object.values((0, $4TEhG.KnowledgeDiscoverySearchChatIntentDetectionModelVersion)).some((candidate)=>candidate === model);
const $3efb76e7662cf58b$var$resolveConvergenceIntentModel = (model)=>$3efb76e7662cf58b$var$isConvergenceIntentModel(model) ? model : (0, $4TEhG.KnowledgeDiscoverySearchChatIntentDetectionModelVersion).GEMMA3_1B_SCI_V1;
const $3efb76e7662cf58b$var$safelyNotifyObserver = (notify)=>{
    try {
        return notify();
    } catch  {
        return undefined;
    }
};
const $3efb76e7662cf58b$export$51ef7f51cf1cc69d = async (input, context, options = {})=>{
    let localIntent;
    try {
        localIntent = (0, $8adf45a1a49f5e12$export$9065ec9dbf9ce0c5)(input, context);
    } catch  {
        return {
            intent: $3efb76e7662cf58b$var$createErrorFallbackIntent(),
            source: 'local'
        };
    }
    if (localIntent.didMatch || !$3efb76e7662cf58b$var$isConvergencePrimaryProduct(context.primaryProduct) || !context.cloudId) return {
        intent: localIntent,
        source: 'local'
    };
    const shouldRunRemote = !options.signal?.aborted && (!options.scheduleRemoteIntent || await options.scheduleRemoteIntent()) && !options.signal?.aborted;
    if (!shouldRunRemote) return {
        intent: localIntent,
        source: 'local'
    };
    const requestObserver = $3efb76e7662cf58b$var$safelyNotifyObserver(()=>options.observeRemoteRequest?.(input));
    try {
        const remoteIntent = await (0, $30c1ef01aa0626f0$export$7ddc00ad2e66f743)(input, {
            primaryProduct: context.primaryProduct,
            cloudId: context.cloudId,
            locale: context.locale,
            model: $3efb76e7662cf58b$var$resolveConvergenceIntentModel(context.model)
        });
        $3efb76e7662cf58b$var$safelyNotifyObserver(()=>requestObserver?.onSuccess(remoteIntent));
        return {
            intent: remoteIntent,
            source: 'remote'
        };
    } catch (error) {
        $3efb76e7662cf58b$var$safelyNotifyObserver(()=>requestObserver?.onFailure(error));
        return {
            intent: localIntent,
            source: 'local'
        };
    }
};


const $5ac052324548ec3c$export$73672a0731384457 = ({ input: input, context: context, observeRemoteRequest: observeRemoteRequest })=>{
    const { model: model, primaryProduct: primaryProduct, cloudId: cloudId, locale: locale = 'en' } = context;
    const [result, setResult] = (0, $cozmU.useState)(null);
    const remoteIntentSchedulerRef = (0, $cozmU.useRef)(null);
    if (remoteIntentSchedulerRef.current === null) remoteIntentSchedulerRef.current = (0, $3efb76e7662cf58b$export$af41a2cc7e98a46b)();
    (0, $cozmU.useEffect)(()=>{
        const remoteIntentScheduler = remoteIntentSchedulerRef.current;
        return ()=>remoteIntentScheduler?.cancel();
    }, []);
    const observeRemoteRequestRef = (0, $cozmU.useRef)(observeRemoteRequest);
    observeRemoteRequestRef.current = observeRemoteRequest;
    (0, $cozmU.useEffect)(()=>{
        let isCurrent = true;
        const abortController = new AbortController();
        (0, $3efb76e7662cf58b$export$51ef7f51cf1cc69d)(input, {
            model: model,
            primaryProduct: primaryProduct,
            cloudId: cloudId,
            locale: locale
        }, {
            observeRemoteRequest: observeRemoteRequestRef.current,
            signal: abortController.signal,
            scheduleRemoteIntent: remoteIntentSchedulerRef.current ?? undefined
        }).then((nextResult)=>{
            if (isCurrent) setResult(nextResult);
        });
        return ()=>{
            isCurrent = false;
            abortController.abort();
        };
    }, [
        cloudId,
        input,
        locale,
        model,
        primaryProduct
    ]);
    return {
        intent: result?.intent ?? null,
        source: result?.source ?? null
    };
};
module.exports["useInputIntent"] = $5ac052324548ec3c$export$73672a0731384457;

});

parcelRegister("9C63M", function(module, exports) {
$parcel$export(module.exports, "DegradeError", () => (parcelRequire("aHhuQ")).DegradeError);

var $aHhuQ = parcelRequire("aHhuQ");

const $40115e6ed8d3612b$export$ff01cc10d3c607be = 6000; // default timeout
const $40115e6ed8d3612b$var$DEGRADE_ERROR = new (0, $aHhuQ.DegradeError)('Promise is degraded');
class $40115e6ed8d3612b$export$ea6d6e4c9647fa9 {
    static from(wrapped, degradationCallback = ()=>{}, timeoutMs) {
        return new $40115e6ed8d3612b$export$ea6d6e4c9647fa9(wrapped, degradationCallback, timeoutMs ?? $40115e6ed8d3612b$export$ff01cc10d3c607be);
    }
    constructor(wrapped, degradationCallback, timeoutMs = $40115e6ed8d3612b$export$ff01cc10d3c607be){
        this.degradablePromiseInternal = void 0;
        this.degradeTimeout = void 0;
        this.timeoutMs = void 0;
        this.degradeInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.timeout = ()=>{
            this.degradeInternal();
        };
        this.promise = ()=>this.degradablePromiseInternal;
        const degrader = new Promise((_, reject)=>{
            this.degradeInternal = ()=>{
                reject($40115e6ed8d3612b$var$DEGRADE_ERROR);
                degradationCallback('timeout');
            };
        });
        // Call the degradation callback with 'failed' if the wrapped promise fails, easy way to track metrics at fetch level
        wrapped.catch(()=>{
            degradationCallback('failure');
        });
        // Build a finally chain into the wrapped promise so if it resolves early, we cancel the degradation
        const wrappedFinally = wrapped.finally(()=>{
            if (this.degradeTimeout) clearTimeout(this.degradeTimeout);
        });
        const wrapper = Promise.race([
            wrappedFinally,
            degrader
        ]);
        this.degradablePromiseInternal = wrapper;
        this.timeoutMs = timeoutMs ?? $40115e6ed8d3612b$export$ff01cc10d3c607be;
        this.degradeTimeout = setTimeout(this.timeout, this.timeoutMs);
    }
}
module.exports["DegradablePromise"] = $40115e6ed8d3612b$export$ea6d6e4c9647fa9;

});

parcelRegister("aHhuQ", function(module, exports) {
class $b0ed35fbaacb89be$export$85bf8e4fb143676a extends Error {
    constructor(...args){
        super(...args);
        this.isDegraded = true;
    }
}
module.exports["DegradeError"] = $b0ed35fbaacb89be$export$85bf8e4fb143676a;

});

parcelRegister("43H9l", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $b0Mpu = parcelRequire("b0Mpu");


var $5HOm2 = parcelRequire("5HOm2");


var $hsKin = parcelRequire("hsKin");


var $1o8wA = parcelRequire("1o8wA");


var $bHHWv = parcelRequire("bHHWv");

/**
 * In-memory cache for Search/Chat intent detection responses.
 *
 * Pending promises are shared by callers with the same cache key. Successful responses remain
 * available for the default cache TTL, while rejected entries are cleared so failures can retry.
 */ const $ad078d775a088ad1$var$searchChatIntentDetectionCache = (0, $bHHWv.inMemoryCache)();
const $ad078d775a088ad1$export$1c8fe7d8eee86c14 = async (key, supplier)=>$ad078d775a088ad1$var$searchChatIntentDetectionCache.inMemoryDecorator(key, supplier);
const $ad078d775a088ad1$export$d3e94d2199eda417 = (key)=>{
    $ad078d775a088ad1$var$searchChatIntentDetectionCache.clear(key);
};



var $a8RYh = parcelRequire("a8RYh");



var $4TEhG = parcelRequire("4TEhG");

const $52a3be260cad254f$var$GQL_KNOWLEDGE_DISCOVERY_INTENT_OPERATION_NAME = 'KnowledgeDiscoveryJiraIntentDetectionQuery';
const $52a3be260cad254f$var$GQL_SEARCH_CHAT_INTENT_OPERATION_NAME = 'KnowledgeDiscoverySearchChatIntentDetectionQuery';
/**
 * GraphQL query string for Jira intent detection.
 */ const $52a3be260cad254f$var$jiraIntentDetectionQueryString = `query ${$52a3be260cad254f$var$GQL_KNOWLEDGE_DISCOVERY_INTENT_OPERATION_NAME}(
	$siteId: String!
	$orgId: String!
	$query: String!
	$experience: KnowledgeDiscoveryJiraSearchExperience!
	$model: KnowledgeDiscoveryJiraIntentDetectionModel!
	$sessionId: String
	$includePatternType: Boolean!
) {
	knowledgeDiscovery {
		jiraIntentDetection(
			siteId: $siteId
			orgId: $orgId
			query: $query
			experience: $experience
			model: $model
			sessionId: $sessionId
		) @optIn(to: "KnowledgeDiscovery Jira Intent Detection") {
			__typename
			... on KnowledgeDiscoveryJiraIntentDetection {
				searchClassification {
					type
					pattern @include(if: $includePatternType)
				}
			}
			... on QueryError {
				message
			}
		}
	}
}`;
/** GraphQL query string for Search/Chat convergence intent detection. */ const $52a3be260cad254f$var$searchChatIntentDetectionQueryString = `query ${$52a3be260cad254f$var$GQL_SEARCH_CHAT_INTENT_OPERATION_NAME}(
	$siteId: String!
	$query: String!
	$locale: String!
	$modelVersion: KnowledgeDiscoverySearchChatIntentDetectionModelVersion!
) {
	knowledgeDiscovery {
		searchChatIntentDetection(
			siteId: $siteId
			query: $query
			locale: $locale
			modelVersion: $modelVersion
		) @optIn(to: "KnowledgeDiscovery Search Chat Intent Detection") {
			__typename
			... on KnowledgeDiscoverySearchChatIntentDetectionSuccess {
				decision
				modelVersion
			}
			... on QueryError {
				message
			}
		}
	}
}`;
const $52a3be260cad254f$export$9e4d70b1495bfcd7 = async (variables, headers)=>{
    const cacheKey = (0, $hsKin.createCacheKey)(variables);
    return (0, $1o8wA.intentDetectionCache).inMemoryDecorator(cacheKey, async ()=>{
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $52a3be260cad254f$var$jiraIntentDetectionQueryString,
            variables: variables,
            operationName: $52a3be260cad254f$var$GQL_KNOWLEDGE_DISCOVERY_INTENT_OPERATION_NAME,
            headers: {
                'X-ExperimentalApi': 'KnowledgeDiscovery',
                ...headers
            }
        });
        const hasGraphQLErrors = response.errors?.some((error)=>error);
        if (hasGraphQLErrors) return Promise.reject(response);
        const result = response.data?.knowledgeDiscovery.jiraIntentDetection;
        if (result?.__typename === 'QueryError') return Promise.reject(response);
        return response;
    });
};
const $52a3be260cad254f$export$5434a3dcbee50c36 = async (variables)=>{
    const cacheKey = (0, $hsKin.createSearchChatCacheKey)(variables);
    return (0, $ad078d775a088ad1$export$1c8fe7d8eee86c14)(cacheKey, async ()=>{
        const [product, cloudId] = (0, $5HOm2.getProductAndIDFromARI)(variables.siteId);
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $52a3be260cad254f$var$searchChatIntentDetectionQueryString,
            variables: variables,
            operationName: $52a3be260cad254f$var$GQL_SEARCH_CHAT_INTENT_OPERATION_NAME,
            headers: {
                'X-ExperimentalApi': 'KnowledgeDiscovery',
                ...(0, $AgYeH.buildAtlAttributionHeaders)({
                    cloudId: cloudId,
                    product: product
                })
            }
        });
        if (response.errors?.some(Boolean)) throw response;
        const result = response.data?.knowledgeDiscovery.searchChatIntentDetection;
        if (result?.__typename !== 'KnowledgeDiscoverySearchChatIntentDetectionSuccess') throw response;
        return response;
    });
};
module.exports["jiraIntentDetectionQuery"] = $52a3be260cad254f$export$9e4d70b1495bfcd7;
module.exports["searchChatIntentDetectionQuery"] = $52a3be260cad254f$export$5434a3dcbee50c36;

});

parcelRegister("AgYeH", function(module, exports) {
function $700a8f1c3e364ff2$export$2066b2fdce449999({ atlWorkspaceId: atlWorkspaceId, tenantId: tenantId, product: product }) {
    const atlAttributionHeader = {
        atlWorkspaceId: atlWorkspaceId,
        tenantId: tenantId,
        product: product
    };
    return JSON.stringify(atlAttributionHeader);
}
function $700a8f1c3e364ff2$export$dbbc0a36865f0300({ cloudId: cloudId, product: product = 'platform', activationId: activationId }) {
    if (!cloudId) return undefined;
    const atlWorkspaceId = activationId ? `ari:cloud:${product}:${cloudId}:workspace/${activationId}` : undefined;
    const headerValue = $700a8f1c3e364ff2$export$2066b2fdce449999({
        ...atlWorkspaceId ? {
            atlWorkspaceId: atlWorkspaceId
        } : {},
        tenantId: cloudId,
        product: product
    });
    return {
        'atl-attribution': headerValue
    };
}
module.exports["createAtlAttributionHeaderValue"] = $700a8f1c3e364ff2$export$2066b2fdce449999;
module.exports["buildAtlAttributionHeaders"] = $700a8f1c3e364ff2$export$dbbc0a36865f0300;

});

parcelRegister("5HOm2", function(module, exports) {

var $9cGsb = parcelRequire("9cGsb");

const $22e45ba5807383ad$export$d8a746fe35b1c95d = (ari)=>{
    const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $22e45ba5807383ad$export$fccbae65febb6fd4(ari) ? $22e45ba5807383ad$export$2f432ca99e30467e(ari) : (0, $9cGsb.parse)(ari);
    return [
        resourceOwner,
        cloudId,
        resourceType,
        resourceId
    ];
};
const $22e45ba5807383ad$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $22e45ba5807383ad$export$2f432ca99e30467e = (ari)=>{
    const result = $22e45ba5807383ad$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$22e45ba5807383ad$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner, resourceType, resourceId] = result;
    return {
        resourceId: resourceId,
        resourceOwner: resourceOwner,
        resourceType: resourceType,
        cloudId: resourceId
    };
};
const $22e45ba5807383ad$export$fccbae65febb6fd4 = (ari)=>$22e45ba5807383ad$var$thirdPartyRegex.test(ari);
module.exports["getProductAndIDFromARI"] = $22e45ba5807383ad$export$d8a746fe35b1c95d;
module.exports["parseThirdPartyARI"] = $22e45ba5807383ad$export$2f432ca99e30467e;

});

parcelRegister("9cGsb", function(module, exports) {
"use strict";
var $6b362a72760d8152$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $6b362a72760d8152$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bAWmc = parcelRequire("bAWmc");


$6b362a72760d8152$var$__export((parcelRequire("5ixmT")));
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ var $6b362a72760d8152$var$InvalidAriError = /** @class */ function(_super) {
    $6b362a72760d8152$var$__extends(InvalidAriError, _super);
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ function InvalidAriError(ariString, description) {
        var _this = _super.call(this, "Invalid ari string: " + ariString + (description ? '. ' + description : '')) || this;
        _this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(_this, InvalidAriError.prototype);
        return _this;
    }
    /**
   * Construct an InvalidAriError given some constraint violations
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
   */ InvalidAriError.withConstraintViolations = function(ariString, violations) {
        return new InvalidAriError(ariString, violations.map(function(v) {
            return v.toString();
        }).join('\n'));
    };
    return InvalidAriError;
}(Error);
module.exports.InvalidAriError = $6b362a72760d8152$var$InvalidAriError;
function $6b362a72760d8152$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
var $6b362a72760d8152$var$basicCharConstraint = $bAWmc.pattern(/^[a-z][a-z.-]*$/);
var $6b362a72760d8152$var$resourceOwnerConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
var $6b362a72760d8152$var$resourceTypeConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
var $6b362a72760d8152$var$cloudIdConstraints = [
    $bAWmc.lengthBetween(36, 255)
];
var $6b362a72760d8152$var$siteResourceType = 'site';
var $6b362a72760d8152$var$resourceIdChars = /[\w-._~:@#]/.source;
var $6b362a72760d8152$var$resourceIdConstraints = [
    $bAWmc.pattern(new RegExp("^" + $6b362a72760d8152$var$resourceIdChars + "+(/" + $6b362a72760d8152$var$resourceIdChars + "*)*(;v=" + $6b362a72760d8152$var$resourceIdChars + "*)*$"))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $6b362a72760d8152$var$upgrade(values) {
    var resourceId = values.resourceId, resourceOwner = values.resourceOwner, cloudId = values.cloudId;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $6b362a72760d8152$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
var $6b362a72760d8152$var$ResourceIdentifier = /** @class */ function() {
    /**
   * Create a new Ari
   *
   * Only the resourceOwner is a required field, any other field can be omitted.
   * Older format types are converted on creation
   *
   * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
   * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
   * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
   * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
   *
   * @throws {InvalidAriError} if the provided segments fail to pass validation
   */ function ResourceIdentifier(values) {
        var _a = $6b362a72760d8152$var$upgrade(values), resourceId = _a.resourceId, resourceOwner = _a.resourceOwner, resourceType = _a.resourceType, cloudId = _a.cloudId;
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    Object.defineProperty(ResourceIdentifier.prototype, "cloudId", {
        get: function() {
            if (this.resourceType === $6b362a72760d8152$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
            return this.internalCloudId;
        },
        enumerable: true,
        configurable: true
    });
    /**
  * Parse a string as an Ari
  *
  * @param {string} ariString - the string to parse
  * @returns {Ari} the parsed ari
  * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
  */ ResourceIdentifier.parse = function(ariString) {
        if (!ariString) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        var match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        var terms = match.map(function(a) {
            return a && a.length > 0 ? a : undefined;
        });
        var resourceOwner = terms[1];
        if (!resourceOwner) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        return new ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    };
    ResourceIdentifier.parseEncoded = function(encodedAriString) {
        return $6b362a72760d8152$var$parse(decodeURIComponent(encodedAriString));
    };
    /**
   * Converts this Ari to a string.
   */ ResourceIdentifier.prototype.toString = function() {
        if (!this.ariString) {
            var resourceId = this.resourceType === $6b362a72760d8152$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            var resourceType = this.resourceType || '';
            var sanitizedCloudId = this.resourceType === $6b362a72760d8152$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = "ari:cloud:" + this.resourceOwner + ":" + sanitizedCloudId + ":" + resourceType + "/" + resourceId;
        }
        return this.ariString;
    };
    /**
   * Converts this object to its json representation
   */ ResourceIdentifier.prototype.toJSON = function() {
        return this.toString();
    };
    /**
   * Checks if this context is the same as another context
   *
   * @param {Ari} other - the other parameter to match with
   * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
   */ ResourceIdentifier.prototype.equals = function(other) {
        return other instanceof ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    };
    /**
   * This method checks if the current context contains the other context.
   *
   * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
   * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
   *
   * @param {Ari} other
   * @returns {boolean}
   */ ResourceIdentifier.prototype.contains = function(other) {
        return this.matches(new ResourceIdentifier(other));
    };
    /**
   * Checks if this context is the same as or contains the provided context.
   *
   * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
   *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
   *
   * e.g.
   * ```
   * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
   * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
   *
   * @param {Ari} other - the other parameter to match with
   * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
   */ ResourceIdentifier.prototype.matches = function(other) {
        return $6b362a72760d8152$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $6b362a72760d8152$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceId, other.resourceId));
    };
    ResourceIdentifier.prototype.validateSiteWide = function() {
        var _a = this, resourceType = _a.resourceType, cloudId = _a.cloudId;
        if (resourceType === $6b362a72760d8152$var$siteResourceType && !cloudId) return new $bAWmc.GeneralValidationError('site wide ARIs must have a cloudId');
    };
    ResourceIdentifier.prototype.validate = function() {
        var constraintViolations = [
            $bAWmc.validateField(this, 'resourceOwner', $6b362a72760d8152$var$resourceOwnerConstraints),
            $bAWmc.validateField(this, 'resourceType', $6b362a72760d8152$var$resourceTypeConstraints),
            $bAWmc.validateField(this, 'resourceId', $6b362a72760d8152$var$resourceIdConstraints),
            $bAWmc.validateField(this, 'cloudId', $6b362a72760d8152$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter(function(v) {
            return v;
        });
        if (constraintViolations.length > 0) throw $6b362a72760d8152$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $6b362a72760d8152$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    };
    ResourceIdentifier.prototype.urlEncode = function() {
        return encodeURIComponent(this.toString());
    };
    ResourceIdentifier.prototype.urlDecode = function() {
        return decodeURIComponent(this.toString());
    };
    return ResourceIdentifier;
}();
module.exports.ResourceIdentifier = $6b362a72760d8152$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parse(ariString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $6b362a72760d8152$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parseEncoded(encodedAriString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $6b362a72760d8152$var$parseEncoded;

});

parcelRegister("bAWmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $871053056dfd3da9$var$LengthConstraint = /** @class */ function() {
    function LengthConstraint(min, max) {
        this.min = min;
        this.max = max;
    }
    Object.defineProperty(LengthConstraint.prototype, "description", {
        get: function() {
            return "length must be between " + this.min + " and " + this.max;
        },
        enumerable: true,
        configurable: true
    });
    LengthConstraint.prototype.isValid = function(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    };
    return LengthConstraint;
}();
module.exports.LengthConstraint = $871053056dfd3da9$var$LengthConstraint;
var $871053056dfd3da9$var$RegexConstraint = /** @class */ function() {
    function RegexConstraint(regex) {
        this.regex = regex;
    }
    Object.defineProperty(RegexConstraint.prototype, "description", {
        get: function() {
            return "value must match regex " + this.regex.source;
        },
        enumerable: true,
        configurable: true
    });
    RegexConstraint.prototype.isValid = function(value) {
        return !value || this.regex.test(value);
    };
    return RegexConstraint;
}();
module.exports.RegexConstraint = $871053056dfd3da9$var$RegexConstraint;
var $871053056dfd3da9$var$GeneralValidationError = /** @class */ function() {
    function GeneralValidationError(error) {
        this.error = error;
    }
    GeneralValidationError.prototype.toString = function() {
        return this.error;
    };
    return GeneralValidationError;
}();
module.exports.GeneralValidationError = $871053056dfd3da9$var$GeneralValidationError;
var $871053056dfd3da9$var$ConstraintViolation = /** @class */ function() {
    function ConstraintViolation(fieldName, value, constraints) {
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    ConstraintViolation.prototype.toString = function() {
        var constraintSummary = this.constraints.map(function(c) {
            return "  - " + c.description;
        }).join('\n');
        return "'" + this.value + "' is not a valid value for " + this.fieldName + " as it violates the following constraints:\n" + constraintSummary;
    };
    return ConstraintViolation;
}();
module.exports.ConstraintViolation = $871053056dfd3da9$var$ConstraintViolation;
function $871053056dfd3da9$var$lengthBetween(min, max) {
    return new $871053056dfd3da9$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $871053056dfd3da9$var$lengthBetween;
function $871053056dfd3da9$var$pattern(regex) {
    return new $871053056dfd3da9$var$RegexConstraint(regex);
}
module.exports.pattern = $871053056dfd3da9$var$pattern;
function $871053056dfd3da9$var$validateField(object, fieldName, constraints) {
    var value = object[fieldName];
    var violatedConstraints = constraints.map(function(c) {
        return c.isValid(value) ? undefined : c;
    }).filter(function(c) {
        return c;
    });
    return violatedConstraints.length > 0 ? new $871053056dfd3da9$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $871053056dfd3da9$var$validateField;

});

parcelRegister("5ixmT", function(module, exports) {
"use strict";
var $3db8846e4ba8de9f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $199iK = parcelRequire("199iK");

var $3db8846e4ba8de9f$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($3db8846e4ba8de9f$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
var $3db8846e4ba8de9f$var$AppFamilyAriError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(AppFamilyAriError, _super);
    function AppFamilyAriError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    return AppFamilyAriError;
}(Error);
module.exports.AppFamilyAriError = $3db8846e4ba8de9f$var$AppFamilyAriError;
var $3db8846e4ba8de9f$var$NotAppFamilyAriError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(NotAppFamilyAriError, _super);
    function NotAppFamilyAriError(ari, reason) {
        var _this = _super.call(this, "ari is not a valid App family ari: " + ari.toString() + " as " + reason) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAppFamilyAriError;
}($3db8846e4ba8de9f$var$AppFamilyAriError);
module.exports.NotAppFamilyAriError = $3db8846e4ba8de9f$var$NotAppFamilyAriError;
var $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(NotExpectedAppFamilyAriTypeError, _super);
    function NotExpectedAppFamilyAriTypeError(type, ari, cause) {
        var _this = _super.call(this, "App family ari (" + ari.toString() + ") is not of expected type: " + type, cause) || this;
        _this.cause = cause;
        return _this;
    }
    return NotExpectedAppFamilyAriTypeError;
}($3db8846e4ba8de9f$var$AppFamilyAriError);
module.exports.NotExpectedAppFamilyAriTypeError = $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $3db8846e4ba8de9f$var$parseAppAri(ari) {
    return $199iK.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $3db8846e4ba8de9f$var$parseAppAri;
function $3db8846e4ba8de9f$var$createAppAri(json) {
    return new $199iK.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $3db8846e4ba8de9f$var$createAppAri;

});

parcelRegister("199iK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5ixmT = parcelRequire("5ixmT");


var $9cGsb = parcelRequire("9cGsb");

var $0d5dd8c916c95343$var$versionPrefix = ';v=';
var $0d5dd8c916c95343$var$AppFamilyAriImpl = /** @class */ function() {
    function AppFamilyAriImpl(json) {
        this.json = json;
    }
    Object.defineProperty(AppFamilyAriImpl.prototype, "appId", {
        get: function() {
            return this.json.appId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "environmentId", {
        get: function() {
            return this.json.environmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "version", {
        get: function() {
            return this.json.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionGroupId", {
        get: function() {
            return this.json.extensionGroupId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionKey", {
        get: function() {
            return this.json.extensionKey;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toJSON = function() {
        return this.json;
    };
    AppFamilyAriImpl.parse = function(ari) {
        var resourceOwner = ari.resourceOwner, resourceType = ari.resourceType, resourceId = ari.resourceId;
        if (resourceOwner !== $5ixmT.AppFamilyAri.resourceOwner) throw new $5ixmT.NotAppFamilyAriError(ari, "resourceOwner (" + resourceOwner + ") must be " + $5ixmT.AppFamilyAri.resourceOwner);
        if (!resourceType || $5ixmT.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $5ixmT.NotAppFamilyAriError(ari, "resourceType must be one of " + $5ixmT.AppFamilyAri.appFamilyResourceTypes);
        if (!resourceId) throw new $5ixmT.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        var versionIndex = resourceId.indexOf($0d5dd8c916c95343$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($0d5dd8c916c95343$var$versionPrefix) > versionIndex) throw new $5ixmT.NotAppFamilyAriError(ari, 'can only include one version suffix');
        var _a = resourceId.split($0d5dd8c916c95343$var$versionPrefix), mainResourceId = _a[0], version = _a[1];
        var segments = mainResourceId.split('/').map($0d5dd8c916c95343$var$stripToUndefined);
        if (segments.length > 4) throw new $5ixmT.NotAppFamilyAriError(ari, "no path segments can be added after extensionKey " + segments.slice(4));
        var _b = segments[0], appId = _b === void 0 ? undefined : _b, _c = segments[1], environmentId = _c === void 0 ? undefined : _c, _d = segments[2], providedExtensionGroupId = _d === void 0 ? undefined : _d, _e = segments[3], extensionKey = _e === void 0 ? undefined : _e;
        if (!appId) throw new $5ixmT.NotAppFamilyAriError(ari, 'appId must be included');
        var extensionGroupId = providedExtensionGroupId || (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType || resourceType === $5ixmT.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $5ixmT.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId, extensionGroupId, extensionKey must all be provided for resourceType " + $5ixmT.AppFamilyAri.extensionResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId, extensionGroupId must all be provided for resourceType " + $5ixmT.AppFamilyAri.extensionGroupResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $5ixmT.AppFamilyAri.environmentResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $5ixmT.AppFamilyAri.environmentResourceType);
        return new AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    };
    AppFamilyAriImpl.prototype.asAppAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppAri();
        }, 'app');
    };
    AppFamilyAriImpl.prototype.asAppEnvironmentAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppEnvironmentAri();
        }, 'environment');
    };
    AppFamilyAriImpl.prototype.asExtensionGroupAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionGroupAri();
        }, 'extension-group');
    };
    AppFamilyAriImpl.prototype.asExtensionAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionAri();
        }, 'extension');
    };
    AppFamilyAriImpl.prototype.isAppAri = function() {
        return !this.isAtLeastAppEnvironmentAri;
    };
    AppFamilyAriImpl.prototype.isAppEnvironmentAri = function() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    };
    AppFamilyAriImpl.prototype.isExtensionGroupAri = function() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    };
    AppFamilyAriImpl.prototype.isExtensionAri = function() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    };
    AppFamilyAriImpl.prototype.returnIf = function(check, type) {
        if (!check()) throw new $5ixmT.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    };
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastAppEnvironmentAri", {
        get: function() {
            return this.environmentId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastExtensionGroupAri", {
        get: function() {
            return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toAri = function() {
        var resourceOwner = $5ixmT.AppFamilyAri.resourceOwner;
        var _a = this.toJSON(), appId = _a.appId, environmentId = _a.environmentId, extensionGroupId = _a.extensionGroupId, extensionKey = _a.extensionKey, version = _a.version;
        function withVersion(segments) {
            var path = segments.join('/');
            if (!version) return path;
            else return "" + path + $0d5dd8c916c95343$var$versionPrefix + version;
        }
        if (this.isExtensionAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    };
    AppFamilyAriImpl.prototype.toString = function() {
        return this.toAri().toString();
    };
    return AppFamilyAriImpl;
}();
module.exports.AppFamilyAriImpl = $0d5dd8c916c95343$var$AppFamilyAriImpl;
function $0d5dd8c916c95343$var$stripToUndefined(str) {
    if (!str) return undefined;
    var trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});

parcelRegister("bZF61", function(module, exports) {
/**
 * Simple implementation of djb2 hashing.
 * The reason we have it internally is because at the moment we can't add new
 * dependencies into search-client package as it triggers a deprecated VR test in Editor
 * and it is locked down. So it fails to resolve the new dependency
 */ const $a6b1de276595dc61$export$daf4c137c5f56404 = (query)=>{
    let hash = 5381;
    for(let i = 0; i < query.length; i++){
        const char = query.charCodeAt(i);
        hash = (hash << 5) + hash + char; /* hash * 33 + char */ 
    }
    return hash;
};
const $a6b1de276595dc61$export$5c07a4287a46fa1f = (variables)=>{
    try {
        return $a6b1de276595dc61$export$daf4c137c5f56404(JSON.stringify(variables)).toString();
    } catch (e) {
        return '';
    }
};
module.exports["generateHash"] = $a6b1de276595dc61$export$daf4c137c5f56404;
module.exports["generateHashFromVariables"] = $a6b1de276595dc61$export$5c07a4287a46fa1f;

});

parcelRegister("a8RYh", function(module, exports) {
function $094abd9fdcf48b39$export$5f50223bd877b041(result) {
    return result?.__typename === 'KnowledgeDiscoveryJiraIntentDetection';
}
module.exports["isIntentDetectionSuccess"] = $094abd9fdcf48b39$export$5f50223bd877b041;

});

parcelRegister("b8bXF", function(module, exports) {
const $ab874c4eecb56fa4$export$2bc60b2a116fbfaf = {
    QUICK_FIND: 'QUICK_FIND'
};
module.exports["KnowledgeDiscoveryJiraSearchExperience"] = $ab874c4eecb56fa4$export$2bc60b2a116fbfaf;

});

parcelRegister("eCHsK", function(module, exports) {
const $61bb4e9a3a1bdb72$export$1a414fdf8e9c6492 = ()=>{
    return window.location.pathname.includes('/jira/rovo-search');
};
module.exports["isOnJiraFullPageSearch"] = $61bb4e9a3a1bdb72$export$1a414fdf8e9c6492;

});

parcelRegister("4aAXq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $beNrf = parcelRequire("beNrf");





var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");


var $gPOtu = parcelRequire("gPOtu");

// Code taken from: platform/packages/ai-mate/conversation-assistant-utils/src/common/hooks/usePostOfficePlacement.ts




const $60e0077656bc2409$export$b9e056b3d42aef4 = ()=>{
    const [PostOfficePlacement, setPostOfficePlacement] = (0, $cozmU.useState)(null);
    const [isMounted, setIsMounted] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            let isComponentMounted = true;
            // Check for mock in test environments (set by VR test)
            const mockModule = window.__mockPostOfficePlacement__;
            if (mockModule) {
                setPostOfficePlacement(()=>mockModule);
                setIsMounted(true);
                return;
            }
            // eslint-disable-next-line @atlassian/post-office-headless-api/no-placement-remote -- Post Office RML placement not recommended in platform. Disabled lint rule for existing usage.
            (parcelRequire("d76kv")).then((module)=>{
                if (isComponentMounted) {
                    setPostOfficePlacement(()=>module.Placement);
                    setIsMounted(true);
                }
            }).catch(()=>{
                // Silently fail if import fails - PostOfficePlacement will remain null
                // This prevents the component from being stuck in a loading state
                if (isComponentMounted) setIsMounted(true);
            });
            return ()=>{
                isComponentMounted = false;
            };
        }
    }, []);
    return {
        PostOfficePlacement: PostOfficePlacement,
        isMounted: isMounted
    };
};


const $60f6ede1d9f800c5$export$d6ffb4087f856769 = (configs, availableProductsOrder)=>{
    const ordered = {};
    for (const productKey of availableProductsOrder){
        const config = configs[productKey];
        if (config) ordered[productKey] = config;
    }
    return ordered;
};
const $60f6ede1d9f800c5$export$9c15322f536ac91d = (configs)=>{
    const entries = Object.entries(configs).filter((entry)=>{
        const [productKey, config] = entry;
        return (0, $dvVWp.is3pProductKey)(productKey) && config != null && config.outboundAuthUrl != null;
    });
    return entries.map(([productKey, config], index)=>{
        const isSmartlink = (0, $gPOtu.isProductSmartlink)({
            productKey: productKey,
            thirdPartyConfigs: configs
        });
        const connectorName = typeof config.displayName === 'string' ? config.displayName : '';
        return {
            connectorId: config.id,
            connectorIndex: index,
            connectorMode: isSmartlink ? (0, $8fNUp.SMARTLINKS_CONNECTOR_SOURCE) : (0, $8fNUp.FULL_CONNECTOR_SOURCE),
            connectorName: connectorName,
            connectorProductKey: productKey,
            icon: config.icon,
            oAuthUrl: config.outboundAuthUrl,
            userNeedsOAuth: config.userNeedsOAuth ?? false
        };
    });
};
const $60f6ede1d9f800c5$export$a26b2af93a17c1d9 = ({ placementId: placementId, thirdPartyConfigs: thirdPartyConfigs, availableProductsOrder: availableProductsOrder, useOAuthHandlers: useOAuthHandlers, onMessageViewed: onMessageViewed })=>{
    const { PostOfficePlacement: PostOfficePlacement, isMounted: isMounted } = (0, $60e0077656bc2409$export$b9e056b3d42aef4)();
    const orderedConfigs = (0, $cozmU.useMemo)(()=>$60f6ede1d9f800c5$export$d6ffb4087f856769(thirdPartyConfigs, availableProductsOrder), [
        thirdPartyConfigs,
        availableProductsOrder
    ]);
    const availableConnectors = (0, $cozmU.useMemo)(()=>$60f6ede1d9f800c5$export$9c15322f536ac91d(orderedConfigs), [
        orderedConfigs
    ]);
    // the props passed into the placement
    const placementProps = {
        availableConnectors: availableConnectors,
        useOAuthHandlers: useOAuthHandlers,
        onMessageViewed: onMessageViewed
    };
    if (!isMounted || !PostOfficePlacement) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PostOfficePlacement, {
        placementId: placementId,
        placementProps: placementProps
    });
};


const $a6fa1889ef9e0ab4$export$5b496c438700a088 = 'rovo-search-page-quick-find-3p-connector-pre-auth-nudge';



const $c419dedc5934e6e7$var$loadQuickFindHeadlessRenderer = ()=>(parcelRequire("bza1o"));
const $c419dedc5934e6e7$var$QuickFindHeadlessMessageRenderer = Object.assign(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>$c419dedc5934e6e7$var$loadQuickFindHeadlessRenderer().then((module)=>({
            default: module.QuickFindHeadlessMessageRenderer
        }))), {
    displayName: 'lazy(QuickFindHeadlessMessageRenderer)'
});
const $c419dedc5934e6e7$var$QuickFindHeadlessPlacementContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $c419dedc5934e6e7$export$f021c2a95c252193 = ({ placementId: placementId, thirdPartyConfigs: thirdPartyConfigs, availableProductsOrder: availableProductsOrder, useOAuthHandlers: useOAuthHandlers, children: children })=>{
    const { messages: messages, dismissMessage: dismissMessage, PostOfficeMessageInstance: PostOfficeMessageInstance } = (0, $beNrf.useMessageInstances)({
        placementId: placementId,
        messageTemplateId: (0, $a6fa1889ef9e0ab4$export$5b496c438700a088)
    }, {
        dataOutsideWrapper: true
    });
    (0, $cozmU.useEffect)(()=>{
        $c419dedc5934e6e7$var$loadQuickFindHeadlessRenderer();
    }, []);
    const orderedConfigs = (0, $cozmU.useMemo)(()=>(0, $60f6ede1d9f800c5$export$d6ffb4087f856769)(thirdPartyConfigs, availableProductsOrder), [
        thirdPartyConfigs,
        availableProductsOrder
    ]);
    const availableConnectors = (0, $cozmU.useMemo)(()=>(0, $60f6ede1d9f800c5$export$9c15322f536ac91d)(orderedConfigs), [
        orderedConfigs
    ]);
    const value = (0, $cozmU.useMemo)(()=>({
            messages: messages,
            availableConnectors: availableConnectors,
            useOAuthHandlers: useOAuthHandlers,
            dismissMessage: dismissMessage,
            PostOfficeMessageInstance: PostOfficeMessageInstance
        }), [
        messages,
        availableConnectors,
        useOAuthHandlers,
        dismissMessage,
        PostOfficeMessageInstance
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c419dedc5934e6e7$var$QuickFindHeadlessPlacementContext.Provider, {
        value: value
    }, children);
};
const $c419dedc5934e6e7$export$10bc17e539691718 = ()=>{
    const placement = (0, $cozmU.useContext)($c419dedc5934e6e7$var$QuickFindHeadlessPlacementContext);
    if (!placement) return null;
    const { messages: messages, availableConnectors: availableConnectors, useOAuthHandlers: useOAuthHandlers, dismissMessage: dismissMessage, PostOfficeMessageInstance: PostOfficeMessageInstance } = placement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, messages.map((message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c419dedc5934e6e7$var$QuickFindHeadlessMessageRenderer, {
            key: message.messageInstanceId,
            message: message,
            availableConnectors: availableConnectors,
            useOAuthHandlers: useOAuthHandlers,
            dismissMessage: dismissMessage,
            PostOfficeMessageInstance: PostOfficeMessageInstance
        })));
};
module.exports["QuickFindHeadlessPlacementDataProvider"] = $c419dedc5934e6e7$export$f021c2a95c252193;
module.exports["QuickFindHeadlessVisiblePlacement"] = $c419dedc5934e6e7$export$10bc17e539691718;

});

parcelRegister("beNrf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kulje = parcelRequire("kulje");


var $bGczG = parcelRequire("bGczG");


var $1lfgq = parcelRequire("1lfgq");


var $8XrN9 = parcelRequire("8XrN9");

function $17464b89cda99436$export$92bc057879827fcf(selector, options) {
    const { placementId: placementId = 'headless', messageTemplateId: messageTemplateId } = selector;
    const { match: match, validate: validate, dataSource: dataSource, queryString: queryString } = options ?? {};
    const dataOutsideWrapper = options?.dataOutsideWrapper ?? false;
    // Store match/validate in refs so inline arrow functions passed by callers don't cause
    // the useMemo to re-run on every render. The latest value is always read inside the memo.
    const matchRef = (0, $cozmU.useRef)(match);
    matchRef.current = match;
    const validateRef = (0, $cozmU.useRef)(validate);
    validateRef.current = validate;
    const { data: data, dismissedIds: dismissedIds, isLoading: isLoading, error: fetchError, dismissMessage: dismissMessage, traceId: traceId } = (0, $1lfgq.usePlacementData)(placementId, {
        dataSource: dataSource,
        queryString: queryString
    });
    const traceIdRef = (0, $cozmU.useRef)(traceId);
    traceIdRef.current = traceId;
    const { templateMessages: templateMessages, validationError: validationError } = (0, $cozmU.useMemo)(()=>{
        if (!data) return {
            templateMessages: [],
            validationError: undefined
        };
        let candidates;
        try {
            const result = matchRef.current ? matchRef.current({
                data: data,
                matchBuilder: (0, $8XrN9.createMatchBuilder)()
            }) : data.messages ?? [];
            const resolved = (0, $8XrN9.isMatchBuilder)(result) ? result.match(data) : result;
            candidates = resolved;
        } catch (err) {
            if (err instanceof (0, $8XrN9.PlacementLocationError)) return {
                templateMessages: [],
                validationError: err
            };
            return {
                templateMessages: [],
                validationError: (0, $8XrN9.toHookError)(err)
            };
        }
        const templateMatches = candidates.filter((m)=>m.messageTemplateId === messageTemplateId);
        const guard = validateRef.current ?? (0, $8XrN9.isPlacementMessage);
        let failedCount;
        try {
            failedCount = templateMatches.filter((m_0)=>!guard(m_0)).length;
        } catch (err_0) {
            return {
                templateMessages: [],
                validationError: (0, $8XrN9.toHookError)(err_0)
            };
        }
        if (failedCount > 0) return {
            templateMessages: [],
            validationError: new (0, $8XrN9.PlacementValidationError)({
                placementId: placementId,
                failedCount: failedCount
            })
        };
        return {
            templateMessages: templateMatches,
            validationError: undefined
        };
    }, [
        data,
        messageTemplateId,
        placementId
    ]);
    const messages = (0, $cozmU.useMemo)(()=>{
        return templateMessages.filter((m_1)=>!dismissedIds.has(m_1.messageInstanceId));
    }, [
        dismissedIds,
        templateMessages
    ]);
    const messageInstanceIds = (0, $cozmU.useMemo)(()=>messages.map((m_2)=>m_2.messageInstanceId), [
        messages
    ]);
    // Build lookup from validated template data (not dismissed-filtered messages)
    // so dismissals and data refreshes don't change PostOfficeMessageInstance identity and remount callers.
    const messageByMessageInstanceId = (0, $cozmU.useMemo)(()=>{
        const lookup = {};
        for (const message of templateMessages)lookup[message.messageInstanceId] = message;
        return lookup;
    }, [
        templateMessages
    ]);
    const messageByMessageInstanceIdRef = (0, $cozmU.useRef)({});
    messageByMessageInstanceIdRef.current = messageByMessageInstanceId;
    // Single wrapper closed over placementId + messageTemplateId.
    // messageInstanceId is passed per-render by the caller.
    const PostOfficeMessageInstance = (0, $cozmU.useMemo)(()=>{
        return ({ children: children, ...props })=>{
            const message_0 = messageByMessageInstanceIdRef.current[props.messageInstanceId];
            const messageCategory = message_0?.messageCategory;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kulje.PostOfficeMessage), {
                placementId: placementId,
                messageTemplateId: messageTemplateId,
                messageCategory: messageCategory,
                ...(0, $bGczG.transformPlacementMessageToMessageLifecycleProps)({
                    message: message_0
                }),
                ...props,
                traceId: traceIdRef.current
            }, (interactions)=>children(message_0, interactions));
        };
    }, [
        messageTemplateId,
        placementId
    ]);
    return dataOutsideWrapper ? {
        messages: messages,
        messageInstanceIds: messageInstanceIds,
        PostOfficeMessageInstance: PostOfficeMessageInstance,
        dismissedIds: dismissedIds,
        isLoading: isLoading,
        error: fetchError ?? validationError,
        dismissMessage: dismissMessage,
        traceId: traceId
    } : {
        messageInstanceIds: messageInstanceIds,
        PostOfficeMessageInstance: PostOfficeMessageInstance,
        dismissedIds: dismissedIds,
        isLoading: isLoading,
        error: fetchError ?? validationError,
        dismissMessage: dismissMessage,
        traceId: traceId
    };
}
module.exports["useMessageInstances"] = $17464b89cda99436$export$92bc057879827fcf;

});

parcelRegister("kulje", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $i3S9F = parcelRequire("i3S9F");


var $cXtTj = parcelRequire("cXtTj");


var $ggtx8 = parcelRequire("ggtx8");


var $3jNKT = parcelRequire("3jNKT");


var $6NRmI = parcelRequire("6NRmI");


var $k4HA2 = parcelRequire("k4HA2");

var $4cICV = parcelRequire("4cICV");

var $kEPax = parcelRequire("kEPax");

/**
 * Fires the Post Office "viewed" analytics events on mount.
 *
 * This is a separate inner component so that it only mounts when the choreographer
 * allows the message to render. It fires all three viewed events exactly once:
 *   - messageViewed() (legacy in-app lifecycle endpoint)
 *   - messageInstanceViewed()
 *   - messageInstanceDeliveredSuccessfully()
 *
 * Must be rendered inside a MessageContextProvider and PlacementProvider so that
 * useMessageViewed() can read the required context values.
 */ const $22daedfb2bfa2f59$var$ViewedOnMount = ()=>{
    const messageViewed = (0, $kEPax.useMessageViewed)();
    (0, $cozmU.useEffect)(()=>{
        messageViewed();
    // We intentionally omit deps — this should fire exactly once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
/**
 * Defers evaluation of the children render prop until the message is mounted.
 *
 * This ensures that any side effects in the render prop only execute when the
 * choreographer allows the message to render, not when it is blocked.
 */ const $22daedfb2bfa2f59$var$RenderedChildren = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const interactions = (0, $3jNKT.usePostOfficeUserInteractions)();
    let t1;
    if ($[0] !== children || $[1] !== interactions) {
        t1 = children(interactions);
        $[0] = children;
        $[1] = interactions;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children })=>{
    const interactions = (0, $3jNKT.usePostOfficeUserInteractions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(interactions));
};
const $22daedfb2bfa2f59$var$ChoreographedMessage = ({ children: children, messageId: messageId, useChoreographedRender: useChoreographedRender })=>{
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (!shouldRender) return null;
    // Post Office is actively choreographing this message. Signal it to descendants
    // so nested product/PO choreographer-wrapped components (e.g. JiraSpotlight, or
    // Confluence components built on the ipm-choreographer engine) defer instead of
    // starting a second, colliding choreographer over the same subtree.
    if ((0, $cXtTj.default).checkGate('post-office_enable_choreographer-ancestor-context')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ggtx8.AncestorChoreographerProvider), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
/**
 * Render-time Isolated Cloud gate.
 *
 * Returns `null` when the prop is enabled AND the tenant is in an Isolated Cloud
 * environment. Mirrors the headful behaviour wired by
 * `createBasePlacementComponentV2` (`options.hideInIsolatedCloud`).
 *
 * SSR handling is delegated to `isIsolatedCloud()` itself, which falls back to
 * `globalThis.ssrContext?.isInIC` when `document` is undefined.
 */ const $22daedfb2bfa2f59$var$IsolatedCloudGate = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children, hideInIsolatedCloud: hideInIsolatedCloud } = t0;
    if (hideInIsolatedCloud && (0, $i3S9F.isIsolatedCloud)()) return null;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children, hideInIsolatedCloud: hideInIsolatedCloud })=>{
    if (hideInIsolatedCloud && (0, $i3S9F.isIsolatedCloud)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
/**
 * Choreographer gating using the `ChoreographerContext` provided by
 * `StableChoreographerProvider` (from `@atlassian/post-office-context/choreographer`).
 *
 * When the choreographer is disabled or its factory is not yet loaded,
 * the message renders unconditionally.
 *
 * When `disableChoreographer` is `true`, the gate short-circuits and renders
 * children unconditionally — bypassing the choreographer entirely for this message.
 */ const $22daedfb2bfa2f59$var$ChoreographerGate = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, disableChoreographer: disableChoreographer, awaitChoreographerFactory: awaitChoreographerFactory } = t0;
    const { factory: choreographerFactory, choreographerEnabled: choreographerEnabled } = (0, $6NRmI.useChoreographerContext)();
    const isChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate("enable_choreographed_post_office_messages");
    if (disableChoreographer) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    if (awaitChoreographerFactory && choreographerEnabled && isChoreographedPostOfficeMessagesEnabled && !choreographerFactory) return null;
    if (choreographerFactory && choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        const { shouldBeChoreographed: shouldBeChoreographed, useChoreographedRender: useChoreographedRender } = choreographerFactory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            const useMessageTemplateIdAsChoreographerMessageId = (0, $cXtTj.default).checkGate("post-office_use_template_id_for_choreo");
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            let t1;
            if ($[2] !== children || $[3] !== choreographerMessageId || $[4] !== useChoreographedRender) {
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$ChoreographedMessage, {
                    messageId: choreographerMessageId,
                    useChoreographedRender: useChoreographedRender
                }, children);
                $[2] = children;
                $[3] = choreographerMessageId;
                $[4] = useChoreographedRender;
                $[5] = t1;
            } else t1 = $[5];
            return t1;
        }
    }
    let t1;
    if ($[6] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[6] = children;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, disableChoreographer: disableChoreographer, awaitChoreographerFactory: awaitChoreographerFactory })=>{
    // Hooks must run on every render to preserve hook order — do not short-circuit
    // before calling them, even when `disableChoreographer` is set.
    const { factory: choreographerFactory, choreographerEnabled: choreographerEnabled } = (0, $6NRmI.useChoreographerContext)();
    const isChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_choreographed_post_office_messages');
    if (disableChoreographer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    if (awaitChoreographerFactory && choreographerEnabled && isChoreographedPostOfficeMessagesEnabled && !choreographerFactory) return null;
    if (choreographerFactory && choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        const { shouldBeChoreographed: shouldBeChoreographed, useChoreographedRender: useChoreographedRender } = choreographerFactory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            const useMessageTemplateIdAsChoreographerMessageId = (0, $cXtTj.default).checkGate('post-office_use_template_id_for_choreo');
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$ChoreographedMessage, {
                messageId: choreographerMessageId,
                useChoreographedRender: useChoreographedRender
            }, children);
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
/**
 * Provides the choreographer context this component's gating depends on, so headless
 * consumers do not have to mount `StableChoreographerProvider` themselves.
 *
 * Nesting is safe: the underlying choreographer factory is a per-product singleton
 * held on `window`, so a provider mounted here resolves to the same factory (and
 * therefore the same fatigue/concurrency queue) as one mounted by an ancestor.
 *
 */ const $22daedfb2bfa2f59$var$ChoreographerProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, placementId: placementId, enabled: enabled } = t0;
    if (!enabled) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children || $[3] !== placementId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6NRmI.StableChoreographerProvider), {
            placementId: placementId
        }, children);
        $[2] = children;
        $[3] = placementId;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ children: children, placementId: placementId, enabled: enabled })=>{
    if (!enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6NRmI.StableChoreographerProvider), {
        placementId: placementId
    }, children);
};
const $22daedfb2bfa2f59$export$7356a355af87a394 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, placementId: placementId, traceId: traceId, messageCategory: messageCategory, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, disableChoreographer: disableChoreographer, hideInIsolatedCloud: hideInIsolatedCloud, children: children } = t0;
    let t1;
    if ($[0] !== configSetId || $[1] !== journeyId || $[2] !== journeyTriggerId || $[3] !== messageCategory || $[4] !== messageCreationType || $[5] !== messageInstanceId || $[6] !== messageTemplateId || $[7] !== triggerId) {
        t1 = {
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId
        };
        $[0] = configSetId;
        $[1] = journeyId;
        $[2] = journeyTriggerId;
        $[3] = messageCategory;
        $[4] = messageCreationType;
        $[5] = messageInstanceId;
        $[6] = messageTemplateId;
        $[7] = triggerId;
        $[8] = t1;
    } else t1 = $[8];
    const messageContext = t1;
    let t2;
    if ($[9] !== placementId || $[10] !== traceId) {
        t2 = {
            placementId: placementId,
            traceId: traceId
        };
        $[9] = placementId;
        $[10] = traceId;
        $[11] = t2;
    } else t2 = $[11];
    const placementContext = t2;
    let t3;
    if ($[12] !== disableChoreographer) {
        t3 = !disableChoreographer && (0, $cXtTj.default).checkGate("post-office_enable_choreographer_provider");
        $[12] = disableChoreographer;
        $[13] = t3;
    } else t3 = $[13];
    const providesChoreographer = t3;
    let t4;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$ViewedOnMount, null);
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== children) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$RenderedChildren, null, children);
        $[15] = children;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== disableChoreographer || $[18] !== messageCategory || $[19] !== messageInstanceId || $[20] !== messageTemplateId || $[21] !== providesChoreographer || $[22] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$ChoreographerGate, {
            messageId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            disableChoreographer: disableChoreographer,
            awaitChoreographerFactory: providesChoreographer
        }, t4, t5);
        $[17] = disableChoreographer;
        $[18] = messageCategory;
        $[19] = messageInstanceId;
        $[20] = messageTemplateId;
        $[21] = providesChoreographer;
        $[22] = t5;
        $[23] = t6;
    } else t6 = $[23];
    let t7;
    if ($[24] !== messageContext || $[25] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k4HA2.MessageContextProvider), {
            value: messageContext
        }, t6);
        $[24] = messageContext;
        $[25] = t6;
        $[26] = t7;
    } else t7 = $[26];
    let t8;
    if ($[27] !== placementContext || $[28] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cICV.PlacementProvider), {
            value: placementContext
        }, t7);
        $[27] = placementContext;
        $[28] = t7;
        $[29] = t8;
    } else t8 = $[29];
    let t9;
    if ($[30] !== hideInIsolatedCloud || $[31] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$IsolatedCloudGate, {
            hideInIsolatedCloud: hideInIsolatedCloud
        }, t8);
        $[30] = hideInIsolatedCloud;
        $[31] = t8;
        $[32] = t9;
    } else t9 = $[32];
    let t10;
    if ($[33] !== placementId || $[34] !== providesChoreographer || $[35] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$ChoreographerProvider, {
            placementId: placementId,
            enabled: providesChoreographer
        }, t9);
        $[33] = placementId;
        $[34] = providesChoreographer;
        $[35] = t9;
        $[36] = t10;
    } else t10 = $[36];
    return t10;
} : ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, placementId: placementId, traceId: traceId, messageCategory: messageCategory, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, disableChoreographer: disableChoreographer, hideInIsolatedCloud: hideInIsolatedCloud, children: children })=>{
    const messageContext = (0, $cozmU.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId
        }), [
        messageInstanceId,
        messageTemplateId,
        messageCategory,
        triggerId,
        messageCreationType,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const placementContext = (0, $cozmU.useMemo)(()=>({
            placementId: placementId,
            traceId: traceId
        }), [
        placementId,
        traceId
    ]);
    const providesChoreographer = !disableChoreographer && (0, $cXtTj.default).checkGate('post-office_enable_choreographer_provider');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$ChoreographerProvider, {
        placementId: placementId,
        enabled: providesChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$IsolatedCloudGate, {
        hideInIsolatedCloud: hideInIsolatedCloud
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cICV.PlacementProvider), {
        value: placementContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k4HA2.MessageContextProvider), {
        value: messageContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$ChoreographerGate, {
        messageId: messageInstanceId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        disableChoreographer: disableChoreographer,
        awaitChoreographerFactory: providesChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$ViewedOnMount, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22daedfb2bfa2f59$var$RenderedChildren, null, children))))));
};
module.exports["PostOfficeMessage"] = $22daedfb2bfa2f59$export$7356a355af87a394;

});

parcelRegister("3jNKT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kEPax = parcelRequire("kEPax");


var $8xFOz = parcelRequire("8xFOz");

const $e6e72577d521fafd$export$ee30c4b9efd02415 = ()=>{
    const { messageInstanceClicked: messageInstanceClicked } = (0, $kEPax.useMessageInstanceEvent)();
    const record = (0, $cozmU.useCallback)((interaction)=>{
        // Dispatch is fire-and-forget: the caller must not wait for analytics before
        // continuing a UI action, and recording an interaction must never break the
        // message.
        messageInstanceClicked((0, $8xFOz.mapInteractionToClickedEvent)(interaction)).catch(()=>{});
    }, [
        messageInstanceClicked
    ]);
    const onCtaActioned = (0, $cozmU.useCallback)((input)=>record({
            kind: 'ctaActioned',
            ...input
        }), [
        record
    ]);
    const onAcknowledged = (0, $cozmU.useCallback)((input)=>record({
            kind: 'acknowledged',
            ...input
        }), [
        record
    ]);
    const onDeclined = (0, $cozmU.useCallback)((input)=>record({
            kind: 'declined',
            ...input
        }), [
        record
    ]);
    const onSnoozed = (0, $cozmU.useCallback)((input)=>record({
            kind: 'snoozed',
            ...input
        }), [
        record
    ]);
    const onClosed = (0, $cozmU.useCallback)((input)=>record({
            kind: 'closed',
            ...input
        }), [
        record
    ]);
    const onStepChanged = (0, $cozmU.useCallback)((input)=>record({
            kind: 'stepChanged',
            ...input
        }), [
        record
    ]);
    return (0, $cozmU.useMemo)(()=>({
            onCtaActioned: onCtaActioned,
            onAcknowledged: onAcknowledged,
            onDeclined: onDeclined,
            onSnoozed: onSnoozed,
            onClosed: onClosed,
            onStepChanged: onStepChanged
        }), [
        onCtaActioned,
        onAcknowledged,
        onDeclined,
        onSnoozed,
        onClosed,
        onStepChanged
    ]);
};
module.exports["usePostOfficeUserInteractions"] = $e6e72577d521fafd$export$ee30c4b9efd02415;

});

parcelRegister("8xFOz", function(module, exports) {

var $eZHZB = parcelRequire("eZHZB");

/**
 * The legacy `clickedElement` shape for kinds that downstream consumers still read as a
 * primary click. Presentation is not intent — this is emitted for backward compatibility
 * only and is removed once consumers read `action.actionType` alone.
 */ const $8935800689fede97$var$primaryButton = (interactionIdentifier)=>({
        clickIdentifier: interactionIdentifier,
        clickedElement: 'button',
        buttonType: 'primary'
    });
/**
 * The legacy `clickedElement` shape for kinds whose meaning does not depend on a rendered
 * element. `closed` in particular covers Escape, click-outside and navigating away.
 *
 * Delegates to `notApplicableClickedElement` rather than building the literal directly —
 * that factory is the only way to produce this branded, PO-owned value.
 */ const $8935800689fede97$var$notApplicable = (interactionIdentifier)=>(0, $eZHZB.notApplicableClickedElement)(interactionIdentifier);
/**
 * Maps a semantic interaction to the `clickedElement` and `action` pair defined by the
 * canonical compatibility mapping.
 *
 * The switch is deliberately exhaustive with no `default`: adding a kind to
 * `SemanticInteraction` without mapping it here is a compile error.
 *
 * @see https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/7480820497/LYT+IPMs+Semantic+Interaction+Contract+Proposal+Rationale+and+Mapping#1.7-End-to-end-mapping
 */ const $8935800689fede97$var$toClickedEventCore = (interaction)=>{
    const identifier = interaction.interactionIdentifier;
    switch(interaction.kind){
        case 'ctaActioned':
            return {
                clickedElement: $8935800689fede97$var$primaryButton(identifier),
                action: {
                    actionType: 'open',
                    ...interaction.destinationUrl !== undefined && {
                        destinationUrl: interaction.destinationUrl
                    },
                    ...interaction.trackingLinkId !== undefined && {
                        trackingLinkId: interaction.trackingLinkId
                    }
                }
            };
        case 'acknowledged':
            return {
                clickedElement: $8935800689fede97$var$primaryButton(identifier),
                action: {
                    actionType: 'acknowledge'
                }
            };
        case 'declined':
            return {
                clickedElement: $8935800689fede97$var$notApplicable(identifier),
                action: {
                    actionType: 'dismiss'
                }
            };
        case 'snoozed':
            return {
                clickedElement: $8935800689fede97$var$notApplicable(identifier),
                action: {
                    actionType: 'snooze',
                    snoozeDuration: interaction.durationDays
                }
            };
        case 'closed':
            // Compatibility mode: `closed` maps to `dismiss` because there is no native
            // `close` actionType yet. Native support is tracked separately, and the split
            // between `declined` and `closed` is preserved in `interactionIdentifier`.
            return {
                clickedElement: $8935800689fede97$var$notApplicable(identifier),
                action: {
                    actionType: 'dismiss'
                }
            };
        case 'stepChanged':
            return {
                clickedElement: $8935800689fede97$var$notApplicable(identifier),
                action: {
                    actionType: interaction.direction,
                    currentStep: interaction.toStep,
                    previousStep: interaction.fromStep,
                    ...interaction.stepName !== undefined && {
                        stepName: interaction.stepName
                    }
                }
            };
    }
};
const $8935800689fede97$export$4f02cad8854e08a4 = (interaction)=>({
        messageEventType: 'clicked',
        interactionIdentifier: interaction.interactionIdentifier,
        ...$8935800689fede97$var$toClickedEventCore(interaction),
        ...interaction.additionalMetadata !== undefined && {
            additionalMetadataFromFrontend: interaction.additionalMetadata
        }
    });
module.exports["mapInteractionToClickedEvent"] = $8935800689fede97$export$4f02cad8854e08a4;

});

parcelRegister("bGczG", function(module, exports) {
const $5cb230a6b87dbda9$var$transformMessageCreationTypeToPostOfficeMessageCreationType = ({ messageCreationType: messageCreationType })=>{
    if (messageCreationType === 'implicit' || messageCreationType === 'explicit') return messageCreationType;
    return undefined;
};
const $5cb230a6b87dbda9$export$61e95755e67323e4 = ({ message: message })=>({
        configSetId: message?.configSetId,
        journeyId: message?.journeyId,
        journeyTriggerId: message?.journeyTriggerId,
        messageCreationType: $5cb230a6b87dbda9$var$transformMessageCreationTypeToPostOfficeMessageCreationType({
            messageCreationType: message?.messageCreationType
        }),
        triggerId: message?.triggerId
    });
module.exports["transformPlacementMessageToMessageLifecycleProps"] = $5cb230a6b87dbda9$export$61e95755e67323e4;

});

parcelRegister("1lfgq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iQwJa = parcelRequire("iQwJa");

var $di43e = parcelRequire("di43e");

var $bGVJw = parcelRequire("bGVJw");


var $dRyWy = parcelRequire("dRyWy");


var $gswTK = parcelRequire("gswTK");


var $8rWh4 = parcelRequire("8rWh4");


var $iDSbf = parcelRequire("iDSbf");


var $kulje = parcelRequire("kulje");

/**
 * Foundation hook for the Post Office Headless API.
 *
 * Fetches raw Placement API data for a given `placementId` and tracks which
 * message instances have been dismissed in the current session via the Post
 * Office pub/sub system.
 *
 * All higher-level hooks (`useAllMessages`, `useMessageInstances`, `useMessageData`) compose on top
 * of this hook.
 *
 * Automatically reads the current `PostOfficeContext` (product, locale, tenantId, workspaceAri,
 * etc.) via `usePostOfficeContext` and forwards it to the Placement API request as query
 * parameters. No manual context threading is required.
 *
 * Requires `PlacementFetchingProvider` and `MessagePlacementProvider` (or
 * `PostOfficeProvider`) to be present in the React tree.
 *
 * @example
 * ```tsx
 * const { data, dismissedIds, isLoading, error, dismissMessage } = usePlacementData(
 *   'some-placement',
 * );
 *
 * const visibleMessages = data?.messages.filter(
 *   m => !dismissedIds.has(m.messageInstanceId)
 * ) ?? [];
 * ```
 *
 * @typeParam TMessage - A {@link PlacementMessageDiscriminant} or union thereof.
 *   Provide a union to model multiple template types with narrowable `context`:
 *   `usePlacementData<{ messageTemplateId: 'banner'; context: BannerCtx } | { messageTemplateId: 'flag'; context: FlagCtx }>(id)`
 * @typeParam TExtension - Additional top-level fields to expect in the `data` shape.
 * @param placementId - The ID of the placement to fetch data for. Defaults to `'headless'`.
 * @param options - Optional configuration. Pass `{ dataSource: 'DEV_SERVER' }` to point the hook
 *   at the local placement dev server (`yarn placement:v2 dev`, default port `4224`).
 * @see https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/6764207116
 */ /** Base URL used when `dataSource` is `'DEV_SERVER'`. Only included in non-production builds. */ const $cbd913b69b48d9f0$var$DEV_SERVER_BASE_URL = 'http://localhost:4224';
const $cbd913b69b48d9f0$export$a9668c1d52481a0f = (placementId = 'headless', options)=>{
    const fetcher = (0, $gswTK.usePlacementFetchingContext)();
    const { onMessageDismiss: onMessageDismiss, dismissMessageFromPlacement: dismissMessageFromPlacement } = (0, $di43e.useMessagePlacementHooks)();
    const postOfficeContext = (0, $bGVJw.usePostOfficeContext)();
    const simulationParams = (0, $dRyWy.useExtensionBridgeSimulationParams)(placementId);
    const { dataSource: dataSource = 'PRODUCTION', queryString: queryString } = options ?? {};
    const arePlacementsGloballyDisabled = (0, $iDrrr.fg)('post-office-enable-headless-disable-placement') && (0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(postOfficeContext);
    const placementIdToFetch = arePlacementsGloballyDisabled ? null : placementId;
    // When targeting the dev server, override the fetch so the request goes to
    // `http://localhost:4224` instead of the production gateway. The dev server
    // exposes the same URL path as production.
    let effectiveFetcher = fetcher;
    if (dataSource === 'DEV_SERVER') effectiveFetcher = {
        fetch: (url, init)=>{
            // Replace the origin with the dev server base URL, keeping the path intact.
            // Guard against SSR environments where window is not defined.
            const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
            const originalUrl = new URL(url, origin);
            const devUrl = `${$cbd913b69b48d9f0$var$DEV_SERVER_BASE_URL}${originalUrl.pathname}${originalUrl.search}`;
            return fetcher.fetch(devUrl, init);
        }
    };
    // Merge any caller-provided `queryString` params with the PostOfficeContext params.
    // This is additive only: context values always take precedence, so callers can never
    // override the context-derived query parameters — they can only add new ones.
    // Gated behind `post-office-enable-headless-query`: when the gate is off the caller
    // `queryString` is ignored entirely and only the context-derived params are sent,
    // preserving the pre-existing request shape.
    // Memoised on the stringified queryString so the SWR request key stays stable across
    // renders when an inline object with identical contents is passed.
    //
    // When `post-office_enable_extension-control` is on and this placement has simulation
    // enabled, per-placement simulate params are merged in the same additive way —
    // never overriding PostOfficeContext keys, and never leaking to sibling placements.
    const isHeadlessQueryEnabled = (0, $iDrrr.fg)('post-office-enable-headless-query');
    const queryStringKey = isHeadlessQueryEnabled && queryString ? JSON.stringify(queryString) : undefined;
    const simulationParamsKey = simulationParams ? JSON.stringify(simulationParams) : undefined;
    const requestContext = (0, $cozmU.useMemo)(()=>{
        const additiveParams = {
            ...simulationParams,
            ...isHeadlessQueryEnabled && queryString ? queryString : {}
        };
        return Object.keys(additiveParams).length > 0 ? {
            ...additiveParams,
            ...postOfficeContext
        } : postOfficeContext;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- keys are stable stringifications of the source objects
    [
        postOfficeContext,
        queryStringKey,
        isHeadlessQueryEnabled,
        simulationParamsKey
    ]);
    const response = (0, $iDSbf.useFetchPlacementData)(placementIdToFetch, 'headless', requestContext, effectiveFetcher, undefined, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    const [dismissedIds, setDismissedIds] = (0, $cozmU.useState)(()=>new Set());
    // Synchronously reset dismissedIds in the render path when placementId changes.
    // A useEffect-based reset fires after paint, leaving a one-render window where
    // the new placement is painted with stale dismissed IDs from the previous one.
    // Calling setState during render causes React to discard this render and
    // immediately re-render with the new state; consumers never observe stale IDs.
    //
    // Infinite re-render safety — two independent guards prevent looping:
    //   1. prevPlacementIdRef.current is written BEFORE setDismissedIds is called.
    //      On the re-render React immediately triggers, the ref already equals
    //      placementId so the outer `if` is false — no further setState occurs.
    //   2. After the reset, dismissedIds.size === 0, so the inner size guard is
    //      also false — a second guard independent of the ref. Either alone is
    //      sufficient; both together make the loop prevention unconditional.
    // See: 'infinite re-render safety' tests in usePlacementData.test.tsx.
    const prevPlacementIdRef = (0, $cozmU.useRef)(placementId);
    const placementChanged = prevPlacementIdRef.current !== placementId;
    // Return an empty set immediately on the first render with a new placementId —
    // including the discarded render that React produces when setState is called
    // during rendering. This ensures no render ever exposes stale dismissed IDs
    // from the previous placement, even transiently.
    // Reference stability: when dismissedIds is already empty we reuse the same
    // Set reference (no new object, no unnecessary re-render).
    const effectiveDismissedIds = placementChanged && dismissedIds.size > 0 ? new Set() : dismissedIds;
    if (placementChanged) {
        prevPlacementIdRef.current = placementId;
        // Only reset if the set is non-empty to avoid an unnecessary extra render.
        if (dismissedIds.size > 0) setDismissedIds(new Set());
    }
    const { mutate: mutate } = response;
    // Subscribe to pub/sub dismiss events on mount, unsubscribe on unmount.
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = onMessageDismiss(({ messageInstanceId: messageInstanceId })=>{
            setDismissedIds((prev)=>{
                // Guard: do not create a new Set reference if the ID is already dismissed.
                if (prev.has(messageInstanceId)) return prev;
                return new Set([
                    ...prev,
                    messageInstanceId
                ]);
            });
            // `dismissedIds` is in-memory only, but SWR data is global + localStorage-backed and reused
            // on remount (no stale revalidation here). Remove the dismissed message from cached payload
            // as well so it does not reappear after remount; do this optimistically (`revalidate: false`)
            // to avoid a backend refetch that may still return it, as sending the dismissal analytic can
            // take a few seconds.
            if ((0, $iDrrr.fg)('post-office_enable_headless-cache-dismiss')) mutate((current)=>{
                if (!current?.data?.messages?.some((m)=>m.messageInstanceId === messageInstanceId)) return current;
                return {
                    ...current,
                    data: {
                        ...current.data,
                        messages: current.data.messages.filter((m)=>m.messageInstanceId !== messageInstanceId)
                    }
                };
            }, {
                revalidate: false
            });
        });
        return unsubscribe;
    }, [
        onMessageDismiss,
        mutate
    ]);
    const dismissMessage = (0, $cozmU.useCallback)((messageInstanceId)=>{
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
    }, [
        dismissMessageFromPlacement
    ]);
    const { isLoading: isLoading, error: error } = response;
    const traceId = (0, $8rWh4.getPlacementTraceId)(response.data);
    const traceIdRef = (0, $cozmU.useRef)(traceId);
    traceIdRef.current = traceId;
    const PostOfficePlacementMessage = (0, $cozmU.useMemo)(()=>({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kulje.PostOfficeMessage), {
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                placementId: placementId,
                traceId: traceIdRef.current,
                messageCategory: messageCategory,
                triggerId: triggerId,
                messageCreationType: messageCreationType,
                journeyId: journeyId,
                journeyTriggerId: journeyTriggerId,
                configSetId: configSetId
            }, children), [
        placementId
    ]);
    return {
        data: response.data?.data,
        errors: response.data?.errors ?? [],
        dismissedIds: effectiveDismissedIds,
        isLoading: isLoading,
        error: error,
        dismissMessage: dismissMessage,
        traceId: traceId,
        PostOfficePlacementMessage: PostOfficePlacementMessage
    };
};
module.exports["usePlacementData"] = $cbd913b69b48d9f0$export$a9668c1d52481a0f;

});

parcelRegister("dRyWy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $gwWC3 = parcelRequire("gwWC3");

const $2e762b64de251827$var$getExtensionBridge = ()=>{
    if (typeof window === 'undefined') return undefined;
    return window.postOffice?.extensionControl;
};
const $2e762b64de251827$export$8cb502483eccaaa7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (placementId)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $iDrrr.fg)("post-office_enable_extension-control");
        $[0] = t0;
    } else t0 = $[0];
    const isEnabled = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (onStoreChange)=>{
            if (!isEnabled) return $2e762b64de251827$var$_temp;
            return $2e762b64de251827$var$getExtensionBridge()?.subscribe(onStoreChange) ?? $2e762b64de251827$var$_temp2;
        };
        $[1] = t1;
    } else t1 = $[1];
    const subscribe = t1;
    let t2;
    if ($[2] !== placementId) {
        t2 = ()=>{
            if (!isEnabled) return;
            return (0, $gwWC3.extensionBridgeStore).getEnabledSimulationParamsSnapshot(placementId);
        };
        $[2] = placementId;
        $[3] = t2;
    } else t2 = $[3];
    const getSnapshot = t2;
    return (0, $cozmU.useSyncExternalStore)(subscribe, getSnapshot, $2e762b64de251827$var$_temp3);
} : (placementId)=>{
    const isEnabled = (0, $iDrrr.fg)('post-office_enable_extension-control');
    const subscribe = (0, $cozmU.useCallback)((onStoreChange)=>{
        if (!isEnabled) return ()=>{};
        return $2e762b64de251827$var$getExtensionBridge()?.subscribe(onStoreChange) ?? (()=>{});
    }, [
        isEnabled
    ]);
    const getSnapshot = (0, $cozmU.useCallback)(()=>{
        if (!isEnabled) return undefined;
        return (0, $gwWC3.extensionBridgeStore).getEnabledSimulationParamsSnapshot(placementId);
    }, [
        isEnabled,
        placementId
    ]);
    return (0, $cozmU.useSyncExternalStore)(subscribe, getSnapshot, ()=>undefined);
};
function $2e762b64de251827$var$_temp() {}
function $2e762b64de251827$var$_temp2() {}
function $2e762b64de251827$var$_temp3() {}
module.exports["useExtensionBridgeSimulationParams"] = $2e762b64de251827$export$8cb502483eccaaa7;

});

parcelRegister("8XrN9", function(module, exports) {
/** Shared utilities for post-office headless API hooks. */ class $d7a7c6eb9fc5b129$export$70abd424e1cca8c3 extends Error {
    constructor({ placementId: placementId, failedCount: failedCount }){
        super('One or more messages failed structural validation');
        this.name = 'PlacementValidationError';
        this.placementId = void 0;
        this.failedCount = void 0;
        this.placementId = placementId;
        this.failedCount = failedCount;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class $d7a7c6eb9fc5b129$export$fc2b8b9bcb86a0d0 extends Error {
    constructor({ placementId: placementId, messageTemplateId: messageTemplateId, instanceCount: instanceCount }){
        super('Multiple message instances found; the hook is in an unexpected state and no message will be returned. Use useMessageInstances if multiple instances are expected.');
        this.name = 'MultipleMessageInstancesError';
        this.placementId = void 0;
        this.messageTemplateId = void 0;
        this.instanceCount = void 0;
        this.placementId = placementId;
        this.messageTemplateId = messageTemplateId;
        this.instanceCount = instanceCount;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class $d7a7c6eb9fc5b129$export$17455b84f403213b extends Error {
    constructor({ locationKey: locationKey, invalidCount: invalidCount }){
        super('All items at the message location must be valid PlacementMessage objects');
        this.name = 'PlacementLocationError';
        this.locationKey = void 0;
        this.invalidCount = void 0;
        this.locationKey = locationKey;
        this.invalidCount = invalidCount;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
const $d7a7c6eb9fc5b129$export$a8ba7e6c095216ec = (item)=>{
    if (typeof item !== 'object' || item === null) return false;
    const msg = item;
    return typeof msg.messageTemplateId === 'string' && typeof msg.messageInstanceId === 'string' && typeof msg.context === 'object' && msg.context !== null;
};
const $d7a7c6eb9fc5b129$export$8364e41b11fd7d3b = (thrown, fallbackMessage = 'Hook callback threw')=>{
    if (thrown instanceof Error) return thrown;
    if (typeof thrown === 'string') return new Error(thrown);
    return new Error(fallbackMessage);
};
// Match Builder
/** @internal — used to tag match-builder objects in place of `instanceof`. */ const $d7a7c6eb9fc5b129$var$MATCH_BUILDER_TAG = Symbol('MatchBuilder');
/** @internal — creates a builder with the given accumulated state (location already resolved). */ const $d7a7c6eb9fc5b129$var$makeMatchBuilder = (locationKey, contextPredicates, dataPredicates)=>{
    const builder = {
        messageContext (predicate) {
            return $d7a7c6eb9fc5b129$var$makeMatchBuilder(locationKey, [
                ...contextPredicates,
                predicate
            ], dataPredicates);
        },
        custom (predicate) {
            return $d7a7c6eb9fc5b129$var$makeMatchBuilder(locationKey, contextPredicates, [
                ...dataPredicates,
                predicate
            ]);
        },
        match (data) {
            if (dataPredicates.some((p)=>!p(data))) return [];
            const raw = data[locationKey] ?? [];
            if (!Array.isArray(raw)) throw new $d7a7c6eb9fc5b129$export$17455b84f403213b({
                locationKey: locationKey,
                invalidCount: 1
            });
            const items = raw;
            const invalidCount = items.filter((item)=>!$d7a7c6eb9fc5b129$export$a8ba7e6c095216ec(item)).length;
            if (invalidCount > 0) throw new $d7a7c6eb9fc5b129$export$17455b84f403213b({
                locationKey: locationKey,
                invalidCount: invalidCount
            });
            const candidates = items;
            return candidates.filter((message)=>contextPredicates.every((p)=>p(message.context)));
        }
    };
    // Tag the builder with a non-enumerable symbol so isMatchBuilder can identify it without
    // relying on instanceof (which would break across module boundaries or after minification).
    Object.defineProperty(builder, $d7a7c6eb9fc5b129$var$MATCH_BUILDER_TAG, {
        value: true,
        enumerable: false
    });
    return builder;
};
/** @internal — creates the initial builder with `messageLocation` available. */ const $d7a7c6eb9fc5b129$var$makeInitialMatchBuilder = ()=>{
    const initial = {
        messageLocation (key) {
            return $d7a7c6eb9fc5b129$var$makeMatchBuilder(key, [], []);
        },
        messageContext (predicate) {
            return $d7a7c6eb9fc5b129$var$makeMatchBuilder('messages', [
                predicate
            ], []);
        },
        custom (predicate) {
            return $d7a7c6eb9fc5b129$var$makeMatchBuilder('messages', [], [
                predicate
            ]);
        },
        match (data) {
            return $d7a7c6eb9fc5b129$var$makeMatchBuilder('messages', [], []).match(data);
        }
    };
    Object.defineProperty(initial, $d7a7c6eb9fc5b129$var$MATCH_BUILDER_TAG, {
        value: true,
        enumerable: false
    });
    return initial;
};
const $d7a7c6eb9fc5b129$export$be507563b85af550 = (value)=>{
    return typeof value === 'object' && value !== null && value[$d7a7c6eb9fc5b129$var$MATCH_BUILDER_TAG] === true;
};
const $d7a7c6eb9fc5b129$export$861b204abcaa015d = ()=>$d7a7c6eb9fc5b129$var$makeInitialMatchBuilder();
module.exports["PlacementValidationError"] = $d7a7c6eb9fc5b129$export$70abd424e1cca8c3;
module.exports["MultipleMessageInstancesError"] = $d7a7c6eb9fc5b129$export$fc2b8b9bcb86a0d0;
module.exports["PlacementLocationError"] = $d7a7c6eb9fc5b129$export$17455b84f403213b;
module.exports["isPlacementMessage"] = $d7a7c6eb9fc5b129$export$a8ba7e6c095216ec;
module.exports["toHookError"] = $d7a7c6eb9fc5b129$export$8364e41b11fd7d3b;
module.exports["isMatchBuilder"] = $d7a7c6eb9fc5b129$export$be507563b85af550;
module.exports["createMatchBuilder"] = $d7a7c6eb9fc5b129$export$861b204abcaa015d;

});

parcelRegister("d76kv", function(module, exports) {

let $98c0d6c6fc3cc045$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $98c0d6c6fc3cc045$var$load("4aKct"),
    $98c0d6c6fc3cc045$var$load("2vidw"),
    $98c0d6c6fc3cc045$var$load("8KaCS"),
    $98c0d6c6fc3cc045$var$load("6SzM6"),
    $98c0d6c6fc3cc045$var$load("4g6rd"),
    $98c0d6c6fc3cc045$var$load("cWzGN")
]).then(()=>parcelRequire('ikSqk'));

});

parcelRegister("bza1o", function(module, exports) {

let $86babca4580421e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86babca4580421e6$var$load("ga8T6").then(()=>parcelRequire('aoINW'));

});

parcelRegister("9peWR", function(module, exports) {
// Pure product key constants imported from product-keys.ts (source of truth).
// Re-exported below so existing consumers continue to work.
const $82b918b2869c0cd7$export$17120d8212b6e08f = (productKey)=>productKey ? productKey.toUpperCase() : undefined;
module.exports["getUppercasePrimaryProductKey"] = $82b918b2869c0cd7$export$17120d8212b6e08f;

});

parcelRegister("4jbt4", function(module, exports) {
const $a340a183e89f417d$export$3c42ae83d2ed6731 = (event)=>{
    return {
        ...event,
        attributes: {
            ...event.attributes.additionalAttributes
        }
    };
};
module.exports["remapVitalStatsEventForQuickFind"] = $a340a183e89f417d$export$3c42ae83d2ed6731;

});

parcelRegister("cI6da", function(module, exports) {
// oxlint-disable-next-line eslint/no-redeclare
const $f1e4b17e8f362f29$export$7254cc27399e90bd = {
    PREQUERY_ERROR: 'PREQUERY_ERROR',
    PREQUERY_LOADING: 'PREQUERY_LOADING',
    PREQUERY_NO_RESULTS: 'PREQUERY_NO_RESULTS',
    PREQUERY_RESULTS: 'PREQUERY_RESULTS',
    POSTQUERY_ERROR: 'POSTQUERY_ERROR',
    POSTQUERY_LOADING: 'POSTQUERY_LOADING',
    POSTQUERY_NO_RESULTS: 'POSTQUERY_NO_RESULTS',
    POSTQUERY_RESULTS: 'POSTQUERY_RESULTS'
};
const $f1e4b17e8f362f29$export$bbc0e9ab60a7c746 = (state)=>{
    return state === $f1e4b17e8f362f29$export$7254cc27399e90bd.PREQUERY_ERROR || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.PREQUERY_LOADING || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.PREQUERY_NO_RESULTS || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.PREQUERY_RESULTS;
};
const $f1e4b17e8f362f29$export$f33d0292f2f7a82a = (state)=>{
    return state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_ERROR || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_LOADING || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_NO_RESULTS || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_RESULTS;
};
const $f1e4b17e8f362f29$export$3d387094581134ab = (state)=>{
    return state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_LOADING || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_RESULTS;
};
const $f1e4b17e8f362f29$export$de6adf92470c6d4 = (state)=>{
    return state === $f1e4b17e8f362f29$export$7254cc27399e90bd.PREQUERY_LOADING || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_LOADING;
};
const $f1e4b17e8f362f29$export$8984dd36dcb68400 = (state)=>{
    return state === $f1e4b17e8f362f29$export$7254cc27399e90bd.PREQUERY_NO_RESULTS || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_NO_RESULTS || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.PREQUERY_ERROR || state === $f1e4b17e8f362f29$export$7254cc27399e90bd.POSTQUERY_ERROR;
};
module.exports["State"] = $f1e4b17e8f362f29$export$7254cc27399e90bd;
module.exports["isPreQueryState"] = $f1e4b17e8f362f29$export$bbc0e9ab60a7c746;
module.exports["isPostQueryState"] = $f1e4b17e8f362f29$export$f33d0292f2f7a82a;
module.exports["isPostQueryLoadingOrResults"] = $f1e4b17e8f362f29$export$3d387094581134ab;
module.exports["isLoadingState"] = $f1e4b17e8f362f29$export$de6adf92470c6d4;
module.exports["isNotResultsState"] = $f1e4b17e8f362f29$export$8984dd36dcb68400;

});

parcelRegister("c9Gfx", function(module, exports) {

var $4IYIa = parcelRequire("4IYIa");

const $d87bd2ac4721e66c$var$ZeroQueryTypesV0 = [
    (0, $4IYIa.ZeroQueryType).RECENT_WORK,
    (0, $4IYIa.ZeroQueryType).RELATED_QUESTION,
    (0, $4IYIa.ZeroQueryType).WHO_IS
];
const $d87bd2ac4721e66c$var$ZeroQueryTypesV1 = [
    (0, $4IYIa.ZeroQueryType).BITBUCKET_PRS_CREATED_COLLABORATOR,
    (0, $4IYIa.ZeroQueryType).BITBUCKET_PRS_CREATED_COLLABORATOR_TOPIC,
    (0, $4IYIa.ZeroQueryType).COLLABORATOR_PROFILE,
    (0, $4IYIa.ZeroQueryType).CONFLUENCE_PAGES_CREATED,
    (0, $4IYIa.ZeroQueryType).CONFLUENCE_PAGES_CREATED_30_DAYS,
    (0, $4IYIa.ZeroQueryType).CONFLUENCE_PAGES_CREATED_7_DAYS,
    (0, $4IYIa.ZeroQueryType).CONFLUENCE_PAGES_CREATED_COLLABORATOR,
    (0, $4IYIa.ZeroQueryType).CONFLUENCE_PAGES_CREATED_COLLABORATOR_30_DAYS,
    (0, $4IYIa.ZeroQueryType).CONFLUENCE_PAGES_CREATED_COLLABORATOR_7_DAYS,
    (0, $4IYIa.ZeroQueryType).CONFLUENCE_PAGES_CREATED_COLLABORATOR_TOPIC,
    (0, $4IYIa.ZeroQueryType).JIRA_MY_WORK_ITEMS,
    (0, $4IYIa.ZeroQueryType).JIRA_NLQ,
    (0, $4IYIa.ZeroQueryType).JIRA_NLQ_COLLABORATOR,
    (0, $4IYIa.ZeroQueryType).JIRA_TICKETS_ASSIGNED,
    (0, $4IYIa.ZeroQueryType).JIRA_TICKETS_ASSIGNED_COLLABORATOR,
    (0, $4IYIa.ZeroQueryType).JIRA_TICKETS_CREATED,
    (0, $4IYIa.ZeroQueryType).JIRA_TICKETS_CREATED_COLLABORATOR,
    (0, $4IYIa.ZeroQueryType).JIRA_TICKETS_CREATED_COLLABORATOR_TOPIC,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_GITHUB_COLLABORATOR_PRS,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_GITHUB_COLLABORATOR_PRS_TOPIC,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS_TOPIC,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_GOOGLE_MY_DOCS,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS_TOPIC,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_SHAREPOINT_MY_DOCS,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_SLACK_MY_MESSAGES
];
// Bitbucket is deliberately absent: it is a first-party product, so its suggestions are not 3P even
// though they sit in the same Orbit-sourced pool as the GitHub ones.
const $d87bd2ac4721e66c$var$ZeroQueryTypes3P = [
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_GITHUB_COLLABORATOR_PRS,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_GITHUB_COLLABORATOR_PRS_TOPIC,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS_TOPIC,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_GOOGLE_MY_DOCS,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS_TOPIC,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_SHAREPOINT_MY_DOCS,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES,
    (0, $4IYIa.ZeroQueryType).THIRD_PARTY_SLACK_MY_MESSAGES
];
const $d87bd2ac4721e66c$export$2378e9e94d0e91e3 = (zeroQueryType)=>{
    if ($d87bd2ac4721e66c$var$ZeroQueryTypesV0.includes(zeroQueryType)) return 0;
    else if ($d87bd2ac4721e66c$var$ZeroQueryTypesV1.includes(zeroQueryType)) return 1;
    return null;
};
const $d87bd2ac4721e66c$export$6da79ec281e5bbf3 = (zeroQueryType)=>$d87bd2ac4721e66c$var$ZeroQueryTypes3P.includes(zeroQueryType);
module.exports["getZeroQueryVersion"] = $d87bd2ac4721e66c$export$2378e9e94d0e91e3;
module.exports["is3PZeroQuery"] = $d87bd2ac4721e66c$export$6da79ec281e5bbf3;

});

parcelRegister("4IYIa", function(module, exports) {
var $c7b4a75a494f5c4c$export$37f28874ca0f7950 = /*#__PURE__*/ function(ZeroQueryProduct) {
    ZeroQueryProduct["CONFLUENCE"] = "CONFLUENCE";
    ZeroQueryProduct["JIRA"] = "JIRA";
    ZeroQueryProduct["BITBUCKET"] = "BITBUCKET";
    ZeroQueryProduct["GOOGLE"] = "GOOGLE";
    ZeroQueryProduct["SLACK"] = "SLACK";
    ZeroQueryProduct["SHAREPOINT"] = "SHAREPOINT";
    ZeroQueryProduct["GITHUB"] = "GITHUB";
    return ZeroQueryProduct;
}({});
var $c7b4a75a494f5c4c$export$9573eaa7882f441b = /*#__PURE__*/ function(ZeroQueryDateRange) {
    ZeroQueryDateRange["TODAY"] = "today";
    ZeroQueryDateRange["YESTERDAY"] = "yesterday";
    ZeroQueryDateRange["PAST_7_DAYS"] = "past7days";
    ZeroQueryDateRange["PAST_30_DAYS"] = "past30days";
    return ZeroQueryDateRange;
}({});
var $c7b4a75a494f5c4c$export$32809655ff50de86 = /*#__PURE__*/ function(ZeroQueryType) {
    ZeroQueryType["BITBUCKET_PRS_CREATED_COLLABORATOR"] = "BITBUCKET_PRS_CREATED_COLLABORATOR";
    ZeroQueryType["BITBUCKET_PRS_CREATED_COLLABORATOR_TOPIC"] = "BITBUCKET_PRS_CREATED_COLLABORATOR_TOPIC";
    ZeroQueryType["COLLABORATOR_PROFILE"] = "COLLABORATOR_PROFILE";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED"] = "CONFLUENCE_PAGES_CREATED";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED_30_DAYS"] = "CONFLUENCE_PAGES_CREATED_30_DAYS";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED_7_DAYS"] = "CONFLUENCE_PAGES_CREATED_7_DAYS";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED_COLLABORATOR"] = "CONFLUENCE_PAGES_CREATED_COLLABORATOR";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED_COLLABORATOR_30_DAYS"] = "CONFLUENCE_PAGES_CREATED_COLLABORATOR_30_DAYS";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED_COLLABORATOR_7_DAYS"] = "CONFLUENCE_PAGES_CREATED_COLLABORATOR_7_DAYS";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED_COLLABORATOR_TOPIC"] = "CONFLUENCE_PAGES_CREATED_COLLABORATOR_TOPIC";
    ZeroQueryType["JIRA_MY_WORK_ITEMS"] = "JIRA_MY_WORK_ITEMS";
    ZeroQueryType["JIRA_NLQ"] = "JIRA_NLQ";
    ZeroQueryType["JIRA_NLQ_COLLABORATOR"] = "JIRA_NLQ_COLLABORATOR";
    ZeroQueryType["JIRA_TICKETS_ASSIGNED"] = "JIRA_TICKETS_ASSIGNED";
    ZeroQueryType["JIRA_TICKETS_ASSIGNED_COLLABORATOR"] = "JIRA_TICKETS_ASSIGNED_COLLABORATOR";
    ZeroQueryType["JIRA_TICKETS_CREATED"] = "JIRA_TICKETS_CREATED";
    ZeroQueryType["JIRA_TICKETS_CREATED_COLLABORATOR"] = "JIRA_TICKETS_CREATED_COLLABORATOR";
    ZeroQueryType["JIRA_TICKETS_CREATED_COLLABORATOR_TOPIC"] = "JIRA_TICKETS_CREATED_COLLABORATOR_TOPIC";
    ZeroQueryType["RECENT_WORK"] = "RECENT_WORK";
    ZeroQueryType["RELATED_QUESTION"] = "RELATED_QUESTION";
    ZeroQueryType["THIRD_PARTY_GITHUB_COLLABORATOR_PRS"] = "THIRD_PARTY_GITHUB_COLLABORATOR_PRS";
    ZeroQueryType["THIRD_PARTY_GITHUB_COLLABORATOR_PRS_TOPIC"] = "THIRD_PARTY_GITHUB_COLLABORATOR_PRS_TOPIC";
    ZeroQueryType["THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS"] = "THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS";
    ZeroQueryType["THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS_TOPIC"] = "THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS_TOPIC";
    ZeroQueryType["THIRD_PARTY_GOOGLE_MY_DOCS"] = "THIRD_PARTY_GOOGLE_MY_DOCS";
    ZeroQueryType["THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS"] = "THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS";
    ZeroQueryType["THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS_TOPIC"] = "THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS_TOPIC";
    ZeroQueryType["THIRD_PARTY_SHAREPOINT_MY_DOCS"] = "THIRD_PARTY_SHAREPOINT_MY_DOCS";
    ZeroQueryType["THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES"] = "THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES";
    ZeroQueryType["THIRD_PARTY_SLACK_MY_MESSAGES"] = "THIRD_PARTY_SLACK_MY_MESSAGES";
    ZeroQueryType["WHO_IS"] = "WHO_IS";
    return ZeroQueryType;
}({});
module.exports["ZeroQueryProduct"] = $c7b4a75a494f5c4c$export$37f28874ca0f7950;
module.exports["ZeroQueryDateRange"] = $c7b4a75a494f5c4c$export$9573eaa7882f441b;
module.exports["ZeroQueryType"] = $c7b4a75a494f5c4c$export$32809655ff50de86;

});

parcelRegister("6ZL8f", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");


var $4yYAm = parcelRequire("4yYAm");


var $3P0Fk = parcelRequire("3P0Fk");


var $79sCv = parcelRequire("79sCv");


var $7ta9v = parcelRequire("7ta9v");


var $1b6u9 = parcelRequire("1b6u9");


var $3bUf0 = parcelRequire("3bUf0");


var $5RzlA = parcelRequire("5RzlA");


var $dvVWp = parcelRequire("dvVWp");


var $jY1sc = parcelRequire("jY1sc");


var $dtCp5 = parcelRequire("dtCp5");


var $bE7SN = parcelRequire("bE7SN");


var $6PqYl = parcelRequire("6PqYl");


var $jL46I = parcelRequire("jL46I");


var $4DhjM = parcelRequire("4DhjM");


var $5PlEu = parcelRequire("5PlEu");


var $9rRtY = parcelRequire("9rRtY");


var $1xRe4 = parcelRequire("1xRe4");


var $4mnle = parcelRequire("4mnle");


var $3Z7rz = parcelRequire("3Z7rz");


var $5dTEu = parcelRequire("5dTEu");


var $i28CG = parcelRequire("i28CG");


var $7uIpT = parcelRequire("7uIpT");


var $9gI1G = parcelRequire("9gI1G");


var $1mE5s = parcelRequire("1mE5s");


var $ir4XI = parcelRequire("ir4XI");


var $32Eau = parcelRequire("32Eau");


var $5lH3O = parcelRequire("5lH3O");


var $3gPSp = parcelRequire("3gPSp");


var $fSyNz = parcelRequire("fSyNz");




const $2ca18adb176ffe1d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    },
    workItem: {
        id: "work_item",
        defaultMessage: "Work item"
    },
    draftLabel: {
        id: "draft_label",
        defaultMessage: "Draft"
    }
});



const $84fecf8779ba71cf$var$HoverCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("fHAed")).then((mod)=>({
            default: mod.HoverCard
        })));
const $84fecf8779ba71cf$var$labelContainer = (0, $buxP3.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $84fecf8779ba71cf$var$DraftBadge = ({ message: message })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "neutral"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), message)));
};
const $84fecf8779ba71cf$export$934ec3855ad17df5 = (data)=>{
    if ((data?.pageStatus === 'DRAFT' || data?.blogStatus === 'DRAFT') && data?.subtype !== 'LIVE') return [
        [
            'confluence-draft',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($84fecf8779ba71cf$var$DraftBadge, {
                message: (0, $2ca18adb176ffe1d$export$defe85febe8b728c).draftLabel
            })
        ]
    ];
};
const $84fecf8779ba71cf$var$mapConfluenceActivityToSearchResult = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { title: title, space: space, links: links } = activity.object.data;
    const highlightedTitle = title && query ? (0, $1b6u9.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const titleMetadataParts = $84fecf8779ba71cf$export$934ec3855ad17df5(activity.object.data);
    const isLiveDoc = activity.object.data?.subtype === (0, $3P0Fk.SearchConfluenceSubtype).LIVE && (0, $iDrrr.fg)('confluence_live_pages_open_beta_trait_opted_in');
    const icon = (0, $jL46I.getConfluenceEntityIcon)({
        iconUrl: activity.object.data.iconData,
        type: activity.object.type,
        isLiveDoc: isLiveDoc
    });
    const resultType = isLiveDoc ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $2ca18adb176ffe1d$export$defe85febe8b728c).liveDoc) : activity.object.type;
    const type = [
        'confluence-type',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $84fecf8779ba71cf$var$labelContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1xRe4.SearchResultType), {
            type: activity.object.type,
            defaultMessage: resultType,
            subtype: activity.object.data?.subtype
        }))
    ];
    const spaceName = space?.name || '';
    const metadata = [
        type,
        spaceName
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bE7SN.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bUf0.ReturnIcon), null));
    const urlBase = links?.base;
    const urlWebUi = links?.webUi;
    const url = urlBase && urlWebUi && `${urlBase}${urlWebUi}`;
    const spaceId = space?.id;
    const analyticsMetadata = {
        contentId: id,
        containerId: spaceId,
        contentType: `${(0, $dvVWp.ProductKeys).Confluence} ${activity.object.type}`,
        product: (0, $dvVWp.ProductKeys).Confluence,
        minutesSinceActivityTimestamp: (0, $9gI1G.calculateMinuteDifference)(timestamp)
    };
    if (!title || !url) return undefined;
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata,
        titleMetadataParts: titleMetadataParts
    };
};
const $84fecf8779ba71cf$export$d1c859566522d367 = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { key: key, fieldsById: fieldsById, webUrl: webUrl } = activity.object.data;
    const isIssue = activity.object.type === 'issue';
    const icon = (0, $jL46I.getJiraEntityIcon)({
        iconUrl: activity.object.data?.issueType?.avatar?.small,
        type: activity.object.type,
        isIssue: isIssue
    });
    const summary = fieldsById?.edges?.[0]?.node?.text;
    const title = key && summary && `${key}: ${summary}`;
    const highlightedTitle = title && query ? (0, $1b6u9.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const productMetadata = 'Jira';
    const projectName = activity?.object?.data?.fieldsById?.edges?.[0]?.node?.issue?.projectField?.project?.name ?? null;
    const issueTypeName = activity?.object?.data?.fieldsById?.edges?.[0]?.node?.issue?.issueTypeField?.issueType?.name ?? null;
    const metadata = [
        productMetadata,
        issueTypeName,
        projectName
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bE7SN.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bUf0.ReturnIcon), null));
    const analyticsMetadata = {
        contentId: id,
        contentType: `${(0, $dvVWp.ProductKeys).Jira} ${activity.object.type}`,
        product: (0, $dvVWp.ProductKeys).Jira,
        minutesSinceActivityTimestamp: (0, $9gI1G.calculateMinuteDifference)(timestamp)
    };
    if (!title || !webUrl) return undefined;
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: webUrl,
        analyticsMetadata: analyticsMetadata,
        isJiraIssue: isIssue
    };
};
const $84fecf8779ba71cf$export$38a5a0823b95c5be = (activity, query)=>{
    if (!activity.object.data) return undefined;
    const id = activity.object.id;
    const data = activity.object.data;
    const { assetsLabel: assetsLabel, assetsDisplayName: assetsDisplayName, displayTypename: displayTypename, links: links, assetsIcon: assetsIcon, schema: schema, objectType: objectType } = data;
    const title = (0, $iDrrr.fg)('cdm_ga') ? assetsDisplayName || '' : assetsLabel || undefined;
    const url = links?.web || null;
    if (!title || !url) return undefined;
    const icon = (0, $jL46I.getAssetsEntityIcon)({
        iconUrl: assetsIcon?.url48,
        type: activity.object.type,
        size: 'small'
    });
    const highlightedTitle = title && query ? (0, $1b6u9.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const schemaDisplayName = schema?.assetsSchemaDisplayName || objectType?.schema?.assetsSchemaDisplayName || null;
    const schemaInternalName = schema?.name || schema?.assetsSchemaName || objectType?.schema?.name || null;
    const schemaName = (0, $iDrrr.fg)('cdm_ga') ? schemaDisplayName || '' : schemaInternalName;
    const productMetadata = 'Assets';
    const schemaMetadata = (0, $iDrrr.fg)('cdm_ga') ? [
        'schema',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dtCp5.DisplayNameTooltip), {
            displayName: schemaDisplayName || '',
            name: schemaInternalName || ''
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), null, schemaDisplayName || ''))
    ] : schemaName;
    const metadata = [
        productMetadata,
        [
            activity.object.type,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $84fecf8779ba71cf$var$labelContainer
            }, displayTypename)
        ],
        schemaMetadata
    ];
    // Add event type information
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bE7SN.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bUf0.ReturnIcon), null));
    const analyticsMetadata = {
        contentId: id,
        contentType: `assets ${activity.object.type}`,
        // Normalise to the canonical 1P key ('cmdb') so analytics pipelines
        // see a single identifier regardless of whether the activity API
        // returns 'assets' or the ARI resource-owner is 'assets'.
        product: (0, $dvVWp.ProductKeys).Assets,
        minutesSinceActivityTimestamp: (0, $9gI1G.calculateMinuteDifference)(timestamp)
    };
    const titleTooltipData = (0, $iDrrr.fg)('cdm_ga') ? {
        displayName: assetsDisplayName || '',
        name: assetsLabel || ''
    } : undefined;
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata,
        titleTooltipData: titleTooltipData
    };
};
const $84fecf8779ba71cf$var$mapTownsquareActivityToSearchResult = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { name: name, key: key, url: url } = activity.object.data;
    const icon = (0, $jL46I.getAtlasEntityIcon)({
        iconUrl: activity.object.data.iconData,
        type: activity.object.type
    });
    const highlightedTitle = name && query ? (0, $1b6u9.highlightMatchedText)(name, query.split(' ')).highlightedTitle : undefined;
    const type = [
        'type',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $84fecf8779ba71cf$var$labelContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1xRe4.SearchResultType), {
            type: activity.object.type,
            defaultMessage: activity.object.type
        }))
    ];
    const metadata = [
        type,
        key ?? null
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bE7SN.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bUf0.ReturnIcon), null));
    let product = (0, $dvVWp.ProductKeys).Atlas;
    if (activity.object.type === 'goal') product = (0, $dvVWp.ProductKeys1PForAnalytics).AtlasGoals;
    else if (activity.object.type === 'project') product = (0, $dvVWp.ProductKeys1PForAnalytics).AtlasProjects;
    const analyticsMetadata = {
        contentId: id,
        contentType: `${(0, $dvVWp.ProductKeys).Atlas} ${activity.object.type}`,
        product: product,
        minutesSinceActivityTimestamp: (0, $9gI1G.calculateMinuteDifference)(timestamp)
    };
    if (!name || !url) return undefined;
    return {
        id: id,
        icon: icon,
        title: name,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $84fecf8779ba71cf$var$mapGraphDocumentActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if (!activity.object.data) return;
    const { type: type, displayName: displayName, parent: parent, url: url, provider: provider } = activity.object.data;
    const id = activity.object.id;
    const providerId = provider?.providerId;
    const product = (0, $3Z7rz.getProductFromProviderId)(thirdPartyConfigs, providerId) || (0, $5dTEu.getProductFromThirdPartyId)({
        thirdPartyId: id
    });
    if (!product) return;
    const subtype = type?.category?.toLowerCase();
    const label = (0, $jY1sc.getDocumentSubtypeLabel)({
        product: product,
        subtype: subtype
    });
    const title = displayName;
    if (!title || !url) return undefined;
    const highlightedTitle = title && query ? (0, $1b6u9.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4DhjM.ProductIcon), {
        size: "small",
        product: product,
        subtype: subtype
    });
    const typeLabel = [
        'typeLabel',
        label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $84fecf8779ba71cf$var$labelContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label)) : subtype ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $84fecf8779ba71cf$var$labelContainer
        }, subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()) : null
    ];
    const parentName = parent?.displayName ?? null;
    const metadata = [
        typeLabel,
        parentName
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bE7SN.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bUf0.ReturnIcon), null));
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${subtype}`,
        product: product,
        minutesSinceActivityTimestamp: (0, $9gI1G.calculateMinuteDifference)(timestamp)
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $84fecf8779ba71cf$var$mapGraphRemoteLinkActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if (!activity.object.data) return;
    const { category: category, displayName: displayName, url: url, provider: provider } = activity.object.data;
    const id = activity.object.id;
    const providerId = provider?.providerId;
    let product;
    let productDisplayName = '';
    if (providerId) {
        product = (0, $3Z7rz.getProductFromProviderId)(thirdPartyConfigs, providerId) || (0, $5dTEu.getProductFromThirdPartyId)({
            thirdPartyId: id
        });
        productDisplayName = (0, $4mnle.getProductDisplayNameFromProviderId)(thirdPartyConfigs, providerId) || '';
    }
    if (!product) return;
    const subtype = category?.toLowerCase();
    const label = (0, $jY1sc.getRemoteLinkSubtypeLabel)({
        product: product,
        subtype: subtype
    });
    const title = displayName;
    if (!title || !url) return undefined;
    const highlightedTitle = title && query ? (0, $1b6u9.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4DhjM.ProductIcon), {
        size: "small",
        product: product,
        subtype: subtype
    });
    const productLabel = [
        'productLabel',
        productDisplayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $84fecf8779ba71cf$var$labelContainer
        }, productDisplayName) : null
    ];
    const typeLabel = [
        'typeLabel',
        label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $84fecf8779ba71cf$var$labelContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label)) : null
    ];
    const metadata = [
        productLabel,
        typeLabel
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bE7SN.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bUf0.ReturnIcon), null));
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${subtype}`,
        product: product,
        minutesSinceActivityTimestamp: (0, $9gI1G.calculateMinuteDifference)(timestamp)
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $84fecf8779ba71cf$var$mapGraphActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if ((0, $79sCv.isDocumentActivity)(activity.object)) return $84fecf8779ba71cf$var$mapGraphDocumentActivityToSearchResult(activity, query, thirdPartyConfigs);
    if ((0, $79sCv.isRemoteLinkActivity)(activity.object)) return $84fecf8779ba71cf$var$mapGraphRemoteLinkActivityToSearchResult(activity, query, thirdPartyConfigs);
    return undefined;
};
const $84fecf8779ba71cf$var$mapGraphWorkItemActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if (!activity.object.data) return undefined;
    const id = activity.object.id;
    // `workItemStatus` is a GraphQL alias for `status` (see ExternalWorkItemFragment) to
    // avoid an AGG FieldsConflict with ExternalPullRequest.status (enum vs String).
    const { displayName: displayName, url: url, provider: provider, workItemStatus: status } = activity.object.data;
    const providerId = provider?.providerId;
    let product;
    let productDisplayName = '';
    if (providerId) {
        product = (0, $3Z7rz.getProductFromProviderId)(thirdPartyConfigs, providerId) || (0, $5dTEu.getProductFromThirdPartyId)({
            thirdPartyId: id
        });
        productDisplayName = product && thirdPartyConfigs?.[product]?.displayName;
    }
    if (!product || !displayName || !url) return undefined;
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4DhjM.ProductIcon), {
        size: "small",
        product: product
    });
    const highlightedTitle = query ? (0, $1b6u9.highlightMatchedText)(displayName, query.split(' ')).highlightedTitle : undefined;
    const type = [
        'work-item-type',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $84fecf8779ba71cf$var$labelContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1xRe4.SearchResultType), {
            type: activity.object.type,
            defaultMessage: activity.object.type
        }))
    ];
    const productLabel = [
        'productLabel',
        productDisplayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $84fecf8779ba71cf$var$labelContainer
        }, productDisplayName) : null
    ];
    const metadata = [
        productLabel,
        type
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bE7SN.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bUf0.ReturnIcon), null));
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${activity.object.type}`,
        product: product
    };
    const titleMetadataParts = [];
    if (status) titleMetadataParts.push([
        'status',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6PqYl.GraphWorkItemStatusLozenge), {
            status: status
        })
    ]);
    return {
        id: id,
        icon: icon,
        title: displayName,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata,
        ...titleMetadataParts.length > 0 ? {
            titleMetadataParts: titleMetadataParts
        } : {}
    };
};
const $84fecf8779ba71cf$var$mapGraphPullRequestActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if (!activity.object.data) return undefined;
    const id = activity.object.id;
    const { displayName: displayName, url: url, provider: provider, status: prStatus } = activity.object.data;
    const providerId = provider?.providerId;
    let product;
    let productDisplayName = '';
    if (providerId) {
        product = (0, $3Z7rz.getProductFromProviderId)(thirdPartyConfigs, providerId) || (0, $5dTEu.getProductFromThirdPartyId)({
            thirdPartyId: id
        });
        productDisplayName = product && thirdPartyConfigs?.[product]?.displayName;
    }
    if (!product || !displayName || !url) return undefined;
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4DhjM.ProductIcon), {
        size: "small",
        product: product
    });
    const highlightedTitle = query ? (0, $1b6u9.highlightMatchedText)(displayName, query.split(' ')).highlightedTitle : undefined;
    const type = [
        'pull-request-type',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $84fecf8779ba71cf$var$labelContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1xRe4.SearchResultType), {
            type: activity.object.type,
            defaultMessage: activity.object.type
        }))
    ];
    const productLabel = [
        'productLabel',
        productDisplayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $84fecf8779ba71cf$var$labelContainer
        }, productDisplayName) : null
    ];
    const metadata = [
        productLabel,
        type
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bE7SN.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bUf0.ReturnIcon), null));
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${activity.object.type}`,
        product: product
    };
    const titleMetadataParts = [];
    if (prStatus) titleMetadataParts.push([
        'status',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: (0, $7uIpT.getPullRequestStatusAppearance)(prStatus),
            testId: "pull-request-status-lozenge"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7uIpT.getPullRequestStatusMessage)(prStatus)))
    ]);
    return {
        id: id,
        icon: icon,
        title: displayName,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata,
        ...titleMetadataParts.length > 0 ? {
            titleMetadataParts: titleMetadataParts
        } : {}
    };
};
const $84fecf8779ba71cf$var$mapLoomActivityToSearchResult = (activity, query)=>{
    if (!activity.object.data) return undefined;
    const id = activity.object.id;
    const { name: name, loomUrl: loomUrl, owner: owner, playableDuration: playableDuration } = activity.object.data;
    if (!name || !loomUrl) return undefined;
    const useNewLoomAppearance = (0, $iDrrr.fg)('loom-rovo-search');
    const icon = useNewLoomAppearance ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSyNz.LoomVideoIcon), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4DhjM.ProductIcon), {
        size: "small",
        product: (0, $dvVWp.ProductKeys).Loom
    });
    const highlightedTitle = query ? (0, $1b6u9.highlightMatchedText)(name, query.split(' ')).highlightedTitle : undefined;
    const metadata = [
        'Loom',
        'Video'
    ];
    if (useNewLoomAppearance && owner?.name) metadata.push(owner.name);
    if (useNewLoomAppearance && playableDuration != null) metadata.push([
        'duration',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3gPSp.LoomVideoDuration), {
            durationInSeconds: playableDuration
        })
    ]);
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bE7SN.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bUf0.ReturnIcon), null));
    const analyticsMetadata = {
        contentId: id,
        contentType: `${activity.object.product} ${activity.object.type}`,
        product: activity.object.product,
        minutesSinceActivityTimestamp: (0, $9gI1G.calculateMinuteDifference)(timestamp)
    };
    return {
        id: id,
        icon: icon,
        title: name,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: loomUrl,
        analyticsMetadata: analyticsMetadata
    };
};
const $84fecf8779ba71cf$export$1d02b83d52558ed = (edge, query, searchSessionId, thirdPartyConfigs, _generatedTownsquareCompatibility)=>{
    const activity = edge.node;
    const product = activity.object.product;
    const timestamp = activity.event.timestamp;
    let result;
    if ((0, $79sCv.isGraphPullRequestActivity)(activity.object)) result = $84fecf8779ba71cf$var$mapGraphPullRequestActivityToSearchResult(activity, query, thirdPartyConfigs);
    else if ((0, $79sCv.isGraphWorkItemActivity)(activity.object)) result = $84fecf8779ba71cf$var$mapGraphWorkItemActivityToSearchResult(activity, query, thirdPartyConfigs);
    else if ((0, $79sCv.isGraphActivity)(activity.object)) result = $84fecf8779ba71cf$var$mapGraphActivityToSearchResult(activity, query, thirdPartyConfigs);
    else if (product === 'confluence') result = $84fecf8779ba71cf$var$mapConfluenceActivityToSearchResult(activity, query);
    else if (product === 'jira') result = $84fecf8779ba71cf$export$d1c859566522d367(activity, query);
    else if (product === 'townsquare') result = $84fecf8779ba71cf$var$mapTownsquareActivityToSearchResult(activity, query);
    else if (product === 'assets' && (0, $iDrrr.fg)('assets_rovo_search_all')) result = $84fecf8779ba71cf$export$38a5a0823b95c5be(activity, query);
    else if ((0, $79sCv.isLoomActivity)(activity.object)) result = $84fecf8779ba71cf$var$mapLoomActivityToSearchResult(activity, query);
    else result = undefined;
    if (!result) return undefined;
    const urlWithAnalyticsQueryParams = (0, $7ta9v.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    return {
        ...result,
        url: urlWithAnalyticsQueryParams,
        minutesSinceActivityTimestamp: (0, $9gI1G.calculateMinuteDifference)(timestamp)
    };
};
const $84fecf8779ba71cf$export$8d9137fcb112aeab = ({ result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted, resultType: resultType = 'recentActivities' })=>{
    const quickFindQuery = (0, $5lH3O.useQuickFindQuery)();
    const { setHoverCardOpen: setHoverCardOpen } = (0, $5lH3O.useQuickFindActions)();
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const [primarySubProduct] = (0, $32Eau.usePrimarySubProduct)();
    const [searchSessionId] = (0, $32Eau.useSearchSessionId)();
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $32Eau.useBootstrap)();
    const { invalidateItem: invalidateItem } = (0, $5PlEu.useItemsAnalyticsContext)();
    const mappedResult = $84fecf8779ba71cf$export$1d02b83d52558ed(result, quickFindQuery, searchSessionId, thirdPartyConfigs);
    const isImpersonated = (0, $i28CG.isProductImpersonated)(mappedResult?.analyticsMetadata.product, thirdPartyConfigs);
    const additionalAnalyticsAttributes = (0, $cozmU.useMemo)(()=>({
            isCached: true,
            metadata: {
                ...mappedResult?.analyticsMetadata,
                connectorType: (0, $1mE5s.getResultConnectorSource)({
                    resultNodeId: result.node.object.id,
                    thirdPartyConfigs: thirdPartyConfigs,
                    productKey: mappedResult?.analyticsMetadata.product,
                    eventType: result.node.event.eventType
                }),
                recentActivityEventType: result.node.event.eventType
            },
            is3pLink: (0, $5RzlA.is3pProductKeyForAnalytics)(mappedResult?.analyticsMetadata.product),
            is3pSmartLink: (0, $1mE5s.isResultSmartLink)({
                resultAri: result.node.object.id,
                thirdPartyConfigs: thirdPartyConfigs,
                productKey: mappedResult?.analyticsMetadata.product,
                eventType: result.node.event.eventType
            })
        }), [
        mappedResult,
        result.node.object.id,
        thirdPartyConfigs,
        result.node.event.eventType
    ]);
    const onHoverCardVisibilityChange = (0, $cozmU.useCallback)((isOpen)=>{
        setHoverCardOpen(result.node.object.id, isOpen);
    }, [
        setHoverCardOpen,
        result.node.object.id
    ]);
    const onResultClicked = (0, $cozmU.useCallback)((event, data)=>{
        onClick?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes,
            isImpersonated: isImpersonated
        });
        onHoverCardVisibilityChange(false);
    }, [
        additionalAnalyticsAttributes,
        isImpersonated,
        onClick,
        state,
        onHoverCardVisibilityChange
    ]);
    const onResultContextMenu = (0, $cozmU.useCallback)((event, data)=>{
        onContextMenu?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes,
            isImpersonated: isImpersonated
        });
    }, [
        additionalAnalyticsAttributes,
        isImpersonated,
        onContextMenu,
        state
    ]);
    const onResultHighlighted = (0, $cozmU.useCallback)((data)=>{
        onHighlighted?.({
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onHighlighted,
        state
    ]);
    if (!mappedResult) {
        invalidateItem(result.node.object.id);
        return null;
    }
    const enableJiraIssueHoverCard = mappedResult.isJiraIssue && primaryProduct === (0, $dvVWp.ProductKeys).Jira;
    const searchResultElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9rRtY.SearchResult), {
        ...mappedResult,
        resultType: resultType,
        primaryProduct: primaryProduct,
        primarySubProduct: primarySubProduct,
        product: mappedResult.analyticsMetadata.product,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onResultHighlighted: onResultHighlighted,
        minutesSinceActivityTimestamp: mappedResult.minutesSinceActivityTimestamp,
        recentActivityEventType: result.node.event.eventType,
        objectType: result.node.object.type,
        connectorType: additionalAnalyticsAttributes.metadata.connectorType,
        titleTooltipData: mappedResult.titleTooltipData
    });
    return enableJiraIssueHoverCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ir4XI.ErrorBoundary), {
        fallback: searchResultElement,
        section: "recent-activity-hover-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: searchResultElement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($84fecf8779ba71cf$var$HoverCard, {
        onVisibilityChange: onHoverCardVisibilityChange,
        allowEventPropagation: true,
        url: mappedResult.url,
        actionOptions: {
            hide: false,
            exclude: [
                (0, $4yYAm.CardAction).PreviewAction
            ]
        },
        role: "dialog",
        titleId: mappedResult.title,
        label: "quick-find-smart-hover-card",
        shouldRenderToParent: true
    }, searchResultElement))) : searchResultElement;
};
module.exports["mapActivityToSearchResult"] = $84fecf8779ba71cf$export$1d02b83d52558ed;
module.exports["RecentActivity"] = $84fecf8779ba71cf$export$8d9137fcb112aeab;

});

parcelRegister("79sCv", function(module, exports) {
var $07b52e547ffa1d51$export$3ca4051c67b8ec7b = /*#__PURE__*/ function(ActivityProduct) {
    ActivityProduct["JIRA"] = "jira";
    ActivityProduct["CONFLUENCE"] = "confluence";
    ActivityProduct["ATLAS"] = "townsquare";
    ActivityProduct["GRAPH"] = "graph";
    ActivityProduct["ASSETS"] = "assets";
    ActivityProduct["GITHUB"] = "github";
    ActivityProduct["LOOM"] = "loom";
    return ActivityProduct;
}({});
var $07b52e547ffa1d51$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SL_VIEWED"] = "sl-viewed";
    return VIEWED_EVENT;
}({});
var $07b52e547ffa1d51$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $07b52e547ffa1d51$var$ExternalDocumentCategory = /*#__PURE__*/ function(ExternalDocumentCategory) {
    ExternalDocumentCategory["DOCUMENT"] = "DOCUMENT";
    ExternalDocumentCategory["PRESENTATION"] = "PRESENTATION";
    ExternalDocumentCategory["SPREADSHEET"] = "SPREADSHEET";
    return ExternalDocumentCategory;
}($07b52e547ffa1d51$var$ExternalDocumentCategory || {});
const $07b52e547ffa1d51$export$b7d2f1faf131fc56 = (activity)=>{
    return activity.type === 'remote-link';
};
const $07b52e547ffa1d51$export$8d4b7c5856642df3 = (activity)=>{
    return activity.type === 'document';
};
const $07b52e547ffa1d51$export$ed71d50c78c3618b = (activity)=>{
    return activity.product === 'graph';
};
const $07b52e547ffa1d51$export$11ceef76bf1f45cb = (activity)=>{
    return activity.product === 'github';
};
const $07b52e547ffa1d51$export$d26e891d2764b7d7 = (activity)=>{
    return activity.product === 'confluence' || activity.product === 'jira' || activity.product === 'townsquare';
};
const $07b52e547ffa1d51$export$3ec7f2aeaa1c6076 = (activity)=>{
    return activity.product === "assets";
};
const $07b52e547ffa1d51$export$41687a53e611f724 = (activity)=>{
    return activity.product === "loom";
};
const $07b52e547ffa1d51$export$91ddde0d7e8e9119 = (activity)=>{
    return activity.product === "graph" && activity.type === 'pull-request';
};
const $07b52e547ffa1d51$export$78b71c148e882a97 = (activity)=>{
    return activity.product === "graph" && activity.type === 'work-item';
};
module.exports["isRemoteLinkActivity"] = $07b52e547ffa1d51$export$b7d2f1faf131fc56;
module.exports["isDocumentActivity"] = $07b52e547ffa1d51$export$8d4b7c5856642df3;
module.exports["isGraphActivity"] = $07b52e547ffa1d51$export$ed71d50c78c3618b;
module.exports["is1PActivity"] = $07b52e547ffa1d51$export$d26e891d2764b7d7;
module.exports["isAssetsActivity"] = $07b52e547ffa1d51$export$3ec7f2aeaa1c6076;
module.exports["isLoomActivity"] = $07b52e547ffa1d51$export$41687a53e611f724;
module.exports["isGraphPullRequestActivity"] = $07b52e547ffa1d51$export$91ddde0d7e8e9119;
module.exports["isGraphWorkItemActivity"] = $07b52e547ffa1d51$export$78b71c148e882a97;

});

parcelRegister("3bUf0", function(module, exports) {
/* return.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kfRNa = parcelRequire("kfRNa");


var $iMnC5 = parcelRequire("iMnC5");


var $9NPFC = parcelRequire("9NPFC");

const $e8d2022b5916e308$var$styles = {
    base: "_1UtDYzZpcK"
};
const $e8d2022b5916e308$export$d6c38c54dfb7c9d5 = ({ size: size = 'small', label: label = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e8d2022b5916e308$var$styles.base
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: "",
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kfRNa))), {
        label: label
    })));
module.exports["ReturnIcon"] = $e8d2022b5916e308$export$d6c38c54dfb7c9d5;

});

parcelRegister("kfRNa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e42b42a1815e911076bb2de76bb24ee7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebeeef547073e2ff$var$_react = $ebeeef547073e2ff$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ebeeef547073e2ff$var$_iconNew = $ebeeef547073e2ff$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $ebeeef547073e2ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Return".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/return
 * Usage guidance:
 * Reserved for submitting text fields without dedicated button, mainly AI prompts
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ebeeef547073e2ff$var$ReturnIcon = (props)=>/*#__PURE__*/ $ebeeef547073e2ff$var$_react.default.createElement($ebeeef547073e2ff$var$_iconNew.default, Object.assign({
        name: "ReturnIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 8V3H14v5.438c0 .586-.476 1.062-1.062 1.062H4.56l2.72 2.72-1.061 1.06-4-4a.75.75 0 0 1 0-1.06l4-4 1.06 1.06L4.56 8z" clip-rule="evenodd"/>`
    }, props));
$ebeeef547073e2ff$var$ReturnIcon.displayName = 'ReturnIcon';
var $ebeeef547073e2ff$var$_default = module.exports.default = $ebeeef547073e2ff$var$ReturnIcon;

});

parcelRegister("5PlEu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3IGXe = parcelRequire("3IGXe");

const $75895dba4089ad94$var$ItemsContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $75895dba4089ad94$var$isItemCountable = (item)=>(0, $3IGXe.isSearchResultItem)(item) || (0, $3IGXe.isRecommendedDocumentItem)(item) || (0, $3IGXe.isRecentActivityItem)(item) || (0, $3IGXe.isPeopleAndTeamsItem)(item);
const $75895dba4089ad94$var$isHeading = (item)=>(0, $3IGXe.isHeadingItem)(item);
const $75895dba4089ad94$var$getItemsAndSectionsCount = (allItems)=>allItems.reduce(({ resultCount: resultCount, sectionCount: sectionCount }, item, currentIndex)=>{
        if ($75895dba4089ad94$var$isItemCountable(item)) resultCount++;
        if (currentIndex === 0 && !$75895dba4089ad94$var$isHeading(item)) // if the first item is not heading, we consider it in a section
        sectionCount++;
        if ($75895dba4089ad94$var$isHeading(item)) sectionCount++;
        return {
            resultCount: resultCount,
            sectionCount: sectionCount
        };
    }, {
        resultCount: 0,
        sectionCount: 0
    });
const $75895dba4089ad94$export$a511f36416966245 = ()=>{
    const ctx = (0, $cozmU.useContext)($75895dba4089ad94$var$ItemsContext);
    if (!ctx) // We throw an error here to make sure the hook is used within the provider,
    // otherwise it would return undefined and cause runtime errors and is hard to debug
    throw new Error('useItemsAnalyticsContext must be used within ItemsAnalyticsProvider');
    return ctx;
};
const $75895dba4089ad94$export$5643dbed0288c870 = ({ allItems: allItems, children: children })=>{
    const invalidatedIdsRef = (0, $cozmU.useRef)(new Set());
    (0, $cozmU.useEffect)(()=>{
        // Reset invalidated IDs when allItems change, the items would call invalidateItem again if needed
        invalidatedIdsRef.current.clear();
    }, [
        allItems
    ]);
    const invalidateItem = (id)=>{
        invalidatedIdsRef.current.add(id);
    };
    const { resultCount: resultCount, sectionCount: sectionCount } = (0, $cozmU.useMemo)(()=>$75895dba4089ad94$var$getItemsAndSectionsCount(allItems), [
        allItems
    ]);
    const getItemIndexes = (0, $cozmU.useCallback)((id)=>{
        const item = id && !invalidatedIdsRef.current.has(id) ? allItems.find((item)=>item.id === id) : undefined;
        if (!item || !$75895dba4089ad94$var$isItemCountable(item)) return undefined;
        let globalIndex = -1;
        let sectionIndex = -1;
        let indexWithinSection = -1;
        let sectionId = '';
        const activeItems = allItems.filter((item)=>!invalidatedIdsRef.current.has(item.id));
        for(let i = 0; i < activeItems.length; i++)if ($75895dba4089ad94$var$isHeading(activeItems[i])) {
            sectionIndex++;
            indexWithinSection = -1;
            sectionId = activeItems[i].id;
        } else {
            if (i === 0) // if the first item is not heading, we consider it in a section
            sectionIndex++;
            if ($75895dba4089ad94$var$isItemCountable(activeItems[i])) {
                indexWithinSection++;
                globalIndex++;
            }
            if (activeItems[i].id === id) return {
                globalIndex: globalIndex,
                sectionIndex: sectionIndex,
                indexWithinSection: indexWithinSection,
                resultCount: resultCount,
                sectionCount: sectionCount,
                sectionId: sectionId
            };
        }
        // if there is no match, return undefined
        return undefined;
    }, [
        allItems,
        resultCount,
        sectionCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($75895dba4089ad94$var$ItemsContext.Provider, {
        value: {
            invalidateItem: invalidateItem,
            getItemIndexes: getItemIndexes
        }
    }, children);
};
module.exports["useItemsAnalyticsContext"] = $75895dba4089ad94$export$a511f36416966245;
module.exports["ItemsAnalyticsProvider"] = $75895dba4089ad94$export$5643dbed0288c870;

});

parcelRegister("3IGXe", function(module, exports) {
const $d0eef912e597c3d2$export$6500cdbd153f3497 = (item)=>{
    return item.type === 'error';
};
const $d0eef912e597c3d2$export$6dc914a1cb2e7113 = (item)=>{
    return item.type === 'landing';
};
const $d0eef912e597c3d2$export$993e95eb6704a94c = (item)=>{
    return item.type === 'no-results';
};
const $d0eef912e597c3d2$export$9050e45a166250f = (item)=>{
    return item.type === 'heading';
};
const $d0eef912e597c3d2$export$d680994c1f15882e = (item)=>{
    return item.type === 'skeleton';
};
const $d0eef912e597c3d2$export$871ba967042323cb = (item)=>{
    return item.type === 'recent-query';
};
const $d0eef912e597c3d2$export$57fb632bdb82e6e6 = (item)=>{
    return item.type === 'autocomplete-suggestion';
};
const $d0eef912e597c3d2$export$99edcb23f38a2d86 = (item)=>{
    return item.type === 'zero-query';
};
const $d0eef912e597c3d2$export$329ac1434313f6b2 = (item)=>{
    return item.type === 'recent-activity';
};
const $d0eef912e597c3d2$export$579664463eebdcd8 = (item)=>{
    return item.type === 'recommended-document';
};
const $d0eef912e597c3d2$export$746233dd1618793c = (item)=>{
    return item.type === 'search-result';
};
const $d0eef912e597c3d2$export$bc8d42212d76a15c = (item)=>{
    return item.type === 'people-and-teams';
};
module.exports["isErrorItem"] = $d0eef912e597c3d2$export$6500cdbd153f3497;
module.exports["isLandingItem"] = $d0eef912e597c3d2$export$6dc914a1cb2e7113;
module.exports["isNoResultsItem"] = $d0eef912e597c3d2$export$993e95eb6704a94c;
module.exports["isHeadingItem"] = $d0eef912e597c3d2$export$9050e45a166250f;
module.exports["isSkeletonItem"] = $d0eef912e597c3d2$export$d680994c1f15882e;
module.exports["isRecentQueryItem"] = $d0eef912e597c3d2$export$871ba967042323cb;
module.exports["isAutocompleteSuggestionItem"] = $d0eef912e597c3d2$export$57fb632bdb82e6e6;
module.exports["isZeroQueryItem"] = $d0eef912e597c3d2$export$99edcb23f38a2d86;
module.exports["isRecentActivityItem"] = $d0eef912e597c3d2$export$329ac1434313f6b2;
module.exports["isRecommendedDocumentItem"] = $d0eef912e597c3d2$export$579664463eebdcd8;
module.exports["isSearchResultItem"] = $d0eef912e597c3d2$export$746233dd1618793c;
module.exports["isPeopleAndTeamsItem"] = $d0eef912e597c3d2$export$bc8d42212d76a15c;

});

parcelRegister("9rRtY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");

var $kh0hi = parcelRequire("kh0hi");

var $buxP3 = parcelRequire("buxP3");


var $kawxu = parcelRequire("kawxu");


var $kl6Mg = parcelRequire("kl6Mg");


var $89906 = parcelRequire("89906");


var $6Hb49 = parcelRequire("6Hb49");


var $4g98k = parcelRequire("4g98k");


var $9gI1G = parcelRequire("9gI1G");


var $3MEmE = parcelRequire("3MEmE");


var $gUz4r = parcelRequire("gUz4r");


var $dtCp5 = parcelRequire("dtCp5");


var $3zSbE = parcelRequire("3zSbE");


var $9S5yN = parcelRequire("9S5yN");


var $5PlEu = parcelRequire("5PlEu");

const $84a5581f1a0ded02$var$containerStyles = (0, $buxP3.xcss)({
    marginInlineStart: 'space.100',
    marginInlineEnd: 'space.100'
});
const $84a5581f1a0ded02$var$resultStyles = (0, $buxP3.xcss)({
    paddingBlockStart: 'space.075',
    paddingBlockEnd: 'space.075',
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100',
    borderRadius: 'radius.large',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
});
const $84a5581f1a0ded02$var$resultHoveredStlyes = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $84a5581f1a0ded02$var$keyboardHighlightedStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $84a5581f1a0ded02$var$iconAreaStyles = (0, $buxP3.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $84a5581f1a0ded02$var$middleAreaStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $84a5581f1a0ded02$var$titleStyles = (0, $buxP3.xcss)({
    overflow: 'clip',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $84a5581f1a0ded02$var$metadataStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    font: 'font.body.small',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '13px',
    display: 'flex',
    alignItems: 'center',
    minWidth: '0'
});
const $84a5581f1a0ded02$var$textOverflowStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $84a5581f1a0ded02$var$rightSectionStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: 'space.150'
});
const $84a5581f1a0ded02$var$linkStyles = (0, $buxP3.xcss)({
    color: 'color.text',
    textDecoration: 'none',
    display: 'inline-block',
    width: '100%',
    borderRadius: 'radius.large',
    ':hover': {
        textDecoration: 'none',
        color: 'color.text'
    },
    ':visited': {
        textDecoration: 'none',
        color: 'color.text'
    },
    ':focus': {
        textDecoration: 'none',
        color: 'color.text'
    }
});
const $84a5581f1a0ded02$var$pressableStyles = (0, $buxP3.xcss)({
    width: '100%'
});
const $84a5581f1a0ded02$var$headingStyle = (0, $buxP3.xcss)({
    display: 'inline-flex',
    gap: 'space.075',
    alignItems: 'center',
    maxWidth: '100%',
    // Fix height to match titleStyles lineHeight so that inline
    // children with built-in margins (e.g. Tag) do not cause the row to grow taller.
    height: "var(--ds-space-200, 16px)"
});
const $84a5581f1a0ded02$export$a2def421b23768aa = ({ icon: icon, title: title, resultType: resultType, product: product, primaryProduct: primaryProduct, primarySubProduct: primarySubProduct, metadata: metadata = [], rightMetadata: rightMetadata, hoveredRightMetadata: hoveredRightMetadata, highlightedRightMetadata: highlightedRightMetadata, url: url, isThirdParty: isThirdParty = false, highlightedTitle: highlightedTitle, includeInAnalytics: includeInAnalytics = true, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onResultHighlighted: onResultHighlighted, titleMetadataParts: titleMetadataParts, id: id, minutesSinceActivityTimestamp: minutesSinceActivityTimestamp, recentActivityEventType: recentActivityEventType, objectType: objectType, connectorType: connectorType, datasourceId: datasourceId, zeroQueryType: zeroQueryType, titleTooltipData: titleTooltipData })=>{
    const wrapperRef = (0, $cozmU.useRef)(null);
    const ref = (0, $cozmU.useRef)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const { getItemIndexes: getItemIndexes } = (0, $5PlEu.useItemsAnalyticsContext)();
    const navigationTrackingId = (0, $cozmU.useMemo)(()=>{
        if (resultType === 'intentRouterWorkItem') return `${resultType}:${0, $6Hb49.MATCHING_WORK_ITEM_ID}`;
        return id ? `${resultType}:${id}` : null;
    }, [
        id,
        resultType
    ]);
    const wrapCrossProductUrl = (0, $gUz4r.useSearchCrossProductUrlWrapper)({
        bridge: 'quickFind',
        primaryProduct: primaryProduct,
        primarySubProduct: primarySubProduct
    });
    const wrappedUrl = wrapCrossProductUrl(url, product);
    // Reports the cross-app interaction using the `xpis` param already on
    // `wrappedUrl`. A no-op when the URL was not wrapped.
    const crossAppLinkHandlers = (0, $3MEmE.useCrossAppLinkHandlers)({
        href: wrappedUrl,
        destinationApp: product
    });
    const [isKeyboardHighlighted, setRef] = (0, $89906.useKeyboardNavigation)({
        onKeydownCallback: (e)=>{
            /**
       * Two different event listeners are used to handle enter key presses
       * when the input is focused:
       * - the onKeyDown callback on the Textfield component which uses
       *   React's synthetic event listeners (onKeyDown)
       * - the keyboard highlight provider's onKeydownCallback which
       *   uses native event listeners (window.addEventListener). This one
       *   will only be called if a search result is highlighted.
       * Ideally there should be only one event listener however, it isn't
       * worth the effort to refactor the keyboard highlight provider right now.
       *
       * Given that the keyboard highlight provider's callback uses native
       * event listeners, it will always be called first. This is a problem
       * because there is no way for the keyboard highlight provider to
       * communicate that the event has been handled, resulting in a bug
       * where we try to handle the event twice if a search result was
       * highlighted. It must be noted that it cannot be guaranteed that
       * the search results are still highlighted after the native event
       * listener has executed as it could close the search dialog.
       *
       * To fix this, a somewhat hacky solution has been added to delay
       * the click event in the keyboard highlight provdier by one frame
       * in search-dialog-result/index. This allows the React synthetic
       * event to decide if it should handle the event by checking if a
       * search result is highlighted, otherwise it will do nothing and
       * let the keyboard highlight provider handle the event.
       */ requestAnimationFrame(()=>{
                if (e.key === 'Enter') ref.current?.click();
            });
        },
        navigationTrackingId: // Used by KeyboardHighlightProvider to keep highlighting stable across re-orders.
        // Also enables imperative highlighting by a stable tracking id.
        //
        // NOTE: `id` alone can collide across sections (e.g. suggestion + recent query),
        // so we namespace it by `resultType`.
        // we need a fixed tracking ID for work item in intent detection to highlight it automatically
        navigationTrackingId,
        onHighlightedCallback: ()=>onResultHighlighted?.({
                ...getItemIndexes(id) ?? {},
                resultType: resultType
            })
    });
    const onClick = (0, $cozmU.useCallback)((event, { isAuxClick: isAuxClick = false } = {})=>onResultClicked?.(event, {
            ...getItemIndexes(id) ?? {},
            isAuxClick: isAuxClick,
            resultType: resultType
        }), [
        onResultClicked,
        getItemIndexes,
        id,
        resultType
    ]);
    const onContextMenu = (0, $cozmU.useCallback)((event)=>onResultContextMenu?.(event, {
            ...getItemIndexes(id) ?? {},
            resultType: resultType
        }), [
        onResultContextMenu,
        getItemIndexes,
        id,
        resultType
    ]);
    const metadataPartsWithTextOverflow = metadata.map((part, i)=>i === metadata.length - 1 && typeof part === 'string' ? [
            part,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $84a5581f1a0ded02$var$textOverflowStyles,
                as: "span"
            }, part)
        ] : part);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        ref: (node)=>{
            ref.current = node;
            setRef(node);
        },
        xcss: [
            $84a5581f1a0ded02$var$resultStyles,
            isHovered && $84a5581f1a0ded02$var$resultHoveredStlyes,
            isKeyboardHighlighted && $84a5581f1a0ded02$var$keyboardHighlightedStyles
        ],
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $84a5581f1a0ded02$var$iconAreaStyles
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $84a5581f1a0ded02$var$middleAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $84a5581f1a0ded02$var$headingStyle
    }, titleTooltipData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dtCp5.DisplayNameTooltip), {
        displayName: titleTooltipData.displayName,
        name: titleTooltipData.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $84a5581f1a0ded02$var$titleStyles,
            $84a5581f1a0ded02$var$textOverflowStyles
        ]
    }, highlightedTitle ? (0, $kl6Mg.enrichResultTitle)(highlightedTitle) : title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $84a5581f1a0ded02$var$titleStyles,
            $84a5581f1a0ded02$var$textOverflowStyles
        ]
    }, highlightedTitle ? (0, $kl6Mg.enrichResultTitle)(highlightedTitle) : title), titleMetadataParts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9S5yN.SearchMetadata), {
        parts: titleMetadataParts
    }))), metadata.length >= 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $84a5581f1a0ded02$var$metadataStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9S5yN.SearchMetadata), {
        parts: metadataPartsWithTextOverflow
    }))), hoveredRightMetadata && isHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $84a5581f1a0ded02$var$rightSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kawxu.Show), {
        above: "xs"
    }, hoveredRightMetadata)) : highlightedRightMetadata && isKeyboardHighlighted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $84a5581f1a0ded02$var$rightSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kawxu.Show), {
        above: "xs"
    }, highlightedRightMetadata)) : rightMetadata ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $84a5581f1a0ded02$var$rightSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kawxu.Show), {
        above: "xs"
    }, rightMetadata)) : null);
    // There should not be any focusable descendant to an 'option' element
    const ariaProps = {
        role: 'option',
        id: navigationTrackingId || undefined,
        'aria-selected': isKeyboardHighlighted
    };
    const resultWithoutAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $84a5581f1a0ded02$var$containerStyles
    }, (0, $iDrrr.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
        ...!url && ariaProps,
        // Pressable renders a native <button>, which only resets
        // box-sizing/appearance/border — NOT padding. Without this the
        // browser's default button padding is added on top of the row's
        // own padding, so the row inset differs from the <Box> (div)
        // variant. Reset it so both gate states render identically.
        padding: "space.0",
        backgroundColor: "color.background.neutral.subtle",
        xcss: $84a5581f1a0ded02$var$pressableStyles,
        onClick: (e)=>onClick(e),
        onAuxClick: (e)=>{
            if ((0, $4g98k.isAuxClick)(e)) return onClick(e, {
                isAuxClick: true
            });
        },
        onContextMenu: onContextMenu
    }, wrappedUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3zSbE.Link), {
        ...ariaProps,
        xcss: [
            $84a5581f1a0ded02$var$linkStyles
        ],
        rel: isThirdParty ? 'noreferrer' : '',
        target: isThirdParty ? '_blank' : undefined,
        href: wrappedUrl,
        testId: "search-dialog-result-link",
        ...crossAppLinkHandlers
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, content)) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        ...!url && ariaProps,
        onClick: (e)=>onClick(e),
        onAuxClick: (e)=>{
            if ((0, $4g98k.isAuxClick)(e)) return onClick(e, {
                isAuxClick: true
            });
        },
        onContextMenu: onContextMenu
    }, wrappedUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3zSbE.Link), {
        ...ariaProps,
        xcss: $84a5581f1a0ded02$var$linkStyles,
        rel: isThirdParty ? 'noreferrer' : '',
        target: isThirdParty ? '_blank' : undefined,
        href: wrappedUrl,
        testId: "search-dialog-result-link",
        ...crossAppLinkHandlers
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, content)));
    return includeInAnalytics ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9gI1G.SearchDialogResultAnalyticsWrapper), {
        "data-testid": "search-dialog-result",
        ref: wrapperRef,
        resultType: resultType,
        product: product,
        id: id,
        connectorType: connectorType,
        datasourceId: datasourceId,
        minutesSinceActivityTimestamp: minutesSinceActivityTimestamp,
        recentActivityEventType: recentActivityEventType,
        objectType: objectType,
        zeroQueryType: zeroQueryType
    }, resultWithoutAnalyticsWrapper) : resultWithoutAnalyticsWrapper;
};
module.exports["SearchResult"] = $84a5581f1a0ded02$export$a2def421b23768aa;

});

parcelRegister("kawxu", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $1tDzb = parcelRequire("1tDzb");


var $gP9iN = parcelRequire("gP9iN");


var $hgbrK = parcelRequire("hgbrK");

function $9278a0867c7923b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9278a0867c7923b7$var$showAboveQueries = (0, $gP9iN.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $9278a0867c7923b7$var$showBelowQueries = (0, $hgbrK.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $9278a0867c7923b7$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $9278a0867c7923b7$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1tDzb.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $lOiVq.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $9278a0867c7923b7$var$defaultHiddenStyles,
            above && $9278a0867c7923b7$var$showAboveQueries[above],
            below && $9278a0867c7923b7$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
module.exports["Show"] = $9278a0867c7923b7$export$f6a3d19be20f5819;

});

parcelRegister("gP9iN", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $lOiVq = parcelRequire("lOiVq");


var $9vEMa = parcelRequire("9vEMa");


var $gnKXs = parcelRequire("gnKXs");

const $43486d63aa94dbc3$export$918f8818cfbbeb2c = (input)=>{
    return (0, $9vEMa.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $lOiVq.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $gnKXs.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
module.exports["UNSAFE_buildAboveMediaQueryCSS"] = $43486d63aa94dbc3$export$918f8818cfbbeb2c;

});

parcelRegister("9vEMa", function(module, exports) {
const $5e5a55fac3e6fd2a$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $5e5a55fac3e6fd2a$export$2d293d9871c38e91 = Object.keys($5e5a55fac3e6fd2a$export$e5ee4fe8b989fd09);
const $5e5a55fac3e6fd2a$export$b7ed752a57b4177b = $5e5a55fac3e6fd2a$export$2d293d9871c38e91[0];
module.exports["UNSAFE_BREAKPOINTS_CONFIG"] = $5e5a55fac3e6fd2a$export$e5ee4fe8b989fd09;
module.exports["UNSAFE_BREAKPOINTS_ORDERED_LIST"] = $5e5a55fac3e6fd2a$export$2d293d9871c38e91;

});

parcelRegister("hgbrK", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $lOiVq = parcelRequire("lOiVq");


var $9vEMa = parcelRequire("9vEMa");


var $45mGg = parcelRequire("45mGg");

const $b7e4de65fa0c7921$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $9vEMa.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $lOiVq.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $45mGg.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};
module.exports["UNSAFE_buildBelowMediaQueryCSS"] = $b7e4de65fa0c7921$export$b2a4e2b0c6417297;

});

parcelRegister("45mGg", function(module, exports) {

var $gnKXs = parcelRequire("gnKXs");

const $61f180d366254050$export$c881183ca713c214 = (0, $gnKXs.media);
module.exports["UNSAFE_media"] = $61f180d366254050$export$c881183ca713c214;

});

parcelRegister("6Hb49", function(module, exports) {
const $49744f21e7730899$export$7cc7cea0c5a977c4 = 'intent-router-matching-work-item';
module.exports["MATCHING_WORK_ITEM_ID"] = $49744f21e7730899$export$7cc7cea0c5a977c4;

});

parcelRegister("4mnle", function(module, exports) {
/**
 * This file was adapted from confluence/next/packages/search-utils/src/excerpt.tsx
 */ parcelRequire("cozmU");

const $520f4059ef79cc73$export$eed5b9b4caf40e24 = (thirdPartyConfigs, providerId)=>{
    if (!providerId) return undefined;
    const [_id, config] = Object.entries(thirdPartyConfigs).find(([, config])=>config?.providerId === providerId) || [];
    if (!config) return undefined;
    return config.displayName;
};
module.exports["getProductDisplayNameFromProviderId"] = $520f4059ef79cc73$export$eed5b9b4caf40e24;

});

parcelRegister("5dTEu", function(module, exports) {

var $5HOm2 = parcelRequire("5HOm2");


var $dvVWp = parcelRequire("dvVWp");

const $ce49343af3cec932$export$f2c90bb8548eb326 = ({ thirdPartyId: thirdPartyId })=>{
    try {
        if (thirdPartyId) {
            const { resourceOwner: resourceOwner } = (0, $5HOm2.parseThirdPartyARI)(thirdPartyId);
            const resourceType = resourceOwner.split('.')[1];
            const productKey = resourceType === 'google-drive' || resourceType === 'google-drive-lite' ? 'drive' : resourceType || '';
            if ((0, $dvVWp.is3pProductKey)(productKey)) return productKey;
        }
        return undefined;
    } catch (e) {
        // If parsing fails, we default to undefined
        return undefined;
    }
};
module.exports["getProductFromThirdPartyId"] = $ce49343af3cec932$export$f2c90bb8548eb326;

});

parcelRegister("3gPSp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $GHTO7 = parcelRequire("GHTO7");

const $7a2e59cd59b000e0$export$4a4dc0a8bd3f80bd = ({ durationInSeconds: durationInSeconds })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const duration = (0, $GHTO7.convertVideoDuration)(durationInSeconds, {
        readable: true,
        formatMessage: formatMessage
    });
    return duration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, duration) : null;
};
module.exports["LoomVideoDuration"] = $7a2e59cd59b000e0$export$4a4dc0a8bd3f80bd;

});

parcelRegister("fSyNz", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $60Yxm = parcelRequire("60Yxm");


var $iMnC5 = parcelRequire("iMnC5");

const $1719f5a954451ac7$var$styles = {
    container: "_0bjKvDKTcp _0hPCNLDIqT _0KLXruDMqu _3iDTPbQ4SZ _0jFU0VN91d _37wbyuDIqT _39xV02N91d"
};
const $1719f5a954451ac7$export$412f97445c5fb31e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "loom-video-icon",
        xcss: $1719f5a954451ac7$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
        label: "",
        color: "var(--ds-icon-brand, #1868DB)",
        size: "small",
        spacing: "none"
    }));
module.exports["LoomVideoIcon"] = $1719f5a954451ac7$export$412f97445c5fb31e;

});

parcelRegister("fHAed", function(module, exports) {

let $b6e6f9557f6844da$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b6e6f9557f6844da$var$load("7A87G"),
    $b6e6f9557f6844da$var$load("6wr18"),
    $b6e6f9557f6844da$var$load("aCJpU"),
    $b6e6f9557f6844da$var$load("aLwQm"),
    $b6e6f9557f6844da$var$load("20Jnx"),
    $b6e6f9557f6844da$var$load("3hhnw"),
    $b6e6f9557f6844da$var$load("Wowvf"),
    $b6e6f9557f6844da$var$load("hhss7"),
    $b6e6f9557f6844da$var$load("1AaZJ"),
    $b6e6f9557f6844da$var$load("81uTE"),
    $b6e6f9557f6844da$var$load("jL1Ke"),
    $b6e6f9557f6844da$var$load("5MQ0D"),
    $b6e6f9557f6844da$var$load("ffEVr"),
    $b6e6f9557f6844da$var$load("f0CsL"),
    $b6e6f9557f6844da$var$load("56OxX"),
    $b6e6f9557f6844da$var$load("k7QWO")
]).then(()=>parcelRequire('fqHdA'));

});

parcelRegister("2PBjm", function(module, exports) {

var $cI6da = parcelRequire("cI6da");

function $efd18817843efd5d$export$b6f8db3ad0711b02(state) {
    switch(state){
        case (0, $cI6da.State).PREQUERY_RESULTS:
            return 'preQuerySearchResults';
        case (0, $cI6da.State).PREQUERY_LOADING:
            return 'preQueryLoadingSearchResults';
        case (0, $cI6da.State).POSTQUERY_LOADING:
            return 'cachedResults';
        case (0, $cI6da.State).POSTQUERY_RESULTS:
            return 'postQuerySearchResults';
        default:
            return '';
    }
}
module.exports["getActionSubjectId"] = $efd18817843efd5d$export$b6f8db3ad0711b02;

});

parcelRegister("1KAXF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $5lH3O = parcelRequire("5lH3O");

const $ed252291952cb68e$var$NOOP_CONTEXT = {
    enablePerceivedLatencyTracking: false,
    recordQueryChange: ()=>{},
    recordResultSelected: ()=>({}),
    observeResults: ()=>{},
    takeResultsAttributes: ()=>({}),
    resetResultsMeasurement: ()=>{},
    resetOnClear: ()=>{},
    resetOnSubmit: ()=>{}
};
const $ed252291952cb68e$var$QuickFindPerceivedLatencyContext = /*#__PURE__*/ (0, $cozmU.createContext)($ed252291952cb68e$var$NOOP_CONTEXT);
const $ed252291952cb68e$var$durationBetween = (startedAt, endedAt)=>Math.max(0, Math.round(endedAt - startedAt));
const $ed252291952cb68e$var$getPercentile = (sortedValues, percentile)=>{
    const index = Math.ceil(percentile / 100 * sortedValues.length) - 1;
    return sortedValues[Math.max(0, index)];
};
const $ed252291952cb68e$var$getInputResponsivenessAttributes = ({ inputTimestamps: inputTimestamps, results: results })=>{
    const durations = inputTimestamps.flatMap((inputTimestamp)=>{
        const nextResult = results.find(({ observedAt: observedAt })=>observedAt >= inputTimestamp);
        return nextResult ? [
            $ed252291952cb68e$var$durationBetween(inputTimestamp, nextResult.observedAt)
        ] : [];
    });
    if (durations.length === 0) return {};
    const sortedDurations = [
        ...durations
    ].sort((a, b)=>a - b);
    return {
        inputToResultsObservedDurationsMs: durations,
        maxInputToResultsObservedMs: sortedDurations[sortedDurations.length - 1],
        meanInputToResultsObservedMs: Math.round(durations.reduce((total, duration)=>total + duration, 0) / durations.length),
        p75InputToResultsObservedMs: $ed252291952cb68e$var$getPercentile(sortedDurations, 75),
        p90InputToResultsObservedMs: $ed252291952cb68e$var$getPercentile(sortedDurations, 90)
    };
};
const $ed252291952cb68e$var$EnabledQuickFindPerceivedLatencyProvider = ({ children: children })=>{
    const quickFindOpen = (0, $5lH3O.useQuickFindOpen)();
    const activeQueryRef = (0, $cozmU.useRef)(undefined);
    const firstResultStateRef = (0, $cozmU.useRef)({
        status: 'idle'
    });
    const firstClickStateRef = (0, $cozmU.useRef)({
        status: 'idle'
    });
    const previousQuickFindOpenRef = (0, $cozmU.useRef)(quickFindOpen);
    const resetResultsMeasurement = (0, $cozmU.useCallback)(()=>{
        activeQueryRef.current = undefined;
    }, []);
    const resetOnClear = (0, $cozmU.useCallback)(()=>{
        resetResultsMeasurement();
        firstResultStateRef.current = {
            status: 'idle'
        };
        firstClickStateRef.current = {
            status: 'idle'
        };
    }, [
        resetResultsMeasurement
    ]);
    const resetOnSubmit = (0, $cozmU.useCallback)(()=>{
        resetResultsMeasurement();
        firstClickStateRef.current = {
            status: 'idle'
        };
    }, [
        resetResultsMeasurement
    ]);
    const recordQueryChange = (0, $cozmU.useCallback)((eventTimestamp, isClear)=>{
        if (isClear) {
            resetOnClear();
            return;
        }
        if (firstResultStateRef.current.status === 'idle') firstResultStateRef.current = {
            status: 'pending',
            startedAt: eventTimestamp
        };
        if (firstClickStateRef.current.status === 'idle') firstClickStateRef.current = {
            status: 'pending',
            startedAt: eventTimestamp
        };
        if (!activeQueryRef.current) activeQueryRef.current = {
            inputTimestamps: [],
            results: []
        };
        activeQueryRef.current.inputTimestamps.push(eventTimestamp);
    }, [
        resetOnClear
    ]);
    const observeResults = (0, $cozmU.useCallback)((kind)=>{
        const observedAt = performance.now();
        const firstResult = firstResultStateRef.current;
        if (kind !== 'recent' && firstResult.status === 'pending') firstResultStateRef.current = {
            status: 'ready',
            durationMs: $ed252291952cb68e$var$durationBetween(firstResult.startedAt, observedAt)
        };
        activeQueryRef.current?.results.push({
            kind: kind,
            observedAt: observedAt
        });
    }, []);
    // Consume TTFR once until clear; only responsiveness resets with each shown event.
    const takeResultsAttributes = (0, $cozmU.useCallback)(()=>{
        const measurement = activeQueryRef.current;
        activeQueryRef.current = undefined;
        const firstResult = firstResultStateRef.current;
        const attributes = {};
        if (firstResult.status === 'ready') {
            attributes.timeToFirstResultMs = firstResult.durationMs;
            firstResultStateRef.current = {
                status: 'reported'
            };
        }
        return {
            ...attributes,
            ...measurement ? $ed252291952cb68e$var$getInputResponsivenessAttributes(measurement) : {}
        };
    }, []);
    const recordResultSelected = (0, $cozmU.useCallback)((eventTimestamp)=>{
        const firstClickState = firstClickStateRef.current;
        const shouldMeasure = firstClickState.status === 'pending';
        firstClickStateRef.current = {
            status: 'handled'
        };
        resetResultsMeasurement();
        return shouldMeasure ? {
            timeToFirstClickMs: $ed252291952cb68e$var$durationBetween(firstClickState.startedAt, eventTimestamp)
        } : {};
    }, [
        resetResultsMeasurement
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (previousQuickFindOpenRef.current && !quickFindOpen) resetResultsMeasurement();
        previousQuickFindOpenRef.current = quickFindOpen;
    }, [
        quickFindOpen,
        resetResultsMeasurement
    ]);
    const value = (0, $cozmU.useMemo)(()=>({
            enablePerceivedLatencyTracking: true,
            recordQueryChange: recordQueryChange,
            recordResultSelected: recordResultSelected,
            observeResults: observeResults,
            takeResultsAttributes: takeResultsAttributes,
            resetResultsMeasurement: resetResultsMeasurement,
            resetOnClear: resetOnClear,
            resetOnSubmit: resetOnSubmit
        }), [
        recordQueryChange,
        recordResultSelected,
        observeResults,
        takeResultsAttributes,
        resetResultsMeasurement,
        resetOnClear,
        resetOnSubmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ed252291952cb68e$var$QuickFindPerceivedLatencyContext.Provider, {
        value: value
    }, children);
};
const $ed252291952cb68e$export$3940845d0101be1d = ({ children: children })=>{
    if (!(0, $iDrrr.fg)('qf_perceived_latency_instrumentation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ed252291952cb68e$var$EnabledQuickFindPerceivedLatencyProvider, null, children);
};
const $ed252291952cb68e$export$871ae27943e876f9 = ()=>(0, $cozmU.useContext)($ed252291952cb68e$var$QuickFindPerceivedLatencyContext);
module.exports["QuickFindPerceivedLatencyProvider"] = $ed252291952cb68e$export$3940845d0101be1d;
module.exports["useQuickFindPerceivedLatency"] = $ed252291952cb68e$export$871ae27943e876f9;

});

parcelRegister("fbOob", function(module, exports) {

var $3ricL = parcelRequire("3ricL");


var $jH9cM = parcelRequire("jH9cM");


var $iDrrr = parcelRequire("iDrrr");

const $040b1ab3a66ac0dd$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        if ((0, $iDrrr.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            return (0, $3ricL.isFeatureEnabled)('confluence', featureKeyMap[contentType]);
        }
        return !(0, $jH9cM.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $040b1ab3a66ac0dd$export$dd376e644565eb89;

});

parcelRegister("fR63l", function(module, exports) {
/**
 * Product keys for third-party connectors.
 * Each key maps to a unique identifier used throughout the search system.
 */ // oxlint-disable-next-line eslint/no-redeclare
const $dce31c4071a2ecfb$export$93aa518ca2694c2d = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3',
    Databricks: 'databricks',
    JsmDC: 'jsm-dc',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Gong: 'gong',
    Zoom: 'zoom'
};
const $dce31c4071a2ecfb$export$5378b945bea99ba3 = {
    AtlassianWebCrawler: 'webcrawler-connector',
    Figma: 'figma-connector',
    Github: 'github-connector',
    GoogleDrive: 'google-drive-connector',
    OneDrive: 'onedrive-connector',
    Dropbox: 'dropbox-connector',
    Slack: 'slack-connector',
    Sharepoint: 'sharepoint-connector',
    Teams: 'microsoft-teams-connector',
    GoogleCalendar: 'google-calendar-connector',
    OutlookCalendar: 'outlook-calendar-connector',
    OutlookMail: 'outlook-mail-connector',
    Gmail: 'gmail-connector',
    AdobeSign: 'adobe-sign-connector',
    Asana: 'asana-connector',
    Zendesk: 'zendesk-connector',
    Airtable: 'airtable-connector',
    Smartsheet: 'smartsheet-connector',
    Notion: 'notion-connector',
    Miro: 'miro-connector',
    Docusign: 'docusign-connector',
    Lucid: 'lucid-connector',
    Monday: 'monday-connector',
    AzureDevops: 'azure-devops-connector',
    Gitlab: 'gitlab-connector',
    ConfluenceDC: 'confluence-dc-connector',
    JiraDC: 'jira-dc-connector',
    JsmDC: 'jsm-dc-connector',
    Canva: 'canva-connector',
    Box: 'box-connector',
    Zeplin: 'smartlinks-connector-zeplin',
    ServiceNow: 'servicenow-connector',
    Freshservice: 'freshservice-connector',
    PowerBI: 'smartlinks-connector-power-bi',
    ClickUp: 'smartlinks-connector-clickup',
    Amplitude: 'smartlinks-connector-amplitude',
    Stripe: 'smartlinks-connector-stripe',
    AdobeXD: 'smartlinks-connector-adobexd',
    Aha: 'aha-connector',
    Mural: 'smartlinks-connector-mural',
    Webex: 'smartlinks-connector-webex',
    Todoist: 'smartlinks-connector-todoist',
    PagerDuty: 'smartlinks-connector-pagerduty',
    Pipedrive: 'smartlinks-connector-pipedrive',
    Hubspot: 'hubspot-connector',
    Dovetail: 'smartlinks-connector-dovetail',
    LaunchDarkly: 'smartlinks-connector-launchdarkly',
    Salesforce: 'salesforce-connector',
    Sentry: 'smartlinks-connector-sentry',
    Gitbook: 'gitbook-connector',
    AWSS3: 'aws-s3-connector',
    Databricks: 'databricks-connector',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Gong: 'gong-connector',
    Zoom: 'zoom-connector'
};
module.exports["ProductKeys3P"] = $dce31c4071a2ecfb$export$93aa518ca2694c2d;
module.exports["ProductResourceTypes3P"] = $dce31c4071a2ecfb$export$5378b945bea99ba3;

});

parcelRegister("aj2pm", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

function $65dad62ca7b11e04$export$5b689ca7b019e89f(interactionName, error) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (!interaction) return;
    if (interaction.ufoName !== interactionName) return;
    (0, $a33Aa.addError)(interaction.id, error.name, null, 'Manual interaction error', error.errorMessage, undefined, true);
}
module.exports["setInteractionError"] = $65dad62ca7b11e04$export$5b689ca7b019e89f;

});

parcelRegister("7AGG2", function(module, exports) {

var $gMmzr = parcelRequire("gMmzr");

const $5be346a983dd4722$var$fetchUserRecommendations = (request, signal)=>{
    const url = (0, $gMmzr.PRD_CONFIG).getRecommendationServiceUrl(request.baseUrl);
    return fetch(url, {
        signal: signal,
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: request.performSearchQueryOnly,
            searchQuery: {
                cpusQueryHighlights: {
                    query: request.searchQuery?.cpusQueryHighlights?.query ?? '',
                    field: request.searchQuery?.cpusQueryHighlights?.field ?? ''
                },
                customQuery: request.searchQuery?.customQuery ?? '',
                customerDirectoryId: request.searchQuery?.customerDirectoryId ?? '',
                filter: request.searchQuery?.filter ?? '',
                minimumAccessLevel: request.searchQuery?.minimumAccessLevel ?? 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: request.searchQuery?.restrictTo?.userIds ?? [],
                    groupIds: request.searchQuery?.restrictTo?.userIds ?? []
                },
                searchUserbase: request.searchQuery?.searchUserbase ?? false,
                teamSearchFields: request.searchQuery?.teamSearchFields ?? []
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        throw new Error(`error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`);
    }).then((response)=>response.recommendedUsers);
};
var $5be346a983dd4722$export$2e2bcd8739ae039 = $5be346a983dd4722$var$fetchUserRecommendations;
module.exports["default"] = $5be346a983dd4722$export$2e2bcd8739ae039;

});

parcelRegister("gMmzr", function(module, exports) {
const $cc0245eb84decfef$export$d4fff2dfff3e2bc1 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey) {
        return productKey === 'jira' ? `/rest/api/3/user/bulk` : `/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `/${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};
module.exports["PRD_CONFIG"] = $cc0245eb84decfef$export$d4fff2dfff3e2bc1;

});

parcelRegister("8N8EQ", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $20c1508e7bfb5af0$var$NOT_AVAILABLE = 'not_available';
/**
 * HTTP response headers the gateway returns its trace / request IDs on. `fetchAgg` copies these
 * onto the parsed result as `gatewayTracingHeaders`.
 */ const $20c1508e7bfb5af0$var$TRACE_ID_HEADER = 'x-trace-id';
const $20c1508e7bfb5af0$var$REQUEST_ID_HEADER = 'atl-request-id';
const $20c1508e7bfb5af0$export$fca3401e33379daf = (result)=>{
    if (!result || typeof result !== 'object') return undefined;
    const preferTracingHeaders = (0, $iDrrr.fg)('rovo-search-vitalstats-trace-from-headers');
    if (preferTracingHeaders) {
        const tracingHeaders = result.gatewayTracingHeaders;
        const traceId = tracingHeaders?.[$20c1508e7bfb5af0$var$TRACE_ID_HEADER];
        const requestId = tracingHeaders?.[$20c1508e7bfb5af0$var$REQUEST_ID_HEADER];
        if (traceId || requestId) return {
            requestId: requestId,
            traceId: traceId
        };
    }
    if ('extensions' in result) {
        const extensions = result.extensions;
        const gateway = extensions?.gateway;
        if (gateway) return {
            requestId: gateway.request_id ?? undefined,
            // `tId` is the current gateway field name, `trace_id` the older one.
            traceId: preferTracingHeaders ? gateway.tId ?? gateway.trace_id ?? undefined : gateway.trace_id ?? undefined
        };
    }
    return undefined;
};
const $20c1508e7bfb5af0$export$4acb28c262cd52bd = (traceInfo)=>({
        requestId: traceInfo?.requestId ?? $20c1508e7bfb5af0$var$NOT_AVAILABLE,
        traceId: traceInfo?.traceId ?? $20c1508e7bfb5af0$var$NOT_AVAILABLE
    });
module.exports["extractTraceInfoFromResponse"] = $20c1508e7bfb5af0$export$fca3401e33379daf;
module.exports["normaliseTraceInfo"] = $20c1508e7bfb5af0$export$4acb28c262cd52bd;

});

parcelRegister("5msm2", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $glA79 = parcelRequire("glA79");


var $cc6x1 = parcelRequire("cc6x1");


var $3XLuW = parcelRequire("3XLuW");


var $hUO8p = parcelRequire("hUO8p");

const $7cb247512fa6c12a$export$2f6c9ab85be44d1a = (onErrorFn, shouldNotGetBackendExperiment = false, getLayerValuesFn)=>{
    if (shouldNotGetBackendExperiment) return;
    return $7cb247512fa6c12a$var$getParallelBackendExperimentsConfig(onErrorFn, getLayerValuesFn ?? $7cb247512fa6c12a$export$3178593b0bf95121);
};
const $7cb247512fa6c12a$export$3178593b0bf95121 = (layerName, options)=>{
    const layer = (0, $cXtTj.default).getLayer(layerName, {
        ...options?.fireLayerExposure === false ? {
            fireLayerExposure: false
        } : {}
    });
    const layerNameWithoutSuffix = layerName.replace('_standard', '').replace('_premium', '');
    return {
        name: layerNameWithoutSuffix,
        layerId: layer.get('layerId', 'default'),
        shadowId: layer.get('shadowId', null),
        // The below values might not be sent to the backend but we can still track them in the frontend
        controlId: layer.get('controlId', null),
        abTestId: layer.get('abTestId', 'no_ab_test_id'),
        armId: layer.get('armId', null),
        ...(0, $cXtTj.default).checkGate('search-experiment-overrides-backend') && {
            testId: layer.get('testId', null)
        }
    };
};
const $7cb247512fa6c12a$export$f0d0c69a221c32ee = (onError, fireLayerExposure = true, getLayerValuesFn)=>{
    try {
        const layer = (0, $cXtTj.default).getLayer((0, $3XLuW.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN), fireLayerExposure ? {} : {
            fireLayerExposure: false
        });
        let abTestId;
        let armId;
        let rawLayerFunctions;
        if (getLayerValuesFn) {
            const layerResult = getLayerValuesFn((0, $3XLuW.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN), fireLayerExposure ? {} : {
                fireLayerExposure: false
            });
            abTestId = layerResult.abTestId ?? 'no_ab_test_id';
            armId = layerResult.armId;
            rawLayerFunctions = layerResult.layerFunctions ?? [];
        } else {
            abTestId = layer.get('abTestId', 'no_ab_test_id');
            rawLayerFunctions = layer.get('layerFunctions', []);
            armId = layer.get('armId', null);
        }
        const layerFunctions = (0, $cc6x1.mutuallyExclusiveBackendSearchLogicParametersSchema).safeParse(rawLayerFunctions).data;
        return {
            layerFunctions: layerFunctions || [],
            abTestId: abTestId,
            armId: armId,
            // The get 'mutualExclusion' is breaking in Jira when retrieving a boolean value from layer,
            // so for the compatibility, we use the abTestId to determine if it's a mutually exclusive experiment
            mutualExclusion: abTestId !== 'no_ab_test_id'
        };
    } catch (error) {
        onError?.(error);
    }
};
const $7cb247512fa6c12a$var$getStandardOrPremiumLayerValues = (featureGateName, standardLayerName, premiumLayerName, resolveLayerValues = $7cb247512fa6c12a$export$3178593b0bf95121)=>{
    const isPremium = (0, $cXtTj.default).checkGate(featureGateName);
    if (isPremium) return resolveLayerValues(premiumLayerName);
    return resolveLayerValues(standardLayerName);
};
const $7cb247512fa6c12a$var$getParallelBackendExperimentsConfig = (onErrorFn, resolveLayerValues = $7cb247512fa6c12a$export$3178593b0bf95121)=>{
    try {
        const allLayers = [];
        const layer1 = $7cb247512fa6c12a$var$getStandardOrPremiumLayerValues((0, $3XLuW.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM), (0, $3XLuW.STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD), (0, $3XLuW.STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM), resolveLayerValues);
        allLayers.push(layer1);
        const layer2 = $7cb247512fa6c12a$var$getStandardOrPremiumLayerValues((0, $3XLuW.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM), (0, $3XLuW.STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD), (0, $3XLuW.STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM), resolveLayerValues);
        allLayers.push(layer2);
        const layer2Blending = resolveLayerValues((0, $3XLuW.STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER));
        allLayers.push(layer2Blending);
        const isLayer3Enabled = (0, $cXtTj.default).checkGate((0, $3XLuW.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED));
        if (isLayer3Enabled) {
            const layer3 = resolveLayerValues((0, $3XLuW.STATSIG_SEARCH_BACKEND_L3_LAYER));
            allLayers.push(layer3);
        }
        const isQueryExpansionLayerEnabled = (0, $cXtTj.default).checkGate((0, $3XLuW.STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED));
        if (isQueryExpansionLayerEnabled) {
            const layerQueryExpansion = resolveLayerValues((0, $3XLuW.STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER));
            allLayers.push(layerQueryExpansion);
        }
        const concatenatedExperimentId = allLayers.map((l)=>l?.layerId).join('_');
        const concatenatedShadowExperimentId = allLayers.map((l)=>l?.shadowId).join('_');
        return {
            experimentId: concatenatedExperimentId,
            shadowExperimentId: concatenatedShadowExperimentId,
            experimentLayers: allLayers
        };
    } catch (error) {
        onErrorFn?.(error);
    }
    return 0, $3XLuW.DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG;
};
const $7cb247512fa6c12a$var$isEnrolledInMutuallyExclusiveUIExperiment = (experience)=>{
    const isEnrolledInQuickFindUIExperiment = (0, $cXtTj.default).getLayerValue((0, $3XLuW.STATSIG_QUICK_FIND_LAYER), 'frontendExperimentName', '', {
        fireLayerExposure: false
    }) !== '';
    const isEnrolledInSearchPageUIExperiment = (0, $cXtTj.default).getLayerValue((0, $3XLuW.STATSIG_FULL_PAGE_SEARCH_LAYER), 'frontendExperimentName', '', {
        fireLayerExposure: false
    }) !== '';
    return experience === 'quick-find' && isEnrolledInQuickFindUIExperiment || experience === 'search-page' && isEnrolledInSearchPageUIExperiment;
};
const $7cb247512fa6c12a$var$applyBackendExperimentOverrides = (backendExperiment, backendExperimentOverrides)=>{
    // Handle undefined backendExperiment by creating a minimal experiment with empty layers
    const experiment = backendExperiment || {
        experimentLayers: []
    };
    const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $cXtTj.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
    const shouldApplyOverrides = enableRovoSearchOverrides && Boolean(backendExperimentOverrides?.length);
    if (!shouldApplyOverrides) return backendExperiment;
    return {
        ...experiment,
        experimentLayers: (0, $hUO8p.mergeBackendExperimentLayerOverrides)(experiment.experimentLayers ?? [], backendExperimentOverrides ?? [])
    };
};
/**
 * Helper function to apply overrides when normal experiment flow is not applicable.
 * Returns undefined if no overrides are provided, otherwise applies overrides to the backend experiment.
 */ const $7cb247512fa6c12a$var$applyOverridesOrReturnUndefined = (experimentConfig, backendExperimentOverrides)=>{
    const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $cXtTj.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
    const shouldApplyOverrides = enableRovoSearchOverrides && Boolean(backendExperimentOverrides?.length);
    if (!shouldApplyOverrides) return undefined;
    return $7cb247512fa6c12a$var$applyBackendExperimentOverrides(experimentConfig.backendExperiment, backendExperimentOverrides);
};
const $7cb247512fa6c12a$export$9009723727c24828 = ({ experimentConfig: experimentConfig, entities: entities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters, backendExperimentOverrides: backendExperimentOverrides, getLayerValuesFn: getLayerValuesFn })=>{
    if (!experimentConfig.dynamicExperiments) return $7cb247512fa6c12a$var$applyOverridesOrReturnUndefined(experimentConfig, backendExperimentOverrides);
    if ($7cb247512fa6c12a$var$isEnrolledInMutuallyExclusiveUIExperiment(experience)) return $7cb247512fa6c12a$var$applyOverridesOrReturnUndefined(experimentConfig, backendExperimentOverrides);
    const requestedEntities = entities.flatMap((entity)=>{
        try {
            const { resourceOwner: resourceOwner, resourceType: resourceType } = (0, $glA79.Ati).parse(entity);
            return [
                {
                    entity: resourceOwner,
                    subEntity: resourceType.toUpperCase()
                }
            ];
        } catch  {
            return [];
        }
    });
    // Skip layer exposure when overrides are enabled and there are overrides.
    const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $cXtTj.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
    const skipLayerExposure = enableRovoSearchOverrides && Boolean(backendExperimentOverrides?.length);
    const fireLayerExposure = !skipLayerExposure;
    const experimentParams = $7cb247512fa6c12a$export$f0d0c69a221c32ee(undefined, fireLayerExposure, getLayerValuesFn);
    if (experimentParams?.mutualExclusion) return $7cb247512fa6c12a$var$applyBackendExperimentOverrides((0, $hUO8p.mapMutuallyExclusiveExperiment)({
        experimentParams: experimentParams,
        productEdition: productEdition,
        isHello: isHello,
        requestedEntities: requestedEntities,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters
    }), backendExperimentOverrides);
    return $7cb247512fa6c12a$var$applyBackendExperimentOverrides((0, $hUO8p.mapDynamicExperiments)({
        dynamicExperiments: experimentConfig.dynamicExperiments,
        productEdition: productEdition,
        isHello: isHello,
        requestedEntities: requestedEntities,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters,
        fireLayerExposure: fireLayerExposure,
        getLayerValuesFn: getLayerValuesFn
    }), backendExperimentOverrides);
};
module.exports["getBackendExperimentConfig"] = $7cb247512fa6c12a$export$2f6c9ab85be44d1a;
module.exports["getLayerValues"] = $7cb247512fa6c12a$export$3178593b0bf95121;
module.exports["getBackendExperiment"] = $7cb247512fa6c12a$export$9009723727c24828;

});

parcelRegister("cc6x1", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $71e7a9f55d82afd8$var$experimentExperienceEnum = (0, $87Lnp.z).enum([
    'search-page',
    'quick-find',
    'search-page-space-filter',
    'quick-search',
    'advanced-search',
    'sain'
]);
const $71e7a9f55d82afd8$var$linkedEntityGranularityEnum = (0, $87Lnp.z).enum([
    'ALL_MATCHING_MESSAGES',
    'DEFAULT',
    'FULL_THREAD',
    'ONLY_LINKED_ENTITIES'
]);
const $71e7a9f55d82afd8$var$layerFunctionBaseSchema = {
    layerType: (0, $87Lnp.z).string().startsWith('search_platform_layer_').optional(),
    entity: (0, $87Lnp.z).string().optional(),
    subEntity: (0, $87Lnp.z).string().optional(),
    hello: (0, $87Lnp.z).boolean().optional(),
    isJiraIssueIndexed: (0, $87Lnp.z).boolean().optional(),
    linkedEntityGranularity: $71e7a9f55d82afd8$var$linkedEntityGranularityEnum.optional(),
    confluenceTier: (0, $87Lnp.z).string().array().optional(),
    productDataRegions: (0, $87Lnp.z).record((0, $87Lnp.z).string(), (0, $87Lnp.z).string().array()).optional(),
    experiences: $71e7a9f55d82afd8$var$experimentExperienceEnum.array().optional(),
    tenantIds: (0, $87Lnp.z).string().array().optional(),
    targetingGateId: (0, $87Lnp.z).string().optional(),
    providerId: (0, $87Lnp.z).string().optional(),
    connectorSources: (0, $87Lnp.z).array((0, $87Lnp.z).string()).optional(),
    integrationAri: (0, $87Lnp.z).string().optional()
};
const $71e7a9f55d82afd8$var$layerFunction = (0, $87Lnp.z).object($71e7a9f55d82afd8$var$layerFunctionBaseSchema);
const $71e7a9f55d82afd8$var$dynamicConfigSchema = (0, $87Lnp.z).string().transform((str, ctx)=>{
    try {
        return JSON.parse(str);
    } catch (e) {
        ctx.addIssue({
            code: 'custom',
            message: 'Invalid JSON'
        });
        return (0, $87Lnp.z).NEVER;
    }
}).pipe((0, $87Lnp.z).object({
    ...$71e7a9f55d82afd8$var$layerFunctionBaseSchema,
    statsigLayerId: (0, $87Lnp.z).string().startsWith('search_platform_')
}));
const $71e7a9f55d82afd8$var$mutuallyExclusiveDynamicConfigSchema = (0, $87Lnp.z).string().transform((str, ctx)=>{
    try {
        return JSON.parse(str);
    } catch (e) {
        ctx.addIssue({
            code: 'custom',
            message: 'Invalid JSON'
        });
        return (0, $87Lnp.z).NEVER;
    }
}).pipe((0, $87Lnp.z).object({
    ...$71e7a9f55d82afd8$var$layerFunctionBaseSchema,
    layerId: (0, $87Lnp.z).string(),
    controlId: (0, $87Lnp.z).string().optional()
}));
const $71e7a9f55d82afd8$export$4b5312b6cfd0d20a = (0, $87Lnp.z).array((0, $87Lnp.z).string()).transform((arrayJSONStrings)=>{
    return arrayJSONStrings.map((jsonStr)=>$71e7a9f55d82afd8$var$dynamicConfigSchema.safeParse(jsonStr).data).flatMap((dynamicConfig)=>dynamicConfig ? dynamicConfig : []);
}).refine((dynamicConfig)=>dynamicConfig.length); // The schema is invalid if all JSON strings are invalid
const $71e7a9f55d82afd8$export$e1f2182538b46e4b = (0, $87Lnp.z).array((0, $87Lnp.z).string()).transform((arrayJSONStrings)=>{
    return arrayJSONStrings.map((jsonStr)=>$71e7a9f55d82afd8$var$mutuallyExclusiveDynamicConfigSchema.safeParse(jsonStr).data).flatMap((dynamicConfig)=>dynamicConfig ? dynamicConfig : []);
}).refine((dynamicConfig)=>dynamicConfig.length); // The schema is invalid if all JSON strings are invalid
module.exports["dynamicExperimentsSchema"] = $71e7a9f55d82afd8$export$4b5312b6cfd0d20a;
module.exports["mutuallyExclusiveBackendSearchLogicParametersSchema"] = $71e7a9f55d82afd8$export$e1f2182538b46e4b;

});

parcelRegister("hUO8p", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $5msm2 = parcelRequire("5msm2");

const $90f2e5a1f458955f$var$WILDCARD = '*';
const $90f2e5a1f458955f$var$JIRA_ENTITY = 'jira';
const $90f2e5a1f458955f$var$mapExperimentsToSearchMatchingLayerExperimentsMetadata = (experiments)=>{
    const matchingLayers = experiments.reduce((metadata, { layerType: layerType, statsigLayerId: statsigLayerId })=>{
        if (!layerType) return metadata;
        if (metadata.some((metadataEntry)=>metadataEntry.layerType === layerType)) return metadata;
        return [
            ...metadata,
            {
                layerType: layerType,
                layerName: statsigLayerId
            }
        ];
    }, []);
    return matchingLayers.length ? {
        matchingLayers: matchingLayers
    } : undefined;
};
const $90f2e5a1f458955f$var$getLayersRelevantToSearchRequest = ({ dynamicExperiments: dynamicExperiments, requestedEntities: requestedEntities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters })=>{
    return dynamicExperiments.filter($90f2e5a1f458955f$var$containsTenantId(tenantId)).filter($90f2e5a1f458955f$export$647cb61786ce5ae0(productEdition)).filter($90f2e5a1f458955f$var$containsExperience(experience)).filter($90f2e5a1f458955f$var$isHelloTenant(isHello)).filter($90f2e5a1f458955f$var$containsRequestedEntities(requestedEntities)).filter($90f2e5a1f458955f$var$containsRequestedSubEntities(requestedEntities)).filter($90f2e5a1f458955f$export$273a58382ea22085(thirdPartyFilters)).filter($90f2e5a1f458955f$var$isJiraIssueIndexedConditionSatisfied(isJiraIssueIndexed)).filter($90f2e5a1f458955f$var$isLinkedEntityGranularityConditionSatisfied(linkedEntityGranularity)).filter($90f2e5a1f458955f$var$passesTargetingGate()).filter($90f2e5a1f458955f$var$satisfiesProductDataRegions(productDataRegions)).reduce((layerFunctions, currentLayerFunction)=>{
        // IF there are more than one definitions with the same definition
        // THEN only add the first one defined, (do not add this one)
        const containsCollision = layerFunctions.find((layerFunction)=>{
            /**
       * This isn't perfect either because there can be some edge cases where
       * an experiment definition is included, but not used. e.g.
       * - Defitions we have are:
       * 			[entity: confluence, subEntity: page],
       * 			[entity: confluence, subEntity: *]
       * - The request is for entity: confluence, subEntity: page
       *
       * Both definitions would be included in the final list, but only the
       * first would ever be used, but we fire exposures for both.
       *
       * To fix this, we would need to do one of the following:
       * - Replicate all of the fan out logic here (ugly and hard to maintain),
       *   so we know exactly which experiment definitions will get used
       * - Fire experiment exposures in the backend
       */ return layerFunction.layerType === currentLayerFunction.layerType && layerFunction.entity === currentLayerFunction.entity && layerFunction.subEntity === currentLayerFunction.subEntity && layerFunction.integrationAri === currentLayerFunction.integrationAri && layerFunction.providerId === currentLayerFunction.providerId && JSON.stringify(layerFunction.connectorSources?.sort()) === JSON.stringify(currentLayerFunction.connectorSources?.sort());
        });
        return containsCollision ? layerFunctions : [
            ...layerFunctions,
            currentLayerFunction
        ];
    }, []);
};
const $90f2e5a1f458955f$var$mapExperimentsToExperimentDefinitions = (experiments)=>{
    return experiments.reduce((experimentLayers, definitionWithLayerType)=>{
        const existingLayer = experimentLayers.find((layer)=>layer.name === definitionWithLayerType.layerType);
        const { controlId: _controlId, statsigLayerId: statsigLayerId, ...baseDefinition } = definitionWithLayerType.definition;
        const definition = (0, $iDrrr.fg)('search_send_statsig_layer_id') ? {
            ...baseDefinition,
            statsigLayerId: statsigLayerId
        } : baseDefinition;
        const analyticsDefinition = {
            ...definitionWithLayerType.definition
        };
        if (!existingLayer) {
            experimentLayers.push({
                name: definitionWithLayerType.layerType,
                layerId: null,
                // TODO QS-6283: Remove this once scalable statsig layers are rolled out
                shadowId: null,
                // TODO QS-6283: Remove this once scalable statsig layers are rolled out
                definitions: [
                    definition
                ],
                analyticsDefinitions: [
                    analyticsDefinition
                ]
            });
            return experimentLayers;
        }
        existingLayer.definitions?.push(definition);
        existingLayer.analyticsDefinitions?.push(analyticsDefinition);
        return experimentLayers;
    }, []);
};
const $90f2e5a1f458955f$export$10532bc904a76c69 = ({ experimentParams: experimentParams, requestedEntities: requestedEntities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters })=>{
    const dynamicExperiments = experimentParams?.layerFunctions || [];
    const { abTestId: abTestId, armId: armId } = experimentParams || {
        abTestId: null,
        armId: null
    };
    const relevantExperiments = $90f2e5a1f458955f$var$getLayersRelevantToSearchRequest({
        dynamicExperiments: dynamicExperiments,
        requestedEntities: requestedEntities,
        productEdition: productEdition,
        isHello: isHello,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters
    });
    const experiments = relevantExperiments.map((dynamicExp)=>{
        return {
            definition: {
                layerId: dynamicExp.layerId,
                shadowId: null,
                entity: dynamicExp.entity,
                subEntity: dynamicExp.subEntity,
                abTestId: abTestId,
                armId: armId,
                controlId: dynamicExp.controlId ?? null,
                statsigLayerId: null,
                providerId: dynamicExp.providerId,
                integrationARI: dynamicExp.integrationAri,
                connectorSources: dynamicExp.connectorSources
            },
            layerType: dynamicExp.layerType
        };
    });
    return {
        experimentLayers: $90f2e5a1f458955f$var$mapExperimentsToExperimentDefinitions(experiments)
    };
};
const $90f2e5a1f458955f$export$b9a99705ca4e42b9 = (experimentLayers, overrides)=>{
    const mergedLayers = experimentLayers.map((l)=>({
            ...l,
            // ensure that definitions and analyticsDefinitions have an array
            definitions: l.definitions ? [
                ...l.definitions
            ] : [],
            analyticsDefinitions: l.analyticsDefinitions ? [
                ...l.analyticsDefinitions
            ] : []
        }));
    for (const override of overrides){
        const overrideDefinitions = override.analyticsDefinitions ?? [];
        if (overrideDefinitions.length === 0) continue;
        const layer = mergedLayers.find((l)=>l.name === override.name);
        if (!layer) {
            // Remove controlId from definitions since they're for request payloads
            const requestDefinitions = overrideDefinitions.map(({ controlId: _controlId, ...def })=>def);
            mergedLayers.push({
                name: override.name,
                layerId: null,
                shadowId: null,
                definitions: requestDefinitions,
                analyticsDefinitions: [
                    ...overrideDefinitions
                ]
            });
            continue;
        }
        for (const overrideDef of overrideDefinitions){
            const keyEntity = overrideDef.entity ?? null;
            const keySubEntity = overrideDef.subEntity ?? null;
            const analyticsIndex = layer.analyticsDefinitions.findIndex((d)=>(d.entity ?? null) === keyEntity && (d.subEntity ?? null) === keySubEntity);
            if (analyticsIndex >= 0) layer.analyticsDefinitions[analyticsIndex] = overrideDef;
            else layer.analyticsDefinitions.push(overrideDef);
            const { controlId: _controlId, ...requestDef } = overrideDef;
            const requestIndex = layer.definitions.findIndex((d)=>(d.entity ?? null) === keyEntity && (d.subEntity ?? null) === keySubEntity);
            if (requestIndex >= 0) layer.definitions[requestIndex] = requestDef;
            else layer.definitions.push(requestDef);
        }
    }
    return mergedLayers;
};
const $90f2e5a1f458955f$export$37bc8313287bf4ea = ({ dynamicExperiments: dynamicExperiments, requestedEntities: requestedEntities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters, fireLayerExposure: fireLayerExposure = true, getLayerValuesFn: getLayerValuesFn = (0, $5msm2.getLayerValues) })=>{
    const relevantExperiments = $90f2e5a1f458955f$var$getLayersRelevantToSearchRequest({
        dynamicExperiments: dynamicExperiments,
        requestedEntities: requestedEntities,
        productEdition: productEdition,
        isHello: isHello,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters
    });
    const experiments = relevantExperiments.map((dynamicExp)=>{
        const { layerId: layerId, shadowId: shadowId, abTestId: abTestId, armId: armId, controlId: controlId } = getLayerValuesFn(dynamicExp.statsigLayerId, fireLayerExposure ? undefined : {
            fireLayerExposure: false
        });
        return {
            definition: {
                layerId: layerId,
                shadowId: shadowId,
                entity: dynamicExp.entity,
                subEntity: dynamicExp.subEntity,
                abTestId: abTestId,
                armId: armId,
                controlId: controlId,
                statsigLayerId: dynamicExp.statsigLayerId,
                providerId: dynamicExp.providerId,
                integrationARI: dynamicExp.integrationAri,
                connectorSources: dynamicExp.connectorSources
            },
            layerType: dynamicExp.layerType
        };
    });
    return {
        experimentLayers: $90f2e5a1f458955f$var$mapExperimentsToExperimentDefinitions(experiments),
        matchingLayerExperimentsMetadata: $90f2e5a1f458955f$var$mapExperimentsToSearchMatchingLayerExperimentsMetadata(relevantExperiments)
    };
};
const $90f2e5a1f458955f$export$647cb61786ce5ae0 = (productEdition)=>(dynamicExp)=>{
        // Opt for specificity. Does not filter out values that do not have the confluenceTier attribute
        if (!dynamicExp.confluenceTier || dynamicExp.confluenceTier.length === 0) return true;
        return !!dynamicExp.confluenceTier?.find((experimentTier)=>productEdition?.['confluence'] === experimentTier);
    };
const $90f2e5a1f458955f$var$isHelloTenant = (isHello)=>(dynamicExp)=>{
        if (dynamicExp.hello === undefined || dynamicExp.hello === null) return true;
        return dynamicExp.hello === isHello;
    };
const $90f2e5a1f458955f$var$passesTargetingGate = ()=>(dynamicExp)=>{
        if (dynamicExp.targetingGateId === undefined || dynamicExp.targetingGateId === null) return true;
        // eslint-disable-next-line @atlaskit/platform/static-feature-flags
        return (0, $iDrrr.fg)(dynamicExp.targetingGateId);
    };
/**
 * This is specifically used for targeting based on indexing status of the tenant.
 * This might NOT be needed once Jira indexed and ROVO in Jira is shipped to 100%
 */ const $90f2e5a1f458955f$var$isJiraIssueIndexedConditionSatisfied = (isJiraIssueIndexed)=>(dynamicExp)=>{
        if (isJiraIssueIndexed === undefined || dynamicExp.isJiraIssueIndexed === undefined || dynamicExp.isJiraIssueIndexed === null || dynamicExp?.entity !== $90f2e5a1f458955f$var$JIRA_ENTITY) return true;
        return dynamicExp.isJiraIssueIndexed === isJiraIssueIndexed;
    };
const $90f2e5a1f458955f$var$isLinkedEntityGranularityConditionSatisfied = (linkedEntityGranularity)=>(dynamicExp)=>{
        if (linkedEntityGranularity === undefined || dynamicExp.linkedEntityGranularity === undefined || dynamicExp.linkedEntityGranularity === null) return true;
        return dynamicExp.linkedEntityGranularity === linkedEntityGranularity;
    };
const $90f2e5a1f458955f$var$containsRequestedEntities = (entityFilter)=>(dynamicExp)=>{
        if (!dynamicExp.entity || dynamicExp.entity === $90f2e5a1f458955f$var$WILDCARD) return true;
        const isFilteredEntity = entityFilter.find((filteredEntity)=>dynamicExp.entity === filteredEntity.entity);
        return isFilteredEntity ?? false;
    };
const $90f2e5a1f458955f$var$containsRequestedSubEntities = (entityFilter)=>(dynamicExp)=>{
        if (!dynamicExp.subEntity || dynamicExp.subEntity === $90f2e5a1f458955f$var$WILDCARD) return true;
        const isFilteredSubEntity = entityFilter.find((filteredEntity)=>dynamicExp.subEntity === filteredEntity.subEntity);
        return isFilteredSubEntity ?? false;
    };
/**
 * Determines whether the provided data regions (dataRegions) are defined in
 * the dynamic configuration (dynamicExp). Every data region for a given product
 * in the dynamic configuration must be specified  in order for the given
 * experiment layer to be eligible.
 *
 * @param dataRegions Represents where the data comes from comes from for
 * each product.
 * ```
 * { 'confluence': ["us-west-2"], 'compass': ["us-east-1"] }`
 * ```
 *
 * @returns a boolean that indicates whether or not the provided data regions
 * (dataRegions) are specified in the dynamic configuration (dynamicExp).
 */ const $90f2e5a1f458955f$var$satisfiesProductDataRegions = (dataRegions)=>(dynamicExp)=>{
        if (!dynamicExp.productDataRegions) return true;
        return Object.keys(dynamicExp.productDataRegions).map((product)=>{
            const productDataRegions = dynamicExp.productDataRegions?.[product];
            const isProductEligible = dataRegions?.[product]?.every((dataRegion)=>{
                return productDataRegions?.includes(dataRegion);
            });
            return !!isProductEligible;
        }).reduce((prev, curr)=>prev && curr);
    };
const $90f2e5a1f458955f$var$containsExperience = (experience)=>(dynamicExp)=>{
        if (!dynamicExp.experiences || dynamicExp.experiences.length === 0) return true;
        return dynamicExp.experiences?.find((dynamicExpExperience)=>experience === dynamicExpExperience);
    };
const $90f2e5a1f458955f$var$containsTenantId = (tenantId)=>(dynamicExp)=>{
        if (!dynamicExp.tenantIds || dynamicExp.tenantIds.length === 0) return true;
        return dynamicExp.tenantIds?.find((dynamicExpTenantId)=>tenantId === dynamicExpTenantId);
    };
const $90f2e5a1f458955f$export$273a58382ea22085 = (thirdPartyFilters)=>(dynamicExp)=>{
        if (!dynamicExp.connectorSources?.length && !dynamicExp.providerId && !dynamicExp.integrationAri) return true;
        if (!thirdPartyFilters?.thirdPartyProducts) return false;
        const providerIdExp = dynamicExp.providerId ?? $90f2e5a1f458955f$var$WILDCARD;
        const integrationAriExp = dynamicExp.integrationAri ?? $90f2e5a1f458955f$var$WILDCARD;
        const connectorSourceExp = dynamicExp.connectorSources;
        const matches3pTarget = thirdPartyFilters.thirdPartyProducts.find((thirdPartyProduct)=>{
            // https://atlassian.slack.com/archives/C08CGNZTMC2/p1756690283247959
            const containsConnectorSource = thirdPartyProduct.connectorSources?.find((connectorSourceFromConfig)=>connectorSourceExp?.find((connectorSourceFromExp)=>connectorSourceFromExp === connectorSourceFromConfig));
            const matchesProviderId = providerIdExp === $90f2e5a1f458955f$var$WILDCARD || providerIdExp === thirdPartyProduct.providerId;
            const matchesIntegrationAri = integrationAriExp === $90f2e5a1f458955f$var$WILDCARD || integrationAriExp === thirdPartyProduct.integrationId;
            return(// !connectorSources = wildcard
            matchesProviderId && matchesIntegrationAri && (!connectorSourceExp || Boolean(containsConnectorSource)));
        });
        return Boolean(matches3pTarget);
    };
module.exports["mapMutuallyExclusiveExperiment"] = $90f2e5a1f458955f$export$10532bc904a76c69;
module.exports["mergeBackendExperimentLayerOverrides"] = $90f2e5a1f458955f$export$b9a99705ca4e42b9;
module.exports["mapDynamicExperiments"] = $90f2e5a1f458955f$export$37bc8313287bf4ea;

});

parcelRegister("7OWRz", function(module, exports) {
const $c1127f863192daaa$export$3268f1527392e5ac = [
    'ati:cloud:graph:pull-request'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI"] = $c1127f863192daaa$export$3268f1527392e5ac;

});

parcelRegister("dLc3D", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bZF61 = parcelRequire("bZF61");


var $fyjce = parcelRequire("fyjce");


var $4yj5G = parcelRequire("4yj5G");

const $3e4a2a10fd65a08f$var$QUICK_FIND_RECOMMENDED_DOCUMENTS_CACHE_KEY = 'quick-find-recommended-documents';
const $3e4a2a10fd65a08f$var$FAILURE_EXPIRATION_MS = 5000; // 5 seconds for failure
const $3e4a2a10fd65a08f$var$SUCCESS_EXPIRATION_MS = 300000; // 5 minutes for success
const $3e4a2a10fd65a08f$export$90883b912e6e9555 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $4yj5G.quickFindRecommendedDocumentsQuery)(),
        operationName: $4yj5G.operationName,
        headers: headers
    });
};
const { refreshOnAccessDecorator: $3e4a2a10fd65a08f$var$refreshOnAccessDecoratorRecommendedDocuments, clear: $3e4a2a10fd65a08f$var$clearRecommendedDocumentsCache } = (0, $fyjce.promiseCache)({
    name: $3e4a2a10fd65a08f$var$QUICK_FIND_RECOMMENDED_DOCUMENTS_CACHE_KEY
});
const $3e4a2a10fd65a08f$export$a4d862e87b221514 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, expiration: expiration, onlyRefreshIfExpired: onlyRefreshIfExpired, returnExpired: returnExpired, headers: headers })=>{
    const cacheKey = (0, $bZF61.generateHash)(`${$3e4a2a10fd65a08f$var$QUICK_FIND_RECOMMENDED_DOCUMENTS_CACHE_KEY}|${JSON.stringify(variables)}`).toString();
    const writeBackWithTTL = (value, ttl)=>{
        $3e4a2a10fd65a08f$var$refreshOnAccessDecoratorRecommendedDocuments({
            key: cacheKey,
            supplier: async ()=>value,
            returnExpired: false,
            onlyRefreshIfExpired: false,
            expiration: ttl
        });
    };
    return $3e4a2a10fd65a08f$var$refreshOnAccessDecoratorRecommendedDocuments({
        key: cacheKey,
        supplier: async ()=>{
            try {
                const result = await $3e4a2a10fd65a08f$export$90883b912e6e9555({
                    variables: variables,
                    aggAbsoluteUrl: aggAbsoluteUrl,
                    headers: headers
                });
                writeBackWithTTL(result, $3e4a2a10fd65a08f$var$SUCCESS_EXPIRATION_MS);
                return result;
            } catch (error) {
                // On failure, cache the rejected promise with a short TTL to avoid hammering the service
                // This ensures the error is still thrown when accessed, but prevents immediate retries
                writeBackWithTTL(Promise.reject(error), $3e4a2a10fd65a08f$var$FAILURE_EXPIRATION_MS);
                // Re-throw the error so the caller knows the request failed
                throw error;
            }
        },
        expiration: expiration,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        returnExpired: returnExpired
    });
};
const $3e4a2a10fd65a08f$export$d67c52a60a23cc67 = (key)=>$3e4a2a10fd65a08f$var$clearRecommendedDocumentsCache(key);
module.exports["cachedRecommendedDocumentsQuery"] = $3e4a2a10fd65a08f$export$a4d862e87b221514;

});

parcelRegister("fyjce", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $6dPGs = parcelRequire("6dPGs");


var $6s56R = parcelRequire("6s56R");


var $8N8EQ = parcelRequire("8N8EQ");


var $7jITD = parcelRequire("7jITD");


var $5oT59 = parcelRequire("5oT59");


var $esAoV = parcelRequire("esAoV");

const $86ca83201018b107$export$e89e805418f4d2c = (args)=>{
    const { name: name, shouldUseStorageAdapter: shouldUseStorageAdapter } = args;
    let cacheInstance = null;
    let resolvedStorage = null;
    // During refresh, the main cache will hold pending promises so we need a way to access the last resolved value
    // This cache can return these values while the refresh is in progress
    const resolvedValueCache = new Map();
    /**
   * NOTE: Scope control (QS-9209)
   *
   * The storage adapter system is introduced specifically so the combined search config cache
   * can participate in host-provided persistence (e.g., Confluence SSR local storage).
   */ const COMBINED_CONFIG_PERSISTED_CACHE_KEY = (0, $5oT59.SEARCH_COMBINED_CONFIG_CACHE_KEY);
    const defaultLocalStorageAdapter = {
        getItem: (key)=>(0, $6dPGs.getLocalStorageItemAsString)(key),
        setItem: (key, value)=>(0, $6dPGs.setLocalStorageItem)(key, value)
    };
    function shouldUseAdapterSystemForThisCache() {
        // Explicit opt-in/out takes precedence (lets two caches share a `name` but
        // target different storage — bare key vs host-adapter/account-namespaced key).
        // When unspecified, preserve the historical behaviour: the combined-config
        // cache routes through the host adapter so the legacy path is untouched.
        if (shouldUseStorageAdapter !== undefined && ((0, $iDrrr.fg)('rovo_fps_use_rovo_config') || (0, $6s56R.isUsingRovoConfigStoreExperiment)())) return shouldUseStorageAdapter;
        return name === COMBINED_CONFIG_PERSISTED_CACHE_KEY;
    }
    const getCacheInstance = ()=>{
        /**
     * We lazily create the cache instance to avoid the issue in SSR
     * where the localStorage isn't available.
     */ if (!cacheInstance) {
            cacheInstance = (0, $7jITD.getInstance)(args);
            // Resolve persisted state lazily (SSR-safe)
            let persistedState = null;
            try {
                if (shouldUseAdapterSystemForThisCache()) {
                    const factory = (0, $esAoV.getSearchClientStorageAdapterFactory)();
                    if (factory) {
                        resolvedStorage = factory();
                        persistedState = resolvedStorage?.getItem(name) ?? null;
                    }
                    // If the adapter cache is cold or the factory isn't registered yet, fall back
                    // to the raw localStorage key. This ensures stale-but-present data is served
                    // immediately rather than blocking on the network and potentially timing out
                    // the DegradablePromise.
                    // SSR-safe: getLocalStorageItemAsString throws in SSR -> caught by outer try/catch.
                    if (!persistedState) persistedState = (0, $6dPGs.getLocalStorageItemAsString)(name);
                } else persistedState = (0, $6dPGs.getLocalStorageItemAsString)(name);
            } catch  {
            // Error retrieving persisted state - continue without it
            }
            if (persistedState) {
                // Populate the resolved value cache with the contents of local storage
                const object = cacheInstance.deserialize(persistedState);
                if (object) Object.entries(object).forEach(([key, entry])=>{
                    if (entry && 'result' in entry) resolvedValueCache.set(key, entry.result);
                });
            }
        }
        return cacheInstance;
    };
    const get = (key, returnExpired)=>{
        const storedValue = getCacheInstance().get(key, returnExpired ?? true); // fetch expired result by default
        const isExpired = getCacheInstance().isExpired(key);
        return {
            storedValue: storedValue,
            isExpired: isExpired
        };
    };
    const set = async (key, result, expiration)=>{
        getCacheInstance().set(key, result, expiration);
        try {
            const resolvedValue = await result;
            resolvedValueCache.set(key, resolvedValue);
            const serialized = await getCacheInstance().serialize();
            if (serialized) {
                if (shouldUseAdapterSystemForThisCache()) {
                    const adapter = resolvedStorage ?? (0, $esAoV.getSearchClientStorageAdapterFactory)()?.() ?? defaultLocalStorageAdapter;
                    adapter.setItem(name, serialized);
                } else (0, $6dPGs.setLocalStorageItem)(name, serialized);
            }
        } catch  {
        // noop - an exception in the result promise or serialisation should be ignored so we dont throw unhandled exceptions
        }
    };
    const update = async (key, updater, expiration)=>{
        // Read remaining TTL before get(), which removes expired entries from the map
        const remainingTtl = expiration ?? getCacheInstance().getRemainingTtl(key);
        const { storedValue: storedValue } = get(key, true);
        if (!storedValue) return false;
        try {
            const currentValue = await storedValue;
            const updatedValue = updater(currentValue);
            await set(key, Promise.resolve(updatedValue), remainingTtl || undefined);
            return true;
        } catch  {
            return false;
        }
    };
    const clear = (key)=>{
        if (key) resolvedValueCache.delete(key);
        else resolvedValueCache.clear();
        getCacheInstance().clear(key);
    };
    const refreshOnAccessDecorator = ({ key: key, supplier: supplier, returnExpired: returnExpired, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, analyticsCallback: analyticsCallback, networkCallbacks: networkCallbacks, serveResolvedDuringRefresh: serveResolvedDuringRefresh, traceInfoExtractor: traceInfoExtractor })=>{
        const { storedValue: storedValue, isExpired: isExpired } = get(key, returnExpired);
        const shouldRefresh = onlyRefreshIfExpired ? isExpired : true;
        // When enabled, returns already-resolved values from an in-memory cache during background
        // refresh instead of returning pending promises. Callers can opt out by passing false.
        const serveResolvedDuringRefreshEnabled = serveResolvedDuringRefresh ?? false;
        if (!storedValue || shouldRefresh) {
            // Wrap the supplier to track network calls
            const trackedSupplier = async ()=>{
                networkCallbacks?.onStart();
                try {
                    const result = await supplier();
                    const traceInfo = traceInfoExtractor ? traceInfoExtractor() : (0, $8N8EQ.extractTraceInfoFromResponse)(result);
                    networkCallbacks?.onSuccess(traceInfo);
                    return result;
                } catch (error) {
                    const errorName = error?.name || 'UnknownError';
                    const errorMessage = error?.message || 'An unknown error occurred';
                    networkCallbacks?.onError(errorName, errorMessage, undefined);
                    throw error;
                }
            };
            const apiPromise = trackedSupplier();
            set(key, apiPromise, expiration);
            // If there was already a stored value prior to refreshing, return it
            if (storedValue) {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: true
                });
                // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
                if (serveResolvedDuringRefreshEnabled) {
                    const resolvedValue = resolvedValueCache.get(key);
                    if (resolvedValue !== undefined) return resolvedValue;
                }
                return storedValue;
            } else {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: false
                });
                return apiPromise;
            }
        } else {
            if (analyticsCallback) analyticsCallback({
                refreshTriggered: false,
                hit: true
            });
            // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
            if (serveResolvedDuringRefreshEnabled) {
                const resolvedValue = resolvedValueCache.get(key);
                if (resolvedValue !== undefined) return resolvedValue;
            }
            return storedValue;
        }
    };
    const seed = (key, value, expiration)=>set(key, Promise.resolve(value), expiration);
    return {
        get: get,
        refreshOnAccessDecorator: refreshOnAccessDecorator,
        clear: clear,
        update: update,
        seed: seed
    };
};
module.exports["promiseCache"] = $86ca83201018b107$export$e89e805418f4d2c;

});

parcelRegister("6dPGs", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7dBf8 = parcelRequire("7dBf8");

// `localStorage` is a browser-only Web API and does not exist during server-side
// rendering (SSR). Accessing the bare `localStorage` identifier on the server
// throws a `ReferenceError`, which crashes the render.
const $96c9493b1d7fc1a3$var$isLocalStorageAvailable = ()=>{
    return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
};
const $96c9493b1d7fc1a3$export$5aa524d86254b4f = (key, value)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return;
    if ((0, $iDrrr.fg)('search_page_use_browser_storage_controls')) (0, $7dBf8.AtlBrowserStorageLocal).setItem(key, value);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(key, value);
};
const $96c9493b1d7fc1a3$export$93d719890ad66653 = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return null;
    const item = (0, $iDrrr.fg)('search_page_use_browser_storage_controls') ? (0, $7dBf8.AtlBrowserStorageLocal).getItem(key) : // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};
const $96c9493b1d7fc1a3$export$5df15f289f441790 = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return null;
    const item = (0, $iDrrr.fg)('search_page_use_browser_storage_controls') ? (0, $7dBf8.AtlBrowserStorageLocal).getItem(key) : // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(key);
    return item ? item : null;
};
const $96c9493b1d7fc1a3$export$baf306891f1b93bd = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return;
    if ((0, $iDrrr.fg)('search_page_use_browser_storage_controls')) (0, $7dBf8.AtlBrowserStorageLocal).removeItem(key);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(key);
};
module.exports["setLocalStorageItem"] = $96c9493b1d7fc1a3$export$5aa524d86254b4f;
module.exports["getLocalStorageItem"] = $96c9493b1d7fc1a3$export$93d719890ad66653;
module.exports["getLocalStorageItemAsString"] = $96c9493b1d7fc1a3$export$5df15f289f441790;
module.exports["removeLocalStorageItem"] = $96c9493b1d7fc1a3$export$baf306891f1b93bd;

});

parcelRegister("6s56R", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $0f4933595e34bba8$export$aa9f97d4dfccb6ff = ()=>{
    if ((0, $iDrrr.fg)('rovo_cas_use_rovo_config')) return true;
    return (0, $cXtTj.default).getExperimentValue('rovo_cas_use_rovo_config_exp', 'cohort', 'control') === 'test';
};
module.exports["isUsingRovoConfigStoreExperiment"] = $0f4933595e34bba8$export$aa9f97d4dfccb6ff;

});

parcelRegister("7jITD", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $df3ea53f68f38eaa$var$DEFAULT_EXPIRATION = 900000; // 15 mins in milliseconds
const $df3ea53f68f38eaa$var$PERSISTED_EXPIRATION_GRACE_PERIOD = 86400000;
class $df3ea53f68f38eaa$var$Cache {
    get(key, returnExpired = false) {
        const entry = this.map[key];
        if (entry) {
            if (entry.isExpired()) {
                delete this.map[key];
                return returnExpired ? entry.getResult() : undefined;
            } else return entry.getResult();
        }
        return;
    }
    set(key, result, expiration) {
        const entry = new $df3ea53f68f38eaa$var$Entry({
            result: result,
            expirationTime: Date.now() + (expiration || this.expiration),
            accessCount: 0
        });
        this.map[key] = entry;
    }
    has(key) {
        return key in this.map;
    }
    clear(key) {
        if (key) delete this.map[key];
        else this.map = {};
    }
    async serialize() {
        const serialized = {};
        const cleanupEnabled = (0, $iDrrr.fg)('search_cache_cleanup_on_write');
        const cutoff = Date.now() - $df3ea53f68f38eaa$var$PERSISTED_EXPIRATION_GRACE_PERIOD;
        const resolvers = Object.entries(this.map).map(([key, entry])=>(async ()=>{
                // Filter persistence only: stale responses remain available in memory.
                // Skip before awaiting so obsolete promises cannot block this write.
                if (cleanupEnabled && entry.getExpirationTime() < cutoff) return;
                serialized[key] = {
                    result: await entry.getResult(),
                    expirationTime: entry.getExpirationTime(),
                    accessCount: entry.getAccessCount()
                };
            })());
        await Promise.all(resolvers);
        return JSON.stringify(serialized);
    }
    deserialize(persisted) {
        try {
            const object = JSON.parse(persisted);
            for(const key in object){
                const { result: result, expirationTime: expirationTime, accessCount: accessCount } = object[key];
                this.map[key] = new $df3ea53f68f38eaa$var$Entry({
                    result: Promise.resolve(result),
                    expirationTime: expirationTime,
                    accessCount: accessCount
                });
            }
            return object;
        } catch  {
        // TODO: Log error via sentry
        }
        return undefined;
    }
    isExpired(key) {
        const entry = this.map[key];
        return entry ? entry.isExpired() : true;
    }
    getRemainingTtl(key) {
        const entry = this.map[key];
        if (!entry) return undefined;
        return Math.max(0, entry.getExpirationTime() - Date.now());
    }
    constructor(args = {}){
        this.map = void 0;
        this.expiration = void 0;
        const { expiration: expiration = $df3ea53f68f38eaa$var$DEFAULT_EXPIRATION } = args;
        this.map = {};
        this.expiration = expiration;
    }
}
class $df3ea53f68f38eaa$var$Entry {
    getResult() {
        this.accessCount++;
        return this.result;
    }
    isExpired() {
        return this.expirationTime < Date.now();
    }
    getExpirationTime() {
        return this.expirationTime;
    }
    getAccessCount() {
        return this.accessCount;
    }
    constructor({ result: result, expirationTime: expirationTime, accessCount: accessCount }){
        this.result = void 0;
        this.expirationTime = void 0;
        this.accessCount = void 0;
        this.result = result;
        this.expirationTime = expirationTime;
        this.accessCount = accessCount;
    }
}
const $df3ea53f68f38eaa$export$8bedcca5bbd73999 = (args)=>{
    return new $df3ea53f68f38eaa$var$Cache(args);
};
module.exports["getInstance"] = $df3ea53f68f38eaa$export$8bedcca5bbd73999;

});

parcelRegister("4yj5G", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $34dc6f055b19b961$var$ConfluencePageFragment = `
  fragment ConfluencePageFragment on ConfluencePage {
    __typename
    id
    title
    type
    subtype
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $34dc6f055b19b961$var$ExternalDocumentFragment = `
  fragment ExternalDocumentFragment on ExternalDocument {
    __typename
    id
    displayName
    url
    documentType: type {
      category
    }
    parent @optIn(to: "ExternalDataDepotQueryV2") {
      ... on ExternalDocument {
        displayName
      }
    }
    provider {
      providerId
    }
  }
`;
const $34dc6f055b19b961$var$JiraIssueFragment = `
  fragment JiraIssueFragment on JiraIssue {
    __typename
    id
    key
    summary
    webUrl
    issueTypeAvatarUrl
    issueType {
      name
    }
    project {
      name
    }
  }
`;
const $34dc6f055b19b961$var$ExternalPullRequestFragment = `
  fragment ExternalPullRequestFragment on ExternalPullRequest {
    __typename
    id
    displayName
    url
    status
    provider {
      providerId
    }
  }
`;
const $34dc6f055b19b961$export$5db520940cf00715 = 'QuickFindRecommendedDocumentsQuery';
const $34dc6f055b19b961$export$53b4eb4fc8d1360f = ()=>{
    const includeIssueAndPullRequest = (0, $iDrrr.fg)('quick_find_recommendations_for_issue_pr');
    return `
  query ${$34dc6f055b19b961$export$5db520940cf00715} (
    $userId: String!,
    $tenantId: String!,
    $caller: String!,
    $maxNumberOfResults: Int!,
    $featureServiceModel: String
  ) {
    contextService {
      quickfindUserRecommendations(
        recommendationsQuery: {
          context: {
            userId: $userId
            tenantId: $tenantId
          }, modelRequestParams: {
            caller: $caller
            experience: "recommendedExternalDocument"
            featureServiceModel: $featureServiceModel
          },
          requestingUserId: $userId
          maxNumberOfResults: $maxNumberOfResults
        }
      ) {
        id
        score
        reason
        object {
          ...ConfluencePageFragment
          ...ExternalDocumentFragment
          ${includeIssueAndPullRequest ? `...JiraIssueFragment` : ''}
          ${includeIssueAndPullRequest ? `...ExternalPullRequestFragment` : ''}
        }
      }
    }
  }
  ${$34dc6f055b19b961$var$ConfluencePageFragment}
  ${$34dc6f055b19b961$var$ExternalDocumentFragment}
  ${includeIssueAndPullRequest ? $34dc6f055b19b961$var$JiraIssueFragment : ''}
  ${includeIssueAndPullRequest ? $34dc6f055b19b961$var$ExternalPullRequestFragment : ''}
`;
};
module.exports["operationName"] = $34dc6f055b19b961$export$5db520940cf00715;
module.exports["quickFindRecommendedDocumentsQuery"] = $34dc6f055b19b961$export$53b4eb4fc8d1360f;

});

parcelRegister("CLiaR", function(module, exports) {

var $4gJa3 = parcelRequire("4gJa3");

const $fe5d12ed5cb121b9$export$90241958e8ec24d5 = async (variables, headers)=>await (0, $4gJa3.zeroQueriesQuery)({
        variables: variables,
        headers: headers
    }).then((response)=>{
        const zeroQueries = response.data?.knowledgeDiscovery?.zeroQueries.zeroQueries || [];
        const shuffledZeroQueries = [
            ...zeroQueries
        ].sort(()=>Math.random() - 0.5);
        return shuffledZeroQueries.map($fe5d12ed5cb121b9$export$cf1f13813d90479a);
    });
const $fe5d12ed5cb121b9$export$e4c44fb2ea08e0f2 = async (variables, headers)=>await (0, $4gJa3.zeroQueriesQueryV1)({
        variables: variables,
        headers: headers
    }).then((response)=>{
        const zeroQueries = response.data?.knowledgeDiscovery?.zeroQueriesV1.zeroQueries || [];
        const shuffledZeroQueries = [
            ...zeroQueries
        ].sort(()=>Math.random() - 0.5);
        return shuffledZeroQueries.map($fe5d12ed5cb121b9$export$cf1f13813d90479a);
    });
const $fe5d12ed5cb121b9$export$cf1f13813d90479a = (zeroQuery)=>({
        id: zeroQuery.query,
        title: zeroQuery.query,
        data: zeroQuery.query,
        product: zeroQuery.product,
        accountId: zeroQuery.accountId,
        avatarUrl: zeroQuery.avatarUrl,
        dateRange: zeroQuery.dateRange,
        type: 'zero-query',
        zeroQueryType: zeroQuery.type
    });
const $fe5d12ed5cb121b9$export$123c86f509cbd0ab = async (variables, headers)=>await (0, $4gJa3.zeroQueriesMutation)({
        variables: variables,
        headers: headers
    }).then((response)=>response.data?.knowledgeDiscovery.markZeroQueryInteracted.success ?? false);
const $fe5d12ed5cb121b9$export$5ceed206e02a9ef = async (variables, headers)=>await (0, $4gJa3.zeroQueriesMutationV1)({
        variables: variables,
        headers: headers
    }).then((response)=>response.data?.knowledgeDiscovery.markZeroQueryInteractedV1.success ?? false);
module.exports["fetchZeroQueries"] = $fe5d12ed5cb121b9$export$90241958e8ec24d5;
module.exports["fetchZeroQueriesV1"] = $fe5d12ed5cb121b9$export$e4c44fb2ea08e0f2;
module.exports["mutateZeroQueries"] = $fe5d12ed5cb121b9$export$123c86f509cbd0ab;
module.exports["mutateZeroQueriesV1"] = $fe5d12ed5cb121b9$export$5ceed206e02a9ef;

});

parcelRegister("4gJa3", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");

const $3c69793304be7572$export$5db520940cf00715 = 'KnowledgeDiscoveryZeroQueries';
const $3c69793304be7572$export$c6209ded7eb543e2 = `
  query ${$3c69793304be7572$export$5db520940cf00715}($cloudId: String!, $product: KnowledgeDiscoveryProduct) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Get Zero Queries") {
			zeroQueries(cloudId: $cloudId, product: $product) {
                __typename
                ... on KnowledgeDiscoveryZeroQueries {
                    zeroQueries {
                        query
                        type
						product
						accountId
						avatarUrl
						dateRange
					}
                }
            }
		}
	}
`;
const $3c69793304be7572$export$7a489cc87c267c4 = 'MarkZeroQueryInteracted';
const $3c69793304be7572$export$e15ac8a4356bed82 = `
	mutation ${$3c69793304be7572$export$7a489cc87c267c4}($input: KnowledgeDiscoveryMarkZeroQueryInteractedInput!) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Mark Zero Query Interacted") {
			markZeroQueryInteracted(input: $input) {
				success
				errors {
					message
					extensions {
						errorType
						statusCode
					}
				}
			}
		}
	}
`;
const $3c69793304be7572$export$c279dc9ea93aad98 = 'KnowledgeDiscoveryZeroQueriesV1';
const $3c69793304be7572$export$cca6d12b1794e42a = `
  query ${$3c69793304be7572$export$c279dc9ea93aad98}($cloudId: String!, $product: KnowledgeDiscoveryProduct) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Get Zero Queries V1") {
			zeroQueriesV1(cloudId: $cloudId, product: $product) {
                __typename
                ... on KnowledgeDiscoveryZeroQueries {
                    zeroQueries {
                        query
                        type
						product
						accountId
						avatarUrl
						dateRange
					}
                }
            }
		}
	}
`;
const $3c69793304be7572$export$2650522d8a738e7e = 'MarkZeroQueryInteractedV1';
const $3c69793304be7572$export$93c9ddb071659b5e = `
	mutation ${$3c69793304be7572$export$2650522d8a738e7e}($input: KnowledgeDiscoveryMarkZeroQueryInteractedInput!) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Mark Zero Query Interacted V1") {
			markZeroQueryInteractedV1(input: $input) {
				success
				errors {
					message
					extensions {
						errorType
						statusCode
					}
				}
			}
		}
	}
`;


const $407dde704abfe629$export$4e6f8f14fd5cfc8c = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $b0Mpu.fetchAgg)({
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $3c69793304be7572$export$c6209ded7eb543e2),
        variables: variables,
        operationName: $3c69793304be7572$export$5db520940cf00715,
        headers: headers
    });
};
const $407dde704abfe629$export$2338c914f7e7b6c6 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $b0Mpu.fetchAgg)({
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $3c69793304be7572$export$cca6d12b1794e42a),
        variables: variables,
        operationName: (0, $3c69793304be7572$export$c279dc9ea93aad98),
        headers: headers
    });
};
const $407dde704abfe629$export$8cd0dd2078791744 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $b0Mpu.fetchAgg)({
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $3c69793304be7572$export$e15ac8a4356bed82),
        variables: variables,
        operationName: (0, $3c69793304be7572$export$7a489cc87c267c4),
        headers: headers
    });
};
const $407dde704abfe629$export$2ffea0896a0ec5f = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $b0Mpu.fetchAgg)({
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $3c69793304be7572$export$93c9ddb071659b5e),
        variables: variables,
        operationName: (0, $3c69793304be7572$export$2650522d8a738e7e),
        headers: headers
    });
};
module.exports["zeroQueriesQuery"] = $407dde704abfe629$export$4e6f8f14fd5cfc8c;
module.exports["zeroQueriesQueryV1"] = $407dde704abfe629$export$2338c914f7e7b6c6;
module.exports["zeroQueriesMutation"] = $407dde704abfe629$export$8cd0dd2078791744;
module.exports["zeroQueriesMutationV1"] = $407dde704abfe629$export$2ffea0896a0ec5f;

});

parcelRegister("gj3Ne", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

// Default value hoisted outside to prevent recreation on every render
const $664e039df50c0e81$var$DEFAULT_TASK_STATE = {
    id: null,
    state: 'idle',
    error: null,
    queryHash: null,
    queryLength: null,
    wordCount: null
};
const $664e039df50c0e81$var$IntentDetectionVitalStatsContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $664e039df50c0e81$export$7d6ff8eec92df467 = ({ children: children })=>{
    // Use hoisted default to prevent object recreation on every render
    const taskStateRef = (0, $cozmU.useRef)($664e039df50c0e81$var$DEFAULT_TASK_STATE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($664e039df50c0e81$var$IntentDetectionVitalStatsContext.Provider, {
        value: taskStateRef
    }, children);
};
const $664e039df50c0e81$export$714277298f52f5c1 = ()=>{
    const taskStateRef = (0, $cozmU.useContext)($664e039df50c0e81$var$IntentDetectionVitalStatsContext);
    if (!taskStateRef) throw new Error('useIntentDetectionVitalStatsTaskState must be used within IntentDetectionVitalStatsProvider');
    return taskStateRef;
};
module.exports["IntentDetectionVitalStatsProvider"] = $664e039df50c0e81$export$7d6ff8eec92df467;
module.exports["useIntentDetectionVitalStatsTaskState"] = $664e039df50c0e81$export$714277298f52f5c1;

});

parcelRegister("iUHik", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $kh0hi = parcelRequire("kh0hi");

const $58a543a95cff3170$export$8657eff97a198097 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: `searchDialogError`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });



var $68JhS = parcelRequire("68JhS");




const $00b8537859aba7ce$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    errorSearchHeading: {
        id: "search_dialog_error_search_heading",
        defaultMessage: "We're having trouble loading your recently viewed content."
    },
    errorSearchBody: {
        id: "search_dialog_error_search_body",
        defaultMessage: "It might just be a hiccup. Please try refreshing the page or <button>try again</button>."
    }
});



const $42921e4b3aa322b0$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("9ADuG")));
const $42921e4b3aa322b0$var$containerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.200',
    color: 'color.text'
});
const $42921e4b3aa322b0$var$imageFallbackStyles = (0, $buxP3.xcss)({
    width: '124px',
    height: '124px'
});
const $42921e4b3aa322b0$var$headingStyles = (0, $buxP3.xcss)({
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    marginTop: 'space.100'
});
const $42921e4b3aa322b0$var$bodyStyles = (0, $buxP3.xcss)({
    marginTop: 'space.100',
    font: 'font.body'
});
const $42921e4b3aa322b0$var$pressableStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    font: 'font.body',
    color: 'color.link',
    padding: 'space.0',
    ':hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
});
const $42921e4b3aa322b0$export$42f84e610f279c31 = ({ onRetry: onRetry })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $68JhS.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $68JhS.useQuickFindAttributes)();
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $58a543a95cff3170$export$8657eff97a198097)({
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    // Same as other analytics events, we only want this to fire when the screen displays
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $42921e4b3aa322b0$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $42921e4b3aa322b0$var$imageFallbackStyles
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($42921e4b3aa322b0$var$Image, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $42921e4b3aa322b0$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $00b8537859aba7ce$export$defe85febe8b728c).errorSearchHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $42921e4b3aa322b0$var$bodyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $00b8537859aba7ce$export$defe85febe8b728c).errorSearchBody,
        values: {
            button: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
                    xcss: $42921e4b3aa322b0$var$pressableStyles,
                    onClick: onRetry
                }, s)
        }
    })));
};
module.exports["ErrorScreen"] = $42921e4b3aa322b0$export$42f84e610f279c31;

});

parcelRegister("9ADuG", function(module, exports) {

let $6fb61c888389f770$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6fb61c888389f770$var$load("lW1Lt").then(()=>parcelRequire('cDSRf'));

});

parcelRegister("d5sGV", function(module, exports) {

let $9871ff8524d2e5ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9871ff8524d2e5ef$var$load("h9H07"),
    $9871ff8524d2e5ef$var$load("h8o2g"),
    $9871ff8524d2e5ef$var$load("6wr18"),
    $9871ff8524d2e5ef$var$load("3Yas1"),
    $9871ff8524d2e5ef$var$load("3jKKg"),
    $9871ff8524d2e5ef$var$load("ksZv4"),
    $9871ff8524d2e5ef$var$load("iN26T"),
    $9871ff8524d2e5ef$var$load("eUsnQ"),
    $9871ff8524d2e5ef$var$load("6C7Vr"),
    $9871ff8524d2e5ef$var$load("jmTCk"),
    $9871ff8524d2e5ef$var$load("Wowvf"),
    $9871ff8524d2e5ef$var$load("kHXvF"),
    $9871ff8524d2e5ef$var$load("ffEVr"),
    $9871ff8524d2e5ef$var$load("5DFe0")
]).then(()=>parcelRequire('f9KrX'));

});

parcelRegister("fcz8B", function(module, exports) {

var $3Ydx7 = parcelRequire("3Ydx7");


var $7kBI6 = parcelRequire("7kBI6");

const $684dfd7ed27180ad$export$a489a09e4aa74de0 = (primaryProduct)=>primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira ? 'jiraAdvancedIssueSearch' : `${primaryProduct.toLowerCase()}AdvancedSearchLink`;
const $684dfd7ed27180ad$export$50f1b1860bee88e0 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, actionSubjectId: actionSubjectId, query: query, intent: intent, isLoading: isLoading, cohort: cohort })=>({
        eventType: 'track',
        action: 'selected',
        actionSubject: 'advancedSearchLink',
        actionSubjectId: actionSubjectId,
        attributes: {
            ...attributes,
            wordCount: (0, $7kBI6.getWordCount)(query),
            ...intent !== undefined && {
                queryClassification: intent?.mode,
                modelId: intent?.modelId,
                patternType: intent?.patternType
            },
            ...isLoading !== undefined && {
                isLoading: isLoading
            },
            ...cohort !== undefined && {
                cohort: cohort
            }
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });
module.exports["getAdvancedSearchActionSubjectId"] = $684dfd7ed27180ad$export$a489a09e4aa74de0;
module.exports["onAdvancedSearchLinkSelected"] = $684dfd7ed27180ad$export$50f1b1860bee88e0;

});

parcelRegister("5Sv3D", function(module, exports) {
$parcel$export(module.exports, "default", () => $447a164f7d0faf6b$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $447a164f7d0faf6b$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $cozmU.useRef)(null);
    var maxWaitArgs = (0, $cozmU.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $cozmU.useRef)(false);
    var functionTimeoutHandler = (0, $cozmU.useRef)(null);
    var isComponentUnmounted = (0, $cozmU.useRef)(false);
    var debouncedFunction = (0, $cozmU.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $cozmU.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $cozmU.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $cozmU.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $cozmU.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("k7Gcl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");

var $kh0hi = parcelRequire("kh0hi");

var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");

const $667192135934f7b9$var$defaultFilterButtonStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.075',
    color: 'color.text.subtle',
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingInline: 'space.150',
    paddingBlock: 'space.050',
    minHeight: '32px',
    // As specified on Figma
    maxWidth: '165px',
    // As specified on Figma
    backgroundColor: 'color.background.neutral.subtle',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    whiteSpace: 'nowrap',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $667192135934f7b9$var$compactContentFitStyles = (0, $buxP3.xcss)({
    maxWidth: '113px' // As specified on Figma
});
const $667192135934f7b9$var$minWidthZeroStyles = (0, $buxP3.xcss)({
    minWidth: '0' // Allow the button to shrink as much as possible
});
const $667192135934f7b9$var$filterButtonSelectedStateStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.selected',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-selected, #1868DB)"}`,
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    }
});
const $667192135934f7b9$var$compactSpacingStyles = (0, $buxP3.xcss)({
    paddingInline: 'space.050'
});
const $667192135934f7b9$var$comfortableGapStyles = (0, $buxP3.xcss)({
    gap: 'space.100'
});
const $667192135934f7b9$var$filterButtonContentStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $667192135934f7b9$var$noBorderStyles = (0, $buxP3.xcss)({
    border: 0
});
const $667192135934f7b9$export$fb46dd9777cc6db0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(function FilterButton({ children: children, contentFit: contentFit = 'default', iconAfter: iconAfter, iconBefore: iconBefore, isSelected: isSelected, noBorder: noBorder, tooltip: tooltip, minWidthZero: minWidthZero = false, spacing: spacing = 'default', gap: gap = 'default', ...pressableProps }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltip ?? null,
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
            ...pressableProps,
            xcss: [
                $667192135934f7b9$var$defaultFilterButtonStyles,
                isSelected && $667192135934f7b9$var$filterButtonSelectedStateStyles,
                spacing === 'compact' && $667192135934f7b9$var$compactSpacingStyles,
                contentFit === 'compact' && $667192135934f7b9$var$compactContentFitStyles,
                gap === 'comfortable' && $667192135934f7b9$var$comfortableGapStyles,
                minWidthZero && $667192135934f7b9$var$minWidthZeroStyles,
                noBorder && $667192135934f7b9$var$noBorderStyles
            ],
            ref: ref
        }, iconBefore, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $667192135934f7b9$var$filterButtonContentStyles
        }, children), iconAfter)));
});
module.exports["FilterButton"] = $667192135934f7b9$export$fb46dd9777cc6db0;

});

parcelRegister("1F9mF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

const $7e34317440dbf9a2$var$filterButtonIconContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.075'
});
const $7e34317440dbf9a2$export$68a752ca64f3cf84 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $7e34317440dbf9a2$var$filterButtonIconContainerStyles
    }, children);
};
module.exports["FilterButtonIconContainer"] = $7e34317440dbf9a2$export$68a752ca64f3cf84;

});

parcelRegister("44yDZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aj8Vc = parcelRequire("aj8Vc");


var $3GNtk = parcelRequire("3GNtk");


var $68JhS = parcelRequire("68JhS");


var $iUD7b = parcelRequire("iUD7b");


var $59z6f = parcelRequire("59z6f");


var $hJSVF = parcelRequire("hJSVF");

const $debbf46baa096b18$export$4f9a317f0153844 = (option)=>{
    const arrayOfOptions = Array.isArray(option) ? option : [
        option
    ];
    return arrayOfOptions.every((popupOption)=>popupOption?.isSelected !== undefined && popupOption?.value !== undefined && popupOption?.trackingKey !== undefined && popupOption?.value !== undefined && popupOption?.queryParamValue !== undefined && popupOption?.isSuggested !== undefined && popupOption?.isDefault !== undefined && popupOption?.label !== undefined);
};


const $39b894e8b7ee9f23$export$381eb977a1d9bc81 = ({ defaultIsOpen: defaultIsOpen = false, isSearchable: isSearchable = false, isLoading: isLoading = false, canClearFilter: canClearFilter = false, checkboxIndicators: checkboxIndicators = false, formatOptionLabel: formatOptionLabel, placeholder: placeholder, searchInput: searchInput, onSearchInputChange: onSearchInputChange, onSelectChange: onSelectChange, onDropdownOpen: onDropdownOpen, onDropdownClose: onDropdownClose, options: options, label: label, noOptionsMessage: noOptionsMessage, onClearOptions: onClearOptions, minMenuWidth: minMenuWidth, target: target, filterId: filterId, filterOption: filterOptionOverride })=>{
    const debounceTimeout = (0, $cozmU.useRef)(null);
    // TODO: this can be removed if we have debounce in the store when lookup
    const [currentSearchInput, setCurrentSearchInput] = (0, $cozmU.useState)(searchInput);
    // For now, the FilterPopupSelect component is only being used in Quick Find so the following
    // analytics hooks are valid. Please extract out the analytics events when we reuse this
    // component in FPS.
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $68JhS.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $68JhS.useQuickFindAttributes)();
    const handleInputChange = (0, $cozmU.useCallback)((value, action)=>{
        if (action.action !== 'input-change') return;
        setCurrentSearchInput(value);
        if (!onSearchInputChange) return;
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(()=>{
            onSearchInputChange(value);
        }, 300);
    }, [
        onSearchInputChange
    ]);
    const handleChange = (0, $cozmU.useCallback)((value)=>{
        if (!(0, $debbf46baa096b18$export$4f9a317f0153844)(value)) throw new Error('Value should match the PopupSelectOption type');
        onSelectChange(value);
        // Omitting these attrtibutes as there is a race condition here since the filter attributes
        // have not yet been applied in the store so it will always be one update behind.
        const { productSelected: _productSelected, filters: _filters, filterSelections: _filterSelections, ...restAttributes } = commonAttributes;
        const selection = (Array.isArray(value) ? value : [
            value
        ])[0];
        if (!selection) return; // This should never be executed
        fireAnalyticsEvent((0, $iUD7b.onFilterSelection)({
            action: selection.isSelected ? 'unselected' : 'selected',
            location: 'inline',
            actionSubjectId: 'searchDialogFilter',
            attributes: {
                ...restAttributes,
                filterId: filterId
            }
        }));
    }, [
        commonAttributes,
        filterId,
        fireAnalyticsEvent,
        onSelectChange
    ]);
    // Disable react-select's default client-side filtering so server results (e.g. matched by
    // project key) are not incorrectly filtered out because their label doesn't match the input.
    // Consumers can override this by passing filterOption={null} to preserve client-side filtering
    const filterOption = filterOptionOverride !== undefined ? filterOptionOverride ?? undefined : isSearchable ? ()=>true : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3GNtk.PopupSelect), {
        blurInputOnSelect: false,
        canClearFilter: canClearFilter,
        closeMenuOnSelect: !checkboxIndicators,
        components: {
            Control: $59z6f.Control,
            MenuList: (0, $hJSVF.MenuListWithoutClearFilterOptionLabel),
            ...checkboxIndicators ? {
                Option: (0, $aj8Vc.CheckboxOption)
            } : {}
        },
        defaultIsOpen: defaultIsOpen,
        defaultOptions: false,
        formatOptionLabel: formatOptionLabel,
        inputValue: currentSearchInput,
        isClearable: false,
        isLoading: isLoading,
        isOptionSelected: (option)=>option.isSelected,
        isSearchable: isSearchable,
        label: label,
        maxMenuHeight: 400,
        maxMenuWidth: "22rem",
        menuPlacement: "bottom",
        minMenuWidth: minMenuWidth,
        noOptionsMessage: currentSearchInput ? undefined : ()=>noOptionsMessage,
        onChange: handleChange,
        onClearOptions: onClearOptions,
        onInputChange: handleInputChange,
        onMenuClose: ()=>{
            setCurrentSearchInput('');
            onDropdownClose?.();
        },
        onMenuOpen: onDropdownOpen,
        options: options,
        placeholder: placeholder,
        popperProps: {
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                },
                {
                    name: 'preventOverflow',
                    enabled: false
                }
            ]
        },
        searchThreshold: -1,
        shouldCloseMenuOnTab: false,
        target: target,
        filterOption: filterOption
    });
};
module.exports["FilterPopupSelect"] = $39b894e8b7ee9f23$export$381eb977a1d9bc81;

});

parcelRegister("aj8Vc", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $fekRe = parcelRequire("fekRe");

const $60c7d7f04a94467b$var$svgStyles = null;
const $60c7d7f04a94467b$var$CheckboxIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    let t0;
    if ($[0] !== primaryColor || $[1] !== secondaryColor) {
        t0 = {
            color: primaryColor,
            fill: secondaryColor
        };
        $[0] = primaryColor;
        $[1] = secondaryColor;
        $[2] = t0;
    } else t0 = $[2];
    const t1 = label ? label : undefined;
    const t2 = label ? "img" : "presentation";
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02oWWg _0jFU0VoWWg _1rdFvhlfZc _1pp6NdYbGa"
        ]);
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        });
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            viewBox: "0 0 24 24",
            style: t0,
            "aria-label": t1,
            role: t2,
            className: t3,
            children: t4
        });
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02oWWg _0jFU0VoWWg _1rdFvhlfZc _1pp6NdYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
const $60c7d7f04a94467b$export$d40cc97ecda916f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fekRe.ControlOption), {
            Icon: $60c7d7f04a94467b$var$CheckboxIcon,
            ...props
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fekRe.ControlOption), {
        Icon: $60c7d7f04a94467b$var$CheckboxIcon,
        ...props
    });
module.exports["CheckboxOption"] = $60c7d7f04a94467b$export$d40cc97ecda916f9;

});

parcelRegister("fekRe", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");

const $c75784b58b2be878$var$optionStyles = {
    default: "_3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _20VacPYbGa _2X4BecWrS5 _24h04i2Njc _0xmtko1Y8M _46hvQm1Y8M _0LQT5E5zaO _03SyCP8HPE _0KLXrujOvk _2OUyjtOLYo _1UtDYzOLYo _3gzVzLN4oS",
    focused: "_0KLXruo126 _2OUyjtP5Rf _2rG9p6TjXh",
    finesseFocused: "_2OUyjtYbGa _2rG9p6YbGa",
    disabled: "_1UtDYzot27",
    motion: "_23rrnHo10F _1B4rbIo10F _3sFUREDdj4"
};
const $c75784b58b2be878$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #0515240F)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
}; // the secondary color represents the radio dot or checkmark
const $c75784b58b2be878$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $c75784b58b2be878$var$iconStyles = {
    inherit: "_4na8rw98eZ _3tP2Tm98eZ",
    default: "_4na8rwWkXl _3tP2TmWkXl"
};
const $c75784b58b2be878$var$baseIconStyles = null;
const $c75784b58b2be878$var$baseOptionStyles = null;
const $c75784b58b2be878$export$e41f7c07e51665da = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(32);
    const [isActive, setIsActive] = (0, $cozmU.useState)(false);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>setIsActive(true);
        $[0] = t0;
    } else t0 = $[0];
    const onMouseDown = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setIsActive(false);
        $[1] = t1;
    } else t1 = $[1];
    const onMouseUp = t1;
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    let t2;
    if ($[2] !== className || $[3] !== cx || $[4] !== isDisabled || $[5] !== isFocused || $[6] !== isSelected) {
        t2 = cx({
            option: true,
            "option--is-disabled": isDisabled,
            "option--is-focused": isFocused,
            "option--is-selected": isSelected
        }, className);
        $[2] = className;
        $[3] = cx;
        $[4] = isDisabled;
        $[5] = isFocused;
        $[6] = isSelected;
        $[7] = t2;
    } else t2 = $[7];
    const classNames = t2;
    let t3;
    if ($[8] !== classNames || $[9] !== isDisabled || $[10] !== isFocused) {
        t3 = (0, $hekY6.default)([
            $c75784b58b2be878$var$optionStyles.default,
            !isDisabled && (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $c75784b58b2be878$var$optionStyles.motion,
            isFocused && $c75784b58b2be878$var$optionStyles.focused,
            isFocused && (0, $iDrrr.fg)("platform-dst-tokens-finesse") && $c75784b58b2be878$var$optionStyles.finesseFocused,
            isDisabled && $c75784b58b2be878$var$optionStyles.disabled,
            classNames
        ]);
        $[8] = classNames;
        $[9] = isDisabled;
        $[10] = isFocused;
        $[11] = t3;
    } else t3 = $[11];
    const t4 = isSelected || isActive || isDisabled ? $c75784b58b2be878$var$iconStyles.inherit : $c75784b58b2be878$var$iconStyles.default;
    let t5;
    if ($[12] !== t4) {
        t5 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC _03SyCP1Y8M _2Nkr8bLEV2 _4zMa6vLEV2 _0lzfxTNvrM _0AC44BNvrM",
            t4
        ]);
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== Icon || $[15] !== isActive || $[16] !== isDisabled || $[17] !== isFocused || $[18] !== isSelected) {
        t6 = !!Icon ? /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: "",
            primaryColor: $c75784b58b2be878$var$getPrimaryColor({
                isDisabled: isDisabled,
                isSelected: isSelected,
                isFocused: isFocused,
                isActive: isActive
            }),
            secondaryColor: $c75784b58b2be878$var$getSecondaryColor({
                isDisabled: isDisabled,
                isSelected: isSelected
            }),
            isFacadeDisabled: true
        }) : null;
        $[14] = Icon;
        $[15] = isActive;
        $[16] = isDisabled;
        $[17] = isFocused;
        $[18] = isSelected;
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== t5 || $[21] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t5,
            children: t6
        });
        $[20] = t5;
        $[21] = t6;
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $hekY6.default)([
            "_2O5Vij7dHp _4bt5LAnQyn _39HuIbz8Lp _1ANEUSLRg7"
        ]);
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== children) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t8,
            children: children
        });
        $[24] = children;
        $[25] = t9;
    } else t9 = $[25];
    let t10;
    if ($[26] !== innerProps || $[27] !== innerRef || $[28] !== t3 || $[29] !== t7 || $[30] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            className: t3,
            ref: innerRef,
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onMouseLeave: onMouseUp,
            ...innerProps,
            children: [
                t7,
                t9
            ]
        });
        $[26] = innerProps;
        $[27] = innerRef;
        $[28] = t3;
        $[29] = t7;
        $[30] = t9;
        $[31] = t10;
    } else t10 = $[31];
    return t10;
} : (props)=>{
    const [isActive, setIsActive] = (0, $cozmU.useState)(false);
    const onMouseDown = (0, $cozmU.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $cozmU.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $cozmU.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            $c75784b58b2be878$var$optionStyles.default,
            !isDisabled && (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $c75784b58b2be878$var$optionStyles.motion,
            isFocused && $c75784b58b2be878$var$optionStyles.focused,
            isFocused && (0, $iDrrr.fg)('platform-dst-tokens-finesse') && $c75784b58b2be878$var$optionStyles.finesseFocused,
            isDisabled && $c75784b58b2be878$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC _03SyCP1Y8M _2Nkr8bLEV2 _4zMa6vLEV2 _0lzfxTNvrM _0AC44BNvrM",
                    isSelected || isActive || isDisabled ? $c75784b58b2be878$var$iconStyles.inherit : $c75784b58b2be878$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                    label: "",
                    primaryColor: $c75784b58b2be878$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $c75784b58b2be878$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_2O5Vij7dHp _4bt5LAnQyn _39HuIbz8Lp _1ANEUSLRg7"
                ]),
                children: children
            })
        ]
    });
};
module.exports["ControlOption"] = $c75784b58b2be878$export$e41f7c07e51665da;

});

parcelRegister("dolMg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jLnA6 = parcelRequire("jLnA6");


var $7sJoX = parcelRequire("7sJoX");


var $8A5sV = parcelRequire("8A5sV");


var $60Yxm = parcelRequire("60Yxm");


var $4ysB6 = parcelRequire("4ysB6");


var $3Ydx7 = parcelRequire("3Ydx7");


var $dvVWp = parcelRequire("dvVWp");


var $2xMvQ = parcelRequire("2xMvQ");


var $k7Gcl = parcelRequire("k7Gcl");


var $1F9mF = parcelRequire("1F9mF");


var $44yDZ = parcelRequire("44yDZ");


var $2gvXK = parcelRequire("2gvXK");


var $4PFuU = parcelRequire("4PFuU");


var $32Eau = parcelRequire("32Eau");


var $1i979 = parcelRequire("1i979");


var $7IS25 = parcelRequire("7IS25");




const $c47f42800c7a0215$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    type: {
        id: "quick-find.filters.names.type",
        defaultMessage: "Type"
    },
    filterTypePlaceholder: {
        id: "quick-find.filter.type.placeholder",
        defaultMessage: "Find type"
    },
    filterLabelSelected: {
        id: "quick-find.filter.type.label.selected",
        defaultMessage: "Selected"
    },
    filterLabelUnselected: {
        id: "quick-find.filter.type.label.unselected",
        defaultMessage: "Available"
    }
});


const $0f58f67a3ce61bf1$var$getOptionsToProducts = (typeMapping)=>{
    const optionsToProducts = {};
    (0, $7IS25.getAllTypeFilterKeysForSearch)().forEach((type)=>{
        optionsToProducts[type] = typeMapping[type].products || [];
    });
    return optionsToProducts;
};
const $0f58f67a3ce61bf1$export$409b84e60ce4841e = ({ filterOptionsByPrimaryProduct: filterOptionsByPrimaryProduct = true, iconBefore: iconBefore, iconAfter: iconAfter, showPrimaryProductIcon: showPrimaryProductIcon, selectPrimaryProductOnChange: selectPrimaryProductOnChange = true })=>{
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const typeMapping = (0, $2gvXK.getTypeMapping)();
    const optionsToProducts = $0f58f67a3ce61bf1$var$getOptionsToProducts(typeMapping);
    const [productSelected] = (0, $1i979.useSelectedProduct)();
    const [filterData, { setOption: setOption, loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $4PFuU.useUniversalSelectFilter)({
        filterId: (0, $4ysB6.universalTypeFilterId),
        filterOptionsByPrimaryProduct: filterOptionsByPrimaryProduct,
        optionsToProducts: optionsToProducts,
        selectPrimaryProductOnChange: selectPrimaryProductOnChange
    });
    if (!filterData) return null;
    // Do not show TypeFilter for Atlas since that is handled by Noun filters
    if (productSelected === (0, $dvVWp.ProductKeys).Atlas) return null;
    const { options: options, lookupInput: lookupInput, selectedOptions: selectedOptions, isLoading: isLoading, isLookupDefined: isLookupDefined } = filterData;
    // Compute the label and badge values since useUniversalSelectFilter doesn't provide them
    const selectedOptionsCount = selectedOptions.length;
    const badgeLabel = selectedOptionsCount > 1 ? `+${selectedOptionsCount - 1}` : undefined;
    const firstSelectedOptionLabel = selectedOptions[0]?.label;
    const getIconBefore = ()=>{
        if (iconBefore) return iconBefore;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1F9mF.FilterButtonIconContainer), null, showPrimaryProductIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2xMvQ.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }), primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Loom ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
            label: formatMessage((0, $c47f42800c7a0215$export$a7357cdd1f0b0168).type)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8A5sV))), {
            label: formatMessage((0, $c47f42800c7a0215$export$a7357cdd1f0b0168).type)
        }));
    };
    const getIconAfter = ()=>{
        return selectedOptions.length === 0 ? iconAfter ? iconAfter : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            size: "small"
        }) : badgeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLnA6.default), {
            appearance: "information"
        }, badgeLabel);
    };
    const handleSetOption = (option)=>{
        setOption(option);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $44yDZ.FilterPopupSelect), {
        filterId: (0, $4ysB6.universalTypeFilterId),
        canClearFilter: true,
        checkboxIndicators: false,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: handleSetOption,
        options: options,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $c47f42800c7a0215$export$a7357cdd1f0b0168).type),
        placeholder: formatMessage((0, $c47f42800c7a0215$export$a7357cdd1f0b0168).filterTypePlaceholder),
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: clearOptions,
        target: ({ isOpen: isOpen, ...targetProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k7Gcl.FilterButton), {
                testId: "quick-find-universal-type-filter-button",
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter(),
                minWidthZero: true
            }, firstSelectedOptionLabel ? `${formatMessage((0, $c47f42800c7a0215$export$a7357cdd1f0b0168).type)}: ${firstSelectedOptionLabel}` : formatMessage((0, $c47f42800c7a0215$export$a7357cdd1f0b0168).type))
    });
};
module.exports["UniversalTypeFilter"] = $0f58f67a3ce61bf1$export$409b84e60ce4841e;

});

parcelRegister("2Icgs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0766cad763d3c100$export$5f44931f2e96c739 = ({ attributes: attributes })=>({
        eventType: 'track',
        action: 'decided',
        actionSubject: 'searchChatCounterfactualIntent',
        attributes: attributes
    });



var $68JhS = parcelRequire("68JhS");

const $c8184d9236a1ee23$export$2e2a72ec179a5445 = (intentDetection)=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $68JhS.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $68JhS.useQuickFindAttributes)();
    return (0, $cozmU.useCallback)(({ query: query })=>{
        if (!intentDetection) return;
        const { intent: intent, source: source } = intentDetection;
        const scorecardAttributes = {
            detectorSource: source,
            enginePrediction: intent?.type,
            modelId: intent?.modelVersion,
            patternType: intent?.pattern
        };
        fireAnalyticsEvent((0, $0766cad763d3c100$export$5f44931f2e96c739)({
            attributes: {
                ...commonAttributes,
                ...(0, $68JhS.getCommonQueryAttributes)(query),
                ...scorecardAttributes
            }
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        intentDetection
    ]);
};
module.exports["useCounterfactualIntentDecision"] = $c8184d9236a1ee23$export$2e2a72ec179a5445;

});

parcelRegister("l35DG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4jbt4 = parcelRequire("4jbt4");


var $e0v3Z = parcelRequire("e0v3Z");


var $jTbFT = parcelRequire("jTbFT");


var $hnyex = parcelRequire("hnyex");


var $535ZC = parcelRequire("535ZC");


var $7kBI6 = parcelRequire("7kBI6");


var $32Eau = parcelRequire("32Eau");


var $68JhS = parcelRequire("68JhS");


var $gj3Ne = parcelRequire("gj3Ne");

const $5c7b8c0e94122846$export$8edca358485a7f22 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $68JhS.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $68JhS.useQuickFindAttributes)();
    const intl = (0, $kSwu1.useIntl)();
    const taskStateRef = (0, $gj3Ne.useIntentDetectionVitalStatsTaskState)();
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const intentDetectionExperiment = (0, $535ZC.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        locale: intl.locale
    });
    const isEnabled = intentDetectionExperiment?.cohort === 'test';
    const cohort = intentDetectionExperiment?.cohort;
    const startTask = (0, $cozmU.useCallback)((query)=>{
        if (!isEnabled) return;
        const taskId = crypto.randomUUID();
        const searchSessionId = commonAttributes.searchSessionId || '';
        const queryHash = (0, $e0v3Z.sha256Hash)(query);
        const queryLength = query.length;
        const wordCount = (0, $7kBI6.getWordCount)(query);
        // Set the shared context state
        if (taskStateRef.current) {
            taskStateRef.current.id = taskId;
            taskStateRef.current.state = 'started';
            taskStateRef.current.queryHash = queryHash;
            taskStateRef.current.queryLength = queryLength;
            taskStateRef.current.wordCount = wordCount;
        }
        fireAnalyticsEvent((0, $4jbt4.remapVitalStatsEventForQuickFind)((0, $hnyex.onTaskStart)({
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_UX,
            moreContext: {
                queryHash: queryHash,
                queryLength: queryLength,
                wordCount: wordCount,
                cohort: cohort
            }
        })));
    }, [
        isEnabled,
        cohort,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const completeTaskSuccess = (0, $cozmU.useCallback)(()=>{
        // Check if task is active using the shared context state
        if (!isEnabled || taskStateRef.current?.state !== 'started') return;
        const { id: taskId, queryHash: queryHash, queryLength: queryLength, wordCount: wordCount } = taskStateRef.current;
        const searchSessionId = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when state is 'started'
        if (!taskId) return;
        fireAnalyticsEvent((0, $4jbt4.remapVitalStatsEventForQuickFind)((0, $hnyex.onTaskSuccess)({
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_UX,
            moreContext: {
                queryHash: queryHash,
                queryLength: queryLength,
                wordCount: wordCount,
                cohort: cohort
            }
        })));
        // Mark task as completed
        taskStateRef.current.state = 'completed';
    }, [
        isEnabled,
        cohort,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const completeTaskFail = (0, $cozmU.useCallback)((error)=>{
        // Check if task is active using the shared context state
        if (!isEnabled || taskStateRef.current?.state !== 'started') return;
        const { id: taskId, queryHash: queryHash, queryLength: queryLength, wordCount: wordCount } = taskStateRef.current;
        const searchSessionId = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when state is 'started'
        if (!taskId) return;
        fireAnalyticsEvent((0, $4jbt4.remapVitalStatsEventForQuickFind)((0, $hnyex.onTaskFail)({
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_UX,
            moreContext: {
                queryHash: queryHash,
                queryLength: queryLength,
                wordCount: wordCount,
                cohort: cohort,
                errorName: error?.name || 'UnknownError',
                errorMessage: error?.message || 'An unknown error occurred'
            }
        })));
        // Mark task as failed
        taskStateRef.current.state = 'failed';
    }, [
        isEnabled,
        cohort,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const abortTask = (0, $cozmU.useCallback)((abortReason)=>{
        // Check if task is active using the shared context state
        if (!isEnabled || taskStateRef.current?.state !== 'started') return;
        const { id: taskId, queryHash: queryHash, queryLength: queryLength, wordCount: wordCount } = taskStateRef.current;
        const searchSessionId = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when state is 'started'
        if (!taskId) return;
        // Mark task as aborted FIRST (synchronously) to prevent race conditions
        taskStateRef.current.state = 'aborted';
        // Then defer the analytics event to not block rendering
        (0, $cozmU.startTransition)(()=>{
            fireAnalyticsEvent((0, $4jbt4.remapVitalStatsEventForQuickFind)((0, $hnyex.onTaskAbort)({
                searchSessionId: searchSessionId,
                taskId: taskId,
                task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_UX,
                moreContext: {
                    abortReason: abortReason,
                    queryHash: queryHash,
                    queryLength: queryLength,
                    wordCount: wordCount,
                    cohort: cohort
                }
            })));
        });
    }, [
        isEnabled,
        cohort,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const isTaskActive = (0, $cozmU.useCallback)(()=>{
        return taskStateRef.current?.state === 'started';
    }, [
        taskStateRef
    ]);
    return {
        startTask: startTask,
        completeTaskSuccess: completeTaskSuccess,
        completeTaskFail: completeTaskFail,
        abortTask: abortTask,
        isTaskActive: isTaskActive
    };
};
module.exports["useIntentDetectionVitalStats"] = $5c7b8c0e94122846$export$8edca358485a7f22;

});

parcelRegister("7dKcF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1qIUZ = parcelRequire("1qIUZ");


var $jTbFT = parcelRequire("jTbFT");


var $hnyex = parcelRequire("hnyex");


var $9gI1G = parcelRequire("9gI1G");


var $dsOco = parcelRequire("dsOco");


var $32Eau = parcelRequire("32Eau");


var $68JhS = parcelRequire("68JhS");


var $1OGSC = parcelRequire("1OGSC");

const $10cf3765431946ce$export$5b6291bff520e069 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dsOco.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $68JhS.useQuickFindAttributes)();
    const taskStateRef = (0, $1OGSC.useVitalStatsTaskState)();
    const userId = (0, $32Eau.useCurrentUserId)();
    const startTask = (0, $cozmU.useCallback)(()=>{
        const taskId = crypto.randomUUID();
        const searchSessionId = commonAttributes.searchSessionId || '';
        // Set the shared context state
        if (taskStateRef.current) {
            taskStateRef.current.id = taskId;
            taskStateRef.current.started = true;
            taskStateRef.current.completed = false;
        }
        fireAnalyticsEvent((0, $hnyex.onTaskStart)({
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_POST_QUERY_UX
        }));
    }, [
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const completeTaskSuccess = (0, $cozmU.useCallback)(()=>{
        // Check if task is active using the shared context state
        if (!taskStateRef.current?.started || taskStateRef.current?.completed) return;
        const { id: taskId } = taskStateRef.current;
        const searchSessionId = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when started is true
        if (!taskId) return;
        // Additive `ml_lens` envelope so the ML Lens transformer can split this
        // taskSuccess into per-connector `results_per_connector` metrics.
        // On `POSTQUERY_NO_RESULTS` `getProductResultCounts` returns `{}` and the
        // envelope is emitted with `metrics: []`. The builder returns `null` when
        // there is no `userId`, so the tag is omitted entirely in that case.
        const mlLensEnvelope = (0, $1qIUZ.buildPostQueryMlLensEnvelope)((0, $9gI1G.getProductResultCounts)(), userId);
        const moreContext = mlLensEnvelope ? {
            ml_lens: mlLensEnvelope
        } : undefined;
        fireAnalyticsEvent((0, $hnyex.onTaskSuccess)({
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
            moreContext: moreContext
        }));
        // Mark task as completed
        if (taskStateRef.current) taskStateRef.current.completed = true;
    }, [
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef,
        userId
    ]);
    const completeTaskFail = (0, $cozmU.useCallback)((error)=>{
        // Check if task is active using the shared context state
        if (!taskStateRef.current?.started || taskStateRef.current?.completed) return;
        const { id: taskId } = taskStateRef.current;
        const searchSessionId = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when started is true
        if (!taskId) return;
        fireAnalyticsEvent((0, $hnyex.onTaskFail)({
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
            moreContext: {
                errorName: error?.name,
                errorMessage: error?.message
            }
        }));
        // Mark task as completed
        taskStateRef.current.completed = true;
    }, [
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const abortTask = (0, $cozmU.useCallback)((abortReason)=>{
        // Check if task is active using the shared context state
        if (!taskStateRef.current?.started || taskStateRef.current?.completed) return;
        const { id: taskId } = taskStateRef.current;
        const searchSessionId = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when started is true
        if (!taskId) return;
        // Mark task as completed FIRST (synchronously) to prevent race conditions
        taskStateRef.current.completed = true;
        // Then defer the analytics event to not block rendering
        (0, $cozmU.startTransition)(()=>{
            fireAnalyticsEvent((0, $hnyex.onTaskAbort)({
                searchSessionId: searchSessionId,
                taskId: taskId,
                task: (0, $jTbFT.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                moreContext: {
                    abortReason: abortReason
                }
            }));
        });
    }, [
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const isTaskActive = (0, $cozmU.useCallback)(()=>{
        // Check if task has started but not yet completed
        return taskStateRef.current?.started && !taskStateRef.current?.completed;
    }, [
        taskStateRef
    ]);
    return {
        startTask: startTask,
        completeTaskSuccess: completeTaskSuccess,
        completeTaskFail: completeTaskFail,
        abortTask: abortTask,
        isTaskActive: isTaskActive
    };
};
module.exports["useQuickFindPostQueryVitalStats"] = $10cf3765431946ce$export$5b6291bff520e069;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    return (0, $hMCZS.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("gTPfK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $6057e25d3e7f93e3$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
            const $ = (0, $bDgLe.c)(11);
            let analyticsContext;
            let rest;
            if ($[0] !== t0) {
                ({ analyticsContext: analyticsContext, ...rest } = t0);
                $[0] = t0;
                $[1] = analyticsContext;
                $[2] = rest;
            } else {
                analyticsContext = $[1];
                rest = $[2];
            }
            let t1;
            if ($[3] !== analyticsContext) {
                t1 = {
                    ...defaultData,
                    ...analyticsContext
                };
                $[3] = analyticsContext;
                $[4] = t1;
            } else t1 = $[4];
            const analyticsData = t1;
            const t2 = rest;
            let t3;
            if ($[5] !== ref || $[6] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                    ...t2,
                    ref: ref
                });
                $[5] = ref;
                $[6] = t2;
                $[7] = t3;
            } else t3 = $[7];
            let t4;
            if ($[8] !== analyticsData || $[9] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                    data: analyticsData
                }, t3);
                $[8] = analyticsData;
                $[9] = t3;
                $[10] = t4;
            } else t4 = $[10];
            return t4;
        } : ({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $cozmU.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...rest,
                ref: ref
            }));
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $6057e25d3e7f93e3$export$2e2bcd8739ae039 = $6057e25d3e7f93e3$var$withAnalyticsContext;
module.exports["default"] = $6057e25d3e7f93e3$export$2e2bcd8739ae039;

});

parcelRegister("5k2zo", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $ad20b5467f7f9ada$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>
</svg>
`;
const $ad20b5467f7f9ada$export$9eb74917ea768ed4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GoalsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Goals" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $ad20b5467f7f9ada$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function GoalsIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $ad20b5467f7f9ada$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["GoalsIcon"] = $ad20b5467f7f9ada$export$9eb74917ea768ed4;

});

parcelRegister("7pJjg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $4hmAW = parcelRequire("4hmAW");

const $5d24b7fd99811061$var$PageLiveDocObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageLiveDocObject({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
};
var $5d24b7fd99811061$export$2e2bcd8739ae039 = $5d24b7fd99811061$var$PageLiveDocObject;
module.exports["default"] = $5d24b7fd99811061$export$2e2bcd8739ae039;

});

parcelRegister("kLlYX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80e1615540ac9d82a9937150e7cfa4ab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d93fa86ac2ebd2$var$_react = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f1d93fa86ac2ebd2$var$_iconNew = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f1d93fa86ac2ebd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/page-live-doc
 * Usage guidance:
 * Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1d93fa86ac2ebd2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $f1d93fa86ac2ebd2$var$_react.default.createElement($f1d93fa86ac2ebd2$var$_iconNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$f1d93fa86ac2ebd2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $f1d93fa86ac2ebd2$var$_default = module.exports.default = $f1d93fa86ac2ebd2$var$PageLiveDocIcon;

});

parcelRegister("jAKKt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krxYo = parcelRequire("krxYo");


var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $2a08l = parcelRequire("2a08l");


var $frXak = parcelRequire("frXak");

const $349db1466702a732$export$fbd198cf40195606 = {
    displayName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $frXak.messages)['atlassian-web-crawler']),
    id: 'atlassian-web-crawler',
    resourceType: (0, $fR63l.ProductResourceTypes3P).AtlassianWebCrawler,
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, (/*@__PURE__*/$parcel$interopDefault($krxYo))), 'Atlassian Web Crawler'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $2a08l.WebDomainSearchResultIcon), 'Atlassian Web Crawler', 'large'),
    integrationAri: 'ari:cloud:platform::integration/atlassian-web-crawler',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: false,
    isEnabled: ()=>true,
    fanOutConnectorSources: true,
    displayWorkspaceNameAsProductName: true,
    getFiltersForSelectedDatasources: (datasource, existingFilters)=>({
            ...existingFilters,
            additionalTexts: [
                ...existingFilters?.additionalTexts || [],
                ...datasource?.workspaceUrl ? [
                    datasource.workspaceUrl
                ] : []
            ]
        })
};
module.exports["atlassianWebCrawlerConfig"] = $349db1466702a732$export$fbd198cf40195606;

});

parcelRegister("dAioJ", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $ac1d391d64bfedde$export$d520529b4595d46c = [
    'ati:cloud:graph:document'
];
module.exports["DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI"] = $ac1d391d64bfedde$export$d520529b4595d46c;

});

parcelRegister("5PPrc", function(module, exports) {
const $b36df32f21d2d1ae$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    DevopsWorkItem: 'devops-work-item',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Slide: 'slide',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask',
    Project: 'project',
    Incident: 'incident',
    Filter: 'filter',
    Plan: 'plan',
    Board: 'board',
    Component: 'component',
    Card: 'card',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item',
    FocusArea: 'focus-area',
    Organization: 'organization',
    Ask: 'ask',
    Risk: 'risk',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal',
    Gliffy: 'gliffy',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Type: 'type',
    Schema: 'schema',
    Position: 'position',
    Image: 'image',
    Audio: 'audio',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Code: 'code',
    Archive: 'archive',
    Other: 'other',
    Notebook: 'notebook',
    Form: 'form',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Campaign: 'campaign',
    Case: 'case',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article',
    NewsArticle: 'news-article',
    Lead: 'lead'
};
const $b36df32f21d2d1ae$export$e01073b80ff953d5 = Object.values($b36df32f21d2d1ae$export$49f6cbb853d30562);
const $b36df32f21d2d1ae$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Article: 'article',
    Post: 'post',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Design: 'design',
    Deal: 'deal',
    Video: 'video',
    Task: 'task',
    Issue: 'issue',
    Space: 'space',
    Project: 'project',
    Repository: 'repository',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Image: 'image',
    Archive: 'archive',
    Audio: 'audio',
    Code: 'code',
    Pdf: 'pdf',
    Other: 'other',
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type',
    Folder: 'folder',
    Notebook: 'notebook',
    Form: 'form',
    Shortcut: 'shortcut',
    Site: 'site',
    Subsite: 'subsite',
    Drive: 'drive',
    Comment: 'comment',
    Incident: 'incident',
    CatalogItem: 'catalog_item',
    RequestedItem: 'requested_item',
    KnowledgeArticle: 'knowledge_article',
    Demand: 'demand',
    NewsArticle: 'news_article',
    Epic: 'epic'
};
/**
 * Maps CloudGraph ATI to TypeFilterValueKey
 */ const $b36df32f21d2d1ae$var$ATI_TO_TYPE_FILTER_KEY_MAP = {
    'ati:cloud:graph:document': $b36df32f21d2d1ae$export$49f6cbb853d30562.Document,
    'ati:cloud:graph:message': $b36df32f21d2d1ae$export$49f6cbb853d30562.Message,
    'ati:cloud:graph:conversation': $b36df32f21d2d1ae$export$49f6cbb853d30562.Conversation,
    'ati:cloud:graph:design': $b36df32f21d2d1ae$export$49f6cbb853d30562.Design,
    'ati:cloud:graph:video': $b36df32f21d2d1ae$export$49f6cbb853d30562.Video,
    'ati:cloud:graph:space': $b36df32f21d2d1ae$export$49f6cbb853d30562.Space,
    'ati:cloud:graph:comment': $b36df32f21d2d1ae$export$49f6cbb853d30562.Comment,
    'ati:cloud:graph:repository': $b36df32f21d2d1ae$export$49f6cbb853d30562.Repository,
    'ati:cloud:graph:pull-request': $b36df32f21d2d1ae$export$49f6cbb853d30562.PullRequest,
    'ati:cloud:graph:commit': $b36df32f21d2d1ae$export$49f6cbb853d30562.Commit,
    'ati:cloud:graph:branch': $b36df32f21d2d1ae$export$49f6cbb853d30562.Branch,
    'ati:cloud:graph:calendar-event': $b36df32f21d2d1ae$export$49f6cbb853d30562.Calendar,
    'ati:cloud:graph:work-item': $b36df32f21d2d1ae$export$49f6cbb853d30562.WorkItem,
    'ati:cloud:graph:project': $b36df32f21d2d1ae$export$49f6cbb853d30562.Project,
    'ati:cloud:graph:deal': $b36df32f21d2d1ae$export$49f6cbb853d30562.Deal,
    'ati:cloud:graph:customer-org': $b36df32f21d2d1ae$export$49f6cbb853d30562.CustomerOrg,
    'ati:cloud:graph:customer-contact': $b36df32f21d2d1ae$export$49f6cbb853d30562.CustomerContact,
    'ati:cloud:graph:dashboard': $b36df32f21d2d1ae$export$49f6cbb853d30562.Dashboard,
    'ati:cloud:graph:data-table': $b36df32f21d2d1ae$export$49f6cbb853d30562.DataTable,
    'ati:cloud:graph:campaign': $b36df32f21d2d1ae$export$49f6cbb853d30562.Campaign,
    'ati:cloud:graph:case': $b36df32f21d2d1ae$export$49f6cbb853d30562.Case,
    'ati:cloud:graph:lead': $b36df32f21d2d1ae$export$49f6cbb853d30562.Lead
};
/**
 * Checks if an ATI string is a CloudGraph ATI
 */ const $b36df32f21d2d1ae$var$isCloudGraphAti = (ati)=>{
    return ati.startsWith('ati:cloud:graph:');
};
function $b36df32f21d2d1ae$export$770175465f396551(atis) {
    const typeFilterConfig = new Map();
    // Group ATIs by their corresponding TypeFilterValueKey
    const atisByTypeKey = new Map();
    for (const ati of atis)if ($b36df32f21d2d1ae$var$isCloudGraphAti(ati)) {
        const typeKey = $b36df32f21d2d1ae$var$ATI_TO_TYPE_FILTER_KEY_MAP[ati];
        if (typeKey) {
            if (!atisByTypeKey.has(typeKey)) atisByTypeKey.set(typeKey, []);
            atisByTypeKey.get(typeKey).push(ati);
        }
    }
    // Convert to TypeFilterConfig3P format
    for (const [typeKey, entityAtis] of atisByTypeKey)typeFilterConfig.set(typeKey, {
        entities3P: entityAtis,
        subTypes3P: [] // Most configs use empty subTypes3P, can be extended if needed
    });
    return typeFilterConfig;
}
module.exports["TypeFilterValueKey"] = $b36df32f21d2d1ae$export$49f6cbb853d30562;
module.exports["allTypeFilterValueKeys"] = $b36df32f21d2d1ae$export$e01073b80ff953d5;
module.exports["NounSubtypeKey"] = $b36df32f21d2d1ae$export$1f2db89e0caa00c9;
module.exports["mapAtisToTypeFilterConfig"] = $b36df32f21d2d1ae$export$770175465f396551;

});

parcelRegister("i52Hf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");




var $6suVE = parcelRequire("6suVE");


var $ehKBQ = parcelRequire("ehKBQ");


var $iS3Tu = parcelRequire("iS3Tu");


var $dULnI = parcelRequire("dULnI");


var $2sFbd = parcelRequire("2sFbd");



var $9Jc29 = parcelRequire("9Jc29");





var $Douji = parcelRequire("Douji");


var $iPmoS = parcelRequire("iPmoS");

// Legacy custom @atlaskit/icon glyphs render one size smaller than requested, so this container
// is bumped up a step to compensate (see `correctedSize` below).
const $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    medium: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    large: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    xlarge: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
// The official brand icon library (behind rovo-search-team-eu-26-brand-icon-library) renders
// through ADS Tile, whose size scale already matches the Logo scale 1:1 — no compensation needed.
const $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    small: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    medium: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    large: "_39xV02UF4f _0jFU0VUF4f _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
const $8a7a1ec4b7d3b7f4$var$SVGIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { glyph: SVG, label: label, legacySize: legacySize, accurateSize: accurateSize } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("rovo-search-team-eu-26-brand-icon-library");
        $[0] = t1;
    } else t1 = $[0];
    const isAccurateSizeEnabled = t1;
    const t2 = isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles[accurateSize] : $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles[legacySize];
    const t3 = label || undefined;
    const t4 = label ? "img" : "presentation";
    let t5;
    if ($[1] !== SVG || $[2] !== accurateSize) {
        t5 = isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, {
            size: accurateSize
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null);
        $[1] = SVG;
        $[2] = accurateSize;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t2,
            "aria-label": t3,
            role: t4
        }, t5);
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
} : ({ glyph: SVG, label: label, legacySize: legacySize, accurateSize: accurateSize })=>{
    const isAccurateSizeEnabled = (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles[accurateSize] : $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles[legacySize],
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, {
        size: accurateSize
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null));
};
const $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize = (size)=>{
    return [
        'xxsmall',
        'xsmall',
        'small',
        'medium',
        'large'
    ].includes(size);
};
const $8a7a1ec4b7d3b7f4$var$correctedSize = {
    xxsmall: 'small',
    xsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};
const $8a7a1ec4b7d3b7f4$var$sizeStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F",
    medium: "_39xV02oWWg _0jFU0VoWWg",
    large: "_39xV02Uofl _0jFU0VUofl",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
}; // The official brand icon library (behind rovo-search-team-eu-26-brand-icon-library) renders
// through ADS Tile, whose size scale already matches the Logo scale 1:1 — unlike the legacy
// custom @atlaskit/icon glyphs above, it needs no "one size bigger" compensation.
const $8a7a1ec4b7d3b7f4$var$accurateSizeStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f"
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with custom Rovo Icons
    *
    * Internally uses <Icon glyph={glyph} ... />
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$7b66a86355afbb91 = (Glyph, defaultLabel = '', defaultSize = 'medium')=>{
    return ({ size: size = defaultSize, label: label = defaultLabel, testId: testId })=>{
        const resolvedSize = size && $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize(size) ? size : defaultSize;
        const isAccurateSizeEnabled = (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-label": label || undefined,
            "data-testid": testId,
            role: label ? 'img' : 'presentation',
            className: (0, $hekY6.default)([
                isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSizeStyles[resolvedSize] : $8a7a1ec4b7d3b7f4$var$sizeStyles[$8a7a1ec4b7d3b7f4$var$correctedSize[resolvedSize]]
            ])
        }, isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, {
            size: resolvedSize
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, null));
    };
}; /**
    * A wrapper for rendering 3P svg illustrations in a similar way for atlaskit icon components
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d = (glyph, defaultLabel = '', defaultSize)=>{
    return ({ label: label = defaultLabel, size: size = defaultSize })=>{
        const resolvedSize = size && $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize(size) ? size : defaultSize ?? 'medium';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a7a1ec4b7d3b7f4$var$SVGIcon, {
            label: label,
            glyph: glyph,
            legacySize: $8a7a1ec4b7d3b7f4$var$correctedSize[resolvedSize],
            accurateSize: resolvedSize
        });
    };
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with \@atlaskit/logo
    *
    * Internally uses <LogoComponent ... />
    *
    * @param {} LogoComponent an import from \@atlaskit/logo
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand"
        });
    };
}; /**
    * Takes a logo component and returns a new logo component that uses the new logo design.
    */ 
function $8a7a1ec4b7d3b7f4$export$a34cd1871c6541c9(Icon) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, props);
}
function $8a7a1ec4b7d3b7f4$export$fab9faef3411dc6c(iconGlyph, iconLabel, size) {
    return $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d(iconGlyph, iconLabel, size);
}
const $8a7a1ec4b7d3b7f4$var$imageStyles = null; /**
                           * Helper function to convert an image URL into a glyph function
                           *
                           * @param imageUrl URL string pointing to the image
                           * @returns A glyph function that returns an img element
                           */ 
const $8a7a1ec4b7d3b7f4$export$f9f7178f66750cba = (imageUrl)=>{
    return ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: imageUrl,
            alt: "",
            className: (0, $hekY6.default)([
                "_39xV02N91d _0jFU0VN91d _00EA0egIor"
            ])
        });
    };
}; /**
    * Creates a RovoLogo from a URL. Useful for Forge connectors that provide icon URLs.
    * Uses the existing RovoLogoFromSVG infrastructure for consistent handling.
    */ 
function $8a7a1ec4b7d3b7f4$export$97ac28be52c9e29f(iconUrl, iconLabel, size) {
    return $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d($8a7a1ec4b7d3b7f4$export$f9f7178f66750cba(iconUrl), iconLabel, size);
} // Jira-specific icons
module.exports["RovoLogoFromGlyph"] = $8a7a1ec4b7d3b7f4$export$7b66a86355afbb91;
module.exports["RovoLogoFromSVG"] = $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d;
module.exports["RovoLogoFromLogo"] = $8a7a1ec4b7d3b7f4$export$32db889b380fa03c;
module.exports["get3PLogo"] = $8a7a1ec4b7d3b7f4$export$fab9faef3411dc6c;
module.exports["get3PLogoFromURL"] = $8a7a1ec4b7d3b7f4$export$97ac28be52c9e29f;

});

parcelRegister("6suVE", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $db93e344a28daeff$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4hzFj")).then((m)=>m.GitHubIcon), {
    moduleId: '@atlassian/logo-third-party/github'
});

const $db93e344a28daeff$var$LazyGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3w7xz")).then((m)=>m.GithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/icon'
});

const $db93e344a28daeff$var$LazyGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3w7xz")).then((m)=>m.GithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/search-result-icon'
});
const $db93e344a28daeff$export$e8e65f186ccd8749 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubIconComponent, null)), $db93e344a28daeff$var$OfficialIcon, 'small');
const $db93e344a28daeff$export$fa0f141eb732d2d7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubSearchResultIconComponent, null)), $db93e344a28daeff$var$OfficialIcon, 'medium');
module.exports["GithubIcon"] = $db93e344a28daeff$export$e8e65f186ccd8749;
module.exports["GithubSearchResultIcon"] = $db93e344a28daeff$export$fa0f141eb732d2d7;

});

parcelRegister("5mh7K", function(module, exports) {

var $6zMm4 = parcelRequire("6zMm4");


var $3zIme = parcelRequire("3zIme");


var $jrpaf = parcelRequire("jrpaf");


var $iqYgx = parcelRequire("iqYgx");


var $3Zhtx = parcelRequire("3Zhtx");

var $dZb8A = parcelRequire("dZb8A");


var $9W961 = parcelRequire("9W961");


var $f1SiZ = parcelRequire("f1SiZ");


var $6DjRB = parcelRequire("6DjRB");


var $ah4XH = parcelRequire("ah4XH");


var $cU4Ow = parcelRequire("cU4Ow");


var $31PDK = parcelRequire("31PDK");


function $bfc96ad9243c26fc$var$noop() {}
function $bfc96ad9243c26fc$var$deferToPhase(phase) {
    switch(phase){
        case (0, $iqYgx.PHASE).PAINT:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'user-blocking'
            });
        case (0, $iqYgx.PHASE).AFTER_PAINT:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'user-visible'
            });
        case (0, $iqYgx.PHASE).LAZY:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'background'
            });
        default:
            return Promise.resolve();
    }
}
function $bfc96ad9243c26fc$var$lazyProxy(loader, { defer: defer = (0, $iqYgx.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $3Zhtx.isNodeEnvironment)();
    const dataLazyId = (0, $dZb8A.default)(moduleId);
    // eslint-disable-next-line @typescript-eslint/no-restricted-types
    const LazyInternal = isServer ? (0, $f1SiZ.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $9W961.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $ah4XH.createDeferred)(dataLazyId, {
            loader: ()=>{
                const { retry: maxAttempts, usePostTaskPhases: usePostTaskPhases } = (0, $jrpaf.getConfig)();
                const deferredLoader = usePostTaskPhases ? ()=>$bfc96ad9243c26fc$var$deferToPhase(defer).then(()=>loader()) : loader;
                return (0, $31PDK.retry)(deferredLoader, {
                    delay: (0, $6DjRB.RETRY_DELAY),
                    factor: (0, $6DjRB.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $3Zhtx.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $jrpaf.getConfig)();
        return (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority ?? (defer === (0, $iqYgx.PHASE).PAINT ? (0, $6DjRB.PRIORITY).HIGH : (0, $6DjRB.PRIORITY).LOW);
        return (0, $cU4Ow.preloadAsset)({
            loader: loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        moduleId: moduleId,
        preload: preload
    });
}
const $bfc96ad9243c26fc$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $iqYgx.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $iqYgx.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $iqYgx.PHASE).LAZY
    }
};
function $bfc96ad9243c26fc$export$c952e5f94576010e(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazyForPaint,
        ...opts || {}
    });
}
function $bfc96ad9243c26fc$export$291dd592399bdafa(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazyAfterPaint,
        ...opts || {}
    });
}
function $bfc96ad9243c26fc$export$488013bae63b21da(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazy,
        ...opts || {}
    });
}
module.exports["lazyForPaint"] = $bfc96ad9243c26fc$export$c952e5f94576010e;
module.exports["lazy"] = $bfc96ad9243c26fc$export$488013bae63b21da;

});

parcelRegister("3zIme", function(module, exports) {
const $26c544e248d4f3ef$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $26c544e248d4f3ef$export$303f43e55cf1ef2f;

});

parcelRegister("jrpaf", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("hwBK6")).MODE);

var $hwBK6 = parcelRequire("hwBK6");

const $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN = undefined;
const $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $8f2b5a3b1d08430b$var$DEFAULT_MODE = (0, $hwBK6.MODE).HYDRATE;
const $8f2b5a3b1d08430b$var$DEFAULT_RETRY = 2;
const $8f2b5a3b1d08430b$var$nullFunction = ()=>{};
const $8f2b5a3b1d08430b$var$config = {
    crossOrigin: $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN,
    manifest: $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST,
    mode: $8f2b5a3b1d08430b$var$DEFAULT_MODE,
    retry: $8f2b5a3b1d08430b$var$DEFAULT_RETRY,
    react18: false,
    onChunkRender: $8f2b5a3b1d08430b$var$nullFunction,
    usePostTaskPhases: false,
    modernErrorFallback: false,
    markedForPreload: [],
    environment: undefined
};
const $8f2b5a3b1d08430b$export$44487a86467333c3 = ()=>$8f2b5a3b1d08430b$var$config;
const $8f2b5a3b1d08430b$export$940a7873bb071df8 = (nextConfig)=>{
    $8f2b5a3b1d08430b$var$config.crossOrigin = nextConfig.crossOrigin ?? $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN;
    $8f2b5a3b1d08430b$var$config.manifest = nextConfig.manifest ?? $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST;
    $8f2b5a3b1d08430b$var$config.mode = nextConfig.mode ?? $8f2b5a3b1d08430b$var$DEFAULT_MODE;
    $8f2b5a3b1d08430b$var$config.retry = nextConfig.retry ?? $8f2b5a3b1d08430b$var$DEFAULT_RETRY;
    $8f2b5a3b1d08430b$var$config.react18 = nextConfig.react18 ?? false;
    $8f2b5a3b1d08430b$var$config.onChunkRender = nextConfig.onChunkRender ?? $8f2b5a3b1d08430b$var$nullFunction;
    $8f2b5a3b1d08430b$var$config.usePostTaskPhases = nextConfig.usePostTaskPhases ?? false;
    $8f2b5a3b1d08430b$var$config.modernErrorFallback = nextConfig.modernErrorFallback ?? false;
    $8f2b5a3b1d08430b$var$config.markedForPreload = nextConfig.markedForPreload ?? undefined;
    $8f2b5a3b1d08430b$var$config.environment = nextConfig.environment ?? undefined;
};
module.exports["getConfig"] = $8f2b5a3b1d08430b$export$44487a86467333c3;

});

parcelRegister("hwBK6", function(module, exports) {
const $b5e78af7707a7c4f$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $b5e78af7707a7c4f$export$e48589d9e4824227;

});

parcelRegister("iqYgx", function(module, exports) {
const $affaceaac00ccc54$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $affaceaac00ccc54$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $affaceaac00ccc54$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $affaceaac00ccc54$export$4831ef3968ea94ef;

});

parcelRegister("3Zhtx", function(module, exports) {

var $dZb8A = parcelRequire("dZb8A");

const $a3803c67f4544810$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $a3803c67f4544810$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $a3803c67f4544810$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $a3803c67f4544810$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $a3803c67f4544810$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $a3803c67f4544810$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $a3803c67f4544810$export$283635c04a02cc36;
module.exports["attrToProp"] = $a3803c67f4544810$export$62bf630d0de3d781;

});

parcelRegister("dZb8A", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a2d13c19047c2e6$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $2a2d13c19047c2e6$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-ignore TS7029 fallthrough
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-ignore TS7029 fallthrough
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("9W961", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");


var $iqYgx = parcelRequire("iqYgx");


var $6pwcu = parcelRequire("6pwcu");


var $hGTvt = parcelRequire("hGTvt");


var $bSocS = parcelRequire("bSocS");


var $3UFgg = parcelRequire("3UFgg");


var $27xqQ = parcelRequire("27xqQ");


var $bYDpj = parcelRequire("bYDpj");


var $iQUPl = parcelRequire("iQUPl");


var $6mYYR = parcelRequire("6mYYR");

function $9e10a968465c2ceb$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $cozmU.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $cozmU.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $iqYgx.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $iqYgx.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const { usePostTaskPhases: usePostTaskPhases } = (0, $jrpaf.getConfig)();
        const { setFallback: setFallback, getIsBoundaryInitialized: getIsBoundaryInitialized } = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
        const profiler = (0, $cozmU.useContext)((0, $bSocS.ProfilerContext)).current;
        const load = ()=>{
            if (usePostTaskPhases) {
                if (status.started) return;
            } else {
                if (status.started || !status.phase || !status.noWait) return;
            }
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $27xqQ.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        if (usePostTaskPhases) // Start loading immediately, as the loader itself will be delayed until the appropriate phase
        (0, $cozmU.useMemo)(()=>{
            load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        else {
            // Subscribe to LazyWait context, triggering load when until is true
            (0, $6mYYR.useSubscription)({
                context: (0, $6pwcu.WaitContext),
                load: load,
                onValue: (v)=>status.noWait = v === 1
            });
            if (defer === (0, $iqYgx.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $6mYYR.useSubscription)({
                context: (0, $hGTvt.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
        }
        (0, $cozmU.useMemo)(()=>{
            // Skip collecting fallbacks if the boundary is already initialized
            if (usePostTaskPhases && getIsBoundaryInitialized()) return;
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $iqYgx.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $jrpaf.getConfig)().mode === (0, $hwBK6.MODE).RENDER ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iQUPl.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bYDpj.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback,
            getIsBoundaryInitialized,
            usePostTaskPhases
        ]);
        (0, $cozmU.useMemo)(()=>{
            const { mode: mode, react18: react18 } = (0, $jrpaf.getConfig)();
            // we dont remove fallback in RENDER mode as it happens too early
            // however it's not a problem for HYDRATION as Suspense will handle all nuances
            if (mode === (0, $hwBK6.MODE).HYDRATE && react18) // Allow hydration to support partials without server components
            // suspense will discard ssr during hydration if re-renders so we
            // set a dummy fallback to block updates from the provider until we resolve
            setFallback(/*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {}));
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, $8aG6j.jsx)(ResolvedLazy, {
            ...props
        });
    };
}
module.exports["createComponentClient"] = $9e10a968465c2ceb$export$6898b5504b58699a;

});

parcelRegister("6pwcu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aJQSl = parcelRequire("aJQSl");

const $548763ff32fd4fa9$export$9ba3fe09d15de47b = (0, $cozmU.createContext)({
    subscribe: ()=>(0, $aJQSl.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $548763ff32fd4fa9$export$9ba3fe09d15de47b;

});

parcelRegister("aJQSl", function(module, exports) {
const $05617924a76d0a6c$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $05617924a76d0a6c$export$276c7dbda7675aec;

});

parcelRegister("hGTvt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iqYgx = parcelRequire("iqYgx");


var $lJvTv = parcelRequire("lJvTv");


var $dcIK9 = parcelRequire("dcIK9");

let $672f0e6595584070$var$CURRENT_PHASE = (0, $iqYgx.PHASE).PAINT;
const $672f0e6595584070$export$5f80f094fd31fffd = (phase)=>{
    $672f0e6595584070$var$CURRENT_PHASE = phase;
    (0, $lJvTv.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $672f0e6595584070$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: (0, $dcIK9.createSubscribe)((0, $lJvTv.LISTENERS)),
    currentValue: ()=>$672f0e6595584070$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $672f0e6595584070$export$5f80f094fd31fffd((0, $iqYgx.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$672f0e6595584070$export$5f80f094fd31fffd((0, $iqYgx.PHASE).PAINT)
    }
});
const $672f0e6595584070$export$1dc361b277327f88 = ()=>{
    const v = (0, $cozmU.useContext)($672f0e6595584070$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["LazyPhaseContext"] = $672f0e6595584070$export$5a25eca35e5debcb;

});

parcelRegister("lJvTv", function(module, exports) {
const $17f151a063744015$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $17f151a063744015$export$81b9c458a026d68f;

});

parcelRegister("dcIK9", function(module, exports) {
const $66c4eef17986e77d$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $66c4eef17986e77d$export$364097d812234b3f;

});

parcelRegister("bSocS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0b79a9622223785f$export$e2d53c0cbedd2710 = {
    current: null
};
const $0b79a9622223785f$export$8146ab57a3f7a7cb = (0, $cozmU.createContext)($0b79a9622223785f$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $0b79a9622223785f$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $0b79a9622223785f$export$8146ab57a3f7a7cb;

});

parcelRegister("3UFgg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");

const $307cdf761723c83f$export$c33990e84065970c = /*#__PURE__*/ (0, $cozmU.createContext)({
    getIsBoundaryInitialized: ()=>false,
    fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Fragment), {}),
    setFallback: ()=>{
        if ((0, $jrpaf.getConfig)().mode === (0, $hwBK6.MODE).RENDER) // render mode MUST have a properly configured boundary
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $307cdf761723c83f$export$c33990e84065970c;

});

parcelRegister("27xqQ", function(module, exports) {
const $8d723af0e292a27d$export$6aa69c1258005366 = Symbol.for('@atlassian/react-loosely-lazy/loader-error');
const $8d723af0e292a27d$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$8d723af0e292a27d$export$6aa69c1258005366]: true
    });
    return error;
};
const $8d723af0e292a27d$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($8d723af0e292a27d$export$6aa69c1258005366);
module.exports["createLoaderError"] = $8d723af0e292a27d$export$c73a6a6f0bf7d425;

});

parcelRegister("bYDpj", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3Zhtx = parcelRequire("3Zhtx");

const $308221388927349f$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                type: "hidden",
                "data-lazy-begin": id
            }),
            content.map((el, i)=>{
                const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
                const props = Array.from(attributes).reduce((0, $3Zhtx.attrToProp), {
                    key: String(i)
                });
                // text node
                if (!tagName) return /*#__PURE__*/ (0, $cozmU.createElement)((0, $cozmU.Fragment), props, el.textContent);
                // childless tag
                if (!childNodes.length) return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), props);
                // tag with content
                return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), {
                    ...props,
                    dangerouslySetInnerHTML: {
                        __html: ''
                    },
                    suppressHydrationWarning: true
                });
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                type: "hidden",
                "data-lazy-end": id
            })
        ]
    });
};
module.exports["PlaceholderFallbackHydrate"] = $308221388927349f$export$ca5b8fbc835d95e4;

});

parcelRegister("iQUPl", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6pwcu = parcelRequire("6pwcu");


var $bSocS = parcelRequire("bSocS");


var $3UFgg = parcelRequire("3UFgg");

function $fac82888d07c9621$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $fac82888d07c9621$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $cozmU.useRef)(null);
    const { current: ssrDomNodes } = (0, $cozmU.useRef)(content || []);
    const profilerContext = (0, $cozmU.useContext)((0, $bSocS.ProfilerContext)).current;
    const waitContext = (0, $cozmU.useContext)((0, $6pwcu.WaitContext));
    const suspenseContext = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
    (0, $cozmU.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext?.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($fac82888d07c9621$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext?.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>node.parentNode?.removeChild(node));
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $fac82888d07c9621$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $fac82888d07c9621$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $fac82888d07c9621$export$d55db778a3e1446b;

});

parcelRegister("6mYYR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $fb43d3d8deaa2f13$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $cozmU.useContext)(context);
    (0, $cozmU.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $fb43d3d8deaa2f13$export$368b4214baeb914c;

});

parcelRegister("f1SiZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3zIme = parcelRequire("3zIme");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");


var $iqYgx = parcelRequire("iqYgx");


var $3UFgg = parcelRequire("3UFgg");


var $3Zhtx = parcelRequire("3Zhtx");


var $27xqQ = parcelRequire("27xqQ");

function $e4910f9bc5a8efc5$var$load(moduleId, loader) {
    try {
        return (0, $3Zhtx.getExport)(loader());
    } catch (err) {
        throw (0, $27xqQ.createLoaderError)(err);
    }
}
function $e4910f9bc5a8efc5$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        const { fallback: fallback } = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest, onChunkRender: onChunkRender, mode: mode, react18: react18, modernErrorFallback: modernErrorFallback, environment: environment } = (0, $jrpaf.getConfig)();
        const shouldLoad = ssr || environment === 'client';
        const Resolved = shouldLoad ? $e4910f9bc5a8efc5$var$load(moduleId, loader) : null;
        onChunkRender(dataLazyId, moduleId, defer);
        if (mode === (0, $hwBK6.MODE).HYDRATE && react18) {
            if (!Resolved) throw new $e4910f9bc5a8efc5$var$ReactLooselyLazyNoSsrError(moduleId);
            return /*#__PURE__*/ (0, $8aG6j.jsx)(Resolved, {
                ...props
            });
        }
        if (modernErrorFallback) {
            if (!Resolved) // lets just return the fallback without extra fuzz
            // and "error" fallback is usually totally empty, so why bother?
            return fallback;
        }
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    type: "hidden",
                    "data-lazy-begin": dataLazyId
                }),
                defer !== (0, $iqYgx.PHASE).LAZY && (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId)?.map((url)=>/*#__PURE__*/ (0, $8aG6j.jsx)("link", {
                        rel: defer === (0, $iqYgx.PHASE).PAINT ? 'preload' : 'prefetch',
                        href: url,
                        crossOrigin: crossOrigin,
                        as: "script"
                    }, url)),
                Resolved ? /*#__PURE__*/ (0, $8aG6j.jsx)(Resolved, {
                    ...props
                }) : fallback,
                /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    type: "hidden",
                    "data-lazy-end": dataLazyId
                })
            ]
        });
    };
}
class $e4910f9bc5a8efc5$var$ReactLooselyLazyNoSsrError extends Error {
    constructor(moduleId){
        super(`[no-error] React-Loosely-Lazy SSR opt out - ${moduleId}`);
        // This error is used to indicate to React that this component should not
        // render in SSR (it will instead trigger the nearest Suspense boundary)
        // so we mark it as ignored in SSR reporting.
        this.skipSsr = void 0;
        this.skipSsr = true;
    }
}
module.exports["createComponentServer"] = $e4910f9bc5a8efc5$export$eb2e4b04351cdd9e;

});

parcelRegister("6DjRB", function(module, exports) {
const $ee7f0d866347d691$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $ee7f0d866347d691$export$a339266ad71b2447 = 300;
const $ee7f0d866347d691$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $ee7f0d866347d691$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $ee7f0d866347d691$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $ee7f0d866347d691$export$ba64c908e55507fe;

});

parcelRegister("ah4XH", function(module, exports) {
/**
 * a map of all created deferred to
 * - ensure there is single deferred created for every lazy (NOT YET ENFORCED/USED)
 * - track list of known LazyComponents so we can, for example, preload them by id
 */ const $841e841717fb4840$var$lazyIds = new Map();
/**
 * ids "marked" for preload on spot
 */ let $841e841717fb4840$var$preloadIds;
const $841e841717fb4840$export$ac21d099cbc8d569 = (preload)=>{
    $841e841717fb4840$var$preloadIds = preload;
    try {
        $841e841717fb4840$var$preloadIds.forEach((lazyId)=>{
            const deffered = $841e841717fb4840$var$lazyIds.get(lazyId);
            if (deffered) // preload dont have any "phases" and visa versa. Just load it ASAP
            deffered.preload();
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('RLL preload', e);
    }
};
const $841e841717fb4840$export$e673efccd97e4223 = (lazyId, { loader: loader, preload: preload })=>{
    // we dont cache deferred FOR NOW as the goal is to handle networking first
    // the next step would in better pre-resolving deferred, so Suspense might be never triggered
    // if (lazyIds.has(lazyId)) {
    // 	return lazyIds.get(lazyId)!;
    // }
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: ()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        },
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    $841e841717fb4840$var$lazyIds.set(lazyId, deferred);
    // in case of "just created" deferred is already marked for preload
    // do instant preload
    if ($841e841717fb4840$var$preloadIds?.includes(lazyId)) deferred.preload();
    return deferred;
};
module.exports["createDeferred"] = $841e841717fb4840$export$e673efccd97e4223;

});

parcelRegister("cU4Ow", function(module, exports) {

var $3zIme = parcelRequire("3zIme");


var $aJQSl = parcelRequire("aJQSl");


var $jrpaf = parcelRequire("jrpaf");


var $bSocS = parcelRequire("bSocS");


var $3Zhtx = parcelRequire("3Zhtx");


var $6DjRB = parcelRequire("6DjRB");


var $1Y0Bp = parcelRequire("1Y0Bp");

function $72b45db42b4960fa$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $jrpaf.getConfig)();
    const assets = (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $1Y0Bp.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $72b45db42b4960fa$var$fakePromise = {
    then: ()=>$72b45db42b4960fa$var$fakePromise,
    catch: ()=>$72b45db42b4960fa$var$fakePromise,
    finally: ()=>$72b45db42b4960fa$var$fakePromise
};
function $72b45db42b4960fa$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $1Y0Bp.insertLinkTag)(href, rel));
        return $72b45db42b4960fa$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $72b45db42b4960fa$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $aJQSl.noopCleanup;
}
function $72b45db42b4960fa$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    if ((0, $3Zhtx.isNodeEnvironment)()) return 0, $aJQSl.noopCleanup;
    (0, $bSocS.GlobalReactLooselyLazyProfiler).current?.onPreload(moduleId, priority);
    const rel = priority === (0, $6DjRB.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $72b45db42b4960fa$export$3af04dbcb01bad4d,
        $72b45db42b4960fa$export$1046fd6a49d5e7a,
        $72b45db42b4960fa$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $aJQSl.noopCleanup;
}
module.exports["preloadAsset"] = $72b45db42b4960fa$export$25bad4aa00c45355;

});

parcelRegister("1Y0Bp", function(module, exports) {

var $aJQSl = parcelRequire("aJQSl");


var $jrpaf = parcelRequire("jrpaf");


var $bSocS = parcelRequire("bSocS");

function $e5a7bcb8f7812549$export$6610512821c8a4ce(href, rel) {
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $aJQSl.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $jrpaf.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $bSocS.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    document.head?.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) document.head?.removeChild(link);
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $e5a7bcb8f7812549$export$6610512821c8a4ce;

});

parcelRegister("31PDK", function(module, exports) {
const $e0741a36efbb4dfa$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $e0741a36efbb4dfa$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $e0741a36efbb4dfa$var$getPolicy = (configuration)=>({
        delay: Math.max(0, configuration.delay ?? 0),
        factor: Math.max(0, configuration.factor ?? 0),
        maxAttempts: Math.max(0, configuration.maxAttempts ?? 0)
    });
function $e0741a36efbb4dfa$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $e0741a36efbb4dfa$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $e0741a36efbb4dfa$var$calculateDelay(context, policy);
        if (delay) await $e0741a36efbb4dfa$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $e0741a36efbb4dfa$export$9369b12211e1fce4;

});

parcelRegister("3LxIp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

function $1efef99f0e02a868$export$7c51f1b21238e429(LegacyIcon, OfficialIcon, defaultSize) {
    return function BrandIcon({ size: size = defaultSize } = {}) {
        if ((0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(OfficialIcon, {
            label: "",
            size: size
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LegacyIcon, null);
    };
}
module.exports["withBrandIcon"] = $1efef99f0e02a868$export$7c51f1b21238e429;

});

parcelRegister("4hzFj", function(module, exports) {

let $31e46a58d87c0f49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $31e46a58d87c0f49$var$load("jxGqt").then(()=>parcelRequire('fyTd1'));

});

parcelRegister("3w7xz", function(module, exports) {

let $28fa35a07f4c32d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $28fa35a07f4c32d8$var$load("ECQ6q").then(()=>parcelRequire('kGNh6'));

});

parcelRegister("ehKBQ", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $6ce68911b0df4e15$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9dtYX")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/logo-third-party/gitlab'
});

const $6ce68911b0df4e15$var$LazyGitlabIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon'
});

const $6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/search-result-icon'
});

const $6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon-borderless'
});
const $6ce68911b0df4e15$export$8b4e5326778cce0f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'small');
const $6ce68911b0df4e15$export$b828123bc19648f9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'medium');
const $6ce68911b0df4e15$export$7e0d364467f49036 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'xxsmall');
module.exports["GitlabIcon"] = $6ce68911b0df4e15$export$8b4e5326778cce0f;
module.exports["GitlabSearchResultIcon"] = $6ce68911b0df4e15$export$b828123bc19648f9;
module.exports["GitlabIconBorderless"] = $6ce68911b0df4e15$export$7e0d364467f49036;

});

parcelRegister("9dtYX", function(module, exports) {

let $6b5c95c494a16587$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b5c95c494a16587$var$load("4LY4N").then(()=>parcelRequire('kmcLM'));

});

parcelRegister("ilgI1", function(module, exports) {

let $d5a726386ad88d53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5a726386ad88d53$var$load("1p9Ip").then(()=>parcelRequire('hYL6T'));

});

parcelRegister("iS3Tu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $83bbbb3fda08bb6a$var$LazyGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDA4")).then((m)=>m.GitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/icon'
});

const $83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDA4")).then((m)=>m.GitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/search-result-icon'
});
const $83bbbb3fda08bb6a$export$6da1c7984975c183 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookIconComponent, null));
const $83bbbb3fda08bb6a$export$65b356f251826206 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent, null));
module.exports["GitbookIcon"] = $83bbbb3fda08bb6a$export$6da1c7984975c183;
module.exports["GitbookSearchResultIcon"] = $83bbbb3fda08bb6a$export$65b356f251826206;

});

parcelRegister("lbDA4", function(module, exports) {

let $f6c953f826ed6884$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6c953f826ed6884$var$load("k1ije").then(()=>parcelRequire('lG6hv'));

});

parcelRegister("dULnI", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2cad9d35507cac43$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("enDSk")).then((m)=>m.MicrosoftAzureDevOpsIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-azure-devops'
});

const $2cad9d35507cac43$var$LazyAzureDevopsIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8WMbv")).then((m)=>m.AzureDevopsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/icon'
});

const $2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8WMbv")).then((m)=>m.AzureDevopsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/search-result-icon'
});
const $2cad9d35507cac43$export$2dcf704e717ca168 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsIconComponent, null)), $2cad9d35507cac43$var$OfficialIcon, 'small');
const $2cad9d35507cac43$export$a64bb17da4dc2efb = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent, null)), $2cad9d35507cac43$var$OfficialIcon, 'medium');
module.exports["AzureDevopsIcon"] = $2cad9d35507cac43$export$2dcf704e717ca168;
module.exports["AzureDevopsSearchResultIcon"] = $2cad9d35507cac43$export$a64bb17da4dc2efb;

});

parcelRegister("enDSk", function(module, exports) {

let $a782250e15e8574e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a782250e15e8574e$var$load("jLsGY").then(()=>parcelRequire('b9s7D'));

});

parcelRegister("8WMbv", function(module, exports) {

let $68391df23b860e75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $68391df23b860e75$var$load("axvMK").then(()=>parcelRequire('fTk3N'));

});

parcelRegister("2sFbd", function(module, exports) {
/**
 * Lazy-loaded Slack icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $809b94d6e1c8821b$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ln0Jc")).then((m)=>m.SlackIcon), {
    moduleId: '@atlassian/logo-third-party/slack'
});

// Lazy load the actual icon components from utils
const $809b94d6e1c8821b$var$LazySlackIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/icon'
});

const $809b94d6e1c8821b$var$LazySlackIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/slack/icon-borderless'
});

const $809b94d6e1c8821b$var$LazySlackSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/search-result-icon'
});

const $809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/app-selector-icon'
});
const $809b94d6e1c8821b$export$b33fb54b08bb6422 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'small');
const $809b94d6e1c8821b$export$359ca796b415372 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconBorderlessComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'xxsmall');
const $809b94d6e1c8821b$export$9e3ecebaf98513b9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackSearchResultIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'medium');
const $809b94d6e1c8821b$export$f11b42d1aefdd173 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'xxsmall');
module.exports["SlackIcon"] = $809b94d6e1c8821b$export$b33fb54b08bb6422;
module.exports["SlackIconBorderless"] = $809b94d6e1c8821b$export$359ca796b415372;
module.exports["SlackSearchResultIcon"] = $809b94d6e1c8821b$export$9e3ecebaf98513b9;

});

parcelRegister("ln0Jc", function(module, exports) {

let $f8ec4f8a6e6abecf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f8ec4f8a6e6abecf$var$load("7S2Sh").then(()=>parcelRequire('eaD9b'));

});

parcelRegister("iCjpP", function(module, exports) {

let $d8dad6234f740135$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8dad6234f740135$var$load("hUTu6").then(()=>parcelRequire('gaQ0m'));

});

parcelRegister("9Jc29", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $f96caf77f5e0e90e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hcdgm")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/logo-third-party/google-drive'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/search-result-icon'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon-borderless'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveAppSelectorIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/app-selector-icon'
});
const $f96caf77f5e0e90e$export$e16bd899bb4eebf9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'small');
const $f96caf77f5e0e90e$export$99050685a064f8e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveSearchResultIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'medium');
const $f96caf77f5e0e90e$export$1f3b452b60b13122 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveIconBorderlessComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'xxsmall');
const $f96caf77f5e0e90e$export$e087ba40596ff085 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveAppSelectorIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'xxsmall');
module.exports["GoogleDriveIcon"] = $f96caf77f5e0e90e$export$e16bd899bb4eebf9;
module.exports["GoogleDriveSearchResultIcon"] = $f96caf77f5e0e90e$export$99050685a064f8e;
module.exports["GoogleDriveIconBorderless"] = $f96caf77f5e0e90e$export$1f3b452b60b13122;
module.exports["GoogleDriveAppSelectorIcon"] = $f96caf77f5e0e90e$export$e087ba40596ff085;

});

parcelRegister("hcdgm", function(module, exports) {

let $c84dd866b614e7fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c84dd866b614e7fc$var$load("iDrFi").then(()=>parcelRequire('4zc1o'));

});

parcelRegister("eauWV", function(module, exports) {

let $a50a01c0fe4d8419$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a50a01c0fe4d8419$var$load("fz4Mg").then(()=>parcelRequire('aqriX'));

});

parcelRegister("jyScu", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $63cad5270e3124a2$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jQMxS")).then((m)=>m.FigmaIcon), {
    moduleId: '@atlassian/logo-third-party/figma'
});

const $63cad5270e3124a2$var$LazyFigmaIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lv0ob")).then((m)=>m.FigmaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/figma/icon'
});

const $63cad5270e3124a2$var$LazyFigmaSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lv0ob")).then((m)=>m.FigmaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/figma/search-result-icon'
});
const $63cad5270e3124a2$export$54e0f4982aa79afe = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63cad5270e3124a2$var$LazyFigmaIconComponent, null)), $63cad5270e3124a2$var$OfficialIcon, 'small');
const $63cad5270e3124a2$export$b31792ff95c3d83f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63cad5270e3124a2$var$LazyFigmaSearchResultIconComponent, null)), $63cad5270e3124a2$var$OfficialIcon, 'medium');
module.exports["FigmaIcon"] = $63cad5270e3124a2$export$54e0f4982aa79afe;
module.exports["FigmaSearchResultIcon"] = $63cad5270e3124a2$export$b31792ff95c3d83f;

});

parcelRegister("jQMxS", function(module, exports) {

let $e73887c3b4774afa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e73887c3b4774afa$var$load("lrpUd").then(()=>parcelRequire('d5OuW'));

});

parcelRegister("lv0ob", function(module, exports) {

let $fa6ccb7c265dd600$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa6ccb7c265dd600$var$load("lXqxA").then(()=>parcelRequire('3jkLL'));

});

parcelRegister("1q7zk", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $795cd329f1dc6efb$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7L3HM")).then((m)=>m.MiroIcon), {
    moduleId: '@atlassian/logo-third-party/miro'
});

const $795cd329f1dc6efb$var$LazyMiroIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8rXyj")).then((m)=>m.MiroIcon), {
    moduleId: '@atlassian/rovo-connectors-config/miro/icon'
});

const $795cd329f1dc6efb$var$LazyMiroSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8rXyj")).then((m)=>m.MiroSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/miro/search-result-icon'
});
const $795cd329f1dc6efb$export$38410c1d5582587e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($795cd329f1dc6efb$var$LazyMiroIconComponent, null)), $795cd329f1dc6efb$var$OfficialIcon, 'small');
const $795cd329f1dc6efb$export$c22696a011659024 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($795cd329f1dc6efb$var$LazyMiroSearchResultIconComponent, null)), $795cd329f1dc6efb$var$OfficialIcon, 'medium');
module.exports["MiroIcon"] = $795cd329f1dc6efb$export$38410c1d5582587e;
module.exports["MiroSearchResultIcon"] = $795cd329f1dc6efb$export$c22696a011659024;

});

parcelRegister("7L3HM", function(module, exports) {

let $5a5fcbf4df6462e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a5fcbf4df6462e4$var$load("fDXJE").then(()=>parcelRequire('dPB9D'));

});

parcelRegister("8rXyj", function(module, exports) {

let $626f0a394095201f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $626f0a394095201f$var$load("6cQfl").then(()=>parcelRequire('UNjzi'));

});

parcelRegister("dpFv1", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $eadc98172343aaf6$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("duDsS")).then((m)=>m.NotionIcon), {
    moduleId: '@atlassian/logo-third-party/notion'
});

const $eadc98172343aaf6$var$LazyNotionIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("dqLLz")).then((m)=>m.NotionIcon), {
    moduleId: '@atlassian/rovo-connectors-config/notion/icon'
});

const $eadc98172343aaf6$var$LazyNotionSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("dqLLz")).then((m)=>m.NotionSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/notion/search-result-icon'
});

const $eadc98172343aaf6$var$LazyNotionIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("dqLLz")).then((m)=>m.NotionIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/notion/icon-borderless'
});
const $eadc98172343aaf6$export$694ff710b1e20299 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eadc98172343aaf6$var$LazyNotionIconComponent, null)), $eadc98172343aaf6$var$OfficialIcon, 'small');
const $eadc98172343aaf6$export$7dd377a68ecb1d9f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eadc98172343aaf6$var$LazyNotionSearchResultIconComponent, null)), $eadc98172343aaf6$var$OfficialIcon, 'medium');
const $eadc98172343aaf6$export$5b5388c6f4e608dd = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eadc98172343aaf6$var$LazyNotionIconBorderlessComponent, null)), $eadc98172343aaf6$var$OfficialIcon, 'xxsmall');
module.exports["NotionIcon"] = $eadc98172343aaf6$export$694ff710b1e20299;
module.exports["NotionSearchResultIcon"] = $eadc98172343aaf6$export$7dd377a68ecb1d9f;
module.exports["NotionIconBorderless"] = $eadc98172343aaf6$export$5b5388c6f4e608dd;

});

parcelRegister("duDsS", function(module, exports) {

let $9d2cb0973885463a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d2cb0973885463a$var$load("gSN2U").then(()=>parcelRequire('3zDBO'));

});

parcelRegister("dqLLz", function(module, exports) {

let $9c72c17820ac74dc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c72c17820ac74dc$var$load("iCnHc").then(()=>parcelRequire('lRem0'));

});

parcelRegister("Douji", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $216cd14c42636556$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("60nw9")).then((m)=>m.MicrosoftSharePointIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-sharepoint'
});

const $216cd14c42636556$var$LazySharePointIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharePointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon'
});

const $216cd14c42636556$var$LazySharePointSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharePointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/search-result-icon'
});

const $216cd14c42636556$var$LazySharepointIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharepointIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon-borderless'
});
const $216cd14c42636556$export$53d8bcde0f28cd56 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointIconComponent, null)), $216cd14c42636556$var$OfficialIcon, 'small');
const $216cd14c42636556$export$65b9e0ddb04a51a1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointSearchResultIconComponent, null)), $216cd14c42636556$var$OfficialIcon, 'medium');
const $216cd14c42636556$export$a0d18fc9cea4f40e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharepointIconBorderlessComponent, null)), $216cd14c42636556$var$OfficialIcon, 'xxsmall');
module.exports["SharePointIcon"] = $216cd14c42636556$export$53d8bcde0f28cd56;
module.exports["SharePointSearchResultIcon"] = $216cd14c42636556$export$65b9e0ddb04a51a1;
module.exports["SharepointIconBorderless"] = $216cd14c42636556$export$a0d18fc9cea4f40e;

});

parcelRegister("60nw9", function(module, exports) {

let $45f4fc3fccb59bad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45f4fc3fccb59bad$var$load("i8lZ0").then(()=>parcelRequire('8RTwe'));

});

parcelRegister("kabYe", function(module, exports) {

let $eade06eb3e209cb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eade06eb3e209cb5$var$load("c2llp").then(()=>parcelRequire('58jvK'));

});

parcelRegister("iPmoS", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b77f1e6828d0ac82$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4hzFj")).then((m)=>m.GitHubIcon), {
    moduleId: '@atlassian/logo-third-party/github'
});

const $b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9RFVr")).then((m)=>m.ForgePioGithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/icon'
});

const $b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9RFVr")).then((m)=>m.ForgePioGithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/search-result-icon'
});
const $b77f1e6828d0ac82$export$f1d7e8d930f0538e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent, null)), $b77f1e6828d0ac82$var$OfficialIcon, 'small');
const $b77f1e6828d0ac82$export$f318f463f9328f3f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent, null)), $b77f1e6828d0ac82$var$OfficialIcon, 'medium');
module.exports["ForgePioGithubIcon"] = $b77f1e6828d0ac82$export$f1d7e8d930f0538e;
module.exports["ForgePioGithubSearchResultIcon"] = $b77f1e6828d0ac82$export$f318f463f9328f3f;

});

parcelRegister("9RFVr", function(module, exports) {

let $72e995d3df53c84c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $72e995d3df53c84c$var$load("cNleL").then(()=>parcelRequire('gcarM'));

});

parcelRegister("2a08l", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $f2ed16baff72ba2b$var$LazyWebDomainSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l1BmH")).then((m)=>m.WebDomainSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/atlassian-web-crawler/search-result-icon'
});
const $f2ed16baff72ba2b$export$b16288f56aa4a879 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2ed16baff72ba2b$var$LazyWebDomainSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2ed16baff72ba2b$var$LazyWebDomainSearchResultIconComponent, null));
module.exports["WebDomainSearchResultIcon"] = $f2ed16baff72ba2b$export$b16288f56aa4a879;

});

parcelRegister("l1BmH", function(module, exports) {

let $f4e6ace1a3666370$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f4e6ace1a3666370$var$load("5ZoVX").then(()=>parcelRequire('5TYsy'));

});

parcelRegister("frXak", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $67596226ed2b5a5b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ['atlassian-web-crawler']: {
        id: "search-page.products.custom-website",
        defaultMessage: "Web page"
    }
});
module.exports["messages"] = $67596226ed2b5a5b$export$defe85febe8b728c;

});

parcelRegister("7dzhu", function(module, exports) {

var $hareu = parcelRequire("hareu");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jyScu = parcelRequire("jyScu");

const $5121b1584cf21fa5$export$e821d8af66e3adab = {
    displayName: 'Figma',
    id: 'figma',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Figma,
    icon: (0, $i52Hf.get3PLogo)((0, $jyScu.FigmaIcon), 'Figma', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jyScu.FigmaSearchResultIcon), 'Figma', 'large'),
    integrationAri: 'ari:cloud:platform::integration/figma',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["figmaConfig"] = $5121b1584cf21fa5$export$e821d8af66e3adab;

});

parcelRegister("hareu", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $572397f4f72859d8$export$9d37c36d8b43baee = [
    'ati:cloud:graph:design'
];
module.exports["DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI"] = $572397f4f72859d8$export$9d37c36d8b43baee;

});

parcelRegister("kFLxH", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $cd2849e7738ca37b$export$1dc2d469fb044d48 = [
    'ati:cloud:graph:remote-link'
];
module.exports["DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI"] = $cd2849e7738ca37b$export$1dc2d469fb044d48;

});

parcelRegister("6Ymez", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $0aab066f73937fd8$export$7bf025ec33e76761 = [
    'ati:cloud:graph:branch'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI"] = $0aab066f73937fd8$export$7bf025ec33e76761;

});

parcelRegister("bCUcs", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $ea564ddf0cc8c2fd$export$3e5409bef2addb56 = [
    'ati:cloud:graph:commit'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI"] = $ea564ddf0cc8c2fd$export$3e5409bef2addb56;

});

parcelRegister("fmJYG", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $51acdb1b50e4834b$export$3268f1527392e5ac = [
    'ati:cloud:graph:pull-request'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI"] = $51acdb1b50e4834b$export$3268f1527392e5ac;

});

parcelRegister("iM9d2", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $fe7cd180c5f0ee38$export$c28231fcae6448eb = [
    'ati:cloud:graph:repository'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI"] = $fe7cd180c5f0ee38$export$c28231fcae6448eb;

});

parcelRegister("2Rsot", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $a989069c3574d0d8$export$d810eae89914369b = [
    'ati:cloud:graph:work-item'
];
module.exports["DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI"] = $a989069c3574d0d8$export$d810eae89914369b;

});

parcelRegister("sRb5o", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $cedd31adddcd6a4e$export$a3d7cddace4fe237 = [
    'ati:cloud:graph:video'
];
module.exports["DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI"] = $cedd31adddcd6a4e$export$a3d7cddace4fe237;

});

parcelRegister("2qza4", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jkp8o = parcelRequire("jkp8o");

const $f930aa7851f48d68$export$4a63cdb15a145936 = {
    displayName: 'Dropbox',
    id: 'dropbox',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Dropbox,
    icon: (0, $i52Hf.get3PLogo)((0, $jkp8o.DropboxIcon), 'Dropbox', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jkp8o.DropboxSearchResultIcon), 'Dropbox', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dropbox',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document,
                    (0, $5PPrc.NounSubtypeKey).Pdf
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Presentation,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["dropboxConfig"] = $f930aa7851f48d68$export$4a63cdb15a145936;

});

parcelRegister("jkp8o", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $f91f519b5bcd4961$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8ndru")).then((m)=>m.DropboxIcon), {
    moduleId: '@atlassian/logo-third-party/dropbox'
});

const $f91f519b5bcd4961$var$LazyDropboxIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jawnG")).then((m)=>m.DropboxIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dropbox/icon'
});

const $f91f519b5bcd4961$var$LazyDropboxSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jawnG")).then((m)=>m.DropboxSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dropbox/search-result-icon'
});
const $f91f519b5bcd4961$export$5e2362bb78414664 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f91f519b5bcd4961$var$LazyDropboxIconComponent, null)), $f91f519b5bcd4961$var$OfficialIcon, 'small');
const $f91f519b5bcd4961$export$197780c70679b508 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f91f519b5bcd4961$var$LazyDropboxSearchResultIconComponent, null)), $f91f519b5bcd4961$var$OfficialIcon, 'medium');
module.exports["DropboxIcon"] = $f91f519b5bcd4961$export$5e2362bb78414664;
module.exports["DropboxSearchResultIcon"] = $f91f519b5bcd4961$export$197780c70679b508;

});

parcelRegister("8ndru", function(module, exports) {

let $618ae617941e5dc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $618ae617941e5dc0$var$load("1FkAI").then(()=>parcelRequire('7qsey'));

});

parcelRegister("jawnG", function(module, exports) {

let $df4811b549e8b26a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $df4811b549e8b26a$var$load("4zHyf").then(()=>parcelRequire('lOu1t'));

});

parcelRegister("kDG5l", function(module, exports) {

var $6GYKu = parcelRequire("6GYKu");


var $72Zuk = parcelRequire("72Zuk");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $2sFbd = parcelRequire("2sFbd");

const $35e09b6a61d5b2b9$var$getSlackTypeFilterConfig = ()=>{
    const typeFilter = new Map();
    // Always include Message
    typeFilter.set((0, $5PPrc.TypeFilterValueKey).Message, {
        entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
        subTypes3P: []
    });
    typeFilter.set((0, $5PPrc.TypeFilterValueKey).Conversation, {
        entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
        subTypes3P: []
    });
    return typeFilter;
};
const $35e09b6a61d5b2b9$export$c33894e475506863 = {
    displayName: 'Slack',
    id: 'slack',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Slack,
    icon: (0, $i52Hf.get3PLogo)((0, $2sFbd.SlackIcon), 'Slack', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $2sFbd.SlackIconBorderless), 'Slack', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $2sFbd.SlackSearchResultIcon), 'Slack', 'large'),
    integrationAri: 'ari:cloud:platform::integration/slack',
    get typeFilterConfig () {
        return $35e09b6a61d5b2b9$var$getSlackTypeFilterConfig();
    },
    filters: [
        'lastUpdated',
        'slackChannel'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["slackConfig"] = $35e09b6a61d5b2b9$export$c33894e475506863;

});

parcelRegister("6GYKu", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $76ad9eb563127536$export$a752b216a5b9069f = [
    'ati:cloud:graph:conversation'
];
module.exports["DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI"] = $76ad9eb563127536$export$a752b216a5b9069f;

});

parcelRegister("72Zuk", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $229f506edf3bbbcc$export$8bd7fa13a82672fe = [
    'ati:cloud:graph:message'
];
module.exports["DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI"] = $229f506edf3bbbcc$export$8bd7fa13a82672fe;

});

parcelRegister("6eg6r", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $bshDC = parcelRequire("bshDC");

const $5a3e20cfdf519b55$export$be326f2f9a08a3a4 = {
    displayName: 'Google Calendar',
    id: 'google-calendar',
    resourceType: (0, $fR63l.ProductResourceTypes3P).GoogleCalendar,
    icon: (0, $i52Hf.get3PLogo)((0, $bshDC.GoogleCalendarIcon), 'Google Calendar', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $bshDC.GoogleCalendarIconBorderless), 'Google Calendar', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $bshDC.GoogleCalendarSearchResultIcon), 'Google Calendar', 'large'),
    integrationAri: 'ari:cloud:platform::integration/google',
    requiresOauth: true,
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    isEnabled: ()=>true
};
module.exports["googleCalendarConfig"] = $5a3e20cfdf519b55$export$be326f2f9a08a3a4;

});

parcelRegister("f3t7x", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $353cafebfceb5684$export$733c2acb2513a07a = [
    'ati:cloud:graph:calendar-event'
];
module.exports["DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI"] = $353cafebfceb5684$export$733c2acb2513a07a;

});

parcelRegister("bshDC", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $5e54e69c86724cae$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("anZGr")).then((m)=>m.GoogleCalendarIcon), {
    moduleId: '@atlassian/logo-third-party/google-calendar'
});

const $5e54e69c86724cae$var$LazyGoogleCalendarIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4w4Kc")).then((m)=>m.GoogleCalendarIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google-calendar/icon'
});

const $5e54e69c86724cae$var$LazyGoogleCalendarSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4w4Kc")).then((m)=>m.GoogleCalendarSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google-calendar/search-result-icon'
});

const $5e54e69c86724cae$var$LazyGoogleCalendarIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4w4Kc")).then((m)=>m.GoogleCalendarIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/google-calendar/icon-borderless'
});
const $5e54e69c86724cae$export$5d128e0a6ffc0558 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5e54e69c86724cae$var$LazyGoogleCalendarIconComponent, null)), $5e54e69c86724cae$var$OfficialIcon, 'small');
const $5e54e69c86724cae$export$aed283b8fb73a449 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5e54e69c86724cae$var$LazyGoogleCalendarSearchResultIconComponent, null)), $5e54e69c86724cae$var$OfficialIcon, 'medium');
const $5e54e69c86724cae$export$dc8e328f8eb98139 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5e54e69c86724cae$var$LazyGoogleCalendarIconBorderlessComponent, null)), $5e54e69c86724cae$var$OfficialIcon, 'xxsmall');
module.exports["GoogleCalendarIcon"] = $5e54e69c86724cae$export$5d128e0a6ffc0558;
module.exports["GoogleCalendarSearchResultIcon"] = $5e54e69c86724cae$export$aed283b8fb73a449;
module.exports["GoogleCalendarIconBorderless"] = $5e54e69c86724cae$export$dc8e328f8eb98139;

});

parcelRegister("anZGr", function(module, exports) {

let $78fbe6699ea6267d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78fbe6699ea6267d$var$load("eN8m9").then(()=>parcelRequire('dO5IM'));

});

parcelRegister("4w4Kc", function(module, exports) {

let $349dd4aca5d2aad7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $349dd4aca5d2aad7$var$load("41vki").then(()=>parcelRequire('bzpJH'));

});

parcelRegister("ijAga", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9dIsl = parcelRequire("9dIsl");

const $28f910cc1563149a$export$3e5044818f2e9ef3 = {
    displayName: 'Outlook Calendar',
    id: 'outlook-calendar',
    resourceType: (0, $fR63l.ProductResourceTypes3P).OutlookCalendar,
    icon: (0, $i52Hf.get3PLogo)((0, $9dIsl.OutlookCalendarIcon), 'Outlook Calendar', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $9dIsl.OutlookCalendarIconBorderless), 'Outlook Calendar', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9dIsl.OutlookCalendarSearchResultIcon), 'Outlook Calendar', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["outlookCalendarConfig"] = $28f910cc1563149a$export$3e5044818f2e9ef3;

});

parcelRegister("9dIsl", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b7be050c70ad0dbd$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lwMgp")).then((m)=>m.MicrosoftOutlookIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-outlook'
});

const $b7be050c70ad0dbd$var$LazyOutlookCalendarIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1cK5e")).then((m)=>m.OutlookCalendarIcon), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-calendar/icon'
});

const $b7be050c70ad0dbd$var$LazyOutlookCalendarSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1cK5e")).then((m)=>m.OutlookCalendarSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-calendar/search-result-icon'
});

const $b7be050c70ad0dbd$var$LazyOutlookCalendarIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1cK5e")).then((m)=>m.OutlookCalendarIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-calendar/icon-borderless'
});
const $b7be050c70ad0dbd$export$62b570fbaf793397 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7be050c70ad0dbd$var$LazyOutlookCalendarIconComponent, null)), $b7be050c70ad0dbd$var$OfficialIcon, 'small');
const $b7be050c70ad0dbd$export$c93fd0887f18cc87 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7be050c70ad0dbd$var$LazyOutlookCalendarSearchResultIconComponent, null)), $b7be050c70ad0dbd$var$OfficialIcon, 'medium');
const $b7be050c70ad0dbd$export$dd150ae24aa9e16a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7be050c70ad0dbd$var$LazyOutlookCalendarIconBorderlessComponent, null)), $b7be050c70ad0dbd$var$OfficialIcon, 'xxsmall');
module.exports["OutlookCalendarIcon"] = $b7be050c70ad0dbd$export$62b570fbaf793397;
module.exports["OutlookCalendarSearchResultIcon"] = $b7be050c70ad0dbd$export$c93fd0887f18cc87;
module.exports["OutlookCalendarIconBorderless"] = $b7be050c70ad0dbd$export$dd150ae24aa9e16a;

});

parcelRegister("lwMgp", function(module, exports) {

let $fac20645ff50f52d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fac20645ff50f52d$var$load("eLIPc").then(()=>parcelRequire('6Adh3'));

});

parcelRegister("1cK5e", function(module, exports) {

let $0e0aa8a5bee42239$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e0aa8a5bee42239$var$load("kD3mK").then(()=>parcelRequire('izieu'));

});

parcelRegister("4Be7r", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5SyKL = parcelRequire("5SyKL");

const $e64348b365719323$export$72c8845a87b8934e = {
    displayName: 'Asana',
    id: 'asana',
    icon: (0, $i52Hf.get3PLogo)((0, $5SyKL.AsanaIcon), 'Asana', 'medium'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).Asana,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5SyKL.AsanaSearchResultIcon), 'Asana', 'large'),
    integrationAri: 'ari:cloud:platform::integration/asana',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: [
                    ...(0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Task
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["asanaConfig"] = $e64348b365719323$export$72c8845a87b8934e;

});

parcelRegister("5SyKL", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $6e40eba859cc102e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kMuq9")).then((m)=>m.AsanaIcon), {
    moduleId: '@atlassian/logo-third-party/asana'
});

const $6e40eba859cc102e$var$LazyAsanaIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("63WVt")).then((m)=>m.AsanaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/asana/icon'
});

const $6e40eba859cc102e$var$LazyAsanaSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("63WVt")).then((m)=>m.AsanaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/asana/search-result-icon'
});
const $6e40eba859cc102e$export$671541d0c7918cd9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e40eba859cc102e$var$LazyAsanaIconComponent, null)), $6e40eba859cc102e$var$OfficialIcon, 'small');
const $6e40eba859cc102e$export$c3fa6bf9156b56f9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e40eba859cc102e$var$LazyAsanaSearchResultIconComponent, null)), $6e40eba859cc102e$var$OfficialIcon, 'medium');
module.exports["AsanaIcon"] = $6e40eba859cc102e$export$671541d0c7918cd9;
module.exports["AsanaSearchResultIcon"] = $6e40eba859cc102e$export$c3fa6bf9156b56f9;

});

parcelRegister("kMuq9", function(module, exports) {

let $f20fe34add90d72b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f20fe34add90d72b$var$load("d4v6U").then(()=>parcelRequire('2FcOq'));

});

parcelRegister("63WVt", function(module, exports) {

let $46a0bb5c742ef139$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46a0bb5c742ef139$var$load("cQSOF").then(()=>parcelRequire('9fYuQ'));

});

parcelRegister("kmEEk", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $ajO8r = parcelRequire("ajO8r");

const $c81e254992debedb$export$74a2db0a5eb2da3f = {
    displayName: 'Zendesk',
    id: 'zendesk',
    icon: (0, $i52Hf.get3PLogo)((0, $ajO8r.ZendeskIcon), 'Zendesk', 'medium'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).Zendesk,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $ajO8r.ZendeskSearchResultIcon), 'Zendesk', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zendesk',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Ticket,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Post,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Post
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Article,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Article
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["zendeskConfig"] = $c81e254992debedb$export$74a2db0a5eb2da3f;

});

parcelRegister("4moZS", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $4dabbc53c19f0eb6$export$4e0eae9edc1a8907 = [
    'ati:cloud:graph:comment'
];
module.exports["DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI"] = $4dabbc53c19f0eb6$export$4e0eae9edc1a8907;

});

parcelRegister("ajO8r", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $8cf8b8beac6f4758$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eU7gC")).then((m)=>m.ZendeskIcon), {
    moduleId: '@atlassian/logo-third-party/zendesk'
});

const $8cf8b8beac6f4758$var$LazyZendeskIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fmsuC")).then((m)=>m.ZendeskIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zendesk/icon'
});

const $8cf8b8beac6f4758$var$LazyZendeskSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fmsuC")).then((m)=>m.ZendeskSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zendesk/search-result-icon'
});
const $8cf8b8beac6f4758$export$9969d63eaadfddf7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8cf8b8beac6f4758$var$LazyZendeskIconComponent, null)), $8cf8b8beac6f4758$var$OfficialIcon, 'small');
const $8cf8b8beac6f4758$export$439dd6b525db0f9a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8cf8b8beac6f4758$var$LazyZendeskSearchResultIconComponent, null)), $8cf8b8beac6f4758$var$OfficialIcon, 'medium');
module.exports["ZendeskIcon"] = $8cf8b8beac6f4758$export$9969d63eaadfddf7;
module.exports["ZendeskSearchResultIcon"] = $8cf8b8beac6f4758$export$439dd6b525db0f9a;

});

parcelRegister("eU7gC", function(module, exports) {

let $ad9beeb805548024$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad9beeb805548024$var$load("T8raP").then(()=>parcelRequire('6foYz'));

});

parcelRegister("fmsuC", function(module, exports) {

let $b2ef03301938ca3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b2ef03301938ca3f$var$load("2TtSv").then(()=>parcelRequire('iMWOo'));

});

parcelRegister("52Drw", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $inzhp = parcelRequire("inzhp");

const $03fbf292f7174bda$export$962b0679c5bd2c33 = {
    displayName: 'Airtable',
    id: 'airtable',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Airtable,
    icon: (0, $i52Hf.get3PLogo)((0, $inzhp.AirtableIcon), 'Airtable', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $inzhp.AirtableSearchResultIcon), 'Airtable', 'large'),
    integrationAri: 'ari:cloud:platform::integration/airtable',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["airtableConfig"] = $03fbf292f7174bda$export$962b0679c5bd2c33;

});

parcelRegister("inzhp", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $92a7691f4600f71d$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("d0y3M")).then((m)=>m.AirtableIcon), {
    moduleId: '@atlassian/logo-third-party/airtable'
});

const $92a7691f4600f71d$var$LazyAirtableIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kzDsq")).then((m)=>m.AirtableIcon), {
    moduleId: '@atlassian/rovo-connectors-config/airtable/icon'
});

const $92a7691f4600f71d$var$LazyAirtableSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kzDsq")).then((m)=>m.AirtableSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/airtable/search-result-icon'
});
const $92a7691f4600f71d$export$88b64eee273831fd = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($92a7691f4600f71d$var$LazyAirtableIconComponent, null)), $92a7691f4600f71d$var$OfficialIcon, 'small');
const $92a7691f4600f71d$export$826c628c1cea041a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($92a7691f4600f71d$var$LazyAirtableSearchResultIconComponent, null)), $92a7691f4600f71d$var$OfficialIcon, 'medium');
module.exports["AirtableIcon"] = $92a7691f4600f71d$export$88b64eee273831fd;
module.exports["AirtableSearchResultIcon"] = $92a7691f4600f71d$export$826c628c1cea041a;

});

parcelRegister("d0y3M", function(module, exports) {

let $9785b20e7cd3fd83$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9785b20e7cd3fd83$var$load("1p5Hv").then(()=>parcelRequire('3WMFE'));

});

parcelRegister("kzDsq", function(module, exports) {

let $efa5aef30890ae60$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $efa5aef30890ae60$var$load("ks6Jw").then(()=>parcelRequire('dIIkr'));

});

parcelRegister("aaz0Y", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $g0bLV = parcelRequire("g0bLV");

const $81da3ded26649f38$export$aad10bcf647ef696 = {
    displayName: 'Smartsheet',
    id: 'smartsheet',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Smartsheet,
    icon: (0, $i52Hf.get3PLogo)((0, $g0bLV.SmartsheetIcon), 'Smartsheet', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $g0bLV.SmartsheetSearchResultIcon), 'Smartsheet', 'large'),
    integrationAri: 'ari:cloud:platform::integration/smartsheet',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["smartsheetConfig"] = $81da3ded26649f38$export$aad10bcf647ef696;

});

parcelRegister("g0bLV", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $8f9328e012078649$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iR5v6")).then((m)=>m.SmartsheetIcon), {
    moduleId: '@atlassian/logo-third-party/smartsheet'
});

const $8f9328e012078649$var$LazySmartsheetIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hsPg7")).then((m)=>m.SmartsheetIcon), {
    moduleId: '@atlassian/rovo-connectors-config/smartsheet/icon'
});

const $8f9328e012078649$var$LazySmartsheetSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hsPg7")).then((m)=>m.SmartsheetSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/smartsheet/search-result-icon'
});
const $8f9328e012078649$export$dd0ad7bd8a5794f4 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8f9328e012078649$var$LazySmartsheetIconComponent, null)), $8f9328e012078649$var$OfficialIcon, 'small');
const $8f9328e012078649$export$3b8c4380ae1ed96d = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8f9328e012078649$var$LazySmartsheetSearchResultIconComponent, null)), $8f9328e012078649$var$OfficialIcon, 'medium');
module.exports["SmartsheetIcon"] = $8f9328e012078649$export$dd0ad7bd8a5794f4;
module.exports["SmartsheetSearchResultIcon"] = $8f9328e012078649$export$3b8c4380ae1ed96d;

});

parcelRegister("iR5v6", function(module, exports) {

let $dba171869ac506f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dba171869ac506f9$var$load("5ErXe").then(()=>parcelRequire('hRzDR'));

});

parcelRegister("hsPg7", function(module, exports) {

let $cb6cd027ab9362e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb6cd027ab9362e1$var$load("hwAbd").then(()=>parcelRequire('7j9rQ'));

});

parcelRegister("kcCFv", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $dpFv1 = parcelRequire("dpFv1");

const $2afe1256651e861b$export$ddf7404f556e473a = {
    displayName: 'Notion',
    id: 'notion',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Notion,
    icon: (0, $i52Hf.get3PLogo)((0, $dpFv1.NotionIcon), 'Notion', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $dpFv1.NotionIconBorderless), 'Notion', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $dpFv1.NotionSearchResultIcon), 'Notion', 'large'),
    integrationAri: 'ari:cloud:platform::integration/notion',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["notionConfig"] = $2afe1256651e861b$export$ddf7404f556e473a;

});

parcelRegister("6lsSn", function(module, exports) {

var $hareu = parcelRequire("hareu");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $1q7zk = parcelRequire("1q7zk");

const $b9040784bae93d2b$export$b11bada05d439596 = {
    displayName: 'Miro',
    id: 'miro',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Miro,
    icon: (0, $i52Hf.get3PLogo)((0, $1q7zk.MiroIcon), 'Miro', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $1q7zk.MiroSearchResultIcon), 'Miro', 'large'),
    integrationAri: 'ari:cloud:platform::integration/miro',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["miroConfig"] = $b9040784bae93d2b$export$b11bada05d439596;

});

parcelRegister("k521G", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $3XMnx = parcelRequire("3XMnx");

const $3c5ca7e0efe3fba9$export$cee55280cabc1aa1 = {
    displayName: 'Docusign',
    id: 'docusign',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Docusign,
    icon: (0, $i52Hf.get3PLogo)((0, $3XMnx.DocusignIcon), 'Docusign', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $3XMnx.DocusignIconBorderless), 'Docusign', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $3XMnx.DocusignSearchResultIcon), 'Docusign', 'large'),
    integrationAri: 'ari:cloud:platform::integration/docusign',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["docusignConfig"] = $3c5ca7e0efe3fba9$export$cee55280cabc1aa1;

});

parcelRegister("3XMnx", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $094cc084c2c96e5c$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2xHBu")).then((m)=>m.DocuSignIcon), {
    moduleId: '@atlassian/logo-third-party/docusign'
});

const $094cc084c2c96e5c$var$LazyDocusignIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l2dtx")).then((m)=>m.DocusignIcon), {
    moduleId: '@atlassian/rovo-connectors-config/docusign/icon'
});

const $094cc084c2c96e5c$var$LazyDocusignSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l2dtx")).then((m)=>m.DocusignSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/docusign/search-result-icon'
});

const $094cc084c2c96e5c$var$LazyDocusignIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l2dtx")).then((m)=>m.DocusignIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/docusign/icon-borderless'
});
const $094cc084c2c96e5c$export$393452da0e179bab = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($094cc084c2c96e5c$var$LazyDocusignIconComponent, null)), $094cc084c2c96e5c$var$OfficialIcon, 'small');
const $094cc084c2c96e5c$export$4cdd065eb81c5a09 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($094cc084c2c96e5c$var$LazyDocusignSearchResultIconComponent, null)), $094cc084c2c96e5c$var$OfficialIcon, 'medium');
const $094cc084c2c96e5c$export$db2f9bd1f316d475 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($094cc084c2c96e5c$var$LazyDocusignIconBorderlessComponent, null)), $094cc084c2c96e5c$var$OfficialIcon, 'xxsmall');
module.exports["DocusignIcon"] = $094cc084c2c96e5c$export$393452da0e179bab;
module.exports["DocusignSearchResultIcon"] = $094cc084c2c96e5c$export$4cdd065eb81c5a09;
module.exports["DocusignIconBorderless"] = $094cc084c2c96e5c$export$db2f9bd1f316d475;

});

parcelRegister("2xHBu", function(module, exports) {

let $1da07ca46271c18f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1da07ca46271c18f$var$load("7YktL").then(()=>parcelRequire('eF6SD'));

});

parcelRegister("l2dtx", function(module, exports) {

let $f5043cd00e87a001$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f5043cd00e87a001$var$load("hY6q1").then(()=>parcelRequire('l3sY5'));

});

parcelRegister("43W2t", function(module, exports) {

var $hareu = parcelRequire("hareu");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $kSVSf = parcelRequire("kSVSf");

const $20e2732837474949$export$3cac442956139a7e = {
    displayName: 'Lucid',
    id: 'lucid',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Lucid,
    icon: (0, $i52Hf.get3PLogo)((0, $kSVSf.LucidIcon), 'Lucid', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $kSVSf.LucidSearchResultIcon), 'Lucid', 'large'),
    integrationAri: 'ari:cloud:platform::integration/lucid',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};
module.exports["lucidConfig"] = $20e2732837474949$export$3cac442956139a7e;

});

parcelRegister("kSVSf", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $28a610a168ffc34d$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("aujOL")).then((m)=>m.LucidIcon), {
    moduleId: '@atlassian/logo-third-party/lucid'
});

const $28a610a168ffc34d$var$LazyLucidIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("627KK")).then((m)=>m.LucidIcon), {
    moduleId: '@atlassian/rovo-connectors-config/lucid/icon'
});

const $28a610a168ffc34d$var$LazyLucidSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("627KK")).then((m)=>m.LucidSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/lucid/search-result-icon'
});
const $28a610a168ffc34d$export$8664694e1d7db2a0 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28a610a168ffc34d$var$LazyLucidIconComponent, null)), $28a610a168ffc34d$var$OfficialIcon, 'small');
const $28a610a168ffc34d$export$6daa097ac5ffeb2c = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28a610a168ffc34d$var$LazyLucidSearchResultIconComponent, null)), $28a610a168ffc34d$var$OfficialIcon, 'medium');
module.exports["LucidIcon"] = $28a610a168ffc34d$export$8664694e1d7db2a0;
module.exports["LucidSearchResultIcon"] = $28a610a168ffc34d$export$6daa097ac5ffeb2c;

});

parcelRegister("aujOL", function(module, exports) {

let $7a2c1421be11368f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a2c1421be11368f$var$load("c2c9w").then(()=>parcelRequire('h4FW2'));

});

parcelRegister("627KK", function(module, exports) {

let $4648f18ba45c9e97$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4648f18ba45c9e97$var$load("hU3Xi").then(()=>parcelRequire('c6ZRh'));

});

parcelRegister("6ThsT", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cJP8d = parcelRequire("cJP8d");

const $03d641d2f237614a$export$49283b8341865631 = {
    displayName: 'Monday',
    id: 'monday',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Monday,
    icon: (0, $i52Hf.get3PLogo)((0, $cJP8d.MondayIcon), 'Monday', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $cJP8d.MondayIconBorderless), 'Monday', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cJP8d.MondaySearchResultIcon), 'Monday', 'large'),
    integrationAri: 'ari:cloud:platform::integration/monday',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["mondayConfig"] = $03d641d2f237614a$export$49283b8341865631;

});

parcelRegister("cJP8d", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $142215abe5670892$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("f2rQp")).then((m)=>m.MondayIcon), {
    moduleId: '@atlassian/logo-third-party/monday'
});

const $142215abe5670892$var$LazyMondayIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9b74Z")).then((m)=>m.MondayIcon), {
    moduleId: '@atlassian/rovo-connectors-config/monday/icon'
});

const $142215abe5670892$var$LazyMondaySearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9b74Z")).then((m)=>m.MondaySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/monday/search-result-icon'
});

const $142215abe5670892$var$LazyMondayIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9b74Z")).then((m)=>m.MondayIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/monday/icon-borderless'
});
const $142215abe5670892$export$37b4104f63b2f4bd = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($142215abe5670892$var$LazyMondayIconComponent, null)), $142215abe5670892$var$OfficialIcon, 'small');
const $142215abe5670892$export$bf10d2e61430fb53 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($142215abe5670892$var$LazyMondaySearchResultIconComponent, null)), $142215abe5670892$var$OfficialIcon, 'medium');
const $142215abe5670892$export$43da0494a61d1337 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($142215abe5670892$var$LazyMondayIconBorderlessComponent, null)), $142215abe5670892$var$OfficialIcon, 'xxsmall');
module.exports["MondayIcon"] = $142215abe5670892$export$37b4104f63b2f4bd;
module.exports["MondaySearchResultIcon"] = $142215abe5670892$export$bf10d2e61430fb53;
module.exports["MondayIconBorderless"] = $142215abe5670892$export$43da0494a61d1337;

});

parcelRegister("f2rQp", function(module, exports) {

let $af2ca43c73de70db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af2ca43c73de70db$var$load("8UmJb").then(()=>parcelRequire('863CU'));

});

parcelRegister("9b74Z", function(module, exports) {

let $6aeaa1f9faf92676$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6aeaa1f9faf92676$var$load("1EOaf").then(()=>parcelRequire('iBWwo'));

});

parcelRegister("4x6XK", function(module, exports) {

var $iM9d2 = parcelRequire("iM9d2");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $dULnI = parcelRequire("dULnI");

const $aaf7a143bc096e5d$export$f324080d91cfb196 = {
    displayName: 'Azure DevOps',
    id: 'azure-devops',
    resourceType: (0, $fR63l.ProductResourceTypes3P).AzureDevops,
    icon: (0, $i52Hf.get3PLogo)((0, $dULnI.AzureDevopsIcon), 'AzureDevOps', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $dULnI.AzureDevopsSearchResultIcon), 'AzureDevOps', 'large'),
    integrationAri: 'ari:cloud:platform::integration/azure-devops',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: [
                    ...(0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Repository
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["azureDevopsConfig"] = $aaf7a143bc096e5d$export$f324080d91cfb196;

});

parcelRegister("382mb", function(module, exports) {

var $iM9d2 = parcelRequire("iM9d2");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $ehKBQ = parcelRequire("ehKBQ");

const $e23e1846e340baa7$export$72758f81cc2e21e1 = {
    displayName: 'Gitlab',
    id: 'gitlab',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Gitlab,
    icon: (0, $i52Hf.get3PLogo)((0, $ehKBQ.GitlabIcon), 'Gitlab', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $ehKBQ.GitlabIconBorderless), 'Gitlab', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $ehKBQ.GitlabSearchResultIcon), 'Gitlab', 'large'),
    integrationAri: 'ari:cloud:platform::integration/gitlab',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: [
                    ...(0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Repository,
                    (0, $5PPrc.NounSubtypeKey).Project
                ]
            }
        ]
    ]),
    filters: [
        'pullRequestStatus'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["gitlabConfig"] = $e23e1846e340baa7$export$72758f81cc2e21e1;

});

parcelRegister("2vDkv", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $b3506739b3db16a9$export$1e3b02869b42f77a = [
    'ati:cloud:graph:space'
];
module.exports["DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI"] = $b3506739b3db16a9$export$1e3b02869b42f77a;

});

parcelRegister("fg2gb", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $fDs5L = parcelRequire("fDs5L");

const $ded2e0e354596c76$export$75e56657ffc0207b = {
    displayName: 'Canva',
    id: 'canva',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Canva,
    icon: (0, $i52Hf.get3PLogo)((0, $fDs5L.CanvaIcon), 'Canva', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $fDs5L.CanvaSearchResultIcon), 'Canva', 'large'),
    integrationAri: 'ari:cloud:platform::integration/canva',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["canvaConfig"] = $ded2e0e354596c76$export$75e56657ffc0207b;

});

parcelRegister("fDs5L", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $4d4fb88adf934208$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gefM5")).then((m)=>m.CanvaIcon), {
    moduleId: '@atlassian/logo-third-party/canva'
});

const $4d4fb88adf934208$var$LazyCanvaIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6LmRM")).then((m)=>m.CanvaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/canva/icon'
});

const $4d4fb88adf934208$var$LazyCanvaSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6LmRM")).then((m)=>m.CanvaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/canva/search-result-icon'
});
const $4d4fb88adf934208$export$3ad1ba1bf426d64a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d4fb88adf934208$var$LazyCanvaIconComponent, null)), $4d4fb88adf934208$var$OfficialIcon, 'small');
const $4d4fb88adf934208$export$ac6bbd7ba99716e3 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d4fb88adf934208$var$LazyCanvaSearchResultIconComponent, null)), $4d4fb88adf934208$var$OfficialIcon, 'medium');
module.exports["CanvaIcon"] = $4d4fb88adf934208$export$3ad1ba1bf426d64a;
module.exports["CanvaSearchResultIcon"] = $4d4fb88adf934208$export$ac6bbd7ba99716e3;

});

parcelRegister("gefM5", function(module, exports) {

let $bd0a30ad629dad14$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd0a30ad629dad14$var$load("h6ocG").then(()=>parcelRequire('luZrp'));

});

parcelRegister("6LmRM", function(module, exports) {

let $4ec8dea8ab0a1852$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ec8dea8ab0a1852$var$load("bX5IH").then(()=>parcelRequire('agGaQ'));

});

parcelRegister("fauGM", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $6MJWz = parcelRequire("6MJWz");

const $9286766965944e9d$export$3e7603f097ea326e = {
    displayName: 'Box',
    id: 'box',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Box,
    icon: (0, $i52Hf.get3PLogo)((0, $6MJWz.BoxIcon), 'Box', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $6MJWz.BoxSearchResultIcon), 'Box', 'large'),
    integrationAri: 'ari:cloud:platform::integration/box',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document,
                    (0, $5PPrc.NounSubtypeKey).Pdf
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Presentation,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["boxConfig"] = $9286766965944e9d$export$3e7603f097ea326e;

});

parcelRegister("6MJWz", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b99c2662195c467e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9cFmD")).then((m)=>m.BoxIcon), {
    moduleId: '@atlassian/logo-third-party/box'
});

const $b99c2662195c467e$var$LazyBoxIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1x79L")).then((m)=>m.BoxIcon), {
    moduleId: '@atlassian/rovo-connectors-config/box/icon'
});

const $b99c2662195c467e$var$LazyBoxSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1x79L")).then((m)=>m.BoxSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/box/search-result-icon'
});
const $b99c2662195c467e$export$adedf1569d7107de = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b99c2662195c467e$var$LazyBoxIconComponent, null)), $b99c2662195c467e$var$OfficialIcon, 'small');
const $b99c2662195c467e$export$f9ea3a56c013af54 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b99c2662195c467e$var$LazyBoxSearchResultIconComponent, null)), $b99c2662195c467e$var$OfficialIcon, 'medium');
module.exports["BoxIcon"] = $b99c2662195c467e$export$adedf1569d7107de;
module.exports["BoxSearchResultIcon"] = $b99c2662195c467e$export$f9ea3a56c013af54;

});

parcelRegister("9cFmD", function(module, exports) {

let $6b35521bfc8d519c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b35521bfc8d519c$var$load("gzrsz").then(()=>parcelRequire('kmQeH'));

});

parcelRegister("1x79L", function(module, exports) {

let $11de6ca258b12afa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11de6ca258b12afa$var$load("1KhjS").then(()=>parcelRequire('h43rp'));

});

parcelRegister("bj13p", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8uEzt = parcelRequire("8uEzt");

const $55934d84816643a8$export$ce290ee9e9d9bcd7 = {
    displayName: 'Zoom',
    id: 'zoom',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Zoom,
    icon: (0, $i52Hf.get3PLogo)((0, $8uEzt.ZoomIcon), 'Zoom', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8uEzt.ZoomSearchResultIcon), 'Zoom', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zoom',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["zoomConfig"] = $55934d84816643a8$export$ce290ee9e9d9bcd7;

});

parcelRegister("8uEzt", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $f1c2fec685aced05$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gByso")).then((m)=>m.ZoomIcon), {
    moduleId: '@atlassian/logo-third-party/zoom'
});

const $f1c2fec685aced05$var$LazyZoomIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("brtqH")).then((m)=>m.ZoomIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zoom/icon'
});

const $f1c2fec685aced05$var$LazyZoomSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("brtqH")).then((m)=>m.ZoomSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zoom/search-result-icon'
});
const $f1c2fec685aced05$export$db7393a57b3e6d84 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1c2fec685aced05$var$LazyZoomIconComponent, null)), $f1c2fec685aced05$var$OfficialIcon, 'small');
const $f1c2fec685aced05$export$5c9fb0638b666051 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1c2fec685aced05$var$LazyZoomSearchResultIconComponent, null)), $f1c2fec685aced05$var$OfficialIcon, 'medium');
module.exports["ZoomIcon"] = $f1c2fec685aced05$export$db7393a57b3e6d84;
module.exports["ZoomSearchResultIcon"] = $f1c2fec685aced05$export$5c9fb0638b666051;

});

parcelRegister("gByso", function(module, exports) {

let $c16ad47bb10c0bc2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c16ad47bb10c0bc2$var$load("b2JtK").then(()=>parcelRequire('30kpZ'));

});

parcelRegister("brtqH", function(module, exports) {

let $85490b746b3dbf90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $85490b746b3dbf90$var$load("kxE93").then(()=>parcelRequire('9e80B'));

});

parcelRegister("3VdqU", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cdPZA = parcelRequire("cdPZA");

const $6e80d7674da45b22$export$d198c255b2b88327 = {
    displayName: 'Zeplin',
    id: 'zeplin',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Zeplin,
    icon: (0, $i52Hf.get3PLogo)((0, $cdPZA.ZeplinIcon), 'Zeplin', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $cdPZA.ZeplinIconBorderless), 'Zeplin', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cdPZA.ZeplinSearchResultIcon), 'Zeplin', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zeplin',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["zeplinConfig"] = $6e80d7674da45b22$export$d198c255b2b88327;

});

parcelRegister("cdPZA", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $fbd169a88d312a73$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hafBA")).then((m)=>m.ZeplinIcon), {
    moduleId: '@atlassian/logo-third-party/zeplin'
});

const $fbd169a88d312a73$var$LazyZeplinIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gAgWa")).then((m)=>m.ZeplinIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zeplin/icon'
});

const $fbd169a88d312a73$var$LazyZeplinSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gAgWa")).then((m)=>m.ZeplinSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zeplin/search-result-icon'
});

const $fbd169a88d312a73$var$LazyZeplinIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gAgWa")).then((m)=>m.ZeplinIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/zeplin/icon-borderless'
});
const $fbd169a88d312a73$export$81c909fcf490b72b = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbd169a88d312a73$var$LazyZeplinIconComponent, null)), $fbd169a88d312a73$var$OfficialIcon, 'small');
const $fbd169a88d312a73$export$e3736b5ffc9fcc9e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbd169a88d312a73$var$LazyZeplinSearchResultIconComponent, null)), $fbd169a88d312a73$var$OfficialIcon, 'medium');
const $fbd169a88d312a73$export$d013f8d99ccc63fb = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbd169a88d312a73$var$LazyZeplinIconBorderlessComponent, null)), $fbd169a88d312a73$var$OfficialIcon, 'xxsmall');
module.exports["ZeplinIcon"] = $fbd169a88d312a73$export$81c909fcf490b72b;
module.exports["ZeplinSearchResultIcon"] = $fbd169a88d312a73$export$e3736b5ffc9fcc9e;
module.exports["ZeplinIconBorderless"] = $fbd169a88d312a73$export$d013f8d99ccc63fb;

});

parcelRegister("hafBA", function(module, exports) {

let $c7ef79bb151dcf06$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c7ef79bb151dcf06$var$load("czpIO").then(()=>parcelRequire('ktsV4'));

});

parcelRegister("gAgWa", function(module, exports) {

let $c12d257c331759c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c12d257c331759c7$var$load("dBdPR").then(()=>parcelRequire('cNG5i'));

});

parcelRegister("fA9zj", function(module, exports) {

var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $ldmHj = parcelRequire("ldmHj");

const $95e57b030e0f8dca$export$8120804698f632ae = {
    displayName: 'Freshservice',
    id: 'freshservice',
    icon: (0, $i52Hf.get3PLogo)((0, $ldmHj.FreshserviceIcon), 'Freshservice', 'medium'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).Freshservice,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $ldmHj.FreshserviceSearchResultIcon), 'Freshservice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/freshservice',
    // this hasn't been implemented in the codebase yet, so will need to confirm that it is correct in the future,
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["freshserviceConfig"] = $95e57b030e0f8dca$export$8120804698f632ae;

});

parcelRegister("ldmHj", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $45beef96d43b57ec$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("d3rS9")).then((m)=>m.FreshserviceIcon), {
    moduleId: '@atlassian/logo-third-party/freshservice'
});

const $45beef96d43b57ec$var$LazyFreshserviceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jwajS")).then((m)=>m.FreshserviceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/freshservice/icon'
});

const $45beef96d43b57ec$var$LazyFreshserviceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jwajS")).then((m)=>m.FreshserviceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/freshservice/search-result-icon'
});
const $45beef96d43b57ec$export$327de5bc0476c8b8 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45beef96d43b57ec$var$LazyFreshserviceIconComponent, null)), $45beef96d43b57ec$var$OfficialIcon, 'small');
const $45beef96d43b57ec$export$afb7a1d2b1e9186c = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45beef96d43b57ec$var$LazyFreshserviceSearchResultIconComponent, null)), $45beef96d43b57ec$var$OfficialIcon, 'medium');
module.exports["FreshserviceIcon"] = $45beef96d43b57ec$export$327de5bc0476c8b8;
module.exports["FreshserviceSearchResultIcon"] = $45beef96d43b57ec$export$afb7a1d2b1e9186c;

});

parcelRegister("d3rS9", function(module, exports) {

let $98112d0f9100e3e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98112d0f9100e3e9$var$load("1TO8o").then(()=>parcelRequire('eVhsQ'));

});

parcelRegister("jwajS", function(module, exports) {

let $e35902b647be50d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e35902b647be50d9$var$load("cgVYM").then(()=>parcelRequire('byKTU'));

});

parcelRegister("iTxTm", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jHpbI = parcelRequire("jHpbI");

const $fe7cdbf0eb82d212$export$b883b80d867cc715 = {
    displayName: 'PowerBI',
    id: 'power-bi',
    resourceType: (0, $fR63l.ProductResourceTypes3P).PowerBI,
    icon: (0, $i52Hf.get3PLogo)((0, $jHpbI.PowerBIIcon), 'PowerBI', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $jHpbI.PowerBIIconBorderless), 'PowerBI', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jHpbI.PowerBISearchResultIcon), 'PowerBI', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Dashboard
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["powerBIConfig"] = $fe7cdbf0eb82d212$export$b883b80d867cc715;

});

parcelRegister("jHpbI", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b89a7a27b28a6f7f$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cZjn1")).then((m)=>m.MicrosoftPowerBIIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-power-bi'
});

const $b89a7a27b28a6f7f$var$LazyPowerBIIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gLSjb")).then((m)=>m.PowerBIIcon), {
    moduleId: '@atlassian/rovo-connectors-config/powerBI/icon'
});

const $b89a7a27b28a6f7f$var$LazyPowerBISearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gLSjb")).then((m)=>m.PowerBISearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/powerBI/search-result-icon'
});

const $b89a7a27b28a6f7f$var$LazyPowerBIIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gLSjb")).then((m)=>m.PowerBIIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/powerBI/icon-borderless'
});
const $b89a7a27b28a6f7f$export$8a27e4cfebfdcb7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b89a7a27b28a6f7f$var$LazyPowerBIIconComponent, null)), $b89a7a27b28a6f7f$var$OfficialIcon, 'small');
const $b89a7a27b28a6f7f$export$66bbf4ebbd8bb09 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b89a7a27b28a6f7f$var$LazyPowerBISearchResultIconComponent, null)), $b89a7a27b28a6f7f$var$OfficialIcon, 'medium');
const $b89a7a27b28a6f7f$export$77c3c6e8d16b3669 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b89a7a27b28a6f7f$var$LazyPowerBIIconBorderlessComponent, null)), $b89a7a27b28a6f7f$var$OfficialIcon, 'xxsmall');
module.exports["PowerBIIcon"] = $b89a7a27b28a6f7f$export$8a27e4cfebfdcb7;
module.exports["PowerBISearchResultIcon"] = $b89a7a27b28a6f7f$export$66bbf4ebbd8bb09;
module.exports["PowerBIIconBorderless"] = $b89a7a27b28a6f7f$export$77c3c6e8d16b3669;

});

parcelRegister("cZjn1", function(module, exports) {

let $974a3518074827aa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $974a3518074827aa$var$load("eLocl").then(()=>parcelRequire('a71rl'));

});

parcelRegister("gLSjb", function(module, exports) {

let $c35b29a88fc41c42$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c35b29a88fc41c42$var$load("7yeiN").then(()=>parcelRequire('7NK6P'));

});

parcelRegister("5pWqV", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $iq3xJ = parcelRequire("iq3xJ");

const $cec4d02f64d13f8c$export$7ef79ba9bf00ce19 = {
    displayName: 'ClickUp',
    id: 'clickup',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ClickUp,
    icon: (0, $i52Hf.get3PLogo)((0, $iq3xJ.ClickUpIcon), 'ClickUp', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $iq3xJ.ClickUpIconBorderless), 'ClickUp', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $iq3xJ.ClickUpSearchResultIcon), 'ClickUp', 'large'),
    integrationAri: 'ari:cloud:platform::integration/clickup',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["clickUpConfig"] = $cec4d02f64d13f8c$export$7ef79ba9bf00ce19;

});

parcelRegister("iq3xJ", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $530f12575ecdabb5$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7sd0z")).then((m)=>m.ClickupIcon), {
    moduleId: '@atlassian/logo-third-party/clickup'
});

const $530f12575ecdabb5$var$LazyClickUpIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eZzOO")).then((m)=>m.ClickUpIcon), {
    moduleId: '@atlassian/rovo-connectors-config/clickup/icon'
});

const $530f12575ecdabb5$var$LazyClickUpSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eZzOO")).then((m)=>m.ClickUpSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/clickup/search-result-icon'
});

const $530f12575ecdabb5$var$LazyClickUpIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eZzOO")).then((m)=>m.ClickUpIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/clickup/icon-borderless'
});
const $530f12575ecdabb5$export$592b235c95c5fb2b = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($530f12575ecdabb5$var$LazyClickUpIconComponent, null)), $530f12575ecdabb5$var$OfficialIcon, 'small');
const $530f12575ecdabb5$export$7ca2508a62493599 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($530f12575ecdabb5$var$LazyClickUpSearchResultIconComponent, null)), $530f12575ecdabb5$var$OfficialIcon, 'medium');
const $530f12575ecdabb5$export$d29fdfa1300ec8ae = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($530f12575ecdabb5$var$LazyClickUpIconBorderlessComponent, null)), $530f12575ecdabb5$var$OfficialIcon, 'xxsmall');
module.exports["ClickUpIcon"] = $530f12575ecdabb5$export$592b235c95c5fb2b;
module.exports["ClickUpSearchResultIcon"] = $530f12575ecdabb5$export$7ca2508a62493599;
module.exports["ClickUpIconBorderless"] = $530f12575ecdabb5$export$d29fdfa1300ec8ae;

});

parcelRegister("7sd0z", function(module, exports) {

let $56d53d15de41d2d2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56d53d15de41d2d2$var$load("lXXxc").then(()=>parcelRequire('el36N'));

});

parcelRegister("eZzOO", function(module, exports) {

let $aea28c0308a21713$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aea28c0308a21713$var$load("Wo3LI").then(()=>parcelRequire('aFqIo'));

});

parcelRegister("juuLe", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8DGA8 = parcelRequire("8DGA8");

const $bf887cabcde61381$export$a0702b571a9392d4 = {
    displayName: 'Amplitude',
    id: 'amplitude',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Amplitude,
    icon: (0, $i52Hf.get3PLogo)((0, $8DGA8.AmplitudeIcon), 'Amplitude', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8DGA8.AmplitudeSearchResultIcon), 'Amplitude', 'large'),
    integrationAri: 'ari:cloud:platform::integration/amplitude',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Dashboard
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["amplitudeConfig"] = $bf887cabcde61381$export$a0702b571a9392d4;

});

parcelRegister("8DGA8", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $1c1e864948fda48c$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fLb3r")).then((m)=>m.AmplitudeIcon), {
    moduleId: '@atlassian/logo-third-party/amplitude'
});

const $1c1e864948fda48c$var$LazyAmplitudeIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1Lj2x")).then((m)=>m.AmplitudeIcon), {
    moduleId: '@atlassian/rovo-connectors-config/amplitude/icon'
});

const $1c1e864948fda48c$var$LazyAmplitudeSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1Lj2x")).then((m)=>m.AmplitudeSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/amplitude/search-result-icon'
});
const $1c1e864948fda48c$export$5e013c7991ef7bd0 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1c1e864948fda48c$var$LazyAmplitudeIconComponent, null)), $1c1e864948fda48c$var$OfficialIcon, 'small');
const $1c1e864948fda48c$export$49b3130ea0e9d6dd = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1c1e864948fda48c$var$LazyAmplitudeSearchResultIconComponent, null)), $1c1e864948fda48c$var$OfficialIcon, 'medium');
module.exports["AmplitudeIcon"] = $1c1e864948fda48c$export$5e013c7991ef7bd0;
module.exports["AmplitudeSearchResultIcon"] = $1c1e864948fda48c$export$49b3130ea0e9d6dd;

});

parcelRegister("fLb3r", function(module, exports) {

let $b793d1fa98c7296a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b793d1fa98c7296a$var$load("7ZEab").then(()=>parcelRequire('aIs8c'));

});

parcelRegister("1Lj2x", function(module, exports) {

let $1488f32e8fa7fe12$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1488f32e8fa7fe12$var$load("aHKXM").then(()=>parcelRequire('7uWoZ'));

});

parcelRegister("3juV6", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9PLia = parcelRequire("9PLia");

const $92674268e4049146$export$3be693d67bbce82 = {
    displayName: 'Stripe',
    id: 'stripe',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Stripe,
    icon: (0, $i52Hf.get3PLogo)((0, $9PLia.StripeIcon), 'Stripe', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9PLia.StripeSearchResultIcon), 'Stripe', 'large'),
    integrationAri: 'ari:cloud:platform::integration/stripe',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Invoice,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Invoice
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["stripeConfig"] = $92674268e4049146$export$3be693d67bbce82;

});

parcelRegister("9PLia", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $33b6aea29cf3117b$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4qEUM")).then((m)=>m.StripeIcon), {
    moduleId: '@atlassian/logo-third-party/stripe'
});

const $33b6aea29cf3117b$var$LazyStripeIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cp8O6")).then((m)=>m.StripeIcon), {
    moduleId: '@atlassian/rovo-connectors-config/stripe/icon'
});

const $33b6aea29cf3117b$var$LazyStripeSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cp8O6")).then((m)=>m.StripeSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/stripe/search-result-icon'
});
const $33b6aea29cf3117b$export$86ab8f6f2448222e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33b6aea29cf3117b$var$LazyStripeIconComponent, null)), $33b6aea29cf3117b$var$OfficialIcon, 'small');
const $33b6aea29cf3117b$export$efbbc3acb0731d93 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33b6aea29cf3117b$var$LazyStripeSearchResultIconComponent, null)), $33b6aea29cf3117b$var$OfficialIcon, 'medium');
module.exports["StripeIcon"] = $33b6aea29cf3117b$export$86ab8f6f2448222e;
module.exports["StripeSearchResultIcon"] = $33b6aea29cf3117b$export$efbbc3acb0731d93;

});

parcelRegister("4qEUM", function(module, exports) {

let $339953fb1179e69d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $339953fb1179e69d$var$load("iZ7w3").then(()=>parcelRequire('fc8zu'));

});

parcelRegister("cp8O6", function(module, exports) {

let $907ea6b91679f987$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $907ea6b91679f987$var$load("12xPP").then(()=>parcelRequire('5eELb'));

});

parcelRegister("hIDj1", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $01lrE = parcelRequire("01lrE");

const $9077aa6f5e17fbbd$export$e69f90b2aa757835 = {
    displayName: 'AdobeXD',
    id: 'adobexd',
    resourceType: (0, $fR63l.ProductResourceTypes3P).AdobeXD,
    icon: (0, $i52Hf.get3PLogo)((0, $01lrE.AdobeXDIcon), 'AdobeXD', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $01lrE.AdobeXDSearchResultIcon), 'AdobeXD', 'large'),
    integrationAri: 'ari:cloud:platform::integration/adobe',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["adobeXDConfig"] = $9077aa6f5e17fbbd$export$e69f90b2aa757835;

});

parcelRegister("01lrE", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $9542dedcb7e547d5$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cD7ku")).then((m)=>m.AdobeXDIcon), {
    moduleId: '@atlassian/logo-third-party/adobexd'
});

const $9542dedcb7e547d5$var$LazyAdobeXDIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6qisw")).then((m)=>m.AdobeXDIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-xd/icon'
});

const $9542dedcb7e547d5$var$LazyAdobeXDSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6qisw")).then((m)=>m.AdobeXDSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-xd/search-result-icon'
});
const $9542dedcb7e547d5$export$be8cba599441db6e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9542dedcb7e547d5$var$LazyAdobeXDIconComponent, null)), $9542dedcb7e547d5$var$OfficialIcon, 'small');
const $9542dedcb7e547d5$export$145a936ff16d9011 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9542dedcb7e547d5$var$LazyAdobeXDSearchResultIconComponent, null)), $9542dedcb7e547d5$var$OfficialIcon, 'medium');
module.exports["AdobeXDIcon"] = $9542dedcb7e547d5$export$be8cba599441db6e;
module.exports["AdobeXDSearchResultIcon"] = $9542dedcb7e547d5$export$145a936ff16d9011;

});

parcelRegister("cD7ku", function(module, exports) {

let $931ed00f35da9582$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $931ed00f35da9582$var$load("bPHKE").then(()=>parcelRequire('8E3YW'));

});

parcelRegister("6qisw", function(module, exports) {

let $4ad37d5fd1b448bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ad37d5fd1b448bd$var$load("jIck0").then(()=>parcelRequire('1M0ll'));

});

parcelRegister("7WW80", function(module, exports) {

var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9DXSY = parcelRequire("9DXSY");

const $c8bb031355bf837b$export$ad976bfe08240460 = {
    displayName: 'Aha',
    id: 'aha',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Aha,
    icon: (0, $i52Hf.get3PLogo)((0, $9DXSY.AhaIcon), 'Aha', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9DXSY.AhaSearchResultIcon), 'Aha', 'large'),
    integrationAri: 'ari:cloud:platform::integration/aha',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["ahaConfig"] = $c8bb031355bf837b$export$ad976bfe08240460;

});

parcelRegister("9DXSY", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2d91c1380dbfeb61$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ajWin")).then((m)=>m.AhaIcon), {
    moduleId: '@atlassian/logo-third-party/aha'
});

const $2d91c1380dbfeb61$var$LazyAhaIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eC0Ay")).then((m)=>m.AhaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/aha/icon'
});

const $2d91c1380dbfeb61$var$LazyAhaSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eC0Ay")).then((m)=>m.AhaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/aha/search-result-icon'
});
const $2d91c1380dbfeb61$export$f28fe6c5ebff8c30 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d91c1380dbfeb61$var$LazyAhaIconComponent, null)), $2d91c1380dbfeb61$var$OfficialIcon, 'small');
const $2d91c1380dbfeb61$export$7dd76757b7d2d978 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d91c1380dbfeb61$var$LazyAhaSearchResultIconComponent, null)), $2d91c1380dbfeb61$var$OfficialIcon, 'medium');
module.exports["AhaIcon"] = $2d91c1380dbfeb61$export$f28fe6c5ebff8c30;
module.exports["AhaSearchResultIcon"] = $2d91c1380dbfeb61$export$7dd76757b7d2d978;

});

parcelRegister("ajWin", function(module, exports) {

let $7838e6019e3525a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7838e6019e3525a7$var$load("jX4pB").then(()=>parcelRequire('4fs5C'));

});

parcelRegister("eC0Ay", function(module, exports) {

let $aa35122a7f0ad582$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aa35122a7f0ad582$var$load("crPYr").then(()=>parcelRequire('52Csx'));

});

parcelRegister("au9jr", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $exlh6 = parcelRequire("exlh6");

const $5a9c1a558ebaa3a8$export$8130889f372e8ca5 = {
    displayName: 'Adobe Sign',
    id: 'adobe-sign',
    resourceType: (0, $fR63l.ProductResourceTypes3P).AdobeSign,
    icon: (0, $i52Hf.get3PLogo)((0, $exlh6.AdobeSignIcon), 'Adobe Sign', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $exlh6.AdobeSignSearchResultIcon), 'Adobe Sign', 'large'),
    integrationAri: 'ari:cloud:platform::integration/adobe',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["adobeSignConfig"] = $5a9c1a558ebaa3a8$export$8130889f372e8ca5;

});

parcelRegister("exlh6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $0790bbd11d84640d$var$LazyAdobeSignIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("71Q5J")).then((m)=>m.AdobeSignIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-sign/icon'
});

const $0790bbd11d84640d$var$LazyAdobeSignSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("71Q5J")).then((m)=>m.AdobeSignSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-sign/search-result-icon'
});
const $0790bbd11d84640d$export$600af2172b0f5fb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0790bbd11d84640d$var$LazyAdobeSignIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0790bbd11d84640d$var$LazyAdobeSignIconComponent, null));
const $0790bbd11d84640d$export$9efd1df023dc9339 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0790bbd11d84640d$var$LazyAdobeSignSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0790bbd11d84640d$var$LazyAdobeSignSearchResultIconComponent, null));
module.exports["AdobeSignIcon"] = $0790bbd11d84640d$export$600af2172b0f5fb;
module.exports["AdobeSignSearchResultIcon"] = $0790bbd11d84640d$export$9efd1df023dc9339;

});

parcelRegister("71Q5J", function(module, exports) {

let $51e108abf4f92495$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $51e108abf4f92495$var$load("6hjEN").then(()=>parcelRequire('8lSkY'));

});

parcelRegister("diJOH", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $fgzey = parcelRequire("fgzey");

const $4cab0849efa124dd$export$8855f5ba0dd32fb9 = {
    displayName: 'Mural',
    id: 'mural',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Mural,
    icon: (0, $i52Hf.get3PLogo)((0, $fgzey.MuralIcon), 'Mural', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $fgzey.MuralIconBorderless), 'Mural', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $fgzey.MuralSearchResultIcon), 'Mural', 'large'),
    integrationAri: 'ari:cloud:platform::integration/mural',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["muralConfig"] = $4cab0849efa124dd$export$8855f5ba0dd32fb9;

});

parcelRegister("fgzey", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $a97a3de67fb67ec6$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("e7Ot5")).then((m)=>m.MuralIcon), {
    moduleId: '@atlassian/logo-third-party/mural'
});

const $a97a3de67fb67ec6$var$LazyMuralIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fR633")).then((m)=>m.MuralIcon), {
    moduleId: '@atlassian/rovo-connectors-config/mural/icon'
});

const $a97a3de67fb67ec6$var$LazyMuralSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fR633")).then((m)=>m.MuralSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/mural/search-result-icon'
});

const $a97a3de67fb67ec6$var$LazyMuralIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fR633")).then((m)=>m.MuralIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/mural/icon-borderless'
});
const $a97a3de67fb67ec6$export$807a21e0dcf114c4 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a97a3de67fb67ec6$var$LazyMuralIconComponent, null)), $a97a3de67fb67ec6$var$OfficialIcon, 'small');
const $a97a3de67fb67ec6$export$930cc976c0fd31d6 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a97a3de67fb67ec6$var$LazyMuralSearchResultIconComponent, null)), $a97a3de67fb67ec6$var$OfficialIcon, 'medium');
const $a97a3de67fb67ec6$export$f2b3c9d5e4a9191a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a97a3de67fb67ec6$var$LazyMuralIconBorderlessComponent, null)), $a97a3de67fb67ec6$var$OfficialIcon, 'xxsmall');
module.exports["MuralIcon"] = $a97a3de67fb67ec6$export$807a21e0dcf114c4;
module.exports["MuralSearchResultIcon"] = $a97a3de67fb67ec6$export$930cc976c0fd31d6;
module.exports["MuralIconBorderless"] = $a97a3de67fb67ec6$export$f2b3c9d5e4a9191a;

});

parcelRegister("e7Ot5", function(module, exports) {

let $a488de0f6b76266c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a488de0f6b76266c$var$load("bHGdS").then(()=>parcelRequire('1YPcS'));

});

parcelRegister("fR633", function(module, exports) {

let $b8b07f4942fa03b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8b07f4942fa03b7$var$load("hZppl").then(()=>parcelRequire('9pV7D'));

});

parcelRegister("5bQLl", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9tcvD = parcelRequire("9tcvD");

const $1ec69a9c30a99d71$export$57d2eef9725d4993 = {
    displayName: 'Webex',
    id: 'webex',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Webex,
    icon: (0, $i52Hf.get3PLogo)((0, $9tcvD.WebexIcon), 'Webex', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $9tcvD.WebexIconBorderless), 'Webex', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9tcvD.WebexSearchResultIcon), 'Webex', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cisco',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Video
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["webexConfig"] = $1ec69a9c30a99d71$export$57d2eef9725d4993;

});

parcelRegister("9tcvD", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $df7a27f90b6b2c5e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("150aL")).then((m)=>m.WebexIcon), {
    moduleId: '@atlassian/logo-third-party/webex'
});

const $df7a27f90b6b2c5e$var$LazyWebexIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lSDFq")).then((m)=>m.WebexIcon), {
    moduleId: '@atlassian/rovo-connectors-config/webex/icon'
});

const $df7a27f90b6b2c5e$var$LazyWebexSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lSDFq")).then((m)=>m.WebexSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/webex/search-result-icon'
});

const $df7a27f90b6b2c5e$var$LazyWebexIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lSDFq")).then((m)=>m.WebexIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/webex/icon-borderless'
});
const $df7a27f90b6b2c5e$export$4079343fb47e7f0d = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df7a27f90b6b2c5e$var$LazyWebexIconComponent, null)), $df7a27f90b6b2c5e$var$OfficialIcon, 'small');
const $df7a27f90b6b2c5e$export$37506c98e5c4eabb = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df7a27f90b6b2c5e$var$LazyWebexSearchResultIconComponent, null)), $df7a27f90b6b2c5e$var$OfficialIcon, 'medium');
const $df7a27f90b6b2c5e$export$92866e6fe777cbf9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df7a27f90b6b2c5e$var$LazyWebexIconBorderlessComponent, null)), $df7a27f90b6b2c5e$var$OfficialIcon, 'xxsmall');
module.exports["WebexIcon"] = $df7a27f90b6b2c5e$export$4079343fb47e7f0d;
module.exports["WebexSearchResultIcon"] = $df7a27f90b6b2c5e$export$37506c98e5c4eabb;
module.exports["WebexIconBorderless"] = $df7a27f90b6b2c5e$export$92866e6fe777cbf9;

});

parcelRegister("150aL", function(module, exports) {

let $0c96645c4f95dd26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0c96645c4f95dd26$var$load("hpN8h").then(()=>parcelRequire('l8EZo'));

});

parcelRegister("lSDFq", function(module, exports) {

let $fedd6930306be96d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fedd6930306be96d$var$load("cbO8L").then(()=>parcelRequire('4o0Z8'));

});

parcelRegister("dVIA3", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $566qE = parcelRequire("566qE");

const $f809cfee2fd3adf4$export$2ece5664272d405b = {
    displayName: 'Todoist',
    id: 'todoist',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Todoist,
    icon: (0, $i52Hf.get3PLogo)((0, $566qE.TodoistIcon), 'Todoist', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $566qE.TodoistSearchResultIcon), 'Todoist', 'large'),
    integrationAri: 'ari:cloud:platform::integration/todoist',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["todoistConfig"] = $f809cfee2fd3adf4$export$2ece5664272d405b;

});

parcelRegister("566qE", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $7f696030f35b1bfe$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("87oFm")).then((m)=>m.TodoistIcon), {
    moduleId: '@atlassian/logo-third-party/todoist'
});

const $7f696030f35b1bfe$var$LazyTodoistIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7r1J2")).then((m)=>m.TodoistIcon), {
    moduleId: '@atlassian/rovo-connectors-config/todoist/icon'
});

const $7f696030f35b1bfe$var$LazyTodoistSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7r1J2")).then((m)=>m.TodoistSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/todoist/search-result-icon'
});
const $7f696030f35b1bfe$export$e5f255e151507cba = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f696030f35b1bfe$var$LazyTodoistIconComponent, null)), $7f696030f35b1bfe$var$OfficialIcon, 'small');
const $7f696030f35b1bfe$export$c7baa9df7dbe4b13 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f696030f35b1bfe$var$LazyTodoistSearchResultIconComponent, null)), $7f696030f35b1bfe$var$OfficialIcon, 'medium');
module.exports["TodoistIcon"] = $7f696030f35b1bfe$export$e5f255e151507cba;
module.exports["TodoistSearchResultIcon"] = $7f696030f35b1bfe$export$c7baa9df7dbe4b13;

});

parcelRegister("87oFm", function(module, exports) {

let $5e921c539822847e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e921c539822847e$var$load("el4Li").then(()=>parcelRequire('irDM6'));

});

parcelRegister("7r1J2", function(module, exports) {

let $569c64a902747f35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $569c64a902747f35$var$load("kriZK").then(()=>parcelRequire('bkDWX'));

});

parcelRegister("emznk", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cgpdn = parcelRequire("cgpdn");

const $aedb00e010a8a347$export$cc8a555111f14137 = {
    displayName: 'PagerDuty',
    id: 'pagerduty',
    resourceType: (0, $fR63l.ProductResourceTypes3P).PagerDuty,
    icon: (0, $i52Hf.get3PLogo)((0, $cgpdn.PagerDutyIcon), 'PagerDuty', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cgpdn.PagerDutySearchResultIcon), 'PagerDuty', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pagerduty',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["pagerDutyConfig"] = $aedb00e010a8a347$export$cc8a555111f14137;

});

parcelRegister("cgpdn", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $82cf772d0622b4e8$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3oqfa")).then((m)=>m.PagerDutyIcon), {
    moduleId: '@atlassian/logo-third-party/pager-duty'
});

const $82cf772d0622b4e8$var$LazyPagerDutyIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bUXcS")).then((m)=>m.PagerDutyIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pagerduty/icon'
});

const $82cf772d0622b4e8$var$LazyPagerDutySearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bUXcS")).then((m)=>m.PagerDutySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pagerduty/search-result-icon'
});
const $82cf772d0622b4e8$export$e9a3fd43f9d4bddc = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82cf772d0622b4e8$var$LazyPagerDutyIconComponent, null)), $82cf772d0622b4e8$var$OfficialIcon, 'small');
const $82cf772d0622b4e8$export$494d5ec19d75a736 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82cf772d0622b4e8$var$LazyPagerDutySearchResultIconComponent, null)), $82cf772d0622b4e8$var$OfficialIcon, 'medium');
module.exports["PagerDutyIcon"] = $82cf772d0622b4e8$export$e9a3fd43f9d4bddc;
module.exports["PagerDutySearchResultIcon"] = $82cf772d0622b4e8$export$494d5ec19d75a736;

});

parcelRegister("3oqfa", function(module, exports) {

let $2787f86fb8a1796c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2787f86fb8a1796c$var$load("3BBsj").then(()=>parcelRequire('hhFQM'));

});

parcelRegister("bUXcS", function(module, exports) {

let $8ad2d9e55360e7ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ad2d9e55360e7ef$var$load("i66KR").then(()=>parcelRequire('BKXay'));

});

parcelRegister("fMCQp", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $4dY8b = parcelRequire("4dY8b");

const $3e19c412c5468840$export$9441b0ee1f92e710 = {
    displayName: 'Pipedrive',
    id: 'pipedrive',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Pipedrive,
    icon: (0, $i52Hf.get3PLogo)((0, $4dY8b.PipedriveIcon), 'Pipedrive', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $4dY8b.PipedriveSearchResultIcon), 'Pipedrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pipedrive',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["pipedriveConfig"] = $3e19c412c5468840$export$9441b0ee1f92e710;

});

parcelRegister("4dY8b", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $37fe8e692e6a8fbb$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("a0UGh")).then((m)=>m.PipedriveIcon), {
    moduleId: '@atlassian/logo-third-party/pipedrive'
});

const $37fe8e692e6a8fbb$var$LazyPipedriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1NJ45")).then((m)=>m.PipedriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pipedrive/icon'
});

const $37fe8e692e6a8fbb$var$LazyPipedriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1NJ45")).then((m)=>m.PipedriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pipedrive/search-result-icon'
});
const $37fe8e692e6a8fbb$export$e66a8d6ac96d6ba1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($37fe8e692e6a8fbb$var$LazyPipedriveIconComponent, null)), $37fe8e692e6a8fbb$var$OfficialIcon, 'small');
const $37fe8e692e6a8fbb$export$18970dea61783916 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($37fe8e692e6a8fbb$var$LazyPipedriveSearchResultIconComponent, null)), $37fe8e692e6a8fbb$var$OfficialIcon, 'medium');
module.exports["PipedriveIcon"] = $37fe8e692e6a8fbb$export$e66a8d6ac96d6ba1;
module.exports["PipedriveSearchResultIcon"] = $37fe8e692e6a8fbb$export$18970dea61783916;

});

parcelRegister("a0UGh", function(module, exports) {

let $01e1a4a1772b5e57$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01e1a4a1772b5e57$var$load("27hzN").then(()=>parcelRequire('7RZ3z'));

});

parcelRegister("1NJ45", function(module, exports) {

let $14fd53058867bdc5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14fd53058867bdc5$var$load("1Vgyr").then(()=>parcelRequire('7n163'));

});

parcelRegister("cdiu6", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $i3YNQ = parcelRequire("i3YNQ");

const $cc73151629925938$export$ba5f4c654d743419 = {
    displayName: 'HubSpot',
    id: 'hubspot',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Hubspot,
    icon: (0, $i52Hf.get3PLogo)((0, $i3YNQ.HubSpotFilterIcon), 'HubSpot', 'medium'),
    searchResultIcon: (0, $i52Hf.RovoLogoFromGlyph)((0, $i3YNQ.HubSpotIcon), 'HubSpot'),
    integrationAri: 'ari:cloud:platform::integration/hubspot',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch',
        'lastUpdatedBy',
        'createdBy'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["hubSpotConfig"] = $cc73151629925938$export$ba5f4c654d743419;

});

parcelRegister("5L3UP", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $c71c6856c01ed4e1$export$8dd471de1c2be682 = [
    'ati:cloud:graph:customer-org'
];
module.exports["DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI"] = $c71c6856c01ed4e1$export$8dd471de1c2be682;

});

parcelRegister("2eAN0", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $985674bff788ed13$export$13c55dcee8605c46 = [
    'ati:cloud:graph:deal'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI"] = $985674bff788ed13$export$13c55dcee8605c46;

});

parcelRegister("i3YNQ", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2057a2845d392fbb$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kQYlp")).then((m)=>m.HubSpotIcon), {
    moduleId: '@atlassian/logo-third-party/hubspot'
});

const $2057a2845d392fbb$var$LazyHubSpotFilterIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iQk0M")).then((m)=>m.HubSpotFilterIcon), {
    moduleId: '@atlassian/rovo-connectors-config/hubspot/icon'
});

const $2057a2845d392fbb$var$LazyHubSpotIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iQk0M")).then((m)=>m.HubSpotIcon), {
    moduleId: '@atlassian/rovo-connectors-config/hubspot/search-result-icon'
});
const $2057a2845d392fbb$export$bee6964e6c60da93 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2057a2845d392fbb$var$LazyHubSpotFilterIconComponent, null)), $2057a2845d392fbb$var$OfficialIcon, 'small');
const $2057a2845d392fbb$export$c9a6a66ee7acc43a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2057a2845d392fbb$var$LazyHubSpotIconComponent, null)), $2057a2845d392fbb$var$OfficialIcon, 'medium');
module.exports["HubSpotFilterIcon"] = $2057a2845d392fbb$export$bee6964e6c60da93;
module.exports["HubSpotIcon"] = $2057a2845d392fbb$export$c9a6a66ee7acc43a;

});

parcelRegister("kQYlp", function(module, exports) {

let $f2e7791a0e64cf65$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f2e7791a0e64cf65$var$load("5tNoP").then(()=>parcelRequire('7v0Y0'));

});

parcelRegister("iQk0M", function(module, exports) {

let $db7c9b3ae5d37f01$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db7c9b3ae5d37f01$var$load("jjiWX").then(()=>parcelRequire('7iwl3'));

});

parcelRegister("8djpu", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $1IKTt = parcelRequire("1IKTt");

const $a36ea8dac5de07a0$export$74bb7abed969b4a3 = {
    displayName: 'Dovetail',
    id: 'dovetail',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Dovetail,
    icon: (0, $i52Hf.get3PLogo)((0, $1IKTt.DovetailIcon), 'Dovetail', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $1IKTt.DovetailSearchResultIcon), 'Dovetail', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dovetail',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["dovetailConfig"] = $a36ea8dac5de07a0$export$74bb7abed969b4a3;

});

parcelRegister("1IKTt", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2f56e48e9ad9c3ed$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jZqjP")).then((m)=>m.DovetailIcon), {
    moduleId: '@atlassian/logo-third-party/dovetail'
});

const $2f56e48e9ad9c3ed$var$LazyDovetailIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1agKU")).then((m)=>m.DovetailIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dovetail/icon'
});

const $2f56e48e9ad9c3ed$var$LazyDovetailSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1agKU")).then((m)=>m.DovetailSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dovetail/search-result-icon'
});
const $2f56e48e9ad9c3ed$export$e67ec9178da81ba8 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2f56e48e9ad9c3ed$var$LazyDovetailIconComponent, null)), $2f56e48e9ad9c3ed$var$OfficialIcon, 'small');
const $2f56e48e9ad9c3ed$export$ba101884e6c20332 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2f56e48e9ad9c3ed$var$LazyDovetailSearchResultIconComponent, null)), $2f56e48e9ad9c3ed$var$OfficialIcon, 'medium');
module.exports["DovetailIcon"] = $2f56e48e9ad9c3ed$export$e67ec9178da81ba8;
module.exports["DovetailSearchResultIcon"] = $2f56e48e9ad9c3ed$export$ba101884e6c20332;

});

parcelRegister("jZqjP", function(module, exports) {

let $e8d8212c9bf885b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e8d8212c9bf885b2$var$load("j30YZ").then(()=>parcelRequire('63pax'));

});

parcelRegister("1agKU", function(module, exports) {

let $0d93b8f44ef4ee77$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d93b8f44ef4ee77$var$load("lX1Po").then(()=>parcelRequire('2C7nj'));

});

parcelRegister("3P9fk", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cGNUU = parcelRequire("cGNUU");

const $c668170e147f45a4$export$e45ddd51efe4cb0c = {
    displayName: 'LaunchDarkly',
    id: 'launchdarkly',
    resourceType: (0, $fR63l.ProductResourceTypes3P).LaunchDarkly,
    icon: (0, $i52Hf.get3PLogo)((0, $cGNUU.LaunchDarklyIcon), 'LaunchDarkly', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cGNUU.LaunchDarklySearchResultIcon), 'LaunchDarkly', 'large'),
    integrationAri: 'ari:cloud:platform::integration/launchdarkly',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["launchDarklyConfig"] = $c668170e147f45a4$export$e45ddd51efe4cb0c;

});

parcelRegister("cGNUU", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $ef4ce76b17680270$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7M0yS")).then((m)=>m.LaunchdarklyIcon), {
    moduleId: '@atlassian/logo-third-party/launchdarkly'
});

const $ef4ce76b17680270$var$LazyLaunchDarklyIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ezxxX")).then((m)=>m.LaunchDarklyIcon), {
    moduleId: '@atlassian/rovo-connectors-config/launchdarkly/icon'
});

const $ef4ce76b17680270$var$LazyLaunchDarklySearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ezxxX")).then((m)=>m.LaunchDarklySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/launchdarkly/search-result-icon'
});
const $ef4ce76b17680270$export$68470e68dec0bc46 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ef4ce76b17680270$var$LazyLaunchDarklyIconComponent, null)), $ef4ce76b17680270$var$OfficialIcon, 'small');
const $ef4ce76b17680270$export$66f000bb4bcf5fcd = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ef4ce76b17680270$var$LazyLaunchDarklySearchResultIconComponent, null)), $ef4ce76b17680270$var$OfficialIcon, 'medium');
module.exports["LaunchDarklyIcon"] = $ef4ce76b17680270$export$68470e68dec0bc46;
module.exports["LaunchDarklySearchResultIcon"] = $ef4ce76b17680270$export$66f000bb4bcf5fcd;

});

parcelRegister("7M0yS", function(module, exports) {

let $5a8d739df515d449$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a8d739df515d449$var$load("jdLOX").then(()=>parcelRequire('d9BBd'));

});

parcelRegister("ezxxX", function(module, exports) {

let $a9be5b4384d2d964$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a9be5b4384d2d964$var$load("fK6ul").then(()=>parcelRequire('26kgz'));

});

parcelRegister("2zNcl", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $gZuUC = parcelRequire("gZuUC");

const $b44f335e0add65f2$export$6c52693ff10aea16 = {
    displayName: 'Sentry',
    id: 'sentry',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Sentry,
    icon: (0, $i52Hf.get3PLogo)((0, $gZuUC.SentryIcon), 'Sentry', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $gZuUC.SentrySearchResultIcon), 'Sentry', 'large'),
    integrationAri: 'ari:cloud:platform::integration/sentry',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["sentryConfig"] = $b44f335e0add65f2$export$6c52693ff10aea16;

});

parcelRegister("gZuUC", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2e1e358b3dafc32e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6PzNO")).then((m)=>m.SentryIcon), {
    moduleId: '@atlassian/logo-third-party/sentry'
});

const $2e1e358b3dafc32e$var$LazySentryIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("5Kyst")).then((m)=>m.SentryIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sentry/icon'
});

const $2e1e358b3dafc32e$var$LazySentrySearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("5Kyst")).then((m)=>m.SentrySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sentry/search-result-icon'
});
const $2e1e358b3dafc32e$export$ddeafef64c08610e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e1e358b3dafc32e$var$LazySentryIconComponent, null)), $2e1e358b3dafc32e$var$OfficialIcon, 'small');
const $2e1e358b3dafc32e$export$18b7ca5aa35613ec = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e1e358b3dafc32e$var$LazySentrySearchResultIconComponent, null)), $2e1e358b3dafc32e$var$OfficialIcon, 'medium');
module.exports["SentryIcon"] = $2e1e358b3dafc32e$export$ddeafef64c08610e;
module.exports["SentrySearchResultIcon"] = $2e1e358b3dafc32e$export$18b7ca5aa35613ec;

});

parcelRegister("6PzNO", function(module, exports) {

let $4f9347196859d88a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f9347196859d88a$var$load("kxaOw").then(()=>parcelRequire('fscxt'));

});

parcelRegister("5Kyst", function(module, exports) {

let $42fbfa53463ffb37$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $42fbfa53463ffb37$var$load("2wWLi").then(()=>parcelRequire('8cuRQ'));

});

parcelRegister("h8Js2", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $iS3Tu = parcelRequire("iS3Tu");

const $1575c63b0570ab84$export$49c4b548f63d5a90 = {
    displayName: 'GitBook',
    id: 'gitbook',
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, $iS3Tu.GitbookIcon), 'GitBook'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).Gitbook,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $iS3Tu.GitbookSearchResultIcon), 'GitBook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/graph-test-app',
    // as provided here: https://atlassian.slack.com/archives/C0882LN4A56/p1741316020130509
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: false,
    userNeedsOAuth: false,
    // This will only be enabled on the demo instance
    isEnabled: ()=>true
};
module.exports["gitbookConfig"] = $1575c63b0570ab84$export$49c4b548f63d5a90;

});

parcelRegister("9Om9G", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8dCVx = parcelRequire("8dCVx");

const $e51655ee0504dbb7$export$7a257877f5f8c5de = {
    displayName: 'Amazon Web Services S3',
    id: 'aws-s3',
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, $8dCVx.AWSS3Icon), 'Amazon Web Services S3'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).AWSS3,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8dCVx.AWSS3SearchResultIcon), 'Amazon Web Services S3', 'large'),
    integrationAri: 'ari:cloud:platform::integration/graph-test-app',
    // as provided here: https://atlassian.slack.com/archives/C0882LN4A56/p1741316020130509
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    // Keeping this disabled for team demo. We only need GitBook enabled for demo.
    isEnabled: ()=>false
};
module.exports["awss3Config"] = $e51655ee0504dbb7$export$7a257877f5f8c5de;

});

parcelRegister("8dCVx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $8d6fe8b599ff2fd4$var$LazyAWSS3IconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lyZyY")).then((m)=>m.AWSS3Icon), {
    moduleId: '@atlassian/rovo-connectors-config/aws-s3/icon'
});

const $8d6fe8b599ff2fd4$var$LazyAWSS3SearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lyZyY")).then((m)=>m.AWSS3SearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/aws-s3/search-result-icon'
});
const $8d6fe8b599ff2fd4$export$abf71a44e930800c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d6fe8b599ff2fd4$var$LazyAWSS3IconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d6fe8b599ff2fd4$var$LazyAWSS3IconComponent, null));
const $8d6fe8b599ff2fd4$export$30c777236008d219 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d6fe8b599ff2fd4$var$LazyAWSS3SearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d6fe8b599ff2fd4$var$LazyAWSS3SearchResultIconComponent, null));
module.exports["AWSS3Icon"] = $8d6fe8b599ff2fd4$export$abf71a44e930800c;
module.exports["AWSS3SearchResultIcon"] = $8d6fe8b599ff2fd4$export$30c777236008d219;

});

parcelRegister("lyZyY", function(module, exports) {

let $fb2c871e4dc34770$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb2c871e4dc34770$var$load("dy0Fn").then(()=>parcelRequire('2tcCJ'));

});

parcelRegister("kiNtZ", function(module, exports) {

var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $4mBqr = parcelRequire("4mBqr");

const $436740c22c009a9f$export$a9b5a82aefd10fde = {
    displayName: 'Databricks',
    id: 'databricks',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Databricks,
    icon: (0, $i52Hf.get3PLogo)((0, $4mBqr.DatabricksIcon), 'Databricks', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $4mBqr.DatabricksSearchResultIcon), 'Databricks', 'large'),
    integrationAri: 'ari:cloud:platform::integration/databricks',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["databricksConfig"] = $436740c22c009a9f$export$a9b5a82aefd10fde;

});

parcelRegister("lSV0R", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $73e7c9ae902307cd$export$5794851cbc8ee193 = [
    'ati:cloud:graph:dashboard'
];
module.exports["DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI"] = $73e7c9ae902307cd$export$5794851cbc8ee193;

});

parcelRegister("5zhyH", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $c56574206e5d9432$export$f752f74515f17189 = [
    'ati:cloud:graph:data-table'
];
module.exports["DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI"] = $c56574206e5d9432$export$f752f74515f17189;

});

parcelRegister("4mBqr", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $4005a63328b92542$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("5aTt1")).then((m)=>m.DatabricksIcon), {
    moduleId: '@atlassian/logo-third-party/databricks'
});

const $4005a63328b92542$var$LazyDatabricksIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("aug3w")).then((m)=>m.DatabricksIcon), {
    moduleId: '@atlassian/rovo-connectors-config/databricks/icon'
});

const $4005a63328b92542$var$LazyDatabricksSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("aug3w")).then((m)=>m.DatabricksSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/databricks/search-result-icon'
});
const $4005a63328b92542$export$d86876f5e6aac5e0 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4005a63328b92542$var$LazyDatabricksIconComponent, null)), $4005a63328b92542$var$OfficialIcon, 'small');
const $4005a63328b92542$export$efd3770b613bb37b = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4005a63328b92542$var$LazyDatabricksSearchResultIconComponent, null)), $4005a63328b92542$var$OfficialIcon, 'medium');
module.exports["DatabricksIcon"] = $4005a63328b92542$export$d86876f5e6aac5e0;
module.exports["DatabricksSearchResultIcon"] = $4005a63328b92542$export$efd3770b613bb37b;

});

parcelRegister("5aTt1", function(module, exports) {

let $3c48e987dbae287f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c48e987dbae287f$var$load("ltjdT").then(()=>parcelRequire('6t9s3'));

});

parcelRegister("aug3w", function(module, exports) {

let $7a292913e24060be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a292913e24060be$var$load("cSRnY").then(()=>parcelRequire('8CpxA'));

});

parcelRegister("1RpaO", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $bcqy7 = parcelRequire("bcqy7");

const $2080cd553843d21e$export$208b563484d68ba9 = {
    displayName: 'VitaReq by Adam',
    id: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeAdamVitareqDev,
    icon: (0, $i52Hf.get3PLogo)((0, $bcqy7.ForgeAdamVitareqIcon), 'ForgeAdamVitareq', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $bcqy7.ForgeAdamVitareqSearchResultIcon), 'ForgeAdamVitareq', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dAkghOClvWGokDftTTaIgNoD6pnNt74z',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeAdamVitareqConfig"] = $2080cd553843d21e$export$208b563484d68ba9;

});

parcelRegister("bcqy7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $93f1018b38c58e9f$var$LazyForgeAdamVitareqIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bVu7g")).then((m)=>m.ForgeAdamVitareqIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-dev/icon'
});

const $93f1018b38c58e9f$var$LazyForgeAdamVitareqSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bVu7g")).then((m)=>m.ForgeAdamVitareqSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-dev/search-result-icon'
});
const $93f1018b38c58e9f$export$31bc4bf573db3488 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93f1018b38c58e9f$var$LazyForgeAdamVitareqIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93f1018b38c58e9f$var$LazyForgeAdamVitareqIconComponent, null));
const $93f1018b38c58e9f$export$bd28886795da63ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93f1018b38c58e9f$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93f1018b38c58e9f$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
module.exports["ForgeAdamVitareqIcon"] = $93f1018b38c58e9f$export$31bc4bf573db3488;
module.exports["ForgeAdamVitareqSearchResultIcon"] = $93f1018b38c58e9f$export$bd28886795da63ae;

});

parcelRegister("bVu7g", function(module, exports) {

let $8aec6105bf7a443e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8aec6105bf7a443e$var$load("ePl2b").then(()=>parcelRequire('kel29'));

});

parcelRegister("jENKA", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $eRwR0 = parcelRequire("eRwR0");

const $939217ca713606ec$export$208b563484d68ba9 = {
    displayName: 'VitaReq by Adam',
    id: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeAdamVitareqProd,
    icon: (0, $i52Hf.get3PLogo)((0, $eRwR0.ForgeAdamVitareqIcon), 'ForgeAdamVitareq', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $eRwR0.ForgeAdamVitareqSearchResultIcon), 'ForgeAdamVitareq', 'large'),
    integrationAri: 'ari:cloud:platform::integration/EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeAdamVitareqConfig"] = $939217ca713606ec$export$208b563484d68ba9;

});

parcelRegister("eRwR0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $ecc3a7c114d137a3$var$LazyForgeAdamVitareqIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4m2wQ")).then((m)=>m.ForgeAdamVitareqIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-prod/icon'
});

const $ecc3a7c114d137a3$var$LazyForgeAdamVitareqSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4m2wQ")).then((m)=>m.ForgeAdamVitareqSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-prod/search-result-icon'
});
const $ecc3a7c114d137a3$export$31bc4bf573db3488 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecc3a7c114d137a3$var$LazyForgeAdamVitareqIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecc3a7c114d137a3$var$LazyForgeAdamVitareqIconComponent, null));
const $ecc3a7c114d137a3$export$bd28886795da63ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecc3a7c114d137a3$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecc3a7c114d137a3$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
module.exports["ForgeAdamVitareqIcon"] = $ecc3a7c114d137a3$export$31bc4bf573db3488;
module.exports["ForgeAdamVitareqSearchResultIcon"] = $ecc3a7c114d137a3$export$bd28886795da63ae;

});

parcelRegister("4m2wQ", function(module, exports) {

let $32bb2da49487064c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32bb2da49487064c$var$load("5bnED").then(()=>parcelRequire('gKTnp'));

});

parcelRegister("aiL8h", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $2vDkv = parcelRequire("2vDkv");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8xRaD = parcelRequire("8xRaD");

const $3bed2460a9ac74a9$export$1e9db6975f6a70ae = {
    displayName: 'Clickup by Pio',
    id: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioClickupDev,
    icon: (0, $i52Hf.get3PLogo)((0, $8xRaD.ForgePioClickupIcon), 'ForgePioClickup', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8xRaD.ForgePioClickupSearchResultIcon), 'ForgePioClickup', 'large'),
    integrationAri: 'ari:cloud:platform::integration/ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioClickupConfig"] = $3bed2460a9ac74a9$export$1e9db6975f6a70ae;

});

parcelRegister("8xRaD", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $90c5d9d93ae12793$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7sd0z")).then((m)=>m.ClickupIcon), {
    moduleId: '@atlassian/logo-third-party/clickup'
});

const $90c5d9d93ae12793$var$LazyForgePioClickupIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cIrR2")).then((m)=>m.ForgePioClickupIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-dev/icon'
});

const $90c5d9d93ae12793$var$LazyForgePioClickupSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cIrR2")).then((m)=>m.ForgePioClickupSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-dev/search-result-icon'
});
const $90c5d9d93ae12793$export$836fbefaf37221f1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90c5d9d93ae12793$var$LazyForgePioClickupIconComponent, null)), $90c5d9d93ae12793$var$OfficialIcon, 'small');
const $90c5d9d93ae12793$export$83043b67e00ef5ec = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90c5d9d93ae12793$var$LazyForgePioClickupSearchResultIconComponent, null)), $90c5d9d93ae12793$var$OfficialIcon, 'medium');
module.exports["ForgePioClickupIcon"] = $90c5d9d93ae12793$export$836fbefaf37221f1;
module.exports["ForgePioClickupSearchResultIcon"] = $90c5d9d93ae12793$export$83043b67e00ef5ec;

});

parcelRegister("cIrR2", function(module, exports) {

let $941f336918174642$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $941f336918174642$var$load("8s0tV").then(()=>parcelRequire('8nxWD'));

});

parcelRegister("cY0ZT", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $2vDkv = parcelRequire("2vDkv");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8IQya = parcelRequire("8IQya");

const $5d6955193314318a$export$1e9db6975f6a70ae = {
    displayName: 'Clickup by Pio',
    id: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioClickupProd,
    icon: (0, $i52Hf.get3PLogo)((0, $8IQya.ForgePioClickupIcon), 'ForgePioClickup', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8IQya.ForgePioClickupSearchResultIcon), 'ForgePioClickup', 'large'),
    integrationAri: 'ari:cloud:platform::integration/uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioClickupConfig"] = $5d6955193314318a$export$1e9db6975f6a70ae;

});

parcelRegister("8IQya", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $87a1e5b2c35074ff$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7sd0z")).then((m)=>m.ClickupIcon), {
    moduleId: '@atlassian/logo-third-party/clickup'
});

const $87a1e5b2c35074ff$var$LazyForgePioClickupIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("181bf")).then((m)=>m.ForgePioClickupIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-prod/icon'
});

const $87a1e5b2c35074ff$var$LazyForgePioClickupSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("181bf")).then((m)=>m.ForgePioClickupSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-prod/search-result-icon'
});
const $87a1e5b2c35074ff$export$836fbefaf37221f1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87a1e5b2c35074ff$var$LazyForgePioClickupIconComponent, null)), $87a1e5b2c35074ff$var$OfficialIcon, 'small');
const $87a1e5b2c35074ff$export$83043b67e00ef5ec = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87a1e5b2c35074ff$var$LazyForgePioClickupSearchResultIconComponent, null)), $87a1e5b2c35074ff$var$OfficialIcon, 'medium');
module.exports["ForgePioClickupIcon"] = $87a1e5b2c35074ff$export$836fbefaf37221f1;
module.exports["ForgePioClickupSearchResultIcon"] = $87a1e5b2c35074ff$export$83043b67e00ef5ec;

});

parcelRegister("181bf", function(module, exports) {

let $0d2774388cdc3227$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d2774388cdc3227$var$load("fHbPr").then(()=>parcelRequire('lbEqU'));

});

parcelRegister("9SYma", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2vDkv = parcelRequire("2vDkv");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $luC3K = parcelRequire("luC3K");

const $30c6c0a5f88da5cd$export$a10b5ae888bd2541 = {
    displayName: 'Gitbook by Pio',
    id: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGitbookDev,
    icon: (0, $i52Hf.get3PLogo)((0, $luC3K.ForgePioGitbookIcon), 'ForgePioGitbook', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $luC3K.ForgePioGitbookSearchResultIcon), 'ForgePioGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGitbookConfig"] = $30c6c0a5f88da5cd$export$a10b5ae888bd2541;

});

parcelRegister("luC3K", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $ff3e09ebc7d38a88$var$LazyForgePioGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eaLXQ")).then((m)=>m.ForgePioGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-dev/icon'
});

const $ff3e09ebc7d38a88$var$LazyForgePioGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eaLXQ")).then((m)=>m.ForgePioGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-dev/search-result-icon'
});
const $ff3e09ebc7d38a88$export$39f7ff8bf3e8ca0a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff3e09ebc7d38a88$var$LazyForgePioGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff3e09ebc7d38a88$var$LazyForgePioGitbookIconComponent, null));
const $ff3e09ebc7d38a88$export$6de477beffd11496 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff3e09ebc7d38a88$var$LazyForgePioGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff3e09ebc7d38a88$var$LazyForgePioGitbookSearchResultIconComponent, null));
module.exports["ForgePioGitbookIcon"] = $ff3e09ebc7d38a88$export$39f7ff8bf3e8ca0a;
module.exports["ForgePioGitbookSearchResultIcon"] = $ff3e09ebc7d38a88$export$6de477beffd11496;

});

parcelRegister("eaLXQ", function(module, exports) {

let $a517348cc13b5415$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a517348cc13b5415$var$load("doxhZ").then(()=>parcelRequire('5yzek'));

});

parcelRegister("ie06K", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2vDkv = parcelRequire("2vDkv");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $hqQhc = parcelRequire("hqQhc");

const $7e16e25b4d6e9ae6$export$a10b5ae888bd2541 = {
    displayName: 'Gitbook by Pio',
    id: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGitbookProd,
    icon: (0, $i52Hf.get3PLogo)((0, $hqQhc.ForgePioGitbookIcon), 'ForgePioGitbook', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $hqQhc.ForgePioGitbookSearchResultIcon), 'ForgePioGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGitbookConfig"] = $7e16e25b4d6e9ae6$export$a10b5ae888bd2541;

});

parcelRegister("hqQhc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $f7c3187305b5af82$var$LazyForgePioGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cxRlS")).then((m)=>m.ForgePioGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-prod/icon'
});

const $f7c3187305b5af82$var$LazyForgePioGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cxRlS")).then((m)=>m.ForgePioGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-prod/search-result-icon'
});
const $f7c3187305b5af82$export$39f7ff8bf3e8ca0a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7c3187305b5af82$var$LazyForgePioGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7c3187305b5af82$var$LazyForgePioGitbookIconComponent, null));
const $f7c3187305b5af82$export$6de477beffd11496 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7c3187305b5af82$var$LazyForgePioGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7c3187305b5af82$var$LazyForgePioGitbookSearchResultIconComponent, null));
module.exports["ForgePioGitbookIcon"] = $f7c3187305b5af82$export$39f7ff8bf3e8ca0a;
module.exports["ForgePioGitbookSearchResultIcon"] = $f7c3187305b5af82$export$6de477beffd11496;

});

parcelRegister("cxRlS", function(module, exports) {

let $9221f3aa58abeaa8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9221f3aa58abeaa8$var$load("f79rV").then(()=>parcelRequire('jAHFR'));

});

parcelRegister("dChew", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5QuHV = parcelRequire("5QuHV");

const $e57423fd67cdd8c6$export$7b3aebc675da1806 = {
    displayName: 'Google Drive by Pio',
    id: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGoogleDriveDev,
    icon: (0, $i52Hf.get3PLogo)((0, $5QuHV.ForgePioGoogleDriveIcon), 'ForgePioGoogleDrive', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5QuHV.ForgePioGoogleDriveSearchResultIcon), 'ForgePioGoogleDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Video
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGoogleDriveConfig"] = $e57423fd67cdd8c6$export$7b3aebc675da1806;

});

parcelRegister("5QuHV", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $9b14ef24b242b0f5$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hcdgm")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/logo-third-party/google-drive'
});

const $9b14ef24b242b0f5$var$LazyForgePioGoogleDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2dyBk")).then((m)=>m.ForgePioGoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-dev/icon'
});

const $9b14ef24b242b0f5$var$LazyForgePioGoogleDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2dyBk")).then((m)=>m.ForgePioGoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-dev/search-result-icon'
});
const $9b14ef24b242b0f5$export$a1f95679f652d1ae = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b14ef24b242b0f5$var$LazyForgePioGoogleDriveIconComponent, null)), $9b14ef24b242b0f5$var$OfficialIcon, 'small');
const $9b14ef24b242b0f5$export$4bae7f77a341daa0 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b14ef24b242b0f5$var$LazyForgePioGoogleDriveSearchResultIconComponent, null)), $9b14ef24b242b0f5$var$OfficialIcon, 'medium');
module.exports["ForgePioGoogleDriveIcon"] = $9b14ef24b242b0f5$export$a1f95679f652d1ae;
module.exports["ForgePioGoogleDriveSearchResultIcon"] = $9b14ef24b242b0f5$export$4bae7f77a341daa0;

});

parcelRegister("2dyBk", function(module, exports) {

let $19d7a2b45b018186$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $19d7a2b45b018186$var$load("eQyR8").then(()=>parcelRequire('65WlL'));

});

parcelRegister("TCovD", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $f0NBB = parcelRequire("f0NBB");

const $edc55c611b3bef54$export$7b3aebc675da1806 = {
    displayName: 'Google Drive by Pio',
    id: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGoogleDriveProd,
    icon: (0, $i52Hf.get3PLogo)((0, $f0NBB.ForgePioGoogleDriveIcon), 'ForgePioGoogleDrive', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $f0NBB.ForgePioGoogleDriveSearchResultIcon), 'ForgePioGoogleDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pcIwW04B398CSnilRIyzPJ5v5GevlCCo',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Video
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGoogleDriveConfig"] = $edc55c611b3bef54$export$7b3aebc675da1806;

});

parcelRegister("f0NBB", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2a4f11fd35f1561d$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hcdgm")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/logo-third-party/google-drive'
});

const $2a4f11fd35f1561d$var$LazyForgePioGoogleDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("a07eA")).then((m)=>m.ForgePioGoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-prod/icon'
});

const $2a4f11fd35f1561d$var$LazyForgePioGoogleDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("a07eA")).then((m)=>m.ForgePioGoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-prod/search-result-icon'
});
const $2a4f11fd35f1561d$export$a1f95679f652d1ae = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a4f11fd35f1561d$var$LazyForgePioGoogleDriveIconComponent, null)), $2a4f11fd35f1561d$var$OfficialIcon, 'small');
const $2a4f11fd35f1561d$export$4bae7f77a341daa0 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a4f11fd35f1561d$var$LazyForgePioGoogleDriveSearchResultIconComponent, null)), $2a4f11fd35f1561d$var$OfficialIcon, 'medium');
module.exports["ForgePioGoogleDriveIcon"] = $2a4f11fd35f1561d$export$a1f95679f652d1ae;
module.exports["ForgePioGoogleDriveSearchResultIcon"] = $2a4f11fd35f1561d$export$4bae7f77a341daa0;

});

parcelRegister("a07eA", function(module, exports) {

let $747f8411ae156579$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $747f8411ae156579$var$load("fPrZJ").then(()=>parcelRequire('foLez'));

});

parcelRegister("feDPe", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cDJLe = parcelRequire("cDJLe");

const $6d6cb4a42f1a5c65$export$528a99587bc9b40e = {
    displayName: 'Guru by Pio',
    id: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGuruDev,
    icon: (0, $i52Hf.get3PLogo)((0, $cDJLe.ForgePioGuruIcon), 'ForgePioGuru', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cDJLe.ForgePioGuruSearchResultIcon), 'ForgePioGuru', 'large'),
    integrationAri: 'ari:cloud:platform::integration/NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGuruConfig"] = $6d6cb4a42f1a5c65$export$528a99587bc9b40e;

});

parcelRegister("cDJLe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $2920441e11b70cd2$var$LazyForgePioGuruIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hIbHQ")).then((m)=>m.ForgePioGuruIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-dev/icon'
});

const $2920441e11b70cd2$var$LazyForgePioGuruSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hIbHQ")).then((m)=>m.ForgePioGuruSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-dev/search-result-icon'
});
const $2920441e11b70cd2$export$f1cafab080b3bd5c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2920441e11b70cd2$var$LazyForgePioGuruIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2920441e11b70cd2$var$LazyForgePioGuruIconComponent, null));
const $2920441e11b70cd2$export$b49ff31395265951 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2920441e11b70cd2$var$LazyForgePioGuruSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2920441e11b70cd2$var$LazyForgePioGuruSearchResultIconComponent, null));
module.exports["ForgePioGuruIcon"] = $2920441e11b70cd2$export$f1cafab080b3bd5c;
module.exports["ForgePioGuruSearchResultIcon"] = $2920441e11b70cd2$export$b49ff31395265951;

});

parcelRegister("hIbHQ", function(module, exports) {

let $ce4fa05b13629a64$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce4fa05b13629a64$var$load("lxdqb").then(()=>parcelRequire('27bjo'));

});

parcelRegister("klS4t", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $4tpeK = parcelRequire("4tpeK");

const $77afbf3b994cdec8$export$528a99587bc9b40e = {
    displayName: 'Guru by Pio',
    id: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGuruProd,
    icon: (0, $i52Hf.get3PLogo)((0, $4tpeK.ForgePioGuruIcon), 'ForgePioGuru', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $4tpeK.ForgePioGuruSearchResultIcon), 'ForgePioGuru', 'large'),
    integrationAri: 'ari:cloud:platform::integration/mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGuruConfig"] = $77afbf3b994cdec8$export$528a99587bc9b40e;

});

parcelRegister("4tpeK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $b236eb93e0f85320$var$LazyForgePioGuruIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hReiL")).then((m)=>m.ForgePioGuruIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-prod/icon'
});

const $b236eb93e0f85320$var$LazyForgePioGuruSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hReiL")).then((m)=>m.ForgePioGuruSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-prod/search-result-icon'
});
const $b236eb93e0f85320$export$f1cafab080b3bd5c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b236eb93e0f85320$var$LazyForgePioGuruIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b236eb93e0f85320$var$LazyForgePioGuruIconComponent, null));
const $b236eb93e0f85320$export$b49ff31395265951 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b236eb93e0f85320$var$LazyForgePioGuruSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b236eb93e0f85320$var$LazyForgePioGuruSearchResultIconComponent, null));
module.exports["ForgePioGuruIcon"] = $b236eb93e0f85320$export$f1cafab080b3bd5c;
module.exports["ForgePioGuruSearchResultIcon"] = $b236eb93e0f85320$export$b49ff31395265951;

});

parcelRegister("hReiL", function(module, exports) {

let $d0027aea808a4c93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0027aea808a4c93$var$load("l3yCu").then(()=>parcelRequire('5IaNj'));

});

parcelRegister("hFdyH", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9o5zM = parcelRequire("9o5zM");

const $d06de435425db1cd$export$a612366ee7742bc4 = {
    displayName: 'Helpjuice by Pio',
    id: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioHelpjuiceDev,
    icon: (0, $i52Hf.get3PLogo)((0, $9o5zM.ForgePioHelpjuiceIcon), 'ForgePioHelpjuice', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9o5zM.ForgePioHelpjuiceSearchResultIcon), 'ForgePioHelpjuice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHelpjuiceConfig"] = $d06de435425db1cd$export$a612366ee7742bc4;

});

parcelRegister("9o5zM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $1a59bb9fa163a26b$var$LazyForgePioHelpjuiceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l85tV")).then((m)=>m.ForgePioHelpjuiceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-dev/icon'
});

const $1a59bb9fa163a26b$var$LazyForgePioHelpjuiceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l85tV")).then((m)=>m.ForgePioHelpjuiceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-dev/search-result-icon'
});
const $1a59bb9fa163a26b$export$7640ce31f2af22a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a59bb9fa163a26b$var$LazyForgePioHelpjuiceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a59bb9fa163a26b$var$LazyForgePioHelpjuiceIconComponent, null));
const $1a59bb9fa163a26b$export$2782a2dcd42b923c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a59bb9fa163a26b$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a59bb9fa163a26b$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
module.exports["ForgePioHelpjuiceIcon"] = $1a59bb9fa163a26b$export$7640ce31f2af22a2;
module.exports["ForgePioHelpjuiceSearchResultIcon"] = $1a59bb9fa163a26b$export$2782a2dcd42b923c;

});

parcelRegister("l85tV", function(module, exports) {

let $f61e98dabceec19b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f61e98dabceec19b$var$load("BZA59").then(()=>parcelRequire('lcok7'));

});

parcelRegister("e6TPF", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $3XLGG = parcelRequire("3XLGG");

const $ebd7c08029c46f92$export$a612366ee7742bc4 = {
    displayName: 'Helpjuice by Pio',
    id: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioHelpjuiceProd,
    icon: (0, $i52Hf.get3PLogo)((0, $3XLGG.ForgePioHelpjuiceIcon), 'ForgePioHelpjuice', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $3XLGG.ForgePioHelpjuiceSearchResultIcon), 'ForgePioHelpjuice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/8durapLyclxZeEexKkwxw6ZpCRpBz4dP',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHelpjuiceConfig"] = $ebd7c08029c46f92$export$a612366ee7742bc4;

});

parcelRegister("3XLGG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8ZtAm")).then((m)=>m.ForgePioHelpjuiceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-prod/icon'
});

const $c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8ZtAm")).then((m)=>m.ForgePioHelpjuiceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-prod/search-result-icon'
});
const $c3f8a80c4bf2155c$export$7640ce31f2af22a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceIconComponent, null));
const $c3f8a80c4bf2155c$export$2782a2dcd42b923c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
module.exports["ForgePioHelpjuiceIcon"] = $c3f8a80c4bf2155c$export$7640ce31f2af22a2;
module.exports["ForgePioHelpjuiceSearchResultIcon"] = $c3f8a80c4bf2155c$export$2782a2dcd42b923c;

});

parcelRegister("8ZtAm", function(module, exports) {

let $68baf8514ec615e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $68baf8514ec615e9$var$load("89OPU").then(()=>parcelRequire('exmtD'));

});

parcelRegister("7piBv", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $lHmnw = parcelRequire("lHmnw");

const $ff6b770550126248$export$2bb44bd2479444f9 = {
    displayName: 'HubSpot by Pio',
    id: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioHubspotDev,
    icon: (0, $i52Hf.get3PLogo)((0, $lHmnw.ForgePioHubspotIcon), 'ForgePioHubspot', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $lHmnw.ForgePioHubspotSearchResultIcon), 'ForgePioHubspot', 'large'),
    integrationAri: 'ari:cloud:platform::integration/RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHubspotConfig"] = $ff6b770550126248$export$2bb44bd2479444f9;

});

parcelRegister("lHmnw", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $ae4c750f6148d7b8$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kQYlp")).then((m)=>m.HubSpotIcon), {
    moduleId: '@atlassian/logo-third-party/hubspot'
});

const $ae4c750f6148d7b8$var$LazyForgePioHubspotIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gDgqn")).then((m)=>m.ForgePioHubspotIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-dev/icon'
});

const $ae4c750f6148d7b8$var$LazyForgePioHubspotSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gDgqn")).then((m)=>m.ForgePioHubspotSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-dev/search-result-icon'
});
const $ae4c750f6148d7b8$export$e87bb425fde16105 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae4c750f6148d7b8$var$LazyForgePioHubspotIconComponent, null)), $ae4c750f6148d7b8$var$OfficialIcon, 'small');
const $ae4c750f6148d7b8$export$cc1026e3c5b549e1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae4c750f6148d7b8$var$LazyForgePioHubspotSearchResultIconComponent, null)), $ae4c750f6148d7b8$var$OfficialIcon, 'medium');
module.exports["ForgePioHubspotIcon"] = $ae4c750f6148d7b8$export$e87bb425fde16105;
module.exports["ForgePioHubspotSearchResultIcon"] = $ae4c750f6148d7b8$export$cc1026e3c5b549e1;

});

parcelRegister("gDgqn", function(module, exports) {

let $c1bd0762a9485a15$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1bd0762a9485a15$var$load("12zSS").then(()=>parcelRequire('577rm'));

});

parcelRegister("3yXQ1", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $dB1o2 = parcelRequire("dB1o2");

const $9438ce5263366d16$export$2bb44bd2479444f9 = {
    displayName: 'HubSpot by Pio',
    id: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioHubspotProd,
    icon: (0, $i52Hf.get3PLogo)((0, $dB1o2.ForgePioHubspotIcon), 'ForgePioHubspot', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $dB1o2.ForgePioHubspotSearchResultIcon), 'ForgePioHubspot', 'large'),
    integrationAri: 'ari:cloud:platform::integration/O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHubspotConfig"] = $9438ce5263366d16$export$2bb44bd2479444f9;

});

parcelRegister("dB1o2", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $138972da21ac7328$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kQYlp")).then((m)=>m.HubSpotIcon), {
    moduleId: '@atlassian/logo-third-party/hubspot'
});

const $138972da21ac7328$var$LazyForgePioHubspotIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("23P54")).then((m)=>m.ForgePioHubspotIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-prod/icon'
});

const $138972da21ac7328$var$LazyForgePioHubspotSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("23P54")).then((m)=>m.ForgePioHubspotSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-prod/search-result-icon'
});
const $138972da21ac7328$export$e87bb425fde16105 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($138972da21ac7328$var$LazyForgePioHubspotIconComponent, null)), $138972da21ac7328$var$OfficialIcon, 'small');
const $138972da21ac7328$export$cc1026e3c5b549e1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($138972da21ac7328$var$LazyForgePioHubspotSearchResultIconComponent, null)), $138972da21ac7328$var$OfficialIcon, 'medium');
module.exports["ForgePioHubspotIcon"] = $138972da21ac7328$export$e87bb425fde16105;
module.exports["ForgePioHubspotSearchResultIcon"] = $138972da21ac7328$export$cc1026e3c5b549e1;

});

parcelRegister("23P54", function(module, exports) {

let $18037c2587a44799$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $18037c2587a44799$var$load("6nOSk").then(()=>parcelRequire('5aOBD'));

});

parcelRegister("cmwLF", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5N1qm = parcelRequire("5N1qm");

const $86d0647c502027e9$export$6ab686f8808b6986 = {
    displayName: 'Salesforce by Pio',
    id: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioSalesforceDev,
    icon: (0, $i52Hf.get3PLogo)((0, $5N1qm.ForgePioSalesforceIcon), 'ForgePioSalesforce', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5N1qm.ForgePioSalesforceSearchResultIcon), 'ForgePioSalesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSalesforceConfig"] = $86d0647c502027e9$export$6ab686f8808b6986;

});

parcelRegister("5N1qm", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2795db874931a453$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1iIDp")).then((m)=>m.SalesforceIcon), {
    moduleId: '@atlassian/logo-third-party/salesforce'
});

const $2795db874931a453$var$LazyForgePioSalesforceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cXnTk")).then((m)=>m.ForgePioSalesforceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-dev/icon'
});

const $2795db874931a453$var$LazyForgePioSalesforceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cXnTk")).then((m)=>m.ForgePioSalesforceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-dev/search-result-icon'
});
const $2795db874931a453$export$fd669dbaab8ebe1e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2795db874931a453$var$LazyForgePioSalesforceIconComponent, null)), $2795db874931a453$var$OfficialIcon, 'small');
const $2795db874931a453$export$ebba99402341b0c4 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2795db874931a453$var$LazyForgePioSalesforceSearchResultIconComponent, null)), $2795db874931a453$var$OfficialIcon, 'medium');
module.exports["ForgePioSalesforceIcon"] = $2795db874931a453$export$fd669dbaab8ebe1e;
module.exports["ForgePioSalesforceSearchResultIcon"] = $2795db874931a453$export$ebba99402341b0c4;

});

parcelRegister("1iIDp", function(module, exports) {

let $0f2a18683fc3a657$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f2a18683fc3a657$var$load("8nWJ9").then(()=>parcelRequire('gwpcy'));

});

parcelRegister("cXnTk", function(module, exports) {

let $96ed870d8ca0e90e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $96ed870d8ca0e90e$var$load("8FiJs").then(()=>parcelRequire('boSNc'));

});

parcelRegister("brRUk", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jW2EI = parcelRequire("jW2EI");

const $57c4a39dfa3b2602$export$6ab686f8808b6986 = {
    displayName: 'Salesforce by Pio',
    id: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioSalesforceProd,
    icon: (0, $i52Hf.get3PLogo)((0, $jW2EI.ForgePioSalesforceIcon), 'ForgePioSalesforce', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jW2EI.ForgePioSalesforceSearchResultIcon), 'ForgePioSalesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSalesforceConfig"] = $57c4a39dfa3b2602$export$6ab686f8808b6986;

});

parcelRegister("jW2EI", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $ad250f24924a2221$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1iIDp")).then((m)=>m.SalesforceIcon), {
    moduleId: '@atlassian/logo-third-party/salesforce'
});

const $ad250f24924a2221$var$LazyForgePioSalesforceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6D4bc")).then((m)=>m.ForgePioSalesforceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-prod/icon'
});

const $ad250f24924a2221$var$LazyForgePioSalesforceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6D4bc")).then((m)=>m.ForgePioSalesforceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-prod/search-result-icon'
});
const $ad250f24924a2221$export$fd669dbaab8ebe1e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ad250f24924a2221$var$LazyForgePioSalesforceIconComponent, null)), $ad250f24924a2221$var$OfficialIcon, 'small');
const $ad250f24924a2221$export$ebba99402341b0c4 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ad250f24924a2221$var$LazyForgePioSalesforceSearchResultIconComponent, null)), $ad250f24924a2221$var$OfficialIcon, 'medium');
module.exports["ForgePioSalesforceIcon"] = $ad250f24924a2221$export$fd669dbaab8ebe1e;
module.exports["ForgePioSalesforceSearchResultIcon"] = $ad250f24924a2221$export$ebba99402341b0c4;

});

parcelRegister("6D4bc", function(module, exports) {

let $4d39a098c6f42bda$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4d39a098c6f42bda$var$load("HN9Az").then(()=>parcelRequire('ezeQe'));

});

parcelRegister("dwyZc", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $7hXqS = parcelRequire("7hXqS");

const $d0c1882acaf8175d$export$a62192356b6384ff = {
    displayName: 'SharePoint by Pio',
    id: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioSharepointDev,
    icon: (0, $i52Hf.get3PLogo)((0, $7hXqS.ForgePioSharepointIcon), 'ForgePioSharepoint', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $7hXqS.ForgePioSharepointSearchResultIcon), 'ForgePioSharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cl5i3J8L463hTuQiDt7f1mK4vZllsAo0',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document,
                    (0, $5PPrc.NounSubtypeKey).Pdf
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSharepointConfig"] = $d0c1882acaf8175d$export$a62192356b6384ff;

});

parcelRegister("7hXqS", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $9b6113d0f81ce6d8$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("60nw9")).then((m)=>m.MicrosoftSharePointIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-sharepoint'
});

const $9b6113d0f81ce6d8$var$LazyForgePioSharepointIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4NZXw")).then((m)=>m.ForgePioSharepointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-dev/icon'
});

const $9b6113d0f81ce6d8$var$LazyForgePioSharepointSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4NZXw")).then((m)=>m.ForgePioSharepointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-dev/search-result-icon'
});
const $9b6113d0f81ce6d8$export$ecc35ba2a32c7e3f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b6113d0f81ce6d8$var$LazyForgePioSharepointIconComponent, null)), $9b6113d0f81ce6d8$var$OfficialIcon, 'small');
const $9b6113d0f81ce6d8$export$ff73eba88c3a5de7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b6113d0f81ce6d8$var$LazyForgePioSharepointSearchResultIconComponent, null)), $9b6113d0f81ce6d8$var$OfficialIcon, 'medium');
module.exports["ForgePioSharepointIcon"] = $9b6113d0f81ce6d8$export$ecc35ba2a32c7e3f;
module.exports["ForgePioSharepointSearchResultIcon"] = $9b6113d0f81ce6d8$export$ff73eba88c3a5de7;

});

parcelRegister("4NZXw", function(module, exports) {

let $37fbccc6b891f09a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37fbccc6b891f09a$var$load("jSUxV").then(()=>parcelRequire('l1iDy'));

});

parcelRegister("9sIt4", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $bE1lG = parcelRequire("bE1lG");

const $683bf0dbe93cd230$export$a62192356b6384ff = {
    displayName: 'SharePoint by Pio',
    id: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioSharepointProd,
    icon: (0, $i52Hf.get3PLogo)((0, $bE1lG.ForgePioSharepointIcon), 'ForgePioSharepoint', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $bE1lG.ForgePioSharepointSearchResultIcon), 'ForgePioSharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/7yrzYPlAOcZAif2tIymeDXBUNUAxI95G',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSharepointConfig"] = $683bf0dbe93cd230$export$a62192356b6384ff;

});

parcelRegister("bE1lG", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b90524babf24a663$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("60nw9")).then((m)=>m.MicrosoftSharePointIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-sharepoint'
});

const $b90524babf24a663$var$LazyForgePioSharepointIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4OSjU")).then((m)=>m.ForgePioSharepointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-prod/icon'
});

const $b90524babf24a663$var$LazyForgePioSharepointSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4OSjU")).then((m)=>m.ForgePioSharepointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-prod/search-result-icon'
});
const $b90524babf24a663$export$ecc35ba2a32c7e3f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b90524babf24a663$var$LazyForgePioSharepointIconComponent, null)), $b90524babf24a663$var$OfficialIcon, 'small');
const $b90524babf24a663$export$ff73eba88c3a5de7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b90524babf24a663$var$LazyForgePioSharepointSearchResultIconComponent, null)), $b90524babf24a663$var$OfficialIcon, 'medium');
module.exports["ForgePioSharepointIcon"] = $b90524babf24a663$export$ecc35ba2a32c7e3f;
module.exports["ForgePioSharepointSearchResultIcon"] = $b90524babf24a663$export$ff73eba88c3a5de7;

});

parcelRegister("4OSjU", function(module, exports) {

let $3825f7c2c9b6438f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3825f7c2c9b6438f$var$load("dGvaI").then(()=>parcelRequire('53U7P'));

});

parcelRegister("7UyZr", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $eLukX = parcelRequire("eLukX");

const $7b363fb97ca8421c$export$cc9a98fbdf14b1ba = {
    displayName: 'Stack Overflow by Pio',
    id: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioStackOverflowDev,
    icon: (0, $i52Hf.get3PLogo)((0, $eLukX.ForgePioStackOverflowIcon), 'ForgePioStackOverflow', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $eLukX.ForgePioStackOverflowSearchResultIcon), 'ForgePioStackOverflow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioStackOverflowConfig"] = $7b363fb97ca8421c$export$cc9a98fbdf14b1ba;

});

parcelRegister("eLukX", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $d275976379838dc2$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fBB29")).then((m)=>m.StackOverflowIcon), {
    moduleId: '@atlassian/logo-third-party/stack-overflow'
});

const $d275976379838dc2$var$LazyForgePioStackOverflowIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kmocd")).then((m)=>m.ForgePioStackOverflowIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-dev/icon'
});

const $d275976379838dc2$var$LazyForgePioStackOverflowSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kmocd")).then((m)=>m.ForgePioStackOverflowSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-dev/search-result-icon'
});
const $d275976379838dc2$export$99bc27b78a6e71df = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d275976379838dc2$var$LazyForgePioStackOverflowIconComponent, null)), $d275976379838dc2$var$OfficialIcon, 'small');
const $d275976379838dc2$export$9a30339a9bdbd3d6 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d275976379838dc2$var$LazyForgePioStackOverflowSearchResultIconComponent, null)), $d275976379838dc2$var$OfficialIcon, 'medium');
module.exports["ForgePioStackOverflowIcon"] = $d275976379838dc2$export$99bc27b78a6e71df;
module.exports["ForgePioStackOverflowSearchResultIcon"] = $d275976379838dc2$export$9a30339a9bdbd3d6;

});

parcelRegister("fBB29", function(module, exports) {

let $b5c709d86027bc48$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b5c709d86027bc48$var$load("aQKKn").then(()=>parcelRequire('l2bfr'));

});

parcelRegister("kmocd", function(module, exports) {

let $ed28a18858f32988$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ed28a18858f32988$var$load("fhGCt").then(()=>parcelRequire('cH70d'));

});

parcelRegister("2KPYZ", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $dNyzf = parcelRequire("dNyzf");

const $406347052a44a9c5$export$cc9a98fbdf14b1ba = {
    displayName: 'Stack Overflow by Pio',
    id: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioStackOverflowProd,
    icon: (0, $i52Hf.get3PLogo)((0, $dNyzf.ForgePioStackOverflowIcon), 'ForgePioStackOverflow', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $dNyzf.ForgePioStackOverflowSearchResultIcon), 'ForgePioStackOverflow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioStackOverflowConfig"] = $406347052a44a9c5$export$cc9a98fbdf14b1ba;

});

parcelRegister("dNyzf", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $d7c3a178bcc55be2$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fBB29")).then((m)=>m.StackOverflowIcon), {
    moduleId: '@atlassian/logo-third-party/stack-overflow'
});

const $d7c3a178bcc55be2$var$LazyForgePioStackOverflowIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2QdDM")).then((m)=>m.ForgePioStackOverflowIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-prod/icon'
});

const $d7c3a178bcc55be2$var$LazyForgePioStackOverflowSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2QdDM")).then((m)=>m.ForgePioStackOverflowSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-prod/search-result-icon'
});
const $d7c3a178bcc55be2$export$99bc27b78a6e71df = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d7c3a178bcc55be2$var$LazyForgePioStackOverflowIconComponent, null)), $d7c3a178bcc55be2$var$OfficialIcon, 'small');
const $d7c3a178bcc55be2$export$9a30339a9bdbd3d6 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d7c3a178bcc55be2$var$LazyForgePioStackOverflowSearchResultIconComponent, null)), $d7c3a178bcc55be2$var$OfficialIcon, 'medium');
module.exports["ForgePioStackOverflowIcon"] = $d7c3a178bcc55be2$export$99bc27b78a6e71df;
module.exports["ForgePioStackOverflowSearchResultIcon"] = $d7c3a178bcc55be2$export$9a30339a9bdbd3d6;

});

parcelRegister("2QdDM", function(module, exports) {

let $211b04dc028d7bac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $211b04dc028d7bac$var$load("i47NY").then(()=>parcelRequire('7DqjS'));

});

parcelRegister("9lVxQ", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5vkE3 = parcelRequire("5vkE3");

const $3e70faad8a12b1e6$export$1c8bdcf28097f33d = {
    displayName: 'Gitbook - by Utoolity',
    id: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUtoolityGitbookDev,
    icon: (0, $i52Hf.get3PLogo)((0, $5vkE3.ForgeUtoolityGitbookIcon), 'ForgeUtoolityGitbook', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5vkE3.ForgeUtoolityGitbookSearchResultIcon), 'ForgeUtoolityGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUtoolityGitbookConfig"] = $3e70faad8a12b1e6$export$1c8bdcf28097f33d;

});

parcelRegister("5vkE3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $d8f18c592b583242$var$LazyForgeUtoolityGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("31MoW")).then((m)=>m.ForgeUtoolityGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-dev/icon'
});

const $d8f18c592b583242$var$LazyForgeUtoolityGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("31MoW")).then((m)=>m.ForgeUtoolityGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-dev/search-result-icon'
});
const $d8f18c592b583242$export$fc1920df99f3d560 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8f18c592b583242$var$LazyForgeUtoolityGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8f18c592b583242$var$LazyForgeUtoolityGitbookIconComponent, null));
const $d8f18c592b583242$export$41e46c9b83e3cfe1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8f18c592b583242$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8f18c592b583242$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
module.exports["ForgeUtoolityGitbookIcon"] = $d8f18c592b583242$export$fc1920df99f3d560;
module.exports["ForgeUtoolityGitbookSearchResultIcon"] = $d8f18c592b583242$export$41e46c9b83e3cfe1;

});

parcelRegister("31MoW", function(module, exports) {

let $2347029a7fa3b936$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2347029a7fa3b936$var$load("5b0ls").then(()=>parcelRequire('krol2'));

});

parcelRegister("1HfnT", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cRk65 = parcelRequire("cRk65");

const $86431f8286f0d68f$export$1c8bdcf28097f33d = {
    displayName: 'Gitbook - by Utoolity',
    id: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUtoolityGitbookProd,
    icon: (0, $i52Hf.get3PLogo)((0, $cRk65.ForgeUtoolityGitbookIcon), 'ForgeUtoolityGitbook', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cRk65.ForgeUtoolityGitbookSearchResultIcon), 'ForgeUtoolityGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUtoolityGitbookConfig"] = $86431f8286f0d68f$export$1c8bdcf28097f33d;

});

parcelRegister("cRk65", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $6130c3bf337d5909$var$LazyForgeUtoolityGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("84tMx")).then((m)=>m.ForgeUtoolityGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-prod/icon'
});

const $6130c3bf337d5909$var$LazyForgeUtoolityGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("84tMx")).then((m)=>m.ForgeUtoolityGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-prod/search-result-icon'
});
const $6130c3bf337d5909$export$fc1920df99f3d560 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6130c3bf337d5909$var$LazyForgeUtoolityGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6130c3bf337d5909$var$LazyForgeUtoolityGitbookIconComponent, null));
const $6130c3bf337d5909$export$41e46c9b83e3cfe1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6130c3bf337d5909$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6130c3bf337d5909$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
module.exports["ForgeUtoolityGitbookIcon"] = $6130c3bf337d5909$export$fc1920df99f3d560;
module.exports["ForgeUtoolityGitbookSearchResultIcon"] = $6130c3bf337d5909$export$41e46c9b83e3cfe1;

});

parcelRegister("84tMx", function(module, exports) {

let $5e05cc7d0478333e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e05cc7d0478333e$var$load("etezH").then(()=>parcelRequire('k1qzV'));

});

parcelRegister("bzVC8", function(module, exports) {

var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $gkMkb = parcelRequire("gkMkb");

const $cd6088651b1d3011$export$da489f084fc70d3a = {
    displayName: 'Gong',
    id: 'gong',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Gong,
    icon: (0, $i52Hf.get3PLogo)((0, $gkMkb.GongIcon), 'Gong', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $gkMkb.GongSearchResultIcon), 'Gong', 'large'),
    integrationAri: 'ari:cloud:platform::integration/gong',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["gongConfig"] = $cd6088651b1d3011$export$da489f084fc70d3a;

});

parcelRegister("gkMkb", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $46f3e375cd9453c4$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6pBWK")).then((m)=>m.GongIcon), {
    moduleId: '@atlassian/logo-third-party/gong'
});

const $46f3e375cd9453c4$var$LazyGongIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1AiKZ")).then((m)=>m.GongIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gong/icon'
});

const $46f3e375cd9453c4$var$LazyGongSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1W2a0")).then((m)=>m.GongSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gong/search-result-icon'
});
const $46f3e375cd9453c4$export$81a901141c7fd09d = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46f3e375cd9453c4$var$LazyGongIconComponent, null)), $46f3e375cd9453c4$var$OfficialIcon, 'small');
const $46f3e375cd9453c4$export$f1670de5ba3e94b4 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46f3e375cd9453c4$var$LazyGongSearchResultIconComponent, null)), $46f3e375cd9453c4$var$OfficialIcon, 'medium');
module.exports["GongIcon"] = $46f3e375cd9453c4$export$81a901141c7fd09d;
module.exports["GongSearchResultIcon"] = $46f3e375cd9453c4$export$f1670de5ba3e94b4;

});

parcelRegister("6pBWK", function(module, exports) {

let $4ab28342f43aa805$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ab28342f43aa805$var$load("4daxi").then(()=>parcelRequire('8DzYI'));

});

parcelRegister("1AiKZ", function(module, exports) {

let $1277b3fb732798dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1277b3fb732798dd$var$load("1GQMk").then(()=>parcelRequire('bkQed'));

});

parcelRegister("1W2a0", function(module, exports) {

let $168ce23c4db71f08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $168ce23c4db71f08$var$load("5lziI").then(()=>parcelRequire('leql4'));

});

parcelRegister("itpo2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::403d648a4ec6dc7540968c496b0b831a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d72ea0b312f9d00a$var$_react = $d72ea0b312f9d00a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d72ea0b312f9d00a$var$_iconNew = $d72ea0b312f9d00a$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $d72ea0b312f9d00a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/dashboard
 * Usage guidance:
 * Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d72ea0b312f9d00a$var$DashboardIcon = (props)=>/*#__PURE__*/ $d72ea0b312f9d00a$var$_react.default.createElement($d72ea0b312f9d00a$var$_iconNew.default, Object.assign({
        name: "DashboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.25v-11zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$d72ea0b312f9d00a$var$DashboardIcon.displayName = 'DashboardIcon';
var $d72ea0b312f9d00a$var$_default = module.exports.default = $d72ea0b312f9d00a$var$DashboardIcon;

});

parcelRegister("4MnFz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iXRmn = parcelRequire("iXRmn");

const $878d7a55fd1744f7$export$2879604e6aec4ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
module.exports["useFlags"] = $878d7a55fd1744f7$export$2879604e6aec4ab;

});

parcelRegister("hQVHS", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $87b9bf478c0c1673$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>
</svg>
`;
const $87b9bf478c0c1673$export$5ed3e1bb3b04fc02 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProjectsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Projects" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $87b9bf478c0c1673$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function ProjectsIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Projects', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $87b9bf478c0c1673$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["ProjectsIcon"] = $87b9bf478c0c1673$export$5ed3e1bb3b04fc02;

});

parcelRegister("dqxOF", function(module, exports) {
function $9c67ef4150ae4cb3$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $9c67ef4150ae4cb3$export$967a6b9924a689f7(a, b);
    return $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(a, b);
}
 //# sourceMappingURL=index.modern.mjs.map
module.exports["shallowEqualObjects"] = $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c;

});

parcelRegister("dDboE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");

const $92e077c22efcc597$export$6be90bcb437e928f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${(0, $6JrSr.useId)()}${postfix}`;
    (0, $cozmU.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
module.exports["IdProvider"] = $92e077c22efcc597$export$6be90bcb437e928f;

});

parcelRegister("1TlML", function(module, exports) {
function $cc70dd2ba0f00d0d$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
module.exports["mergeStyles"] = $cc70dd2ba0f00d0d$export$e618dc39ac9ad607;

});

parcelRegister("1Ltep", function(module, exports) {
$parcel$export(module.exports, "default", () => $1490daf4e920e8da$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $1490daf4e920e8da$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("2iY37", function(module, exports) {
$parcel$export(module.exports, "default", () => $1adbd7c5d1b8dbaa$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $1Ltep = parcelRequire("1Ltep");


var $WeoLw = parcelRequire("WeoLw");


var $3yGK6 = parcelRequire("3yGK6");

function $1adbd7c5d1b8dbaa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    return (0, $1Ltep.default)(date).getTime() === (0, $WeoLw.default)(date).getTime();
}

});

parcelRegister("WeoLw", function(module, exports) {
$parcel$export(module.exports, "default", () => $0af0962005736f62$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0af0962005736f62$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("k5sGX", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9fa87e3de3aa88c$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $e9fa87e3de3aa88c$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $3yGK6.default)(1, arguments);
    var additionalDigits = (0, $kr6hK.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $e9fa87e3de3aa88c$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $e9fa87e3de3aa88c$var$parseYear(dateStrings.date, additionalDigits);
        date = $e9fa87e3de3aa88c$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $e9fa87e3de3aa88c$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $e9fa87e3de3aa88c$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $e9fa87e3de3aa88c$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $e9fa87e3de3aa88c$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $e9fa87e3de3aa88c$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $e9fa87e3de3aa88c$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $e9fa87e3de3aa88c$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($e9fa87e3de3aa88c$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($e9fa87e3de3aa88c$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($e9fa87e3de3aa88c$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $e9fa87e3de3aa88c$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $e9fa87e3de3aa88c$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $e9fa87e3de3aa88c$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($e9fa87e3de3aa88c$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $e9fa87e3de3aa88c$var$parseDateUnit(captures[1]);
    var month = $e9fa87e3de3aa88c$var$parseDateUnit(captures[2]) - 1;
    var day = $e9fa87e3de3aa88c$var$parseDateUnit(captures[3]);
    var week = $e9fa87e3de3aa88c$var$parseDateUnit(captures[4]);
    var dayOfWeek = $e9fa87e3de3aa88c$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$e9fa87e3de3aa88c$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $e9fa87e3de3aa88c$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$e9fa87e3de3aa88c$var$validateDate(year, month, day) || !$e9fa87e3de3aa88c$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $e9fa87e3de3aa88c$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $e9fa87e3de3aa88c$var$parseTime(timeString) {
    var captures = timeString.match($e9fa87e3de3aa88c$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[1]);
    var minutes = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[2]);
    var seconds = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[3]);
    if (!$e9fa87e3de3aa88c$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute) + seconds * 1000;
}
function $e9fa87e3de3aa88c$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $e9fa87e3de3aa88c$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($e9fa87e3de3aa88c$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$e9fa87e3de3aa88c$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute));
}
function $e9fa87e3de3aa88c$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $e9fa87e3de3aa88c$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $e9fa87e3de3aa88c$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $e9fa87e3de3aa88c$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($e9fa87e3de3aa88c$var$daysInMonths[month] || ($e9fa87e3de3aa88c$var$isLeapYearIndex(year) ? 29 : 28));
}
function $e9fa87e3de3aa88c$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($e9fa87e3de3aa88c$var$isLeapYearIndex(year) ? 366 : 365);
}
function $e9fa87e3de3aa88c$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $e9fa87e3de3aa88c$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $e9fa87e3de3aa88c$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jO73f", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e6b828148d99ab2b$export$dfd9b671c89acc8e = 7;
var $e6b828148d99ab2b$export$3913210603d8e9ae = 365.2425;
var $e6b828148d99ab2b$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e6b828148d99ab2b$export$91246f0b9bd9beff = 60000;
var $e6b828148d99ab2b$export$7f72910d6dfd237a = 3600000;
var $e6b828148d99ab2b$export$397c2d5776aa9055 = 1000;
var $e6b828148d99ab2b$export$4dec998e48f9c246 = -$e6b828148d99ab2b$export$81caae6e1cc7a622;
var $e6b828148d99ab2b$export$f2f5ae5a8e2d8f9f = 60;
var $e6b828148d99ab2b$export$3c58128db900d44e = 3;
var $e6b828148d99ab2b$export$80d7e435f744f319 = 12;
var $e6b828148d99ab2b$export$4db7641526e3241f = 4;
var $e6b828148d99ab2b$export$698aec755e92c695 = 3600;
var $e6b828148d99ab2b$export$a77c1a7ebebe2a5a = 60;
var $e6b828148d99ab2b$export$815a9362476d2fe3 = $e6b828148d99ab2b$export$698aec755e92c695 * 24;
var $e6b828148d99ab2b$export$34804a017b31e2fe = $e6b828148d99ab2b$export$815a9362476d2fe3 * 7;
var $e6b828148d99ab2b$export$7271e9e3478110d1 = $e6b828148d99ab2b$export$815a9362476d2fe3 * $e6b828148d99ab2b$export$3913210603d8e9ae;
var $e6b828148d99ab2b$export$8e6600bbdee7dabb = $e6b828148d99ab2b$export$7271e9e3478110d1 / 12;
var $e6b828148d99ab2b$export$be1dccf2de902d31 = $e6b828148d99ab2b$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e6b828148d99ab2b$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e6b828148d99ab2b$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e6b828148d99ab2b$export$397c2d5776aa9055;

});

parcelRegister("2Xb4T", function(module, exports) {
'use strict';

var $2269af4a175bb16e$var$hasToStringTag = (parcelRequire("DVsRa"))();

var $2BPyg = parcelRequire("2BPyg");

var $2269af4a175bb16e$var$$toString = $2BPyg('Object.prototype.toString');
var $2269af4a175bb16e$var$isStandardArguments = function isArguments(value) {
    if ($2269af4a175bb16e$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $2269af4a175bb16e$var$$toString(value) === '[object Arguments]';
};
var $2269af4a175bb16e$var$isLegacyArguments = function isArguments(value) {
    if ($2269af4a175bb16e$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $2269af4a175bb16e$var$$toString(value) !== '[object Array]' && $2269af4a175bb16e$var$$toString(value.callee) === '[object Function]';
};
var $2269af4a175bb16e$var$supportsStandardArguments = function() {
    return $2269af4a175bb16e$var$isStandardArguments(arguments);
}();
$2269af4a175bb16e$var$isStandardArguments.isLegacyArguments = $2269af4a175bb16e$var$isLegacyArguments; // for tests
module.exports = $2269af4a175bb16e$var$supportsStandardArguments ? $2269af4a175bb16e$var$isStandardArguments : $2269af4a175bb16e$var$isLegacyArguments;

});

parcelRegister("2BPyg", function(module, exports) {
'use strict';

var $cAbhD = parcelRequire("cAbhD");


var $26J2z = parcelRequire("26J2z");

var $1e670692988d4e8b$var$$indexOf = $26J2z($cAbhD('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $cAbhD(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $1e670692988d4e8b$var$$indexOf(name, '.prototype.') > -1) return $26J2z(intrinsic);
    return intrinsic;
};

});

parcelRegister("2aMTq", function(module, exports) {
'use strict';
var $19527114ab6c974a$var$slice = Array.prototype.slice;

var $9QzFm = parcelRequire("9QzFm");

var $19527114ab6c974a$var$origKeys = Object.keys;

var $19527114ab6c974a$var$keysShim = $19527114ab6c974a$var$origKeys ? function keys(o) {
    return $19527114ab6c974a$var$origKeys(o);
} : (parcelRequire("6NXwY"));
var $19527114ab6c974a$var$originalKeys = Object.keys;
$19527114ab6c974a$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($9QzFm(object)) return $19527114ab6c974a$var$originalKeys($19527114ab6c974a$var$slice.call(object));
            return $19527114ab6c974a$var$originalKeys(object);
        };
    } else Object.keys = $19527114ab6c974a$var$keysShim;
    return Object.keys || $19527114ab6c974a$var$keysShim;
};
module.exports = $19527114ab6c974a$var$keysShim;

});

parcelRegister("9QzFm", function(module, exports) {
'use strict';
var $72b4a2f3cb441a79$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $72b4a2f3cb441a79$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $72b4a2f3cb441a79$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("6NXwY", function(module, exports) {
'use strict';
var $4f457f4760cceef9$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $4f457f4760cceef9$var$has = Object.prototype.hasOwnProperty;
    var $4f457f4760cceef9$var$toStr = Object.prototype.toString;
    var $4f457f4760cceef9$var$isArgs = (parcelRequire("9QzFm")); // eslint-disable-line global-require
    var $4f457f4760cceef9$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $4f457f4760cceef9$var$hasDontEnumBug = !$4f457f4760cceef9$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $4f457f4760cceef9$var$hasProtoEnumBug = $4f457f4760cceef9$var$isEnumerable.call(function() {}, 'prototype');
    var $4f457f4760cceef9$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $4f457f4760cceef9$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $4f457f4760cceef9$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $4f457f4760cceef9$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$4f457f4760cceef9$var$excludedKeys['$' + k] && $4f457f4760cceef9$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $4f457f4760cceef9$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $4f457f4760cceef9$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$4f457f4760cceef9$var$hasAutomationEqualityBug) return $4f457f4760cceef9$var$equalsConstructorPrototype(o);
        try {
            return $4f457f4760cceef9$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $4f457f4760cceef9$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $4f457f4760cceef9$var$toStr.call(object) === '[object Function]';
        var isArguments = $4f457f4760cceef9$var$isArgs(object);
        var isString = isObject && $4f457f4760cceef9$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $4f457f4760cceef9$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$4f457f4760cceef9$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $4f457f4760cceef9$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($4f457f4760cceef9$var$hasDontEnumBug) {
            var skipConstructor = $4f457f4760cceef9$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $4f457f4760cceef9$var$dontEnums.length; ++k)if (!(skipConstructor && $4f457f4760cceef9$var$dontEnums[k] === 'constructor') && $4f457f4760cceef9$var$has.call(object, $4f457f4760cceef9$var$dontEnums[k])) theKeys.push($4f457f4760cceef9$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $4f457f4760cceef9$var$keysShim;

});

parcelRegister("aKQxr", function(module, exports) {
'use strict';

var $iZo8r = parcelRequire("iZo8r");

module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $iZo8r;
};

});

parcelRegister("iZo8r", function(module, exports) {
'use strict';
var $dd30a53fbc79558f$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($dd30a53fbc79558f$var$numberIsNaN(a) && $dd30a53fbc79558f$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("29nQp", function(module, exports) {
'use strict';

var $eGbn7 = parcelRequire("eGbn7");


var $26J2z = parcelRequire("26J2z");


var $iZo8r = parcelRequire("iZo8r");


var $aKQxr = parcelRequire("aKQxr");


var $h9z8p = parcelRequire("h9z8p");

var $190eeb03c4f85517$var$polyfill = $26J2z($aKQxr(), Object);
$eGbn7($190eeb03c4f85517$var$polyfill, {
    getPolyfill: $aKQxr,
    implementation: $iZo8r,
    shim: $h9z8p
});
module.exports = $190eeb03c4f85517$var$polyfill;

});

parcelRegister("eGbn7", function(module, exports) {
'use strict';

var $2aMTq = parcelRequire("2aMTq");

var $aafdcf22e1319c4a$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $aafdcf22e1319c4a$var$toStr = Object.prototype.toString;
var $aafdcf22e1319c4a$var$concat = Array.prototype.concat;

var $iFj39 = parcelRequire("iFj39");

var $aafdcf22e1319c4a$var$isFunction = function(fn) {
    return typeof fn === 'function' && $aafdcf22e1319c4a$var$toStr.call(fn) === '[object Function]';
};

var $aafdcf22e1319c4a$var$supportsDescriptors = (parcelRequire("9CFxa"))();
var $aafdcf22e1319c4a$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$aafdcf22e1319c4a$var$isFunction(predicate) || !predicate()) return;
    }
    if ($aafdcf22e1319c4a$var$supportsDescriptors) $iFj39(object, name, value, true);
    else $iFj39(object, name, value);
};
var $aafdcf22e1319c4a$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $2aMTq(map);
    if ($aafdcf22e1319c4a$var$hasSymbols) props = $aafdcf22e1319c4a$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$aafdcf22e1319c4a$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$aafdcf22e1319c4a$var$defineProperties.supportsDescriptors = !!$aafdcf22e1319c4a$var$supportsDescriptors;
module.exports = $aafdcf22e1319c4a$var$defineProperties;

});

parcelRegister("h9z8p", function(module, exports) {
'use strict';

var $aKQxr = parcelRequire("aKQxr");


var $eGbn7 = parcelRequire("eGbn7");

module.exports = function shimObjectIs() {
    var polyfill = $aKQxr();
    $eGbn7(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});

parcelRegister("6vPLm", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $83056c684d55bb4d$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"/>
</svg>
`;
const $83056c684d55bb4d$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729"/>
</svg>
`;
const $83056c684d55bb4d$export$d89497e7f33ca6f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AssetsIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Assets" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $83056c684d55bb4d$var$svg,
            customThemeSvg: $83056c684d55bb4d$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            isAssets: true,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function AssetsIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Assets', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $83056c684d55bb4d$var$svg,
        customThemeSvg: $83056c684d55bb4d$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["AssetsIcon"] = $83056c684d55bb4d$export$d89497e7f33ca6f5;

});

parcelRegister("jg98Q", function(module, exports) {

var $2aMTq = parcelRequire("2aMTq");


var $2Xb4T = parcelRequire("2Xb4T");


var $29nQp = parcelRequire("29nQp");


var $fzJ6O = parcelRequire("fzJ6O");


var $kORU3 = parcelRequire("kORU3");


var $ejReL = parcelRequire("ejReL");

var $e0569a4986fb9bed$var$getTime = Date.prototype.getTime;
function $e0569a4986fb9bed$var$deepEqual(actual, expected, options) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? $29nQp(actual, expected) : actual === expected) return true;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') return opts.strict ? $29nQp(actual, expected) : actual == expected;
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // eslint-disable-next-line no-use-before-define
    return $e0569a4986fb9bed$var$objEquiv(actual, expected, opts);
}
function $e0569a4986fb9bed$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $e0569a4986fb9bed$var$isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $e0569a4986fb9bed$var$objEquiv(a, b, opts) {
    /* eslint max-statements: [2, 50] */ var i, key;
    if (typeof a !== typeof b) return false;
    if ($e0569a4986fb9bed$var$isUndefinedOrNull(a) || $e0569a4986fb9bed$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    if ($2Xb4T(a) !== $2Xb4T(b)) return false;
    var aIsRegex = $fzJ6O(a);
    var bIsRegex = $fzJ6O(b);
    if (aIsRegex !== bIsRegex) return false;
    if (aIsRegex || bIsRegex) return a.source === b.source && $kORU3(a) === $kORU3(b);
    if ($ejReL(a) && $ejReL(b)) return $e0569a4986fb9bed$var$getTime.call(a) === $e0569a4986fb9bed$var$getTime.call(b);
    var aIsBuffer = $e0569a4986fb9bed$var$isBuffer(a);
    var bIsBuffer = $e0569a4986fb9bed$var$isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    if (typeof a !== typeof b) return false;
    try {
        var ka = $2aMTq(a);
        var kb = $2aMTq(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$e0569a4986fb9bed$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return true;
}
module.exports = $e0569a4986fb9bed$var$deepEqual;

});

parcelRegister("fzJ6O", function(module, exports) {
'use strict';

var $blqMe = parcelRequire("blqMe");


var $b56d1d94960f1e28$var$hasToStringTag = (parcelRequire("DVsRa"))();

var $ajrtq = parcelRequire("ajrtq");


var $i6XCs = parcelRequire("i6XCs");

/** @type {import('.')} */ var $b56d1d94960f1e28$var$fn;
if ($b56d1d94960f1e28$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $b56d1d94960f1e28$var$$exec = $blqMe('RegExp.prototype.exec');
    /** @type {object} */ var $b56d1d94960f1e28$var$isRegexMarker = {};
    var $b56d1d94960f1e28$var$throwRegexMarker = function() {
        throw $b56d1d94960f1e28$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $b56d1d94960f1e28$var$badStringifier = {
        toString: $b56d1d94960f1e28$var$throwRegexMarker,
        valueOf: $b56d1d94960f1e28$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $b56d1d94960f1e28$var$badStringifier[Symbol.toPrimitive] = $b56d1d94960f1e28$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $b56d1d94960f1e28$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $i6XCs(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $ajrtq(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $b56d1d94960f1e28$var$$exec(value, /** @type {unknown} */ $b56d1d94960f1e28$var$badStringifier);
        } catch (e) {
            return e === $b56d1d94960f1e28$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $b56d1d94960f1e28$var$$toString = $blqMe('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $b56d1d94960f1e28$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $b56d1d94960f1e28$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $b56d1d94960f1e28$var$$toString(value) === $b56d1d94960f1e28$var$regexClass;
    };
}
module.exports = $b56d1d94960f1e28$var$fn;

});

parcelRegister("kORU3", function(module, exports) {
'use strict';

var $eGbn7 = parcelRequire("eGbn7");


var $26J2z = parcelRequire("26J2z");


var $c0iPD = parcelRequire("c0iPD");


var $fBecP = parcelRequire("fBecP");


var $hYwLZ = parcelRequire("hYwLZ");

var $f2824a3758370aa3$var$flagsBound = $26J2z($fBecP());
$eGbn7($f2824a3758370aa3$var$flagsBound, {
    getPolyfill: $fBecP,
    implementation: $c0iPD,
    shim: $hYwLZ
});
module.exports = $f2824a3758370aa3$var$flagsBound;

});

parcelRegister("c0iPD", function(module, exports) {
'use strict';

var $aSUWA = parcelRequire("aSUWA");


var $bRQLx = parcelRequire("bRQLx");

var $8bd417bd9a9fdae1$var$$Object = Object;
module.exports = $aSUWA(function flags() {
    if (this == null || this !== $8bd417bd9a9fdae1$var$$Object(this)) throw new $bRQLx('RegExp.prototype.flags getter called on non-object');
    var result = '';
    if (this.hasIndices) result += 'd';
    if (this.global) result += 'g';
    if (this.ignoreCase) result += 'i';
    if (this.multiline) result += 'm';
    if (this.dotAll) result += 's';
    if (this.unicode) result += 'u';
    if (this.unicodeSets) result += 'v';
    if (this.sticky) result += 'y';
    return result;
}, 'get flags', true);

});

parcelRegister("aSUWA", function(module, exports) {
'use strict';

var $iFj39 = parcelRequire("iFj39");


var $7ecb1e67e67f53fe$var$hasDescriptors = (parcelRequire("9CFxa"))();

var $7ecb1e67e67f53fe$var$functionsHaveConfigurableNames = (parcelRequire("bb0EK")).functionsHaveConfigurableNames();

var $bRQLx = parcelRequire("bRQLx");

/** @type {import('.')} */ module.exports = function setFunctionName(fn, name) {
    if (typeof fn !== 'function') throw new $bRQLx('`fn` is not a function');
    var loose = arguments.length > 2 && !!arguments[2];
    if (!loose || $7ecb1e67e67f53fe$var$functionsHaveConfigurableNames) {
        if ($7ecb1e67e67f53fe$var$hasDescriptors) $iFj39(/** @type {Parameters<define>[0]} */ fn, 'name', name, true, true);
        else $iFj39(/** @type {Parameters<define>[0]} */ fn, 'name', name);
    }
    return fn;
};

});

parcelRegister("bb0EK", function(module, exports) {
'use strict';
var $82313b16d9fa3696$var$functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === 'string';
};
var $82313b16d9fa3696$var$gOPD = Object.getOwnPropertyDescriptor;
if ($82313b16d9fa3696$var$gOPD) try {
    $82313b16d9fa3696$var$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $82313b16d9fa3696$var$gOPD = null;
}
$82313b16d9fa3696$var$functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!$82313b16d9fa3696$var$functionsHaveNames() || !$82313b16d9fa3696$var$gOPD) return false;
    var desc = $82313b16d9fa3696$var$gOPD(function() {}, 'name');
    return !!desc && !!desc.configurable;
};
var $82313b16d9fa3696$var$$bind = Function.prototype.bind;
$82313b16d9fa3696$var$functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return $82313b16d9fa3696$var$functionsHaveNames() && typeof $82313b16d9fa3696$var$$bind === 'function' && (function f() {}).bind().name !== '';
};
module.exports = $82313b16d9fa3696$var$functionsHaveNames;

});

parcelRegister("fBecP", function(module, exports) {
'use strict';

var $c0iPD = parcelRequire("c0iPD");


var $eGbn7 = parcelRequire("eGbn7");

var $b5b554b7f595cb65$require$supportsDescriptors = $eGbn7.supportsDescriptors;
var $b5b554b7f595cb65$var$$gOPD = Object.getOwnPropertyDescriptor;
module.exports = function getPolyfill() {
    if ($b5b554b7f595cb65$require$supportsDescriptors && /a/mig.flags === 'gim') {
        var descriptor = $b5b554b7f595cb65$var$$gOPD(RegExp.prototype, 'flags');
        if (descriptor && typeof descriptor.get === 'function' && 'dotAll' in RegExp.prototype && 'hasIndices' in RegExp.prototype) {
            /* eslint getter-return: 0 */ var calls = '';
            var o = {};
            Object.defineProperty(o, 'hasIndices', {
                get: function() {
                    calls += 'd';
                }
            });
            Object.defineProperty(o, 'sticky', {
                get: function() {
                    calls += 'y';
                }
            });
            descriptor.get.call(o);
            if (calls === 'dy') return descriptor.get;
        }
    }
    return $c0iPD;
};

});

parcelRegister("hYwLZ", function(module, exports) {
'use strict';

var $eGbn7 = parcelRequire("eGbn7");

var $d161764a3ad06cf4$require$supportsDescriptors = $eGbn7.supportsDescriptors;

var $fBecP = parcelRequire("fBecP");


var $i6XCs = parcelRequire("i6XCs");

var $d161764a3ad06cf4$var$defineProperty = Object.defineProperty;

var $gv9mB = parcelRequire("gv9mB");


var $eO0yE = parcelRequire("eO0yE");

var $d161764a3ad06cf4$var$regex = /a/;
module.exports = function shimFlags() {
    if (!$d161764a3ad06cf4$require$supportsDescriptors || !$eO0yE) throw new $gv9mB('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
    var polyfill = $fBecP();
    var proto = $eO0yE($d161764a3ad06cf4$var$regex);
    var descriptor = $i6XCs(proto, 'flags');
    if (!descriptor || descriptor.get !== polyfill) $d161764a3ad06cf4$var$defineProperty(proto, 'flags', {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};

});

parcelRegister("ejReL", function(module, exports) {
'use strict';

var $blqMe = parcelRequire("blqMe");

var $a6cc22d1603d27aa$var$getDay = $blqMe('Date.prototype.getDay');
/** @type {import('.')} */ var $a6cc22d1603d27aa$var$tryDateObject = function tryDateGetDayCall(value) {
    try {
        $a6cc22d1603d27aa$var$getDay(value);
        return true;
    } catch (e) {
        return false;
    }
};
/** @type {(value: unknown) => string} */ var $a6cc22d1603d27aa$var$toStr = $blqMe('Object.prototype.toString');
var $a6cc22d1603d27aa$var$dateClass = '[object Date]';

var $a6cc22d1603d27aa$var$hasToStringTag = (parcelRequire("DVsRa"))();
/** @type {import('.')} */ module.exports = function isDateObject(value) {
    if (typeof value !== 'object' || value === null) return false;
    return $a6cc22d1603d27aa$var$hasToStringTag ? $a6cc22d1603d27aa$var$tryDateObject(value) : $a6cc22d1603d27aa$var$toStr(value) === $a6cc22d1603d27aa$var$dateClass;
};

});

parcelRegister("jgqX6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0646b18c90b3a18$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3c3I9 = parcelRequire("3c3I9");


var $eYSi7 = parcelRequire("eYSi7");


var $3yGK6 = parcelRequire("3yGK6");


var $2iY37 = parcelRequire("2iY37");

function $e0646b18c90b3a18$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var sign = (0, $eYSi7.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $3c3I9.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $eYSi7.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $2iY37.default)((0, $dkBOe.default)(dirtyDateLeft)) && difference === 1 && (0, $eYSi7.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("3c3I9", function(module, exports) {
$parcel$export(module.exports, "default", () => $25355f04f79cc351$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $25355f04f79cc351$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("eYSi7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae80c86a80ef7d08$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $ae80c86a80ef7d08$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("2aija", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $1tDzb = parcelRequire("1tDzb");


var $gP9iN = parcelRequire("gP9iN");


var $hgbrK = parcelRequire("hgbrK");

const $97165e869498f5e6$var$hideAboveQueries = (0, $gP9iN.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $97165e869498f5e6$var$hideBelowQueries = (0, $hgbrK.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $97165e869498f5e6$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1tDzb.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $lOiVq.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $97165e869498f5e6$var$hideAboveQueries[above],
            below && $97165e869498f5e6$var$hideBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
module.exports["Hide"] = $97165e869498f5e6$export$bed28288a051538;

});

parcelRegister("dL3KD", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $b10ebbefbae983ec$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z"/>
</svg>
`;
const $b10ebbefbae983ec$export$1e02e7298035a77c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FocusIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Focus" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $b10ebbefbae983ec$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function FocusIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Focus', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $b10ebbefbae983ec$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["FocusIcon"] = $b10ebbefbae983ec$export$1e02e7298035a77c;

});

parcelRegister("33FWk", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $9f7a3b7caba550ed$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>
</svg>
`;
const $9f7a3b7caba550ed$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>
</svg>
`;
const $9f7a3b7caba550ed$export$21bfbeb62fdcce8d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function JiraProductDiscoveryIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Jira Product Discovery" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $9f7a3b7caba550ed$var$svg,
            customThemeSvg: $9f7a3b7caba550ed$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function JiraProductDiscoveryIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Product Discovery', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $9f7a3b7caba550ed$var$svg,
        customThemeSvg: $9f7a3b7caba550ed$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["JiraProductDiscoveryIcon"] = $9f7a3b7caba550ed$export$21bfbeb62fdcce8d;

});

parcelRegister("hupj2", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $fb0eeb73da830bbb$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786" clip-rule="evenodd"/>
</svg>
`;
const $fb0eeb73da830bbb$export$4b05688514531169 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TalentIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Talent" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $fb0eeb73da830bbb$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function TalentIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Talent', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $fb0eeb73da830bbb$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["TalentIcon"] = $fb0eeb73da830bbb$export$4b05688514531169;

});

parcelRegister("2UMCh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hp074 = parcelRequire("hp074");

const $21f685ebe54e3804$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    getArtifact: null
});
function $21f685ebe54e3804$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return new (0, $hp074.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            },
            expiryMS: config === null || config === void 0 ? void 0 : config.artifactExpiryMS
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21f685ebe54e3804$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $21f685ebe54e3804$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($21f685ebe54e3804$export$ca1b33377afa620);
function $21f685ebe54e3804$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    const { getArtifact: getArtifact } = $21f685ebe54e3804$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}
module.exports["FlightDeckProvider"] = $21f685ebe54e3804$export$56da85ac9d40dbcd;
module.exports["useFlightDeckContext"] = $21f685ebe54e3804$export$73c96350a5e69ec;
module.exports["useFlightDeckArtifact"] = $21f685ebe54e3804$export$3b241cde208d2c5e;

});

parcelRegister("bg9GW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8328b4ddc95230a8$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $g93kp = parcelRequire("g93kp");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $8328b4ddc95230a8$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $g93kp.default)(dateLeft, dateRight) / (0, $jO73f.millisecondsInHour);
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("g93kp", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc101184c63d7a7a$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $bc101184c63d7a7a$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $3yGK6.default)(2, arguments);
    return (0, $dkBOe.default)(dateLeft).getTime() - (0, $dkBOe.default)(dateRight).getTime();
}

});

parcelRegister("byLBW", function(module, exports) {
var $86a7cd36e9b99950$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $86a7cd36e9b99950$var$defaultRoundingMethod = 'trunc';
function $86a7cd36e9b99950$export$b6474a47258c1211(method) {
    return method ? $86a7cd36e9b99950$var$roundingMap[method] : $86a7cd36e9b99950$var$roundingMap[$86a7cd36e9b99950$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $86a7cd36e9b99950$export$b6474a47258c1211;

});

parcelRegister("fNtG8", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8027429ed7dcbe2$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $g93kp = parcelRequire("g93kp");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $b8027429ed7dcbe2$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $g93kp.default)(dateLeft, dateRight) / (0, $jO73f.millisecondsInMinute);
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("1xxT0", function(module, exports) {
$parcel$export(module.exports, "default", () => $11f3289e9f8e4176$export$2e2bcd8739ae039);

var $gkHoc = parcelRequire("gkHoc");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $11f3289e9f8e4176$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    return (0, $gkHoc.default)(dirtyDate, -amount);
}

});

parcelRegister("P1m33", function(module, exports) {
$parcel$export(module.exports, "default", () => $0995d08896a40d30$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $3jKk3 = parcelRequire("3jKk3");


var $3yGK6 = parcelRequire("3yGK6");

function $0995d08896a40d30$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    return (0, $3jKk3.default)(dirtyDate, -amount);
}

});

parcelRegister("3jKk3", function(module, exports) {
$parcel$export(module.exports, "default", () => $26a7141bcda1f520$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $gkHoc = parcelRequire("gkHoc");


var $3yGK6 = parcelRequire("3yGK6");

function $26a7141bcda1f520$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $gkHoc.default)(dirtyDate, days);
}

});

parcelRegister("2qJQZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hMaHH = parcelRequire("hMaHH");


var $4hmAW = parcelRequire("4hmAW");

const $f3e0d6c6400f29a4$var$PageObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageObject({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $f3e0d6c6400f29a4$export$2e2bcd8739ae039 = $f3e0d6c6400f29a4$var$PageObject;
module.exports["default"] = $f3e0d6c6400f29a4$export$2e2bcd8739ae039;

});

parcelRegister("lFTzz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $824lD = parcelRequire("824lD");


var $4hmAW = parcelRequire("4hmAW");

const $1365dcd1e56867c4$var$CalendarObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CalendarObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Calendar" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($824lD))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CalendarObject({ label: label = 'Calendar', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($824lD))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $1365dcd1e56867c4$export$2e2bcd8739ae039 = $1365dcd1e56867c4$var$CalendarObject;
module.exports["default"] = $1365dcd1e56867c4$export$2e2bcd8739ae039;

});

parcelRegister("hkAs2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lBKFk = parcelRequire("lBKFk");


var $4hmAW = parcelRequire("4hmAW");

const $a395f01d1124dfc4$var$DatabaseObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DatabaseObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Database" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function DatabaseObject({ label: label = 'Database', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $a395f01d1124dfc4$export$2e2bcd8739ae039 = $a395f01d1124dfc4$var$DatabaseObject;
module.exports["default"] = $a395f01d1124dfc4$export$2e2bcd8739ae039;

});

parcelRegister("aKhvB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kyJuy = parcelRequire("kyJuy");


var $4hmAW = parcelRequire("4hmAW");

const $0e81307ff604f35e$var$QuestionObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function QuestionObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Question" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function QuestionObject({ label: label = 'Question', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $0e81307ff604f35e$export$2e2bcd8739ae039 = $0e81307ff604f35e$var$QuestionObject;
module.exports["default"] = $0e81307ff604f35e$export$2e2bcd8739ae039;

});

parcelRegister("dt415", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $bDjVc = parcelRequire("bDjVc");


var $4hmAW = parcelRequire("4hmAW");

const $a250350db8bca8ef$var$WhiteboardObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WhiteboardObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Whiteboard" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
            color: "var(--ds-icon-accent-teal, #2898BD)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WhiteboardObject({ label: label = 'Whiteboard', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        color: "var(--ds-icon-accent-teal, #2898BD)"
    });
};
var $a250350db8bca8ef$export$2e2bcd8739ae039 = $a250350db8bca8ef$var$WhiteboardObject;
module.exports["default"] = $a250350db8bca8ef$export$2e2bcd8739ae039;

});

parcelRegister("fCd3b", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");


var $iVNH5 = parcelRequire("iVNH5");

const $a663f43e8e7364a7$var$MAX_SITES_INITIAL_QUERY = 3;
const $a663f43e8e7364a7$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $a663f43e8e7364a7$var$MAX_SITES_INITIAL_QUERY);
};
class $a663f43e8e7364a7$var$AggregatorClient {
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($a663f43e8e7364a7$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $a663f43e8e7364a7$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $iVNH5.timed)(this.makePostRequest($a663f43e8e7364a7$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $gABt9.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
$a663f43e8e7364a7$var$AggregatorClient.QUICKSEARCH_API_URL = 'quicksearch/v1';
$a663f43e8e7364a7$var$AggregatorClient.AUTO_CORRECT_API_URL = 'autocorrect';
const $a663f43e8e7364a7$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $a663f43e8e7364a7$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};
module.exports["createClient"] = $a663f43e8e7364a7$export$5d730b7aed1a3eb0;

});

parcelRegister("iVNH5", function(module, exports) {
const $7a547b1e741af2d7$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};
module.exports["timed"] = $7a547b1e741af2d7$export$d35186a762cd39c8;

});

parcelRegister("6Zvcd", function(module, exports) {
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $2f98cc823dddcacd$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $2f98cc823dddcacd$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $2f98cc823dddcacd$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $2f98cc823dddcacd$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $2f98cc823dddcacd$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});
module.exports["Scope"] = $2f98cc823dddcacd$export$775b6bb06e53a214;

});

parcelRegister("j5Usq", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $697023b8b47eb551$export$69a3209f1a06c04d = (0, $bHHWv.inMemoryCache)();
const $697023b8b47eb551$var$GQL_OPERATION_NAME = 'SearchPageUserQuery';
const $697023b8b47eb551$var$getUserQuery = ()=>`
query ${$697023b8b47eb551$var$GQL_OPERATION_NAME}($accountId: ID!) {
  user(accountId: $accountId) {
    id
    accountId
    name
    picture
  }
}
`;
const $697023b8b47eb551$export$25f4d46d5dabadfc = (accountId, headers)=>{
    return $697023b8b47eb551$export$69a3209f1a06c04d.inMemoryDecorator(accountId, async ()=>{
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $697023b8b47eb551$var$getUserQuery(),
            variables: {
                accountId: accountId
            },
            operationName: $697023b8b47eb551$var$GQL_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
const $697023b8b47eb551$export$c3d7afa7f49d431e = (0, $bHHWv.inMemoryCache)();
const $697023b8b47eb551$var$GQL_USERS_OPERATION_NAME = 'SearchPageUsersQuery';
const $697023b8b47eb551$var$getUsersQuery = ()=>`
query ${$697023b8b47eb551$var$GQL_USERS_OPERATION_NAME}($accountIds: [ID!]!) {
  users(accountIds: $accountIds) {
    id
    name
    picture
    accountId
  }
}
`;
const $697023b8b47eb551$export$ef7fb495aeba8901 = (accountIds, headers)=>{
    return $697023b8b47eb551$export$c3d7afa7f49d431e.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per user id
    accountIds.join(','), async ()=>{
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $697023b8b47eb551$var$getUsersQuery(),
            variables: {
                accountIds: accountIds
            },
            operationName: $697023b8b47eb551$var$GQL_USERS_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["usersQuery"] = $697023b8b47eb551$export$ef7fb495aeba8901;

});

parcelRegister("6yWnN", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bZF61 = parcelRequire("bZF61");


var $bHHWv = parcelRequire("bHHWv");

const $8bbf0973c124500e$var$operationName = 'FPSConfluenceSmartUsersQuery';
const $8bbf0973c124500e$var$SmartsRecommendedUserQuery = `
query ${$8bbf0973c124500e$var$operationName}($userId: String!, $tenantId: String!, $maxNumberOfResults: Int!) {
  smarts {
    results: recommendedUser(
      recommendationsQuery: {
        context: {
          userId: $userId
          tenantId: $tenantId
          product: "confluence"
        },
        modelRequestParams: {
          caller: "full-page-search"
          experience: "CgUserNearbyUser"
        }
        requestingUserId: $userId
        maxNumberOfResults: $maxNumberOfResults
      }
    ) {
      id
      user {
        accountId
        name
        picture
      }
    }
  }
}
`;
const $8bbf0973c124500e$export$69a3209f1a06c04d = (0, $bHHWv.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $8bbf0973c124500e$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    const { results: results } = data.smarts;
    return !results || results.length === 0;
};
const $8bbf0973c124500e$export$74adda2a74e06fa9 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>$8bbf0973c124500e$export$69a3209f1a06c04d.inMemoryDecorator((0, $bZF61.generateHashFromVariables)(variables), ()=>(0, $b0Mpu.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $8bbf0973c124500e$var$SmartsRecommendedUserQuery,
            operationName: $8bbf0973c124500e$var$operationName,
            headers: headers
        }), $8bbf0973c124500e$var$expireWhen);
module.exports["smartsRecommendedUserQuery"] = $8bbf0973c124500e$export$74adda2a74e06fa9;

});

parcelRegister("dYKlp", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $6E9Xj = parcelRequire("6E9Xj");

const $06d01c2d88ae5cdf$export$cd224500ea4a2de1 = async ({ cloudId: cloudId, datasourceId: datasourceId, orgId: orgId, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    try {
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: (0, $6E9Xj.getThirdPartyFilterOptionsQuery)(),
            variables: {
                cloudId: cloudId,
                datasourceId: datasourceId,
                orgId: orgId != null && orgId !== '' ? orgId : null
            },
            operationName: (0, $6E9Xj.GQL_OPERATION_NAME),
            aggAbsoluteUrl: aggAbsoluteUrl
        });
        const filterOptions = response.data?.search?.configuration?.thirdPartyFilterOptions ?? null;
        if (response.errors?.length) {
            console.warn(`[${(0, $6E9Xj.GQL_OPERATION_NAME)}] GraphQL errors for datasource "${datasourceId}":`, response.errors);
            if (!filterOptions) throw new Error(`[${(0, $6E9Xj.GQL_OPERATION_NAME)}] GraphQL errors prevented loading third-party filter options for datasource "${datasourceId}"`);
        }
        return filterOptions;
    } catch (error) {
        console.error(`[${(0, $6E9Xj.GQL_OPERATION_NAME)}] Failed to fetch third-party filter options for datasource "${datasourceId}":`, error);
        throw error;
    }
};
module.exports["getThirdPartyFilterOptions"] = $06d01c2d88ae5cdf$export$cd224500ea4a2de1;

});

parcelRegister("6E9Xj", function(module, exports) {
const $43211b550670686b$export$c5dfc39e7764783c = 'searchThirdPartyFilterOptions';
const $43211b550670686b$export$417982613a1b9ae2 = `
query ${$43211b550670686b$export$c5dfc39e7764783c}($cloudId: ID!, $datasourceId: String!, $orgId: String) {
  search {
    configuration(cloudId: $cloudId) {
      thirdPartyFilterOptions(datasourceId: $datasourceId, orgId: $orgId) {
        filters {
          name
          values {
            name
            label
          }
        }
      }
    }
  }
}`;
const $43211b550670686b$export$cbfaf396d242dba9 = ()=>$43211b550670686b$export$417982613a1b9ae2;
module.exports["GQL_OPERATION_NAME"] = $43211b550670686b$export$c5dfc39e7764783c;
module.exports["getThirdPartyFilterOptionsQuery"] = $43211b550670686b$export$cbfaf396d242dba9;

});

parcelRegister("e6Tv8", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $aff2d6af91e5ade1$export$fe2cce9cc2f02a10 = (0, $bHHWv.inMemoryCache)();
const $aff2d6af91e5ade1$var$GQL_CF_PAGES_OPERATION_NAME = 'SearchPageConfluencePagesQuery';
const $aff2d6af91e5ade1$var$getConfluencePagesQuery = ()=>`
query ${$aff2d6af91e5ade1$var$GQL_CF_PAGES_OPERATION_NAME}($pageIds: [ID]!) {
  confluence {
    pages(ids: $pageIds) {
      id
      title
      type
      links {
        base
      }
    }
  }
}
`;
const $aff2d6af91e5ade1$export$eeab7469706cab80 = (pageIds, headers)=>{
    return $aff2d6af91e5ade1$export$fe2cce9cc2f02a10.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per page id
    pageIds.join(','), async ()=>{
        if (pageIds.length === 0) return {
            data: {
                confluence: {
                    pages: []
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $aff2d6af91e5ade1$var$getConfluencePagesQuery(),
            variables: {
                pageIds: pageIds
            },
            operationName: $aff2d6af91e5ade1$var$GQL_CF_PAGES_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["confluencePagesQuery"] = $aff2d6af91e5ade1$export$eeab7469706cab80;

});

parcelRegister("evHnc", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $3wZF4 = parcelRequire("3wZF4");


var $bZF61 = parcelRequire("bZF61");


var $bHHWv = parcelRequire("bHHWv");

const $1d4baeadb938847e$var$operationName = 'SearchEntitiesQuery';
const $1d4baeadb938847e$var$getSearchEntitiesQuery = ({ includeSpaceKey: includeSpaceKey, includeContainerId: includeContainerId })=>{
    const SearchConfluenceSpace = `
    ... on SearchConfluenceSpace {
      key
    }
  `;
    // containerId is available on ExternalDocument entity (3P documents like Google Drive folders)
    const ContainerIdFragment = `
    ... on SearchResultGraphDocument {
      entity {
        ... on ExternalDocument {
          containerId
        }
      }
    }
  `;
    return `
  query ${$1d4baeadb938847e$var$operationName}(
		$experience: String!, 
		$useCaseId: String,
		$query: String!, 
		$first: Int, 
		$filters: SearchFilterInput!
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
	) {
    search {
      results: search(
        experience: $experience
		useCaseId: $useCaseId
        query: $query
        first: $first
        filters: $filters
				experimentContext: {
					experimentId: $experimentId
					shadowExperimentId: $shadowExperimentId
					experimentLayers: $experimentLayers
				}
      ) {
        edges {
          node {
            id
            title
            type
            url
            iconUrl
            ${includeSpaceKey ? SearchConfluenceSpace : ``}
            ${includeContainerId ? ContainerIdFragment : ``}
          }
        }
      }
    }
  }
  `;
};
const $1d4baeadb938847e$export$69a3209f1a06c04d = (0, $bHHWv.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $1d4baeadb938847e$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    return data.search?.results.edges.length === 0;
};
const $1d4baeadb938847e$export$98f1867fd4cb2c65 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers, includeSpaceKey: includeSpaceKey, includeContainerId: includeContainerId })=>{
    const { useCaseId: _useCaseId, ...functionalVariables } = variables;
    const requestVariables = (0, $3wZF4.toSearchUseCaseIdWireVariables)({
        first: 20,
        experience: '',
        ...variables
    });
    return $1d4baeadb938847e$export$69a3209f1a06c04d.inMemoryDecorator((0, $bZF61.generateHashFromVariables)(functionalVariables), ()=>(0, $b0Mpu.fetchAgg)({
            variables: requestVariables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $1d4baeadb938847e$var$getSearchEntitiesQuery({
                includeSpaceKey: includeSpaceKey,
                includeContainerId: includeContainerId
            }),
            operationName: $1d4baeadb938847e$var$operationName,
            headers: headers
        }), $1d4baeadb938847e$var$expireWhen);
};
module.exports["searchEntitiesQuery"] = $1d4baeadb938847e$export$98f1867fd4cb2c65;

});

parcelRegister("S6W9B", function(module, exports) {

var $1Qme9 = parcelRequire("1Qme9");

const $e14285b53154dd46$export$98613a34994a7d63 = (cloudId, primaryProduct)=>{
    if ((0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
        primaryProduct: primaryProduct,
        fireExperimentExposure: false
    })) return `ari:cloud:platform::site/${cloudId}`;
    return primaryProduct === 'jira' ? `ari:cloud:jira::site/${cloudId}` : `ari:cloud:confluence::site/${cloudId}`;
};
const $e14285b53154dd46$export$5af1ec507ebe78f1 = (cloudId, primaryProduct, additionalCloudIds = [])=>{
    const cloudIds = [
        cloudId,
        ...additionalCloudIds
    ].filter((id, index, all)=>Boolean(id) && all.indexOf(id) === index);
    return cloudIds.map((id)=>$e14285b53154dd46$export$98613a34994a7d63(id, primaryProduct));
};
module.exports["getCloudIdARI"] = $e14285b53154dd46$export$98613a34994a7d63;
module.exports["getCloudIdARIs"] = $e14285b53154dd46$export$5af1ec507ebe78f1;

});

parcelRegister("1Qme9", function(module, exports) {
/* eslint-disable @atlaskit/platform/use-recommended-utils */ 
var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

/**
 * Products that support multi-site search. Kept as literals rather than importing a product-key
 * enum so that this stays usable from every search package.
 */ const $86b0a51e5ff11063$var$MULTI_SITE_SEARCH_PRODUCTS = [
    'confluence',
    'jira'
];
const $86b0a51e5ff11063$export$feb2c22b30a0e873 = ({ primaryProduct: primaryProduct, fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    if (!primaryProduct || !$86b0a51e5ff11063$var$MULTI_SITE_SEARCH_PRODUCTS.includes(primaryProduct)) return false;
    if (!(0, $iDrrr.fg)('rovo_fps_enable_multi_site_search')) return false;
    return (0, $cXtTj.default).getExperimentValue('rovo_fps_multi_site_search_exp', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
module.exports["serveFpsMultiSiteSearchExperiment"] = $86b0a51e5ff11063$export$feb2c22b30a0e873;

});

parcelRegister("gByuu", function(module, exports) {
/**
 * Merges filter option lists fetched per site into one list, round-robin so every site is fairly
 * represented, and drops repeats. Options are deduped by `value`, falling back to `trackingKey`;
 * options carrying neither are dropped.
 */ const $100acfa2cdd80a38$export$2fda76ee2696f1c5 = (optionLists)=>{
    const seen = new Set();
    const merged = [];
    const longest = optionLists.reduce((max, options)=>Math.max(max, options.length), 0);
    for(let index = 0; index < longest; index++)for (const options of optionLists){
        const option = options[index];
        if (!option) continue;
        // `||` not `??`: an empty-string value is not a usable key, so fall back to trackingKey.
        const dedupeKey = option.value || option.trackingKey;
        if (!dedupeKey || seen.has(dedupeKey)) continue;
        seen.add(dedupeKey);
        merged.push(option);
    }
    return merged;
};
module.exports["mergeAndDedupeOptions"] = $100acfa2cdd80a38$export$2fda76ee2696f1c5;

});

parcelRegister("7Ag9o", function(module, exports) {
/**
 * Strip highlight markers from text
 */ const $a2e0e4cc948fc4f0$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
module.exports["cleanExcerpt"] = $a2e0e4cc948fc4f0$export$7512fe8206a7f75b;

});

parcelRegister("YTPUb", function(module, exports) {

var $b9heI = parcelRequire("b9heI");

const $11c8f4518d873306$export$f63f2da3517cdf9c = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'contributors',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $b9heI.default)(requestParams, intl);
};
module.exports["getContributors"] = $11c8f4518d873306$export$f63f2da3517cdf9c;

});

parcelRegister("iviWm", function(module, exports) {

var $gByuu = parcelRequire("gByuu");

const $e344f009f1c191eb$export$51337de818d0aa1c = async (config, fetchOptionsForSite)=>{
    // TODO: Use selectedCloudIds exclusively once the multi-site search experiment is cleaned up.
    const cloudIds = config.selectedCloudIds?.length ? config.selectedCloudIds : [
        config.cloudId || ''
    ];
    if (cloudIds.length === 1) return fetchOptionsForSite(cloudIds[0]);
    const settledPerSite = await Promise.allSettled(cloudIds.map((cloudId)=>fetchOptionsForSite(cloudId)));
    const succeeded = settledPerSite.filter((result)=>result.status === 'fulfilled');
    // One unhealthy site should not blank out the whole filter; only fail if every site failed.
    if (succeeded.length === 0) throw settledPerSite[0].reason;
    return (0, $gByuu.mergeAndDedupeOptions)(succeeded.map((result)=>result.value));
};
module.exports["fetchOptionsAcrossSites"] = $e344f009f1c191eb$export$51337de818d0aa1c;

});

parcelRegister("5yReE", function(module, exports) {

var $b9heI = parcelRequire("b9heI");

const $c1765f354c88eda7$export$cc8468b84430954 = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'createdBy',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $b9heI.default)(requestParams, intl);
};
module.exports["getCreatedBy"] = $c1765f354c88eda7$export$cc8468b84430954;

});

parcelRegister("gMpbY", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $96dc2a6c1e3b1c9f$export$a8f449a3d81f3a4c = (0, $bHHWv.inMemoryCache)();
const $96dc2a6c1e3b1c9f$var$GQL_CF_LABEL_OPERATION_NAME = 'SearchLabelsQuery';
const $96dc2a6c1e3b1c9f$var$getConfluenceLabelsQuery = ()=>`
query ${$96dc2a6c1e3b1c9f$var$GQL_CF_LABEL_OPERATION_NAME}($cloudId: ID! $searchText: String!, $limit: Int) {
  confluence {
    searchLabels(cloudId: $cloudId, searchText: $searchText, limit: $limit) @optIn(to: "ConfluenceExperimentalSearchLabels") {
	  otherLabels {
        label
      }
      suggestedLabels {
        label
      }
    }
  }
}
`;
const $96dc2a6c1e3b1c9f$export$b9ea4761dac8a473 = (cloudId, searchText, limit, headers)=>{
    // Key includes cloudId: multi-site fan-out issues one call per site with the same searchText.
    return $96dc2a6c1e3b1c9f$export$a8f449a3d81f3a4c.inMemoryDecorator(`${cloudId}::${searchText}`, async ()=>{
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $96dc2a6c1e3b1c9f$var$getConfluenceLabelsQuery(),
            variables: {
                cloudId: cloudId,
                searchText: searchText,
                limit: limit
            },
            operationName: $96dc2a6c1e3b1c9f$var$GQL_CF_LABEL_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["confluenceLabelsQuery"] = $96dc2a6c1e3b1c9f$export$b9ea4761dac8a473;

});

parcelRegister("8pAq5", function(module, exports) {

var $b9heI = parcelRequire("b9heI");

const $6d8429c7aa46b5f0$export$5fc95d9e84e12fd3 = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'lastUpdatedBy',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $b9heI.default)(requestParams, intl);
};
module.exports["getLastUpdatedBy"] = $6d8429c7aa46b5f0$export$5fc95d9e84e12fd3;

});

parcelRegister("f530N", function(module, exports) {

var $b9heI = parcelRequire("b9heI");

const $3a062b7ee0ab8ca2$export$148de59b68ce26ae = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'owners',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $b9heI.default)(requestParams, intl);
};
module.exports["getOwners"] = $3a062b7ee0ab8ca2$export$148de59b68ce26ae;

});

parcelRegister("iPZ04", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $5g39H = parcelRequire("5g39H");

const $b8cda7fef19cd30b$export$74d737bad7014c80 = async ({ cloudId: cloudId, limit: limit, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    try {
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: (0, $5g39H.getSlackChannelsQuery)(),
            variables: {
                cloudId: cloudId,
                ...limit !== undefined && {
                    limit: limit
                }
            },
            operationName: (0, $5g39H.GQL_OPERATION_NAME),
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const payload = response.data?.search?.configuration?.thirdPartySlackChannels ?? null;
        if (response.errors?.length) {
            console.warn(`[${(0, $5g39H.GQL_OPERATION_NAME)}] GraphQL errors for cloudId "${cloudId}":`, response.errors);
            if (!payload) throw new Error(`[${(0, $5g39H.GQL_OPERATION_NAME)}] GraphQL errors prevented loading Slack channels for cloudId "${cloudId}"`);
        }
        return payload;
    } catch (error) {
        console.error(`[${(0, $5g39H.GQL_OPERATION_NAME)}] Failed to fetch Slack channels:`, error);
        throw error;
    }
};
module.exports["getSlackChannels"] = $b8cda7fef19cd30b$export$74d737bad7014c80;

});

parcelRegister("5g39H", function(module, exports) {
const $34dabb57a028edd9$export$c5dfc39e7764783c = 'searchSlackChannels';
const $34dabb57a028edd9$export$c94f0ac2580f3d4 = `
query ${$34dabb57a028edd9$export$c5dfc39e7764783c}($cloudId: ID!, $limit: Int) {
  search {
    configuration(cloudId: $cloudId) {
      thirdPartySlackChannels(limit: $limit) {
        channels {
          id
          name
          isPrivate
        }
        nextCursor
      }
    }
  }
}`;
const $34dabb57a028edd9$export$4b8a3f4aff3d6261 = ()=>$34dabb57a028edd9$export$c94f0ac2580f3d4;
module.exports["GQL_OPERATION_NAME"] = $34dabb57a028edd9$export$c5dfc39e7764783c;
module.exports["getSlackChannelsQuery"] = $34dabb57a028edd9$export$4b8a3f4aff3d6261;

});

parcelRegister("gfZaP", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bZF61 = parcelRequire("bZF61");


var $bHHWv = parcelRequire("bHHWv");

const $d12651f8742916d8$var$operationName = 'SmartsRecommendedContainerQuery';
const $d12651f8742916d8$var$SmartsRecommendedContainerQuery = `
query ${$d12651f8742916d8$var$operationName}($userId: String!, $tenantId: String!) {
  smarts {
    results: recommendedContainer(
      recommendationsQuery: {
        context: {
          userId: $userId,
          tenantId: $tenantId,
          product: "confluence"
        },
        modelRequestParams: {
          caller: "full-page-search",
          experience: "CgContainerNearbyUser"
        },
        requestingUserId: $userId
      }
    ) {
      id
      score
      container {
        createdDate
        id
        key
        name
        spaceId
        status
        type
        links {
          base
        }
        icon {
          path
        }
      }
    }
  }
}
`;
const $d12651f8742916d8$export$69a3209f1a06c04d = (0, $bHHWv.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $d12651f8742916d8$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    const { results: results } = data.smarts;
    return !results || results.length === 0;
};
const $d12651f8742916d8$export$9d6625cf80401405 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>$d12651f8742916d8$export$69a3209f1a06c04d.inMemoryDecorator((0, $bZF61.generateHashFromVariables)(variables), ()=>(0, $b0Mpu.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $d12651f8742916d8$var$SmartsRecommendedContainerQuery,
            operationName: $d12651f8742916d8$var$operationName,
            headers: headers
        }), $d12651f8742916d8$var$expireWhen);
module.exports["smartsRecommendedContainerQuery"] = $d12651f8742916d8$export$9d6625cf80401405;

});

parcelRegister("kGvYo", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $24a422ec0db16ecd$export$f400862b5c7e6c62 = (0, $bHHWv.inMemoryCache)();
const $24a422ec0db16ecd$var$GQL_CF_SPACES_OPERATION_NAME = 'SearchPageConfluenceSpacesQuery';
const $24a422ec0db16ecd$var$getConfluenceSpacesQuery = ()=>`
query ${$24a422ec0db16ecd$var$GQL_CF_SPACES_OPERATION_NAME}($spaceIds: [ID]!) {
  confluence {
    spaces(ids: $spaceIds) {
      id
      spaceId
      name
      key
      links {
        base
      }
      icon {
        path
      }
    }
  }
}
`;
const $24a422ec0db16ecd$export$d8fbf668d55936f8 = (spaceIds, headers)=>{
    return $24a422ec0db16ecd$export$f400862b5c7e6c62.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per page id
    spaceIds.join(','), async ()=>{
        if (spaceIds.length === 0) return {
            data: {
                confluence: {
                    spaces: []
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $24a422ec0db16ecd$var$getConfluenceSpacesQuery(),
            variables: {
                spaceIds: spaceIds
            },
            operationName: $24a422ec0db16ecd$var$GQL_CF_SPACES_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["confluenceSpacesQuery"] = $24a422ec0db16ecd$export$d8fbf668d55936f8;

});

parcelRegister("hZCfd", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $185f2d8a8f5258a3$var$spacesCache = (0, $bHHWv.inMemoryCache)();
const $185f2d8a8f5258a3$var$GRAPHQL_OPERATION_NAME = 'ConfluenceSpaceKeysToIdsQuery';
const $185f2d8a8f5258a3$var$CONFLUENCE_SPACE_KEYS_TO_IDS_QUERY = `
query ${$185f2d8a8f5258a3$var$GRAPHQL_OPERATION_NAME}($cloudId: ID!, $spaceKeys: [String]) {
  spaces(cloudId: $cloudId, spaceKeys: $spaceKeys) {
    nodes {
      id
    }
  }
}
`;
const $185f2d8a8f5258a3$export$726cc5bea9d2607e = ({ spaceKeys: spaceKeys, cloudId: cloudId, headers: headers })=>{
    return $185f2d8a8f5258a3$var$spacesCache.inMemoryDecorator(`${spaceKeys.join(',')}-${cloudId}`, async ()=>{
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $185f2d8a8f5258a3$var$CONFLUENCE_SPACE_KEYS_TO_IDS_QUERY,
            variables: {
                cloudId: cloudId,
                spaceKeys: spaceKeys
            },
            operationName: $185f2d8a8f5258a3$var$GRAPHQL_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["confluenceSpaceKeysToIdsQuery"] = $185f2d8a8f5258a3$export$726cc5bea9d2607e;

});

parcelRegister("2UnMH", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $3wZF4 = parcelRequire("3wZF4");


var $bDWrn = parcelRequire("bDWrn");

// Computed once at module load — the query string has no dynamic parts
const $6fd4f3728c8eee10$var$TEAMS_WORKSPACE_GRAPH_QUERY = (0, $bDWrn.teamsWorkspaceFilterOptionsQueryGenerator)();
const $6fd4f3728c8eee10$var$TEAMS_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $6fd4f3728c8eee10$var$TEAMS_CONVERSATION_ENTITY_ATI = 'ati:cloud:graph:conversation';
const $6fd4f3728c8eee10$var$MAX_WORKSPACE_RESULTS = 30;
const $6fd4f3728c8eee10$export$2bb68a7d2eeb3442 = async ({ cloudId: cloudId, useCaseId: useCaseId, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const response = await (0, $b0Mpu.fetchAgg)({
        graphQuery: $6fd4f3728c8eee10$var$TEAMS_WORKSPACE_GRAPH_QUERY,
        operationName: (0, $bDWrn.teamsWorkspaceFilterOptionsOperationName),
        variables: (0, $3wZF4.toSearchUseCaseIdWireVariables)({
            query: '',
            useCaseId: useCaseId,
            cloudIdARI: [
                `ari:cloud:confluence::site/${cloudId}`
            ],
            limit: $6fd4f3728c8eee10$var$MAX_WORKSPACE_RESULTS,
            entities: [
                $6fd4f3728c8eee10$var$TEAMS_CONVERSATION_ENTITY_ATI
            ],
            product: 'teams',
            integration: $6fd4f3728c8eee10$var$TEAMS_INTEGRATION_ARI,
            subtypes: [
                'space'
            ]
        }),
        aggAbsoluteUrl: aggAbsoluteUrl,
        headers: headers
    });
    if (response.errors?.length) throw new Error(`[${(0, $bDWrn.teamsWorkspaceFilterOptionsOperationName)}] GraphQL errors prevented loading MS Teams workspaces`);
    const seen = new Set();
    return response?.data?.search?.search?.edges?.flatMap(({ node: node })=>{
        const workspace = node?.entity?.workspace;
        if (!workspace || seen.has(workspace)) return [];
        seen.add(workspace);
        const result = {
            name: workspace,
            ...node?.entity?.id !== undefined && {
                id: node.entity.id
            }
        };
        return [
            result
        ];
    }) ?? [];
};
module.exports["getMSTeamsWorkspaces"] = $6fd4f3728c8eee10$export$2bb68a7d2eeb3442;

});

parcelRegister("aOjGz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::630f7862dea052120b01b06315f58212>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7dedd806b3dd6402$var$_react = $7dedd806b3dd6402$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7dedd806b3dd6402$var$_iconNew = $7dedd806b3dd6402$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $7dedd806b3dd6402$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/spaces
 * Usage guidance:
 * Reserved for use for Jira Projects for now. This will replace the Jira rocket.
 * 
 * More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7dedd806b3dd6402$var$SpacesIcon = (props)=>/*#__PURE__*/ $7dedd806b3dd6402$var$_react.default.createElement($7dedd806b3dd6402$var$_iconNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.497A5.98 5.98 0 0 1 11 13.196a5.98 5.98 0 0 1-4.608.584 29.4 29.4 0 0 0 3.858-1.882 29.4 29.4 0 0 0 3.559-2.401"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.424 2.308-.447.377-.013.751.017 1.083.126.338.111.678.32.888.685.354.613.152 1.296-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.396c-.444.413-.954.837-1.517 1.263a29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.581c-.65.275-1.272.505-1.85.683h-.003q-.28.087-.548.158c-.783.206-1.511.318-2.116.288-.505-.024-1.114-.161-1.49-.63l-.052-.068-.07-.11-.07-.138a1.6 1.6 0 0 1-.078-.973c.071-.342.231-.68.431-1 .35-.56.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.5a6 6 0 0 0-.698.878c-.147.235-.213.407-.236.516l-.004.046c.048.022.155.056.37.066.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34a4.5 4.5 0 0 0 1.24 2.396C5.986 10.743 7.347 10.11 8.75 9.3s2.63-1.673 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36c-.306.01-.68.066-1.111.165q.233.306.432.648.196.341.342.695c.394-.424.665-.789.816-1.081.098-.192.121-.302.127-.355l-.041-.018c-.106-.035-.288-.063-.565-.054" clip-rule="evenodd"/>`
    }, props));
$7dedd806b3dd6402$var$SpacesIcon.displayName = 'SpacesIcon';
var $7dedd806b3dd6402$var$_default = module.exports.default = $7dedd806b3dd6402$var$SpacesIcon;

});

parcelRegister("b4vCW", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $6BYyi = parcelRequire("6BYyi");


var $6Zvcd = parcelRequire("6Zvcd");


var $fJfKO = parcelRequire("fJfKO");


var $7Cfp7 = parcelRequire("7Cfp7");

var $2103cf628600479a$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["townsquare"] = "TOWNSQUARE";
    Products["trello"] = "TRELLO";
    Products["bitbucket"] = "BITBUCKET";
    Products["other"] = "OTHER";
    return Products;
}({});
const $2103cf628600479a$export$775b6bb06e53a214 = {
    ...(0, $6BYyi.Scope),
    ...(0, $6Zvcd.Scope),
    ...(0, $7Cfp7.TownsquareScope),
    ...(0, $fJfKO.Scope)
};
module.exports["Scope"] = $2103cf628600479a$export$775b6bb06e53a214;

});

parcelRegister("6BYyi", function(module, exports) {
/**
 * Instead of enum types for ResultType, AnalyticsType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $14f7537098ab5b98$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    Scope["ConfluencePageBlogWhiteboard"] = "confluence.page,blogpost,whiteboard";
    Scope["ConfluenceContentType"] = "confluence.page,blogpost,whiteboard,database,embed";
    return Scope;
}({});
const $14f7537098ab5b98$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $14f7537098ab5b98$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $14f7537098ab5b98$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $14f7537098ab5b98$export$7694915d49dbf79 = 'confluence_experiments.page,blogpost,whiteboard';
const $14f7537098ab5b98$export$2d908678acc2f256 = 'confluence_experiments.page,blogpost,whiteboard,database,embed';
const $14f7537098ab5b98$export$80a5be864676016b = 'confluence.space';
const $14f7537098ab5b98$export$70542451ad6057d2 = 'urs.user-confluence';
const $14f7537098ab5b98$export$6ec00f56b27cdc1d = 'generic-container-result';
const $14f7537098ab5b98$export$ca1a50bc869949e = 'person-result';
const $14f7537098ab5b98$export$a99961038e9d5471 = 'confluence-object-result';
const $14f7537098ab5b98$export$18c69de2b4aa679c = 'recent-confluence';
const $14f7537098ab5b98$export$dc31f0db54ab1a30 = 'result-confluence';
const $14f7537098ab5b98$export$cb8b6c470492bee8 = 'recent-person';
const $14f7537098ab5b98$export$ebb42dafe7a39a20 = 'result-person';
const $14f7537098ab5b98$export$602b44a55c824e30 = 'advanced-search-confluence';
const $14f7537098ab5b98$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $14f7537098ab5b98$export$bbd1709e62826142 = 'confluence-page';
const $14f7537098ab5b98$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $14f7537098ab5b98$export$b441f0c13fd510b9 = 'confluence-attachment';
const $14f7537098ab5b98$export$8ee8726ca4e2f8bd = 'confluence-space';
const $14f7537098ab5b98$export$d0e824889e01c751 = 'person';
const $14f7537098ab5b98$export$b0c74445b9c9b57 = 'confluence-app';
module.exports["Scope"] = $14f7537098ab5b98$export$775b6bb06e53a214;

});

parcelRegister("fJfKO", function(module, exports) {
var $1d3fb901b1492caa$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["Loom"] = "loom.loom";
    return Scope;
}({});
module.exports["Scope"] = $1d3fb901b1492caa$export$775b6bb06e53a214;

});

parcelRegister("7Cfp7", function(module, exports) {
var $7ab467722a6086d5$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareQuestion"] = "townsquare.question";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});
 // End of copied code.
module.exports["TownsquareScope"] = $7ab467722a6086d5$export$fca43c5c12a4e3fa;

});

parcelRegister("8EgKx", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $8f2d8a51bc5e5758$var$ROTATION_PATTERN = [
    0,
    6,
    0,
    -8
];
const $8f2d8a51bc5e5758$var$DEFAULT_MAX_ITEMS = 6;
const $8f2d8a51bc5e5758$var$styles = {
    root: "_1LMyvKYbGa _0hPCNLDIqT _3iDTPbQ4SZ _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg",
    item: "_0hPCNLDIqT _3iDTPbQ4SZ _0rIjykPgdg _43nrzTPgdg _1mT5xdRAKS",
    rotate6: "_1VJPcarnNt _1sLQ8qC67X",
    rotateMinus8: "_1VJPcahzcQ _1sLQ8qC67X"
};
const $8f2d8a51bc5e5758$var$overlapStyles = {
    xsmall: "_0GTcwR5UaJ",
    small: "_0GTcwR5UaJ",
    medium: "_0GTcwRTUhv"
};
const $8f2d8a51bc5e5758$var$overlapXxsmallStyle = null; // These padding properties prevent rotated elements from being clipped on the block and inline-end edges.
const $8f2d8a51bc5e5758$var$clipPaddingStyle = null;
const $8f2d8a51bc5e5758$var$lastRotatedStyle = null;
const $8f2d8a51bc5e5758$var$AppStack = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ data: data, label: label, maxCount: maxCount = $8f2d8a51bc5e5758$var$DEFAULT_MAX_ITEMS, size: size = 'medium', testId: testId }, ref)=>{
    const visibleItems = data.slice(0, Math.max(1, maxCount));
    return /*#__PURE__*/ (0, $8aG6j.jsx)("ul", {
        ref: ref,
        "aria-label": label,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $8f2d8a51bc5e5758$var$styles.root,
            "_0xmtkoHZdu _46hvQmHZdu"
        ]),
        children: visibleItems.map((item, index)=>{
            const rotation = $8f2d8a51bc5e5758$var$ROTATION_PATTERN[index % $8f2d8a51bc5e5758$var$ROTATION_PATTERN.length];
            const isLast = index === visibleItems.length - 1;
            const Component = item.component;
            return /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                "data-testid": item.testId ?? (testId ? `${testId}--item-${index}` : undefined),
                className: (0, $hekY6.default)([
                    $8f2d8a51bc5e5758$var$styles.item,
                    index > 0 && size === 'xxsmall' && "_0GTcwR7vQP",
                    index > 0 && size !== 'xxsmall' && $8f2d8a51bc5e5758$var$overlapStyles[size],
                    rotation === 6 && $8f2d8a51bc5e5758$var$styles.rotate6,
                    rotation === -8 && $8f2d8a51bc5e5758$var$styles.rotateMinus8,
                    isLast && rotation !== 0 && "_03SyCPHZdu"
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                    label: item.label,
                    size: size,
                    testId: item.testId
                })
            }, `${item.label ?? item.component.displayName ?? index}-${index}`);
        })
    });
});
$8f2d8a51bc5e5758$var$AppStack.displayName = 'AppStack';
var $8f2d8a51bc5e5758$export$2e2bcd8739ae039 = $8f2d8a51bc5e5758$var$AppStack;
module.exports["default"] = $8f2d8a51bc5e5758$export$2e2bcd8739ae039;

});

parcelRegister("7SkLu", function(module, exports) {

var $E1QOf = parcelRequire("E1QOf");


var $a33Aa = parcelRequire("a33Aa");

function $c60ab42870e33b24$export$f9c6890b323d326b(key, value) {
    const interactionId = (0, $E1QOf.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $a33Aa.addCohortingCustomData)(currentInteractionId, key, value);
}
module.exports["addUFOCustomCohortData"] = $c60ab42870e33b24$export$f9c6890b323d326b;

});

parcelRegister("8zVc5", function(module, exports) {

var $cmi7m = parcelRequire("cmi7m");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/jira/project/manifest.ts
var $63edf52524ccdf3d$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $cmi7m.JiraProjectAriResourceOwner),
    resourceType: (0, $cmi7m.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $63edf52524ccdf3d$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $63edf52524ccdf3d$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $63edf52524ccdf3d$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $63edf52524ccdf3d$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $63edf52524ccdf3d$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $63edf52524ccdf3d$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $63edf52524ccdf3d$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
};
module.exports["JiraProjectAri"] = $63edf52524ccdf3d$export$75a0a0a7cb0a58ae;

});

parcelRegister("cmi7m", function(module, exports) {
// src/jira/project/types.ts
var $8ff597edad1ad36f$export$99d538a3b04916b1 = "jira", $8ff597edad1ad36f$export$736763838d3aa22e = "project";
module.exports["JiraProjectAriResourceOwner"] = $8ff597edad1ad36f$export$99d538a3b04916b1;
module.exports["JiraProjectAriResourceType"] = $8ff597edad1ad36f$export$736763838d3aa22e;

});

parcelRegister("d2hGj", function(module, exports) {
$parcel$export(module.exports, "default", () => $97d92d6ee994596f$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $bUJkW = parcelRequire("bUJkW");


var $3yGK6 = parcelRequire("3yGK6");

function $97d92d6ee994596f$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    return (0, $bUJkW.default)(dirtyDate, amount * 1000);
}

});

parcelRegister("7RXGY", function(module, exports) {

var $94P5g = parcelRequire("94P5g");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/teams/team/manifest.ts
var $017a833ee3e228d5$var$teamsTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $94P5g.TeamsTeamAriResourceOwner),
    resourceType: (0, $94P5g.TeamsTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/teams/team/index.ts
var $017a833ee3e228d5$export$e87aab29b355b2fe = class _TeamsTeamAri extends (0, $9j37t.RegisteredAri) {
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $017a833ee3e228d5$var$teamsTeamAriStaticOpts.qualifier,
            platformQualifier: $017a833ee3e228d5$var$teamsTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $017a833ee3e228d5$var$teamsTeamAriStaticOpts.resourceOwner,
            resourceType: $017a833ee3e228d5$var$teamsTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $017a833ee3e228d5$var$teamsTeamAriStaticOpts);
        return new _TeamsTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $017a833ee3e228d5$var$teamsTeamAriStaticOpts);
        return new _TeamsTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
    constructor(opts){
        super(opts), this._teamId = opts.resourceIdSegmentValues.teamId;
    }
};
module.exports["TeamsTeamAri"] = $017a833ee3e228d5$export$e87aab29b355b2fe;

});

parcelRegister("94P5g", function(module, exports) {
// src/teams/team/types.ts
var $69bc1cf71bd2048d$export$bea3076d6b75920c = "teams", $69bc1cf71bd2048d$export$439b0a7d78926555 = "team";
module.exports["TeamsTeamAriResourceOwner"] = $69bc1cf71bd2048d$export$bea3076d6b75920c;
module.exports["TeamsTeamAriResourceType"] = $69bc1cf71bd2048d$export$439b0a7d78926555;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});

parcelRegister("eDWBm", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $cozmU = parcelRequire("cozmU");

class $7b3dfa8de6f3510b$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        this.props.onException(error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }
    componentWillUnmount() {
        if (this.props.setErrorBoundaryResetCb) this.props.setErrorBoundaryResetCb(undefined);
    }
    render() {
        const { renderWithErrorInfo: RenderWithErrorInfo } = this.props;
        if (RenderWithErrorInfo && this.state.error && this.state.errorInfo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RenderWithErrorInfo, {
            error: this.state.error,
            errorInfo: this.state.errorInfo
        });
        if (this.state.error) return this.props.fallback !== undefined ? this.props.fallback : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = ()=>{
            this.setState({
                error: undefined,
                errorInfo: undefined
            });
        };
        this.state = {
            error: undefined,
            errorInfo: undefined
        };
        if (this.props.setErrorBoundaryResetCb) this.props.setErrorBoundaryResetCb(this.resetErrorBoundary);
    }
}
module.exports["ErrorBoundary"] = $7b3dfa8de6f3510b$export$e926676385687eaf;

});

parcelRegister("iC0LJ", function(module, exports) {
const $0b0e5bc3509465c8$var$MS_PER_SECOND = 1e3;
const $0b0e5bc3509465c8$var$SECS_PER_MIN = 60;
const $0b0e5bc3509465c8$var$SECS_PER_HOUR = $0b0e5bc3509465c8$var$SECS_PER_MIN * 60;
const $0b0e5bc3509465c8$var$SECS_PER_DAY = $0b0e5bc3509465c8$var$SECS_PER_HOUR * 24;
const $0b0e5bc3509465c8$var$SECS_PER_WEEK = $0b0e5bc3509465c8$var$SECS_PER_DAY * 7;
function $0b0e5bc3509465c8$export$b8f7189986dd5395(from, to = Date.now(), thresholds = {}) {
    const resolvedThresholds = {
        ...$0b0e5bc3509465c8$export$f4fd60e41371f80d,
        ...thresholds || {}
    };
    const secs = (+from - +to) / $0b0e5bc3509465c8$var$MS_PER_SECOND;
    if (Math.abs(secs) < resolvedThresholds.second) return {
        value: Math.round(secs),
        unit: 'second'
    };
    const mins = secs / $0b0e5bc3509465c8$var$SECS_PER_MIN;
    if (Math.abs(mins) < resolvedThresholds.minute) return {
        value: Math.round(mins),
        unit: 'minute'
    };
    const hours = secs / $0b0e5bc3509465c8$var$SECS_PER_HOUR;
    if (Math.abs(hours) < resolvedThresholds.hour) return {
        value: Math.round(hours),
        unit: 'hour'
    };
    const days = secs / $0b0e5bc3509465c8$var$SECS_PER_DAY;
    if (Math.abs(days) < resolvedThresholds.day) return {
        value: Math.round(days),
        unit: 'day'
    };
    const weeks = secs / $0b0e5bc3509465c8$var$SECS_PER_WEEK;
    return {
        value: Math.round(weeks),
        unit: 'week'
    };
}
const $0b0e5bc3509465c8$export$f4fd60e41371f80d = {
    second: 45,
    // seconds to minute
    minute: 45,
    // minutes to hour
    hour: 22,
    // hour to day
    day: 5 // day to week
};
module.exports["selectUnit"] = $0b0e5bc3509465c8$export$b8f7189986dd5395;

});

parcelRegister("2NJB3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $l7sn3 = parcelRequire("l7sn3");


var $5uDbk = parcelRequire("5uDbk");

const $67105ada1150ec9d$export$613b94bf89cb511d = /*#__PURE__*/ (0, $cozmU.createContext)({
    eventTypeMessages: (0, $5uDbk.LOCAL_EVENT_TYPE_MESSAGES)
});
const $67105ada1150ec9d$export$63b523c1d6b0c2f4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RecentWorkEventTypeMessagesProvider(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { children: children, locale: locale } = t0;
    const artifact = (0, $l7sn3.useRecentWorkArtifact)(locale);
    const t1 = artifact?.localization.eventTypes;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $5uDbk.translatedStringsToMessageDescriptors)(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== t2) {
        t3 = {
            eventTypeMessages: (0, $5uDbk.LOCAL_EVENT_TYPE_MESSAGES),
            eventTypeMessagesTranslated: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const providerValue = t3;
    let t4;
    if ($[4] !== children || $[5] !== providerValue) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67105ada1150ec9d$export$613b94bf89cb511d.Provider, {
            value: providerValue
        }, children);
        $[4] = children;
        $[5] = providerValue;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function RecentWorkEventTypeMessagesProvider({ children: children, locale: locale }) {
    const artifact = (0, $l7sn3.useRecentWorkArtifact)(locale);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            eventTypeMessages: (0, $5uDbk.LOCAL_EVENT_TYPE_MESSAGES),
            eventTypeMessagesTranslated: (0, $5uDbk.translatedStringsToMessageDescriptors)(artifact?.localization.eventTypes)
        }), [
        artifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67105ada1150ec9d$export$613b94bf89cb511d.Provider, {
        value: providerValue
    }, children);
};
const $67105ada1150ec9d$export$779009172d654787 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WrappedRecentWorkEventTypeMessagesProvider(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== children || $[1] !== locale) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67105ada1150ec9d$export$63b523c1d6b0c2f4, {
            locale: locale
        }, children);
        $[0] = children;
        $[1] = locale;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function WrappedRecentWorkEventTypeMessagesProvider({ children: children }) {
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67105ada1150ec9d$export$63b523c1d6b0c2f4, {
        locale: locale
    }, children);
};
const $67105ada1150ec9d$export$ddd7b41a8fb59ad6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($67105ada1150ec9d$export$613b94bf89cb511d);
} : ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($67105ada1150ec9d$export$613b94bf89cb511d);
const $67105ada1150ec9d$export$7948ea9187af6c9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useEventTypeMessage(eventType, t0) {
    const $ = (0, $bDgLe.c)(6);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const { eventTypeMessages: eventTypeMessages, eventTypeMessagesTranslated: translatedMessagesMap } = $67105ada1150ec9d$export$ddd7b41a8fb59ad6();
    const t2 = translatedMessagesMap || eventTypeMessages;
    let t3;
    if ($[2] !== eventType || $[3] !== options || $[4] !== t2) {
        t3 = (0, $5uDbk.messageForEventType)(eventType, t2, options);
        $[2] = eventType;
        $[3] = options;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function useEventTypeMessage(eventType, options = {}) {
    const { eventTypeMessages: eventTypeMessages, eventTypeMessagesTranslated: translatedMessagesMap } = $67105ada1150ec9d$export$ddd7b41a8fb59ad6();
    return (0, $5uDbk.messageForEventType)(eventType, translatedMessagesMap || eventTypeMessages, options);
};
module.exports["useEventTypeMessage"] = $67105ada1150ec9d$export$7948ea9187af6c9;

});

parcelRegister("l7sn3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2UMCh = parcelRequire("2UMCh");


var $2YNjC = parcelRequire("2YNjC");

const $7f848878d818ec2b$export$9c10d80bcd5b4264 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (locale)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== locale) {
        t0 = {
            ...(0, $2YNjC.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        };
        $[0] = locale;
        $[1] = t0;
    } else t0 = $[1];
    const dimensions = t0;
    return (0, $2UMCh.useFlightDeckArtifact)((0, $2YNjC.FD_CLIENT_FETCH_PROPS).name, dimensions);
} : (locale)=>{
    const dimensions = (0, $cozmU.useMemo)(()=>({
            ...(0, $2YNjC.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        }), [
        locale
    ]);
    return (0, $2UMCh.useFlightDeckArtifact)((0, $2YNjC.FD_CLIENT_FETCH_PROPS).name, dimensions);
};
module.exports["useRecentWorkArtifact"] = $7f848878d818ec2b$export$9c10d80bcd5b4264;

});

parcelRegister("5uDbk", function(module, exports) {

var $kRg7a = parcelRequire("kRg7a");


var $5fVDd = parcelRequire("5fVDd");

const $ee3aa75d5af7545b$export$be5e766167e613a9 = {
    commented: (0, $5fVDd.commentedEventTypeMessages),
    created: (0, $5fVDd.createdEventTypeMessages),
    edited: (0, $5fVDd.editedEventTypeMessages),
    published: (0, $5fVDd.publishedEventTypeMessages),
    updated: (0, $5fVDd.updatedEventTypeMessages),
    viewed: (0, $5fVDd.viewedEventTypeMessages),
    'sl-viewed': (0, $5fVDd.viewedEventTypeMessages),
    'sl-clicked': (0, $5fVDd.viewedEventTypeMessages),
    clicked: (0, $5fVDd.viewedEventTypeMessages)
};
function $ee3aa75d5af7545b$export$d3dc5798f9d19382(eventType, eventTypeMessages = $ee3aa75d5af7545b$export$be5e766167e613a9, options = {}) {
    const { isAbsolute: isAbsolute = true, isMyActivityData: isMyActivityData = true, isSimple: isSimple = false } = options;
    const eventTypeMessage = eventTypeMessages.hasOwnProperty(eventType) ? eventTypeMessages[eventType] : eventType === (0, $kRg7a.VIEWED_EVENT).SMARTLINK_VIEWED ? eventTypeMessages[(0, $kRg7a.VIEWED_EVENT).VIEWED] : (0, $5fVDd.defaultEventTypeMessages); // defaults to "... worked on ..."
    if (isSimple) {
        if (isMyActivityData) return eventTypeMessage.standalone;
        else return eventTypeMessage.multiStandalone;
    } else {
        if (isMyActivityData && isAbsolute) return eventTypeMessage.absolute;
        else if (isMyActivityData && !isAbsolute) return eventTypeMessage.relative;
        else if (!isMyActivityData && isAbsolute) return eventTypeMessage.multiAbsolute;
        else return eventTypeMessage.multiRelative;
    }
}
function $ee3aa75d5af7545b$export$ba0d5bdc49112491(translatedStrings) {
    if (!translatedStrings) return undefined;
    return Object.entries(translatedStrings).reduce((acc, [eventType, translatedMessages])=>{
        acc[eventType] = Object.entries(translatedMessages).reduce((eventTypeMessages, [translatedKey, translatedEntry])=>{
            eventTypeMessages[translatedKey] = {
                defaultMessage: translatedEntry,
                id: `recentWork.eventTypeMessage.translated.${translatedKey}.no-translate`
            };
            return eventTypeMessages;
        }, {});
        return acc;
    }, {});
}
module.exports["LOCAL_EVENT_TYPE_MESSAGES"] = $ee3aa75d5af7545b$export$be5e766167e613a9;
module.exports["messageForEventType"] = $ee3aa75d5af7545b$export$d3dc5798f9d19382;
module.exports["translatedStringsToMessageDescriptors"] = $ee3aa75d5af7545b$export$ba0d5bdc49112491;

});

parcelRegister("5fVDd", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $09c1cf05e8892170$export$29c048cc57fefaf8 = (0, $kSwu1.defineMessages)({
    absolute: {
        defaultMessage: "You commented on {absoluteTime}",
        id: "recentWork.eventTypeMessage.absolute.commented"
    },
    relative: {
        defaultMessage: "You commented {relativeTime}",
        id: "recentWork.eventTypeMessage.relative.commented"
    },
    standalone: {
        defaultMessage: "You commented",
        id: "recentWork.eventTypeMessage.commented"
    },
    multiAbsolute: {
        defaultMessage: "Commented on {absoluteTime}",
        id: "recentWork.eventTypeMessage.multi.absolute.commented"
    },
    multiRelative: {
        defaultMessage: "Commented {relativeTime}",
        id: "recentWork.eventTypeMessage.multi.relative.commented"
    },
    multiStandalone: {
        defaultMessage: "Commented",
        id: "recentWork.eventTypeMessage.multi.commented"
    }
});
const $09c1cf05e8892170$export$99e7e287b0f1db7 = (0, $kSwu1.defineMessages)({
    absolute: {
        defaultMessage: "You created on {absoluteTime}",
        id: "recentWork.eventTypeMessage.absolute.created"
    },
    relative: {
        defaultMessage: "You created {relativeTime}",
        id: "recentWork.eventTypeMessage.relative.created"
    },
    standalone: {
        defaultMessage: "You created",
        id: "recentWork.eventTypeMessage.created"
    },
    multiAbsolute: {
        defaultMessage: "Created on {absoluteTime}",
        id: "recentWork.eventTypeMessage.multi.absolute.created"
    },
    multiRelative: {
        defaultMessage: "Created {relativeTime}",
        id: "recentWork.eventTypeMessage.multi.relative.created"
    },
    multiStandalone: {
        defaultMessage: "Created",
        id: "recentWork.eventTypeMessage.multi.created"
    }
});
const $09c1cf05e8892170$export$4d0c20aef6601783 = (0, $kSwu1.defineMessages)({
    absolute: {
        defaultMessage: "You edited on {absoluteTime}",
        id: "recentWork.eventTypeMessage.absolute.edited"
    },
    relative: {
        defaultMessage: "You edited {relativeTime}",
        id: "recentWork.eventTypeMessage.relative.edited"
    },
    standalone: {
        defaultMessage: "You edited",
        id: "recentWork.eventTypeMessage.edited"
    },
    multiAbsolute: {
        defaultMessage: "Edited on {absoluteTime}",
        id: "recentWork.eventTypeMessage.multi.absolute.edited"
    },
    multiRelative: {
        defaultMessage: "Edited {relativeTime}",
        id: "recentWork.eventTypeMessage.multi.relative.edited"
    },
    multiStandalone: {
        defaultMessage: "Edited",
        id: "recentWork.eventTypeMessage.multi.edited"
    }
});
const $09c1cf05e8892170$export$2cd1ec4decb563bb = (0, $kSwu1.defineMessages)({
    absolute: {
        defaultMessage: "You published on {absoluteTime}",
        id: "recentWork.eventTypeMessage.absolute.published"
    },
    relative: {
        defaultMessage: "You published {relativeTime}",
        id: "recentWork.eventTypeMessage.relative.published"
    },
    standalone: {
        defaultMessage: "You published",
        id: "recentWork.eventTypeMessage.published"
    },
    multiAbsolute: {
        defaultMessage: "Published on {absoluteTime}",
        id: "recentWork.eventTypeMessage.multi.absolute.published"
    },
    multiRelative: {
        defaultMessage: "Published {relativeTime}",
        id: "recentWork.eventTypeMessage.multi.relative.published"
    },
    multiStandalone: {
        defaultMessage: "Published",
        id: "recentWork.eventTypeMessage.multi.published"
    }
});
const $09c1cf05e8892170$export$3b389551d0b5bf03 = (0, $kSwu1.defineMessages)({
    absolute: {
        defaultMessage: "You updated on {absoluteTime}",
        id: "recentWork.eventTypeMessage.absolute.updated"
    },
    relative: {
        defaultMessage: "You updated {relativeTime}",
        id: "recentWork.eventTypeMessage.relative.updated"
    },
    standalone: {
        defaultMessage: "You updated",
        id: "recentWork.eventTypeMessage.updated"
    },
    multiAbsolute: {
        defaultMessage: "Updated on {absoluteTime}",
        id: "recentWork.eventTypeMessage.multi.absolute.updated"
    },
    multiRelative: {
        defaultMessage: "Updated {relativeTime}",
        id: "recentWork.eventTypeMessage.multi.relative.updated"
    },
    multiStandalone: {
        defaultMessage: "Updated",
        id: "recentWork.eventTypeMessage.multi.updated"
    }
});
const $09c1cf05e8892170$export$2d3fe6e7f84a868e = (0, $kSwu1.defineMessages)({
    absolute: {
        defaultMessage: "You viewed on {absoluteTime}",
        id: "recentWork.eventTypeMessage.absolute.viewed"
    },
    relative: {
        defaultMessage: "You viewed {relativeTime}",
        id: "recentWork.eventTypeMessage.relative.viewed"
    },
    standalone: {
        defaultMessage: "You viewed",
        id: "recentWork.eventTypeMessage.viewed"
    },
    multiAbsolute: {
        defaultMessage: "Viewed on {absoluteTime}",
        id: "recentWork.eventTypeMessage.multi.absolute.viewed"
    },
    multiRelative: {
        defaultMessage: "Viewed {relativeTime}",
        id: "recentWork.eventTypeMessage.multi.relative.viewed"
    },
    multiStandalone: {
        defaultMessage: "Viewed",
        id: "recentWork.eventTypeMessage.multi.viewed"
    }
});
const $09c1cf05e8892170$export$9be55d016b768442 = (0, $kSwu1.defineMessages)({
    absolute: {
        defaultMessage: "You worked on {absoluteTime}",
        id: "recentWork.eventTypeMessage.absolute.workedOn"
    },
    relative: {
        defaultMessage: "You worked on {relativeTime}",
        id: "recentWork.eventTypeMessage.absolute.workedOn"
    },
    standalone: {
        defaultMessage: "You worked on",
        id: "recentWork.eventTypeMessage.workedOn"
    },
    multiAbsolute: {
        defaultMessage: "Worked on {absoluteTime}",
        id: "recentWork.eventTypeMessage.multi.absolute.workedOn"
    },
    multiRelative: {
        defaultMessage: "Worked on {relativeTime}",
        id: "recentWork.eventTypeMessage.multi.dateTime.workedOn"
    },
    multiStandalone: {
        defaultMessage: "Worked on",
        id: "recentWork.eventTypeMessage.multi.workedOn"
    }
});
module.exports["commentedEventTypeMessages"] = $09c1cf05e8892170$export$29c048cc57fefaf8;
module.exports["createdEventTypeMessages"] = $09c1cf05e8892170$export$99e7e287b0f1db7;
module.exports["editedEventTypeMessages"] = $09c1cf05e8892170$export$4d0c20aef6601783;
module.exports["publishedEventTypeMessages"] = $09c1cf05e8892170$export$2cd1ec4decb563bb;
module.exports["updatedEventTypeMessages"] = $09c1cf05e8892170$export$3b389551d0b5bf03;
module.exports["viewedEventTypeMessages"] = $09c1cf05e8892170$export$2d3fe6e7f84a868e;
module.exports["defaultEventTypeMessages"] = $09c1cf05e8892170$export$9be55d016b768442;

});

parcelRegister("aNJkw", function(module, exports) {
var $8954a3d126cba9b4$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});
var $8954a3d126cba9b4$export$3d32048696128045 = /*#__PURE__*/ function(TeamSearchField) {
    TeamSearchField["NAME"] = "name";
    TeamSearchField["DESCRIPTION"] = "description";
    return TeamSearchField;
}({});
module.exports["EntityType"] = $8954a3d126cba9b4$export$8eda7e02f8f033b2;
module.exports["TeamSearchField"] = $8954a3d126cba9b4$export$3d32048696128045;

});

parcelRegister("8bWTU", function(module, exports) {

var $aDF4t = parcelRequire("aDF4t");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/platform/integration/manifest.ts
var $5f6d0a48605f16d3$var$platformIntegrationAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $aDF4t.PlatformIntegrationAriResourceOwner),
    resourceType: (0, $aDF4t.PlatformIntegrationAriResourceType),
    resourceIdSlug: "{integrationKey}",
    resourceIdSegmentFormats: {
        integrationKey: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/platform/integration/index.ts
var $5f6d0a48605f16d3$export$2abc7817c3952e61 = class _PlatformIntegrationAri extends (0, $9j37t.RegisteredAri) {
    get integrationKey() {
        return this._integrationKey;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $5f6d0a48605f16d3$var$platformIntegrationAriStaticOpts.qualifier,
            platformQualifier: $5f6d0a48605f16d3$var$platformIntegrationAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $5f6d0a48605f16d3$var$platformIntegrationAriStaticOpts.resourceOwner,
            resourceType: $5f6d0a48605f16d3$var$platformIntegrationAriStaticOpts.resourceType,
            resourceId: `${opts.integrationKey}`,
            resourceIdSegmentValues: {
                integrationKey: opts.integrationKey
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $5f6d0a48605f16d3$var$platformIntegrationAriStaticOpts);
        return new _PlatformIntegrationAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $5f6d0a48605f16d3$var$platformIntegrationAriStaticOpts);
        return new _PlatformIntegrationAri(opts);
    }
    getVariables() {
        return {
            integrationKey: this.integrationKey
        };
    }
    constructor(opts){
        super(opts), this._integrationKey = opts.resourceIdSegmentValues.integrationKey;
    }
};
module.exports["PlatformIntegrationAri"] = $5f6d0a48605f16d3$export$2abc7817c3952e61;

});

parcelRegister("aDF4t", function(module, exports) {
// src/platform/integration/types.ts
var $7bed67caf43f9865$export$e5bef3642d94d161 = "platform", $7bed67caf43f9865$export$913c8f7d772fab02 = "integration";
module.exports["PlatformIntegrationAriResourceOwner"] = $7bed67caf43f9865$export$e5bef3642d94d161;
module.exports["PlatformIntegrationAriResourceType"] = $7bed67caf43f9865$export$913c8f7d772fab02;

});

parcelRegister("fayTW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8904d7ecd8870c62b721c48cdb04560c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0b2dcda52076574$var$_react = $b0b2dcda52076574$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b0b2dcda52076574$var$_iconNew = $b0b2dcda52076574$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $b0b2dcda52076574$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsSchema".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/assets-schema
 * Usage guidance:
 * Reserved for representing schema in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0b2dcda52076574$var$AssetsSchemaIcon = (props)=>/*#__PURE__*/ $b0b2dcda52076574$var$_react.default.createElement($b0b2dcda52076574$var$_iconNew.default, Object.assign({
        name: "AssetsSchemaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.75 11a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0-8a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M3 13.5a2 2 0 0 1-2-2V0h1.5v4H8v1.5H2.5v6a.5.5 0 0 0 .5.5h5v1.5zm9.75-4a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5m0-8a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5"/>`
    }, props));
$b0b2dcda52076574$var$AssetsSchemaIcon.displayName = 'AssetsSchemaIcon';
var $b0b2dcda52076574$var$_default = module.exports.default = $b0b2dcda52076574$var$AssetsSchemaIcon;

});

parcelRegister("6IUkh", function(module, exports) {

var $6s3PG = parcelRequire("6s3PG");

const $8c4a6f575efcb37b$export$d2ecfcb20099e313 = (rotations, locale, existingGhostTextData)=>{
    if (rotations.length === 0) return {
        id: '',
        locale: locale,
        text: '',
        occurrence: 0
    };
    // Find current position by id
    let currentIndex = 0;
    let currentOccurrence = 0;
    if (existingGhostTextData) {
        const foundIndex = rotations.findIndex((r)=>r.id === existingGhostTextData.id);
        if (foundIndex >= 0) {
            currentIndex = foundIndex;
            currentOccurrence = existingGhostTextData.occurrence ?? 0;
        }
    }
    // Check if we need to rotate to next text
    const newOccurrence = currentOccurrence + 1;
    if (newOccurrence >= (0, $6s3PG.ROTATION_THRESHOLD)) {
        // Move to next text, reset occurrence
        const nextIndex = (currentIndex + 1) % rotations.length;
        return {
            id: rotations[nextIndex].id,
            locale: locale,
            text: rotations[nextIndex].text,
            occurrence: 0
        };
    }
    // Keep current text, increment occurrence
    return {
        id: rotations[currentIndex].id,
        locale: locale,
        text: rotations[currentIndex].text,
        occurrence: newOccurrence
    };
};
module.exports["selectGhostText"] = $8c4a6f575efcb37b$export$d2ecfcb20099e313;

});

parcelRegister("hsKin", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");

const $016188a34d1f945d$export$aa68fd26e593cc7e = (variables)=>{
    const { siteId: siteId, orgId: orgId, query: query, experience: experience, model: model, includePatternType: includePatternType } = variables;
    const parts = [
        siteId,
        orgId,
        query,
        experience
    ];
    if (model) parts.push(model);
    parts.push(`includePatternType=${includePatternType}`);
    return parts.join(':');
};
const $016188a34d1f945d$export$c6e22d95dec11356 = (variables)=>{
    const { siteId: siteId, query: query, locale: locale, modelVersion: modelVersion } = variables;
    const queryHash = (0, $bZF61.generateHash)(query).toString();
    return JSON.stringify([
        'search-chat-intent-detection',
        siteId,
        locale,
        modelVersion,
        queryHash
    ]);
};
module.exports["createCacheKey"] = $016188a34d1f945d$export$aa68fd26e593cc7e;
module.exports["createSearchChatCacheKey"] = $016188a34d1f945d$export$c6e22d95dec11356;

});

parcelRegister("1o8wA", function(module, exports) {

var $bHHWv = parcelRequire("bHHWv");

const $c8e3ef44a3b0aa08$export$56db430dd07e9e8c = (0, $bHHWv.inMemoryCache)();
module.exports["intentDetectionCache"] = $c8e3ef44a3b0aa08$export$56db430dd07e9e8c;

});

parcelRegister("1qIUZ", function(module, exports) {
/**
 * Builds the `ml_lens` envelope for the Quick Find post-query `taskSuccess`
 * event, attaching per-product result counts in an ML-Lens-compatible shape.
 *
 * See: https://hello.atlassian.net/wiki/spaces/~93171358/pages/6820686403/
 *   GASv3+Events+Transformation+for+ML+Lens+Metrics+Schema
 *
 * Used by the `quick-find/postquery-search-results-ux` `taskSuccess` event.
 *
 * For `POSTQUERY_NO_RESULTS`, callers pass an empty `productCounts` object,
 * which yields no metrics — so no envelope is emitted and `ml_lens` is omitted
 * from the event entirely. An envelope carrying `"metrics":[]` invalidates the
 * whole `ml_lens` payload for the transformer, so "post-query succeeded with
 * zero results" is signalled by the absence of `ml_lens` rather than by an
 * empty metric list.
 *
 * This is a thin, surface-specific wrapper around the generic
 * {@link buildMlLensEnvelope}.
 */ 
var $cHss8 = parcelRequire("cHss8");

const $8f32bb2308ad4f7b$export$f88d0928235f96eb = 'rovo.quick_find';
const $8f32bb2308ad4f7b$export$9942b5a88584e08d = {
    page: 'quick_find',
    task: 'postquery_search_results_ux'
};
const $8f32bb2308ad4f7b$export$490db5b6f5dc980c = 'results_per_connector';
const $8f32bb2308ad4f7b$export$addc105232081b06 = (productCounts, userId)=>{
    const metrics = Object.entries(productCounts)// Stable ordering for deterministic payloads / easier diffing in QA.
    .sort(([a], [b])=>a.localeCompare(b)).map(([connector, value])=>({
            key: $8f32bb2308ad4f7b$export$490db5b6f5dc980c,
            type: 'number',
            value: value,
            tags: {
                connector: connector
            }
        }));
    return (0, $cHss8.buildMlLensEnvelope)({
        namespace: $8f32bb2308ad4f7b$export$f88d0928235f96eb,
        baseTags: {
            ...$8f32bb2308ad4f7b$export$9942b5a88584e08d
        },
        userId: userId,
        metrics: metrics
    });
};
module.exports["buildPostQueryMlLensEnvelope"] = $8f32bb2308ad4f7b$export$addc105232081b06;

});

parcelRegister("1OGSC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

// Default value hoisted outside to prevent recreation on every render
const $04663bbe06d26c6c$var$DEFAULT_TASK_STATE = {
    id: null,
    started: false,
    completed: false,
    error: null
};
const $04663bbe06d26c6c$var$VitalStatsTaskContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $04663bbe06d26c6c$export$40a6847b10816750 = ({ children: children })=>{
    // Use hoisted default to prevent object recreation on every render
    const taskStateRef = (0, $cozmU.useRef)($04663bbe06d26c6c$var$DEFAULT_TASK_STATE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($04663bbe06d26c6c$var$VitalStatsTaskContext.Provider, {
        value: taskStateRef
    }, children);
};
const $04663bbe06d26c6c$export$85fd2191723185b5 = ()=>{
    const taskStateRef = (0, $cozmU.useContext)($04663bbe06d26c6c$var$VitalStatsTaskContext);
    if (!taskStateRef) throw new Error('useVitalStatsTaskState must be used within QuickFindPostQueryVitalStatsProvider');
    return taskStateRef;
};
module.exports["QuickFindPostQueryVitalStatsProvider"] = $04663bbe06d26c6c$export$40a6847b10816750;
module.exports["useVitalStatsTaskState"] = $04663bbe06d26c6c$export$85fd2191723185b5;

});


//# sourceMappingURL=QuickFind.3b7efc61.js.map
